import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FontawesomeListService {
  catagories = [
    {
      title: 'Accessibility',
      items: [
        'fa-solid fa-circle-info fa-fw',
        'fa-regular fa-circle-info fa-fw',
        'fa-light fa-circle-info fa-fw',
        'fa-thin fa-circle-info fa-fw',
        'fa-duotone fa-circle-info fa-fw',
        'fa-sharp fa-solid fa-circle-info fa-fw',
        'fa-sharp fa-regular fa-circle-info fa-fw',
        'fa-sharp fa-light fa-circle-info fa-fw',
        'fa-solid fa-eye fa-fw',
        'fa-regular fa-eye fa-fw',
        'fa-light fa-eye fa-fw',
        'fa-thin fa-eye fa-fw',
        'fa-duotone fa-eye fa-fw',
        'fa-sharp fa-solid fa-eye fa-fw',
        'fa-sharp fa-regular fa-eye fa-fw',
        'fa-sharp fa-light fa-eye fa-fw',
        'fa-solid fa-question fa-fw',
        'fa-regular fa-question fa-fw',
        'fa-light fa-question fa-fw',
        'fa-thin fa-question fa-fw',
        'fa-duotone fa-question fa-fw',
        'fa-sharp fa-solid fa-question fa-fw',
        'fa-sharp fa-regular fa-question fa-fw',
        'fa-sharp fa-light fa-question fa-fw',
        'fa-solid fa-phone-volume fa-fw',
        'fa-regular fa-phone-volume fa-fw',
        'fa-light fa-phone-volume fa-fw',
        'fa-thin fa-phone-volume fa-fw',
        'fa-duotone fa-phone-volume fa-fw',
        'fa-sharp fa-solid fa-phone-volume fa-fw',
        'fa-sharp fa-regular fa-phone-volume fa-fw',
        'fa-sharp fa-light fa-phone-volume fa-fw',
        'fa-solid fa-address-card fa-fw',
        'fa-regular fa-address-card fa-fw',
        'fa-light fa-address-card fa-fw',
        'fa-thin fa-address-card fa-fw',
        'fa-duotone fa-address-card fa-fw',
        'fa-sharp fa-solid fa-address-card fa-fw',
        'fa-sharp fa-regular fa-address-card fa-fw',
        'fa-sharp fa-light fa-address-card fa-fw',
        'fa-solid fa-square-question fa-fw',
        'fa-regular fa-square-question fa-fw',
        'fa-light fa-square-question fa-fw',
        'fa-thin fa-square-question fa-fw',
        'fa-duotone fa-square-question fa-fw',
        'fa-sharp fa-solid fa-square-question fa-fw',
        'fa-sharp fa-regular fa-square-question fa-fw',
        'fa-sharp fa-light fa-square-question fa-fw',
        'fa-solid fa-tty fa-fw',
        'fa-regular fa-tty fa-fw',
        'fa-light fa-tty fa-fw',
        'fa-thin fa-tty fa-fw',
        'fa-duotone fa-tty fa-fw',
        'fa-sharp fa-solid fa-tty fa-fw',
        'fa-sharp fa-regular fa-tty fa-fw',
        'fa-sharp fa-light fa-tty fa-fw',
        'fa-solid fa-square-info fa-fw',
        'fa-regular fa-square-info fa-fw',
        'fa-light fa-square-info fa-fw',
        'fa-thin fa-square-info fa-fw',
        'fa-duotone fa-square-info fa-fw',
        'fa-sharp fa-solid fa-square-info fa-fw',
        'fa-sharp fa-regular fa-square-info fa-fw',
        'fa-sharp fa-light fa-square-info fa-fw',
        'fa-solid fa-hands fa-fw',
        'fa-regular fa-hands fa-fw',
        'fa-light fa-hands fa-fw',
        'fa-thin fa-hands fa-fw',
        'fa-duotone fa-hands fa-fw',
        'fa-sharp fa-solid fa-hands fa-fw',
        'fa-sharp fa-regular fa-hands fa-fw',
        'fa-sharp fa-light fa-hands fa-fw',
        'fa-solid fa-audio-description fa-fw',
        'fa-regular fa-audio-description fa-fw',
        'fa-light fa-audio-description fa-fw',
        'fa-thin fa-audio-description fa-fw',
        'fa-duotone fa-audio-description fa-fw',
        'fa-sharp fa-solid fa-audio-description fa-fw',
        'fa-sharp fa-regular fa-audio-description fa-fw',
        'fa-sharp fa-light fa-audio-description fa-fw',
        'fa-brands fa-accessible-icon fa-fw',
        'fa-solid fa-closed-captioning fa-fw',
        'fa-regular fa-closed-captioning fa-fw',
        'fa-light fa-closed-captioning fa-fw',
        'fa-thin fa-closed-captioning fa-fw',
        'fa-duotone fa-closed-captioning fa-fw',
        'fa-sharp fa-solid fa-closed-captioning fa-fw',
        'fa-sharp fa-regular fa-closed-captioning fa-fw',
        'fa-sharp fa-light fa-closed-captioning fa-fw',
        'fa-solid fa-fingerprint fa-fw',
        'fa-regular fa-fingerprint fa-fw',
        'fa-light fa-fingerprint fa-fw',
        'fa-thin fa-fingerprint fa-fw',
        'fa-duotone fa-fingerprint fa-fw',
        'fa-sharp fa-solid fa-fingerprint fa-fw',
        'fa-sharp fa-regular fa-fingerprint fa-fw',
        'fa-sharp fa-light fa-fingerprint fa-fw',
        'fa-solid fa-wheelchair-move fa-fw',
        'fa-solid fa-wheelchair fa-fw',
        'fa-solid fa-universal-access fa-fw',
        'fa-solid fa-tty-answer fa-fw',
        'fa-solid fa-person-walking-with-cane fa-fw',
        'fa-solid fa-person-cane fa-fw',
        'fa-solid fa-message-captions fa-fw',
        'fa-solid fa-keyboard-brightness-low fa-fw',
        'fa-solid fa-keyboard-brightness fa-fw',
        'fa-solid fa-head-side-heart fa-fw',
        'fa-solid fa-handshake-angle fa-fw',
        'fa-solid fa-hands-asl-interpreting fa-fw',
        'fa-solid fa-eye-low-vision fa-fw',
        'fa-solid fa-ear-listen fa-fw',
        'fa-solid fa-ear-deaf fa-fw',
        'fa-solid fa-ear fa-fw',
        'fa-solid fa-dog-leashed fa-fw',
        'fa-solid fa-comment-captions fa-fw',
        'fa-solid fa-closed-captioning-slash fa-fw',
        'fa-solid fa-circle-question fa-fw',
        'fa-solid fa-brightness-low fa-fw',
        'fa-solid fa-brightness fa-fw',
        'fa-solid fa-braille fa-fw',
        'fa-solid fa-audio-description-slash fa-fw',
        'fa-regular fa-wheelchair-move fa-fw',
        'fa-regular fa-wheelchair fa-fw',
        'fa-regular fa-universal-access fa-fw',
        'fa-regular fa-tty-answer fa-fw',
        'fa-regular fa-person-walking-with-cane fa-fw',
        'fa-regular fa-person-cane fa-fw',
        'fa-regular fa-message-captions fa-fw',
        'fa-regular fa-keyboard-brightness-low fa-fw',
        'fa-regular fa-keyboard-brightness fa-fw',
        'fa-regular fa-head-side-heart fa-fw',
        'fa-regular fa-handshake-angle fa-fw',
        'fa-regular fa-hands-asl-interpreting fa-fw',
        'fa-regular fa-eye-low-vision fa-fw',
        'fa-regular fa-ear-listen fa-fw',
        'fa-regular fa-ear-deaf fa-fw',
        'fa-regular fa-ear fa-fw',
        'fa-regular fa-dog-leashed fa-fw',
        'fa-regular fa-comment-captions fa-fw',
        'fa-regular fa-closed-captioning-slash fa-fw',
        'fa-regular fa-circle-question fa-fw',
        'fa-regular fa-brightness-low fa-fw',
        'fa-regular fa-brightness fa-fw',
        'fa-regular fa-braille fa-fw',
        'fa-regular fa-audio-description-slash fa-fw',
        'fa-light fa-wheelchair-move fa-fw',
        'fa-light fa-wheelchair fa-fw',
        'fa-light fa-universal-access fa-fw',
        'fa-light fa-tty-answer fa-fw',
        'fa-light fa-person-walking-with-cane fa-fw',
        'fa-light fa-person-cane fa-fw',
        'fa-light fa-message-captions fa-fw',
        'fa-light fa-keyboard-brightness-low fa-fw',
        'fa-light fa-keyboard-brightness fa-fw',
        'fa-light fa-head-side-heart fa-fw',
        'fa-light fa-handshake-angle fa-fw',
        'fa-light fa-hands-asl-interpreting fa-fw',
        'fa-light fa-eye-low-vision fa-fw',
        'fa-light fa-ear-listen fa-fw',
        'fa-light fa-ear-deaf fa-fw',
        'fa-light fa-ear fa-fw',
        'fa-light fa-dog-leashed fa-fw',
        'fa-light fa-comment-captions fa-fw',
        'fa-light fa-closed-captioning-slash fa-fw',
        'fa-light fa-circle-question fa-fw',
        'fa-light fa-brightness-low fa-fw',
        'fa-light fa-brightness fa-fw',
        'fa-light fa-braille fa-fw',
        'fa-light fa-audio-description-slash fa-fw',
        'fa-thin fa-wheelchair-move fa-fw',
        'fa-thin fa-wheelchair fa-fw',
        'fa-thin fa-universal-access fa-fw',
        'fa-thin fa-tty-answer fa-fw',
        'fa-thin fa-person-walking-with-cane fa-fw',
        'fa-thin fa-person-cane fa-fw',
        'fa-thin fa-message-captions fa-fw',
        'fa-thin fa-keyboard-brightness-low fa-fw',
        'fa-thin fa-keyboard-brightness fa-fw',
        'fa-thin fa-head-side-heart fa-fw',
        'fa-thin fa-handshake-angle fa-fw',
        'fa-thin fa-hands-asl-interpreting fa-fw',
        'fa-thin fa-eye-low-vision fa-fw',
        'fa-thin fa-ear-listen fa-fw',
        'fa-thin fa-ear-deaf fa-fw',
        'fa-thin fa-ear fa-fw',
        'fa-thin fa-dog-leashed fa-fw',
        'fa-thin fa-comment-captions fa-fw',
        'fa-thin fa-closed-captioning-slash fa-fw',
        'fa-thin fa-circle-question fa-fw',
        'fa-thin fa-brightness-low fa-fw',
        'fa-thin fa-brightness fa-fw',
        'fa-thin fa-braille fa-fw',
        'fa-thin fa-audio-description-slash fa-fw',
        'fa-duotone fa-wheelchair-move fa-fw',
        'fa-duotone fa-wheelchair fa-fw',
        'fa-duotone fa-universal-access fa-fw',
        'fa-duotone fa-tty-answer fa-fw',
        'fa-duotone fa-person-walking-with-cane fa-fw',
        'fa-duotone fa-person-cane fa-fw',
        'fa-duotone fa-message-captions fa-fw',
        'fa-duotone fa-keyboard-brightness-low fa-fw',
        'fa-duotone fa-keyboard-brightness fa-fw',
        'fa-duotone fa-head-side-heart fa-fw',
        'fa-duotone fa-handshake-angle fa-fw',
        'fa-duotone fa-hands-asl-interpreting fa-fw',
        'fa-duotone fa-eye-low-vision fa-fw',
        'fa-duotone fa-ear-listen fa-fw',
        'fa-duotone fa-ear-deaf fa-fw',
        'fa-duotone fa-ear fa-fw',
        'fa-duotone fa-dog-leashed fa-fw',
        'fa-duotone fa-comment-captions fa-fw',
        'fa-duotone fa-closed-captioning-slash fa-fw',
        'fa-duotone fa-circle-question fa-fw',
        'fa-duotone fa-brightness-low fa-fw',
        'fa-duotone fa-brightness fa-fw',
        'fa-duotone fa-braille fa-fw',
        'fa-duotone fa-audio-description-slash fa-fw',
        'fa-sharp fa-solid fa-wheelchair-move fa-fw',
        'fa-sharp fa-solid fa-wheelchair fa-fw',
        'fa-sharp fa-solid fa-universal-access fa-fw',
        'fa-sharp fa-solid fa-tty-answer fa-fw',
        'fa-sharp fa-solid fa-person-walking-with-cane fa-fw',
        'fa-sharp fa-solid fa-person-cane fa-fw',
        'fa-sharp fa-solid fa-message-captions fa-fw',
        'fa-sharp fa-solid fa-keyboard-brightness-low fa-fw',
        'fa-sharp fa-solid fa-keyboard-brightness fa-fw',
        'fa-sharp fa-solid fa-head-side-heart fa-fw',
        'fa-sharp fa-solid fa-handshake-angle fa-fw',
        'fa-sharp fa-solid fa-hands-asl-interpreting fa-fw',
        'fa-sharp fa-solid fa-eye-low-vision fa-fw',
        'fa-sharp fa-solid fa-ear-listen fa-fw',
        'fa-sharp fa-solid fa-ear-deaf fa-fw',
        'fa-sharp fa-solid fa-ear fa-fw',
        'fa-sharp fa-solid fa-dog-leashed fa-fw',
        'fa-sharp fa-solid fa-comment-captions fa-fw',
        'fa-sharp fa-solid fa-closed-captioning-slash fa-fw',
        'fa-sharp fa-solid fa-circle-question fa-fw',
        'fa-sharp fa-solid fa-brightness-low fa-fw',
        'fa-sharp fa-solid fa-brightness fa-fw',
        'fa-sharp fa-solid fa-braille fa-fw',
        'fa-sharp fa-solid fa-audio-description-slash fa-fw',
        'fa-sharp fa-regular fa-wheelchair-move fa-fw',
        'fa-sharp fa-regular fa-wheelchair fa-fw',
        'fa-sharp fa-regular fa-universal-access fa-fw',
        'fa-sharp fa-regular fa-tty-answer fa-fw',
        'fa-sharp fa-regular fa-person-walking-with-cane fa-fw',
        'fa-sharp fa-regular fa-person-cane fa-fw',
        'fa-sharp fa-regular fa-message-captions fa-fw',
        'fa-sharp fa-regular fa-keyboard-brightness-low fa-fw',
        'fa-sharp fa-regular fa-keyboard-brightness fa-fw',
        'fa-sharp fa-regular fa-head-side-heart fa-fw',
        'fa-sharp fa-regular fa-handshake-angle fa-fw',
        'fa-sharp fa-regular fa-hands-asl-interpreting fa-fw',
        'fa-sharp fa-regular fa-eye-low-vision fa-fw',
        'fa-sharp fa-regular fa-ear-listen fa-fw',
        'fa-sharp fa-regular fa-ear-deaf fa-fw',
        'fa-sharp fa-regular fa-ear fa-fw',
        'fa-sharp fa-regular fa-dog-leashed fa-fw',
        'fa-sharp fa-regular fa-comment-captions fa-fw',
        'fa-sharp fa-regular fa-closed-captioning-slash fa-fw',
        'fa-sharp fa-regular fa-circle-question fa-fw',
        'fa-sharp fa-regular fa-brightness-low fa-fw',
        'fa-sharp fa-regular fa-brightness fa-fw',
        'fa-sharp fa-regular fa-braille fa-fw',
        'fa-sharp fa-regular fa-audio-description-slash fa-fw',
        'fa-sharp fa-light fa-wheelchair-move fa-fw',
        'fa-sharp fa-light fa-wheelchair fa-fw',
        'fa-sharp fa-light fa-universal-access fa-fw',
        'fa-sharp fa-light fa-tty-answer fa-fw',
        'fa-sharp fa-light fa-person-walking-with-cane fa-fw',
        'fa-sharp fa-light fa-person-cane fa-fw',
        'fa-sharp fa-light fa-message-captions fa-fw',
        'fa-sharp fa-light fa-keyboard-brightness-low fa-fw',
        'fa-sharp fa-light fa-keyboard-brightness fa-fw',
        'fa-sharp fa-light fa-head-side-heart fa-fw',
        'fa-sharp fa-light fa-handshake-angle fa-fw',
        'fa-sharp fa-light fa-hands-asl-interpreting fa-fw',
        'fa-sharp fa-light fa-eye-low-vision fa-fw',
        'fa-sharp fa-light fa-ear-listen fa-fw',
        'fa-sharp fa-light fa-ear-deaf fa-fw',
        'fa-sharp fa-light fa-ear fa-fw',
        'fa-sharp fa-light fa-dog-leashed fa-fw',
        'fa-sharp fa-light fa-comment-captions fa-fw',
        'fa-sharp fa-light fa-closed-captioning-slash fa-fw',
        'fa-sharp fa-light fa-circle-question fa-fw',
        'fa-sharp fa-light fa-brightness-low fa-fw',
        'fa-sharp fa-light fa-brightness fa-fw',
        'fa-sharp fa-light fa-braille fa-fw',
        'fa-sharp fa-light fa-audio-description-slash fa-fw',
      ],
    },
    {
      title: 'Alert',
      items: [
        'fa-solid fa-bell fa-fw',
        'fa-regular fa-bell fa-fw',
        'fa-light fa-bell fa-fw',
        'fa-thin fa-bell fa-fw',
        'fa-duotone fa-bell fa-fw',
        'fa-sharp fa-solid fa-bell fa-fw',
        'fa-sharp fa-regular fa-bell fa-fw',
        'fa-sharp fa-light fa-bell fa-fw',
        'fa-solid fa-alarm-clock fa-fw',
        'fa-regular fa-alarm-clock fa-fw',
        'fa-light fa-alarm-clock fa-fw',
        'fa-thin fa-alarm-clock fa-fw',
        'fa-duotone fa-alarm-clock fa-fw',
        'fa-sharp fa-solid fa-alarm-clock fa-fw',
        'fa-sharp fa-regular fa-alarm-clock fa-fw',
        'fa-sharp fa-light fa-alarm-clock fa-fw',
        'fa-solid fa-circle-exclamation fa-fw',
        'fa-regular fa-circle-exclamation fa-fw',
        'fa-light fa-circle-exclamation fa-fw',
        'fa-thin fa-circle-exclamation fa-fw',
        'fa-duotone fa-circle-exclamation fa-fw',
        'fa-sharp fa-solid fa-circle-exclamation fa-fw',
        'fa-sharp fa-regular fa-circle-exclamation fa-fw',
        'fa-sharp fa-light fa-circle-exclamation fa-fw',
        'fa-solid fa-question fa-fw',
        'fa-regular fa-question fa-fw',
        'fa-light fa-question fa-fw',
        'fa-thin fa-question fa-fw',
        'fa-duotone fa-question fa-fw',
        'fa-sharp fa-solid fa-question fa-fw',
        'fa-sharp fa-regular fa-question fa-fw',
        'fa-sharp fa-light fa-question fa-fw',
        'fa-solid fa-exclamation fa-fw',
        'fa-regular fa-exclamation fa-fw',
        'fa-light fa-exclamation fa-fw',
        'fa-thin fa-exclamation fa-fw',
        'fa-duotone fa-exclamation fa-fw',
        'fa-sharp fa-solid fa-exclamation fa-fw',
        'fa-sharp fa-regular fa-exclamation fa-fw',
        'fa-sharp fa-light fa-exclamation fa-fw',
        'fa-solid fa-file-exclamation fa-fw',
        'fa-regular fa-file-exclamation fa-fw',
        'fa-light fa-file-exclamation fa-fw',
        'fa-thin fa-file-exclamation fa-fw',
        'fa-duotone fa-file-exclamation fa-fw',
        'fa-sharp fa-solid fa-file-exclamation fa-fw',
        'fa-sharp fa-regular fa-file-exclamation fa-fw',
        'fa-sharp fa-light fa-file-exclamation fa-fw',
        'fa-solid fa-engine-warning fa-fw',
        'fa-regular fa-engine-warning fa-fw',
        'fa-light fa-engine-warning fa-fw',
        'fa-thin fa-engine-warning fa-fw',
        'fa-duotone fa-engine-warning fa-fw',
        'fa-sharp fa-solid fa-engine-warning fa-fw',
        'fa-sharp fa-regular fa-engine-warning fa-fw',
        'fa-sharp fa-light fa-engine-warning fa-fw',
        'fa-solid fa-wind-warning fa-fw',
        'fa-solid fa-wifi-exclamation fa-fw',
        'fa-solid fa-triangle-exclamation fa-fw',
        'fa-solid fa-star-exclamation fa-fw',
        'fa-solid fa-square-exclamation fa-fw',
        'fa-solid fa-skull-crossbones fa-fw',
        'fa-solid fa-shield-exclamation fa-fw',
        'fa-solid fa-sensor-triangle-exclamation fa-fw',
        'fa-solid fa-sensor-on fa-fw',
        'fa-solid fa-sensor-fire fa-fw',
        'fa-solid fa-sensor-cloud fa-fw',
        'fa-solid fa-sensor fa-fw',
        'fa-solid fa-seal-question fa-fw',
        'fa-solid fa-seal-exclamation fa-fw',
        'fa-solid fa-rotate-exclamation fa-fw',
        'fa-solid fa-radiation fa-fw',
        'fa-solid fa-party-horn fa-fw',
        'fa-solid fa-party-bell fa-fw',
        'fa-solid fa-octagon-exclamation fa-fw',
        'fa-solid fa-message-exclamation fa-fw',
        'fa-solid fa-location-exclamation fa-fw',
        'fa-solid fa-lightbulb-exclamation-on fa-fw',
        'fa-solid fa-lightbulb-exclamation fa-fw',
        'fa-solid fa-light-emergency-on fa-fw',
        'fa-solid fa-light-emergency fa-fw',
        'fa-solid fa-hexagon-exclamation fa-fw',
        'fa-solid fa-diamond-exclamation fa-fw',
        'fa-solid fa-comment-exclamation fa-fw',
        'fa-solid fa-cloud-question fa-fw',
        'fa-solid fa-cloud-exclamation fa-fw',
        'fa-solid fa-circle-radiation fa-fw',
        'fa-solid fa-circle-quarters fa-fw',
        'fa-solid fa-circle-exclamation-check fa-fw',
        'fa-solid fa-calendar-exclamation fa-fw',
        'fa-solid fa-bells fa-fw',
        'fa-solid fa-bell-slash fa-fw',
        'fa-solid fa-bell-school-slash fa-fw',
        'fa-solid fa-bell-on fa-fw',
        'fa-solid fa-bell-exclamation fa-fw',
        'fa-solid fa-battery-exclamation fa-fw',
        'fa-solid fa-alarm-exclamation fa-fw',
        'fa-regular fa-wind-warning fa-fw',
        'fa-regular fa-wifi-exclamation fa-fw',
        'fa-regular fa-triangle-exclamation fa-fw',
        'fa-regular fa-star-exclamation fa-fw',
        'fa-regular fa-square-exclamation fa-fw',
        'fa-regular fa-skull-crossbones fa-fw',
        'fa-regular fa-shield-exclamation fa-fw',
        'fa-regular fa-sensor-triangle-exclamation fa-fw',
        'fa-regular fa-sensor-on fa-fw',
        'fa-regular fa-sensor-fire fa-fw',
        'fa-regular fa-sensor-cloud fa-fw',
        'fa-regular fa-sensor fa-fw',
        'fa-regular fa-seal-question fa-fw',
        'fa-regular fa-seal-exclamation fa-fw',
        'fa-regular fa-rotate-exclamation fa-fw',
        'fa-regular fa-radiation fa-fw',
        'fa-regular fa-party-horn fa-fw',
        'fa-regular fa-party-bell fa-fw',
        'fa-regular fa-octagon-exclamation fa-fw',
        'fa-regular fa-message-exclamation fa-fw',
        'fa-regular fa-location-exclamation fa-fw',
        'fa-regular fa-lightbulb-exclamation-on fa-fw',
        'fa-regular fa-lightbulb-exclamation fa-fw',
        'fa-regular fa-light-emergency-on fa-fw',
        'fa-regular fa-light-emergency fa-fw',
        'fa-regular fa-hexagon-exclamation fa-fw',
        'fa-regular fa-diamond-exclamation fa-fw',
        'fa-regular fa-comment-exclamation fa-fw',
        'fa-regular fa-cloud-question fa-fw',
        'fa-regular fa-cloud-exclamation fa-fw',
        'fa-regular fa-circle-radiation fa-fw',
        'fa-regular fa-circle-quarters fa-fw',
        'fa-regular fa-circle-exclamation-check fa-fw',
        'fa-regular fa-calendar-exclamation fa-fw',
        'fa-regular fa-bells fa-fw',
        'fa-regular fa-bell-slash fa-fw',
        'fa-regular fa-bell-school-slash fa-fw',
        'fa-regular fa-bell-on fa-fw',
        'fa-regular fa-bell-exclamation fa-fw',
        'fa-regular fa-battery-exclamation fa-fw',
        'fa-regular fa-alarm-exclamation fa-fw',
        'fa-light fa-wind-warning fa-fw',
        'fa-light fa-wifi-exclamation fa-fw',
        'fa-light fa-triangle-exclamation fa-fw',
        'fa-light fa-star-exclamation fa-fw',
        'fa-light fa-square-exclamation fa-fw',
        'fa-light fa-skull-crossbones fa-fw',
        'fa-light fa-shield-exclamation fa-fw',
        'fa-light fa-sensor-triangle-exclamation fa-fw',
        'fa-light fa-sensor-on fa-fw',
        'fa-light fa-sensor-fire fa-fw',
        'fa-light fa-sensor-cloud fa-fw',
        'fa-light fa-sensor fa-fw',
        'fa-light fa-seal-question fa-fw',
        'fa-light fa-seal-exclamation fa-fw',
        'fa-light fa-rotate-exclamation fa-fw',
        'fa-light fa-radiation fa-fw',
        'fa-light fa-party-horn fa-fw',
        'fa-light fa-party-bell fa-fw',
        'fa-light fa-octagon-exclamation fa-fw',
        'fa-light fa-message-exclamation fa-fw',
        'fa-light fa-location-exclamation fa-fw',
        'fa-light fa-lightbulb-exclamation-on fa-fw',
        'fa-light fa-lightbulb-exclamation fa-fw',
        'fa-light fa-light-emergency-on fa-fw',
        'fa-light fa-light-emergency fa-fw',
        'fa-light fa-hexagon-exclamation fa-fw',
        'fa-light fa-diamond-exclamation fa-fw',
        'fa-light fa-comment-exclamation fa-fw',
        'fa-light fa-cloud-question fa-fw',
        'fa-light fa-cloud-exclamation fa-fw',
        'fa-light fa-circle-radiation fa-fw',
        'fa-light fa-circle-quarters fa-fw',
        'fa-light fa-circle-exclamation-check fa-fw',
        'fa-light fa-calendar-exclamation fa-fw',
        'fa-light fa-bells fa-fw',
        'fa-light fa-bell-slash fa-fw',
        'fa-light fa-bell-school-slash fa-fw',
        'fa-light fa-bell-on fa-fw',
        'fa-light fa-bell-exclamation fa-fw',
        'fa-light fa-battery-exclamation fa-fw',
        'fa-light fa-alarm-exclamation fa-fw',
        'fa-thin fa-wind-warning fa-fw',
        'fa-thin fa-wifi-exclamation fa-fw',
        'fa-thin fa-triangle-exclamation fa-fw',
        'fa-thin fa-star-exclamation fa-fw',
        'fa-thin fa-square-exclamation fa-fw',
        'fa-thin fa-skull-crossbones fa-fw',
        'fa-thin fa-shield-exclamation fa-fw',
        'fa-thin fa-sensor-triangle-exclamation fa-fw',
        'fa-thin fa-sensor-on fa-fw',
        'fa-thin fa-sensor-fire fa-fw',
        'fa-thin fa-sensor-cloud fa-fw',
        'fa-thin fa-sensor fa-fw',
        'fa-thin fa-seal-question fa-fw',
        'fa-thin fa-seal-exclamation fa-fw',
        'fa-thin fa-rotate-exclamation fa-fw',
        'fa-thin fa-radiation fa-fw',
        'fa-thin fa-party-horn fa-fw',
        'fa-thin fa-party-bell fa-fw',
        'fa-thin fa-octagon-exclamation fa-fw',
        'fa-thin fa-message-exclamation fa-fw',
        'fa-thin fa-location-exclamation fa-fw',
        'fa-thin fa-lightbulb-exclamation-on fa-fw',
        'fa-thin fa-lightbulb-exclamation fa-fw',
        'fa-thin fa-light-emergency-on fa-fw',
        'fa-thin fa-light-emergency fa-fw',
        'fa-thin fa-hexagon-exclamation fa-fw',
        'fa-thin fa-diamond-exclamation fa-fw',
        'fa-thin fa-comment-exclamation fa-fw',
        'fa-thin fa-cloud-question fa-fw',
        'fa-thin fa-cloud-exclamation fa-fw',
        'fa-thin fa-circle-radiation fa-fw',
        'fa-thin fa-circle-quarters fa-fw',
        'fa-thin fa-circle-exclamation-check fa-fw',
        'fa-thin fa-calendar-exclamation fa-fw',
        'fa-thin fa-bells fa-fw',
        'fa-thin fa-bell-slash fa-fw',
        'fa-thin fa-bell-school-slash fa-fw',
        'fa-thin fa-bell-on fa-fw',
        'fa-thin fa-bell-exclamation fa-fw',
        'fa-thin fa-battery-exclamation fa-fw',
        'fa-thin fa-alarm-exclamation fa-fw',
        'fa-duotone fa-wind-warning fa-fw',
        'fa-duotone fa-wifi-exclamation fa-fw',
        'fa-duotone fa-triangle-exclamation fa-fw',
        'fa-duotone fa-star-exclamation fa-fw',
        'fa-duotone fa-square-exclamation fa-fw',
        'fa-duotone fa-skull-crossbones fa-fw',
        'fa-duotone fa-shield-exclamation fa-fw',
        'fa-duotone fa-sensor-triangle-exclamation fa-fw',
        'fa-duotone fa-sensor-on fa-fw',
        'fa-duotone fa-sensor-fire fa-fw',
        'fa-duotone fa-sensor-cloud fa-fw',
        'fa-duotone fa-sensor fa-fw',
        'fa-duotone fa-seal-question fa-fw',
        'fa-duotone fa-seal-exclamation fa-fw',
        'fa-duotone fa-rotate-exclamation fa-fw',
        'fa-duotone fa-radiation fa-fw',
        'fa-duotone fa-party-horn fa-fw',
        'fa-duotone fa-party-bell fa-fw',
        'fa-duotone fa-octagon-exclamation fa-fw',
        'fa-duotone fa-message-exclamation fa-fw',
        'fa-duotone fa-location-exclamation fa-fw',
        'fa-duotone fa-lightbulb-exclamation-on fa-fw',
        'fa-duotone fa-lightbulb-exclamation fa-fw',
        'fa-duotone fa-light-emergency-on fa-fw',
        'fa-duotone fa-light-emergency fa-fw',
        'fa-duotone fa-hexagon-exclamation fa-fw',
        'fa-duotone fa-diamond-exclamation fa-fw',
        'fa-duotone fa-comment-exclamation fa-fw',
        'fa-duotone fa-cloud-question fa-fw',
        'fa-duotone fa-cloud-exclamation fa-fw',
        'fa-duotone fa-circle-radiation fa-fw',
        'fa-duotone fa-circle-quarters fa-fw',
        'fa-duotone fa-circle-exclamation-check fa-fw',
        'fa-duotone fa-calendar-exclamation fa-fw',
        'fa-duotone fa-bells fa-fw',
        'fa-duotone fa-bell-slash fa-fw',
        'fa-duotone fa-bell-school-slash fa-fw',
        'fa-duotone fa-bell-on fa-fw',
        'fa-duotone fa-bell-exclamation fa-fw',
        'fa-duotone fa-battery-exclamation fa-fw',
        'fa-duotone fa-alarm-exclamation fa-fw',
        'fa-sharp fa-solid fa-wind-warning fa-fw',
        'fa-sharp fa-solid fa-wifi-exclamation fa-fw',
        'fa-sharp fa-solid fa-triangle-exclamation fa-fw',
        'fa-sharp fa-solid fa-star-exclamation fa-fw',
        'fa-sharp fa-solid fa-square-exclamation fa-fw',
        'fa-sharp fa-solid fa-skull-crossbones fa-fw',
        'fa-sharp fa-solid fa-shield-exclamation fa-fw',
        'fa-sharp fa-solid fa-sensor-triangle-exclamation fa-fw',
        'fa-sharp fa-solid fa-sensor-on fa-fw',
        'fa-sharp fa-solid fa-sensor-fire fa-fw',
        'fa-sharp fa-solid fa-sensor-cloud fa-fw',
        'fa-sharp fa-solid fa-sensor fa-fw',
        'fa-sharp fa-solid fa-seal-question fa-fw',
        'fa-sharp fa-solid fa-seal-exclamation fa-fw',
        'fa-sharp fa-solid fa-rotate-exclamation fa-fw',
        'fa-sharp fa-solid fa-radiation fa-fw',
        'fa-sharp fa-solid fa-party-horn fa-fw',
        'fa-sharp fa-solid fa-party-bell fa-fw',
        'fa-sharp fa-solid fa-octagon-exclamation fa-fw',
        'fa-sharp fa-solid fa-message-exclamation fa-fw',
        'fa-sharp fa-solid fa-location-exclamation fa-fw',
        'fa-sharp fa-solid fa-lightbulb-exclamation-on fa-fw',
        'fa-sharp fa-solid fa-lightbulb-exclamation fa-fw',
        'fa-sharp fa-solid fa-light-emergency-on fa-fw',
        'fa-sharp fa-solid fa-light-emergency fa-fw',
        'fa-sharp fa-solid fa-hexagon-exclamation fa-fw',
        'fa-sharp fa-solid fa-diamond-exclamation fa-fw',
        'fa-sharp fa-solid fa-comment-exclamation fa-fw',
        'fa-sharp fa-solid fa-cloud-question fa-fw',
        'fa-sharp fa-solid fa-cloud-exclamation fa-fw',
        'fa-sharp fa-solid fa-circle-radiation fa-fw',
        'fa-sharp fa-solid fa-circle-quarters fa-fw',
        'fa-sharp fa-solid fa-circle-exclamation-check fa-fw',
        'fa-sharp fa-solid fa-calendar-exclamation fa-fw',
        'fa-sharp fa-solid fa-bells fa-fw',
        'fa-sharp fa-solid fa-bell-slash fa-fw',
        'fa-sharp fa-solid fa-bell-school-slash fa-fw',
        'fa-sharp fa-solid fa-bell-on fa-fw',
        'fa-sharp fa-solid fa-bell-exclamation fa-fw',
        'fa-sharp fa-solid fa-battery-exclamation fa-fw',
        'fa-sharp fa-solid fa-alarm-exclamation fa-fw',
        'fa-sharp fa-regular fa-wind-warning fa-fw',
        'fa-sharp fa-regular fa-wifi-exclamation fa-fw',
        'fa-sharp fa-regular fa-triangle-exclamation fa-fw',
        'fa-sharp fa-regular fa-star-exclamation fa-fw',
        'fa-sharp fa-regular fa-square-exclamation fa-fw',
        'fa-sharp fa-regular fa-skull-crossbones fa-fw',
        'fa-sharp fa-regular fa-shield-exclamation fa-fw',
        'fa-sharp fa-regular fa-sensor-triangle-exclamation fa-fw',
        'fa-sharp fa-regular fa-sensor-on fa-fw',
        'fa-sharp fa-regular fa-sensor-fire fa-fw',
        'fa-sharp fa-regular fa-sensor-cloud fa-fw',
        'fa-sharp fa-regular fa-sensor fa-fw',
        'fa-sharp fa-regular fa-seal-question fa-fw',
        'fa-sharp fa-regular fa-seal-exclamation fa-fw',
        'fa-sharp fa-regular fa-rotate-exclamation fa-fw',
        'fa-sharp fa-regular fa-radiation fa-fw',
        'fa-sharp fa-regular fa-party-horn fa-fw',
        'fa-sharp fa-regular fa-party-bell fa-fw',
        'fa-sharp fa-regular fa-octagon-exclamation fa-fw',
        'fa-sharp fa-regular fa-message-exclamation fa-fw',
        'fa-sharp fa-regular fa-location-exclamation fa-fw',
        'fa-sharp fa-regular fa-lightbulb-exclamation-on fa-fw',
        'fa-sharp fa-regular fa-lightbulb-exclamation fa-fw',
        'fa-sharp fa-regular fa-light-emergency-on fa-fw',
        'fa-sharp fa-regular fa-light-emergency fa-fw',
        'fa-sharp fa-regular fa-hexagon-exclamation fa-fw',
        'fa-sharp fa-regular fa-diamond-exclamation fa-fw',
        'fa-sharp fa-regular fa-comment-exclamation fa-fw',
        'fa-sharp fa-regular fa-cloud-question fa-fw',
        'fa-sharp fa-regular fa-cloud-exclamation fa-fw',
        'fa-sharp fa-regular fa-circle-radiation fa-fw',
        'fa-sharp fa-regular fa-circle-quarters fa-fw',
        'fa-sharp fa-regular fa-circle-exclamation-check fa-fw',
        'fa-sharp fa-regular fa-calendar-exclamation fa-fw',
        'fa-sharp fa-regular fa-bells fa-fw',
        'fa-sharp fa-regular fa-bell-slash fa-fw',
        'fa-sharp fa-regular fa-bell-school-slash fa-fw',
        'fa-sharp fa-regular fa-bell-on fa-fw',
        'fa-sharp fa-regular fa-bell-exclamation fa-fw',
        'fa-sharp fa-regular fa-battery-exclamation fa-fw',
        'fa-sharp fa-regular fa-alarm-exclamation fa-fw',
        'fa-sharp fa-light fa-wind-warning fa-fw',
        'fa-sharp fa-light fa-wifi-exclamation fa-fw',
        'fa-sharp fa-light fa-triangle-exclamation fa-fw',
        'fa-sharp fa-light fa-star-exclamation fa-fw',
        'fa-sharp fa-light fa-square-exclamation fa-fw',
        'fa-sharp fa-light fa-skull-crossbones fa-fw',
        'fa-sharp fa-light fa-shield-exclamation fa-fw',
        'fa-sharp fa-light fa-sensor-triangle-exclamation fa-fw',
        'fa-sharp fa-light fa-sensor-on fa-fw',
        'fa-sharp fa-light fa-sensor-fire fa-fw',
        'fa-sharp fa-light fa-sensor-cloud fa-fw',
        'fa-sharp fa-light fa-sensor fa-fw',
        'fa-sharp fa-light fa-seal-question fa-fw',
        'fa-sharp fa-light fa-seal-exclamation fa-fw',
        'fa-sharp fa-light fa-rotate-exclamation fa-fw',
        'fa-sharp fa-light fa-radiation fa-fw',
        'fa-sharp fa-light fa-party-horn fa-fw',
        'fa-sharp fa-light fa-party-bell fa-fw',
        'fa-sharp fa-light fa-octagon-exclamation fa-fw',
        'fa-sharp fa-light fa-message-exclamation fa-fw',
        'fa-sharp fa-light fa-location-exclamation fa-fw',
        'fa-sharp fa-light fa-lightbulb-exclamation-on fa-fw',
        'fa-sharp fa-light fa-lightbulb-exclamation fa-fw',
        'fa-sharp fa-light fa-light-emergency-on fa-fw',
        'fa-sharp fa-light fa-light-emergency fa-fw',
        'fa-sharp fa-light fa-hexagon-exclamation fa-fw',
        'fa-sharp fa-light fa-diamond-exclamation fa-fw',
        'fa-sharp fa-light fa-comment-exclamation fa-fw',
        'fa-sharp fa-light fa-cloud-question fa-fw',
        'fa-sharp fa-light fa-cloud-exclamation fa-fw',
        'fa-sharp fa-light fa-circle-radiation fa-fw',
        'fa-sharp fa-light fa-circle-quarters fa-fw',
        'fa-sharp fa-light fa-circle-exclamation-check fa-fw',
        'fa-sharp fa-light fa-calendar-exclamation fa-fw',
        'fa-sharp fa-light fa-bells fa-fw',
        'fa-sharp fa-light fa-bell-slash fa-fw',
        'fa-sharp fa-light fa-bell-school-slash fa-fw',
        'fa-sharp fa-light fa-bell-on fa-fw',
        'fa-sharp fa-light fa-bell-exclamation fa-fw',
        'fa-sharp fa-light fa-battery-exclamation fa-fw',
        'fa-sharp fa-light fa-alarm-exclamation fa-fw',
      ],
    },
    {
      title: 'Alphabet',
      items: [
        'fa-solid fa-address-card fa-fw',
        'fa-regular fa-address-card fa-fw',
        'fa-light fa-address-card fa-fw',
        'fa-thin fa-address-card fa-fw',
        'fa-duotone fa-address-card fa-fw',
        'fa-sharp fa-solid fa-address-card fa-fw',
        'fa-sharp fa-regular fa-address-card fa-fw',
        'fa-sharp fa-light fa-address-card fa-fw',
        'fa-solid fa-z fa-fw',
        'fa-solid fa-y fa-fw',
        'fa-solid fa-x fa-fw',
        'fa-solid fa-w fa-fw',
        'fa-solid fa-v fa-fw',
        'fa-solid fa-u fa-fw',
        'fa-solid fa-t fa-fw',
        'fa-solid fa-square-z fa-fw',
        'fa-solid fa-square-y fa-fw',
        'fa-solid fa-square-x fa-fw',
        'fa-solid fa-square-w fa-fw',
        'fa-solid fa-square-v fa-fw',
        'fa-solid fa-square-u fa-fw',
        'fa-solid fa-square-t fa-fw',
        'fa-solid fa-square-s fa-fw',
        'fa-solid fa-square-r fa-fw',
        'fa-solid fa-square-q fa-fw',
        'fa-solid fa-square-p fa-fw',
        'fa-solid fa-square-o fa-fw',
        'fa-solid fa-square-n fa-fw',
        'fa-solid fa-square-m fa-fw',
        'fa-solid fa-square-l fa-fw',
        'fa-solid fa-square-k fa-fw',
        'fa-solid fa-square-j fa-fw',
        'fa-solid fa-square-i fa-fw',
        'fa-solid fa-square-h fa-fw',
        'fa-solid fa-square-g fa-fw',
        'fa-solid fa-square-f fa-fw',
        'fa-solid fa-square-e fa-fw',
        'fa-solid fa-square-d fa-fw',
        'fa-solid fa-square-c fa-fw',
        'fa-solid fa-square-b fa-fw',
        'fa-solid fa-square-a fa-fw',
        'fa-solid fa-s fa-fw',
        'fa-solid fa-r fa-fw',
        'fa-solid fa-q fa-fw',
        'fa-solid fa-p fa-fw',
        'fa-solid fa-o fa-fw',
        'fa-solid fa-n fa-fw',
        'fa-solid fa-m fa-fw',
        'fa-solid fa-l fa-fw',
        'fa-solid fa-k fa-fw',
        'fa-solid fa-j fa-fw',
        'fa-solid fa-i fa-fw',
        'fa-solid fa-h fa-fw',
        'fa-solid fa-g fa-fw',
        'fa-solid fa-f fa-fw',
        'fa-solid fa-e fa-fw',
        'fa-solid fa-d fa-fw',
        'fa-solid fa-circle-z fa-fw',
        'fa-solid fa-circle-y fa-fw',
        'fa-solid fa-circle-x fa-fw',
        'fa-solid fa-circle-w fa-fw',
        'fa-solid fa-circle-v fa-fw',
        'fa-solid fa-circle-u fa-fw',
        'fa-solid fa-circle-t fa-fw',
        'fa-solid fa-circle-s fa-fw',
        'fa-solid fa-circle-r fa-fw',
        'fa-solid fa-circle-q fa-fw',
        'fa-solid fa-circle-p fa-fw',
        'fa-solid fa-circle-o fa-fw',
        'fa-solid fa-circle-n fa-fw',
        'fa-solid fa-circle-m fa-fw',
        'fa-solid fa-circle-l fa-fw',
        'fa-solid fa-circle-k fa-fw',
        'fa-solid fa-circle-j fa-fw',
        'fa-solid fa-circle-i fa-fw',
        'fa-solid fa-circle-h fa-fw',
        'fa-solid fa-circle-g fa-fw',
        'fa-solid fa-circle-f fa-fw',
        'fa-solid fa-circle-e fa-fw',
        'fa-solid fa-circle-d fa-fw',
        'fa-solid fa-circle-c fa-fw',
        'fa-solid fa-circle-b fa-fw',
        'fa-solid fa-circle-a fa-fw',
        'fa-solid fa-c fa-fw',
        'fa-solid fa-b fa-fw',
        'fa-solid fa-a fa-fw',
        'fa-regular fa-z fa-fw',
        'fa-regular fa-y fa-fw',
        'fa-regular fa-x fa-fw',
        'fa-regular fa-w fa-fw',
        'fa-regular fa-v fa-fw',
        'fa-regular fa-u fa-fw',
        'fa-regular fa-t fa-fw',
        'fa-regular fa-square-z fa-fw',
        'fa-regular fa-square-y fa-fw',
        'fa-regular fa-square-x fa-fw',
        'fa-regular fa-square-w fa-fw',
        'fa-regular fa-square-v fa-fw',
        'fa-regular fa-square-u fa-fw',
        'fa-regular fa-square-t fa-fw',
        'fa-regular fa-square-s fa-fw',
        'fa-regular fa-square-r fa-fw',
        'fa-regular fa-square-q fa-fw',
        'fa-regular fa-square-p fa-fw',
        'fa-regular fa-square-o fa-fw',
        'fa-regular fa-square-n fa-fw',
        'fa-regular fa-square-m fa-fw',
        'fa-regular fa-square-l fa-fw',
        'fa-regular fa-square-k fa-fw',
        'fa-regular fa-square-j fa-fw',
        'fa-regular fa-square-i fa-fw',
        'fa-regular fa-square-h fa-fw',
        'fa-regular fa-square-g fa-fw',
        'fa-regular fa-square-f fa-fw',
        'fa-regular fa-square-e fa-fw',
        'fa-regular fa-square-d fa-fw',
        'fa-regular fa-square-c fa-fw',
        'fa-regular fa-square-b fa-fw',
        'fa-regular fa-square-a fa-fw',
        'fa-regular fa-s fa-fw',
        'fa-regular fa-r fa-fw',
        'fa-regular fa-q fa-fw',
        'fa-regular fa-p fa-fw',
        'fa-regular fa-o fa-fw',
        'fa-regular fa-n fa-fw',
        'fa-regular fa-m fa-fw',
        'fa-regular fa-l fa-fw',
        'fa-regular fa-k fa-fw',
        'fa-regular fa-j fa-fw',
        'fa-regular fa-i fa-fw',
        'fa-regular fa-h fa-fw',
        'fa-regular fa-g fa-fw',
        'fa-regular fa-f fa-fw',
        'fa-regular fa-e fa-fw',
        'fa-regular fa-d fa-fw',
        'fa-regular fa-circle-z fa-fw',
        'fa-regular fa-circle-y fa-fw',
        'fa-regular fa-circle-x fa-fw',
        'fa-regular fa-circle-w fa-fw',
        'fa-regular fa-circle-v fa-fw',
        'fa-regular fa-circle-u fa-fw',
        'fa-regular fa-circle-t fa-fw',
        'fa-regular fa-circle-s fa-fw',
        'fa-regular fa-circle-r fa-fw',
        'fa-regular fa-circle-q fa-fw',
        'fa-regular fa-circle-p fa-fw',
        'fa-regular fa-circle-o fa-fw',
        'fa-regular fa-circle-n fa-fw',
        'fa-regular fa-circle-m fa-fw',
        'fa-regular fa-circle-l fa-fw',
        'fa-regular fa-circle-k fa-fw',
        'fa-regular fa-circle-j fa-fw',
        'fa-regular fa-circle-i fa-fw',
        'fa-regular fa-circle-h fa-fw',
        'fa-regular fa-circle-g fa-fw',
        'fa-regular fa-circle-f fa-fw',
        'fa-regular fa-circle-e fa-fw',
        'fa-regular fa-circle-d fa-fw',
        'fa-regular fa-circle-c fa-fw',
        'fa-regular fa-circle-b fa-fw',
        'fa-regular fa-circle-a fa-fw',
        'fa-regular fa-c fa-fw',
        'fa-regular fa-b fa-fw',
        'fa-regular fa-a fa-fw',
        'fa-light fa-z fa-fw',
        'fa-light fa-y fa-fw',
        'fa-light fa-x fa-fw',
        'fa-light fa-w fa-fw',
        'fa-light fa-v fa-fw',
        'fa-light fa-u fa-fw',
        'fa-light fa-t fa-fw',
        'fa-light fa-square-z fa-fw',
        'fa-light fa-square-y fa-fw',
        'fa-light fa-square-x fa-fw',
        'fa-light fa-square-w fa-fw',
        'fa-light fa-square-v fa-fw',
        'fa-light fa-square-u fa-fw',
        'fa-light fa-square-t fa-fw',
        'fa-light fa-square-s fa-fw',
        'fa-light fa-square-r fa-fw',
        'fa-light fa-square-q fa-fw',
        'fa-light fa-square-p fa-fw',
        'fa-light fa-square-o fa-fw',
        'fa-light fa-square-n fa-fw',
        'fa-light fa-square-m fa-fw',
        'fa-light fa-square-l fa-fw',
        'fa-light fa-square-k fa-fw',
        'fa-light fa-square-j fa-fw',
        'fa-light fa-square-i fa-fw',
        'fa-light fa-square-h fa-fw',
        'fa-light fa-square-g fa-fw',
        'fa-light fa-square-f fa-fw',
        'fa-light fa-square-e fa-fw',
        'fa-light fa-square-d fa-fw',
        'fa-light fa-square-c fa-fw',
        'fa-light fa-square-b fa-fw',
        'fa-light fa-square-a fa-fw',
        'fa-light fa-s fa-fw',
        'fa-light fa-r fa-fw',
        'fa-light fa-q fa-fw',
        'fa-light fa-p fa-fw',
        'fa-light fa-o fa-fw',
        'fa-light fa-n fa-fw',
        'fa-light fa-m fa-fw',
        'fa-light fa-l fa-fw',
        'fa-light fa-k fa-fw',
        'fa-light fa-j fa-fw',
        'fa-light fa-i fa-fw',
        'fa-light fa-h fa-fw',
        'fa-light fa-g fa-fw',
        'fa-light fa-f fa-fw',
        'fa-light fa-e fa-fw',
        'fa-light fa-d fa-fw',
        'fa-light fa-circle-z fa-fw',
        'fa-light fa-circle-y fa-fw',
        'fa-light fa-circle-x fa-fw',
        'fa-light fa-circle-w fa-fw',
        'fa-light fa-circle-v fa-fw',
        'fa-light fa-circle-u fa-fw',
        'fa-light fa-circle-t fa-fw',
        'fa-light fa-circle-s fa-fw',
        'fa-light fa-circle-r fa-fw',
        'fa-light fa-circle-q fa-fw',
        'fa-light fa-circle-p fa-fw',
        'fa-light fa-circle-o fa-fw',
        'fa-light fa-circle-n fa-fw',
        'fa-light fa-circle-m fa-fw',
        'fa-light fa-circle-l fa-fw',
        'fa-light fa-circle-k fa-fw',
        'fa-light fa-circle-j fa-fw',
        'fa-light fa-circle-i fa-fw',
        'fa-light fa-circle-h fa-fw',
        'fa-light fa-circle-g fa-fw',
        'fa-light fa-circle-f fa-fw',
        'fa-light fa-circle-e fa-fw',
        'fa-light fa-circle-d fa-fw',
        'fa-light fa-circle-c fa-fw',
        'fa-light fa-circle-b fa-fw',
        'fa-light fa-circle-a fa-fw',
        'fa-light fa-c fa-fw',
        'fa-light fa-b fa-fw',
        'fa-light fa-a fa-fw',
        'fa-thin fa-z fa-fw',
        'fa-thin fa-y fa-fw',
        'fa-thin fa-x fa-fw',
        'fa-thin fa-w fa-fw',
        'fa-thin fa-v fa-fw',
        'fa-thin fa-u fa-fw',
        'fa-thin fa-t fa-fw',
        'fa-thin fa-square-z fa-fw',
        'fa-thin fa-square-y fa-fw',
        'fa-thin fa-square-x fa-fw',
        'fa-thin fa-square-w fa-fw',
        'fa-thin fa-square-v fa-fw',
        'fa-thin fa-square-u fa-fw',
        'fa-thin fa-square-t fa-fw',
        'fa-thin fa-square-s fa-fw',
        'fa-thin fa-square-r fa-fw',
        'fa-thin fa-square-q fa-fw',
        'fa-thin fa-square-p fa-fw',
        'fa-thin fa-square-o fa-fw',
        'fa-thin fa-square-n fa-fw',
        'fa-thin fa-square-m fa-fw',
        'fa-thin fa-square-l fa-fw',
        'fa-thin fa-square-k fa-fw',
        'fa-thin fa-square-j fa-fw',
        'fa-thin fa-square-i fa-fw',
        'fa-thin fa-square-h fa-fw',
        'fa-thin fa-square-g fa-fw',
        'fa-thin fa-square-f fa-fw',
        'fa-thin fa-square-e fa-fw',
        'fa-thin fa-square-d fa-fw',
        'fa-thin fa-square-c fa-fw',
        'fa-thin fa-square-b fa-fw',
        'fa-thin fa-square-a fa-fw',
        'fa-thin fa-s fa-fw',
        'fa-thin fa-r fa-fw',
        'fa-thin fa-q fa-fw',
        'fa-thin fa-p fa-fw',
        'fa-thin fa-o fa-fw',
        'fa-thin fa-n fa-fw',
        'fa-thin fa-m fa-fw',
        'fa-thin fa-l fa-fw',
        'fa-thin fa-k fa-fw',
        'fa-thin fa-j fa-fw',
        'fa-thin fa-i fa-fw',
        'fa-thin fa-h fa-fw',
        'fa-thin fa-g fa-fw',
        'fa-thin fa-f fa-fw',
        'fa-thin fa-e fa-fw',
        'fa-thin fa-d fa-fw',
        'fa-thin fa-circle-z fa-fw',
        'fa-thin fa-circle-y fa-fw',
        'fa-thin fa-circle-x fa-fw',
        'fa-thin fa-circle-w fa-fw',
        'fa-thin fa-circle-v fa-fw',
        'fa-thin fa-circle-u fa-fw',
        'fa-thin fa-circle-t fa-fw',
        'fa-thin fa-circle-s fa-fw',
        'fa-thin fa-circle-r fa-fw',
        'fa-thin fa-circle-q fa-fw',
        'fa-thin fa-circle-p fa-fw',
        'fa-thin fa-circle-o fa-fw',
        'fa-thin fa-circle-n fa-fw',
        'fa-thin fa-circle-m fa-fw',
        'fa-thin fa-circle-l fa-fw',
        'fa-thin fa-circle-k fa-fw',
        'fa-thin fa-circle-j fa-fw',
        'fa-thin fa-circle-i fa-fw',
        'fa-thin fa-circle-h fa-fw',
        'fa-thin fa-circle-g fa-fw',
        'fa-thin fa-circle-f fa-fw',
        'fa-thin fa-circle-e fa-fw',
        'fa-thin fa-circle-d fa-fw',
        'fa-thin fa-circle-c fa-fw',
        'fa-thin fa-circle-b fa-fw',
        'fa-thin fa-circle-a fa-fw',
        'fa-thin fa-c fa-fw',
        'fa-thin fa-b fa-fw',
        'fa-thin fa-a fa-fw',
        'fa-duotone fa-z fa-fw',
        'fa-duotone fa-y fa-fw',
        'fa-duotone fa-x fa-fw',
        'fa-duotone fa-w fa-fw',
        'fa-duotone fa-v fa-fw',
        'fa-duotone fa-u fa-fw',
        'fa-duotone fa-t fa-fw',
        'fa-duotone fa-square-z fa-fw',
        'fa-duotone fa-square-y fa-fw',
        'fa-duotone fa-square-x fa-fw',
        'fa-duotone fa-square-w fa-fw',
        'fa-duotone fa-square-v fa-fw',
        'fa-duotone fa-square-u fa-fw',
        'fa-duotone fa-square-t fa-fw',
        'fa-duotone fa-square-s fa-fw',
        'fa-duotone fa-square-r fa-fw',
        'fa-duotone fa-square-q fa-fw',
        'fa-duotone fa-square-p fa-fw',
        'fa-duotone fa-square-o fa-fw',
        'fa-duotone fa-square-n fa-fw',
        'fa-duotone fa-square-m fa-fw',
        'fa-duotone fa-square-l fa-fw',
        'fa-duotone fa-square-k fa-fw',
        'fa-duotone fa-square-j fa-fw',
        'fa-duotone fa-square-i fa-fw',
        'fa-duotone fa-square-h fa-fw',
        'fa-duotone fa-square-g fa-fw',
        'fa-duotone fa-square-f fa-fw',
        'fa-duotone fa-square-e fa-fw',
        'fa-duotone fa-square-d fa-fw',
        'fa-duotone fa-square-c fa-fw',
        'fa-duotone fa-square-b fa-fw',
        'fa-duotone fa-square-a fa-fw',
        'fa-duotone fa-s fa-fw',
        'fa-duotone fa-r fa-fw',
        'fa-duotone fa-q fa-fw',
        'fa-duotone fa-p fa-fw',
        'fa-duotone fa-o fa-fw',
        'fa-duotone fa-n fa-fw',
        'fa-duotone fa-m fa-fw',
        'fa-duotone fa-l fa-fw',
        'fa-duotone fa-k fa-fw',
        'fa-duotone fa-j fa-fw',
        'fa-duotone fa-i fa-fw',
        'fa-duotone fa-h fa-fw',
        'fa-duotone fa-g fa-fw',
        'fa-duotone fa-f fa-fw',
        'fa-duotone fa-e fa-fw',
        'fa-duotone fa-d fa-fw',
        'fa-duotone fa-circle-z fa-fw',
        'fa-duotone fa-circle-y fa-fw',
        'fa-duotone fa-circle-x fa-fw',
        'fa-duotone fa-circle-w fa-fw',
        'fa-duotone fa-circle-v fa-fw',
        'fa-duotone fa-circle-u fa-fw',
        'fa-duotone fa-circle-t fa-fw',
        'fa-duotone fa-circle-s fa-fw',
        'fa-duotone fa-circle-r fa-fw',
        'fa-duotone fa-circle-q fa-fw',
        'fa-duotone fa-circle-p fa-fw',
        'fa-duotone fa-circle-o fa-fw',
        'fa-duotone fa-circle-n fa-fw',
        'fa-duotone fa-circle-m fa-fw',
        'fa-duotone fa-circle-l fa-fw',
        'fa-duotone fa-circle-k fa-fw',
        'fa-duotone fa-circle-j fa-fw',
        'fa-duotone fa-circle-i fa-fw',
        'fa-duotone fa-circle-h fa-fw',
        'fa-duotone fa-circle-g fa-fw',
        'fa-duotone fa-circle-f fa-fw',
        'fa-duotone fa-circle-e fa-fw',
        'fa-duotone fa-circle-d fa-fw',
        'fa-duotone fa-circle-c fa-fw',
        'fa-duotone fa-circle-b fa-fw',
        'fa-duotone fa-circle-a fa-fw',
        'fa-duotone fa-c fa-fw',
        'fa-duotone fa-b fa-fw',
        'fa-duotone fa-a fa-fw',
        'fa-sharp fa-solid fa-z fa-fw',
        'fa-sharp fa-solid fa-y fa-fw',
        'fa-sharp fa-solid fa-x fa-fw',
        'fa-sharp fa-solid fa-w fa-fw',
        'fa-sharp fa-solid fa-v fa-fw',
        'fa-sharp fa-solid fa-u fa-fw',
        'fa-sharp fa-solid fa-t fa-fw',
        'fa-sharp fa-solid fa-square-z fa-fw',
        'fa-sharp fa-solid fa-square-y fa-fw',
        'fa-sharp fa-solid fa-square-x fa-fw',
        'fa-sharp fa-solid fa-square-w fa-fw',
        'fa-sharp fa-solid fa-square-v fa-fw',
        'fa-sharp fa-solid fa-square-u fa-fw',
        'fa-sharp fa-solid fa-square-t fa-fw',
        'fa-sharp fa-solid fa-square-s fa-fw',
        'fa-sharp fa-solid fa-square-r fa-fw',
        'fa-sharp fa-solid fa-square-q fa-fw',
        'fa-sharp fa-solid fa-square-p fa-fw',
        'fa-sharp fa-solid fa-square-o fa-fw',
        'fa-sharp fa-solid fa-square-n fa-fw',
        'fa-sharp fa-solid fa-square-m fa-fw',
        'fa-sharp fa-solid fa-square-l fa-fw',
        'fa-sharp fa-solid fa-square-k fa-fw',
        'fa-sharp fa-solid fa-square-j fa-fw',
        'fa-sharp fa-solid fa-square-i fa-fw',
        'fa-sharp fa-solid fa-square-h fa-fw',
        'fa-sharp fa-solid fa-square-g fa-fw',
        'fa-sharp fa-solid fa-square-f fa-fw',
        'fa-sharp fa-solid fa-square-e fa-fw',
        'fa-sharp fa-solid fa-square-d fa-fw',
        'fa-sharp fa-solid fa-square-c fa-fw',
        'fa-sharp fa-solid fa-square-b fa-fw',
        'fa-sharp fa-solid fa-square-a fa-fw',
        'fa-sharp fa-solid fa-s fa-fw',
        'fa-sharp fa-solid fa-r fa-fw',
        'fa-sharp fa-solid fa-q fa-fw',
        'fa-sharp fa-solid fa-p fa-fw',
        'fa-sharp fa-solid fa-o fa-fw',
        'fa-sharp fa-solid fa-n fa-fw',
        'fa-sharp fa-solid fa-m fa-fw',
        'fa-sharp fa-solid fa-l fa-fw',
        'fa-sharp fa-solid fa-k fa-fw',
        'fa-sharp fa-solid fa-j fa-fw',
        'fa-sharp fa-solid fa-i fa-fw',
        'fa-sharp fa-solid fa-h fa-fw',
        'fa-sharp fa-solid fa-g fa-fw',
        'fa-sharp fa-solid fa-f fa-fw',
        'fa-sharp fa-solid fa-e fa-fw',
        'fa-sharp fa-solid fa-d fa-fw',
        'fa-sharp fa-solid fa-circle-z fa-fw',
        'fa-sharp fa-solid fa-circle-y fa-fw',
        'fa-sharp fa-solid fa-circle-x fa-fw',
        'fa-sharp fa-solid fa-circle-w fa-fw',
        'fa-sharp fa-solid fa-circle-v fa-fw',
        'fa-sharp fa-solid fa-circle-u fa-fw',
        'fa-sharp fa-solid fa-circle-t fa-fw',
        'fa-sharp fa-solid fa-circle-s fa-fw',
        'fa-sharp fa-solid fa-circle-r fa-fw',
        'fa-sharp fa-solid fa-circle-q fa-fw',
        'fa-sharp fa-solid fa-circle-p fa-fw',
        'fa-sharp fa-solid fa-circle-o fa-fw',
        'fa-sharp fa-solid fa-circle-n fa-fw',
        'fa-sharp fa-solid fa-circle-m fa-fw',
        'fa-sharp fa-solid fa-circle-l fa-fw',
        'fa-sharp fa-solid fa-circle-k fa-fw',
        'fa-sharp fa-solid fa-circle-j fa-fw',
        'fa-sharp fa-solid fa-circle-i fa-fw',
        'fa-sharp fa-solid fa-circle-h fa-fw',
        'fa-sharp fa-solid fa-circle-g fa-fw',
        'fa-sharp fa-solid fa-circle-f fa-fw',
        'fa-sharp fa-solid fa-circle-e fa-fw',
        'fa-sharp fa-solid fa-circle-d fa-fw',
        'fa-sharp fa-solid fa-circle-c fa-fw',
        'fa-sharp fa-solid fa-circle-b fa-fw',
        'fa-sharp fa-solid fa-circle-a fa-fw',
        'fa-sharp fa-solid fa-c fa-fw',
        'fa-sharp fa-solid fa-b fa-fw',
        'fa-sharp fa-solid fa-a fa-fw',
        'fa-sharp fa-regular fa-z fa-fw',
        'fa-sharp fa-regular fa-y fa-fw',
        'fa-sharp fa-regular fa-x fa-fw',
        'fa-sharp fa-regular fa-w fa-fw',
        'fa-sharp fa-regular fa-v fa-fw',
        'fa-sharp fa-regular fa-u fa-fw',
        'fa-sharp fa-regular fa-t fa-fw',
        'fa-sharp fa-regular fa-square-z fa-fw',
        'fa-sharp fa-regular fa-square-y fa-fw',
        'fa-sharp fa-regular fa-square-x fa-fw',
        'fa-sharp fa-regular fa-square-w fa-fw',
        'fa-sharp fa-regular fa-square-v fa-fw',
        'fa-sharp fa-regular fa-square-u fa-fw',
        'fa-sharp fa-regular fa-square-t fa-fw',
        'fa-sharp fa-regular fa-square-s fa-fw',
        'fa-sharp fa-regular fa-square-r fa-fw',
        'fa-sharp fa-regular fa-square-q fa-fw',
        'fa-sharp fa-regular fa-square-p fa-fw',
        'fa-sharp fa-regular fa-square-o fa-fw',
        'fa-sharp fa-regular fa-square-n fa-fw',
        'fa-sharp fa-regular fa-square-m fa-fw',
        'fa-sharp fa-regular fa-square-l fa-fw',
        'fa-sharp fa-regular fa-square-k fa-fw',
        'fa-sharp fa-regular fa-square-j fa-fw',
        'fa-sharp fa-regular fa-square-i fa-fw',
        'fa-sharp fa-regular fa-square-h fa-fw',
        'fa-sharp fa-regular fa-square-g fa-fw',
        'fa-sharp fa-regular fa-square-f fa-fw',
        'fa-sharp fa-regular fa-square-e fa-fw',
        'fa-sharp fa-regular fa-square-d fa-fw',
        'fa-sharp fa-regular fa-square-c fa-fw',
        'fa-sharp fa-regular fa-square-b fa-fw',
        'fa-sharp fa-regular fa-square-a fa-fw',
        'fa-sharp fa-regular fa-s fa-fw',
        'fa-sharp fa-regular fa-r fa-fw',
        'fa-sharp fa-regular fa-q fa-fw',
        'fa-sharp fa-regular fa-p fa-fw',
        'fa-sharp fa-regular fa-o fa-fw',
        'fa-sharp fa-regular fa-n fa-fw',
        'fa-sharp fa-regular fa-m fa-fw',
        'fa-sharp fa-regular fa-l fa-fw',
        'fa-sharp fa-regular fa-k fa-fw',
        'fa-sharp fa-regular fa-j fa-fw',
        'fa-sharp fa-regular fa-i fa-fw',
        'fa-sharp fa-regular fa-h fa-fw',
        'fa-sharp fa-regular fa-g fa-fw',
        'fa-sharp fa-regular fa-f fa-fw',
        'fa-sharp fa-regular fa-e fa-fw',
        'fa-sharp fa-regular fa-d fa-fw',
        'fa-sharp fa-regular fa-circle-z fa-fw',
        'fa-sharp fa-regular fa-circle-y fa-fw',
        'fa-sharp fa-regular fa-circle-x fa-fw',
        'fa-sharp fa-regular fa-circle-w fa-fw',
        'fa-sharp fa-regular fa-circle-v fa-fw',
        'fa-sharp fa-regular fa-circle-u fa-fw',
        'fa-sharp fa-regular fa-circle-t fa-fw',
        'fa-sharp fa-regular fa-circle-s fa-fw',
        'fa-sharp fa-regular fa-circle-r fa-fw',
        'fa-sharp fa-regular fa-circle-q fa-fw',
        'fa-sharp fa-regular fa-circle-p fa-fw',
        'fa-sharp fa-regular fa-circle-o fa-fw',
        'fa-sharp fa-regular fa-circle-n fa-fw',
        'fa-sharp fa-regular fa-circle-m fa-fw',
        'fa-sharp fa-regular fa-circle-l fa-fw',
        'fa-sharp fa-regular fa-circle-k fa-fw',
        'fa-sharp fa-regular fa-circle-j fa-fw',
        'fa-sharp fa-regular fa-circle-i fa-fw',
        'fa-sharp fa-regular fa-circle-h fa-fw',
        'fa-sharp fa-regular fa-circle-g fa-fw',
        'fa-sharp fa-regular fa-circle-f fa-fw',
        'fa-sharp fa-regular fa-circle-e fa-fw',
        'fa-sharp fa-regular fa-circle-d fa-fw',
        'fa-sharp fa-regular fa-circle-c fa-fw',
        'fa-sharp fa-regular fa-circle-b fa-fw',
        'fa-sharp fa-regular fa-circle-a fa-fw',
        'fa-sharp fa-regular fa-c fa-fw',
        'fa-sharp fa-regular fa-b fa-fw',
        'fa-sharp fa-regular fa-a fa-fw',
        'fa-sharp fa-light fa-z fa-fw',
        'fa-sharp fa-light fa-y fa-fw',
        'fa-sharp fa-light fa-x fa-fw',
        'fa-sharp fa-light fa-w fa-fw',
        'fa-sharp fa-light fa-v fa-fw',
        'fa-sharp fa-light fa-u fa-fw',
        'fa-sharp fa-light fa-t fa-fw',
        'fa-sharp fa-light fa-square-z fa-fw',
        'fa-sharp fa-light fa-square-y fa-fw',
        'fa-sharp fa-light fa-square-x fa-fw',
        'fa-sharp fa-light fa-square-w fa-fw',
        'fa-sharp fa-light fa-square-v fa-fw',
        'fa-sharp fa-light fa-square-u fa-fw',
        'fa-sharp fa-light fa-square-t fa-fw',
        'fa-sharp fa-light fa-square-s fa-fw',
        'fa-sharp fa-light fa-square-r fa-fw',
        'fa-sharp fa-light fa-square-q fa-fw',
        'fa-sharp fa-light fa-square-p fa-fw',
        'fa-sharp fa-light fa-square-o fa-fw',
        'fa-sharp fa-light fa-square-n fa-fw',
        'fa-sharp fa-light fa-square-m fa-fw',
        'fa-sharp fa-light fa-square-l fa-fw',
        'fa-sharp fa-light fa-square-k fa-fw',
        'fa-sharp fa-light fa-square-j fa-fw',
        'fa-sharp fa-light fa-square-i fa-fw',
        'fa-sharp fa-light fa-square-h fa-fw',
        'fa-sharp fa-light fa-square-g fa-fw',
        'fa-sharp fa-light fa-square-f fa-fw',
        'fa-sharp fa-light fa-square-e fa-fw',
        'fa-sharp fa-light fa-square-d fa-fw',
        'fa-sharp fa-light fa-square-c fa-fw',
        'fa-sharp fa-light fa-square-b fa-fw',
        'fa-sharp fa-light fa-square-a fa-fw',
        'fa-sharp fa-light fa-s fa-fw',
        'fa-sharp fa-light fa-r fa-fw',
        'fa-sharp fa-light fa-q fa-fw',
        'fa-sharp fa-light fa-p fa-fw',
        'fa-sharp fa-light fa-o fa-fw',
        'fa-sharp fa-light fa-n fa-fw',
        'fa-sharp fa-light fa-m fa-fw',
        'fa-sharp fa-light fa-l fa-fw',
        'fa-sharp fa-light fa-k fa-fw',
        'fa-sharp fa-light fa-j fa-fw',
        'fa-sharp fa-light fa-i fa-fw',
        'fa-sharp fa-light fa-h fa-fw',
        'fa-sharp fa-light fa-g fa-fw',
        'fa-sharp fa-light fa-f fa-fw',
        'fa-sharp fa-light fa-e fa-fw',
        'fa-sharp fa-light fa-d fa-fw',
        'fa-sharp fa-light fa-circle-z fa-fw',
        'fa-sharp fa-light fa-circle-y fa-fw',
        'fa-sharp fa-light fa-circle-x fa-fw',
        'fa-sharp fa-light fa-circle-w fa-fw',
        'fa-sharp fa-light fa-circle-v fa-fw',
        'fa-sharp fa-light fa-circle-u fa-fw',
        'fa-sharp fa-light fa-circle-t fa-fw',
        'fa-sharp fa-light fa-circle-s fa-fw',
        'fa-sharp fa-light fa-circle-r fa-fw',
        'fa-sharp fa-light fa-circle-q fa-fw',
        'fa-sharp fa-light fa-circle-p fa-fw',
        'fa-sharp fa-light fa-circle-o fa-fw',
        'fa-sharp fa-light fa-circle-n fa-fw',
        'fa-sharp fa-light fa-circle-m fa-fw',
        'fa-sharp fa-light fa-circle-l fa-fw',
        'fa-sharp fa-light fa-circle-k fa-fw',
        'fa-sharp fa-light fa-circle-j fa-fw',
        'fa-sharp fa-light fa-circle-i fa-fw',
        'fa-sharp fa-light fa-circle-h fa-fw',
        'fa-sharp fa-light fa-circle-g fa-fw',
        'fa-sharp fa-light fa-circle-f fa-fw',
        'fa-sharp fa-light fa-circle-e fa-fw',
        'fa-sharp fa-light fa-circle-d fa-fw',
        'fa-sharp fa-light fa-circle-c fa-fw',
        'fa-sharp fa-light fa-circle-b fa-fw',
        'fa-sharp fa-light fa-circle-a fa-fw',
        'fa-sharp fa-light fa-c fa-fw',
        'fa-sharp fa-light fa-b fa-fw',
        'fa-sharp fa-light fa-a fa-fw',
      ],
    },
    {
      title: 'Animals',
      items: [
        'fa-solid fa-hippo fa-fw',
        'fa-regular fa-hippo fa-fw',
        'fa-light fa-hippo fa-fw',
        'fa-thin fa-hippo fa-fw',
        'fa-duotone fa-hippo fa-fw',
        'fa-sharp fa-solid fa-hippo fa-fw',
        'fa-sharp fa-regular fa-hippo fa-fw',
        'fa-sharp fa-light fa-hippo fa-fw',
        'fa-solid fa-feather fa-fw',
        'fa-regular fa-feather fa-fw',
        'fa-light fa-feather fa-fw',
        'fa-thin fa-feather fa-fw',
        'fa-duotone fa-feather fa-fw',
        'fa-sharp fa-solid fa-feather fa-fw',
        'fa-sharp fa-regular fa-feather fa-fw',
        'fa-sharp fa-light fa-feather fa-fw',
        'fa-solid fa-fish fa-fw',
        'fa-regular fa-fish fa-fw',
        'fa-light fa-fish fa-fw',
        'fa-thin fa-fish fa-fw',
        'fa-duotone fa-fish fa-fw',
        'fa-sharp fa-solid fa-fish fa-fw',
        'fa-sharp fa-regular fa-fish fa-fw',
        'fa-sharp fa-light fa-fish fa-fw',
        'fa-solid fa-dolphin fa-fw',
        'fa-regular fa-dolphin fa-fw',
        'fa-light fa-dolphin fa-fw',
        'fa-thin fa-dolphin fa-fw',
        'fa-duotone fa-dolphin fa-fw',
        'fa-sharp fa-solid fa-dolphin fa-fw',
        'fa-sharp fa-regular fa-dolphin fa-fw',
        'fa-sharp fa-light fa-dolphin fa-fw',
        'fa-solid fa-bird fa-fw',
        'fa-regular fa-bird fa-fw',
        'fa-light fa-bird fa-fw',
        'fa-thin fa-bird fa-fw',
        'fa-duotone fa-bird fa-fw',
        'fa-sharp fa-solid fa-bird fa-fw',
        'fa-sharp fa-regular fa-bird fa-fw',
        'fa-sharp fa-light fa-bird fa-fw',
        'fa-solid fa-crab fa-fw',
        'fa-regular fa-crab fa-fw',
        'fa-light fa-crab fa-fw',
        'fa-thin fa-crab fa-fw',
        'fa-duotone fa-crab fa-fw',
        'fa-sharp fa-solid fa-crab fa-fw',
        'fa-sharp fa-regular fa-crab fa-fw',
        'fa-sharp fa-light fa-crab fa-fw',
        'fa-solid fa-bat fa-fw',
        'fa-regular fa-bat fa-fw',
        'fa-light fa-bat fa-fw',
        'fa-thin fa-bat fa-fw',
        'fa-duotone fa-bat fa-fw',
        'fa-sharp fa-solid fa-bat fa-fw',
        'fa-sharp fa-regular fa-bat fa-fw',
        'fa-sharp fa-light fa-bat fa-fw',
        'fa-solid fa-dragon fa-fw',
        'fa-regular fa-dragon fa-fw',
        'fa-light fa-dragon fa-fw',
        'fa-thin fa-dragon fa-fw',
        'fa-duotone fa-dragon fa-fw',
        'fa-sharp fa-solid fa-dragon fa-fw',
        'fa-sharp fa-regular fa-dragon fa-fw',
        'fa-sharp fa-light fa-dragon fa-fw',
        'fa-solid fa-otter fa-fw',
        'fa-regular fa-otter fa-fw',
        'fa-light fa-otter fa-fw',
        'fa-thin fa-otter fa-fw',
        'fa-duotone fa-otter fa-fw',
        'fa-sharp fa-solid fa-otter fa-fw',
        'fa-sharp fa-regular fa-otter fa-fw',
        'fa-sharp fa-light fa-otter fa-fw',
        'fa-solid fa-kiwi-bird fa-fw',
        'fa-regular fa-kiwi-bird fa-fw',
        'fa-light fa-kiwi-bird fa-fw',
        'fa-thin fa-kiwi-bird fa-fw',
        'fa-duotone fa-kiwi-bird fa-fw',
        'fa-sharp fa-solid fa-kiwi-bird fa-fw',
        'fa-sharp fa-regular fa-kiwi-bird fa-fw',
        'fa-sharp fa-light fa-kiwi-bird fa-fw',
        'fa-solid fa-worm fa-fw',
        'fa-solid fa-whale fa-fw',
        'fa-solid fa-unicorn fa-fw',
        'fa-solid fa-turtle fa-fw',
        'fa-solid fa-teddy-bear fa-fw',
        'fa-solid fa-squirrel fa-fw',
        'fa-solid fa-squid fa-fw',
        'fa-solid fa-spider-black-widow fa-fw',
        'fa-solid fa-spider fa-fw',
        'fa-solid fa-snake fa-fw',
        'fa-solid fa-skull-cow fa-fw',
        'fa-solid fa-shrimp fa-fw',
        'fa-solid fa-shield-dog fa-fw',
        'fa-solid fa-shield-cat fa-fw',
        'fa-solid fa-sheep fa-fw',
        'fa-solid fa-ram fa-fw',
        'fa-solid fa-rabbit-running fa-fw',
        'fa-solid fa-rabbit fa-fw',
        'fa-solid fa-pig fa-fw',
        'fa-solid fa-pegasus fa-fw',
        'fa-solid fa-paw-simple fa-fw',
        'fa-solid fa-paw-claws fa-fw',
        'fa-solid fa-paw fa-fw',
        'fa-solid fa-narwhal fa-fw',
        'fa-solid fa-mouse-field fa-fw',
        'fa-solid fa-mosquito fa-fw',
        'fa-solid fa-monkey fa-fw',
        'fa-solid fa-locust fa-fw',
        'fa-solid fa-lobster fa-fw',
        'fa-solid fa-horse-saddle fa-fw',
        'fa-solid fa-horse-head fa-fw',
        'fa-solid fa-horse fa-fw',
        'fa-solid fa-frog fa-fw',
        'fa-solid fa-fish-fins fa-fw',
        'fa-solid fa-fish-bones fa-fw',
        'fa-solid fa-feather-pointed fa-fw',
        'fa-solid fa-elephant fa-fw',
        'fa-solid fa-duck fa-fw',
        'fa-solid fa-dove fa-fw',
        'fa-solid fa-dog-leashed fa-fw',
        'fa-solid fa-dog fa-fw',
        'fa-solid fa-dinosaur fa-fw',
        'fa-solid fa-deer-rudolph fa-fw',
        'fa-solid fa-deer fa-fw',
        'fa-solid fa-crow fa-fw',
        'fa-solid fa-cow fa-fw',
        'fa-solid fa-cat-space fa-fw',
        'fa-solid fa-cat fa-fw',
        'fa-solid fa-bugs fa-fw',
        'fa-solid fa-bee fa-fw',
        'fa-solid fa-badger-honey fa-fw',
        'fa-solid fa-alicorn fa-fw',
        'fa-regular fa-worm fa-fw',
        'fa-regular fa-whale fa-fw',
        'fa-regular fa-unicorn fa-fw',
        'fa-regular fa-turtle fa-fw',
        'fa-regular fa-teddy-bear fa-fw',
        'fa-regular fa-squirrel fa-fw',
        'fa-regular fa-squid fa-fw',
        'fa-regular fa-spider-black-widow fa-fw',
        'fa-regular fa-spider fa-fw',
        'fa-regular fa-snake fa-fw',
        'fa-regular fa-skull-cow fa-fw',
        'fa-regular fa-shrimp fa-fw',
        'fa-regular fa-shield-dog fa-fw',
        'fa-regular fa-shield-cat fa-fw',
        'fa-regular fa-sheep fa-fw',
        'fa-regular fa-ram fa-fw',
        'fa-regular fa-rabbit-running fa-fw',
        'fa-regular fa-rabbit fa-fw',
        'fa-regular fa-pig fa-fw',
        'fa-regular fa-pegasus fa-fw',
        'fa-regular fa-paw-simple fa-fw',
        'fa-regular fa-paw-claws fa-fw',
        'fa-regular fa-paw fa-fw',
        'fa-regular fa-narwhal fa-fw',
        'fa-regular fa-mouse-field fa-fw',
        'fa-regular fa-mosquito fa-fw',
        'fa-regular fa-monkey fa-fw',
        'fa-regular fa-locust fa-fw',
        'fa-regular fa-lobster fa-fw',
        'fa-regular fa-horse-saddle fa-fw',
        'fa-regular fa-horse-head fa-fw',
        'fa-regular fa-horse fa-fw',
        'fa-regular fa-frog fa-fw',
        'fa-regular fa-fish-fins fa-fw',
        'fa-regular fa-fish-bones fa-fw',
        'fa-regular fa-feather-pointed fa-fw',
        'fa-regular fa-elephant fa-fw',
        'fa-regular fa-duck fa-fw',
        'fa-regular fa-dove fa-fw',
        'fa-regular fa-dog-leashed fa-fw',
        'fa-regular fa-dog fa-fw',
        'fa-regular fa-dinosaur fa-fw',
        'fa-regular fa-deer-rudolph fa-fw',
        'fa-regular fa-deer fa-fw',
        'fa-regular fa-crow fa-fw',
        'fa-regular fa-cow fa-fw',
        'fa-regular fa-cat-space fa-fw',
        'fa-regular fa-cat fa-fw',
        'fa-regular fa-bugs fa-fw',
        'fa-regular fa-bee fa-fw',
        'fa-regular fa-badger-honey fa-fw',
        'fa-regular fa-alicorn fa-fw',
        'fa-light fa-worm fa-fw',
        'fa-light fa-whale fa-fw',
        'fa-light fa-unicorn fa-fw',
        'fa-light fa-turtle fa-fw',
        'fa-light fa-teddy-bear fa-fw',
        'fa-light fa-squirrel fa-fw',
        'fa-light fa-squid fa-fw',
        'fa-light fa-spider-black-widow fa-fw',
        'fa-light fa-spider fa-fw',
        'fa-light fa-snake fa-fw',
        'fa-light fa-skull-cow fa-fw',
        'fa-light fa-shrimp fa-fw',
        'fa-light fa-shield-dog fa-fw',
        'fa-light fa-shield-cat fa-fw',
        'fa-light fa-sheep fa-fw',
        'fa-light fa-ram fa-fw',
        'fa-light fa-rabbit-running fa-fw',
        'fa-light fa-rabbit fa-fw',
        'fa-light fa-pig fa-fw',
        'fa-light fa-pegasus fa-fw',
        'fa-light fa-paw-simple fa-fw',
        'fa-light fa-paw-claws fa-fw',
        'fa-light fa-paw fa-fw',
        'fa-light fa-narwhal fa-fw',
        'fa-light fa-mouse-field fa-fw',
        'fa-light fa-mosquito fa-fw',
        'fa-light fa-monkey fa-fw',
        'fa-light fa-locust fa-fw',
        'fa-light fa-lobster fa-fw',
        'fa-light fa-horse-saddle fa-fw',
        'fa-light fa-horse-head fa-fw',
        'fa-light fa-horse fa-fw',
        'fa-light fa-frog fa-fw',
        'fa-light fa-fish-fins fa-fw',
        'fa-light fa-fish-bones fa-fw',
        'fa-light fa-feather-pointed fa-fw',
        'fa-light fa-elephant fa-fw',
        'fa-light fa-duck fa-fw',
        'fa-light fa-dove fa-fw',
        'fa-light fa-dog-leashed fa-fw',
        'fa-light fa-dog fa-fw',
        'fa-light fa-dinosaur fa-fw',
        'fa-light fa-deer-rudolph fa-fw',
        'fa-light fa-deer fa-fw',
        'fa-light fa-crow fa-fw',
        'fa-light fa-cow fa-fw',
        'fa-light fa-cat-space fa-fw',
        'fa-light fa-cat fa-fw',
        'fa-light fa-bugs fa-fw',
        'fa-light fa-bee fa-fw',
        'fa-light fa-badger-honey fa-fw',
        'fa-light fa-alicorn fa-fw',
        'fa-thin fa-worm fa-fw',
        'fa-thin fa-whale fa-fw',
        'fa-thin fa-unicorn fa-fw',
        'fa-thin fa-turtle fa-fw',
        'fa-thin fa-teddy-bear fa-fw',
        'fa-thin fa-squirrel fa-fw',
        'fa-thin fa-squid fa-fw',
        'fa-thin fa-spider-black-widow fa-fw',
        'fa-thin fa-spider fa-fw',
        'fa-thin fa-snake fa-fw',
        'fa-thin fa-skull-cow fa-fw',
        'fa-thin fa-shrimp fa-fw',
        'fa-thin fa-shield-dog fa-fw',
        'fa-thin fa-shield-cat fa-fw',
        'fa-thin fa-sheep fa-fw',
        'fa-thin fa-ram fa-fw',
        'fa-thin fa-rabbit-running fa-fw',
        'fa-thin fa-rabbit fa-fw',
        'fa-thin fa-pig fa-fw',
        'fa-thin fa-pegasus fa-fw',
        'fa-thin fa-paw-simple fa-fw',
        'fa-thin fa-paw-claws fa-fw',
        'fa-thin fa-paw fa-fw',
        'fa-thin fa-narwhal fa-fw',
        'fa-thin fa-mouse-field fa-fw',
        'fa-thin fa-mosquito fa-fw',
        'fa-thin fa-monkey fa-fw',
        'fa-thin fa-locust fa-fw',
        'fa-thin fa-lobster fa-fw',
        'fa-thin fa-horse-saddle fa-fw',
        'fa-thin fa-horse-head fa-fw',
        'fa-thin fa-horse fa-fw',
        'fa-thin fa-frog fa-fw',
        'fa-thin fa-fish-fins fa-fw',
        'fa-thin fa-fish-bones fa-fw',
        'fa-thin fa-feather-pointed fa-fw',
        'fa-thin fa-elephant fa-fw',
        'fa-thin fa-duck fa-fw',
        'fa-thin fa-dove fa-fw',
        'fa-thin fa-dog-leashed fa-fw',
        'fa-thin fa-dog fa-fw',
        'fa-thin fa-dinosaur fa-fw',
        'fa-thin fa-deer-rudolph fa-fw',
        'fa-thin fa-deer fa-fw',
        'fa-thin fa-crow fa-fw',
        'fa-thin fa-cow fa-fw',
        'fa-thin fa-cat-space fa-fw',
        'fa-thin fa-cat fa-fw',
        'fa-thin fa-bugs fa-fw',
        'fa-thin fa-bee fa-fw',
        'fa-thin fa-badger-honey fa-fw',
        'fa-thin fa-alicorn fa-fw',
        'fa-duotone fa-worm fa-fw',
        'fa-duotone fa-whale fa-fw',
        'fa-duotone fa-unicorn fa-fw',
        'fa-duotone fa-turtle fa-fw',
        'fa-duotone fa-teddy-bear fa-fw',
        'fa-duotone fa-squirrel fa-fw',
        'fa-duotone fa-squid fa-fw',
        'fa-duotone fa-spider-black-widow fa-fw',
        'fa-duotone fa-spider fa-fw',
        'fa-duotone fa-snake fa-fw',
        'fa-duotone fa-skull-cow fa-fw',
        'fa-duotone fa-shrimp fa-fw',
        'fa-duotone fa-shield-dog fa-fw',
        'fa-duotone fa-shield-cat fa-fw',
        'fa-duotone fa-sheep fa-fw',
        'fa-duotone fa-ram fa-fw',
        'fa-duotone fa-rabbit-running fa-fw',
        'fa-duotone fa-rabbit fa-fw',
        'fa-duotone fa-pig fa-fw',
        'fa-duotone fa-pegasus fa-fw',
        'fa-duotone fa-paw-simple fa-fw',
        'fa-duotone fa-paw-claws fa-fw',
        'fa-duotone fa-paw fa-fw',
        'fa-duotone fa-narwhal fa-fw',
        'fa-duotone fa-mouse-field fa-fw',
        'fa-duotone fa-mosquito fa-fw',
        'fa-duotone fa-monkey fa-fw',
        'fa-duotone fa-locust fa-fw',
        'fa-duotone fa-lobster fa-fw',
        'fa-duotone fa-horse-saddle fa-fw',
        'fa-duotone fa-horse-head fa-fw',
        'fa-duotone fa-horse fa-fw',
        'fa-duotone fa-frog fa-fw',
        'fa-duotone fa-fish-fins fa-fw',
        'fa-duotone fa-fish-bones fa-fw',
        'fa-duotone fa-feather-pointed fa-fw',
        'fa-duotone fa-elephant fa-fw',
        'fa-duotone fa-duck fa-fw',
        'fa-duotone fa-dove fa-fw',
        'fa-duotone fa-dog-leashed fa-fw',
        'fa-duotone fa-dog fa-fw',
        'fa-duotone fa-dinosaur fa-fw',
        'fa-duotone fa-deer-rudolph fa-fw',
        'fa-duotone fa-deer fa-fw',
        'fa-duotone fa-crow fa-fw',
        'fa-duotone fa-cow fa-fw',
        'fa-duotone fa-cat-space fa-fw',
        'fa-duotone fa-cat fa-fw',
        'fa-duotone fa-bugs fa-fw',
        'fa-duotone fa-bee fa-fw',
        'fa-duotone fa-badger-honey fa-fw',
        'fa-duotone fa-alicorn fa-fw',
        'fa-sharp fa-solid fa-worm fa-fw',
        'fa-sharp fa-solid fa-whale fa-fw',
        'fa-sharp fa-solid fa-unicorn fa-fw',
        'fa-sharp fa-solid fa-turtle fa-fw',
        'fa-sharp fa-solid fa-teddy-bear fa-fw',
        'fa-sharp fa-solid fa-squirrel fa-fw',
        'fa-sharp fa-solid fa-squid fa-fw',
        'fa-sharp fa-solid fa-spider-black-widow fa-fw',
        'fa-sharp fa-solid fa-spider fa-fw',
        'fa-sharp fa-solid fa-snake fa-fw',
        'fa-sharp fa-solid fa-skull-cow fa-fw',
        'fa-sharp fa-solid fa-shrimp fa-fw',
        'fa-sharp fa-solid fa-shield-dog fa-fw',
        'fa-sharp fa-solid fa-shield-cat fa-fw',
        'fa-sharp fa-solid fa-sheep fa-fw',
        'fa-sharp fa-solid fa-ram fa-fw',
        'fa-sharp fa-solid fa-rabbit-running fa-fw',
        'fa-sharp fa-solid fa-rabbit fa-fw',
        'fa-sharp fa-solid fa-pig fa-fw',
        'fa-sharp fa-solid fa-pegasus fa-fw',
        'fa-sharp fa-solid fa-paw-simple fa-fw',
        'fa-sharp fa-solid fa-paw-claws fa-fw',
        'fa-sharp fa-solid fa-paw fa-fw',
        'fa-sharp fa-solid fa-narwhal fa-fw',
        'fa-sharp fa-solid fa-mouse-field fa-fw',
        'fa-sharp fa-solid fa-mosquito fa-fw',
        'fa-sharp fa-solid fa-monkey fa-fw',
        'fa-sharp fa-solid fa-locust fa-fw',
        'fa-sharp fa-solid fa-lobster fa-fw',
        'fa-sharp fa-solid fa-horse-saddle fa-fw',
        'fa-sharp fa-solid fa-horse-head fa-fw',
        'fa-sharp fa-solid fa-horse fa-fw',
        'fa-sharp fa-solid fa-frog fa-fw',
        'fa-sharp fa-solid fa-fish-fins fa-fw',
        'fa-sharp fa-solid fa-fish-bones fa-fw',
        'fa-sharp fa-solid fa-feather-pointed fa-fw',
        'fa-sharp fa-solid fa-elephant fa-fw',
        'fa-sharp fa-solid fa-duck fa-fw',
        'fa-sharp fa-solid fa-dove fa-fw',
        'fa-sharp fa-solid fa-dog-leashed fa-fw',
        'fa-sharp fa-solid fa-dog fa-fw',
        'fa-sharp fa-solid fa-dinosaur fa-fw',
        'fa-sharp fa-solid fa-deer-rudolph fa-fw',
        'fa-sharp fa-solid fa-deer fa-fw',
        'fa-sharp fa-solid fa-crow fa-fw',
        'fa-sharp fa-solid fa-cow fa-fw',
        'fa-sharp fa-solid fa-cat-space fa-fw',
        'fa-sharp fa-solid fa-cat fa-fw',
        'fa-sharp fa-solid fa-bugs fa-fw',
        'fa-sharp fa-solid fa-bee fa-fw',
        'fa-sharp fa-solid fa-badger-honey fa-fw',
        'fa-sharp fa-solid fa-alicorn fa-fw',
        'fa-sharp fa-regular fa-worm fa-fw',
        'fa-sharp fa-regular fa-whale fa-fw',
        'fa-sharp fa-regular fa-unicorn fa-fw',
        'fa-sharp fa-regular fa-turtle fa-fw',
        'fa-sharp fa-regular fa-teddy-bear fa-fw',
        'fa-sharp fa-regular fa-squirrel fa-fw',
        'fa-sharp fa-regular fa-squid fa-fw',
        'fa-sharp fa-regular fa-spider-black-widow fa-fw',
        'fa-sharp fa-regular fa-spider fa-fw',
        'fa-sharp fa-regular fa-snake fa-fw',
        'fa-sharp fa-regular fa-skull-cow fa-fw',
        'fa-sharp fa-regular fa-shrimp fa-fw',
        'fa-sharp fa-regular fa-shield-dog fa-fw',
        'fa-sharp fa-regular fa-shield-cat fa-fw',
        'fa-sharp fa-regular fa-sheep fa-fw',
        'fa-sharp fa-regular fa-ram fa-fw',
        'fa-sharp fa-regular fa-rabbit-running fa-fw',
        'fa-sharp fa-regular fa-rabbit fa-fw',
        'fa-sharp fa-regular fa-pig fa-fw',
        'fa-sharp fa-regular fa-pegasus fa-fw',
        'fa-sharp fa-regular fa-paw-simple fa-fw',
        'fa-sharp fa-regular fa-paw-claws fa-fw',
        'fa-sharp fa-regular fa-paw fa-fw',
        'fa-sharp fa-regular fa-narwhal fa-fw',
        'fa-sharp fa-regular fa-mouse-field fa-fw',
        'fa-sharp fa-regular fa-mosquito fa-fw',
        'fa-sharp fa-regular fa-monkey fa-fw',
        'fa-sharp fa-regular fa-locust fa-fw',
        'fa-sharp fa-regular fa-lobster fa-fw',
        'fa-sharp fa-regular fa-horse-saddle fa-fw',
        'fa-sharp fa-regular fa-horse-head fa-fw',
        'fa-sharp fa-regular fa-horse fa-fw',
        'fa-sharp fa-regular fa-frog fa-fw',
        'fa-sharp fa-regular fa-fish-fins fa-fw',
        'fa-sharp fa-regular fa-fish-bones fa-fw',
        'fa-sharp fa-regular fa-feather-pointed fa-fw',
        'fa-sharp fa-regular fa-elephant fa-fw',
        'fa-sharp fa-regular fa-duck fa-fw',
        'fa-sharp fa-regular fa-dove fa-fw',
        'fa-sharp fa-regular fa-dog-leashed fa-fw',
        'fa-sharp fa-regular fa-dog fa-fw',
        'fa-sharp fa-regular fa-dinosaur fa-fw',
        'fa-sharp fa-regular fa-deer-rudolph fa-fw',
        'fa-sharp fa-regular fa-deer fa-fw',
        'fa-sharp fa-regular fa-crow fa-fw',
        'fa-sharp fa-regular fa-cow fa-fw',
        'fa-sharp fa-regular fa-cat-space fa-fw',
        'fa-sharp fa-regular fa-cat fa-fw',
        'fa-sharp fa-regular fa-bugs fa-fw',
        'fa-sharp fa-regular fa-bee fa-fw',
        'fa-sharp fa-regular fa-badger-honey fa-fw',
        'fa-sharp fa-regular fa-alicorn fa-fw',
        'fa-sharp fa-light fa-worm fa-fw',
        'fa-sharp fa-light fa-whale fa-fw',
        'fa-sharp fa-light fa-unicorn fa-fw',
        'fa-sharp fa-light fa-turtle fa-fw',
        'fa-sharp fa-light fa-teddy-bear fa-fw',
        'fa-sharp fa-light fa-squirrel fa-fw',
        'fa-sharp fa-light fa-squid fa-fw',
        'fa-sharp fa-light fa-spider-black-widow fa-fw',
        'fa-sharp fa-light fa-spider fa-fw',
        'fa-sharp fa-light fa-snake fa-fw',
        'fa-sharp fa-light fa-skull-cow fa-fw',
        'fa-sharp fa-light fa-shrimp fa-fw',
        'fa-sharp fa-light fa-shield-dog fa-fw',
        'fa-sharp fa-light fa-shield-cat fa-fw',
        'fa-sharp fa-light fa-sheep fa-fw',
        'fa-sharp fa-light fa-ram fa-fw',
        'fa-sharp fa-light fa-rabbit-running fa-fw',
        'fa-sharp fa-light fa-rabbit fa-fw',
        'fa-sharp fa-light fa-pig fa-fw',
        'fa-sharp fa-light fa-pegasus fa-fw',
        'fa-sharp fa-light fa-paw-simple fa-fw',
        'fa-sharp fa-light fa-paw-claws fa-fw',
        'fa-sharp fa-light fa-paw fa-fw',
        'fa-sharp fa-light fa-narwhal fa-fw',
        'fa-sharp fa-light fa-mouse-field fa-fw',
        'fa-sharp fa-light fa-mosquito fa-fw',
        'fa-sharp fa-light fa-monkey fa-fw',
        'fa-sharp fa-light fa-locust fa-fw',
        'fa-sharp fa-light fa-lobster fa-fw',
        'fa-sharp fa-light fa-horse-saddle fa-fw',
        'fa-sharp fa-light fa-horse-head fa-fw',
        'fa-sharp fa-light fa-horse fa-fw',
        'fa-sharp fa-light fa-frog fa-fw',
        'fa-sharp fa-light fa-fish-fins fa-fw',
        'fa-sharp fa-light fa-fish-bones fa-fw',
        'fa-sharp fa-light fa-feather-pointed fa-fw',
        'fa-sharp fa-light fa-elephant fa-fw',
        'fa-sharp fa-light fa-duck fa-fw',
        'fa-sharp fa-light fa-dove fa-fw',
        'fa-sharp fa-light fa-dog-leashed fa-fw',
        'fa-sharp fa-light fa-dog fa-fw',
        'fa-sharp fa-light fa-dinosaur fa-fw',
        'fa-sharp fa-light fa-deer-rudolph fa-fw',
        'fa-sharp fa-light fa-deer fa-fw',
        'fa-sharp fa-light fa-crow fa-fw',
        'fa-sharp fa-light fa-cow fa-fw',
        'fa-sharp fa-light fa-cat-space fa-fw',
        'fa-sharp fa-light fa-cat fa-fw',
        'fa-sharp fa-light fa-bugs fa-fw',
        'fa-sharp fa-light fa-bee fa-fw',
        'fa-sharp fa-light fa-badger-honey fa-fw',
        'fa-sharp fa-light fa-alicorn fa-fw',
      ],
    },
    {
      title: 'Astronomy',
      items: [
        'fa-solid fa-globe fa-fw',
        'fa-regular fa-globe fa-fw',
        'fa-light fa-globe fa-fw',
        'fa-thin fa-globe fa-fw',
        'fa-duotone fa-globe fa-fw',
        'fa-sharp fa-solid fa-globe fa-fw',
        'fa-sharp fa-regular fa-globe fa-fw',
        'fa-sharp fa-light fa-globe fa-fw',
        'fa-solid fa-planet-ringed fa-fw',
        'fa-regular fa-planet-ringed fa-fw',
        'fa-light fa-planet-ringed fa-fw',
        'fa-thin fa-planet-ringed fa-fw',
        'fa-duotone fa-planet-ringed fa-fw',
        'fa-sharp fa-solid fa-planet-ringed fa-fw',
        'fa-sharp fa-regular fa-planet-ringed fa-fw',
        'fa-sharp fa-light fa-planet-ringed fa-fw',
        'fa-solid fa-ufo fa-fw',
        'fa-regular fa-ufo fa-fw',
        'fa-light fa-ufo fa-fw',
        'fa-thin fa-ufo fa-fw',
        'fa-duotone fa-ufo fa-fw',
        'fa-sharp fa-solid fa-ufo fa-fw',
        'fa-sharp fa-regular fa-ufo fa-fw',
        'fa-sharp fa-light fa-ufo fa-fw',
        'fa-solid fa-moon-stars fa-fw',
        'fa-regular fa-moon-stars fa-fw',
        'fa-light fa-moon-stars fa-fw',
        'fa-thin fa-moon-stars fa-fw',
        'fa-duotone fa-moon-stars fa-fw',
        'fa-sharp fa-solid fa-moon-stars fa-fw',
        'fa-sharp fa-regular fa-moon-stars fa-fw',
        'fa-sharp fa-light fa-moon-stars fa-fw',
        'fa-solid fa-moon fa-fw',
        'fa-regular fa-moon fa-fw',
        'fa-light fa-moon fa-fw',
        'fa-thin fa-moon fa-fw',
        'fa-duotone fa-moon fa-fw',
        'fa-sharp fa-solid fa-moon fa-fw',
        'fa-sharp fa-regular fa-moon fa-fw',
        'fa-sharp fa-light fa-moon fa-fw',
        'fa-solid fa-planet-moon fa-fw',
        'fa-regular fa-planet-moon fa-fw',
        'fa-light fa-planet-moon fa-fw',
        'fa-thin fa-planet-moon fa-fw',
        'fa-duotone fa-planet-moon fa-fw',
        'fa-sharp fa-solid fa-planet-moon fa-fw',
        'fa-sharp fa-regular fa-planet-moon fa-fw',
        'fa-sharp fa-light fa-planet-moon fa-fw',
        'fa-solid fa-radar fa-fw',
        'fa-regular fa-radar fa-fw',
        'fa-light fa-radar fa-fw',
        'fa-thin fa-radar fa-fw',
        'fa-duotone fa-radar fa-fw',
        'fa-sharp fa-solid fa-radar fa-fw',
        'fa-sharp fa-regular fa-radar fa-fw',
        'fa-sharp fa-light fa-radar fa-fw',
        'fa-solid fa-stars fa-fw',
        'fa-regular fa-stars fa-fw',
        'fa-light fa-stars fa-fw',
        'fa-thin fa-stars fa-fw',
        'fa-duotone fa-stars fa-fw',
        'fa-sharp fa-solid fa-stars fa-fw',
        'fa-sharp fa-regular fa-stars fa-fw',
        'fa-sharp fa-light fa-stars fa-fw',
        'fa-solid fa-solar-system fa-fw',
        'fa-regular fa-solar-system fa-fw',
        'fa-light fa-solar-system fa-fw',
        'fa-thin fa-solar-system fa-fw',
        'fa-duotone fa-solar-system fa-fw',
        'fa-sharp fa-solid fa-solar-system fa-fw',
        'fa-sharp fa-regular fa-solar-system fa-fw',
        'fa-sharp fa-light fa-solar-system fa-fw',
        'fa-solid fa-user-astronaut fa-fw',
        'fa-solid fa-user-alien fa-fw',
        'fa-solid fa-ufo-beam fa-fw',
        'fa-solid fa-telescope fa-fw',
        'fa-solid fa-star-shooting fa-fw',
        'fa-solid fa-shuttle-space fa-fw',
        'fa-solid fa-satellite-dish fa-fw',
        'fa-solid fa-satellite fa-fw',
        'fa-solid fa-moon-over-sun fa-fw',
        'fa-solid fa-meteor fa-fw',
        'fa-solid fa-galaxy fa-fw',
        'fa-solid fa-eclipse fa-fw',
        'fa-solid fa-comet fa-fw',
        'fa-solid fa-cat-space fa-fw',
        'fa-solid fa-alien fa-fw',
        'fa-regular fa-user-astronaut fa-fw',
        'fa-regular fa-user-alien fa-fw',
        'fa-regular fa-ufo-beam fa-fw',
        'fa-regular fa-telescope fa-fw',
        'fa-regular fa-star-shooting fa-fw',
        'fa-regular fa-shuttle-space fa-fw',
        'fa-regular fa-satellite-dish fa-fw',
        'fa-regular fa-satellite fa-fw',
        'fa-regular fa-moon-over-sun fa-fw',
        'fa-regular fa-meteor fa-fw',
        'fa-regular fa-galaxy fa-fw',
        'fa-regular fa-eclipse fa-fw',
        'fa-regular fa-comet fa-fw',
        'fa-regular fa-cat-space fa-fw',
        'fa-regular fa-alien fa-fw',
        'fa-light fa-user-astronaut fa-fw',
        'fa-light fa-user-alien fa-fw',
        'fa-light fa-ufo-beam fa-fw',
        'fa-light fa-telescope fa-fw',
        'fa-light fa-star-shooting fa-fw',
        'fa-light fa-shuttle-space fa-fw',
        'fa-light fa-satellite-dish fa-fw',
        'fa-light fa-satellite fa-fw',
        'fa-light fa-moon-over-sun fa-fw',
        'fa-light fa-meteor fa-fw',
        'fa-light fa-galaxy fa-fw',
        'fa-light fa-eclipse fa-fw',
        'fa-light fa-comet fa-fw',
        'fa-light fa-cat-space fa-fw',
        'fa-light fa-alien fa-fw',
        'fa-thin fa-user-astronaut fa-fw',
        'fa-thin fa-user-alien fa-fw',
        'fa-thin fa-ufo-beam fa-fw',
        'fa-thin fa-telescope fa-fw',
        'fa-thin fa-star-shooting fa-fw',
        'fa-thin fa-shuttle-space fa-fw',
        'fa-thin fa-satellite-dish fa-fw',
        'fa-thin fa-satellite fa-fw',
        'fa-thin fa-moon-over-sun fa-fw',
        'fa-thin fa-meteor fa-fw',
        'fa-thin fa-galaxy fa-fw',
        'fa-thin fa-eclipse fa-fw',
        'fa-thin fa-comet fa-fw',
        'fa-thin fa-cat-space fa-fw',
        'fa-thin fa-alien fa-fw',
        'fa-duotone fa-user-astronaut fa-fw',
        'fa-duotone fa-user-alien fa-fw',
        'fa-duotone fa-ufo-beam fa-fw',
        'fa-duotone fa-telescope fa-fw',
        'fa-duotone fa-star-shooting fa-fw',
        'fa-duotone fa-shuttle-space fa-fw',
        'fa-duotone fa-satellite-dish fa-fw',
        'fa-duotone fa-satellite fa-fw',
        'fa-duotone fa-moon-over-sun fa-fw',
        'fa-duotone fa-meteor fa-fw',
        'fa-duotone fa-galaxy fa-fw',
        'fa-duotone fa-eclipse fa-fw',
        'fa-duotone fa-comet fa-fw',
        'fa-duotone fa-cat-space fa-fw',
        'fa-duotone fa-alien fa-fw',
        'fa-sharp fa-solid fa-user-astronaut fa-fw',
        'fa-sharp fa-solid fa-user-alien fa-fw',
        'fa-sharp fa-solid fa-ufo-beam fa-fw',
        'fa-sharp fa-solid fa-telescope fa-fw',
        'fa-sharp fa-solid fa-star-shooting fa-fw',
        'fa-sharp fa-solid fa-shuttle-space fa-fw',
        'fa-sharp fa-solid fa-satellite-dish fa-fw',
        'fa-sharp fa-solid fa-satellite fa-fw',
        'fa-sharp fa-solid fa-moon-over-sun fa-fw',
        'fa-sharp fa-solid fa-meteor fa-fw',
        'fa-sharp fa-solid fa-galaxy fa-fw',
        'fa-sharp fa-solid fa-eclipse fa-fw',
        'fa-sharp fa-solid fa-comet fa-fw',
        'fa-sharp fa-solid fa-cat-space fa-fw',
        'fa-sharp fa-solid fa-alien fa-fw',
        'fa-sharp fa-regular fa-user-astronaut fa-fw',
        'fa-sharp fa-regular fa-user-alien fa-fw',
        'fa-sharp fa-regular fa-ufo-beam fa-fw',
        'fa-sharp fa-regular fa-telescope fa-fw',
        'fa-sharp fa-regular fa-star-shooting fa-fw',
        'fa-sharp fa-regular fa-shuttle-space fa-fw',
        'fa-sharp fa-regular fa-satellite-dish fa-fw',
        'fa-sharp fa-regular fa-satellite fa-fw',
        'fa-sharp fa-regular fa-moon-over-sun fa-fw',
        'fa-sharp fa-regular fa-meteor fa-fw',
        'fa-sharp fa-regular fa-galaxy fa-fw',
        'fa-sharp fa-regular fa-eclipse fa-fw',
        'fa-sharp fa-regular fa-comet fa-fw',
        'fa-sharp fa-regular fa-cat-space fa-fw',
        'fa-sharp fa-regular fa-alien fa-fw',
        'fa-sharp fa-light fa-user-astronaut fa-fw',
        'fa-sharp fa-light fa-user-alien fa-fw',
        'fa-sharp fa-light fa-ufo-beam fa-fw',
        'fa-sharp fa-light fa-telescope fa-fw',
        'fa-sharp fa-light fa-star-shooting fa-fw',
        'fa-sharp fa-light fa-shuttle-space fa-fw',
        'fa-sharp fa-light fa-satellite-dish fa-fw',
        'fa-sharp fa-light fa-satellite fa-fw',
        'fa-sharp fa-light fa-moon-over-sun fa-fw',
        'fa-sharp fa-light fa-meteor fa-fw',
        'fa-sharp fa-light fa-galaxy fa-fw',
        'fa-sharp fa-light fa-eclipse fa-fw',
        'fa-sharp fa-light fa-comet fa-fw',
        'fa-sharp fa-light fa-cat-space fa-fw',
        'fa-sharp fa-light fa-alien fa-fw',
      ],
    },
    {
      title: 'Arrows',
      items: [
        'fa-sharp fa-light fa-arrows-turn-right fa-fw',
        'fa-sharp fa-light fa-arrows-to-line fa-fw',
        'fa-sharp fa-light fa-arrows-to-eye fa-fw',
        'fa-sharp fa-light fa-arrows-to-dotted-line fa-fw',
        'fa-sharp fa-light fa-arrows-to-dot fa-fw',
        'fa-sharp fa-light fa-arrows-to-circle fa-fw',
        'fa-sharp fa-light fa-arrows-split-up-and-left fa-fw',
        'fa-sharp fa-light fa-arrows-spin fa-fw',
        'fa-sharp fa-light fa-arrows-rotate fa-fw',
        'fa-sharp fa-light fa-arrows-retweet fa-fw',
        'fa-sharp fa-light fa-arrows-repeat-1 fa-fw',
        'fa-sharp fa-light fa-arrows-repeat fa-fw',
        'fa-sharp fa-light fa-arrows-minimize fa-fw',
        'fa-sharp fa-light fa-arrows-maximize fa-fw',
        'fa-sharp fa-light fa-arrows-left-right-to-line fa-fw',
        'fa-sharp fa-light fa-arrows-left-right fa-fw',
        'fa-sharp fa-light fa-arrows-from-line fa-fw',
        'fa-sharp fa-light fa-arrows-from-dotted-line fa-fw',
        'fa-sharp fa-light fa-arrows-down-to-line fa-fw',
        'fa-sharp fa-light fa-arrows-cross fa-fw',
        'fa-sharp fa-light fa-arrow-up-z-a fa-fw',
        'fa-sharp fa-light fa-arrow-up-wide-short fa-fw',
        'fa-sharp fa-light fa-arrow-up-triangle-square fa-fw',
        'fa-sharp fa-light fa-arrow-up-to-line fa-fw',
        'fa-sharp fa-light fa-arrow-up-to-dotted-line fa-fw',
        'fa-sharp fa-light fa-arrow-up-square-triangle fa-fw',
        'fa-sharp fa-light fa-arrow-up-small-big fa-fw',
        'fa-sharp fa-light fa-arrow-up-short-wide fa-fw',
        'fa-sharp fa-light fa-arrow-up-right-dots fa-fw',
        'fa-sharp fa-light fa-arrow-up-right-and-arrow-down-left-from-center fa-fw',
        'fa-sharp fa-light fa-arrow-up-right fa-fw',
        'fa-sharp fa-light fa-arrow-up-long fa-fw',
        'fa-sharp fa-light fa-arrow-up-left-from-circle fa-fw',
        'fa-sharp fa-light fa-arrow-up-left fa-fw',
        'fa-sharp fa-light fa-arrow-up-from-square fa-fw',
        'fa-sharp fa-light fa-arrow-up-from-line fa-fw',
        'fa-sharp fa-light fa-arrow-up-from-dotted-line fa-fw',
        'fa-sharp fa-light fa-arrow-up-from-arc fa-fw',
        'fa-sharp fa-light fa-arrow-up-big-small fa-fw',
        'fa-sharp fa-light fa-arrow-up-arrow-down fa-fw',
        'fa-sharp fa-light fa-arrow-up-a-z fa-fw',
        'fa-sharp fa-light fa-arrow-up-9-1 fa-fw',
        'fa-sharp fa-light fa-arrow-up-1-9 fa-fw',
        'fa-sharp fa-light fa-arrow-turn-up fa-fw',
        'fa-sharp fa-light fa-arrow-turn-down-right fa-fw',
        'fa-sharp fa-light fa-arrow-turn-down-left fa-fw',
        'fa-sharp fa-light fa-arrow-turn-down fa-fw',
        'fa-sharp fa-light fa-arrow-trend-up fa-fw',
        'fa-sharp fa-light fa-arrow-trend-down fa-fw',
        'fa-sharp fa-light fa-arrow-rotate-right fa-fw',
        'fa-sharp fa-light fa-arrow-rotate-left fa-fw',
        'fa-sharp fa-light fa-arrow-right-to-line fa-fw',
        'fa-sharp fa-light fa-arrow-right-to-bracket fa-fw',
        'fa-sharp fa-light fa-arrow-right-to-arc fa-fw',
        'fa-sharp fa-light fa-arrow-right-long-to-line fa-fw',
        'fa-sharp fa-light fa-arrow-right-long fa-fw',
        'fa-sharp fa-light fa-arrow-right-from-line fa-fw',
        'fa-sharp fa-light fa-arrow-right-from-bracket fa-fw',
        'fa-sharp fa-light fa-arrow-right-from-arc fa-fw',
        'fa-sharp fa-light fa-arrow-right-arrow-left fa-fw',
        'fa-sharp fa-light fa-arrow-progress fa-fw',
        'fa-sharp fa-light fa-arrow-pointer fa-fw',
        'fa-sharp fa-light fa-arrow-left-to-line fa-fw',
        'fa-sharp fa-light fa-arrow-left-long-to-line fa-fw',
        'fa-sharp fa-light fa-arrow-left-long fa-fw',
        'fa-sharp fa-light fa-arrow-left-from-line fa-fw',
        'fa-sharp fa-light fa-arrow-down-z-a fa-fw',
        'fa-sharp fa-light fa-arrow-down-wide-short fa-fw',
        'fa-sharp fa-light fa-arrow-down-up-lock fa-fw',
        'fa-sharp fa-light fa-arrow-down-up-across-line fa-fw',
        'fa-sharp fa-light fa-arrow-down-triangle-square fa-fw',
        'fa-sharp fa-light fa-arrow-down-to-square fa-fw',
        'fa-sharp fa-light fa-arrow-down-to-dotted-line fa-fw',
        'fa-sharp fa-light fa-arrow-down-to-bracket fa-fw',
        'fa-sharp fa-light fa-arrow-down-to-arc fa-fw',
        'fa-sharp fa-light fa-arrow-down-square-triangle fa-fw',
        'fa-sharp fa-light fa-arrow-down-small-big fa-fw',
        'fa-sharp fa-light fa-arrow-down-short-wide fa-fw',
        'fa-sharp fa-light fa-arrow-down-right fa-fw',
        'fa-sharp fa-light fa-arrow-down-long fa-fw',
        'fa-sharp fa-light fa-arrow-down-left-and-arrow-up-right-to-center fa-fw',
        'fa-sharp fa-light fa-arrow-down-left fa-fw',
        'fa-sharp fa-light fa-arrow-down-from-line fa-fw',
        'fa-sharp fa-light fa-arrow-down-from-dotted-line fa-fw',
        'fa-sharp fa-light fa-arrow-down-big-small fa-fw',
        'fa-sharp fa-light fa-arrow-down-arrow-up fa-fw',
        'fa-sharp fa-light fa-arrow-down-a-z fa-fw',
        'fa-sharp fa-light fa-arrow-down-9-1 fa-fw',
        'fa-sharp fa-light fa-arrow-down-1-9 fa-fw',
        'fa-sharp fa-light fa-angles-up fa-fw',
        'fa-sharp fa-light fa-angles-right fa-fw',
        'fa-sharp fa-light fa-angles-left fa-fw',
        'fa-sharp fa-light fa-angles-down fa-fw',
        'fa-sharp fa-light fa-angle-right fa-fw',
        'fa-sharp fa-light fa-angle-left fa-fw',
        'fa-sharp fa-light fa-angle-down fa-fw',
        'fa-solid fa-download fa-fw',
        'fa-regular fa-download fa-fw',
        'fa-light fa-download fa-fw',
        'fa-thin fa-download fa-fw',
        'fa-duotone fa-download fa-fw',
        'fa-sharp fa-solid fa-download fa-fw',
        'fa-sharp fa-regular fa-download fa-fw',
        'fa-sharp fa-light fa-download fa-fw',
        'fa-solid fa-arrow-right fa-fw',
        'fa-regular fa-arrow-right fa-fw',
        'fa-light fa-arrow-right fa-fw',
        'fa-thin fa-arrow-right fa-fw',
        'fa-duotone fa-arrow-right fa-fw',
        'fa-sharp fa-solid fa-arrow-right fa-fw',
        'fa-sharp fa-regular fa-arrow-right fa-fw',
        'fa-sharp fa-light fa-arrow-right fa-fw',
        'fa-solid fa-caret-up fa-fw',
        'fa-regular fa-caret-up fa-fw',
        'fa-light fa-caret-up fa-fw',
        'fa-thin fa-caret-up fa-fw',
        'fa-duotone fa-caret-up fa-fw',
        'fa-sharp fa-solid fa-caret-up fa-fw',
        'fa-sharp fa-regular fa-caret-up fa-fw',
        'fa-sharp fa-light fa-caret-up fa-fw',
        'fa-solid fa-arrow-up fa-fw',
        'fa-regular fa-arrow-up fa-fw',
        'fa-light fa-arrow-up fa-fw',
        'fa-thin fa-arrow-up fa-fw',
        'fa-duotone fa-arrow-up fa-fw',
        'fa-sharp fa-solid fa-arrow-up fa-fw',
        'fa-sharp fa-regular fa-arrow-up fa-fw',
        'fa-sharp fa-light fa-arrow-up fa-fw',
        'fa-solid fa-arrow-up-from-bracket fa-fw',
        'fa-regular fa-arrow-up-from-bracket fa-fw',
        'fa-light fa-arrow-up-from-bracket fa-fw',
        'fa-thin fa-arrow-up-from-bracket fa-fw',
        'fa-duotone fa-arrow-up-from-bracket fa-fw',
        'fa-sharp fa-solid fa-arrow-up-from-bracket fa-fw',
        'fa-sharp fa-regular fa-arrow-up-from-bracket fa-fw',
        'fa-sharp fa-light fa-arrow-up-from-bracket fa-fw',
        'fa-solid fa-circle-up fa-fw',
        'fa-regular fa-circle-up fa-fw',
        'fa-light fa-circle-up fa-fw',
        'fa-thin fa-circle-up fa-fw',
        'fa-duotone fa-circle-up fa-fw',
        'fa-sharp fa-solid fa-circle-up fa-fw',
        'fa-sharp fa-regular fa-circle-up fa-fw',
        'fa-sharp fa-light fa-circle-up fa-fw',
        'fa-solid fa-circle-down fa-fw',
        'fa-regular fa-circle-down fa-fw',
        'fa-light fa-circle-down fa-fw',
        'fa-thin fa-circle-down fa-fw',
        'fa-duotone fa-circle-down fa-fw',
        'fa-sharp fa-solid fa-circle-down fa-fw',
        'fa-sharp fa-regular fa-circle-down fa-fw',
        'fa-sharp fa-light fa-circle-down fa-fw',
        'fa-solid fa-rotate-right fa-fw',
        'fa-regular fa-rotate-right fa-fw',
        'fa-light fa-rotate-right fa-fw',
        'fa-thin fa-rotate-right fa-fw',
        'fa-duotone fa-rotate-right fa-fw',
        'fa-sharp fa-solid fa-rotate-right fa-fw',
        'fa-sharp fa-regular fa-rotate-right fa-fw',
        'fa-sharp fa-light fa-rotate-right fa-fw',
        'fa-solid fa-share-from-square fa-fw',
        'fa-regular fa-share-from-square fa-fw',
        'fa-light fa-share-from-square fa-fw',
        'fa-thin fa-share-from-square fa-fw',
        'fa-duotone fa-share-from-square fa-fw',
        'fa-sharp fa-solid fa-share-from-square fa-fw',
        'fa-sharp fa-regular fa-share-from-square fa-fw',
        'fa-sharp fa-light fa-share-from-square fa-fw',
        'fa-solid fa-share fa-fw',
        'fa-regular fa-share fa-fw',
        'fa-light fa-share fa-fw',
        'fa-thin fa-share fa-fw',
        'fa-duotone fa-share fa-fw',
        'fa-sharp fa-solid fa-share fa-fw',
        'fa-sharp fa-regular fa-share fa-fw',
        'fa-sharp fa-light fa-share fa-fw',
        'fa-solid fa-arrow-down-to-line fa-fw',
        'fa-regular fa-arrow-down-to-line fa-fw',
        'fa-light fa-arrow-down-to-line fa-fw',
        'fa-thin fa-arrow-down-to-line fa-fw',
        'fa-duotone fa-arrow-down-to-line fa-fw',
        'fa-sharp fa-solid fa-arrow-down-to-line fa-fw',
        'fa-sharp fa-regular fa-arrow-down-to-line fa-fw',
        'fa-sharp fa-light fa-arrow-down-to-line fa-fw',
        'fa-solid fa-right-to-bracket fa-fw',
        'fa-regular fa-right-to-bracket fa-fw',
        'fa-light fa-right-to-bracket fa-fw',
        'fa-thin fa-right-to-bracket fa-fw',
        'fa-duotone fa-right-to-bracket fa-fw',
        'fa-sharp fa-solid fa-right-to-bracket fa-fw',
        'fa-sharp fa-regular fa-right-to-bracket fa-fw',
        'fa-sharp fa-light fa-right-to-bracket fa-fw',
        'fa-solid fa-cloud-arrow-up fa-fw',
        'fa-regular fa-cloud-arrow-up fa-fw',
        'fa-light fa-cloud-arrow-up fa-fw',
        'fa-thin fa-cloud-arrow-up fa-fw',
        'fa-duotone fa-cloud-arrow-up fa-fw',
        'fa-sharp fa-solid fa-cloud-arrow-up fa-fw',
        'fa-sharp fa-regular fa-cloud-arrow-up fa-fw',
        'fa-sharp fa-light fa-cloud-arrow-up fa-fw',
        'fa-solid fa-chevron-up fa-fw',
        'fa-regular fa-chevron-up fa-fw',
        'fa-light fa-chevron-up fa-fw',
        'fa-thin fa-chevron-up fa-fw',
        'fa-duotone fa-chevron-up fa-fw',
        'fa-sharp fa-solid fa-chevron-up fa-fw',
        'fa-sharp fa-regular fa-chevron-up fa-fw',
        'fa-sharp fa-light fa-chevron-up fa-fw',
        'fa-solid fa-upload fa-fw',
        'fa-regular fa-upload fa-fw',
        'fa-light fa-upload fa-fw',
        'fa-thin fa-upload fa-fw',
        'fa-duotone fa-upload fa-fw',
        'fa-sharp fa-solid fa-upload fa-fw',
        'fa-sharp fa-regular fa-upload fa-fw',
        'fa-sharp fa-light fa-upload fa-fw',
        'fa-solid fa-sort fa-fw',
        'fa-regular fa-sort fa-fw',
        'fa-light fa-sort fa-fw',
        'fa-thin fa-sort fa-fw',
        'fa-duotone fa-sort fa-fw',
        'fa-sharp fa-solid fa-sort fa-fw',
        'fa-sharp fa-regular fa-sort fa-fw',
        'fa-sharp fa-light fa-sort fa-fw',
        'fa-solid fa-angle-up fa-fw',
        'fa-regular fa-angle-up fa-fw',
        'fa-light fa-angle-up fa-fw',
        'fa-thin fa-angle-up fa-fw',
        'fa-duotone fa-angle-up fa-fw',
        'fa-sharp fa-solid fa-angle-up fa-fw',
        'fa-sharp fa-regular fa-angle-up fa-fw',
        'fa-sharp fa-light fa-angle-up fa-fw',
        'fa-solid fa-arrow-down fa-fw',
        'fa-regular fa-arrow-down fa-fw',
        'fa-light fa-arrow-down fa-fw',
        'fa-thin fa-arrow-down fa-fw',
        'fa-duotone fa-arrow-down fa-fw',
        'fa-sharp fa-solid fa-arrow-down fa-fw',
        'fa-sharp fa-regular fa-arrow-down fa-fw',
        'fa-sharp fa-light fa-arrow-down fa-fw',
        'fa-solid fa-caret-down fa-fw',
        'fa-regular fa-caret-down fa-fw',
        'fa-light fa-caret-down fa-fw',
        'fa-thin fa-caret-down fa-fw',
        'fa-duotone fa-caret-down fa-fw',
        'fa-sharp fa-solid fa-caret-down fa-fw',
        'fa-sharp fa-regular fa-caret-down fa-fw',
        'fa-sharp fa-light fa-caret-down fa-fw',
        'fa-solid fa-arrow-up-right-from-square fa-fw',
        'fa-regular fa-arrow-up-right-from-square fa-fw',
        'fa-light fa-arrow-up-right-from-square fa-fw',
        'fa-thin fa-arrow-up-right-from-square fa-fw',
        'fa-duotone fa-arrow-up-right-from-square fa-fw',
        'fa-sharp fa-solid fa-arrow-up-right-from-square fa-fw',
        'fa-sharp fa-regular fa-arrow-up-right-from-square fa-fw',
        'fa-sharp fa-light fa-arrow-up-right-from-square fa-fw',
        'fa-solid fa-arrow-left fa-fw',
        'fa-regular fa-arrow-left fa-fw',
        'fa-light fa-arrow-left fa-fw',
        'fa-thin fa-arrow-left fa-fw',
        'fa-duotone fa-arrow-left fa-fw',
        'fa-sharp fa-solid fa-arrow-left fa-fw',
        'fa-sharp fa-regular fa-arrow-left fa-fw',
        'fa-sharp fa-light fa-arrow-left fa-fw',
        'fa-solid fa-repeat fa-fw',
        'fa-regular fa-repeat fa-fw',
        'fa-light fa-repeat fa-fw',
        'fa-thin fa-repeat fa-fw',
        'fa-duotone fa-repeat fa-fw',
        'fa-sharp fa-solid fa-repeat fa-fw',
        'fa-sharp fa-regular fa-repeat fa-fw',
        'fa-sharp fa-light fa-repeat fa-fw',
        'fa-solid fa-reply fa-fw',
        'fa-regular fa-reply fa-fw',
        'fa-light fa-reply fa-fw',
        'fa-thin fa-reply fa-fw',
        'fa-duotone fa-reply fa-fw',
        'fa-sharp fa-solid fa-reply fa-fw',
        'fa-sharp fa-regular fa-reply fa-fw',
        'fa-sharp fa-light fa-reply fa-fw',
        'fa-solid fa-recycle fa-fw',
        'fa-regular fa-recycle fa-fw',
        'fa-light fa-recycle fa-fw',
        'fa-thin fa-recycle fa-fw',
        'fa-duotone fa-recycle fa-fw',
        'fa-sharp fa-solid fa-recycle fa-fw',
        'fa-sharp fa-regular fa-recycle fa-fw',
        'fa-sharp fa-light fa-recycle fa-fw',
        'fa-solid fa-chevron-down fa-fw',
        'fa-regular fa-chevron-down fa-fw',
        'fa-light fa-chevron-down fa-fw',
        'fa-thin fa-chevron-down fa-fw',
        'fa-duotone fa-chevron-down fa-fw',
        'fa-sharp fa-solid fa-chevron-down fa-fw',
        'fa-sharp fa-regular fa-chevron-down fa-fw',
        'fa-sharp fa-light fa-chevron-down fa-fw',
        'fa-solid fa-up-to-line fa-fw',
        'fa-solid fa-up-to-dotted-line fa-fw',
        'fa-solid fa-up-right-from-square fa-fw',
        'fa-solid fa-up-right-and-down-left-from-center fa-fw',
        'fa-solid fa-up-right fa-fw',
        'fa-solid fa-up-long fa-fw',
        'fa-solid fa-up-left fa-fw',
        'fa-solid fa-up-from-line fa-fw',
        'fa-solid fa-up-from-dotted-line fa-fw',
        'fa-solid fa-up-from-bracket fa-fw',
        'fa-solid fa-up-down-left-right fa-fw',
        'fa-solid fa-up-down fa-fw',
        'fa-solid fa-up fa-fw',
        'fa-solid fa-turn-up fa-fw',
        'fa-solid fa-turn-down-right fa-fw',
        'fa-solid fa-turn-down-left fa-fw',
        'fa-solid fa-turn-down fa-fw',
        'fa-solid fa-square-up-right fa-fw',
        'fa-solid fa-square-up-left fa-fw',
        'fa-solid fa-square-up fa-fw',
        'fa-solid fa-square-right fa-fw',
        'fa-solid fa-square-left fa-fw',
        'fa-solid fa-square-down-right fa-fw',
        'fa-solid fa-square-down-left fa-fw',
        'fa-solid fa-square-down fa-fw',
        'fa-solid fa-square-chevron-up fa-fw',
        'fa-solid fa-square-chevron-right fa-fw',
        'fa-solid fa-square-chevron-left fa-fw',
        'fa-solid fa-square-chevron-down fa-fw',
        'fa-solid fa-square-caret-up fa-fw',
        'fa-solid fa-square-caret-right fa-fw',
        'fa-solid fa-square-caret-left fa-fw',
        'fa-solid fa-square-caret-down fa-fw',
        'fa-solid fa-square-arrow-up-right fa-fw',
        'fa-solid fa-square-arrow-up-left fa-fw',
        'fa-solid fa-square-arrow-up fa-fw',
        'fa-solid fa-square-arrow-right fa-fw',
        'fa-solid fa-square-arrow-left fa-fw',
        'fa-solid fa-square-arrow-down-right fa-fw',
        'fa-solid fa-square-arrow-down-left fa-fw',
        'fa-solid fa-square-arrow-down fa-fw',
        'fa-solid fa-split fa-fw',
        'fa-solid fa-sort-up fa-fw',
        'fa-solid fa-sort-down fa-fw',
        'fa-solid fa-shuffle fa-fw',
        'fa-solid fa-share-all fa-fw',
        'fa-solid fa-rotate-left fa-fw',
        'fa-solid fa-rotate fa-fw',
        'fa-solid fa-right-to-line fa-fw',
        'fa-solid fa-right-long-to-line fa-fw',
        'fa-solid fa-right-long fa-fw',
        'fa-solid fa-right-left-large fa-fw',
        'fa-solid fa-right-left fa-fw',
        'fa-solid fa-right-from-line fa-fw',
        'fa-solid fa-right-from-bracket fa-fw',
        'fa-solid fa-right fa-fw',
        'fa-solid fa-retweet fa-fw',
        'fa-solid fa-reply-all fa-fw',
        'fa-solid fa-repeat-1 fa-fw',
        'fa-solid fa-merge fa-fw',
        'fa-solid fa-maximize fa-fw',
        'fa-solid fa-location-arrow fa-fw',
        'fa-solid fa-left-to-line fa-fw',
        'fa-solid fa-left-right fa-fw',
        'fa-solid fa-left-long-to-line fa-fw',
        'fa-solid fa-left-long fa-fw',
        'fa-solid fa-left-from-line fa-fw',
        'fa-solid fa-left fa-fw',
        'fa-solid fa-inbox-out fa-fw',
        'fa-solid fa-inbox-in fa-fw',
        'fa-solid fa-down-to-line fa-fw',
        'fa-solid fa-down-to-dotted-line fa-fw',
        'fa-solid fa-down-to-bracket fa-fw',
        'fa-solid fa-down-right fa-fw',
        'fa-solid fa-down-long fa-fw',
        'fa-solid fa-down-left-and-up-right-to-center fa-fw',
        'fa-solid fa-down-left fa-fw',
        'fa-solid fa-down-from-line fa-fw',
        'fa-solid fa-down-from-dotted-line fa-fw',
        'fa-solid fa-down fa-fw',
        'fa-solid fa-cloud-arrow-down fa-fw',
        'fa-solid fa-clock-rotate-left fa-fw',
        'fa-solid fa-circle-up-right fa-fw',
        'fa-solid fa-circle-up-left fa-fw',
        'fa-solid fa-circle-right fa-fw',
        'fa-solid fa-circle-left fa-fw',
        'fa-solid fa-circle-down-right fa-fw',
        'fa-solid fa-circle-down-left fa-fw',
        'fa-solid fa-circle-chevron-up fa-fw',
        'fa-solid fa-circle-chevron-right fa-fw',
        'fa-solid fa-circle-chevron-left fa-fw',
        'fa-solid fa-circle-chevron-down fa-fw',
        'fa-solid fa-circle-caret-up fa-fw',
        'fa-solid fa-circle-caret-right fa-fw',
        'fa-solid fa-circle-caret-left fa-fw',
        'fa-solid fa-circle-caret-down fa-fw',
        'fa-solid fa-circle-arrow-up-right fa-fw',
        'fa-solid fa-circle-arrow-up-left fa-fw',
        'fa-solid fa-circle-arrow-up fa-fw',
        'fa-solid fa-circle-arrow-right fa-fw',
        'fa-solid fa-circle-arrow-left fa-fw',
        'fa-solid fa-circle-arrow-down-right fa-fw',
        'fa-solid fa-circle-arrow-down-left fa-fw',
        'fa-solid fa-circle-arrow-down fa-fw',
        'fa-solid fa-chevrons-up fa-fw',
        'fa-solid fa-chevrons-right fa-fw',
        'fa-solid fa-chevrons-left fa-fw',
        'fa-solid fa-chevrons-down fa-fw',
        'fa-solid fa-chevron-right fa-fw',
        'fa-solid fa-chevron-left fa-fw',
        'fa-solid fa-caret-right fa-fw',
        'fa-solid fa-caret-left fa-fw',
        'fa-solid fa-arrows-up-to-line fa-fw',
        'fa-solid fa-arrows-up-down-left-right fa-fw',
        'fa-solid fa-arrows-up-down fa-fw',
        'fa-solid fa-arrows-turn-to-dots fa-fw',
        'fa-solid fa-arrows-turn-right fa-fw',
        'fa-solid fa-arrows-to-line fa-fw',
        'fa-solid fa-arrows-to-eye fa-fw',
        'fa-solid fa-arrows-to-dotted-line fa-fw',
        'fa-solid fa-arrows-to-dot fa-fw',
        'fa-solid fa-arrows-to-circle fa-fw',
        'fa-solid fa-arrows-split-up-and-left fa-fw',
        'fa-solid fa-arrows-spin fa-fw',
        'fa-solid fa-arrows-rotate fa-fw',
        'fa-solid fa-arrows-retweet fa-fw',
        'fa-solid fa-arrows-repeat-1 fa-fw',
        'fa-solid fa-arrows-repeat fa-fw',
        'fa-solid fa-arrows-minimize fa-fw',
        'fa-solid fa-arrows-maximize fa-fw',
        'fa-solid fa-arrows-left-right-to-line fa-fw',
        'fa-solid fa-arrows-left-right fa-fw',
        'fa-solid fa-arrows-from-line fa-fw',
        'fa-solid fa-arrows-from-dotted-line fa-fw',
        'fa-solid fa-arrows-down-to-line fa-fw',
        'fa-solid fa-arrows-cross fa-fw',
        'fa-solid fa-arrow-up-z-a fa-fw',
        'fa-solid fa-arrow-up-wide-short fa-fw',
        'fa-solid fa-arrow-up-triangle-square fa-fw',
        'fa-solid fa-arrow-up-to-line fa-fw',
        'fa-solid fa-arrow-up-to-dotted-line fa-fw',
        'fa-solid fa-arrow-up-square-triangle fa-fw',
        'fa-solid fa-arrow-up-small-big fa-fw',
        'fa-solid fa-arrow-up-short-wide fa-fw',
        'fa-solid fa-arrow-up-right-dots fa-fw',
        'fa-solid fa-arrow-up-right-and-arrow-down-left-from-center fa-fw',
        'fa-solid fa-arrow-up-right fa-fw',
        'fa-solid fa-arrow-up-long fa-fw',
        'fa-solid fa-arrow-up-left-from-circle fa-fw',
        'fa-solid fa-arrow-up-left fa-fw',
        'fa-solid fa-arrow-up-from-square fa-fw',
        'fa-solid fa-arrow-up-from-line fa-fw',
        'fa-solid fa-arrow-up-from-dotted-line fa-fw',
        'fa-solid fa-arrow-up-from-arc fa-fw',
        'fa-solid fa-arrow-up-big-small fa-fw',
        'fa-solid fa-arrow-up-arrow-down fa-fw',
        'fa-solid fa-arrow-up-a-z fa-fw',
        'fa-solid fa-arrow-up-9-1 fa-fw',
        'fa-solid fa-arrow-up-1-9 fa-fw',
        'fa-solid fa-arrow-turn-up fa-fw',
        'fa-solid fa-arrow-turn-down-right fa-fw',
        'fa-solid fa-arrow-turn-down-left fa-fw',
        'fa-solid fa-arrow-turn-down fa-fw',
        'fa-solid fa-arrow-trend-up fa-fw',
        'fa-solid fa-arrow-trend-down fa-fw',
        'fa-solid fa-arrow-rotate-right fa-fw',
        'fa-solid fa-arrow-rotate-left fa-fw',
        'fa-solid fa-arrow-right-to-line fa-fw',
        'fa-solid fa-arrow-right-to-bracket fa-fw',
        'fa-solid fa-arrow-right-to-arc fa-fw',
        'fa-solid fa-arrow-right-long-to-line fa-fw',
        'fa-solid fa-arrow-right-long fa-fw',
        'fa-solid fa-arrow-right-from-line fa-fw',
        'fa-solid fa-arrow-right-from-bracket fa-fw',
        'fa-solid fa-arrow-right-from-arc fa-fw',
        'fa-solid fa-arrow-right-arrow-left fa-fw',
        'fa-solid fa-arrow-progress fa-fw',
        'fa-solid fa-arrow-pointer fa-fw',
        'fa-solid fa-arrow-left-to-line fa-fw',
        'fa-solid fa-arrow-left-long-to-line fa-fw',
        'fa-solid fa-arrow-left-long fa-fw',
        'fa-solid fa-arrow-left-from-line fa-fw',
        'fa-solid fa-arrow-down-z-a fa-fw',
        'fa-solid fa-arrow-down-wide-short fa-fw',
        'fa-solid fa-arrow-down-up-lock fa-fw',
        'fa-solid fa-arrow-down-up-across-line fa-fw',
        'fa-solid fa-arrow-down-triangle-square fa-fw',
        'fa-solid fa-arrow-down-to-square fa-fw',
        'fa-solid fa-arrow-down-to-dotted-line fa-fw',
        'fa-solid fa-arrow-down-to-bracket fa-fw',
        'fa-solid fa-arrow-down-to-arc fa-fw',
        'fa-solid fa-arrow-down-square-triangle fa-fw',
        'fa-solid fa-arrow-down-small-big fa-fw',
        'fa-solid fa-arrow-down-short-wide fa-fw',
        'fa-solid fa-arrow-down-right fa-fw',
        'fa-solid fa-arrow-down-long fa-fw',
        'fa-solid fa-arrow-down-left-and-arrow-up-right-to-center fa-fw',
        'fa-solid fa-arrow-down-left fa-fw',
        'fa-solid fa-arrow-down-from-line fa-fw',
        'fa-solid fa-arrow-down-from-dotted-line fa-fw',
        'fa-solid fa-arrow-down-big-small fa-fw',
        'fa-solid fa-arrow-down-arrow-up fa-fw',
        'fa-solid fa-arrow-down-a-z fa-fw',
        'fa-solid fa-arrow-down-9-1 fa-fw',
        'fa-solid fa-arrow-down-1-9 fa-fw',
        'fa-solid fa-angles-up fa-fw',
        'fa-solid fa-angles-right fa-fw',
        'fa-solid fa-angles-left fa-fw',
        'fa-solid fa-angles-down fa-fw',
        'fa-solid fa-angle-right fa-fw',
        'fa-solid fa-angle-left fa-fw',
        'fa-solid fa-angle-down fa-fw',
        'fa-regular fa-up-to-line fa-fw',
        'fa-regular fa-up-to-dotted-line fa-fw',
        'fa-regular fa-up-right-from-square fa-fw',
        'fa-regular fa-up-right-and-down-left-from-center fa-fw',
        'fa-regular fa-up-right fa-fw',
        'fa-regular fa-up-long fa-fw',
        'fa-regular fa-up-left fa-fw',
        'fa-regular fa-up-from-line fa-fw',
        'fa-regular fa-up-from-dotted-line fa-fw',
        'fa-regular fa-up-from-bracket fa-fw',
        'fa-regular fa-up-down-left-right fa-fw',
        'fa-regular fa-up-down fa-fw',
        'fa-regular fa-up fa-fw',
        'fa-regular fa-turn-up fa-fw',
        'fa-regular fa-turn-down-right fa-fw',
        'fa-regular fa-turn-down-left fa-fw',
        'fa-regular fa-turn-down fa-fw',
        'fa-regular fa-square-up-right fa-fw',
        'fa-regular fa-square-up-left fa-fw',
        'fa-regular fa-square-up fa-fw',
        'fa-regular fa-square-right fa-fw',
        'fa-regular fa-square-left fa-fw',
        'fa-regular fa-square-down-right fa-fw',
        'fa-regular fa-square-down-left fa-fw',
        'fa-regular fa-square-down fa-fw',
        'fa-regular fa-square-chevron-up fa-fw',
        'fa-regular fa-square-chevron-right fa-fw',
        'fa-regular fa-square-chevron-left fa-fw',
        'fa-regular fa-square-chevron-down fa-fw',
        'fa-regular fa-square-caret-up fa-fw',
        'fa-regular fa-square-caret-right fa-fw',
        'fa-regular fa-square-caret-left fa-fw',
        'fa-regular fa-square-caret-down fa-fw',
        'fa-regular fa-square-arrow-up-right fa-fw',
        'fa-regular fa-square-arrow-up-left fa-fw',
        'fa-regular fa-square-arrow-up fa-fw',
        'fa-regular fa-square-arrow-right fa-fw',
        'fa-regular fa-square-arrow-left fa-fw',
        'fa-regular fa-square-arrow-down-right fa-fw',
        'fa-regular fa-square-arrow-down-left fa-fw',
        'fa-regular fa-square-arrow-down fa-fw',
        'fa-regular fa-split fa-fw',
        'fa-regular fa-sort-up fa-fw',
        'fa-regular fa-sort-down fa-fw',
        'fa-regular fa-shuffle fa-fw',
        'fa-regular fa-share-all fa-fw',
        'fa-regular fa-rotate-left fa-fw',
        'fa-regular fa-rotate fa-fw',
        'fa-regular fa-right-to-line fa-fw',
        'fa-regular fa-right-long-to-line fa-fw',
        'fa-regular fa-right-long fa-fw',
        'fa-regular fa-right-left-large fa-fw',
        'fa-regular fa-right-left fa-fw',
        'fa-regular fa-right-from-line fa-fw',
        'fa-regular fa-right-from-bracket fa-fw',
        'fa-regular fa-right fa-fw',
        'fa-regular fa-retweet fa-fw',
        'fa-regular fa-reply-all fa-fw',
        'fa-regular fa-repeat-1 fa-fw',
        'fa-regular fa-merge fa-fw',
        'fa-regular fa-maximize fa-fw',
        'fa-regular fa-location-arrow fa-fw',
        'fa-regular fa-left-to-line fa-fw',
        'fa-regular fa-left-right fa-fw',
        'fa-regular fa-left-long-to-line fa-fw',
        'fa-regular fa-left-long fa-fw',
        'fa-regular fa-left-from-line fa-fw',
        'fa-regular fa-left fa-fw',
        'fa-regular fa-inbox-out fa-fw',
        'fa-regular fa-inbox-in fa-fw',
        'fa-regular fa-down-to-line fa-fw',
        'fa-regular fa-down-to-dotted-line fa-fw',
        'fa-regular fa-down-to-bracket fa-fw',
        'fa-regular fa-down-right fa-fw',
        'fa-regular fa-down-long fa-fw',
        'fa-regular fa-down-left-and-up-right-to-center fa-fw',
        'fa-regular fa-down-left fa-fw',
        'fa-regular fa-down-from-line fa-fw',
        'fa-regular fa-down-from-dotted-line fa-fw',
        'fa-regular fa-down fa-fw',
        'fa-regular fa-cloud-arrow-down fa-fw',
        'fa-regular fa-clock-rotate-left fa-fw',
        'fa-regular fa-circle-up-right fa-fw',
        'fa-regular fa-circle-up-left fa-fw',
        'fa-regular fa-circle-right fa-fw',
        'fa-regular fa-circle-left fa-fw',
        'fa-regular fa-circle-down-right fa-fw',
        'fa-regular fa-circle-down-left fa-fw',
        'fa-regular fa-circle-chevron-up fa-fw',
        'fa-regular fa-circle-chevron-right fa-fw',
        'fa-regular fa-circle-chevron-left fa-fw',
        'fa-regular fa-circle-chevron-down fa-fw',
        'fa-regular fa-circle-caret-up fa-fw',
        'fa-regular fa-circle-caret-right fa-fw',
        'fa-regular fa-circle-caret-left fa-fw',
        'fa-regular fa-circle-caret-down fa-fw',
        'fa-regular fa-circle-arrow-up-right fa-fw',
        'fa-regular fa-circle-arrow-up-left fa-fw',
        'fa-regular fa-circle-arrow-up fa-fw',
        'fa-regular fa-circle-arrow-right fa-fw',
        'fa-regular fa-circle-arrow-left fa-fw',
        'fa-regular fa-circle-arrow-down-right fa-fw',
        'fa-regular fa-circle-arrow-down-left fa-fw',
        'fa-regular fa-circle-arrow-down fa-fw',
        'fa-regular fa-chevrons-up fa-fw',
        'fa-regular fa-chevrons-right fa-fw',
        'fa-regular fa-chevrons-left fa-fw',
        'fa-regular fa-chevrons-down fa-fw',
        'fa-regular fa-chevron-right fa-fw',
        'fa-regular fa-chevron-left fa-fw',
        'fa-regular fa-caret-right fa-fw',
        'fa-regular fa-caret-left fa-fw',
        'fa-regular fa-arrows-up-to-line fa-fw',
        'fa-regular fa-arrows-up-down-left-right fa-fw',
        'fa-regular fa-arrows-up-down fa-fw',
        'fa-regular fa-arrows-turn-to-dots fa-fw',
        'fa-regular fa-arrows-turn-right fa-fw',
        'fa-regular fa-arrows-to-line fa-fw',
        'fa-regular fa-arrows-to-eye fa-fw',
        'fa-regular fa-arrows-to-dotted-line fa-fw',
        'fa-regular fa-arrows-to-dot fa-fw',
        'fa-regular fa-arrows-to-circle fa-fw',
        'fa-regular fa-arrows-split-up-and-left fa-fw',
        'fa-regular fa-arrows-spin fa-fw',
        'fa-regular fa-arrows-rotate fa-fw',
        'fa-regular fa-arrows-retweet fa-fw',
        'fa-regular fa-arrows-repeat-1 fa-fw',
        'fa-regular fa-arrows-repeat fa-fw',
        'fa-regular fa-arrows-minimize fa-fw',
        'fa-regular fa-arrows-maximize fa-fw',
        'fa-regular fa-arrows-left-right-to-line fa-fw',
        'fa-regular fa-arrows-left-right fa-fw',
        'fa-regular fa-arrows-from-line fa-fw',
        'fa-regular fa-arrows-from-dotted-line fa-fw',
        'fa-regular fa-arrows-down-to-line fa-fw',
        'fa-regular fa-arrows-cross fa-fw',
        'fa-regular fa-arrow-up-z-a fa-fw',
        'fa-regular fa-arrow-up-wide-short fa-fw',
        'fa-regular fa-arrow-up-triangle-square fa-fw',
        'fa-regular fa-arrow-up-to-line fa-fw',
        'fa-regular fa-arrow-up-to-dotted-line fa-fw',
        'fa-regular fa-arrow-up-square-triangle fa-fw',
        'fa-regular fa-arrow-up-small-big fa-fw',
        'fa-regular fa-arrow-up-short-wide fa-fw',
        'fa-regular fa-arrow-up-right-dots fa-fw',
        'fa-regular fa-arrow-up-right-and-arrow-down-left-from-center fa-fw',
        'fa-regular fa-arrow-up-right fa-fw',
        'fa-regular fa-arrow-up-long fa-fw',
        'fa-regular fa-arrow-up-left-from-circle fa-fw',
        'fa-regular fa-arrow-up-left fa-fw',
        'fa-regular fa-arrow-up-from-square fa-fw',
        'fa-regular fa-arrow-up-from-line fa-fw',
        'fa-regular fa-arrow-up-from-dotted-line fa-fw',
        'fa-regular fa-arrow-up-from-arc fa-fw',
        'fa-regular fa-arrow-up-big-small fa-fw',
        'fa-regular fa-arrow-up-arrow-down fa-fw',
        'fa-regular fa-arrow-up-a-z fa-fw',
        'fa-regular fa-arrow-up-9-1 fa-fw',
        'fa-regular fa-arrow-up-1-9 fa-fw',
        'fa-regular fa-arrow-turn-up fa-fw',
        'fa-regular fa-arrow-turn-down-right fa-fw',
        'fa-regular fa-arrow-turn-down-left fa-fw',
        'fa-regular fa-arrow-turn-down fa-fw',
        'fa-regular fa-arrow-trend-up fa-fw',
        'fa-regular fa-arrow-trend-down fa-fw',
        'fa-regular fa-arrow-rotate-right fa-fw',
        'fa-regular fa-arrow-rotate-left fa-fw',
        'fa-regular fa-arrow-right-to-line fa-fw',
        'fa-regular fa-arrow-right-to-bracket fa-fw',
        'fa-regular fa-arrow-right-to-arc fa-fw',
        'fa-regular fa-arrow-right-long-to-line fa-fw',
        'fa-regular fa-arrow-right-long fa-fw',
        'fa-regular fa-arrow-right-from-line fa-fw',
        'fa-regular fa-arrow-right-from-bracket fa-fw',
        'fa-regular fa-arrow-right-from-arc fa-fw',
        'fa-regular fa-arrow-right-arrow-left fa-fw',
        'fa-regular fa-arrow-progress fa-fw',
        'fa-regular fa-arrow-pointer fa-fw',
        'fa-regular fa-arrow-left-to-line fa-fw',
        'fa-regular fa-arrow-left-long-to-line fa-fw',
        'fa-regular fa-arrow-left-long fa-fw',
        'fa-regular fa-arrow-left-from-line fa-fw',
        'fa-regular fa-arrow-down-z-a fa-fw',
        'fa-regular fa-arrow-down-wide-short fa-fw',
        'fa-regular fa-arrow-down-up-lock fa-fw',
        'fa-regular fa-arrow-down-up-across-line fa-fw',
        'fa-regular fa-arrow-down-triangle-square fa-fw',
        'fa-regular fa-arrow-down-to-square fa-fw',
        'fa-regular fa-arrow-down-to-dotted-line fa-fw',
        'fa-regular fa-arrow-down-to-bracket fa-fw',
        'fa-regular fa-arrow-down-to-arc fa-fw',
        'fa-regular fa-arrow-down-square-triangle fa-fw',
        'fa-regular fa-arrow-down-small-big fa-fw',
        'fa-regular fa-arrow-down-short-wide fa-fw',
        'fa-regular fa-arrow-down-right fa-fw',
        'fa-regular fa-arrow-down-long fa-fw',
        'fa-regular fa-arrow-down-left-and-arrow-up-right-to-center fa-fw',
        'fa-regular fa-arrow-down-left fa-fw',
        'fa-regular fa-arrow-down-from-line fa-fw',
        'fa-regular fa-arrow-down-from-dotted-line fa-fw',
        'fa-regular fa-arrow-down-big-small fa-fw',
        'fa-regular fa-arrow-down-arrow-up fa-fw',
        'fa-regular fa-arrow-down-a-z fa-fw',
        'fa-regular fa-arrow-down-9-1 fa-fw',
        'fa-regular fa-arrow-down-1-9 fa-fw',
        'fa-regular fa-angles-up fa-fw',
        'fa-regular fa-angles-right fa-fw',
        'fa-regular fa-angles-left fa-fw',
        'fa-regular fa-angles-down fa-fw',
        'fa-regular fa-angle-right fa-fw',
        'fa-regular fa-angle-left fa-fw',
        'fa-regular fa-angle-down fa-fw',
        'fa-light fa-up-to-line fa-fw',
        'fa-light fa-up-to-dotted-line fa-fw',
        'fa-light fa-up-right-from-square fa-fw',
        'fa-light fa-up-right-and-down-left-from-center fa-fw',
        'fa-light fa-up-right fa-fw',
        'fa-light fa-up-long fa-fw',
        'fa-light fa-up-left fa-fw',
        'fa-light fa-up-from-line fa-fw',
        'fa-light fa-up-from-dotted-line fa-fw',
        'fa-light fa-up-from-bracket fa-fw',
        'fa-light fa-up-down-left-right fa-fw',
        'fa-light fa-up-down fa-fw',
        'fa-light fa-up fa-fw',
        'fa-light fa-turn-up fa-fw',
        'fa-light fa-turn-down-right fa-fw',
        'fa-light fa-turn-down-left fa-fw',
        'fa-light fa-turn-down fa-fw',
        'fa-light fa-square-up-right fa-fw',
        'fa-light fa-square-up-left fa-fw',
        'fa-light fa-square-up fa-fw',
        'fa-light fa-square-right fa-fw',
        'fa-light fa-square-left fa-fw',
        'fa-light fa-square-down-right fa-fw',
        'fa-light fa-square-down-left fa-fw',
        'fa-light fa-square-down fa-fw',
        'fa-light fa-square-chevron-up fa-fw',
        'fa-light fa-square-chevron-right fa-fw',
        'fa-light fa-square-chevron-left fa-fw',
        'fa-light fa-square-chevron-down fa-fw',
        'fa-light fa-square-caret-up fa-fw',
        'fa-light fa-square-caret-right fa-fw',
        'fa-light fa-square-caret-left fa-fw',
        'fa-light fa-square-caret-down fa-fw',
        'fa-light fa-square-arrow-up-right fa-fw',
        'fa-light fa-square-arrow-up-left fa-fw',
        'fa-light fa-square-arrow-up fa-fw',
        'fa-light fa-square-arrow-right fa-fw',
        'fa-light fa-square-arrow-left fa-fw',
        'fa-light fa-square-arrow-down-right fa-fw',
        'fa-light fa-square-arrow-down-left fa-fw',
        'fa-light fa-square-arrow-down fa-fw',
        'fa-light fa-split fa-fw',
        'fa-light fa-sort-up fa-fw',
        'fa-light fa-sort-down fa-fw',
        'fa-light fa-shuffle fa-fw',
        'fa-light fa-share-all fa-fw',
        'fa-light fa-rotate-left fa-fw',
        'fa-light fa-rotate fa-fw',
        'fa-light fa-right-to-line fa-fw',
        'fa-light fa-right-long-to-line fa-fw',
        'fa-light fa-right-long fa-fw',
        'fa-light fa-right-left-large fa-fw',
        'fa-light fa-right-left fa-fw',
        'fa-light fa-right-from-line fa-fw',
        'fa-light fa-right-from-bracket fa-fw',
        'fa-light fa-right fa-fw',
        'fa-light fa-retweet fa-fw',
        'fa-light fa-reply-all fa-fw',
        'fa-light fa-repeat-1 fa-fw',
        'fa-light fa-merge fa-fw',
        'fa-light fa-maximize fa-fw',
        'fa-light fa-location-arrow fa-fw',
        'fa-light fa-left-to-line fa-fw',
        'fa-light fa-left-right fa-fw',
        'fa-light fa-left-long-to-line fa-fw',
        'fa-light fa-left-long fa-fw',
        'fa-light fa-left-from-line fa-fw',
        'fa-light fa-left fa-fw',
        'fa-light fa-inbox-out fa-fw',
        'fa-light fa-inbox-in fa-fw',
        'fa-light fa-down-to-line fa-fw',
        'fa-light fa-down-to-dotted-line fa-fw',
        'fa-light fa-down-to-bracket fa-fw',
        'fa-light fa-down-right fa-fw',
        'fa-light fa-down-long fa-fw',
        'fa-light fa-down-left-and-up-right-to-center fa-fw',
        'fa-light fa-down-left fa-fw',
        'fa-light fa-down-from-line fa-fw',
        'fa-light fa-down-from-dotted-line fa-fw',
        'fa-light fa-down fa-fw',
        'fa-light fa-cloud-arrow-down fa-fw',
        'fa-light fa-clock-rotate-left fa-fw',
        'fa-light fa-circle-up-right fa-fw',
        'fa-light fa-circle-up-left fa-fw',
        'fa-light fa-circle-right fa-fw',
        'fa-light fa-circle-left fa-fw',
        'fa-light fa-circle-down-right fa-fw',
        'fa-light fa-circle-down-left fa-fw',
        'fa-light fa-circle-chevron-up fa-fw',
        'fa-light fa-circle-chevron-right fa-fw',
        'fa-light fa-circle-chevron-left fa-fw',
        'fa-light fa-circle-chevron-down fa-fw',
        'fa-light fa-circle-caret-up fa-fw',
        'fa-light fa-circle-caret-right fa-fw',
        'fa-light fa-circle-caret-left fa-fw',
        'fa-light fa-circle-caret-down fa-fw',
        'fa-light fa-circle-arrow-up-right fa-fw',
        'fa-light fa-circle-arrow-up-left fa-fw',
        'fa-light fa-circle-arrow-up fa-fw',
        'fa-light fa-circle-arrow-right fa-fw',
        'fa-light fa-circle-arrow-left fa-fw',
        'fa-light fa-circle-arrow-down-right fa-fw',
        'fa-light fa-circle-arrow-down-left fa-fw',
        'fa-light fa-circle-arrow-down fa-fw',
        'fa-light fa-chevrons-up fa-fw',
        'fa-light fa-chevrons-right fa-fw',
        'fa-light fa-chevrons-left fa-fw',
        'fa-light fa-chevrons-down fa-fw',
        'fa-light fa-chevron-right fa-fw',
        'fa-light fa-chevron-left fa-fw',
        'fa-light fa-caret-right fa-fw',
        'fa-light fa-caret-left fa-fw',
        'fa-light fa-arrows-up-to-line fa-fw',
        'fa-light fa-arrows-up-down-left-right fa-fw',
        'fa-light fa-arrows-up-down fa-fw',
        'fa-light fa-arrows-turn-to-dots fa-fw',
        'fa-light fa-arrows-turn-right fa-fw',
        'fa-light fa-arrows-to-line fa-fw',
        'fa-light fa-arrows-to-eye fa-fw',
        'fa-light fa-arrows-to-dotted-line fa-fw',
        'fa-light fa-arrows-to-dot fa-fw',
        'fa-light fa-arrows-to-circle fa-fw',
        'fa-light fa-arrows-split-up-and-left fa-fw',
        'fa-light fa-arrows-spin fa-fw',
        'fa-light fa-arrows-rotate fa-fw',
        'fa-light fa-arrows-retweet fa-fw',
        'fa-light fa-arrows-repeat-1 fa-fw',
        'fa-light fa-arrows-repeat fa-fw',
        'fa-light fa-arrows-minimize fa-fw',
        'fa-light fa-arrows-maximize fa-fw',
        'fa-light fa-arrows-left-right-to-line fa-fw',
        'fa-light fa-arrows-left-right fa-fw',
        'fa-light fa-arrows-from-line fa-fw',
        'fa-light fa-arrows-from-dotted-line fa-fw',
        'fa-light fa-arrows-down-to-line fa-fw',
        'fa-light fa-arrows-cross fa-fw',
        'fa-light fa-arrow-up-z-a fa-fw',
        'fa-light fa-arrow-up-wide-short fa-fw',
        'fa-light fa-arrow-up-triangle-square fa-fw',
        'fa-light fa-arrow-up-to-line fa-fw',
        'fa-light fa-arrow-up-to-dotted-line fa-fw',
        'fa-light fa-arrow-up-square-triangle fa-fw',
        'fa-light fa-arrow-up-small-big fa-fw',
        'fa-light fa-arrow-up-short-wide fa-fw',
        'fa-light fa-arrow-up-right-dots fa-fw',
        'fa-light fa-arrow-up-right-and-arrow-down-left-from-center fa-fw',
        'fa-light fa-arrow-up-right fa-fw',
        'fa-light fa-arrow-up-long fa-fw',
        'fa-light fa-arrow-up-left-from-circle fa-fw',
        'fa-light fa-arrow-up-left fa-fw',
        'fa-light fa-arrow-up-from-square fa-fw',
        'fa-light fa-arrow-up-from-line fa-fw',
        'fa-light fa-arrow-up-from-dotted-line fa-fw',
        'fa-light fa-arrow-up-from-arc fa-fw',
        'fa-light fa-arrow-up-big-small fa-fw',
        'fa-light fa-arrow-up-arrow-down fa-fw',
        'fa-light fa-arrow-up-a-z fa-fw',
        'fa-light fa-arrow-up-9-1 fa-fw',
        'fa-light fa-arrow-up-1-9 fa-fw',
        'fa-light fa-arrow-turn-up fa-fw',
        'fa-light fa-arrow-turn-down-right fa-fw',
        'fa-light fa-arrow-turn-down-left fa-fw',
        'fa-light fa-arrow-turn-down fa-fw',
        'fa-light fa-arrow-trend-up fa-fw',
        'fa-light fa-arrow-trend-down fa-fw',
        'fa-light fa-arrow-rotate-right fa-fw',
        'fa-light fa-arrow-rotate-left fa-fw',
        'fa-light fa-arrow-right-to-line fa-fw',
        'fa-light fa-arrow-right-to-bracket fa-fw',
        'fa-light fa-arrow-right-to-arc fa-fw',
        'fa-light fa-arrow-right-long-to-line fa-fw',
        'fa-light fa-arrow-right-long fa-fw',
        'fa-light fa-arrow-right-from-line fa-fw',
        'fa-light fa-arrow-right-from-bracket fa-fw',
        'fa-light fa-arrow-right-from-arc fa-fw',
        'fa-light fa-arrow-right-arrow-left fa-fw',
        'fa-light fa-arrow-progress fa-fw',
        'fa-light fa-arrow-pointer fa-fw',
        'fa-light fa-arrow-left-to-line fa-fw',
        'fa-light fa-arrow-left-long-to-line fa-fw',
        'fa-light fa-arrow-left-long fa-fw',
        'fa-light fa-arrow-left-from-line fa-fw',
        'fa-light fa-arrow-down-z-a fa-fw',
        'fa-light fa-arrow-down-wide-short fa-fw',
        'fa-light fa-arrow-down-up-lock fa-fw',
        'fa-light fa-arrow-down-up-across-line fa-fw',
        'fa-light fa-arrow-down-triangle-square fa-fw',
        'fa-light fa-arrow-down-to-square fa-fw',
        'fa-light fa-arrow-down-to-dotted-line fa-fw',
        'fa-light fa-arrow-down-to-bracket fa-fw',
        'fa-light fa-arrow-down-to-arc fa-fw',
        'fa-light fa-arrow-down-square-triangle fa-fw',
        'fa-light fa-arrow-down-small-big fa-fw',
        'fa-light fa-arrow-down-short-wide fa-fw',
        'fa-light fa-arrow-down-right fa-fw',
        'fa-light fa-arrow-down-long fa-fw',
        'fa-light fa-arrow-down-left-and-arrow-up-right-to-center fa-fw',
        'fa-light fa-arrow-down-left fa-fw',
        'fa-light fa-arrow-down-from-line fa-fw',
        'fa-light fa-arrow-down-from-dotted-line fa-fw',
        'fa-light fa-arrow-down-big-small fa-fw',
        'fa-light fa-arrow-down-arrow-up fa-fw',
        'fa-light fa-arrow-down-a-z fa-fw',
        'fa-light fa-arrow-down-9-1 fa-fw',
        'fa-light fa-arrow-down-1-9 fa-fw',
        'fa-light fa-angles-up fa-fw',
        'fa-light fa-angles-right fa-fw',
        'fa-light fa-angles-left fa-fw',
        'fa-light fa-angles-down fa-fw',
        'fa-light fa-angle-right fa-fw',
        'fa-light fa-angle-left fa-fw',
        'fa-light fa-angle-down fa-fw',
        'fa-thin fa-up-to-line fa-fw',
        'fa-thin fa-up-to-dotted-line fa-fw',
        'fa-thin fa-up-right-from-square fa-fw',
        'fa-thin fa-up-right-and-down-left-from-center fa-fw',
        'fa-thin fa-up-right fa-fw',
        'fa-thin fa-up-long fa-fw',
        'fa-thin fa-up-left fa-fw',
        'fa-thin fa-up-from-line fa-fw',
        'fa-thin fa-up-from-dotted-line fa-fw',
        'fa-thin fa-up-from-bracket fa-fw',
        'fa-thin fa-up-down-left-right fa-fw',
        'fa-thin fa-up-down fa-fw',
        'fa-thin fa-up fa-fw',
        'fa-thin fa-turn-up fa-fw',
        'fa-thin fa-turn-down-right fa-fw',
        'fa-thin fa-turn-down-left fa-fw',
        'fa-thin fa-turn-down fa-fw',
        'fa-thin fa-square-up-right fa-fw',
        'fa-thin fa-square-up-left fa-fw',
        'fa-thin fa-square-up fa-fw',
        'fa-thin fa-square-right fa-fw',
        'fa-thin fa-square-left fa-fw',
        'fa-thin fa-square-down-right fa-fw',
        'fa-thin fa-square-down-left fa-fw',
        'fa-thin fa-square-down fa-fw',
        'fa-thin fa-square-chevron-up fa-fw',
        'fa-thin fa-square-chevron-right fa-fw',
        'fa-thin fa-square-chevron-left fa-fw',
        'fa-thin fa-square-chevron-down fa-fw',
        'fa-thin fa-square-caret-up fa-fw',
        'fa-thin fa-square-caret-right fa-fw',
        'fa-thin fa-square-caret-left fa-fw',
        'fa-thin fa-square-caret-down fa-fw',
        'fa-thin fa-square-arrow-up-right fa-fw',
        'fa-thin fa-square-arrow-up-left fa-fw',
        'fa-thin fa-square-arrow-up fa-fw',
        'fa-thin fa-square-arrow-right fa-fw',
        'fa-thin fa-square-arrow-left fa-fw',
        'fa-thin fa-square-arrow-down-right fa-fw',
        'fa-thin fa-square-arrow-down-left fa-fw',
        'fa-thin fa-square-arrow-down fa-fw',
        'fa-thin fa-split fa-fw',
        'fa-thin fa-sort-up fa-fw',
        'fa-thin fa-sort-down fa-fw',
        'fa-thin fa-shuffle fa-fw',
        'fa-thin fa-share-all fa-fw',
        'fa-thin fa-rotate-left fa-fw',
        'fa-thin fa-rotate fa-fw',
        'fa-thin fa-right-to-line fa-fw',
        'fa-thin fa-right-long-to-line fa-fw',
        'fa-thin fa-right-long fa-fw',
        'fa-thin fa-right-left-large fa-fw',
        'fa-thin fa-right-left fa-fw',
        'fa-thin fa-right-from-line fa-fw',
        'fa-thin fa-right-from-bracket fa-fw',
        'fa-thin fa-right fa-fw',
        'fa-thin fa-retweet fa-fw',
        'fa-thin fa-reply-all fa-fw',
        'fa-thin fa-repeat-1 fa-fw',
        'fa-thin fa-merge fa-fw',
        'fa-thin fa-maximize fa-fw',
        'fa-thin fa-location-arrow fa-fw',
        'fa-thin fa-left-to-line fa-fw',
        'fa-thin fa-left-right fa-fw',
        'fa-thin fa-left-long-to-line fa-fw',
        'fa-thin fa-left-long fa-fw',
        'fa-thin fa-left-from-line fa-fw',
        'fa-thin fa-left fa-fw',
        'fa-thin fa-inbox-out fa-fw',
        'fa-thin fa-inbox-in fa-fw',
        'fa-thin fa-down-to-line fa-fw',
        'fa-thin fa-down-to-dotted-line fa-fw',
        'fa-thin fa-down-to-bracket fa-fw',
        'fa-thin fa-down-right fa-fw',
        'fa-thin fa-down-long fa-fw',
        'fa-thin fa-down-left-and-up-right-to-center fa-fw',
        'fa-thin fa-down-left fa-fw',
        'fa-thin fa-down-from-line fa-fw',
        'fa-thin fa-down-from-dotted-line fa-fw',
        'fa-thin fa-down fa-fw',
        'fa-thin fa-cloud-arrow-down fa-fw',
        'fa-thin fa-clock-rotate-left fa-fw',
        'fa-thin fa-circle-up-right fa-fw',
        'fa-thin fa-circle-up-left fa-fw',
        'fa-thin fa-circle-right fa-fw',
        'fa-thin fa-circle-left fa-fw',
        'fa-thin fa-circle-down-right fa-fw',
        'fa-thin fa-circle-down-left fa-fw',
        'fa-thin fa-circle-chevron-up fa-fw',
        'fa-thin fa-circle-chevron-right fa-fw',
        'fa-thin fa-circle-chevron-left fa-fw',
        'fa-thin fa-circle-chevron-down fa-fw',
        'fa-thin fa-circle-caret-up fa-fw',
        'fa-thin fa-circle-caret-right fa-fw',
        'fa-thin fa-circle-caret-left fa-fw',
        'fa-thin fa-circle-caret-down fa-fw',
        'fa-thin fa-circle-arrow-up-right fa-fw',
        'fa-thin fa-circle-arrow-up-left fa-fw',
        'fa-thin fa-circle-arrow-up fa-fw',
        'fa-thin fa-circle-arrow-right fa-fw',
        'fa-thin fa-circle-arrow-left fa-fw',
        'fa-thin fa-circle-arrow-down-right fa-fw',
        'fa-thin fa-circle-arrow-down-left fa-fw',
        'fa-thin fa-circle-arrow-down fa-fw',
        'fa-thin fa-chevrons-up fa-fw',
        'fa-thin fa-chevrons-right fa-fw',
        'fa-thin fa-chevrons-left fa-fw',
        'fa-thin fa-chevrons-down fa-fw',
        'fa-thin fa-chevron-right fa-fw',
        'fa-thin fa-chevron-left fa-fw',
        'fa-thin fa-caret-right fa-fw',
        'fa-thin fa-caret-left fa-fw',
        'fa-thin fa-arrows-up-to-line fa-fw',
        'fa-thin fa-arrows-up-down-left-right fa-fw',
        'fa-thin fa-arrows-up-down fa-fw',
        'fa-thin fa-arrows-turn-to-dots fa-fw',
        'fa-thin fa-arrows-turn-right fa-fw',
        'fa-thin fa-arrows-to-line fa-fw',
        'fa-thin fa-arrows-to-eye fa-fw',
        'fa-thin fa-arrows-to-dotted-line fa-fw',
        'fa-thin fa-arrows-to-dot fa-fw',
        'fa-thin fa-arrows-to-circle fa-fw',
        'fa-thin fa-arrows-split-up-and-left fa-fw',
        'fa-thin fa-arrows-spin fa-fw',
        'fa-thin fa-arrows-rotate fa-fw',
        'fa-thin fa-arrows-retweet fa-fw',
        'fa-thin fa-arrows-repeat-1 fa-fw',
        'fa-thin fa-arrows-repeat fa-fw',
        'fa-thin fa-arrows-minimize fa-fw',
        'fa-thin fa-arrows-maximize fa-fw',
        'fa-thin fa-arrows-left-right-to-line fa-fw',
        'fa-thin fa-arrows-left-right fa-fw',
        'fa-thin fa-arrows-from-line fa-fw',
        'fa-thin fa-arrows-from-dotted-line fa-fw',
        'fa-thin fa-arrows-down-to-line fa-fw',
        'fa-thin fa-arrows-cross fa-fw',
        'fa-thin fa-arrow-up-z-a fa-fw',
        'fa-thin fa-arrow-up-wide-short fa-fw',
        'fa-thin fa-arrow-up-triangle-square fa-fw',
        'fa-thin fa-arrow-up-to-line fa-fw',
        'fa-thin fa-arrow-up-to-dotted-line fa-fw',
        'fa-thin fa-arrow-up-square-triangle fa-fw',
        'fa-thin fa-arrow-up-small-big fa-fw',
        'fa-thin fa-arrow-up-short-wide fa-fw',
        'fa-thin fa-arrow-up-right-dots fa-fw',
        'fa-thin fa-arrow-up-right-and-arrow-down-left-from-center fa-fw',
        'fa-thin fa-arrow-up-right fa-fw',
        'fa-thin fa-arrow-up-long fa-fw',
        'fa-thin fa-arrow-up-left-from-circle fa-fw',
        'fa-thin fa-arrow-up-left fa-fw',
        'fa-thin fa-arrow-up-from-square fa-fw',
        'fa-thin fa-arrow-up-from-line fa-fw',
        'fa-thin fa-arrow-up-from-dotted-line fa-fw',
        'fa-thin fa-arrow-up-from-arc fa-fw',
        'fa-thin fa-arrow-up-big-small fa-fw',
        'fa-thin fa-arrow-up-arrow-down fa-fw',
        'fa-thin fa-arrow-up-a-z fa-fw',
        'fa-thin fa-arrow-up-9-1 fa-fw',
        'fa-thin fa-arrow-up-1-9 fa-fw',
        'fa-thin fa-arrow-turn-up fa-fw',
        'fa-thin fa-arrow-turn-down-right fa-fw',
        'fa-thin fa-arrow-turn-down-left fa-fw',
        'fa-thin fa-arrow-turn-down fa-fw',
        'fa-thin fa-arrow-trend-up fa-fw',
        'fa-thin fa-arrow-trend-down fa-fw',
        'fa-thin fa-arrow-rotate-right fa-fw',
        'fa-thin fa-arrow-rotate-left fa-fw',
        'fa-thin fa-arrow-right-to-line fa-fw',
        'fa-thin fa-arrow-right-to-bracket fa-fw',
        'fa-thin fa-arrow-right-to-arc fa-fw',
        'fa-thin fa-arrow-right-long-to-line fa-fw',
        'fa-thin fa-arrow-right-long fa-fw',
        'fa-thin fa-arrow-right-from-line fa-fw',
        'fa-thin fa-arrow-right-from-bracket fa-fw',
        'fa-thin fa-arrow-right-from-arc fa-fw',
        'fa-thin fa-arrow-right-arrow-left fa-fw',
        'fa-thin fa-arrow-progress fa-fw',
        'fa-thin fa-arrow-pointer fa-fw',
        'fa-thin fa-arrow-left-to-line fa-fw',
        'fa-thin fa-arrow-left-long-to-line fa-fw',
        'fa-thin fa-arrow-left-long fa-fw',
        'fa-thin fa-arrow-left-from-line fa-fw',
        'fa-thin fa-arrow-down-z-a fa-fw',
        'fa-thin fa-arrow-down-wide-short fa-fw',
        'fa-thin fa-arrow-down-up-lock fa-fw',
        'fa-thin fa-arrow-down-up-across-line fa-fw',
        'fa-thin fa-arrow-down-triangle-square fa-fw',
        'fa-thin fa-arrow-down-to-square fa-fw',
        'fa-thin fa-arrow-down-to-dotted-line fa-fw',
        'fa-thin fa-arrow-down-to-bracket fa-fw',
        'fa-thin fa-arrow-down-to-arc fa-fw',
        'fa-thin fa-arrow-down-square-triangle fa-fw',
        'fa-thin fa-arrow-down-small-big fa-fw',
        'fa-thin fa-arrow-down-short-wide fa-fw',
        'fa-thin fa-arrow-down-right fa-fw',
        'fa-thin fa-arrow-down-long fa-fw',
        'fa-thin fa-arrow-down-left-and-arrow-up-right-to-center fa-fw',
        'fa-thin fa-arrow-down-left fa-fw',
        'fa-thin fa-arrow-down-from-line fa-fw',
        'fa-thin fa-arrow-down-from-dotted-line fa-fw',
        'fa-thin fa-arrow-down-big-small fa-fw',
        'fa-thin fa-arrow-down-arrow-up fa-fw',
        'fa-thin fa-arrow-down-a-z fa-fw',
        'fa-thin fa-arrow-down-9-1 fa-fw',
        'fa-thin fa-arrow-down-1-9 fa-fw',
        'fa-thin fa-angles-up fa-fw',
        'fa-thin fa-angles-right fa-fw',
        'fa-thin fa-angles-left fa-fw',
        'fa-thin fa-angles-down fa-fw',
        'fa-thin fa-angle-right fa-fw',
        'fa-thin fa-angle-left fa-fw',
        'fa-thin fa-angle-down fa-fw',
        'fa-duotone fa-up-to-line fa-fw',
        'fa-duotone fa-up-to-dotted-line fa-fw',
        'fa-duotone fa-up-right-from-square fa-fw',
        'fa-duotone fa-up-right-and-down-left-from-center fa-fw',
        'fa-duotone fa-up-right fa-fw',
        'fa-duotone fa-up-long fa-fw',
        'fa-duotone fa-up-left fa-fw',
        'fa-duotone fa-up-from-line fa-fw',
        'fa-duotone fa-up-from-dotted-line fa-fw',
        'fa-duotone fa-up-from-bracket fa-fw',
        'fa-duotone fa-up-down-left-right fa-fw',
        'fa-duotone fa-up-down fa-fw',
        'fa-duotone fa-up fa-fw',
        'fa-duotone fa-turn-up fa-fw',
        'fa-duotone fa-turn-down-right fa-fw',
        'fa-duotone fa-turn-down-left fa-fw',
        'fa-duotone fa-turn-down fa-fw',
        'fa-duotone fa-square-up-right fa-fw',
        'fa-duotone fa-square-up-left fa-fw',
        'fa-duotone fa-square-up fa-fw',
        'fa-duotone fa-square-right fa-fw',
        'fa-duotone fa-square-left fa-fw',
        'fa-duotone fa-square-down-right fa-fw',
        'fa-duotone fa-square-down-left fa-fw',
        'fa-duotone fa-square-down fa-fw',
        'fa-duotone fa-square-chevron-up fa-fw',
        'fa-duotone fa-square-chevron-right fa-fw',
        'fa-duotone fa-square-chevron-left fa-fw',
        'fa-duotone fa-square-chevron-down fa-fw',
        'fa-duotone fa-square-caret-up fa-fw',
        'fa-duotone fa-square-caret-right fa-fw',
        'fa-duotone fa-square-caret-left fa-fw',
        'fa-duotone fa-square-caret-down fa-fw',
        'fa-duotone fa-square-arrow-up-right fa-fw',
        'fa-duotone fa-square-arrow-up-left fa-fw',
        'fa-duotone fa-square-arrow-up fa-fw',
        'fa-duotone fa-square-arrow-right fa-fw',
        'fa-duotone fa-square-arrow-left fa-fw',
        'fa-duotone fa-square-arrow-down-right fa-fw',
        'fa-duotone fa-square-arrow-down-left fa-fw',
        'fa-duotone fa-square-arrow-down fa-fw',
        'fa-duotone fa-split fa-fw',
        'fa-duotone fa-sort-up fa-fw',
        'fa-duotone fa-sort-down fa-fw',
        'fa-duotone fa-shuffle fa-fw',
        'fa-duotone fa-share-all fa-fw',
        'fa-duotone fa-rotate-left fa-fw',
        'fa-duotone fa-rotate fa-fw',
        'fa-duotone fa-right-to-line fa-fw',
        'fa-duotone fa-right-long-to-line fa-fw',
        'fa-duotone fa-right-long fa-fw',
        'fa-duotone fa-right-left-large fa-fw',
        'fa-duotone fa-right-left fa-fw',
        'fa-duotone fa-right-from-line fa-fw',
        'fa-duotone fa-right-from-bracket fa-fw',
        'fa-duotone fa-right fa-fw',
        'fa-duotone fa-retweet fa-fw',
        'fa-duotone fa-reply-all fa-fw',
        'fa-duotone fa-repeat-1 fa-fw',
        'fa-duotone fa-merge fa-fw',
        'fa-duotone fa-maximize fa-fw',
        'fa-duotone fa-location-arrow fa-fw',
        'fa-duotone fa-left-to-line fa-fw',
        'fa-duotone fa-left-right fa-fw',
        'fa-duotone fa-left-long-to-line fa-fw',
        'fa-duotone fa-left-long fa-fw',
        'fa-duotone fa-left-from-line fa-fw',
        'fa-duotone fa-left fa-fw',
        'fa-duotone fa-inbox-out fa-fw',
        'fa-duotone fa-inbox-in fa-fw',
        'fa-duotone fa-down-to-line fa-fw',
        'fa-duotone fa-down-to-dotted-line fa-fw',
        'fa-duotone fa-down-to-bracket fa-fw',
        'fa-duotone fa-down-right fa-fw',
        'fa-duotone fa-down-long fa-fw',
        'fa-duotone fa-down-left-and-up-right-to-center fa-fw',
        'fa-duotone fa-down-left fa-fw',
        'fa-duotone fa-down-from-line fa-fw',
        'fa-duotone fa-down-from-dotted-line fa-fw',
        'fa-duotone fa-down fa-fw',
        'fa-duotone fa-cloud-arrow-down fa-fw',
        'fa-duotone fa-clock-rotate-left fa-fw',
        'fa-duotone fa-circle-up-right fa-fw',
        'fa-duotone fa-circle-up-left fa-fw',
        'fa-duotone fa-circle-right fa-fw',
        'fa-duotone fa-circle-left fa-fw',
        'fa-duotone fa-circle-down-right fa-fw',
        'fa-duotone fa-circle-down-left fa-fw',
        'fa-duotone fa-circle-chevron-up fa-fw',
        'fa-duotone fa-circle-chevron-right fa-fw',
        'fa-duotone fa-circle-chevron-left fa-fw',
        'fa-duotone fa-circle-chevron-down fa-fw',
        'fa-duotone fa-circle-caret-up fa-fw',
        'fa-duotone fa-circle-caret-right fa-fw',
        'fa-duotone fa-circle-caret-left fa-fw',
        'fa-duotone fa-circle-caret-down fa-fw',
        'fa-duotone fa-circle-arrow-up-right fa-fw',
        'fa-duotone fa-circle-arrow-up-left fa-fw',
        'fa-duotone fa-circle-arrow-up fa-fw',
        'fa-duotone fa-circle-arrow-right fa-fw',
        'fa-duotone fa-circle-arrow-left fa-fw',
        'fa-duotone fa-circle-arrow-down-right fa-fw',
        'fa-duotone fa-circle-arrow-down-left fa-fw',
        'fa-duotone fa-circle-arrow-down fa-fw',
        'fa-duotone fa-chevrons-up fa-fw',
        'fa-duotone fa-chevrons-right fa-fw',
        'fa-duotone fa-chevrons-left fa-fw',
        'fa-duotone fa-chevrons-down fa-fw',
        'fa-duotone fa-chevron-right fa-fw',
        'fa-duotone fa-chevron-left fa-fw',
        'fa-duotone fa-caret-right fa-fw',
        'fa-duotone fa-caret-left fa-fw',
        'fa-duotone fa-arrows-up-to-line fa-fw',
        'fa-duotone fa-arrows-up-down-left-right fa-fw',
        'fa-duotone fa-arrows-up-down fa-fw',
        'fa-duotone fa-arrows-turn-to-dots fa-fw',
        'fa-duotone fa-arrows-turn-right fa-fw',
        'fa-duotone fa-arrows-to-line fa-fw',
        'fa-duotone fa-arrows-to-eye fa-fw',
        'fa-duotone fa-arrows-to-dotted-line fa-fw',
        'fa-duotone fa-arrows-to-dot fa-fw',
        'fa-duotone fa-arrows-to-circle fa-fw',
        'fa-duotone fa-arrows-split-up-and-left fa-fw',
        'fa-duotone fa-arrows-spin fa-fw',
        'fa-duotone fa-arrows-rotate fa-fw',
        'fa-duotone fa-arrows-retweet fa-fw',
        'fa-duotone fa-arrows-repeat-1 fa-fw',
        'fa-duotone fa-arrows-repeat fa-fw',
        'fa-duotone fa-arrows-minimize fa-fw',
        'fa-duotone fa-arrows-maximize fa-fw',
        'fa-duotone fa-arrows-left-right-to-line fa-fw',
        'fa-duotone fa-arrows-left-right fa-fw',
        'fa-duotone fa-arrows-from-line fa-fw',
        'fa-duotone fa-arrows-from-dotted-line fa-fw',
        'fa-duotone fa-arrows-down-to-line fa-fw',
        'fa-duotone fa-arrows-cross fa-fw',
        'fa-duotone fa-arrow-up-z-a fa-fw',
        'fa-duotone fa-arrow-up-wide-short fa-fw',
        'fa-duotone fa-arrow-up-triangle-square fa-fw',
        'fa-duotone fa-arrow-up-to-line fa-fw',
        'fa-duotone fa-arrow-up-to-dotted-line fa-fw',
        'fa-duotone fa-arrow-up-square-triangle fa-fw',
        'fa-duotone fa-arrow-up-small-big fa-fw',
        'fa-duotone fa-arrow-up-short-wide fa-fw',
        'fa-duotone fa-arrow-up-right-dots fa-fw',
        'fa-duotone fa-arrow-up-right-and-arrow-down-left-from-center fa-fw',
        'fa-duotone fa-arrow-up-right fa-fw',
        'fa-duotone fa-arrow-up-long fa-fw',
        'fa-duotone fa-arrow-up-left-from-circle fa-fw',
        'fa-duotone fa-arrow-up-left fa-fw',
        'fa-duotone fa-arrow-up-from-square fa-fw',
        'fa-duotone fa-arrow-up-from-line fa-fw',
        'fa-duotone fa-arrow-up-from-dotted-line fa-fw',
        'fa-duotone fa-arrow-up-from-arc fa-fw',
        'fa-duotone fa-arrow-up-big-small fa-fw',
        'fa-duotone fa-arrow-up-arrow-down fa-fw',
        'fa-duotone fa-arrow-up-a-z fa-fw',
        'fa-duotone fa-arrow-up-9-1 fa-fw',
        'fa-duotone fa-arrow-up-1-9 fa-fw',
        'fa-duotone fa-arrow-turn-up fa-fw',
        'fa-duotone fa-arrow-turn-down-right fa-fw',
        'fa-duotone fa-arrow-turn-down-left fa-fw',
        'fa-duotone fa-arrow-turn-down fa-fw',
        'fa-duotone fa-arrow-trend-up fa-fw',
        'fa-duotone fa-arrow-trend-down fa-fw',
        'fa-duotone fa-arrow-rotate-right fa-fw',
        'fa-duotone fa-arrow-rotate-left fa-fw',
        'fa-duotone fa-arrow-right-to-line fa-fw',
        'fa-duotone fa-arrow-right-to-bracket fa-fw',
        'fa-duotone fa-arrow-right-to-arc fa-fw',
        'fa-duotone fa-arrow-right-long-to-line fa-fw',
        'fa-duotone fa-arrow-right-long fa-fw',
        'fa-duotone fa-arrow-right-from-line fa-fw',
        'fa-duotone fa-arrow-right-from-bracket fa-fw',
        'fa-duotone fa-arrow-right-from-arc fa-fw',
        'fa-duotone fa-arrow-right-arrow-left fa-fw',
        'fa-duotone fa-arrow-progress fa-fw',
        'fa-duotone fa-arrow-pointer fa-fw',
        'fa-duotone fa-arrow-left-to-line fa-fw',
        'fa-duotone fa-arrow-left-long-to-line fa-fw',
        'fa-duotone fa-arrow-left-long fa-fw',
        'fa-duotone fa-arrow-left-from-line fa-fw',
        'fa-duotone fa-arrow-down-z-a fa-fw',
        'fa-duotone fa-arrow-down-wide-short fa-fw',
        'fa-duotone fa-arrow-down-up-lock fa-fw',
        'fa-duotone fa-arrow-down-up-across-line fa-fw',
        'fa-duotone fa-arrow-down-triangle-square fa-fw',
        'fa-duotone fa-arrow-down-to-square fa-fw',
        'fa-duotone fa-arrow-down-to-dotted-line fa-fw',
        'fa-duotone fa-arrow-down-to-bracket fa-fw',
        'fa-duotone fa-arrow-down-to-arc fa-fw',
        'fa-duotone fa-arrow-down-square-triangle fa-fw',
        'fa-duotone fa-arrow-down-small-big fa-fw',
        'fa-duotone fa-arrow-down-short-wide fa-fw',
        'fa-duotone fa-arrow-down-right fa-fw',
        'fa-duotone fa-arrow-down-long fa-fw',
        'fa-duotone fa-arrow-down-left-and-arrow-up-right-to-center fa-fw',
        'fa-duotone fa-arrow-down-left fa-fw',
        'fa-duotone fa-arrow-down-from-line fa-fw',
        'fa-duotone fa-arrow-down-from-dotted-line fa-fw',
        'fa-duotone fa-arrow-down-big-small fa-fw',
        'fa-duotone fa-arrow-down-arrow-up fa-fw',
        'fa-duotone fa-arrow-down-a-z fa-fw',
        'fa-duotone fa-arrow-down-9-1 fa-fw',
        'fa-duotone fa-arrow-down-1-9 fa-fw',
        'fa-duotone fa-angles-up fa-fw',
        'fa-duotone fa-angles-right fa-fw',
        'fa-duotone fa-angles-left fa-fw',
        'fa-duotone fa-angles-down fa-fw',
        'fa-duotone fa-angle-right fa-fw',
        'fa-duotone fa-angle-left fa-fw',
        'fa-duotone fa-angle-down fa-fw',
        'fa-sharp fa-solid fa-up-to-line fa-fw',
        'fa-sharp fa-solid fa-up-to-dotted-line fa-fw',
        'fa-sharp fa-solid fa-up-right-from-square fa-fw',
        'fa-sharp fa-solid fa-up-right-and-down-left-from-center fa-fw',
        'fa-sharp fa-solid fa-up-right fa-fw',
        'fa-sharp fa-solid fa-up-long fa-fw',
        'fa-sharp fa-solid fa-up-left fa-fw',
        'fa-sharp fa-solid fa-up-from-line fa-fw',
        'fa-sharp fa-solid fa-up-from-dotted-line fa-fw',
        'fa-sharp fa-solid fa-up-from-bracket fa-fw',
        'fa-sharp fa-solid fa-up-down-left-right fa-fw',
        'fa-sharp fa-solid fa-up-down fa-fw',
        'fa-sharp fa-solid fa-up fa-fw',
        'fa-sharp fa-solid fa-turn-up fa-fw',
        'fa-sharp fa-solid fa-turn-down-right fa-fw',
        'fa-sharp fa-solid fa-turn-down-left fa-fw',
        'fa-sharp fa-solid fa-turn-down fa-fw',
        'fa-sharp fa-solid fa-square-up-right fa-fw',
        'fa-sharp fa-solid fa-square-up-left fa-fw',
        'fa-sharp fa-solid fa-square-up fa-fw',
        'fa-sharp fa-solid fa-square-right fa-fw',
        'fa-sharp fa-solid fa-square-left fa-fw',
        'fa-sharp fa-solid fa-square-down-right fa-fw',
        'fa-sharp fa-solid fa-square-down-left fa-fw',
        'fa-sharp fa-solid fa-square-down fa-fw',
        'fa-sharp fa-solid fa-square-chevron-up fa-fw',
        'fa-sharp fa-solid fa-square-chevron-right fa-fw',
        'fa-sharp fa-solid fa-square-chevron-left fa-fw',
        'fa-sharp fa-solid fa-square-chevron-down fa-fw',
        'fa-sharp fa-solid fa-square-caret-up fa-fw',
        'fa-sharp fa-solid fa-square-caret-right fa-fw',
        'fa-sharp fa-solid fa-square-caret-left fa-fw',
        'fa-sharp fa-solid fa-square-caret-down fa-fw',
        'fa-sharp fa-solid fa-square-arrow-up-right fa-fw',
        'fa-sharp fa-solid fa-square-arrow-up-left fa-fw',
        'fa-sharp fa-solid fa-square-arrow-up fa-fw',
        'fa-sharp fa-solid fa-square-arrow-right fa-fw',
        'fa-sharp fa-solid fa-square-arrow-left fa-fw',
        'fa-sharp fa-solid fa-square-arrow-down-right fa-fw',
        'fa-sharp fa-solid fa-square-arrow-down-left fa-fw',
        'fa-sharp fa-solid fa-square-arrow-down fa-fw',
        'fa-sharp fa-solid fa-split fa-fw',
        'fa-sharp fa-solid fa-sort-up fa-fw',
        'fa-sharp fa-solid fa-sort-down fa-fw',
        'fa-sharp fa-solid fa-shuffle fa-fw',
        'fa-sharp fa-solid fa-share-all fa-fw',
        'fa-sharp fa-solid fa-rotate-left fa-fw',
        'fa-sharp fa-solid fa-rotate fa-fw',
        'fa-sharp fa-solid fa-right-to-line fa-fw',
        'fa-sharp fa-solid fa-right-long-to-line fa-fw',
        'fa-sharp fa-solid fa-right-long fa-fw',
        'fa-sharp fa-solid fa-right-left-large fa-fw',
        'fa-sharp fa-solid fa-right-left fa-fw',
        'fa-sharp fa-solid fa-right-from-line fa-fw',
        'fa-sharp fa-solid fa-right-from-bracket fa-fw',
        'fa-sharp fa-solid fa-right fa-fw',
        'fa-sharp fa-solid fa-retweet fa-fw',
        'fa-sharp fa-solid fa-reply-all fa-fw',
        'fa-sharp fa-solid fa-repeat-1 fa-fw',
        'fa-sharp fa-solid fa-merge fa-fw',
        'fa-sharp fa-solid fa-maximize fa-fw',
        'fa-sharp fa-solid fa-location-arrow fa-fw',
        'fa-sharp fa-solid fa-left-to-line fa-fw',
        'fa-sharp fa-solid fa-left-right fa-fw',
        'fa-sharp fa-solid fa-left-long-to-line fa-fw',
        'fa-sharp fa-solid fa-left-long fa-fw',
        'fa-sharp fa-solid fa-left-from-line fa-fw',
        'fa-sharp fa-solid fa-left fa-fw',
        'fa-sharp fa-solid fa-inbox-out fa-fw',
        'fa-sharp fa-solid fa-inbox-in fa-fw',
        'fa-sharp fa-solid fa-down-to-line fa-fw',
        'fa-sharp fa-solid fa-down-to-dotted-line fa-fw',
        'fa-sharp fa-solid fa-down-to-bracket fa-fw',
        'fa-sharp fa-solid fa-down-right fa-fw',
        'fa-sharp fa-solid fa-down-long fa-fw',
        'fa-sharp fa-solid fa-down-left-and-up-right-to-center fa-fw',
        'fa-sharp fa-solid fa-down-left fa-fw',
        'fa-sharp fa-solid fa-down-from-line fa-fw',
        'fa-sharp fa-solid fa-down-from-dotted-line fa-fw',
        'fa-sharp fa-solid fa-down fa-fw',
        'fa-sharp fa-solid fa-cloud-arrow-down fa-fw',
        'fa-sharp fa-solid fa-clock-rotate-left fa-fw',
        'fa-sharp fa-solid fa-circle-up-right fa-fw',
        'fa-sharp fa-solid fa-circle-up-left fa-fw',
        'fa-sharp fa-solid fa-circle-right fa-fw',
        'fa-sharp fa-solid fa-circle-left fa-fw',
        'fa-sharp fa-solid fa-circle-down-right fa-fw',
        'fa-sharp fa-solid fa-circle-down-left fa-fw',
        'fa-sharp fa-solid fa-circle-chevron-up fa-fw',
        'fa-sharp fa-solid fa-circle-chevron-right fa-fw',
        'fa-sharp fa-solid fa-circle-chevron-left fa-fw',
        'fa-sharp fa-solid fa-circle-chevron-down fa-fw',
        'fa-sharp fa-solid fa-circle-caret-up fa-fw',
        'fa-sharp fa-solid fa-circle-caret-right fa-fw',
        'fa-sharp fa-solid fa-circle-caret-left fa-fw',
        'fa-sharp fa-solid fa-circle-caret-down fa-fw',
        'fa-sharp fa-solid fa-circle-arrow-up-right fa-fw',
        'fa-sharp fa-solid fa-circle-arrow-up-left fa-fw',
        'fa-sharp fa-solid fa-circle-arrow-up fa-fw',
        'fa-sharp fa-solid fa-circle-arrow-right fa-fw',
        'fa-sharp fa-solid fa-circle-arrow-left fa-fw',
        'fa-sharp fa-solid fa-circle-arrow-down-right fa-fw',
        'fa-sharp fa-solid fa-circle-arrow-down-left fa-fw',
        'fa-sharp fa-solid fa-circle-arrow-down fa-fw',
        'fa-sharp fa-solid fa-chevrons-up fa-fw',
        'fa-sharp fa-solid fa-chevrons-right fa-fw',
        'fa-sharp fa-solid fa-chevrons-left fa-fw',
        'fa-sharp fa-solid fa-chevrons-down fa-fw',
        'fa-sharp fa-solid fa-chevron-right fa-fw',
        'fa-sharp fa-solid fa-chevron-left fa-fw',
        'fa-sharp fa-solid fa-caret-right fa-fw',
        'fa-sharp fa-solid fa-caret-left fa-fw',
        'fa-sharp fa-solid fa-arrows-up-to-line fa-fw',
        'fa-sharp fa-solid fa-arrows-up-down-left-right fa-fw',
        'fa-sharp fa-solid fa-arrows-up-down fa-fw',
        'fa-sharp fa-solid fa-arrows-turn-to-dots fa-fw',
        'fa-sharp fa-solid fa-arrows-turn-right fa-fw',
        'fa-sharp fa-solid fa-arrows-to-line fa-fw',
        'fa-sharp fa-solid fa-arrows-to-eye fa-fw',
        'fa-sharp fa-solid fa-arrows-to-dotted-line fa-fw',
        'fa-sharp fa-solid fa-arrows-to-dot fa-fw',
        'fa-sharp fa-solid fa-arrows-to-circle fa-fw',
        'fa-sharp fa-solid fa-arrows-split-up-and-left fa-fw',
        'fa-sharp fa-solid fa-arrows-spin fa-fw',
        'fa-sharp fa-solid fa-arrows-rotate fa-fw',
        'fa-sharp fa-solid fa-arrows-retweet fa-fw',
        'fa-sharp fa-solid fa-arrows-repeat-1 fa-fw',
        'fa-sharp fa-solid fa-arrows-repeat fa-fw',
        'fa-sharp fa-solid fa-arrows-minimize fa-fw',
        'fa-sharp fa-solid fa-arrows-maximize fa-fw',
        'fa-sharp fa-solid fa-arrows-left-right-to-line fa-fw',
        'fa-sharp fa-solid fa-arrows-left-right fa-fw',
        'fa-sharp fa-solid fa-arrows-from-line fa-fw',
        'fa-sharp fa-solid fa-arrows-from-dotted-line fa-fw',
        'fa-sharp fa-solid fa-arrows-down-to-line fa-fw',
        'fa-sharp fa-solid fa-arrows-cross fa-fw',
        'fa-sharp fa-solid fa-arrow-up-z-a fa-fw',
        'fa-sharp fa-solid fa-arrow-up-wide-short fa-fw',
        'fa-sharp fa-solid fa-arrow-up-triangle-square fa-fw',
        'fa-sharp fa-solid fa-arrow-up-to-line fa-fw',
        'fa-sharp fa-solid fa-arrow-up-to-dotted-line fa-fw',
        'fa-sharp fa-solid fa-arrow-up-square-triangle fa-fw',
        'fa-sharp fa-solid fa-arrow-up-small-big fa-fw',
        'fa-sharp fa-solid fa-arrow-up-short-wide fa-fw',
        'fa-sharp fa-solid fa-arrow-up-right-dots fa-fw',
        'fa-sharp fa-solid fa-arrow-up-right-and-arrow-down-left-from-center fa-fw',
        'fa-sharp fa-solid fa-arrow-up-right fa-fw',
        'fa-sharp fa-solid fa-arrow-up-long fa-fw',
        'fa-sharp fa-solid fa-arrow-up-left-from-circle fa-fw',
        'fa-sharp fa-solid fa-arrow-up-left fa-fw',
        'fa-sharp fa-solid fa-arrow-up-from-square fa-fw',
        'fa-sharp fa-solid fa-arrow-up-from-line fa-fw',
        'fa-sharp fa-solid fa-arrow-up-from-dotted-line fa-fw',
        'fa-sharp fa-solid fa-arrow-up-from-arc fa-fw',
        'fa-sharp fa-solid fa-arrow-up-big-small fa-fw',
        'fa-sharp fa-solid fa-arrow-up-arrow-down fa-fw',
        'fa-sharp fa-solid fa-arrow-up-a-z fa-fw',
        'fa-sharp fa-solid fa-arrow-up-9-1 fa-fw',
        'fa-sharp fa-solid fa-arrow-up-1-9 fa-fw',
        'fa-sharp fa-solid fa-arrow-turn-up fa-fw',
        'fa-sharp fa-solid fa-arrow-turn-down-right fa-fw',
        'fa-sharp fa-solid fa-arrow-turn-down-left fa-fw',
        'fa-sharp fa-solid fa-arrow-turn-down fa-fw',
        'fa-sharp fa-solid fa-arrow-trend-up fa-fw',
        'fa-sharp fa-solid fa-arrow-trend-down fa-fw',
        'fa-sharp fa-solid fa-arrow-rotate-right fa-fw',
        'fa-sharp fa-solid fa-arrow-rotate-left fa-fw',
        'fa-sharp fa-solid fa-arrow-right-to-line fa-fw',
        'fa-sharp fa-solid fa-arrow-right-to-bracket fa-fw',
        'fa-sharp fa-solid fa-arrow-right-to-arc fa-fw',
        'fa-sharp fa-solid fa-arrow-right-long-to-line fa-fw',
        'fa-sharp fa-solid fa-arrow-right-long fa-fw',
        'fa-sharp fa-solid fa-arrow-right-from-line fa-fw',
        'fa-sharp fa-solid fa-arrow-right-from-bracket fa-fw',
        'fa-sharp fa-solid fa-arrow-right-from-arc fa-fw',
        'fa-sharp fa-solid fa-arrow-right-arrow-left fa-fw',
        'fa-sharp fa-solid fa-arrow-progress fa-fw',
        'fa-sharp fa-solid fa-arrow-pointer fa-fw',
        'fa-sharp fa-solid fa-arrow-left-to-line fa-fw',
        'fa-sharp fa-solid fa-arrow-left-long-to-line fa-fw',
        'fa-sharp fa-solid fa-arrow-left-long fa-fw',
        'fa-sharp fa-solid fa-arrow-left-from-line fa-fw',
        'fa-sharp fa-solid fa-arrow-down-z-a fa-fw',
        'fa-sharp fa-solid fa-arrow-down-wide-short fa-fw',
        'fa-sharp fa-solid fa-arrow-down-up-lock fa-fw',
        'fa-sharp fa-solid fa-arrow-down-up-across-line fa-fw',
        'fa-sharp fa-solid fa-arrow-down-triangle-square fa-fw',
        'fa-sharp fa-solid fa-arrow-down-to-square fa-fw',
        'fa-sharp fa-solid fa-arrow-down-to-dotted-line fa-fw',
        'fa-sharp fa-solid fa-arrow-down-to-bracket fa-fw',
        'fa-sharp fa-solid fa-arrow-down-to-arc fa-fw',
        'fa-sharp fa-solid fa-arrow-down-square-triangle fa-fw',
        'fa-sharp fa-solid fa-arrow-down-small-big fa-fw',
        'fa-sharp fa-solid fa-arrow-down-short-wide fa-fw',
        'fa-sharp fa-solid fa-arrow-down-right fa-fw',
        'fa-sharp fa-solid fa-arrow-down-long fa-fw',
        'fa-sharp fa-solid fa-arrow-down-left-and-arrow-up-right-to-center fa-fw',
        'fa-sharp fa-solid fa-arrow-down-left fa-fw',
        'fa-sharp fa-solid fa-arrow-down-from-line fa-fw',
        'fa-sharp fa-solid fa-arrow-down-from-dotted-line fa-fw',
        'fa-sharp fa-solid fa-arrow-down-big-small fa-fw',
        'fa-sharp fa-solid fa-arrow-down-arrow-up fa-fw',
        'fa-sharp fa-solid fa-arrow-down-a-z fa-fw',
        'fa-sharp fa-solid fa-arrow-down-9-1 fa-fw',
        'fa-sharp fa-solid fa-arrow-down-1-9 fa-fw',
        'fa-sharp fa-solid fa-angles-up fa-fw',
        'fa-sharp fa-solid fa-angles-right fa-fw',
        'fa-sharp fa-solid fa-angles-left fa-fw',
        'fa-sharp fa-solid fa-angles-down fa-fw',
        'fa-sharp fa-solid fa-angle-right fa-fw',
        'fa-sharp fa-solid fa-angle-left fa-fw',
        'fa-sharp fa-solid fa-angle-down fa-fw',
        'fa-sharp fa-regular fa-up-to-line fa-fw',
        'fa-sharp fa-regular fa-up-to-dotted-line fa-fw',
        'fa-sharp fa-regular fa-up-right-from-square fa-fw',
        'fa-sharp fa-regular fa-up-right-and-down-left-from-center fa-fw',
        'fa-sharp fa-regular fa-up-right fa-fw',
        'fa-sharp fa-regular fa-up-long fa-fw',
        'fa-sharp fa-regular fa-up-left fa-fw',
        'fa-sharp fa-regular fa-up-from-line fa-fw',
        'fa-sharp fa-regular fa-up-from-dotted-line fa-fw',
        'fa-sharp fa-regular fa-up-from-bracket fa-fw',
        'fa-sharp fa-regular fa-up-down-left-right fa-fw',
        'fa-sharp fa-regular fa-up-down fa-fw',
        'fa-sharp fa-regular fa-up fa-fw',
        'fa-sharp fa-regular fa-turn-up fa-fw',
        'fa-sharp fa-regular fa-turn-down-right fa-fw',
        'fa-sharp fa-regular fa-turn-down-left fa-fw',
        'fa-sharp fa-regular fa-turn-down fa-fw',
        'fa-sharp fa-regular fa-square-up-right fa-fw',
        'fa-sharp fa-regular fa-square-up-left fa-fw',
        'fa-sharp fa-regular fa-square-up fa-fw',
        'fa-sharp fa-regular fa-square-right fa-fw',
        'fa-sharp fa-regular fa-square-left fa-fw',
        'fa-sharp fa-regular fa-square-down-right fa-fw',
        'fa-sharp fa-regular fa-square-down-left fa-fw',
        'fa-sharp fa-regular fa-square-down fa-fw',
        'fa-sharp fa-regular fa-square-chevron-up fa-fw',
        'fa-sharp fa-regular fa-square-chevron-right fa-fw',
        'fa-sharp fa-regular fa-square-chevron-left fa-fw',
        'fa-sharp fa-regular fa-square-chevron-down fa-fw',
        'fa-sharp fa-regular fa-square-caret-up fa-fw',
        'fa-sharp fa-regular fa-square-caret-right fa-fw',
        'fa-sharp fa-regular fa-square-caret-left fa-fw',
        'fa-sharp fa-regular fa-square-caret-down fa-fw',
        'fa-sharp fa-regular fa-square-arrow-up-right fa-fw',
        'fa-sharp fa-regular fa-square-arrow-up-left fa-fw',
        'fa-sharp fa-regular fa-square-arrow-up fa-fw',
        'fa-sharp fa-regular fa-square-arrow-right fa-fw',
        'fa-sharp fa-regular fa-square-arrow-left fa-fw',
        'fa-sharp fa-regular fa-square-arrow-down-right fa-fw',
        'fa-sharp fa-regular fa-square-arrow-down-left fa-fw',
        'fa-sharp fa-regular fa-square-arrow-down fa-fw',
        'fa-sharp fa-regular fa-split fa-fw',
        'fa-sharp fa-regular fa-sort-up fa-fw',
        'fa-sharp fa-regular fa-sort-down fa-fw',
        'fa-sharp fa-regular fa-shuffle fa-fw',
        'fa-sharp fa-regular fa-share-all fa-fw',
        'fa-sharp fa-regular fa-rotate-left fa-fw',
        'fa-sharp fa-regular fa-rotate fa-fw',
        'fa-sharp fa-regular fa-right-to-line fa-fw',
        'fa-sharp fa-regular fa-right-long-to-line fa-fw',
        'fa-sharp fa-regular fa-right-long fa-fw',
        'fa-sharp fa-regular fa-right-left-large fa-fw',
        'fa-sharp fa-regular fa-right-left fa-fw',
        'fa-sharp fa-regular fa-right-from-line fa-fw',
        'fa-sharp fa-regular fa-right-from-bracket fa-fw',
        'fa-sharp fa-regular fa-right fa-fw',
        'fa-sharp fa-regular fa-retweet fa-fw',
        'fa-sharp fa-regular fa-reply-all fa-fw',
        'fa-sharp fa-regular fa-repeat-1 fa-fw',
        'fa-sharp fa-regular fa-merge fa-fw',
        'fa-sharp fa-regular fa-maximize fa-fw',
        'fa-sharp fa-regular fa-location-arrow fa-fw',
        'fa-sharp fa-regular fa-left-to-line fa-fw',
        'fa-sharp fa-regular fa-left-right fa-fw',
        'fa-sharp fa-regular fa-left-long-to-line fa-fw',
        'fa-sharp fa-regular fa-left-long fa-fw',
        'fa-sharp fa-regular fa-left-from-line fa-fw',
        'fa-sharp fa-regular fa-left fa-fw',
        'fa-sharp fa-regular fa-inbox-out fa-fw',
        'fa-sharp fa-regular fa-inbox-in fa-fw',
        'fa-sharp fa-regular fa-down-to-line fa-fw',
        'fa-sharp fa-regular fa-down-to-dotted-line fa-fw',
        'fa-sharp fa-regular fa-down-to-bracket fa-fw',
        'fa-sharp fa-regular fa-down-right fa-fw',
        'fa-sharp fa-regular fa-down-long fa-fw',
        'fa-sharp fa-regular fa-down-left-and-up-right-to-center fa-fw',
        'fa-sharp fa-regular fa-down-left fa-fw',
        'fa-sharp fa-regular fa-down-from-line fa-fw',
        'fa-sharp fa-regular fa-down-from-dotted-line fa-fw',
        'fa-sharp fa-regular fa-down fa-fw',
        'fa-sharp fa-regular fa-cloud-arrow-down fa-fw',
        'fa-sharp fa-regular fa-clock-rotate-left fa-fw',
        'fa-sharp fa-regular fa-circle-up-right fa-fw',
        'fa-sharp fa-regular fa-circle-up-left fa-fw',
        'fa-sharp fa-regular fa-circle-right fa-fw',
        'fa-sharp fa-regular fa-circle-left fa-fw',
        'fa-sharp fa-regular fa-circle-down-right fa-fw',
        'fa-sharp fa-regular fa-circle-down-left fa-fw',
        'fa-sharp fa-regular fa-circle-chevron-up fa-fw',
        'fa-sharp fa-regular fa-circle-chevron-right fa-fw',
        'fa-sharp fa-regular fa-circle-chevron-left fa-fw',
        'fa-sharp fa-regular fa-circle-chevron-down fa-fw',
        'fa-sharp fa-regular fa-circle-caret-up fa-fw',
        'fa-sharp fa-regular fa-circle-caret-right fa-fw',
        'fa-sharp fa-regular fa-circle-caret-left fa-fw',
        'fa-sharp fa-regular fa-circle-caret-down fa-fw',
        'fa-sharp fa-regular fa-circle-arrow-up-right fa-fw',
        'fa-sharp fa-regular fa-circle-arrow-up-left fa-fw',
        'fa-sharp fa-regular fa-circle-arrow-up fa-fw',
        'fa-sharp fa-regular fa-circle-arrow-right fa-fw',
        'fa-sharp fa-regular fa-circle-arrow-left fa-fw',
        'fa-sharp fa-regular fa-circle-arrow-down-right fa-fw',
        'fa-sharp fa-regular fa-circle-arrow-down-left fa-fw',
        'fa-sharp fa-regular fa-circle-arrow-down fa-fw',
        'fa-sharp fa-regular fa-chevrons-up fa-fw',
        'fa-sharp fa-regular fa-chevrons-right fa-fw',
        'fa-sharp fa-regular fa-chevrons-left fa-fw',
        'fa-sharp fa-regular fa-chevrons-down fa-fw',
        'fa-sharp fa-regular fa-chevron-right fa-fw',
        'fa-sharp fa-regular fa-chevron-left fa-fw',
        'fa-sharp fa-regular fa-caret-right fa-fw',
        'fa-sharp fa-regular fa-caret-left fa-fw',
        'fa-sharp fa-regular fa-arrows-up-to-line fa-fw',
        'fa-sharp fa-regular fa-arrows-up-down-left-right fa-fw',
        'fa-sharp fa-regular fa-arrows-up-down fa-fw',
        'fa-sharp fa-regular fa-arrows-turn-to-dots fa-fw',
        'fa-sharp fa-regular fa-arrows-turn-right fa-fw',
        'fa-sharp fa-regular fa-arrows-to-line fa-fw',
        'fa-sharp fa-regular fa-arrows-to-eye fa-fw',
        'fa-sharp fa-regular fa-arrows-to-dotted-line fa-fw',
        'fa-sharp fa-regular fa-arrows-to-dot fa-fw',
        'fa-sharp fa-regular fa-arrows-to-circle fa-fw',
        'fa-sharp fa-regular fa-arrows-split-up-and-left fa-fw',
        'fa-sharp fa-regular fa-arrows-spin fa-fw',
        'fa-sharp fa-regular fa-arrows-rotate fa-fw',
        'fa-sharp fa-regular fa-arrows-retweet fa-fw',
        'fa-sharp fa-regular fa-arrows-repeat-1 fa-fw',
        'fa-sharp fa-regular fa-arrows-repeat fa-fw',
        'fa-sharp fa-regular fa-arrows-minimize fa-fw',
        'fa-sharp fa-regular fa-arrows-maximize fa-fw',
        'fa-sharp fa-regular fa-arrows-left-right-to-line fa-fw',
        'fa-sharp fa-regular fa-arrows-left-right fa-fw',
        'fa-sharp fa-regular fa-arrows-from-line fa-fw',
        'fa-sharp fa-regular fa-arrows-from-dotted-line fa-fw',
        'fa-sharp fa-regular fa-arrows-down-to-line fa-fw',
        'fa-sharp fa-regular fa-arrows-cross fa-fw',
        'fa-sharp fa-regular fa-arrow-up-z-a fa-fw',
        'fa-sharp fa-regular fa-arrow-up-wide-short fa-fw',
        'fa-sharp fa-regular fa-arrow-up-triangle-square fa-fw',
        'fa-sharp fa-regular fa-arrow-up-to-line fa-fw',
        'fa-sharp fa-regular fa-arrow-up-to-dotted-line fa-fw',
        'fa-sharp fa-regular fa-arrow-up-square-triangle fa-fw',
        'fa-sharp fa-regular fa-arrow-up-small-big fa-fw',
        'fa-sharp fa-regular fa-arrow-up-short-wide fa-fw',
        'fa-sharp fa-regular fa-arrow-up-right-dots fa-fw',
        'fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center fa-fw',
        'fa-sharp fa-regular fa-arrow-up-right fa-fw',
        'fa-sharp fa-regular fa-arrow-up-long fa-fw',
        'fa-sharp fa-regular fa-arrow-up-left-from-circle fa-fw',
        'fa-sharp fa-regular fa-arrow-up-left fa-fw',
        'fa-sharp fa-regular fa-arrow-up-from-square fa-fw',
        'fa-sharp fa-regular fa-arrow-up-from-line fa-fw',
        'fa-sharp fa-regular fa-arrow-up-from-dotted-line fa-fw',
        'fa-sharp fa-regular fa-arrow-up-from-arc fa-fw',
        'fa-sharp fa-regular fa-arrow-up-big-small fa-fw',
        'fa-sharp fa-regular fa-arrow-up-arrow-down fa-fw',
        'fa-sharp fa-regular fa-arrow-up-a-z fa-fw',
        'fa-sharp fa-regular fa-arrow-up-9-1 fa-fw',
        'fa-sharp fa-regular fa-arrow-up-1-9 fa-fw',
        'fa-sharp fa-regular fa-arrow-turn-up fa-fw',
        'fa-sharp fa-regular fa-arrow-turn-down-right fa-fw',
        'fa-sharp fa-regular fa-arrow-turn-down-left fa-fw',
        'fa-sharp fa-regular fa-arrow-turn-down fa-fw',
        'fa-sharp fa-regular fa-arrow-trend-up fa-fw',
        'fa-sharp fa-regular fa-arrow-trend-down fa-fw',
        'fa-sharp fa-regular fa-arrow-rotate-right fa-fw',
        'fa-sharp fa-regular fa-arrow-rotate-left fa-fw',
        'fa-sharp fa-regular fa-arrow-right-to-line fa-fw',
        'fa-sharp fa-regular fa-arrow-right-to-bracket fa-fw',
        'fa-sharp fa-regular fa-arrow-right-to-arc fa-fw',
        'fa-sharp fa-regular fa-arrow-right-long-to-line fa-fw',
        'fa-sharp fa-regular fa-arrow-right-long fa-fw',
        'fa-sharp fa-regular fa-arrow-right-from-line fa-fw',
        'fa-sharp fa-regular fa-arrow-right-from-bracket fa-fw',
        'fa-sharp fa-regular fa-arrow-right-from-arc fa-fw',
        'fa-sharp fa-regular fa-arrow-right-arrow-left fa-fw',
        'fa-sharp fa-regular fa-arrow-progress fa-fw',
        'fa-sharp fa-regular fa-arrow-pointer fa-fw',
        'fa-sharp fa-regular fa-arrow-left-to-line fa-fw',
        'fa-sharp fa-regular fa-arrow-left-long-to-line fa-fw',
        'fa-sharp fa-regular fa-arrow-left-long fa-fw',
        'fa-sharp fa-regular fa-arrow-left-from-line fa-fw',
        'fa-sharp fa-regular fa-arrow-down-z-a fa-fw',
        'fa-sharp fa-regular fa-arrow-down-wide-short fa-fw',
        'fa-sharp fa-regular fa-arrow-down-up-lock fa-fw',
        'fa-sharp fa-regular fa-arrow-down-up-across-line fa-fw',
        'fa-sharp fa-regular fa-arrow-down-triangle-square fa-fw',
        'fa-sharp fa-regular fa-arrow-down-to-square fa-fw',
        'fa-sharp fa-regular fa-arrow-down-to-dotted-line fa-fw',
        'fa-sharp fa-regular fa-arrow-down-to-bracket fa-fw',
        'fa-sharp fa-regular fa-arrow-down-to-arc fa-fw',
        'fa-sharp fa-regular fa-arrow-down-square-triangle fa-fw',
        'fa-sharp fa-regular fa-arrow-down-small-big fa-fw',
        'fa-sharp fa-regular fa-arrow-down-short-wide fa-fw',
        'fa-sharp fa-regular fa-arrow-down-right fa-fw',
        'fa-sharp fa-regular fa-arrow-down-long fa-fw',
        'fa-sharp fa-regular fa-arrow-down-left-and-arrow-up-right-to-center fa-fw',
        'fa-sharp fa-regular fa-arrow-down-left fa-fw',
        'fa-sharp fa-regular fa-arrow-down-from-line fa-fw',
        'fa-sharp fa-regular fa-arrow-down-from-dotted-line fa-fw',
        'fa-sharp fa-regular fa-arrow-down-big-small fa-fw',
        'fa-sharp fa-regular fa-arrow-down-arrow-up fa-fw',
        'fa-sharp fa-regular fa-arrow-down-a-z fa-fw',
        'fa-sharp fa-regular fa-arrow-down-9-1 fa-fw',
        'fa-sharp fa-regular fa-arrow-down-1-9 fa-fw',
        'fa-sharp fa-regular fa-angles-up fa-fw',
        'fa-sharp fa-regular fa-angles-right fa-fw',
        'fa-sharp fa-regular fa-angles-left fa-fw',
        'fa-sharp fa-regular fa-angles-down fa-fw',
        'fa-sharp fa-regular fa-angle-right fa-fw',
        'fa-sharp fa-regular fa-angle-left fa-fw',
        'fa-sharp fa-regular fa-angle-down fa-fw',
        'fa-sharp fa-light fa-up-to-line fa-fw',
        'fa-sharp fa-light fa-up-to-dotted-line fa-fw',
        'fa-sharp fa-light fa-up-right-from-square fa-fw',
        'fa-sharp fa-light fa-up-right-and-down-left-from-center fa-fw',
        'fa-sharp fa-light fa-up-right fa-fw',
        'fa-sharp fa-light fa-up-long fa-fw',
        'fa-sharp fa-light fa-up-left fa-fw',
        'fa-sharp fa-light fa-up-from-line fa-fw',
        'fa-sharp fa-light fa-up-from-dotted-line fa-fw',
        'fa-sharp fa-light fa-up-from-bracket fa-fw',
        'fa-sharp fa-light fa-up-down-left-right fa-fw',
        'fa-sharp fa-light fa-up-down fa-fw',
        'fa-sharp fa-light fa-up fa-fw',
        'fa-sharp fa-light fa-turn-up fa-fw',
        'fa-sharp fa-light fa-turn-down-right fa-fw',
        'fa-sharp fa-light fa-turn-down-left fa-fw',
        'fa-sharp fa-light fa-turn-down fa-fw',
        'fa-sharp fa-light fa-square-up-right fa-fw',
        'fa-sharp fa-light fa-square-up-left fa-fw',
        'fa-sharp fa-light fa-square-up fa-fw',
        'fa-sharp fa-light fa-square-right fa-fw',
        'fa-sharp fa-light fa-square-left fa-fw',
        'fa-sharp fa-light fa-square-down-right fa-fw',
        'fa-sharp fa-light fa-square-down-left fa-fw',
        'fa-sharp fa-light fa-square-down fa-fw',
        'fa-sharp fa-light fa-square-chevron-up fa-fw',
        'fa-sharp fa-light fa-square-chevron-right fa-fw',
        'fa-sharp fa-light fa-square-chevron-left fa-fw',
        'fa-sharp fa-light fa-square-chevron-down fa-fw',
        'fa-sharp fa-light fa-square-caret-up fa-fw',
        'fa-sharp fa-light fa-square-caret-right fa-fw',
        'fa-sharp fa-light fa-square-caret-left fa-fw',
        'fa-sharp fa-light fa-square-caret-down fa-fw',
        'fa-sharp fa-light fa-square-arrow-up-right fa-fw',
        'fa-sharp fa-light fa-square-arrow-up-left fa-fw',
        'fa-sharp fa-light fa-square-arrow-up fa-fw',
        'fa-sharp fa-light fa-square-arrow-right fa-fw',
        'fa-sharp fa-light fa-square-arrow-left fa-fw',
        'fa-sharp fa-light fa-square-arrow-down-right fa-fw',
        'fa-sharp fa-light fa-square-arrow-down-left fa-fw',
        'fa-sharp fa-light fa-square-arrow-down fa-fw',
        'fa-sharp fa-light fa-split fa-fw',
        'fa-sharp fa-light fa-sort-up fa-fw',
        'fa-sharp fa-light fa-sort-down fa-fw',
        'fa-sharp fa-light fa-shuffle fa-fw',
        'fa-sharp fa-light fa-share-all fa-fw',
        'fa-sharp fa-light fa-rotate-left fa-fw',
        'fa-sharp fa-light fa-rotate fa-fw',
        'fa-sharp fa-light fa-right-to-line fa-fw',
        'fa-sharp fa-light fa-right-long-to-line fa-fw',
        'fa-sharp fa-light fa-right-long fa-fw',
        'fa-sharp fa-light fa-right-left-large fa-fw',
        'fa-sharp fa-light fa-right-left fa-fw',
        'fa-sharp fa-light fa-right-from-line fa-fw',
        'fa-sharp fa-light fa-right-from-bracket fa-fw',
        'fa-sharp fa-light fa-right fa-fw',
        'fa-sharp fa-light fa-retweet fa-fw',
        'fa-sharp fa-light fa-reply-all fa-fw',
        'fa-sharp fa-light fa-repeat-1 fa-fw',
        'fa-sharp fa-light fa-merge fa-fw',
        'fa-sharp fa-light fa-maximize fa-fw',
        'fa-sharp fa-light fa-location-arrow fa-fw',
        'fa-sharp fa-light fa-left-to-line fa-fw',
        'fa-sharp fa-light fa-left-right fa-fw',
        'fa-sharp fa-light fa-left-long-to-line fa-fw',
        'fa-sharp fa-light fa-left-long fa-fw',
        'fa-sharp fa-light fa-left-from-line fa-fw',
        'fa-sharp fa-light fa-left fa-fw',
        'fa-sharp fa-light fa-inbox-out fa-fw',
        'fa-sharp fa-light fa-inbox-in fa-fw',
        'fa-sharp fa-light fa-down-to-line fa-fw',
        'fa-sharp fa-light fa-down-to-dotted-line fa-fw',
        'fa-sharp fa-light fa-down-to-bracket fa-fw',
        'fa-sharp fa-light fa-down-right fa-fw',
        'fa-sharp fa-light fa-down-long fa-fw',
        'fa-sharp fa-light fa-down-left-and-up-right-to-center fa-fw',
        'fa-sharp fa-light fa-down-left fa-fw',
        'fa-sharp fa-light fa-down-from-line fa-fw',
        'fa-sharp fa-light fa-down-from-dotted-line fa-fw',
        'fa-sharp fa-light fa-down fa-fw',
        'fa-sharp fa-light fa-cloud-arrow-down fa-fw',
        'fa-sharp fa-light fa-clock-rotate-left fa-fw',
        'fa-sharp fa-light fa-circle-up-right fa-fw',
        'fa-sharp fa-light fa-circle-up-left fa-fw',
        'fa-sharp fa-light fa-circle-right fa-fw',
        'fa-sharp fa-light fa-circle-left fa-fw',
        'fa-sharp fa-light fa-circle-down-right fa-fw',
        'fa-sharp fa-light fa-circle-down-left fa-fw',
        'fa-sharp fa-light fa-circle-chevron-up fa-fw',
        'fa-sharp fa-light fa-circle-chevron-right fa-fw',
        'fa-sharp fa-light fa-circle-chevron-left fa-fw',
        'fa-sharp fa-light fa-circle-chevron-down fa-fw',
        'fa-sharp fa-light fa-circle-caret-up fa-fw',
        'fa-sharp fa-light fa-circle-caret-right fa-fw',
        'fa-sharp fa-light fa-circle-caret-left fa-fw',
        'fa-sharp fa-light fa-circle-caret-down fa-fw',
        'fa-sharp fa-light fa-circle-arrow-up-right fa-fw',
        'fa-sharp fa-light fa-circle-arrow-up-left fa-fw',
        'fa-sharp fa-light fa-circle-arrow-up fa-fw',
        'fa-sharp fa-light fa-circle-arrow-right fa-fw',
        'fa-sharp fa-light fa-circle-arrow-left fa-fw',
        'fa-sharp fa-light fa-circle-arrow-down-right fa-fw',
        'fa-sharp fa-light fa-circle-arrow-down-left fa-fw',
        'fa-sharp fa-light fa-circle-arrow-down fa-fw',
        'fa-sharp fa-light fa-chevrons-up fa-fw',
        'fa-sharp fa-light fa-chevrons-right fa-fw',
        'fa-sharp fa-light fa-chevrons-left fa-fw',
        'fa-sharp fa-light fa-chevrons-down fa-fw',
        'fa-sharp fa-light fa-chevron-right fa-fw',
        'fa-sharp fa-light fa-chevron-left fa-fw',
        'fa-sharp fa-light fa-caret-right fa-fw',
        'fa-sharp fa-light fa-caret-left fa-fw',
        'fa-sharp fa-light fa-arrows-up-to-line fa-fw',
        'fa-sharp fa-light fa-arrows-up-down-left-right fa-fw',
        'fa-sharp fa-light fa-arrows-up-down fa-fw',
        'fa-sharp fa-light fa-arrows-turn-to-dots fa-fw',
      ],
    },

    {
      title: 'Automotive',
      items: [
        'fa-solid fa-car fa-fw',
        'fa-regular fa-car fa-fw',
        'fa-light fa-car fa-fw',
        'fa-thin fa-car fa-fw',
        'fa-duotone fa-car fa-fw',
        'fa-sharp fa-solid fa-car fa-fw',
        'fa-sharp fa-regular fa-car fa-fw',
        'fa-sharp fa-light fa-car fa-fw',
        'fa-solid fa-truck fa-fw',
        'fa-regular fa-truck fa-fw',
        'fa-light fa-truck fa-fw',
        'fa-thin fa-truck fa-fw',
        'fa-duotone fa-truck fa-fw',
        'fa-sharp fa-solid fa-truck fa-fw',
        'fa-sharp fa-regular fa-truck fa-fw',
        'fa-sharp fa-light fa-truck fa-fw',
        'fa-solid fa-gauge fa-fw',
        'fa-regular fa-gauge fa-fw',
        'fa-light fa-gauge fa-fw',
        'fa-thin fa-gauge fa-fw',
        'fa-duotone fa-gauge fa-fw',
        'fa-sharp fa-solid fa-gauge fa-fw',
        'fa-sharp fa-regular fa-gauge fa-fw',
        'fa-sharp fa-light fa-gauge fa-fw',
        'fa-solid fa-car-side fa-fw',
        'fa-regular fa-car-side fa-fw',
        'fa-light fa-car-side fa-fw',
        'fa-thin fa-car-side fa-fw',
        'fa-duotone fa-car-side fa-fw',
        'fa-sharp fa-solid fa-car-side fa-fw',
        'fa-sharp fa-regular fa-car-side fa-fw',
        'fa-sharp fa-light fa-car-side fa-fw',
        'fa-solid fa-moped fa-fw',
        'fa-regular fa-moped fa-fw',
        'fa-light fa-moped fa-fw',
        'fa-thin fa-moped fa-fw',
        'fa-duotone fa-moped fa-fw',
        'fa-sharp fa-solid fa-moped fa-fw',
        'fa-sharp fa-regular fa-moped fa-fw',
        'fa-sharp fa-light fa-moped fa-fw',
        'fa-solid fa-car-building fa-fw',
        'fa-regular fa-car-building fa-fw',
        'fa-light fa-car-building fa-fw',
        'fa-thin fa-car-building fa-fw',
        'fa-duotone fa-car-building fa-fw',
        'fa-sharp fa-solid fa-car-building fa-fw',
        'fa-sharp fa-regular fa-car-building fa-fw',
        'fa-sharp fa-light fa-car-building fa-fw',
        'fa-solid fa-motorcycle fa-fw',
        'fa-regular fa-motorcycle fa-fw',
        'fa-light fa-motorcycle fa-fw',
        'fa-thin fa-motorcycle fa-fw',
        'fa-duotone fa-motorcycle fa-fw',
        'fa-sharp fa-solid fa-motorcycle fa-fw',
        'fa-sharp fa-regular fa-motorcycle fa-fw',
        'fa-sharp fa-light fa-motorcycle fa-fw',
        'fa-solid fa-truck-monster fa-fw',
        'fa-regular fa-truck-monster fa-fw',
        'fa-light fa-truck-monster fa-fw',
        'fa-thin fa-truck-monster fa-fw',
        'fa-duotone fa-truck-monster fa-fw',
        'fa-sharp fa-solid fa-truck-monster fa-fw',
        'fa-sharp fa-regular fa-truck-monster fa-fw',
        'fa-sharp fa-light fa-truck-monster fa-fw',
        'fa-solid fa-wagon-covered fa-fw',
        'fa-regular fa-wagon-covered fa-fw',
        'fa-light fa-wagon-covered fa-fw',
        'fa-thin fa-wagon-covered fa-fw',
        'fa-duotone fa-wagon-covered fa-fw',
        'fa-sharp fa-solid fa-wagon-covered fa-fw',
        'fa-sharp fa-regular fa-wagon-covered fa-fw',
        'fa-sharp fa-light fa-wagon-covered fa-fw',
        'fa-solid fa-engine-warning fa-fw',
        'fa-regular fa-engine-warning fa-fw',
        'fa-light fa-engine-warning fa-fw',
        'fa-thin fa-engine-warning fa-fw',
        'fa-duotone fa-engine-warning fa-fw',
        'fa-sharp fa-solid fa-engine-warning fa-fw',
        'fa-sharp fa-regular fa-engine-warning fa-fw',
        'fa-sharp fa-light fa-engine-warning fa-fw',
        'fa-solid fa-van-shuttle fa-fw',
        'fa-solid fa-truck-pickup fa-fw',
        'fa-solid fa-truck-medical fa-fw',
        'fa-solid fa-truck-field-un fa-fw',
        'fa-solid fa-truck-field fa-fw',
        'fa-solid fa-truck-bolt fa-fw',
        'fa-solid fa-trailer fa-fw',
        'fa-solid fa-tire-rugged fa-fw',
        'fa-solid fa-tire-pressure-warning fa-fw',
        'fa-solid fa-tire-flat fa-fw',
        'fa-solid fa-tire fa-fw',
        'fa-solid fa-taxi fa-fw',
        'fa-solid fa-tank-water fa-fw',
        'fa-solid fa-steering-wheel fa-fw',
        'fa-solid fa-spray-can-sparkles fa-fw',
        'fa-solid fa-rv fa-fw',
        'fa-solid fa-pump fa-fw',
        'fa-solid fa-oil-temperature fa-fw',
        'fa-solid fa-oil-can-drip fa-fw',
        'fa-solid fa-oil-can fa-fw',
        'fa-solid fa-gauge-simple-min fa-fw',
        'fa-solid fa-gauge-simple-max fa-fw',
        'fa-solid fa-gauge-simple-low fa-fw',
        'fa-solid fa-gauge-simple-high fa-fw',
        'fa-solid fa-gauge-simple fa-fw',
        'fa-solid fa-gauge-min fa-fw',
        'fa-solid fa-gauge-max fa-fw',
        'fa-solid fa-gauge-low fa-fw',
        'fa-solid fa-gauge-high fa-fw',
        'fa-solid fa-gauge-circle-plus fa-fw',
        'fa-solid fa-gauge-circle-minus fa-fw',
        'fa-solid fa-gauge-circle-bolt fa-fw',
        'fa-solid fa-gas-pump-slash fa-fw',
        'fa-solid fa-gas-pump fa-fw',
        'fa-solid fa-garage-open fa-fw',
        'fa-solid fa-garage-car fa-fw',
        'fa-solid fa-garage fa-fw',
        'fa-solid fa-flux-capacitor fa-fw',
        'fa-solid fa-engine fa-fw',
        'fa-solid fa-charging-station fa-fw',
        'fa-solid fa-cars fa-fw',
        'fa-solid fa-caravan-simple fa-fw',
        'fa-solid fa-caravan fa-fw',
        'fa-solid fa-car-wrench fa-fw',
        'fa-solid fa-car-wash fa-fw',
        'fa-solid fa-car-tunnel fa-fw',
        'fa-solid fa-car-tilt fa-fw',
        'fa-solid fa-car-side-bolt fa-fw',
        'fa-solid fa-car-rear fa-fw',
        'fa-solid fa-car-on fa-fw',
        'fa-solid fa-car-mirrors fa-fw',
        'fa-solid fa-car-garage fa-fw',
        'fa-solid fa-car-circle-bolt fa-fw',
        'fa-solid fa-car-bus fa-fw',
        'fa-solid fa-car-burst fa-fw',
        'fa-solid fa-car-bump fa-fw',
        'fa-solid fa-car-bolt fa-fw',
        'fa-solid fa-car-battery fa-fw',
        'fa-solid fa-bus-simple fa-fw',
        'fa-solid fa-bus fa-fw',
        'fa-solid fa-brake-warning fa-fw',
        'fa-regular fa-van-shuttle fa-fw',
        'fa-regular fa-truck-pickup fa-fw',
        'fa-regular fa-truck-medical fa-fw',
        'fa-regular fa-truck-field-un fa-fw',
        'fa-regular fa-truck-field fa-fw',
        'fa-regular fa-truck-bolt fa-fw',
        'fa-regular fa-trailer fa-fw',
        'fa-regular fa-tire-rugged fa-fw',
        'fa-regular fa-tire-pressure-warning fa-fw',
        'fa-regular fa-tire-flat fa-fw',
        'fa-regular fa-tire fa-fw',
        'fa-regular fa-taxi fa-fw',
        'fa-regular fa-tank-water fa-fw',
        'fa-regular fa-steering-wheel fa-fw',
        'fa-regular fa-spray-can-sparkles fa-fw',
        'fa-regular fa-rv fa-fw',
        'fa-regular fa-pump fa-fw',
        'fa-regular fa-oil-temperature fa-fw',
        'fa-regular fa-oil-can-drip fa-fw',
        'fa-regular fa-oil-can fa-fw',
        'fa-regular fa-gauge-simple-min fa-fw',
        'fa-regular fa-gauge-simple-max fa-fw',
        'fa-regular fa-gauge-simple-low fa-fw',
        'fa-regular fa-gauge-simple-high fa-fw',
        'fa-regular fa-gauge-simple fa-fw',
        'fa-regular fa-gauge-min fa-fw',
        'fa-regular fa-gauge-max fa-fw',
        'fa-regular fa-gauge-low fa-fw',
        'fa-regular fa-gauge-high fa-fw',
        'fa-regular fa-gauge-circle-plus fa-fw',
        'fa-regular fa-gauge-circle-minus fa-fw',
        'fa-regular fa-gauge-circle-bolt fa-fw',
        'fa-regular fa-gas-pump-slash fa-fw',
        'fa-regular fa-gas-pump fa-fw',
        'fa-regular fa-garage-open fa-fw',
        'fa-regular fa-garage-car fa-fw',
        'fa-regular fa-garage fa-fw',
        'fa-regular fa-flux-capacitor fa-fw',
        'fa-regular fa-engine fa-fw',
        'fa-regular fa-charging-station fa-fw',
        'fa-regular fa-cars fa-fw',
        'fa-regular fa-caravan-simple fa-fw',
        'fa-regular fa-caravan fa-fw',
        'fa-regular fa-car-wrench fa-fw',
        'fa-regular fa-car-wash fa-fw',
        'fa-regular fa-car-tunnel fa-fw',
        'fa-regular fa-car-tilt fa-fw',
        'fa-regular fa-car-side-bolt fa-fw',
        'fa-regular fa-car-rear fa-fw',
        'fa-regular fa-car-on fa-fw',
        'fa-regular fa-car-mirrors fa-fw',
        'fa-regular fa-car-garage fa-fw',
        'fa-regular fa-car-circle-bolt fa-fw',
        'fa-regular fa-car-bus fa-fw',
        'fa-regular fa-car-burst fa-fw',
        'fa-regular fa-car-bump fa-fw',
        'fa-regular fa-car-bolt fa-fw',
        'fa-regular fa-car-battery fa-fw',
        'fa-regular fa-bus-simple fa-fw',
        'fa-regular fa-bus fa-fw',
        'fa-regular fa-brake-warning fa-fw',
        'fa-light fa-van-shuttle fa-fw',
        'fa-light fa-truck-pickup fa-fw',
        'fa-light fa-truck-medical fa-fw',
        'fa-light fa-truck-field-un fa-fw',
        'fa-light fa-truck-field fa-fw',
        'fa-light fa-truck-bolt fa-fw',
        'fa-light fa-trailer fa-fw',
        'fa-light fa-tire-rugged fa-fw',
        'fa-light fa-tire-pressure-warning fa-fw',
        'fa-light fa-tire-flat fa-fw',
        'fa-light fa-tire fa-fw',
        'fa-light fa-taxi fa-fw',
        'fa-light fa-tank-water fa-fw',
        'fa-light fa-steering-wheel fa-fw',
        'fa-light fa-spray-can-sparkles fa-fw',
        'fa-light fa-rv fa-fw',
        'fa-light fa-pump fa-fw',
        'fa-light fa-oil-temperature fa-fw',
        'fa-light fa-oil-can-drip fa-fw',
        'fa-light fa-oil-can fa-fw',
        'fa-light fa-gauge-simple-min fa-fw',
        'fa-light fa-gauge-simple-max fa-fw',
        'fa-light fa-gauge-simple-low fa-fw',
        'fa-light fa-gauge-simple-high fa-fw',
        'fa-light fa-gauge-simple fa-fw',
        'fa-light fa-gauge-min fa-fw',
        'fa-light fa-gauge-max fa-fw',
        'fa-light fa-gauge-low fa-fw',
        'fa-light fa-gauge-high fa-fw',
        'fa-light fa-gauge-circle-plus fa-fw',
        'fa-light fa-gauge-circle-minus fa-fw',
        'fa-light fa-gauge-circle-bolt fa-fw',
        'fa-light fa-gas-pump-slash fa-fw',
        'fa-light fa-gas-pump fa-fw',
        'fa-light fa-garage-open fa-fw',
        'fa-light fa-garage-car fa-fw',
        'fa-light fa-garage fa-fw',
        'fa-light fa-flux-capacitor fa-fw',
        'fa-light fa-engine fa-fw',
        'fa-light fa-charging-station fa-fw',
        'fa-light fa-cars fa-fw',
        'fa-light fa-caravan-simple fa-fw',
        'fa-light fa-caravan fa-fw',
        'fa-light fa-car-wrench fa-fw',
        'fa-light fa-car-wash fa-fw',
        'fa-light fa-car-tunnel fa-fw',
        'fa-light fa-car-tilt fa-fw',
        'fa-light fa-car-side-bolt fa-fw',
        'fa-light fa-car-rear fa-fw',
        'fa-light fa-car-on fa-fw',
        'fa-light fa-car-mirrors fa-fw',
        'fa-light fa-car-garage fa-fw',
        'fa-light fa-car-circle-bolt fa-fw',
        'fa-light fa-car-bus fa-fw',
        'fa-light fa-car-burst fa-fw',
        'fa-light fa-car-bump fa-fw',
        'fa-light fa-car-bolt fa-fw',
        'fa-light fa-car-battery fa-fw',
        'fa-light fa-bus-simple fa-fw',
        'fa-light fa-bus fa-fw',
        'fa-light fa-brake-warning fa-fw',
        'fa-thin fa-van-shuttle fa-fw',
        'fa-thin fa-truck-pickup fa-fw',
        'fa-thin fa-truck-medical fa-fw',
        'fa-thin fa-truck-field-un fa-fw',
        'fa-thin fa-truck-field fa-fw',
        'fa-thin fa-truck-bolt fa-fw',
        'fa-thin fa-trailer fa-fw',
        'fa-thin fa-tire-rugged fa-fw',
        'fa-thin fa-tire-pressure-warning fa-fw',
        'fa-thin fa-tire-flat fa-fw',
        'fa-thin fa-tire fa-fw',
        'fa-thin fa-taxi fa-fw',
        'fa-thin fa-tank-water fa-fw',
        'fa-thin fa-steering-wheel fa-fw',
        'fa-thin fa-spray-can-sparkles fa-fw',
        'fa-thin fa-rv fa-fw',
        'fa-thin fa-pump fa-fw',
        'fa-thin fa-oil-temperature fa-fw',
        'fa-thin fa-oil-can-drip fa-fw',
        'fa-thin fa-oil-can fa-fw',
        'fa-thin fa-gauge-simple-min fa-fw',
        'fa-thin fa-gauge-simple-max fa-fw',
        'fa-thin fa-gauge-simple-low fa-fw',
        'fa-thin fa-gauge-simple-high fa-fw',
        'fa-thin fa-gauge-simple fa-fw',
        'fa-thin fa-gauge-min fa-fw',
        'fa-thin fa-gauge-max fa-fw',
        'fa-thin fa-gauge-low fa-fw',
        'fa-thin fa-gauge-high fa-fw',
        'fa-thin fa-gauge-circle-plus fa-fw',
        'fa-thin fa-gauge-circle-minus fa-fw',
        'fa-thin fa-gauge-circle-bolt fa-fw',
        'fa-thin fa-gas-pump-slash fa-fw',
        'fa-thin fa-gas-pump fa-fw',
        'fa-thin fa-garage-open fa-fw',
        'fa-thin fa-garage-car fa-fw',
        'fa-thin fa-garage fa-fw',
        'fa-thin fa-flux-capacitor fa-fw',
        'fa-thin fa-engine fa-fw',
        'fa-thin fa-charging-station fa-fw',
        'fa-thin fa-cars fa-fw',
        'fa-thin fa-caravan-simple fa-fw',
        'fa-thin fa-caravan fa-fw',
        'fa-thin fa-car-wrench fa-fw',
        'fa-thin fa-car-wash fa-fw',
        'fa-thin fa-car-tunnel fa-fw',
        'fa-thin fa-car-tilt fa-fw',
        'fa-thin fa-car-side-bolt fa-fw',
        'fa-thin fa-car-rear fa-fw',
        'fa-thin fa-car-on fa-fw',
        'fa-thin fa-car-mirrors fa-fw',
        'fa-thin fa-car-garage fa-fw',
        'fa-thin fa-car-circle-bolt fa-fw',
        'fa-thin fa-car-bus fa-fw',
        'fa-thin fa-car-burst fa-fw',
        'fa-thin fa-car-bump fa-fw',
        'fa-thin fa-car-bolt fa-fw',
        'fa-thin fa-car-battery fa-fw',
        'fa-thin fa-bus-simple fa-fw',
        'fa-thin fa-bus fa-fw',
        'fa-thin fa-brake-warning fa-fw',
        'fa-duotone fa-van-shuttle fa-fw',
        'fa-duotone fa-truck-pickup fa-fw',
        'fa-duotone fa-truck-medical fa-fw',
        'fa-duotone fa-truck-field-un fa-fw',
        'fa-duotone fa-truck-field fa-fw',
        'fa-duotone fa-truck-bolt fa-fw',
        'fa-duotone fa-trailer fa-fw',
        'fa-duotone fa-tire-rugged fa-fw',
        'fa-duotone fa-tire-pressure-warning fa-fw',
        'fa-duotone fa-tire-flat fa-fw',
        'fa-duotone fa-tire fa-fw',
        'fa-duotone fa-taxi fa-fw',
        'fa-duotone fa-tank-water fa-fw',
        'fa-duotone fa-steering-wheel fa-fw',
        'fa-duotone fa-spray-can-sparkles fa-fw',
        'fa-duotone fa-rv fa-fw',
        'fa-duotone fa-pump fa-fw',
        'fa-duotone fa-oil-temperature fa-fw',
        'fa-duotone fa-oil-can-drip fa-fw',
        'fa-duotone fa-oil-can fa-fw',
        'fa-duotone fa-gauge-simple-min fa-fw',
        'fa-duotone fa-gauge-simple-max fa-fw',
        'fa-duotone fa-gauge-simple-low fa-fw',
        'fa-duotone fa-gauge-simple-high fa-fw',
        'fa-duotone fa-gauge-simple fa-fw',
        'fa-duotone fa-gauge-min fa-fw',
        'fa-duotone fa-gauge-max fa-fw',
        'fa-duotone fa-gauge-low fa-fw',
        'fa-duotone fa-gauge-high fa-fw',
        'fa-duotone fa-gauge-circle-plus fa-fw',
        'fa-duotone fa-gauge-circle-minus fa-fw',
        'fa-duotone fa-gauge-circle-bolt fa-fw',
        'fa-duotone fa-gas-pump-slash fa-fw',
        'fa-duotone fa-gas-pump fa-fw',
        'fa-duotone fa-garage-open fa-fw',
        'fa-duotone fa-garage-car fa-fw',
        'fa-duotone fa-garage fa-fw',
        'fa-duotone fa-flux-capacitor fa-fw',
        'fa-duotone fa-engine fa-fw',
        'fa-duotone fa-charging-station fa-fw',
        'fa-duotone fa-cars fa-fw',
        'fa-duotone fa-caravan-simple fa-fw',
        'fa-duotone fa-caravan fa-fw',
        'fa-duotone fa-car-wrench fa-fw',
        'fa-duotone fa-car-wash fa-fw',
        'fa-duotone fa-car-tunnel fa-fw',
        'fa-duotone fa-car-tilt fa-fw',
        'fa-duotone fa-car-side-bolt fa-fw',
        'fa-duotone fa-car-rear fa-fw',
        'fa-duotone fa-car-on fa-fw',
        'fa-duotone fa-car-mirrors fa-fw',
        'fa-duotone fa-car-garage fa-fw',
        'fa-duotone fa-car-circle-bolt fa-fw',
        'fa-duotone fa-car-bus fa-fw',
        'fa-duotone fa-car-burst fa-fw',
        'fa-duotone fa-car-bump fa-fw',
        'fa-duotone fa-car-bolt fa-fw',
        'fa-duotone fa-car-battery fa-fw',
        'fa-duotone fa-bus-simple fa-fw',
        'fa-duotone fa-bus fa-fw',
        'fa-duotone fa-brake-warning fa-fw',
        'fa-sharp fa-solid fa-van-shuttle fa-fw',
        'fa-sharp fa-solid fa-truck-pickup fa-fw',
        'fa-sharp fa-solid fa-truck-medical fa-fw',
        'fa-sharp fa-solid fa-truck-field-un fa-fw',
        'fa-sharp fa-solid fa-truck-field fa-fw',
        'fa-sharp fa-solid fa-truck-bolt fa-fw',
        'fa-sharp fa-solid fa-trailer fa-fw',
        'fa-sharp fa-solid fa-tire-rugged fa-fw',
        'fa-sharp fa-solid fa-tire-pressure-warning fa-fw',
        'fa-sharp fa-solid fa-tire-flat fa-fw',
        'fa-sharp fa-solid fa-tire fa-fw',
        'fa-sharp fa-solid fa-taxi fa-fw',
        'fa-sharp fa-solid fa-tank-water fa-fw',
        'fa-sharp fa-solid fa-steering-wheel fa-fw',
        'fa-sharp fa-solid fa-spray-can-sparkles fa-fw',
        'fa-sharp fa-solid fa-rv fa-fw',
        'fa-sharp fa-solid fa-pump fa-fw',
        'fa-sharp fa-solid fa-oil-temperature fa-fw',
        'fa-sharp fa-solid fa-oil-can-drip fa-fw',
        'fa-sharp fa-solid fa-oil-can fa-fw',
        'fa-sharp fa-solid fa-gauge-simple-min fa-fw',
        'fa-sharp fa-solid fa-gauge-simple-max fa-fw',
        'fa-sharp fa-solid fa-gauge-simple-low fa-fw',
        'fa-sharp fa-solid fa-gauge-simple-high fa-fw',
        'fa-sharp fa-solid fa-gauge-simple fa-fw',
        'fa-sharp fa-solid fa-gauge-min fa-fw',
        'fa-sharp fa-solid fa-gauge-max fa-fw',
        'fa-sharp fa-solid fa-gauge-low fa-fw',
        'fa-sharp fa-solid fa-gauge-high fa-fw',
        'fa-sharp fa-solid fa-gauge-circle-plus fa-fw',
        'fa-sharp fa-solid fa-gauge-circle-minus fa-fw',
        'fa-sharp fa-solid fa-gauge-circle-bolt fa-fw',
        'fa-sharp fa-solid fa-gas-pump-slash fa-fw',
        'fa-sharp fa-solid fa-gas-pump fa-fw',
        'fa-sharp fa-solid fa-garage-open fa-fw',
        'fa-sharp fa-solid fa-garage-car fa-fw',
        'fa-sharp fa-solid fa-garage fa-fw',
        'fa-sharp fa-solid fa-flux-capacitor fa-fw',
        'fa-sharp fa-solid fa-engine fa-fw',
        'fa-sharp fa-solid fa-charging-station fa-fw',
        'fa-sharp fa-solid fa-cars fa-fw',
        'fa-sharp fa-solid fa-caravan-simple fa-fw',
        'fa-sharp fa-solid fa-caravan fa-fw',
        'fa-sharp fa-solid fa-car-wrench fa-fw',
        'fa-sharp fa-solid fa-car-wash fa-fw',
        'fa-sharp fa-solid fa-car-tunnel fa-fw',
        'fa-sharp fa-solid fa-car-tilt fa-fw',
        'fa-sharp fa-solid fa-car-side-bolt fa-fw',
        'fa-sharp fa-solid fa-car-rear fa-fw',
        'fa-sharp fa-solid fa-car-on fa-fw',
        'fa-sharp fa-solid fa-car-mirrors fa-fw',
        'fa-sharp fa-solid fa-car-garage fa-fw',
        'fa-sharp fa-solid fa-car-circle-bolt fa-fw',
        'fa-sharp fa-solid fa-car-bus fa-fw',
        'fa-sharp fa-solid fa-car-burst fa-fw',
        'fa-sharp fa-solid fa-car-bump fa-fw',
        'fa-sharp fa-solid fa-car-bolt fa-fw',
        'fa-sharp fa-solid fa-car-battery fa-fw',
        'fa-sharp fa-solid fa-bus-simple fa-fw',
        'fa-sharp fa-solid fa-bus fa-fw',
        'fa-sharp fa-solid fa-brake-warning fa-fw',
        'fa-sharp fa-regular fa-van-shuttle fa-fw',
        'fa-sharp fa-regular fa-truck-pickup fa-fw',
        'fa-sharp fa-regular fa-truck-medical fa-fw',
        'fa-sharp fa-regular fa-truck-field-un fa-fw',
        'fa-sharp fa-regular fa-truck-field fa-fw',
        'fa-sharp fa-regular fa-truck-bolt fa-fw',
        'fa-sharp fa-regular fa-trailer fa-fw',
        'fa-sharp fa-regular fa-tire-rugged fa-fw',
        'fa-sharp fa-regular fa-tire-pressure-warning fa-fw',
        'fa-sharp fa-regular fa-tire-flat fa-fw',
        'fa-sharp fa-regular fa-tire fa-fw',
        'fa-sharp fa-regular fa-taxi fa-fw',
        'fa-sharp fa-regular fa-tank-water fa-fw',
        'fa-sharp fa-regular fa-steering-wheel fa-fw',
        'fa-sharp fa-regular fa-spray-can-sparkles fa-fw',
        'fa-sharp fa-regular fa-rv fa-fw',
        'fa-sharp fa-regular fa-pump fa-fw',
        'fa-sharp fa-regular fa-oil-temperature fa-fw',
        'fa-sharp fa-regular fa-oil-can-drip fa-fw',
        'fa-sharp fa-regular fa-oil-can fa-fw',
        'fa-sharp fa-regular fa-gauge-simple-min fa-fw',
        'fa-sharp fa-regular fa-gauge-simple-max fa-fw',
        'fa-sharp fa-regular fa-gauge-simple-low fa-fw',
        'fa-sharp fa-regular fa-gauge-simple-high fa-fw',
        'fa-sharp fa-regular fa-gauge-simple fa-fw',
        'fa-sharp fa-regular fa-gauge-min fa-fw',
        'fa-sharp fa-regular fa-gauge-max fa-fw',
        'fa-sharp fa-regular fa-gauge-low fa-fw',
        'fa-sharp fa-regular fa-gauge-high fa-fw',
        'fa-sharp fa-regular fa-gauge-circle-plus fa-fw',
        'fa-sharp fa-regular fa-gauge-circle-minus fa-fw',
        'fa-sharp fa-regular fa-gauge-circle-bolt fa-fw',
        'fa-sharp fa-regular fa-gas-pump-slash fa-fw',
        'fa-sharp fa-regular fa-gas-pump fa-fw',
        'fa-sharp fa-regular fa-garage-open fa-fw',
        'fa-sharp fa-regular fa-garage-car fa-fw',
        'fa-sharp fa-regular fa-garage fa-fw',
        'fa-sharp fa-regular fa-flux-capacitor fa-fw',
        'fa-sharp fa-regular fa-engine fa-fw',
        'fa-sharp fa-regular fa-charging-station fa-fw',
        'fa-sharp fa-regular fa-cars fa-fw',
        'fa-sharp fa-regular fa-caravan-simple fa-fw',
        'fa-sharp fa-regular fa-caravan fa-fw',
        'fa-sharp fa-regular fa-car-wrench fa-fw',
        'fa-sharp fa-regular fa-car-wash fa-fw',
        'fa-sharp fa-regular fa-car-tunnel fa-fw',
        'fa-sharp fa-regular fa-car-tilt fa-fw',
        'fa-sharp fa-regular fa-car-side-bolt fa-fw',
        'fa-sharp fa-regular fa-car-rear fa-fw',
        'fa-sharp fa-regular fa-car-on fa-fw',
        'fa-sharp fa-regular fa-car-mirrors fa-fw',
        'fa-sharp fa-regular fa-car-garage fa-fw',
        'fa-sharp fa-regular fa-car-circle-bolt fa-fw',
        'fa-sharp fa-regular fa-car-bus fa-fw',
        'fa-sharp fa-regular fa-car-burst fa-fw',
        'fa-sharp fa-regular fa-car-bump fa-fw',
        'fa-sharp fa-regular fa-car-bolt fa-fw',
        'fa-sharp fa-regular fa-car-battery fa-fw',
        'fa-sharp fa-regular fa-bus-simple fa-fw',
        'fa-sharp fa-regular fa-bus fa-fw',
        'fa-sharp fa-regular fa-brake-warning fa-fw',
        'fa-sharp fa-light fa-van-shuttle fa-fw',
        'fa-sharp fa-light fa-truck-pickup fa-fw',
        'fa-sharp fa-light fa-truck-medical fa-fw',
        'fa-sharp fa-light fa-truck-field-un fa-fw',
        'fa-sharp fa-light fa-truck-field fa-fw',
        'fa-sharp fa-light fa-truck-bolt fa-fw',
        'fa-sharp fa-light fa-trailer fa-fw',
        'fa-sharp fa-light fa-tire-rugged fa-fw',
        'fa-sharp fa-light fa-tire-pressure-warning fa-fw',
        'fa-sharp fa-light fa-tire-flat fa-fw',
        'fa-sharp fa-light fa-tire fa-fw',
        'fa-sharp fa-light fa-taxi fa-fw',
        'fa-sharp fa-light fa-tank-water fa-fw',
        'fa-sharp fa-light fa-steering-wheel fa-fw',
        'fa-sharp fa-light fa-spray-can-sparkles fa-fw',
        'fa-sharp fa-light fa-rv fa-fw',
        'fa-sharp fa-light fa-pump fa-fw',
        'fa-sharp fa-light fa-oil-temperature fa-fw',
        'fa-sharp fa-light fa-oil-can-drip fa-fw',
        'fa-sharp fa-light fa-oil-can fa-fw',
        'fa-sharp fa-light fa-gauge-simple-min fa-fw',
        'fa-sharp fa-light fa-gauge-simple-max fa-fw',
        'fa-sharp fa-light fa-gauge-simple-low fa-fw',
        'fa-sharp fa-light fa-gauge-simple-high fa-fw',
        'fa-sharp fa-light fa-gauge-simple fa-fw',
        'fa-sharp fa-light fa-gauge-min fa-fw',
        'fa-sharp fa-light fa-gauge-max fa-fw',
        'fa-sharp fa-light fa-gauge-low fa-fw',
        'fa-sharp fa-light fa-gauge-high fa-fw',
        'fa-sharp fa-light fa-gauge-circle-plus fa-fw',
        'fa-sharp fa-light fa-gauge-circle-minus fa-fw',
        'fa-sharp fa-light fa-gauge-circle-bolt fa-fw',
        'fa-sharp fa-light fa-gas-pump-slash fa-fw',
        'fa-sharp fa-light fa-gas-pump fa-fw',
        'fa-sharp fa-light fa-garage-open fa-fw',
        'fa-sharp fa-light fa-garage-car fa-fw',
        'fa-sharp fa-light fa-garage fa-fw',
        'fa-sharp fa-light fa-flux-capacitor fa-fw',
        'fa-sharp fa-light fa-engine fa-fw',
        'fa-sharp fa-light fa-charging-station fa-fw',
        'fa-sharp fa-light fa-cars fa-fw',
        'fa-sharp fa-light fa-caravan-simple fa-fw',
        'fa-sharp fa-light fa-caravan fa-fw',
        'fa-sharp fa-light fa-car-wrench fa-fw',
        'fa-sharp fa-light fa-car-wash fa-fw',
        'fa-sharp fa-light fa-car-tunnel fa-fw',
        'fa-sharp fa-light fa-car-tilt fa-fw',
        'fa-sharp fa-light fa-car-side-bolt fa-fw',
        'fa-sharp fa-light fa-car-rear fa-fw',
        'fa-sharp fa-light fa-car-on fa-fw',
        'fa-sharp fa-light fa-car-mirrors fa-fw',
        'fa-sharp fa-light fa-car-garage fa-fw',
        'fa-sharp fa-light fa-car-circle-bolt fa-fw',
        'fa-sharp fa-light fa-car-bus fa-fw',
        'fa-sharp fa-light fa-car-burst fa-fw',
        'fa-sharp fa-light fa-car-bump fa-fw',
        'fa-sharp fa-light fa-car-bolt fa-fw',
        'fa-sharp fa-light fa-car-battery fa-fw',
        'fa-sharp fa-light fa-bus-simple fa-fw',
        'fa-sharp fa-light fa-bus fa-fw',
        'fa-sharp fa-light fa-brake-warning fa-fw',
      ],
    },

    {
      title: 'Audio & Video',
      items: [
        'fas fa-audio-description',
        'fas fa-backward',
        'fas fa-circle',
        'far fa-circle',
        'fas fa-closed-captioning',
        'far fa-closed-captioning',
        'fas fa-compress',
        'fas fa-eject',
        'fas fa-expand',
        'fas fa-expand-arrows-alt',
        'fas fa-fast-backward',
        'fas fa-fast-forward',
        'fas fa-file-audio',
        'far fa-file-audio',
        'fas fa-file-video',
        'far fa-file-video',
        'fas fa-film',
        'fas fa-forward',
        'fas fa-headphones',
        'fas fa-microphone',
        'fas fa-microphone-slash',
        'fas fa-music',
        'fas fa-pause',
        'fas fa-pause-circle',
        'far fa-pause-circle',
        'fas fa-phone-volume',
        'fas fa-play',
        'fas fa-play-circle',
        'far fa-play-circle',
        'fas fa-podcast',
        'fas fa-random',
        'fas fa-redo',
        'fas fa-redo-alt',
        'fas fa-rss',
        'fas fa-rss-square',
        'fas fa-step-backward',
        'fas fa-step-forward',
        'fas fa-stop',
        'fas fa-stop-circle',
        'far fa-stop-circle',
        'fas fa-sync',
        'fas fa-sync-alt',
        'fas fa-undo',
        'fas fa-undo-alt',
        'fas fa-video',
        'fas fa-volume-down',
        'fas fa-volume-off',
        'fas fa-volume-up',
        'fab fa-youtube',
      ],
    },
    {
      title: 'Buildings',
      items: [
        'fa-solid fa-house fa-fw',
        'fa-regular fa-house fa-fw',
        'fa-light fa-house fa-fw',
        'fa-thin fa-house fa-fw',
        'fa-duotone fa-house fa-fw',
        'fa-sharp fa-solid fa-house fa-fw',
        'fa-sharp fa-regular fa-house fa-fw',
        'fa-sharp fa-light fa-house fa-fw',
        'fa-solid fa-city fa-fw',
        'fa-regular fa-city fa-fw',
        'fa-light fa-city fa-fw',
        'fa-thin fa-city fa-fw',
        'fa-duotone fa-city fa-fw',
        'fa-sharp fa-solid fa-city fa-fw',
        'fa-sharp fa-regular fa-city fa-fw',
        'fa-sharp fa-light fa-city fa-fw',
        'fa-solid fa-shop fa-fw',
        'fa-regular fa-shop fa-fw',
        'fa-light fa-shop fa-fw',
        'fa-thin fa-shop fa-fw',
        'fa-duotone fa-shop fa-fw',
        'fa-sharp fa-solid fa-shop fa-fw',
        'fa-sharp fa-regular fa-shop fa-fw',
        'fa-sharp fa-light fa-shop fa-fw',
        'fa-solid fa-landmark fa-fw',
        'fa-regular fa-landmark fa-fw',
        'fa-light fa-landmark fa-fw',
        'fa-thin fa-landmark fa-fw',
        'fa-duotone fa-landmark fa-fw',
        'fa-sharp fa-solid fa-landmark fa-fw',
        'fa-sharp fa-regular fa-landmark fa-fw',
        'fa-sharp fa-light fa-landmark fa-fw',
        'fa-solid fa-fort fa-fw',
        'fa-regular fa-fort fa-fw',
        'fa-light fa-fort fa-fw',
        'fa-thin fa-fort fa-fw',
        'fa-duotone fa-fort fa-fw',
        'fa-sharp fa-solid fa-fort fa-fw',
        'fa-sharp fa-regular fa-fort fa-fw',
        'fa-sharp fa-light fa-fort fa-fw',
        'fa-solid fa-car-building fa-fw',
        'fa-regular fa-car-building fa-fw',
        'fa-light fa-car-building fa-fw',
        'fa-thin fa-car-building fa-fw',
        'fa-duotone fa-car-building fa-fw',
        'fa-sharp fa-solid fa-car-building fa-fw',
        'fa-sharp fa-regular fa-car-building fa-fw',
        'fa-sharp fa-light fa-car-building fa-fw',
        'fa-solid fa-building fa-fw',
        'fa-regular fa-building fa-fw',
        'fa-light fa-building fa-fw',
        'fa-thin fa-building fa-fw',
        'fa-duotone fa-building fa-fw',
        'fa-sharp fa-solid fa-building fa-fw',
        'fa-sharp fa-regular fa-building fa-fw',
        'fa-sharp fa-light fa-building fa-fw',
        'fa-solid fa-store fa-fw',
        'fa-regular fa-store fa-fw',
        'fa-light fa-store fa-fw',
        'fa-thin fa-store fa-fw',
        'fa-duotone fa-store fa-fw',
        'fa-sharp fa-solid fa-store fa-fw',
        'fa-sharp fa-regular fa-store fa-fw',
        'fa-sharp fa-light fa-store fa-fw',
        'fa-solid fa-school fa-fw',
        'fa-regular fa-school fa-fw',
        'fa-light fa-school fa-fw',
        'fa-thin fa-school fa-fw',
        'fa-duotone fa-school fa-fw',
        'fa-sharp fa-solid fa-school fa-fw',
        'fa-sharp fa-regular fa-school fa-fw',
        'fa-sharp fa-light fa-school fa-fw',
        'fa-solid fa-hotel fa-fw',
        'fa-regular fa-hotel fa-fw',
        'fa-light fa-hotel fa-fw',
        'fa-thin fa-hotel fa-fw',
        'fa-duotone fa-hotel fa-fw',
        'fa-sharp fa-solid fa-hotel fa-fw',
        'fa-sharp fa-regular fa-hotel fa-fw',
        'fa-sharp fa-light fa-hotel fa-fw',
        'fa-solid fa-place-of-worship fa-fw',
        'fa-regular fa-place-of-worship fa-fw',
        'fa-light fa-place-of-worship fa-fw',
        'fa-thin fa-place-of-worship fa-fw',
        'fa-duotone fa-place-of-worship fa-fw',
        'fa-sharp fa-solid fa-place-of-worship fa-fw',
        'fa-sharp fa-regular fa-place-of-worship fa-fw',
        'fa-sharp fa-light fa-place-of-worship fa-fw',
        'fa-solid fa-hospital fa-fw',
        'fa-regular fa-hospital fa-fw',
        'fa-light fa-hospital fa-fw',
        'fa-thin fa-hospital fa-fw',
        'fa-duotone fa-hospital fa-fw',
        'fa-sharp fa-solid fa-hospital fa-fw',
        'fa-sharp fa-regular fa-hospital fa-fw',
        'fa-sharp fa-light fa-hospital fa-fw',
        'fa-solid fa-church fa-fw',
        'fa-regular fa-church fa-fw',
        'fa-light fa-church fa-fw',
        'fa-thin fa-church fa-fw',
        'fa-duotone fa-church fa-fw',
        'fa-sharp fa-solid fa-church fa-fw',
        'fa-sharp fa-regular fa-church fa-fw',
        'fa-sharp fa-light fa-church fa-fw',
        'fa-solid fa-container-storage fa-fw',
        'fa-regular fa-container-storage fa-fw',
        'fa-light fa-container-storage fa-fw',
        'fa-thin fa-container-storage fa-fw',
        'fa-duotone fa-container-storage fa-fw',
        'fa-sharp fa-solid fa-container-storage fa-fw',
        'fa-sharp fa-regular fa-container-storage fa-fw',
        'fa-sharp fa-light fa-container-storage fa-fw',
        'fa-solid fa-warehouse fa-fw',
        'fa-regular fa-warehouse fa-fw',
        'fa-light fa-warehouse fa-fw',
        'fa-thin fa-warehouse fa-fw',
        'fa-duotone fa-warehouse fa-fw',
        'fa-sharp fa-solid fa-warehouse fa-fw',
        'fa-sharp fa-regular fa-warehouse fa-fw',
        'fa-sharp fa-light fa-warehouse fa-fw',
        'fa-solid fa-house-night fa-fw',
        'fa-regular fa-house-night fa-fw',
        'fa-light fa-house-night fa-fw',
        'fa-thin fa-house-night fa-fw',
        'fa-duotone fa-house-night fa-fw',
        'fa-sharp fa-solid fa-house-night fa-fw',
        'fa-sharp fa-regular fa-house-night fa-fw',
        'fa-sharp fa-light fa-house-night fa-fw',
        'fa-solid fa-gopuram fa-fw',
        'fa-regular fa-gopuram fa-fw',
        'fa-light fa-gopuram fa-fw',
        'fa-thin fa-gopuram fa-fw',
        'fa-duotone fa-gopuram fa-fw',
        'fa-sharp fa-solid fa-gopuram fa-fw',
        'fa-sharp fa-regular fa-gopuram fa-fw',
        'fa-sharp fa-light fa-gopuram fa-fw',
        'fa-solid fa-industry fa-fw',
        'fa-regular fa-industry fa-fw',
        'fa-light fa-industry fa-fw',
        'fa-thin fa-industry fa-fw',
        'fa-duotone fa-industry fa-fw',
        'fa-sharp fa-solid fa-industry fa-fw',
        'fa-sharp fa-regular fa-industry fa-fw',
        'fa-sharp fa-light fa-industry fa-fw',
        'fa-solid fa-warehouse-full fa-fw',
        'fa-solid fa-vihara fa-fw',
        'fa-solid fa-tree-city fa-fw',
        'fa-solid fa-tower-observation fa-fw',
        'fa-solid fa-torii-gate fa-fw',
        'fa-solid fa-toilets-portable fa-fw',
        'fa-solid fa-toilet-portable fa-fw',
        'fa-solid fa-tents fa-fw',
        'fa-solid fa-tent-arrows-down fa-fw',
        'fa-solid fa-tent-arrow-turn-left fa-fw',
        'fa-solid fa-tent-arrow-left-right fa-fw',
        'fa-solid fa-tent-arrow-down-to-line fa-fw',
        'fa-solid fa-tent fa-fw',
        'fa-solid fa-synagogue fa-fw',
        'fa-solid fa-store-lock fa-fw',
        'fa-solid fa-shop-lock fa-fw',
        'fa-solid fa-school-lock fa-fw',
        'fa-solid fa-school-flag fa-fw',
        'fa-solid fa-school-circle-xmark fa-fw',
        'fa-solid fa-school-circle-exclamation fa-fw',
        'fa-solid fa-school-circle-check fa-fw',
        'fa-solid fa-roller-coaster fa-fw',
        'fa-solid fa-oil-well fa-fw',
        'fa-solid fa-mountain-city fa-fw',
        'fa-solid fa-mosque fa-fw',
        'fa-solid fa-monument fa-fw',
        'fa-solid fa-landmark-flag fa-fw',
        'fa-solid fa-landmark-dome fa-fw',
        'fa-solid fa-kaaba fa-fw',
        'fa-solid fa-industry-windows fa-fw',
        'fa-solid fa-igloo fa-fw',
        'fa-solid fa-house-window fa-fw',
        'fa-solid fa-house-water fa-fw',
        'fa-solid fa-house-turret fa-fw',
        'fa-solid fa-house-tree fa-fw',
        'fa-solid fa-house-medical-flag fa-fw',
        'fa-solid fa-house-medical-circle-xmark fa-fw',
        'fa-solid fa-house-medical-circle-exclamation fa-fw',
        'fa-solid fa-house-medical-circle-check fa-fw',
        'fa-solid fa-house-medical fa-fw',
        'fa-solid fa-house-lock fa-fw',
        'fa-solid fa-house-flag fa-fw',
        'fa-solid fa-house-fire fa-fw',
        'fa-solid fa-house-day fa-fw',
        'fa-solid fa-house-crack fa-fw',
        'fa-solid fa-house-circle-xmark fa-fw',
        'fa-solid fa-house-circle-exclamation fa-fw',
        'fa-solid fa-house-circle-check fa-fw',
        'fa-solid fa-house-chimney-window fa-fw',
        'fa-solid fa-house-chimney-medical fa-fw',
        'fa-solid fa-house-chimney-crack fa-fw',
        'fa-solid fa-house-chimney-blank fa-fw',
        'fa-solid fa-house-chimney fa-fw',
        'fa-solid fa-house-building fa-fw',
        'fa-solid fa-house-blank fa-fw',
        'fa-solid fa-hospitals fa-fw',
        'fa-solid fa-hospital-user fa-fw',
        'fa-solid fa-garage-open fa-fw',
        'fa-solid fa-garage-car fa-fw',
        'fa-solid fa-garage fa-fw',
        'fa-solid fa-ferris-wheel fa-fw',
        'fa-solid fa-fence fa-fw',
        'fa-solid fa-farm fa-fw',
        'fa-solid fa-dungeon fa-fw',
        'fa-solid fa-chimney fa-fw',
        'fa-solid fa-castle fa-fw',
        'fa-solid fa-campground fa-fw',
        'fa-solid fa-cabin fa-fw',
        'fa-solid fa-buildings fa-fw',
        'fa-solid fa-building-wheat fa-fw',
        'fa-solid fa-building-user fa-fw',
        'fa-solid fa-building-un fa-fw',
        'fa-solid fa-building-shield fa-fw',
        'fa-solid fa-building-ngo fa-fw',
        'fa-solid fa-building-lock fa-fw',
        'fa-solid fa-building-flag fa-fw',
        'fa-solid fa-building-columns fa-fw',
        'fa-solid fa-building-circle-xmark fa-fw',
        'fa-solid fa-building-circle-exclamation fa-fw',
        'fa-solid fa-building-circle-check fa-fw',
        'fa-solid fa-building-circle-arrow-right fa-fw',
        'fa-solid fa-bridge-suspension fa-fw',
        'fa-solid fa-arrow-right-to-city fa-fw',
        'fa-solid fa-archway fa-fw',
        'fa-solid fa-apartment fa-fw',
        'fa-regular fa-warehouse-full fa-fw',
        'fa-regular fa-vihara fa-fw',
        'fa-regular fa-tree-city fa-fw',
        'fa-regular fa-tower-observation fa-fw',
        'fa-regular fa-torii-gate fa-fw',
        'fa-regular fa-toilets-portable fa-fw',
        'fa-regular fa-toilet-portable fa-fw',
        'fa-regular fa-tents fa-fw',
        'fa-regular fa-tent-arrows-down fa-fw',
        'fa-regular fa-tent-arrow-turn-left fa-fw',
        'fa-regular fa-tent-arrow-left-right fa-fw',
        'fa-regular fa-tent-arrow-down-to-line fa-fw',
        'fa-regular fa-tent fa-fw',
        'fa-regular fa-synagogue fa-fw',
        'fa-regular fa-store-lock fa-fw',
        'fa-regular fa-shop-lock fa-fw',
        'fa-regular fa-school-lock fa-fw',
        'fa-regular fa-school-flag fa-fw',
        'fa-regular fa-school-circle-xmark fa-fw',
        'fa-regular fa-school-circle-exclamation fa-fw',
        'fa-regular fa-school-circle-check fa-fw',
        'fa-regular fa-roller-coaster fa-fw',
        'fa-regular fa-oil-well fa-fw',
        'fa-regular fa-mountain-city fa-fw',
        'fa-regular fa-mosque fa-fw',
        'fa-regular fa-monument fa-fw',
        'fa-regular fa-landmark-flag fa-fw',
        'fa-regular fa-landmark-dome fa-fw',
        'fa-regular fa-kaaba fa-fw',
        'fa-regular fa-industry-windows fa-fw',
        'fa-regular fa-igloo fa-fw',
        'fa-regular fa-house-window fa-fw',
        'fa-regular fa-house-water fa-fw',
        'fa-regular fa-house-turret fa-fw',
        'fa-regular fa-house-tree fa-fw',
        'fa-regular fa-house-medical-flag fa-fw',
        'fa-regular fa-house-medical-circle-xmark fa-fw',
        'fa-regular fa-house-medical-circle-exclamation fa-fw',
        'fa-regular fa-house-medical-circle-check fa-fw',
        'fa-regular fa-house-medical fa-fw',
        'fa-regular fa-house-lock fa-fw',
        'fa-regular fa-house-flag fa-fw',
        'fa-regular fa-house-fire fa-fw',
        'fa-regular fa-house-day fa-fw',
        'fa-regular fa-house-crack fa-fw',
        'fa-regular fa-house-circle-xmark fa-fw',
        'fa-regular fa-house-circle-exclamation fa-fw',
        'fa-regular fa-house-circle-check fa-fw',
        'fa-regular fa-house-chimney-window fa-fw',
        'fa-regular fa-house-chimney-medical fa-fw',
        'fa-regular fa-house-chimney-crack fa-fw',
        'fa-regular fa-house-chimney-blank fa-fw',
        'fa-regular fa-house-chimney fa-fw',
        'fa-regular fa-house-building fa-fw',
        'fa-regular fa-house-blank fa-fw',
        'fa-regular fa-hospitals fa-fw',
        'fa-regular fa-hospital-user fa-fw',
        'fa-regular fa-garage-open fa-fw',
        'fa-regular fa-garage-car fa-fw',
        'fa-regular fa-garage fa-fw',
        'fa-regular fa-ferris-wheel fa-fw',
        'fa-regular fa-fence fa-fw',
        'fa-regular fa-farm fa-fw',
        'fa-regular fa-dungeon fa-fw',
        'fa-regular fa-chimney fa-fw',
        'fa-regular fa-castle fa-fw',
        'fa-regular fa-campground fa-fw',
        'fa-regular fa-cabin fa-fw',
        'fa-regular fa-buildings fa-fw',
        'fa-regular fa-building-wheat fa-fw',
        'fa-regular fa-building-user fa-fw',
        'fa-regular fa-building-un fa-fw',
        'fa-regular fa-building-shield fa-fw',
        'fa-regular fa-building-ngo fa-fw',
        'fa-regular fa-building-lock fa-fw',
        'fa-regular fa-building-flag fa-fw',
        'fa-regular fa-building-columns fa-fw',
        'fa-regular fa-building-circle-xmark fa-fw',
        'fa-regular fa-building-circle-exclamation fa-fw',
        'fa-regular fa-building-circle-check fa-fw',
        'fa-regular fa-building-circle-arrow-right fa-fw',
        'fa-regular fa-bridge-suspension fa-fw',
        'fa-regular fa-arrow-right-to-city fa-fw',
        'fa-regular fa-archway fa-fw',
        'fa-regular fa-apartment fa-fw',
        'fa-light fa-warehouse-full fa-fw',
        'fa-light fa-vihara fa-fw',
        'fa-light fa-tree-city fa-fw',
        'fa-light fa-tower-observation fa-fw',
        'fa-light fa-torii-gate fa-fw',
        'fa-light fa-toilets-portable fa-fw',
        'fa-light fa-toilet-portable fa-fw',
        'fa-light fa-tents fa-fw',
        'fa-light fa-tent-arrows-down fa-fw',
        'fa-light fa-tent-arrow-turn-left fa-fw',
        'fa-light fa-tent-arrow-left-right fa-fw',
        'fa-light fa-tent-arrow-down-to-line fa-fw',
        'fa-light fa-tent fa-fw',
        'fa-light fa-synagogue fa-fw',
        'fa-light fa-store-lock fa-fw',
        'fa-light fa-shop-lock fa-fw',
        'fa-light fa-school-lock fa-fw',
        'fa-light fa-school-flag fa-fw',
        'fa-light fa-school-circle-xmark fa-fw',
        'fa-light fa-school-circle-exclamation fa-fw',
        'fa-light fa-school-circle-check fa-fw',
        'fa-light fa-roller-coaster fa-fw',
        'fa-light fa-oil-well fa-fw',
        'fa-light fa-mountain-city fa-fw',
        'fa-light fa-mosque fa-fw',
        'fa-light fa-monument fa-fw',
        'fa-light fa-landmark-flag fa-fw',
        'fa-light fa-landmark-dome fa-fw',
        'fa-light fa-kaaba fa-fw',
        'fa-light fa-industry-windows fa-fw',
        'fa-light fa-igloo fa-fw',
        'fa-light fa-house-window fa-fw',
        'fa-light fa-house-water fa-fw',
        'fa-light fa-house-turret fa-fw',
        'fa-light fa-house-tree fa-fw',
        'fa-light fa-house-medical-flag fa-fw',
        'fa-light fa-house-medical-circle-xmark fa-fw',
        'fa-light fa-house-medical-circle-exclamation fa-fw',
        'fa-light fa-house-medical-circle-check fa-fw',
        'fa-light fa-house-medical fa-fw',
        'fa-light fa-house-lock fa-fw',
        'fa-light fa-house-flag fa-fw',
        'fa-light fa-house-fire fa-fw',
        'fa-light fa-house-day fa-fw',
        'fa-light fa-house-crack fa-fw',
        'fa-light fa-house-circle-xmark fa-fw',
        [
          'fa-light fa-house-circle-exclamation fa-fw',
          'fa-light fa-house-circle-check fa-fw',
          'fa-light fa-house-chimney-window fa-fw',
          'fa-light fa-house-chimney-medical fa-fw',
          'fa-light fa-house-chimney-crack fa-fw',
          'fa-light fa-house-chimney-blank fa-fw',
          'fa-light fa-house-chimney fa-fw',
          'fa-light fa-house-building fa-fw',
          'fa-light fa-house-blank fa-fw',
          'fa-light fa-hospitals fa-fw',
          'fa-light fa-hospital-user fa-fw',
          'fa-light fa-garage-open fa-fw',
          'fa-light fa-garage-car fa-fw',
          'fa-light fa-garage fa-fw',
          'fa-light fa-ferris-wheel fa-fw',
          'fa-light fa-fence fa-fw',
          'fa-light fa-farm fa-fw',
          'fa-light fa-dungeon fa-fw',
          'fa-light fa-chimney fa-fw',
          'fa-light fa-castle fa-fw',
          'fa-light fa-campground fa-fw',
          'fa-light fa-cabin fa-fw',
          'fa-light fa-buildings fa-fw',
          'fa-light fa-building-wheat fa-fw',
          'fa-light fa-building-user fa-fw',
          'fa-light fa-building-un fa-fw',
          'fa-light fa-building-shield fa-fw',
          'fa-light fa-building-ngo fa-fw',
          'fa-light fa-building-lock fa-fw',
          'fa-light fa-building-flag fa-fw',
          'fa-light fa-building-columns fa-fw',
          'fa-light fa-building-circle-xmark fa-fw',
          'fa-light fa-building-circle-exclamation fa-fw',
          'fa-light fa-building-circle-check fa-fw',
          'fa-light fa-building-circle-arrow-right fa-fw',
          'fa-light fa-bridge-suspension fa-fw',
          'fa-light fa-arrow-right-to-city fa-fw',
          'fa-light fa-archway fa-fw',
          'fa-light fa-apartment fa-fw',
          'fa-thin fa-warehouse-full fa-fw',
          'fa-thin fa-vihara fa-fw',
          'fa-thin fa-tree-city fa-fw',
          'fa-thin fa-tower-observation fa-fw',
          'fa-thin fa-torii-gate fa-fw',
          'fa-thin fa-toilets-portable fa-fw',
          'fa-thin fa-toilet-portable fa-fw',
          'fa-thin fa-tents fa-fw',
          'fa-thin fa-tent-arrows-down fa-fw',
          'fa-thin fa-tent-arrow-turn-left fa-fw',
          'fa-thin fa-tent-arrow-left-right fa-fw',
          'fa-thin fa-tent-arrow-down-to-line fa-fw',
          'fa-thin fa-tent fa-fw',
          'fa-thin fa-synagogue fa-fw',
          'fa-thin fa-store-lock fa-fw',
          'fa-thin fa-shop-lock fa-fw',
          'fa-thin fa-school-lock fa-fw',
          'fa-thin fa-school-flag fa-fw',
          'fa-thin fa-school-circle-xmark fa-fw',
          'fa-thin fa-school-circle-exclamation fa-fw',
          'fa-thin fa-school-circle-check fa-fw',
          'fa-thin fa-roller-coaster fa-fw',
          'fa-thin fa-oil-well fa-fw',
          'fa-thin fa-mountain-city fa-fw',
          'fa-thin fa-mosque fa-fw',
          'fa-thin fa-monument fa-fw',
          'fa-thin fa-landmark-flag fa-fw',
          'fa-thin fa-landmark-dome fa-fw',
          'fa-thin fa-kaaba fa-fw',
          'fa-thin fa-industry-windows fa-fw',
          'fa-thin fa-igloo fa-fw',
          'fa-thin fa-house-window fa-fw',
          'fa-thin fa-house-water fa-fw',
          'fa-thin fa-house-turret fa-fw',
          'fa-thin fa-house-tree fa-fw',
          'fa-thin fa-house-medical-flag fa-fw',
          'fa-thin fa-house-medical-circle-xmark fa-fw',
          'fa-thin fa-house-medical-circle-exclamation fa-fw',
          'fa-thin fa-house-medical-circle-check fa-fw',
          'fa-thin fa-house-medical fa-fw',
          'fa-thin fa-house-lock fa-fw',
          'fa-thin fa-house-flag fa-fw',
          'fa-thin fa-house-fire fa-fw',
          'fa-thin fa-house-day fa-fw',
          'fa-thin fa-house-crack fa-fw',
          'fa-thin fa-house-circle-xmark fa-fw',
          'fa-thin fa-house-circle-exclamation fa-fw',
          'fa-thin fa-house-circle-check fa-fw',
          'fa-thin fa-house-chimney-window fa-fw',
          'fa-thin fa-house-chimney-medical fa-fw',
          'fa-thin fa-house-chimney-crack fa-fw',
          'fa-thin fa-house-chimney-blank fa-fw',
          'fa-thin fa-house-chimney fa-fw',
          'fa-thin fa-house-building fa-fw',
          'fa-thin fa-house-blank fa-fw',
          'fa-thin fa-hospitals fa-fw',
          'fa-thin fa-hospital-user fa-fw',
          'fa-thin fa-garage-open fa-fw',
          'fa-thin fa-garage-car fa-fw',
          'fa-thin fa-garage fa-fw',
          'fa-thin fa-ferris-wheel fa-fw',
          'fa-thin fa-fence fa-fw',
          'fa-thin fa-farm fa-fw',
          'fa-thin fa-dungeon fa-fw',
          'fa-thin fa-chimney fa-fw',
          'fa-thin fa-castle fa-fw',
          'fa-thin fa-campground fa-fw',
          'fa-thin fa-cabin fa-fw',
          'fa-thin fa-buildings fa-fw',
          'fa-thin fa-building-wheat fa-fw',
          'fa-thin fa-building-user fa-fw',
          'fa-thin fa-building-un fa-fw',
          'fa-thin fa-building-shield fa-fw',
          'fa-thin fa-building-ngo fa-fw',
          'fa-thin fa-building-lock fa-fw',
          'fa-thin fa-building-flag fa-fw',
          'fa-thin fa-building-columns fa-fw',
          'fa-thin fa-building-circle-xmark fa-fw',
          'fa-thin fa-building-circle-exclamation fa-fw',
          'fa-thin fa-building-circle-check fa-fw',
          'fa-thin fa-building-circle-arrow-right fa-fw',
          'fa-thin fa-bridge-suspension fa-fw',
          'fa-thin fa-arrow-right-to-city fa-fw',
          'fa-thin fa-archway fa-fw',
          'fa-thin fa-apartment fa-fw',
          'fa-duotone fa-warehouse-full fa-fw',
          'fa-duotone fa-vihara fa-fw',
          'fa-duotone fa-tree-city fa-fw',
          'fa-duotone fa-tower-observation fa-fw',
          'fa-duotone fa-torii-gate fa-fw',
          'fa-duotone fa-toilets-portable fa-fw',
          'fa-duotone fa-toilet-portable fa-fw',
          'fa-duotone fa-tents fa-fw',
          'fa-duotone fa-tent-arrows-down fa-fw',
          'fa-duotone fa-tent-arrow-turn-left fa-fw',
          'fa-duotone fa-tent-arrow-left-right fa-fw',
          'fa-duotone fa-tent-arrow-down-to-line fa-fw',
          'fa-duotone fa-tent fa-fw',
          'fa-duotone fa-synagogue fa-fw',
          'fa-duotone fa-store-lock fa-fw',
          'fa-duotone fa-shop-lock fa-fw',
          'fa-duotone fa-school-lock fa-fw',
          'fa-duotone fa-school-flag fa-fw',
          'fa-duotone fa-school-circle-xmark fa-fw',
          'fa-duotone fa-school-circle-exclamation fa-fw',
          'fa-duotone fa-school-circle-check fa-fw',
          'fa-duotone fa-roller-coaster fa-fw',
          'fa-duotone fa-oil-well fa-fw',
          'fa-duotone fa-mountain-city fa-fw',
          'fa-duotone fa-mosque fa-fw',
          'fa-duotone fa-monument fa-fw',
          'fa-duotone fa-landmark-flag fa-fw',
          'fa-duotone fa-landmark-dome fa-fw',
          'fa-duotone fa-kaaba fa-fw',
          'fa-duotone fa-industry-windows fa-fw',
          'fa-duotone fa-igloo fa-fw',
          'fa-duotone fa-house-window fa-fw',
          'fa-duotone fa-house-water fa-fw',
          'fa-duotone fa-house-turret fa-fw',
          'fa-duotone fa-house-tree fa-fw',
          'fa-duotone fa-house-medical-flag fa-fw',
          'fa-duotone fa-house-medical-circle-xmark fa-fw',
          'fa-duotone fa-house-medical-circle-exclamation fa-fw',
          'fa-duotone fa-house-medical-circle-check fa-fw',
          'fa-duotone fa-house-medical fa-fw',
          'fa-duotone fa-house-lock fa-fw',
          'fa-duotone fa-house-flag fa-fw',
          'fa-duotone fa-house-fire fa-fw',
          'fa-duotone fa-house-day fa-fw',
          'fa-duotone fa-house-crack fa-fw',
          'fa-duotone fa-house-circle-xmark fa-fw',
          'fa-duotone fa-house-circle-exclamation fa-fw',
          'fa-duotone fa-house-circle-check fa-fw',
          'fa-duotone fa-house-chimney-window fa-fw',
          'fa-duotone fa-house-chimney-medical fa-fw',
          'fa-duotone fa-house-chimney-crack fa-fw',
          'fa-duotone fa-house-chimney-blank fa-fw',
          'fa-duotone fa-house-chimney fa-fw',
          'fa-duotone fa-house-building fa-fw',
          'fa-duotone fa-house-blank fa-fw',
          'fa-duotone fa-hospitals fa-fw',
          [
            'fa-duotone fa-hospital-user fa-fw',
            'fa-duotone fa-garage-open fa-fw',
            'fa-duotone fa-garage-car fa-fw',
            'fa-duotone fa-garage fa-fw',
            'fa-duotone fa-ferris-wheel fa-fw',
            'fa-duotone fa-fence fa-fw',
            'fa-duotone fa-farm fa-fw',
            'fa-duotone fa-dungeon fa-fw',
            'fa-duotone fa-chimney fa-fw',
            'fa-duotone fa-castle fa-fw',
            'fa-duotone fa-campground fa-fw',
            'fa-duotone fa-cabin fa-fw',
            'fa-duotone fa-buildings fa-fw',
            'fa-duotone fa-building-wheat fa-fw',
            'fa-duotone fa-building-user fa-fw',
            'fa-duotone fa-building-un fa-fw',
            'fa-duotone fa-building-shield fa-fw',
            'fa-duotone fa-building-ngo fa-fw',
            'fa-duotone fa-building-lock fa-fw',
            'fa-duotone fa-building-flag fa-fw',
            'fa-duotone fa-building-columns fa-fw',
            'fa-duotone fa-building-circle-xmark fa-fw',
            'fa-duotone fa-building-circle-exclamation fa-fw',
            'fa-duotone fa-building-circle-check fa-fw',
            'fa-duotone fa-building-circle-arrow-right fa-fw',
            'fa-duotone fa-bridge-suspension fa-fw',
            'fa-duotone fa-arrow-right-to-city fa-fw',
            'fa-duotone fa-archway fa-fw',
            'fa-duotone fa-apartment fa-fw',
            'fa-sharp fa-solid fa-warehouse-full fa-fw',
            'fa-sharp fa-solid fa-vihara fa-fw',
            'fa-sharp fa-solid fa-tree-city fa-fw',
            'fa-sharp fa-solid fa-tower-observation fa-fw',
            'fa-sharp fa-solid fa-torii-gate fa-fw',
            'fa-sharp fa-solid fa-toilets-portable fa-fw',
            'fa-sharp fa-solid fa-toilet-portable fa-fw',
            'fa-sharp fa-solid fa-tents fa-fw',
            'fa-sharp fa-solid fa-tent-arrows-down fa-fw',
            'fa-sharp fa-solid fa-tent-arrow-turn-left fa-fw',
            'fa-sharp fa-solid fa-tent-arrow-left-right fa-fw',
            'fa-sharp fa-solid fa-tent-arrow-down-to-line fa-fw',
            'fa-sharp fa-solid fa-tent fa-fw',
            'fa-sharp fa-solid fa-synagogue fa-fw',
            'fa-sharp fa-solid fa-store-lock fa-fw',
            'fa-sharp fa-solid fa-shop-lock fa-fw',
            'fa-sharp fa-solid fa-school-lock fa-fw',
            'fa-sharp fa-solid fa-school-flag fa-fw',
            'fa-sharp fa-solid fa-school-circle-xmark fa-fw',
            'fa-sharp fa-solid fa-school-circle-exclamation fa-fw',
            'fa-sharp fa-solid fa-school-circle-check fa-fw',
            'fa-sharp fa-solid fa-roller-coaster fa-fw',
            'fa-sharp fa-solid fa-oil-well fa-fw',
            'fa-sharp fa-solid fa-mountain-city fa-fw',
            'fa-sharp fa-solid fa-mosque fa-fw',
            'fa-sharp fa-solid fa-monument fa-fw',
            'fa-sharp fa-solid fa-landmark-flag fa-fw',
            'fa-sharp fa-solid fa-landmark-dome fa-fw',
            'fa-sharp fa-solid fa-kaaba fa-fw',
            'fa-sharp fa-solid fa-industry-windows fa-fw',
            'fa-sharp fa-solid fa-igloo fa-fw',
            'fa-sharp fa-solid fa-house-window fa-fw',
            'fa-sharp fa-solid fa-house-water fa-fw',
            'fa-sharp fa-solid fa-house-turret fa-fw',
            'fa-sharp fa-solid fa-house-tree fa-fw',
            'fa-sharp fa-solid fa-house-medical-flag fa-fw',
            'fa-sharp fa-solid fa-house-medical-circle-xmark fa-fw',
            'fa-sharp fa-solid fa-house-medical-circle-exclamation fa-fw',
            'fa-sharp fa-solid fa-house-medical-circle-check fa-fw',
            'fa-sharp fa-solid fa-house-medical fa-fw',
            'fa-sharp fa-solid fa-house-lock fa-fw',
            'fa-sharp fa-solid fa-house-flag fa-fw',
            'fa-sharp fa-solid fa-house-fire fa-fw',
            'fa-sharp fa-solid fa-house-day fa-fw',
            'fa-sharp fa-solid fa-house-crack fa-fw',
            'fa-sharp fa-solid fa-house-circle-xmark fa-fw',
            'fa-sharp fa-solid fa-house-circle-exclamation fa-fw',
            'fa-sharp fa-solid fa-house-circle-check fa-fw',
            'fa-sharp fa-solid fa-house-chimney-window fa-fw',
            'fa-sharp fa-solid fa-house-chimney-medical fa-fw',
            'fa-sharp fa-solid fa-house-chimney-crack fa-fw',
            'fa-sharp fa-solid fa-house-chimney-blank fa-fw',
            'fa-sharp fa-solid fa-house-chimney fa-fw',
            'fa-sharp fa-solid fa-house-building fa-fw',
            'fa-sharp fa-solid fa-house-blank fa-fw',
            'fa-sharp fa-solid fa-hospitals fa-fw',
            'fa-sharp fa-solid fa-hospital-user fa-fw',
            'fa-sharp fa-solid fa-garage-open fa-fw',
            'fa-sharp fa-solid fa-garage-car fa-fw',
            'fa-sharp fa-solid fa-garage fa-fw',
            'fa-sharp fa-solid fa-ferris-wheel fa-fw',
            'fa-sharp fa-solid fa-fence fa-fw',
            'fa-sharp fa-solid fa-farm fa-fw',
            'fa-sharp fa-solid fa-dungeon fa-fw',
            'fa-sharp fa-solid fa-chimney fa-fw',
            'fa-sharp fa-solid fa-castle fa-fw',
            'fa-sharp fa-solid fa-campground fa-fw',
            'fa-sharp fa-solid fa-cabin fa-fw',
            'fa-sharp fa-solid fa-buildings fa-fw',
            'fa-sharp fa-solid fa-building-wheat fa-fw',
            'fa-sharp fa-solid fa-building-user fa-fw',
            'fa-sharp fa-solid fa-building-un fa-fw',
            'fa-sharp fa-solid fa-building-shield fa-fw',
            'fa-sharp fa-solid fa-building-ngo fa-fw',
            'fa-sharp fa-solid fa-building-lock fa-fw',
            'fa-sharp fa-solid fa-building-flag fa-fw',
            'fa-sharp fa-solid fa-building-columns fa-fw',
            'fa-sharp fa-solid fa-building-circle-xmark fa-fw',
            'fa-sharp fa-solid fa-building-circle-exclamation fa-fw',
            'fa-sharp fa-solid fa-building-circle-check fa-fw',
            'fa-sharp fa-solid fa-building-circle-arrow-right fa-fw',
            'fa-sharp fa-solid fa-bridge-suspension fa-fw',
            'fa-sharp fa-solid fa-arrow-right-to-city fa-fw',
            'fa-sharp fa-solid fa-archway fa-fw',
            'fa-sharp fa-solid fa-apartment fa-fw',
            'fa-sharp fa-regular fa-warehouse-full fa-fw',
            'fa-sharp fa-regular fa-vihara fa-fw',
            'fa-sharp fa-regular fa-tree-city fa-fw',
            'fa-sharp fa-regular fa-tower-observation fa-fw',
            'fa-sharp fa-regular fa-torii-gate fa-fw',
            'fa-sharp fa-regular fa-toilets-portable fa-fw',
            'fa-sharp fa-regular fa-toilet-portable fa-fw',
            'fa-sharp fa-regular fa-tents fa-fw',
            'fa-sharp fa-regular fa-tent-arrows-down fa-fw',
            'fa-sharp fa-regular fa-tent-arrow-turn-left fa-fw',
            'fa-sharp fa-regular fa-tent-arrow-left-right fa-fw',
            'fa-sharp fa-regular fa-tent-arrow-down-to-line fa-fw',
            'fa-sharp fa-regular fa-tent fa-fw',
            'fa-sharp fa-regular fa-synagogue fa-fw',
            'fa-sharp fa-regular fa-store-lock fa-fw',
            'fa-sharp fa-regular fa-shop-lock fa-fw',
            'fa-sharp fa-regular fa-school-lock fa-fw',
            'fa-sharp fa-regular fa-school-flag fa-fw',
            'fa-sharp fa-regular fa-school-circle-xmark fa-fw',
            'fa-sharp fa-regular fa-school-circle-exclamation fa-fw',
            'fa-sharp fa-regular fa-school-circle-check fa-fw',
            'fa-sharp fa-regular fa-roller-coaster fa-fw',
            'fa-sharp fa-regular fa-oil-well fa-fw',
            'fa-sharp fa-regular fa-mountain-city fa-fw',
            'fa-sharp fa-regular fa-mosque fa-fw',
            'fa-sharp fa-regular fa-monument fa-fw',
            'fa-sharp fa-regular fa-landmark-flag fa-fw',
            'fa-sharp fa-regular fa-landmark-dome fa-fw',
            'fa-sharp fa-regular fa-kaaba fa-fw',
            'fa-sharp fa-regular fa-industry-windows fa-fw',
            'fa-sharp fa-regular fa-igloo fa-fw',
            'fa-sharp fa-regular fa-house-window fa-fw',
            'fa-sharp fa-regular fa-house-water fa-fw',
            'fa-sharp fa-regular fa-house-turret fa-fw',
            'fa-sharp fa-regular fa-house-tree fa-fw',
            'fa-sharp fa-regular fa-house-medical-flag fa-fw',
            'fa-sharp fa-regular fa-house-medical-circle-xmark fa-fw',
            'fa-sharp fa-regular fa-house-medical-circle-exclamation fa-fw',
            'fa-sharp fa-regular fa-house-medical-circle-check fa-fw',
            'fa-sharp fa-regular fa-house-medical fa-fw',
            'fa-sharp fa-regular fa-house-lock fa-fw',
            'fa-sharp fa-regular fa-house-flag fa-fw',
            'fa-sharp fa-regular fa-house-fire fa-fw',
            'fa-sharp fa-regular fa-house-day fa-fw',
            'fa-sharp fa-regular fa-house-crack fa-fw',
            'fa-sharp fa-regular fa-house-circle-xmark fa-fw',
            'fa-sharp fa-regular fa-house-circle-exclamation fa-fw',
            'fa-sharp fa-regular fa-house-circle-check fa-fw',
            'fa-sharp fa-regular fa-house-chimney-window fa-fw',
            'fa-sharp fa-regular fa-house-chimney-medical fa-fw',
            'fa-sharp fa-regular fa-house-chimney-crack fa-fw',
            'fa-sharp fa-regular fa-house-chimney-blank fa-fw',
            'fa-sharp fa-regular fa-house-chimney fa-fw',
            'fa-sharp fa-regular fa-house-building fa-fw',
            'fa-sharp fa-regular fa-house-blank fa-fw',
            'fa-sharp fa-regular fa-hospitals fa-fw',
            'fa-sharp fa-regular fa-hospital-user fa-fw',
            'fa-sharp fa-regular fa-garage-open fa-fw',
            'fa-sharp fa-regular fa-garage-car fa-fw',
            'fa-sharp fa-regular fa-garage fa-fw',
            'fa-sharp fa-regular fa-ferris-wheel fa-fw',
            'fa-sharp fa-regular fa-fence fa-fw',
            'fa-sharp fa-regular fa-farm fa-fw',
            'fa-sharp fa-regular fa-dungeon fa-fw',
            'fa-sharp fa-regular fa-chimney fa-fw',
            'fa-sharp fa-regular fa-castle fa-fw',
            [
              'fa-sharp fa-regular fa-campground fa-fw',
              'fa-sharp fa-regular fa-cabin fa-fw',
              'fa-sharp fa-regular fa-buildings fa-fw',
              'fa-sharp fa-regular fa-building-wheat fa-fw',
              'fa-sharp fa-regular fa-building-user fa-fw',
              'fa-sharp fa-regular fa-building-un fa-fw',
              'fa-sharp fa-regular fa-building-shield fa-fw',
              'fa-sharp fa-regular fa-building-ngo fa-fw',
              'fa-sharp fa-regular fa-building-lock fa-fw',
              'fa-sharp fa-regular fa-building-flag fa-fw',
              'fa-sharp fa-regular fa-building-columns fa-fw',
              'fa-sharp fa-regular fa-building-circle-xmark fa-fw',
              'fa-sharp fa-regular fa-building-circle-exclamation fa-fw',
              'fa-sharp fa-regular fa-building-circle-check fa-fw',
              'fa-sharp fa-regular fa-building-circle-arrow-right fa-fw',
              'fa-sharp fa-regular fa-bridge-suspension fa-fw',
              'fa-sharp fa-regular fa-arrow-right-to-city fa-fw',
              'fa-sharp fa-regular fa-archway fa-fw',
              'fa-sharp fa-regular fa-apartment fa-fw',
              'fa-sharp fa-light fa-warehouse-full fa-fw',
              'fa-sharp fa-light fa-vihara fa-fw',
              'fa-sharp fa-light fa-tree-city fa-fw',
              'fa-sharp fa-light fa-tower-observation fa-fw',
              'fa-sharp fa-light fa-torii-gate fa-fw',
              'fa-sharp fa-light fa-toilets-portable fa-fw',
              'fa-sharp fa-light fa-toilet-portable fa-fw',
              'fa-sharp fa-light fa-tents fa-fw',
              'fa-sharp fa-light fa-tent-arrows-down fa-fw',
              'fa-sharp fa-light fa-tent-arrow-turn-left fa-fw',
              'fa-sharp fa-light fa-tent-arrow-left-right fa-fw',
              'fa-sharp fa-light fa-tent-arrow-down-to-line fa-fw',
              'fa-sharp fa-light fa-tent fa-fw',
              'fa-sharp fa-light fa-synagogue fa-fw',
              'fa-sharp fa-light fa-store-lock fa-fw',
              'fa-sharp fa-light fa-shop-lock fa-fw',
              'fa-sharp fa-light fa-school-lock fa-fw',
              'fa-sharp fa-light fa-school-flag fa-fw',
              'fa-sharp fa-light fa-school-circle-xmark fa-fw',
              'fa-sharp fa-light fa-school-circle-exclamation fa-fw',
              'fa-sharp fa-light fa-school-circle-check fa-fw',
              'fa-sharp fa-light fa-roller-coaster fa-fw',
              'fa-sharp fa-light fa-oil-well fa-fw',
              'fa-sharp fa-light fa-mountain-city fa-fw',
              'fa-sharp fa-light fa-mosque fa-fw',
              'fa-sharp fa-light fa-monument fa-fw',
              'fa-sharp fa-light fa-landmark-flag fa-fw',
              'fa-sharp fa-light fa-landmark-dome fa-fw',
              'fa-sharp fa-light fa-kaaba fa-fw',
              'fa-sharp fa-light fa-industry-windows fa-fw',
              'fa-sharp fa-light fa-igloo fa-fw',
              'fa-sharp fa-light fa-house-window fa-fw',
              'fa-sharp fa-light fa-house-water fa-fw',
              'fa-sharp fa-light fa-house-turret fa-fw',
              'fa-sharp fa-light fa-house-tree fa-fw',
              'fa-sharp fa-light fa-house-medical-flag fa-fw',
              'fa-sharp fa-light fa-house-medical-circle-xmark fa-fw',
              'fa-sharp fa-light fa-house-medical-circle-exclamation fa-fw',
              'fa-sharp fa-light fa-house-medical-circle-check fa-fw',
              'fa-sharp fa-light fa-house-medical fa-fw',
              'fa-sharp fa-light fa-house-lock fa-fw',
              'fa-sharp fa-light fa-house-flag fa-fw',
              'fa-sharp fa-light fa-house-fire fa-fw',
              'fa-sharp fa-light fa-house-day fa-fw',
              'fa-sharp fa-light fa-house-crack fa-fw',
              'fa-sharp fa-light fa-house-circle-xmark fa-fw',
              'fa-sharp fa-light fa-house-circle-exclamation fa-fw',
              'fa-sharp fa-light fa-house-circle-check fa-fw',
              'fa-sharp fa-light fa-house-chimney-window fa-fw',
              'fa-sharp fa-light fa-house-chimney-medical fa-fw',
              'fa-sharp fa-light fa-house-chimney-crack fa-fw',
              'fa-sharp fa-light fa-house-chimney-blank fa-fw',
              'fa-sharp fa-light fa-house-chimney fa-fw',
              'fa-sharp fa-light fa-house-building fa-fw',
              'fa-sharp fa-light fa-house-blank fa-fw',
              'fa-sharp fa-light fa-hospitals fa-fw',
              'fa-sharp fa-light fa-hospital-user fa-fw',
              'fa-sharp fa-light fa-garage-open fa-fw',
              'fa-sharp fa-light fa-garage-car fa-fw',
              'fa-sharp fa-light fa-garage fa-fw',
              'fa-sharp fa-light fa-ferris-wheel fa-fw',
              'fa-sharp fa-light fa-fence fa-fw',
              'fa-sharp fa-light fa-farm fa-fw',
              'fa-sharp fa-light fa-dungeon fa-fw',
              'fa-sharp fa-light fa-chimney fa-fw',
              'fa-sharp fa-light fa-castle fa-fw',
              'fa-sharp fa-light fa-campground fa-fw',
              'fa-sharp fa-light fa-cabin fa-fw',
              'fa-sharp fa-light fa-buildings fa-fw',
              'fa-sharp fa-light fa-building-wheat fa-fw',
              'fa-sharp fa-light fa-building-user fa-fw',
              'fa-sharp fa-light fa-building-un fa-fw',
              'fa-sharp fa-light fa-building-shield fa-fw',
              'fa-sharp fa-light fa-building-ngo fa-fw',
              'fa-sharp fa-light fa-building-lock fa-fw',
              'fa-sharp fa-light fa-building-flag fa-fw',
              'fa-sharp fa-light fa-building-columns fa-fw',
              'fa-sharp fa-light fa-building-circle-xmark fa-fw',
              'fa-sharp fa-light fa-building-circle-exclamation fa-fw',
              'fa-sharp fa-light fa-building-circle-check fa-fw',
              'fa-sharp fa-light fa-building-circle-arrow-right fa-fw',
              'fa-sharp fa-light fa-bridge-suspension fa-fw',
              'fa-sharp fa-light fa-arrow-right-to-city fa-fw',
              'fa-sharp fa-light fa-archway fa-fw',
              'fa-sharp fa-light fa-apartment fa-fw',
            ],
          ],
        ],
      ],
    },
    {
      title: 'Business',
      items: [
        'fa-solid fa-phone fa-fw',
        'fa-regular fa-phone fa-fw',
        'fa-light fa-phone fa-fw',
        'fa-thin fa-phone fa-fw',
        'fa-duotone fa-phone fa-fw',
        'fa-sharp fa-solid fa-phone fa-fw',
        'fa-sharp fa-regular fa-phone fa-fw',
        'fa-sharp fa-light fa-phone fa-fw',
        'fa-solid fa-envelope fa-fw',
        'fa-regular fa-envelope fa-fw',
        'fa-light fa-envelope fa-fw',
        'fa-thin fa-envelope fa-fw',
        'fa-duotone fa-envelope fa-fw',
        'fa-sharp fa-solid fa-envelope fa-fw',
        'fa-sharp fa-regular fa-envelope fa-fw',
        'fa-sharp fa-light fa-envelope fa-fw',
        'fa-solid fa-pen-nib fa-fw',
        'fa-regular fa-pen-nib fa-fw',
        'fa-light fa-pen-nib fa-fw',
        'fa-thin fa-pen-nib fa-fw',
        'fa-duotone fa-pen-nib fa-fw',
        'fa-sharp fa-solid fa-pen-nib fa-fw',
        'fa-sharp fa-regular fa-pen-nib fa-fw',
        'fa-sharp fa-light fa-pen-nib fa-fw',
        'fa-solid fa-calendar-days fa-fw',
        'fa-regular fa-calendar-days fa-fw',
        'fa-light fa-calendar-days fa-fw',
        'fa-thin fa-calendar-days fa-fw',
        'fa-duotone fa-calendar-days fa-fw',
        'fa-sharp fa-solid fa-calendar-days fa-fw',
        'fa-sharp fa-regular fa-calendar-days fa-fw',
        'fa-sharp fa-light fa-calendar-days fa-fw',
        'fa-solid fa-paperclip fa-fw',
        'fa-regular fa-paperclip fa-fw',
        'fa-light fa-paperclip fa-fw',
        'fa-thin fa-paperclip fa-fw',
        'fa-duotone fa-paperclip fa-fw',
        'fa-sharp fa-solid fa-paperclip fa-fw',
        'fa-sharp fa-regular fa-paperclip fa-fw',
        'fa-sharp fa-light fa-paperclip fa-fw',
        'fa-solid fa-file fa-fw',
        'fa-regular fa-file fa-fw',
        'fa-light fa-file fa-fw',
        'fa-thin fa-file fa-fw',
        'fa-duotone fa-file fa-fw',
        'fa-sharp fa-solid fa-file fa-fw',
        'fa-sharp fa-regular fa-file fa-fw',
        'fa-sharp fa-light fa-file fa-fw',
        'fa-solid fa-clipboard fa-fw',
        'fa-regular fa-clipboard fa-fw',
        'fa-light fa-clipboard fa-fw',
        'fa-thin fa-clipboard fa-fw',
        'fa-duotone fa-clipboard fa-fw',
        'fa-sharp fa-solid fa-clipboard fa-fw',
        'fa-sharp fa-regular fa-clipboard fa-fw',
        'fa-sharp fa-light fa-clipboard fa-fw',
        'fa-solid fa-pen fa-fw',
        'fa-regular fa-pen fa-fw',
        'fa-light fa-pen fa-fw',
        'fa-thin fa-pen fa-fw',
        'fa-duotone fa-pen fa-fw',
        'fa-sharp fa-solid fa-pen fa-fw',
        'fa-sharp fa-regular fa-pen fa-fw',
        'fa-sharp fa-light fa-pen fa-fw',
        'fa-solid fa-tag fa-fw',
        'fa-regular fa-tag fa-fw',
        'fa-light fa-tag fa-fw',
        'fa-thin fa-tag fa-fw',
        'fa-duotone fa-tag fa-fw',
        'fa-sharp fa-solid fa-tag fa-fw',
        'fa-sharp fa-regular fa-tag fa-fw',
        'fa-sharp fa-light fa-tag fa-fw',
        'fa-solid fa-book fa-fw',
        'fa-regular fa-book fa-fw',
        'fa-light fa-book fa-fw',
        'fa-thin fa-book fa-fw',
        'fa-duotone fa-book fa-fw',
        'fa-sharp fa-solid fa-book fa-fw',
        'fa-sharp fa-regular fa-book fa-fw',
        'fa-sharp fa-light fa-book fa-fw',
        'fa-solid fa-print fa-fw',
        'fa-regular fa-print fa-fw',
        'fa-light fa-print fa-fw',
        'fa-thin fa-print fa-fw',
        'fa-duotone fa-print fa-fw',
        'fa-sharp fa-solid fa-print fa-fw',
        'fa-sharp fa-regular fa-print fa-fw',
        'fa-sharp fa-light fa-print fa-fw',
        'fa-solid fa-pen-to-square fa-fw',
        'fa-regular fa-pen-to-square fa-fw',
        'fa-light fa-pen-to-square fa-fw',
        'fa-thin fa-pen-to-square fa-fw',
        'fa-duotone fa-pen-to-square fa-fw',
        'fa-sharp fa-solid fa-pen-to-square fa-fw',
        'fa-sharp fa-regular fa-pen-to-square fa-fw',
        'fa-sharp fa-light fa-pen-to-square fa-fw',
        'fa-solid fa-folder fa-fw',
        'fa-regular fa-folder fa-fw',
        'fa-light fa-folder fa-fw',
        'fa-thin fa-folder fa-fw',
        'fa-duotone fa-folder fa-fw',
        'fa-sharp fa-solid fa-folder fa-fw',
        'fa-sharp fa-regular fa-folder fa-fw',
        'fa-sharp fa-light fa-folder fa-fw',
        'fa-solid fa-folder-open fa-fw',
        'fa-regular fa-folder-open fa-fw',
        'fa-light fa-folder-open fa-fw',
        'fa-thin fa-folder-open fa-fw',
        'fa-duotone fa-folder-open fa-fw',
        'fa-sharp fa-solid fa-folder-open fa-fw',
        'fa-sharp fa-regular fa-folder-open fa-fw',
        'fa-sharp fa-light fa-folder-open fa-fw',
        'fa-solid fa-thumbtack fa-fw',
        'fa-regular fa-thumbtack fa-fw',
        'fa-light fa-thumbtack fa-fw',
        'fa-thin fa-thumbtack fa-fw',
        'fa-duotone fa-thumbtack fa-fw',
        'fa-sharp fa-solid fa-thumbtack fa-fw',
        'fa-sharp fa-regular fa-thumbtack fa-fw',
        'fa-sharp fa-light fa-thumbtack fa-fw',
        'fa-solid fa-globe fa-fw',
        'fa-regular fa-globe fa-fw',
        'fa-light fa-globe fa-fw',
        'fa-thin fa-globe fa-fw',
        'fa-duotone fa-globe fa-fw',
        'fa-sharp fa-solid fa-globe fa-fw',
        'fa-sharp fa-regular fa-globe fa-fw',
        'fa-sharp fa-light fa-globe fa-fw',
        'fa-solid fa-city fa-fw',
        'fa-regular fa-city fa-fw',
        'fa-light fa-city fa-fw',
        'fa-thin fa-city fa-fw',
        'fa-duotone fa-city fa-fw',
        'fa-sharp fa-solid fa-city fa-fw',
        'fa-sharp fa-regular fa-city fa-fw',
        'fa-sharp fa-light fa-city fa-fw',
        'fa-solid fa-briefcase fa-fw',
        'fa-regular fa-briefcase fa-fw',
        'fa-light fa-briefcase fa-fw',
        'fa-thin fa-briefcase fa-fw',
        'fa-duotone fa-briefcase fa-fw',
        'fa-sharp fa-solid fa-briefcase fa-fw',
        'fa-sharp fa-regular fa-briefcase fa-fw',
        'fa-sharp fa-light fa-briefcase fa-fw',
        'fa-solid fa-compass fa-fw',
        'fa-regular fa-compass fa-fw',
        'fa-light fa-compass fa-fw',
        'fa-thin fa-compass fa-fw',
        'fa-duotone fa-compass fa-fw',
        'fa-sharp fa-solid fa-compass fa-fw',
        'fa-sharp fa-regular fa-compass fa-fw',
        'fa-sharp fa-light fa-compass fa-fw',
        'fa-solid fa-address-book fa-fw',
        'fa-regular fa-address-book fa-fw',
        'fa-light fa-address-book fa-fw',
        'fa-thin fa-address-book fa-fw',
        'fa-duotone fa-address-book fa-fw',
        'fa-sharp fa-solid fa-address-book fa-fw',
        'fa-sharp fa-regular fa-address-book fa-fw',
        'fa-sharp fa-light fa-address-book fa-fw',
        'fa-solid fa-business-time fa-fw',
        'fa-regular fa-business-time fa-fw',
        'fa-light fa-business-time fa-fw',
        'fa-thin fa-business-time fa-fw',
        'fa-duotone fa-business-time fa-fw',
        'fa-sharp fa-solid fa-business-time fa-fw',
        'fa-sharp fa-regular fa-business-time fa-fw',
        'fa-sharp fa-light fa-business-time fa-fw',
        'fa-solid fa-computer-classic fa-fw',
        'fa-regular fa-computer-classic fa-fw',
        'fa-light fa-computer-classic fa-fw',
        'fa-thin fa-computer-classic fa-fw',
        'fa-duotone fa-computer-classic fa-fw',
        'fa-sharp fa-solid fa-computer-classic fa-fw',
        'fa-sharp fa-regular fa-computer-classic fa-fw',
        'fa-sharp fa-light fa-computer-classic fa-fw',
        'fa-solid fa-pen-fancy fa-fw',
        'fa-regular fa-pen-fancy fa-fw',
        'fa-light fa-pen-fancy fa-fw',
        'fa-thin fa-pen-fancy fa-fw',
        'fa-duotone fa-pen-fancy fa-fw',
        'fa-sharp fa-solid fa-pen-fancy fa-fw',
        'fa-sharp fa-regular fa-pen-fancy fa-fw',
        'fa-sharp fa-light fa-pen-fancy fa-fw',
        'fa-solid fa-badge-check fa-fw',
        'fa-regular fa-badge-check fa-fw',
        'fa-light fa-badge-check fa-fw',
        'fa-thin fa-badge-check fa-fw',
        'fa-duotone fa-badge-check fa-fw',
        'fa-sharp fa-solid fa-badge-check fa-fw',
        'fa-sharp fa-regular fa-badge-check fa-fw',
        'fa-sharp fa-light fa-badge-check fa-fw',
        'fa-solid fa-mug-saucer fa-fw',
        'fa-regular fa-mug-saucer fa-fw',
        'fa-light fa-mug-saucer fa-fw',
        'fa-thin fa-mug-saucer fa-fw',
        'fa-duotone fa-mug-saucer fa-fw',
        'fa-sharp fa-solid fa-mug-saucer fa-fw',
        'fa-sharp fa-regular fa-mug-saucer fa-fw',
        'fa-sharp fa-light fa-mug-saucer fa-fw',
        'fa-solid fa-landmark fa-fw',
        'fa-regular fa-landmark fa-fw',
        'fa-light fa-landmark fa-fw',
        'fa-thin fa-landmark fa-fw',
        'fa-duotone fa-landmark fa-fw',
        'fa-sharp fa-solid fa-landmark fa-fw',
        'fa-sharp fa-regular fa-landmark fa-fw',
        'fa-sharp fa-light fa-landmark fa-fw',
        'fa-solid fa-chart-simple fa-fw',
        'fa-regular fa-chart-simple fa-fw',
        'fa-light fa-chart-simple fa-fw',
        'fa-thin fa-chart-simple fa-fw',
        'fa-duotone fa-chart-simple fa-fw',
        'fa-sharp fa-solid fa-chart-simple fa-fw',
        'fa-sharp fa-regular fa-chart-simple fa-fw',
        'fa-sharp fa-light fa-chart-simple fa-fw',
        'fa-solid fa-envelopes fa-fw',
        'fa-regular fa-envelopes fa-fw',
        'fa-light fa-envelopes fa-fw',
        'fa-thin fa-envelopes fa-fw',
        'fa-duotone fa-envelopes fa-fw',
        'fa-sharp fa-solid fa-envelopes fa-fw',
        'fa-sharp fa-regular fa-envelopes fa-fw',
        'fa-sharp fa-light fa-envelopes fa-fw',
        'fa-solid fa-diagram-venn fa-fw',
        'fa-regular fa-diagram-venn fa-fw',
        'fa-light fa-diagram-venn fa-fw',
        'fa-thin fa-diagram-venn fa-fw',
        'fa-duotone fa-diagram-venn fa-fw',
        'fa-sharp fa-solid fa-diagram-venn fa-fw',
        'fa-sharp fa-regular fa-diagram-venn fa-fw',
        'fa-sharp fa-light fa-diagram-venn fa-fw',
        'fa-solid fa-calendar fa-fw',
        'fa-regular fa-calendar fa-fw',
        'fa-light fa-calendar fa-fw',
        'fa-thin fa-calendar fa-fw',
        'fa-duotone fa-calendar fa-fw',
        'fa-sharp fa-solid fa-calendar fa-fw',
        'fa-sharp fa-regular fa-calendar fa-fw',
        'fa-sharp fa-light fa-calendar fa-fw',
        'fa-solid fa-pencil fa-fw',
        'fa-regular fa-pencil fa-fw',
        'fa-light fa-pencil fa-fw',
        'fa-thin fa-pencil fa-fw',
        'fa-duotone fa-pencil fa-fw',
        'fa-sharp fa-solid fa-pencil fa-fw',
        'fa-sharp fa-regular fa-pencil fa-fw',
        'fa-sharp fa-light fa-pencil fa-fw',
        'fa-solid fa-phone-volume fa-fw',
        'fa-regular fa-phone-volume fa-fw',
        'fa-light fa-phone-volume fa-fw',
        'fa-thin fa-phone-volume fa-fw',
        'fa-duotone fa-phone-volume fa-fw',
        'fa-sharp fa-solid fa-phone-volume fa-fw',
        'fa-sharp fa-regular fa-phone-volume fa-fw',
        'fa-sharp fa-light fa-phone-volume fa-fw',
        'fa-solid fa-copy fa-fw',
        'fa-regular fa-copy fa-fw',
        'fa-light fa-copy fa-fw',
        'fa-thin fa-copy fa-fw',
        'fa-duotone fa-copy fa-fw',
        'fa-sharp fa-solid fa-copy fa-fw',
        'fa-sharp fa-regular fa-copy fa-fw',
        'fa-sharp fa-light fa-copy fa-fw',
        'fa-solid fa-table fa-fw',
        'fa-regular fa-table fa-fw',
        'fa-light fa-table fa-fw',
        'fa-thin fa-table fa-fw',
        'fa-duotone fa-table fa-fw',
        'fa-sharp fa-solid fa-table fa-fw',
        'fa-sharp fa-regular fa-table fa-fw',
        'fa-sharp fa-light fa-table fa-fw',
        'fa-solid fa-building fa-fw',
        'fa-regular fa-building fa-fw',
        'fa-light fa-building fa-fw',
        'fa-thin fa-building fa-fw',
        'fa-duotone fa-building fa-fw',
        'fa-sharp fa-solid fa-building fa-fw',
        'fa-sharp fa-regular fa-building fa-fw',
        'fa-sharp fa-light fa-building fa-fw',
        'fa-solid fa-network-wired fa-fw',
        'fa-regular fa-network-wired fa-fw',
        'fa-light fa-network-wired fa-fw',
        'fa-thin fa-network-wired fa-fw',
        'fa-duotone fa-network-wired fa-fw',
        'fa-sharp fa-solid fa-network-wired fa-fw',
        'fa-sharp fa-regular fa-network-wired fa-fw',
        'fa-sharp fa-light fa-network-wired fa-fw',
        'fa-solid fa-address-card fa-fw',
        'fa-regular fa-address-card fa-fw',
        'fa-light fa-address-card fa-fw',
        'fa-thin fa-address-card fa-fw',
        'fa-duotone fa-address-card fa-fw',
        'fa-sharp fa-solid fa-address-card fa-fw',
        'fa-sharp fa-regular fa-address-card fa-fw',
        'fa-sharp fa-light fa-address-card fa-fw',
        'fa-solid fa-tags fa-fw',
        'fa-regular fa-tags fa-fw',
        'fa-light fa-tags fa-fw',
        'fa-thin fa-tags fa-fw',
        'fa-duotone fa-tags fa-fw',
        'fa-sharp fa-solid fa-tags fa-fw',
        'fa-sharp fa-regular fa-tags fa-fw',
        'fa-sharp fa-light fa-tags fa-fw',
        'fa-solid fa-registered fa-fw',
        'fa-regular fa-registered fa-fw',
        'fa-light fa-registered fa-fw',
        'fa-thin fa-registered fa-fw',
        'fa-duotone fa-registered fa-fw',
        'fa-sharp fa-solid fa-registered fa-fw',
        'fa-sharp fa-regular fa-registered fa-fw',
        'fa-sharp fa-light fa-registered fa-fw',
        'fa-solid fa-signature fa-fw',
        'fa-regular fa-signature fa-fw',
        'fa-light fa-signature fa-fw',
        'fa-thin fa-signature fa-fw',
        'fa-duotone fa-signature fa-fw',
        'fa-sharp fa-solid fa-signature fa-fw',
        'fa-sharp fa-regular fa-signature fa-fw',
        'fa-sharp fa-light fa-signature fa-fw',
        'fa-solid fa-phone-office fa-fw',
        'fa-regular fa-phone-office fa-fw',
        'fa-light fa-phone-office fa-fw',
        'fa-thin fa-phone-office fa-fw',
        'fa-duotone fa-phone-office fa-fw',
        'fa-sharp fa-solid fa-phone-office fa-fw',
        'fa-sharp fa-regular fa-phone-office fa-fw',
        'fa-sharp fa-light fa-phone-office fa-fw',
        'fa-solid fa-projector fa-fw',
        'fa-regular fa-projector fa-fw',
        'fa-light fa-projector fa-fw',
        'fa-thin fa-projector fa-fw',
        'fa-duotone fa-projector fa-fw',
        'fa-sharp fa-solid fa-projector fa-fw',
        'fa-sharp fa-regular fa-projector fa-fw',
        'fa-sharp fa-light fa-projector fa-fw',
        'fa-solid fa-sitemap fa-fw',
        'fa-regular fa-sitemap fa-fw',
        'fa-light fa-sitemap fa-fw',
        'fa-thin fa-sitemap fa-fw',
        'fa-duotone fa-sitemap fa-fw',
        'fa-sharp fa-solid fa-sitemap fa-fw',
        'fa-sharp fa-regular fa-sitemap fa-fw',
        'fa-sharp fa-light fa-sitemap fa-fw',
        'fa-solid fa-marker fa-fw',
        'fa-regular fa-marker fa-fw',
        'fa-light fa-marker fa-fw',
        'fa-thin fa-marker fa-fw',
        'fa-duotone fa-marker fa-fw',
        'fa-sharp fa-solid fa-marker fa-fw',
        'fa-sharp fa-regular fa-marker fa-fw',
        'fa-sharp fa-light fa-marker fa-fw',
        'fa-solid fa-badge fa-fw',
        'fa-regular fa-badge fa-fw',
        'fa-light fa-badge fa-fw',
        'fa-thin fa-badge fa-fw',
        'fa-duotone fa-badge fa-fw',
        'fa-sharp fa-solid fa-badge fa-fw',
        'fa-sharp fa-regular fa-badge fa-fw',
        'fa-sharp fa-light fa-badge fa-fw',
        'fa-solid fa-wallet fa-fw',
        'fa-regular fa-wallet fa-fw',
        'fa-light fa-wallet fa-fw',
        'fa-thin fa-wallet fa-fw',
        'fa-duotone fa-wallet fa-fw',
        'fa-sharp fa-solid fa-wallet fa-fw',
        'fa-sharp fa-regular fa-wallet fa-fw',
        'fa-sharp fa-light fa-wallet fa-fw',
        'fa-solid fa-copyright fa-fw',
        'fa-regular fa-copyright fa-fw',
        'fa-light fa-copyright fa-fw',
        'fa-thin fa-copyright fa-fw',
        'fa-duotone fa-copyright fa-fw',
        'fa-sharp fa-solid fa-copyright fa-fw',
        'fa-sharp fa-regular fa-copyright fa-fw',
        'fa-sharp fa-light fa-copyright fa-fw',
        'fa-solid fa-bullseye fa-fw',
        'fa-regular fa-bullseye fa-fw',
        'fa-light fa-bullseye fa-fw',
        'fa-thin fa-bullseye fa-fw',
        'fa-duotone fa-bullseye fa-fw',
        'fa-sharp fa-solid fa-bullseye fa-fw',
        'fa-sharp fa-regular fa-bullseye fa-fw',
        'fa-sharp fa-light fa-bullseye fa-fw',
        'fa-solid fa-calculator fa-fw',
        'fa-regular fa-calculator fa-fw',
        'fa-light fa-calculator fa-fw',
        'fa-thin fa-calculator fa-fw',
        'fa-duotone fa-calculator fa-fw',
        'fa-sharp fa-solid fa-calculator fa-fw',
        'fa-sharp fa-regular fa-calculator fa-fw',
        'fa-sharp fa-light fa-calculator fa-fw',
        'fa-solid fa-certificate fa-fw',
        'fa-regular fa-certificate fa-fw',
        'fa-light fa-certificate fa-fw',
        'fa-thin fa-certificate fa-fw',
        'fa-duotone fa-certificate fa-fw',
        'fa-sharp fa-solid fa-certificate fa-fw',
        'fa-sharp fa-regular fa-certificate fa-fw',
        'fa-sharp fa-light fa-certificate fa-fw',
        'fa-solid fa-percent fa-fw',
        'fa-regular fa-percent fa-fw',
        'fa-light fa-percent fa-fw',
        'fa-thin fa-percent fa-fw',
        'fa-duotone fa-percent fa-fw',
        'fa-sharp fa-solid fa-percent fa-fw',
        'fa-sharp fa-regular fa-percent fa-fw',
        'fa-sharp fa-light fa-percent fa-fw',
        'fa-solid fa-eraser fa-fw',
        'fa-regular fa-eraser fa-fw',
        'fa-light fa-eraser fa-fw',
        'fa-thin fa-eraser fa-fw',
        'fa-duotone fa-eraser fa-fw',
        'fa-sharp fa-solid fa-eraser fa-fw',
        'fa-sharp fa-regular fa-eraser fa-fw',
        'fa-sharp fa-light fa-eraser fa-fw',
        'fa-solid fa-file-spreadsheet fa-fw',
        'fa-regular fa-file-spreadsheet fa-fw',
        'fa-light fa-file-spreadsheet fa-fw',
        'fa-thin fa-file-spreadsheet fa-fw',
        'fa-duotone fa-file-spreadsheet fa-fw',
        'fa-sharp fa-solid fa-file-spreadsheet fa-fw',
        'fa-sharp fa-regular fa-file-spreadsheet fa-fw',
        'fa-sharp fa-light fa-file-spreadsheet fa-fw',
        'fa-solid fa-glasses fa-fw',
        'fa-regular fa-glasses fa-fw',
        'fa-light fa-glasses fa-fw',
        'fa-thin fa-glasses fa-fw',
        'fa-duotone fa-glasses fa-fw',
        'fa-sharp fa-solid fa-glasses fa-fw',
        'fa-sharp fa-regular fa-glasses fa-fw',
        'fa-sharp fa-light fa-glasses fa-fw',
        'fa-solid fa-industry fa-fw',
        'fa-regular fa-industry fa-fw',
        'fa-light fa-industry fa-fw',
        'fa-thin fa-industry fa-fw',
        'fa-duotone fa-industry fa-fw',
        'fa-sharp fa-solid fa-industry fa-fw',
        'fa-sharp fa-regular fa-industry fa-fw',
        'fa-sharp fa-light fa-industry fa-fw',
        'fa-solid fa-vault fa-fw',
        'fa-solid fa-user-tie-hair-long fa-fw',
        'fa-solid fa-user-tie-hair fa-fw',
        'fa-solid fa-user-hair-mullet fa-fw',
        'fa-solid fa-trademark fa-fw',
        'fa-solid fa-timeline-arrow fa-fw',
        'fa-solid fa-timeline fa-fw',
        'fa-solid fa-table-tree fa-fw',
        'fa-solid fa-table-rows fa-fw',
        'fa-solid fa-table-pivot fa-fw',
        'fa-solid fa-table-layout fa-fw',
        'fa-solid fa-table-columns fa-fw',
        'fa-solid fa-stapler fa-fw',
        'fa-solid fa-square-poll-vertical fa-fw',
        'fa-solid fa-square-poll-horizontal fa-fw',
        'fa-solid fa-square-phone-flip fa-fw',
        'fa-solid fa-square-phone fa-fw',
        'fa-solid fa-square-pen fa-fw',
        'fa-solid fa-square-kanban fa-fw',
        'fa-solid fa-square-envelope fa-fw',
        'fa-solid fa-socks fa-fw',
        'fa-solid fa-slot-machine fa-fw',
        'fa-solid fa-signature-slash fa-fw',
        'fa-solid fa-signature-lock fa-fw',
        'fa-solid fa-shredder fa-fw',
        'fa-solid fa-scissors fa-fw',
        'fa-solid fa-scanner-image fa-fw',
        'fa-solid fa-scale-unbalanced-flip fa-fw',
        'fa-solid fa-scale-unbalanced fa-fw',
        'fa-solid fa-scale-balanced fa-fw',
        'fa-solid fa-router fa-fw',
        'fa-solid fa-rectangle-pro fa-fw',
        'fa-solid fa-print-slash fa-fw',
        'fa-solid fa-print-magnifying-glass fa-fw',
        'fa-solid fa-presentation-screen fa-fw',
        'fa-solid fa-podium fa-fw',
        'fa-solid fa-phone-slash fa-fw',
        'fa-solid fa-phone-intercom fa-fw',
        'fa-solid fa-phone-flip fa-fw',
        'fa-solid fa-person-chalkboard fa-fw',
        'fa-solid fa-pen-nib-slash fa-fw',
        'fa-solid fa-pen-clip fa-fw',
        'fa-solid fa-paste fa-fw',
        'fa-solid fa-paperclip-vertical fa-fw',
        'fa-solid fa-notebook fa-fw',
        'fa-solid fa-note-sticky fa-fw',
        'fa-solid fa-money-check-pen fa-fw',
        'fa-solid fa-money-check-dollar-pen fa-fw',
        'fa-solid fa-magnifying-glass-chart fa-fw',
        'fa-solid fa-magnifying-glass-arrow-right fa-fw',
        'fa-solid fa-list-tree fa-fw',
        'fa-solid fa-list-timeline fa-fw',
        'fa-solid fa-list-radio fa-fw',
        'fa-solid fa-list-dropdown fa-fw',
        'fa-solid fa-list-check fa-fw',
        'fa-solid fa-laptop-file fa-fw',
        'fa-solid fa-laptop-binary fa-fw',
        'fa-solid fa-lamp-desk fa-fw',
        'fa-solid fa-keynote fa-fw',
        'fa-solid fa-industry-windows fa-fw',
        'fa-solid fa-inboxes fa-fw',
        'fa-solid fa-inbox-full fa-fw',
        'fa-solid fa-house-laptop fa-fw',
        'fa-solid fa-highlighter fa-fw',
        'fa-solid fa-folders fa-fw',
        'fa-solid fa-folder-xmark fa-fw',
        'fa-solid fa-folder-tree fa-fw',
        'fa-solid fa-folder-plus fa-fw',
        'fa-solid fa-folder-minus fa-fw',
        'fa-solid fa-folder-arrow-up fa-fw',
        'fa-solid fa-folder-arrow-down fa-fw',
        'fa-solid fa-floppy-disk-circle-xmark fa-fw',
        'fa-solid fa-floppy-disk-circle-arrow-right fa-fw',
        'fa-solid fa-floppy-disk fa-fw',
        'fa-solid fa-file-user fa-fw',
        'fa-solid fa-file-lines fa-fw',
        'fa-solid fa-file-circle-plus fa-fw',
        'fa-solid fa-file-circle-info fa-fw',
        'fa-solid fa-file-chart-pie fa-fw',
        'fa-solid fa-file-chart-column fa-fw',
        'fa-solid fa-fax fa-fw',
        'fa-solid fa-envelope-open fa-fw',
        'fa-solid fa-envelope-dot fa-fw',
        'fa-solid fa-envelope-circle-check fa-fw',
        'fa-solid fa-coffee-pot fa-fw',
        'fa-solid fa-cloud-word fa-fw',
        'fa-solid fa-clipboard-question fa-fw',
        'fa-solid fa-chart-user fa-fw',
        'fa-solid fa-chart-tree-map fa-fw',
        'fa-solid fa-chart-simple-horizontal fa-fw',
        'fa-solid fa-chart-pyramid fa-fw',
        'fa-solid fa-chart-pie-simple-circle-dollar fa-fw',
        'fa-solid fa-chart-pie-simple-circle-currency fa-fw',
        'fa-solid fa-chart-pie-simple fa-fw',
        'fa-solid fa-chart-pie fa-fw',
        'fa-solid fa-chart-line-up-down fa-fw',
        'fa-solid fa-chart-line-up fa-fw',
        'fa-solid fa-chart-line-down fa-fw',
        'fa-solid fa-chart-line fa-fw',
        'fa-solid fa-cake-candles fa-fw',
        'fa-solid fa-cabinet-filing fa-fw',
        'fa-solid fa-bullhorn fa-fw',
        'fa-solid fa-briefcase-blank fa-fw',
        'fa-solid fa-briefcase-arrow-right fa-fw',
        'fa-solid fa-brain-arrow-curved-right fa-fw',
        'fa-solid fa-boxes-packing fa-fw',
        'fa-solid fa-box-archive fa-fw',
        'fa-solid fa-book-section fa-fw',
        'fa-solid fa-bars-staggered fa-fw',
        'fa-solid fa-bars-progress fa-fw',
        'fa-solid fa-badge-percent fa-fw',
        'fa-solid fa-badge-dollar fa-fw',
        'fa-solid fa-arrows-to-eye fa-fw',
        'fa-solid fa-arrows-to-dot fa-fw',
        'fa-solid fa-arrows-spin fa-fw',
        'fa-solid fa-arrow-progress fa-fw',
        'fa-regular fa-vault fa-fw',
        'fa-regular fa-user-tie-hair-long fa-fw',
        'fa-regular fa-user-tie-hair fa-fw',
        'fa-regular fa-user-hair-mullet fa-fw',
        'fa-regular fa-trademark fa-fw',
        'fa-regular fa-timeline-arrow fa-fw',
        'fa-regular fa-timeline fa-fw',
        'fa-regular fa-table-tree fa-fw',
        'fa-regular fa-table-rows fa-fw',
        'fa-regular fa-table-pivot fa-fw',
        'fa-regular fa-table-layout fa-fw',
        'fa-regular fa-table-columns fa-fw',
        'fa-regular fa-stapler fa-fw',
        'fa-regular fa-square-poll-vertical fa-fw',
        'fa-regular fa-square-poll-horizontal fa-fw',
        'fa-regular fa-square-phone-flip fa-fw',
        'fa-regular fa-square-phone fa-fw',
        'fa-regular fa-square-pen fa-fw',
        'fa-regular fa-square-kanban fa-fw',
        'fa-regular fa-square-envelope fa-fw',
        'fa-regular fa-socks fa-fw',
        'fa-regular fa-slot-machine fa-fw',
        'fa-regular fa-signature-slash fa-fw',
        'fa-regular fa-signature-lock fa-fw',
        'fa-regular fa-shredder fa-fw',
        'fa-regular fa-scissors fa-fw',
        'fa-regular fa-scanner-image fa-fw',
        'fa-regular fa-scale-unbalanced-flip fa-fw',
        'fa-regular fa-scale-unbalanced fa-fw',
        'fa-regular fa-scale-balanced fa-fw',
        'fa-regular fa-router fa-fw',
        'fa-regular fa-rectangle-pro fa-fw',
        'fa-regular fa-print-slash fa-fw',
        'fa-regular fa-print-magnifying-glass fa-fw',
        'fa-regular fa-presentation-screen fa-fw',
        'fa-regular fa-podium fa-fw',
        'fa-regular fa-phone-slash fa-fw',
        'fa-regular fa-phone-intercom fa-fw',
        'fa-regular fa-phone-flip fa-fw',
        'fa-regular fa-person-chalkboard fa-fw',
        'fa-regular fa-pen-nib-slash fa-fw',
        'fa-regular fa-pen-clip fa-fw',
        'fa-regular fa-paste fa-fw',
        'fa-regular fa-paperclip-vertical fa-fw',
        'fa-regular fa-notebook fa-fw',
        'fa-regular fa-note-sticky fa-fw',
        'fa-regular fa-money-check-pen fa-fw',
        'fa-regular fa-money-check-dollar-pen fa-fw',
        'fa-regular fa-magnifying-glass-chart fa-fw',
        'fa-regular fa-magnifying-glass-arrow-right fa-fw',
        'fa-regular fa-list-tree fa-fw',
        'fa-regular fa-list-timeline fa-fw',
        'fa-regular fa-list-radio fa-fw',
        'fa-regular fa-list-dropdown fa-fw',
        'fa-regular fa-list-check fa-fw',
        'fa-regular fa-laptop-file fa-fw',
        'fa-regular fa-laptop-binary fa-fw',
        'fa-regular fa-lamp-desk fa-fw',
        'fa-regular fa-keynote fa-fw',
        'fa-regular fa-industry-windows fa-fw',
        'fa-regular fa-inboxes fa-fw',
        'fa-regular fa-inbox-full fa-fw',
        'fa-regular fa-house-laptop fa-fw',
        'fa-regular fa-highlighter fa-fw',
        'fa-regular fa-folders fa-fw',
        'fa-regular fa-folder-xmark fa-fw',
        'fa-regular fa-folder-tree fa-fw',
        'fa-regular fa-folder-plus fa-fw',
        'fa-regular fa-folder-minus fa-fw',
        'fa-regular fa-folder-arrow-up fa-fw',
        'fa-regular fa-folder-arrow-down fa-fw',
        'fa-regular fa-floppy-disk-circle-xmark fa-fw',
        'fa-regular fa-floppy-disk-circle-arrow-right fa-fw',
        'fa-regular fa-floppy-disk fa-fw',
        'fa-regular fa-file-user fa-fw',
        'fa-regular fa-file-lines fa-fw',
        'fa-regular fa-file-circle-plus fa-fw',
        'fa-regular fa-file-circle-info fa-fw',
        'fa-regular fa-file-chart-pie fa-fw',
        'fa-regular fa-file-chart-column fa-fw',
        'fa-regular fa-fax fa-fw',
        'fa-regular fa-envelope-open fa-fw',
        'fa-regular fa-envelope-dot fa-fw',
        'fa-regular fa-envelope-circle-check fa-fw',
        'fa-regular fa-coffee-pot fa-fw',
        'fa-regular fa-cloud-word fa-fw',
        'fa-regular fa-clipboard-question fa-fw',
        'fa-regular fa-chart-user fa-fw',
        'fa-regular fa-chart-tree-map fa-fw',
        'fa-regular fa-chart-simple-horizontal fa-fw',
        'fa-regular fa-chart-pyramid fa-fw',
        'fa-regular fa-chart-pie-simple-circle-dollar fa-fw',
        'fa-regular fa-chart-pie-simple-circle-currency fa-fw',
        'fa-regular fa-chart-pie-simple fa-fw',
        'fa-regular fa-chart-pie fa-fw',
        'fa-regular fa-chart-line-up-down fa-fw',
        'fa-regular fa-chart-line-up fa-fw',
        'fa-regular fa-chart-line-down fa-fw',
        'fa-regular fa-chart-line fa-fw',
        'fa-regular fa-cake-candles fa-fw',
        'fa-regular fa-cabinet-filing fa-fw',
        'fa-regular fa-bullhorn fa-fw',
        'fa-regular fa-briefcase-blank fa-fw',
        'fa-regular fa-briefcase-arrow-right fa-fw',
        'fa-regular fa-brain-arrow-curved-right fa-fw',
        'fa-regular fa-boxes-packing fa-fw',
        'fa-regular fa-box-archive fa-fw',
        'fa-regular fa-book-section fa-fw',
        'fa-regular fa-bars-staggered fa-fw',
        'fa-regular fa-bars-progress fa-fw',
        'fa-regular fa-badge-percent fa-fw',
        'fa-regular fa-badge-dollar fa-fw',
        'fa-regular fa-arrows-to-eye fa-fw',
        'fa-regular fa-arrows-to-dot fa-fw',
        'fa-regular fa-arrows-spin fa-fw',
        'fa-regular fa-arrow-progress fa-fw',
        'fa-light fa-vault fa-fw',
        'fa-light fa-user-tie-hair-long fa-fw',
        'fa-light fa-user-tie-hair fa-fw',
        'fa-light fa-user-hair-mullet fa-fw',
        'fa-light fa-trademark fa-fw',
        'fa-light fa-timeline-arrow fa-fw',
        'fa-light fa-timeline fa-fw',
        'fa-light fa-table-tree fa-fw',
        'fa-light fa-table-rows fa-fw',
        'fa-light fa-table-pivot fa-fw',
        'fa-light fa-table-layout fa-fw',
        'fa-light fa-table-columns fa-fw',
        'fa-light fa-stapler fa-fw',
        'fa-light fa-square-poll-vertical fa-fw',
        'fa-light fa-square-poll-horizontal fa-fw',
        'fa-light fa-square-phone-flip fa-fw',
        'fa-light fa-square-phone fa-fw',
        'fa-light fa-square-pen fa-fw',
        'fa-light fa-square-kanban fa-fw',
        'fa-light fa-square-envelope fa-fw',
        'fa-light fa-socks fa-fw',
        'fa-light fa-slot-machine fa-fw',
        'fa-light fa-signature-slash fa-fw',
        'fa-light fa-signature-lock fa-fw',
        'fa-light fa-shredder fa-fw',
        'fa-light fa-scissors fa-fw',
        'fa-light fa-scanner-image fa-fw',
        'fa-light fa-scale-unbalanced-flip fa-fw',
        'fa-light fa-scale-unbalanced fa-fw',
        'fa-light fa-scale-balanced fa-fw',
        'fa-light fa-router fa-fw',
        'fa-light fa-rectangle-pro fa-fw',
        'fa-light fa-print-slash fa-fw',
        'fa-light fa-print-magnifying-glass fa-fw',
        'fa-light fa-presentation-screen fa-fw',
        'fa-light fa-podium fa-fw',
        'fa-light fa-phone-slash fa-fw',
        'fa-light fa-phone-intercom fa-fw',
        'fa-light fa-phone-flip fa-fw',
        'fa-light fa-person-chalkboard fa-fw',
        'fa-light fa-pen-nib-slash fa-fw',
        'fa-light fa-pen-clip fa-fw',
        'fa-light fa-paste fa-fw',
        'fa-light fa-paperclip-vertical fa-fw',
        'fa-light fa-notebook fa-fw',
        'fa-light fa-note-sticky fa-fw',
        'fa-light fa-money-check-pen fa-fw',
        'fa-light fa-money-check-dollar-pen fa-fw',
        'fa-light fa-magnifying-glass-chart fa-fw',
        'fa-light fa-magnifying-glass-arrow-right fa-fw',
        'fa-light fa-list-tree fa-fw',
        'fa-light fa-list-timeline fa-fw',
        'fa-light fa-list-radio fa-fw',
        'fa-light fa-list-dropdown fa-fw',
        'fa-light fa-list-check fa-fw',
        'fa-light fa-laptop-file fa-fw',
        'fa-light fa-laptop-binary fa-fw',
        'fa-light fa-lamp-desk fa-fw',
        'fa-light fa-keynote fa-fw',
        'fa-light fa-industry-windows fa-fw',
        'fa-light fa-inboxes fa-fw',
        'fa-light fa-inbox-full fa-fw',
        'fa-light fa-house-laptop fa-fw',
        'fa-light fa-highlighter fa-fw',
        'fa-light fa-folders fa-fw',
        'fa-light fa-folder-xmark fa-fw',
        'fa-light fa-folder-tree fa-fw',
        'fa-light fa-folder-plus fa-fw',
        'fa-light fa-folder-minus fa-fw',
        'fa-light fa-folder-arrow-up fa-fw',
        'fa-light fa-folder-arrow-down fa-fw',
        'fa-light fa-floppy-disk-circle-xmark fa-fw',
        'fa-light fa-floppy-disk-circle-arrow-right fa-fw',
        'fa-light fa-floppy-disk fa-fw',
        'fa-light fa-file-user fa-fw',
        'fa-light fa-file-lines fa-fw',
        'fa-light fa-file-circle-plus fa-fw',
        'fa-light fa-file-circle-info fa-fw',
        'fa-light fa-file-chart-pie fa-fw',
        'fa-light fa-file-chart-column fa-fw',
        'fa-light fa-fax fa-fw',
        'fa-light fa-envelope-open fa-fw',
        'fa-light fa-envelope-dot fa-fw',
        'fa-light fa-envelope-circle-check fa-fw',
        'fa-light fa-coffee-pot fa-fw',
        'fa-light fa-cloud-word fa-fw',
        'fa-light fa-clipboard-question fa-fw',
        'fa-light fa-chart-user fa-fw',
        'fa-light fa-chart-tree-map fa-fw',
        'fa-light fa-chart-simple-horizontal fa-fw',
        'fa-light fa-chart-pyramid fa-fw',
        'fa-light fa-chart-pie-simple-circle-dollar fa-fw',
        'fa-light fa-chart-pie-simple-circle-currency fa-fw',
        'fa-light fa-chart-pie-simple fa-fw',
        'fa-light fa-chart-pie fa-fw',
        'fa-light fa-chart-line-up-down fa-fw',
        'fa-light fa-chart-line-up fa-fw',
        'fa-light fa-chart-line-down fa-fw',
        'fa-light fa-chart-line fa-fw',
        'fa-light fa-cake-candles fa-fw',
        'fa-light fa-cabinet-filing fa-fw',
        'fa-light fa-bullhorn fa-fw',
        'fa-light fa-briefcase-blank fa-fw',
        'fa-light fa-briefcase-arrow-right fa-fw',
        'fa-light fa-brain-arrow-curved-right fa-fw',
        'fa-light fa-boxes-packing fa-fw',
        'fa-light fa-box-archive fa-fw',
        'fa-light fa-book-section fa-fw',
        'fa-light fa-bars-staggered fa-fw',
        'fa-light fa-bars-progress fa-fw',
        'fa-light fa-badge-percent fa-fw',
        'fa-light fa-badge-dollar fa-fw',
        'fa-light fa-arrows-to-eye fa-fw',
        'fa-light fa-arrows-to-dot fa-fw',
        'fa-light fa-arrows-spin fa-fw',
        'fa-light fa-arrow-progress fa-fw',
        'fa-thin fa-vault fa-fw',
        'fa-thin fa-user-tie-hair-long fa-fw',
        'fa-thin fa-user-tie-hair fa-fw',
        'fa-thin fa-user-hair-mullet fa-fw',
        'fa-thin fa-trademark fa-fw',
        'fa-thin fa-timeline-arrow fa-fw',
        'fa-thin fa-timeline fa-fw',
        'fa-thin fa-table-tree fa-fw',
        'fa-thin fa-table-rows fa-fw',
        'fa-thin fa-table-pivot fa-fw',
        'fa-thin fa-table-layout fa-fw',
        'fa-thin fa-table-columns fa-fw',
        'fa-thin fa-stapler fa-fw',
        'fa-thin fa-square-poll-vertical fa-fw',
        'fa-thin fa-square-poll-horizontal fa-fw',
        'fa-thin fa-square-phone-flip fa-fw',
        'fa-thin fa-square-phone fa-fw',
        'fa-thin fa-square-pen fa-fw',
        'fa-thin fa-square-kanban fa-fw',
        'fa-thin fa-square-envelope fa-fw',
        'fa-thin fa-socks fa-fw',
        'fa-thin fa-slot-machine fa-fw',
        'fa-thin fa-signature-slash fa-fw',
        'fa-thin fa-signature-lock fa-fw',
        'fa-thin fa-shredder fa-fw',
        'fa-thin fa-scissors fa-fw',
        'fa-thin fa-scanner-image fa-fw',
        'fa-thin fa-scale-unbalanced-flip fa-fw',
        'fa-thin fa-scale-unbalanced fa-fw',
        'fa-thin fa-scale-balanced fa-fw',
        'fa-thin fa-router fa-fw',
        'fa-thin fa-rectangle-pro fa-fw',
        'fa-thin fa-print-slash fa-fw',
        'fa-thin fa-print-magnifying-glass fa-fw',
        'fa-thin fa-presentation-screen fa-fw',
        'fa-thin fa-podium fa-fw',
        'fa-thin fa-phone-slash fa-fw',
        'fa-thin fa-phone-intercom fa-fw',
        'fa-thin fa-phone-flip fa-fw',
        'fa-thin fa-person-chalkboard fa-fw',
        'fa-thin fa-pen-nib-slash fa-fw',
        'fa-thin fa-pen-clip fa-fw',
        'fa-thin fa-paste fa-fw',
        'fa-thin fa-paperclip-vertical fa-fw',
        'fa-thin fa-notebook fa-fw',
        'fa-thin fa-note-sticky fa-fw',
        'fa-thin fa-money-check-pen fa-fw',
        'fa-thin fa-money-check-dollar-pen fa-fw',
        'fa-thin fa-magnifying-glass-chart fa-fw',
        'fa-thin fa-magnifying-glass-arrow-right fa-fw',
        'fa-thin fa-list-tree fa-fw',
        'fa-thin fa-list-timeline fa-fw',
        'fa-thin fa-list-radio fa-fw',
        'fa-thin fa-list-dropdown fa-fw',
        'fa-thin fa-list-check fa-fw',
        'fa-thin fa-laptop-file fa-fw',
        'fa-thin fa-laptop-binary fa-fw',
        'fa-thin fa-lamp-desk fa-fw',
        'fa-thin fa-keynote fa-fw',
        'fa-thin fa-industry-windows fa-fw',
        'fa-thin fa-inboxes fa-fw',
        'fa-thin fa-inbox-full fa-fw',
        'fa-thin fa-house-laptop fa-fw',
        'fa-thin fa-highlighter fa-fw',
        'fa-thin fa-folders fa-fw',
        'fa-thin fa-folder-xmark fa-fw',
        'fa-thin fa-folder-tree fa-fw',
        'fa-thin fa-folder-plus fa-fw',
        'fa-thin fa-folder-minus fa-fw',
        'fa-thin fa-folder-arrow-up fa-fw',
        'fa-thin fa-folder-arrow-down fa-fw',
        'fa-thin fa-floppy-disk-circle-xmark fa-fw',
        'fa-thin fa-floppy-disk-circle-arrow-right fa-fw',
        'fa-thin fa-floppy-disk fa-fw',
        'fa-thin fa-file-user fa-fw',
        'fa-thin fa-file-lines fa-fw',
        'fa-thin fa-file-circle-plus fa-fw',
        'fa-thin fa-file-circle-info fa-fw',
        'fa-thin fa-file-chart-pie fa-fw',
        'fa-thin fa-file-chart-column fa-fw',
        'fa-thin fa-fax fa-fw',
        'fa-thin fa-envelope-open fa-fw',
        'fa-thin fa-envelope-dot fa-fw',
        'fa-thin fa-envelope-circle-check fa-fw',
        'fa-thin fa-coffee-pot fa-fw',
        'fa-thin fa-cloud-word fa-fw',
        'fa-thin fa-clipboard-question fa-fw',
        'fa-thin fa-chart-user fa-fw',
        'fa-thin fa-chart-tree-map fa-fw',
        'fa-thin fa-chart-simple-horizontal fa-fw',
        'fa-thin fa-chart-pyramid fa-fw',
        'fa-thin fa-chart-pie-simple-circle-dollar fa-fw',
        'fa-thin fa-chart-pie-simple-circle-currency fa-fw',
        'fa-thin fa-chart-pie-simple fa-fw',
        'fa-thin fa-chart-pie fa-fw',
        'fa-thin fa-chart-line-up-down fa-fw',
        'fa-thin fa-chart-line-up fa-fw',
        'fa-thin fa-chart-line-down fa-fw',
        'fa-thin fa-chart-line fa-fw',
        'fa-thin fa-cake-candles fa-fw',
        'fa-thin fa-cabinet-filing fa-fw',
        'fa-thin fa-bullhorn fa-fw',
        'fa-thin fa-briefcase-blank fa-fw',
        'fa-thin fa-briefcase-arrow-right fa-fw',
        'fa-thin fa-brain-arrow-curved-right fa-fw',
        'fa-thin fa-boxes-packing fa-fw',
        'fa-thin fa-box-archive fa-fw',
        'fa-thin fa-book-section fa-fw',
        'fa-thin fa-bars-staggered fa-fw',
        'fa-thin fa-bars-progress fa-fw',
        'fa-thin fa-badge-percent fa-fw',
        'fa-thin fa-badge-dollar fa-fw',
        'fa-thin fa-arrows-to-eye fa-fw',
        'fa-thin fa-arrows-to-dot fa-fw',
        'fa-thin fa-arrows-spin fa-fw',
        'fa-thin fa-arrow-progress fa-fw',
        'fa-duotone fa-vault fa-fw',
        'fa-duotone fa-user-tie-hair-long fa-fw',
        'fa-duotone fa-user-tie-hair fa-fw',
        'fa-duotone fa-user-hair-mullet fa-fw',
        'fa-duotone fa-trademark fa-fw',
        'fa-duotone fa-timeline-arrow fa-fw',
        'fa-duotone fa-timeline fa-fw',
        'fa-duotone fa-table-tree fa-fw',
        'fa-duotone fa-table-rows fa-fw',
        'fa-duotone fa-table-pivot fa-fw',
        'fa-duotone fa-table-layout fa-fw',
        'fa-duotone fa-table-columns fa-fw',
        'fa-duotone fa-stapler fa-fw',
        'fa-duotone fa-square-poll-vertical fa-fw',
        'fa-duotone fa-square-poll-horizontal fa-fw',
        'fa-duotone fa-square-phone-flip fa-fw',
        'fa-duotone fa-square-phone fa-fw',
        'fa-duotone fa-square-pen fa-fw',
        'fa-duotone fa-square-kanban fa-fw',
        'fa-duotone fa-square-envelope fa-fw',
        'fa-duotone fa-socks fa-fw',
        'fa-duotone fa-slot-machine fa-fw',
        'fa-duotone fa-signature-slash fa-fw',
        'fa-duotone fa-signature-lock fa-fw',
        'fa-duotone fa-shredder fa-fw',
        'fa-duotone fa-scissors fa-fw',
        'fa-duotone fa-scanner-image fa-fw',
        'fa-duotone fa-scale-unbalanced-flip fa-fw',
        'fa-duotone fa-scale-unbalanced fa-fw',
        'fa-duotone fa-scale-balanced fa-fw',
        'fa-duotone fa-router fa-fw',
        'fa-duotone fa-rectangle-pro fa-fw',
        'fa-duotone fa-print-slash fa-fw',
        'fa-duotone fa-print-magnifying-glass fa-fw',
        'fa-duotone fa-presentation-screen fa-fw',
        'fa-duotone fa-podium fa-fw',
        'fa-duotone fa-phone-slash fa-fw',
        'fa-duotone fa-phone-intercom fa-fw',
        'fa-duotone fa-phone-flip fa-fw',
        'fa-duotone fa-person-chalkboard fa-fw',
        'fa-duotone fa-pen-nib-slash fa-fw',
        'fa-duotone fa-pen-clip fa-fw',
        'fa-duotone fa-paste fa-fw',
        'fa-duotone fa-paperclip-vertical fa-fw',
        'fa-duotone fa-notebook fa-fw',
        'fa-duotone fa-note-sticky fa-fw',
        'fa-duotone fa-money-check-pen fa-fw',
        'fa-duotone fa-money-check-dollar-pen fa-fw',
        'fa-duotone fa-magnifying-glass-chart fa-fw',
        'fa-duotone fa-magnifying-glass-arrow-right fa-fw',
        'fa-duotone fa-list-tree fa-fw',
        'fa-duotone fa-list-timeline fa-fw',
        'fa-duotone fa-list-radio fa-fw',
        'fa-duotone fa-list-dropdown fa-fw',
        'fa-duotone fa-list-check fa-fw',
        'fa-duotone fa-laptop-file fa-fw',
        'fa-duotone fa-laptop-binary fa-fw',
        'fa-duotone fa-lamp-desk fa-fw',
        'fa-duotone fa-keynote fa-fw',
        'fa-duotone fa-industry-windows fa-fw',
        'fa-duotone fa-inboxes fa-fw',
        'fa-duotone fa-inbox-full fa-fw',
        'fa-duotone fa-house-laptop fa-fw',
        'fa-duotone fa-highlighter fa-fw',
        'fa-duotone fa-folders fa-fw',
        'fa-duotone fa-folder-xmark fa-fw',
        'fa-duotone fa-folder-tree fa-fw',
        'fa-duotone fa-folder-plus fa-fw',
        'fa-duotone fa-folder-minus fa-fw',
        'fa-duotone fa-folder-arrow-up fa-fw',
        'fa-duotone fa-folder-arrow-down fa-fw',
        'fa-duotone fa-floppy-disk-circle-xmark fa-fw',
        'fa-duotone fa-floppy-disk-circle-arrow-right fa-fw',
        'fa-duotone fa-floppy-disk fa-fw',
        'fa-duotone fa-file-user fa-fw',
        'fa-duotone fa-file-lines fa-fw',
        'fa-duotone fa-file-circle-plus fa-fw',
        'fa-duotone fa-file-circle-info fa-fw',
        'fa-duotone fa-file-chart-pie fa-fw',
        'fa-duotone fa-file-chart-column fa-fw',
        'fa-duotone fa-fax fa-fw',
        'fa-duotone fa-envelope-open fa-fw',
        'fa-duotone fa-envelope-dot fa-fw',
        'fa-duotone fa-envelope-circle-check fa-fw',
        'fa-duotone fa-coffee-pot fa-fw',
        'fa-duotone fa-cloud-word fa-fw',
        'fa-duotone fa-clipboard-question fa-fw',
        'fa-duotone fa-chart-user fa-fw',
        'fa-duotone fa-chart-tree-map fa-fw',
        'fa-duotone fa-chart-simple-horizontal fa-fw',
        'fa-duotone fa-chart-pyramid fa-fw',
        'fa-duotone fa-chart-pie-simple-circle-dollar fa-fw',
        'fa-duotone fa-chart-pie-simple-circle-currency fa-fw',
        'fa-duotone fa-chart-pie-simple fa-fw',
        'fa-duotone fa-chart-pie fa-fw',
        'fa-duotone fa-chart-line-up-down fa-fw',
        'fa-duotone fa-chart-line-up fa-fw',
        'fa-duotone fa-chart-line-down fa-fw',
        'fa-duotone fa-chart-line fa-fw',
        'fa-duotone fa-cake-candles fa-fw',
        'fa-duotone fa-cabinet-filing fa-fw',
        'fa-duotone fa-bullhorn fa-fw',
        'fa-duotone fa-briefcase-blank fa-fw',
        'fa-duotone fa-briefcase-arrow-right fa-fw',
        'fa-duotone fa-brain-arrow-curved-right fa-fw',
        'fa-duotone fa-boxes-packing fa-fw',
        'fa-duotone fa-box-archive fa-fw',
        'fa-duotone fa-book-section fa-fw',
        'fa-duotone fa-bars-staggered fa-fw',
        'fa-duotone fa-bars-progress fa-fw',
        'fa-duotone fa-badge-percent fa-fw',
        'fa-duotone fa-badge-dollar fa-fw',
        'fa-duotone fa-arrows-to-eye fa-fw',
        'fa-duotone fa-arrows-to-dot fa-fw',
        'fa-duotone fa-arrows-spin fa-fw',
        'fa-duotone fa-arrow-progress fa-fw',
        'fa-sharp fa-solid fa-vault fa-fw',
        'fa-sharp fa-solid fa-user-tie-hair-long fa-fw',
        'fa-sharp fa-solid fa-user-tie-hair fa-fw',
        'fa-sharp fa-solid fa-user-hair-mullet fa-fw',
        'fa-sharp fa-solid fa-trademark fa-fw',
        'fa-sharp fa-solid fa-timeline-arrow fa-fw',
        'fa-sharp fa-solid fa-timeline fa-fw',
        'fa-sharp fa-solid fa-table-tree fa-fw',
        'fa-sharp fa-solid fa-table-rows fa-fw',
        'fa-sharp fa-solid fa-table-pivot fa-fw',
        'fa-sharp fa-solid fa-table-layout fa-fw',
        'fa-sharp fa-solid fa-table-columns fa-fw',
        'fa-sharp fa-solid fa-stapler fa-fw',
        'fa-sharp fa-solid fa-square-poll-vertical fa-fw',
        'fa-sharp fa-solid fa-square-poll-horizontal fa-fw',
        'fa-sharp fa-solid fa-square-phone-flip fa-fw',
        'fa-sharp fa-solid fa-square-phone fa-fw',
        'fa-sharp fa-solid fa-square-pen fa-fw',
        'fa-sharp fa-solid fa-square-kanban fa-fw',
        'fa-sharp fa-solid fa-square-envelope fa-fw',
        'fa-sharp fa-solid fa-socks fa-fw',
        'fa-sharp fa-solid fa-slot-machine fa-fw',
        'fa-sharp fa-solid fa-signature-slash fa-fw',
        'fa-sharp fa-solid fa-signature-lock fa-fw',
        'fa-sharp fa-solid fa-shredder fa-fw',
        'fa-sharp fa-solid fa-scissors fa-fw',
        'fa-sharp fa-solid fa-scanner-image fa-fw',
        'fa-sharp fa-solid fa-scale-unbalanced-flip fa-fw',
        'fa-sharp fa-solid fa-scale-unbalanced fa-fw',
        'fa-sharp fa-solid fa-scale-balanced fa-fw',
        'fa-sharp fa-solid fa-router fa-fw',
        'fa-sharp fa-solid fa-rectangle-pro fa-fw',
        'fa-sharp fa-solid fa-print-slash fa-fw',
        'fa-sharp fa-solid fa-print-magnifying-glass fa-fw',
        'fa-sharp fa-solid fa-presentation-screen fa-fw',
        'fa-sharp fa-solid fa-podium fa-fw',
        'fa-sharp fa-solid fa-phone-slash fa-fw',
        'fa-sharp fa-solid fa-phone-intercom fa-fw',
        'fa-sharp fa-solid fa-phone-flip fa-fw',
        'fa-sharp fa-solid fa-person-chalkboard fa-fw',
        'fa-sharp fa-solid fa-pen-nib-slash fa-fw',
        'fa-sharp fa-solid fa-pen-clip fa-fw',
        'fa-sharp fa-solid fa-paste fa-fw',
        'fa-sharp fa-solid fa-paperclip-vertical fa-fw',
        'fa-sharp fa-solid fa-notebook fa-fw',
        'fa-sharp fa-solid fa-note-sticky fa-fw',
        'fa-sharp fa-solid fa-money-check-pen fa-fw',
        'fa-sharp fa-solid fa-money-check-dollar-pen fa-fw',
        'fa-sharp fa-solid fa-magnifying-glass-chart fa-fw',
        'fa-sharp fa-solid fa-magnifying-glass-arrow-right fa-fw',
        'fa-sharp fa-solid fa-list-tree fa-fw',
        'fa-sharp fa-solid fa-list-timeline fa-fw',
        'fa-sharp fa-solid fa-list-radio fa-fw',
        'fa-sharp fa-solid fa-list-dropdown fa-fw',
        'fa-sharp fa-solid fa-list-check fa-fw',
        'fa-sharp fa-solid fa-laptop-file fa-fw',
        'fa-sharp fa-solid fa-laptop-binary fa-fw',
        'fa-sharp fa-solid fa-lamp-desk fa-fw',
        'fa-sharp fa-solid fa-keynote fa-fw',
        'fa-sharp fa-solid fa-industry-windows fa-fw',
        'fa-sharp fa-solid fa-inboxes fa-fw',
        'fa-sharp fa-solid fa-inbox-full fa-fw',
        'fa-sharp fa-solid fa-house-laptop fa-fw',
        'fa-sharp fa-solid fa-highlighter fa-fw',
        'fa-sharp fa-solid fa-folders fa-fw',
        'fa-sharp fa-solid fa-folder-xmark fa-fw',
        'fa-sharp fa-solid fa-folder-tree fa-fw',
        'fa-sharp fa-solid fa-folder-plus fa-fw',
        'fa-sharp fa-solid fa-folder-minus fa-fw',
        'fa-sharp fa-solid fa-folder-arrow-up fa-fw',
        'fa-sharp fa-solid fa-folder-arrow-down fa-fw',
        'fa-sharp fa-solid fa-floppy-disk-circle-xmark fa-fw',
        'fa-sharp fa-solid fa-floppy-disk-circle-arrow-right fa-fw',
        'fa-sharp fa-solid fa-floppy-disk fa-fw',
        'fa-sharp fa-solid fa-file-user fa-fw',
        'fa-sharp fa-solid fa-file-lines fa-fw',
        'fa-sharp fa-solid fa-file-circle-plus fa-fw',
        'fa-sharp fa-solid fa-file-circle-info fa-fw',
        'fa-sharp fa-solid fa-file-chart-pie fa-fw',
        'fa-sharp fa-solid fa-file-chart-column fa-fw',
        'fa-sharp fa-solid fa-fax fa-fw',
        'fa-sharp fa-solid fa-envelope-open fa-fw',
        'fa-sharp fa-solid fa-envelope-dot fa-fw',
        'fa-sharp fa-solid fa-envelope-circle-check fa-fw',
        'fa-sharp fa-solid fa-coffee-pot fa-fw',
        'fa-sharp fa-solid fa-cloud-word fa-fw',
        'fa-sharp fa-solid fa-clipboard-question fa-fw',
        'fa-sharp fa-solid fa-chart-user fa-fw',
        'fa-sharp fa-solid fa-chart-tree-map fa-fw',
        'fa-sharp fa-solid fa-chart-simple-horizontal fa-fw',
        'fa-sharp fa-solid fa-chart-pyramid fa-fw',
        'fa-sharp fa-solid fa-chart-pie-simple-circle-dollar fa-fw',
        'fa-sharp fa-solid fa-chart-pie-simple-circle-currency fa-fw',
        'fa-sharp fa-solid fa-chart-pie-simple fa-fw',
        'fa-sharp fa-solid fa-chart-pie fa-fw',
        'fa-sharp fa-solid fa-chart-line-up-down fa-fw',
        'fa-sharp fa-solid fa-chart-line-up fa-fw',
        'fa-sharp fa-solid fa-chart-line-down fa-fw',
        'fa-sharp fa-solid fa-chart-line fa-fw',
        'fa-sharp fa-solid fa-cake-candles fa-fw',
        'fa-sharp fa-solid fa-cabinet-filing fa-fw',
        'fa-sharp fa-solid fa-bullhorn fa-fw',
        'fa-sharp fa-solid fa-briefcase-blank fa-fw',
        'fa-sharp fa-solid fa-briefcase-arrow-right fa-fw',
        'fa-sharp fa-solid fa-brain-arrow-curved-right fa-fw',
        'fa-sharp fa-solid fa-boxes-packing fa-fw',
        'fa-sharp fa-solid fa-box-archive fa-fw',
        'fa-sharp fa-solid fa-book-section fa-fw',
        'fa-sharp fa-solid fa-bars-staggered fa-fw',
        'fa-sharp fa-solid fa-bars-progress fa-fw',
        'fa-sharp fa-solid fa-badge-percent fa-fw',
        'fa-sharp fa-solid fa-badge-dollar fa-fw',
        'fa-sharp fa-solid fa-arrows-to-eye fa-fw',
        'fa-sharp fa-solid fa-arrows-to-dot fa-fw',
        'fa-sharp fa-solid fa-arrows-spin fa-fw',
        'fa-sharp fa-solid fa-arrow-progress fa-fw',
        'fa-sharp fa-regular fa-vault fa-fw',
        'fa-sharp fa-regular fa-user-tie-hair-long fa-fw',
        'fa-sharp fa-regular fa-user-tie-hair fa-fw',
        'fa-sharp fa-regular fa-user-hair-mullet fa-fw',
        'fa-sharp fa-regular fa-trademark fa-fw',
        'fa-sharp fa-regular fa-timeline-arrow fa-fw',
        'fa-sharp fa-regular fa-timeline fa-fw',
        'fa-sharp fa-regular fa-table-tree fa-fw',
        'fa-sharp fa-regular fa-table-rows fa-fw',
        'fa-sharp fa-regular fa-table-pivot fa-fw',
        'fa-sharp fa-regular fa-table-layout fa-fw',
        'fa-sharp fa-regular fa-table-columns fa-fw',
        'fa-sharp fa-regular fa-stapler fa-fw',
        'fa-sharp fa-regular fa-square-poll-vertical fa-fw',
        'fa-sharp fa-regular fa-square-poll-horizontal fa-fw',
        'fa-sharp fa-regular fa-square-phone-flip fa-fw',
        'fa-sharp fa-regular fa-square-phone fa-fw',
        'fa-sharp fa-regular fa-square-pen fa-fw',
        'fa-sharp fa-regular fa-square-kanban fa-fw',
        'fa-sharp fa-regular fa-square-envelope fa-fw',
        'fa-sharp fa-regular fa-socks fa-fw',
        'fa-sharp fa-regular fa-slot-machine fa-fw',
        'fa-sharp fa-regular fa-signature-slash fa-fw',
        'fa-sharp fa-regular fa-signature-lock fa-fw',
        'fa-sharp fa-regular fa-shredder fa-fw',
        'fa-sharp fa-regular fa-scissors fa-fw',
        'fa-sharp fa-regular fa-scanner-image fa-fw',
        'fa-sharp fa-regular fa-scale-unbalanced-flip fa-fw',
        'fa-sharp fa-regular fa-scale-unbalanced fa-fw',
        'fa-sharp fa-regular fa-scale-balanced fa-fw',
        'fa-sharp fa-regular fa-router fa-fw',
        'fa-sharp fa-regular fa-rectangle-pro fa-fw',
        'fa-sharp fa-regular fa-print-slash fa-fw',
        'fa-sharp fa-regular fa-print-magnifying-glass fa-fw',
        'fa-sharp fa-regular fa-presentation-screen fa-fw',
        'fa-sharp fa-regular fa-podium fa-fw',
        'fa-sharp fa-regular fa-phone-slash fa-fw',
        'fa-sharp fa-regular fa-phone-intercom fa-fw',
        'fa-sharp fa-regular fa-phone-flip fa-fw',
        'fa-sharp fa-regular fa-person-chalkboard fa-fw',
        'fa-sharp fa-regular fa-pen-nib-slash fa-fw',
        'fa-sharp fa-regular fa-pen-clip fa-fw',
        'fa-sharp fa-regular fa-paste fa-fw',
        'fa-sharp fa-regular fa-paperclip-vertical fa-fw',
        'fa-sharp fa-regular fa-notebook fa-fw',
        'fa-sharp fa-regular fa-note-sticky fa-fw',
        'fa-sharp fa-regular fa-money-check-pen fa-fw',
        'fa-sharp fa-regular fa-money-check-dollar-pen fa-fw',
        'fa-sharp fa-regular fa-magnifying-glass-chart fa-fw',
        'fa-sharp fa-regular fa-magnifying-glass-arrow-right fa-fw',
        'fa-sharp fa-regular fa-list-tree fa-fw',
        'fa-sharp fa-regular fa-list-timeline fa-fw',
        'fa-sharp fa-regular fa-list-radio fa-fw',
        'fa-sharp fa-regular fa-list-dropdown fa-fw',
        'fa-sharp fa-regular fa-list-check fa-fw',
        'fa-sharp fa-regular fa-laptop-file fa-fw',
        'fa-sharp fa-regular fa-laptop-binary fa-fw',
        'fa-sharp fa-regular fa-lamp-desk fa-fw',
        'fa-sharp fa-regular fa-keynote fa-fw',
        'fa-sharp fa-regular fa-industry-windows fa-fw',
        'fa-sharp fa-regular fa-inboxes fa-fw',
        'fa-sharp fa-regular fa-inbox-full fa-fw',
        'fa-sharp fa-regular fa-house-laptop fa-fw',
        'fa-sharp fa-regular fa-highlighter fa-fw',
        'fa-sharp fa-regular fa-folders fa-fw',
        'fa-sharp fa-regular fa-folder-xmark fa-fw',
        'fa-sharp fa-regular fa-folder-tree fa-fw',
        'fa-sharp fa-regular fa-folder-plus fa-fw',
        'fa-sharp fa-regular fa-folder-minus fa-fw',
        'fa-sharp fa-regular fa-folder-arrow-up fa-fw',
        'fa-sharp fa-regular fa-folder-arrow-down fa-fw',
        'fa-sharp fa-regular fa-floppy-disk-circle-xmark fa-fw',
        'fa-sharp fa-regular fa-floppy-disk-circle-arrow-right fa-fw',
        'fa-sharp fa-regular fa-floppy-disk fa-fw',
        'fa-sharp fa-regular fa-file-user fa-fw',
        'fa-sharp fa-regular fa-file-lines fa-fw',
        'fa-sharp fa-regular fa-file-circle-plus fa-fw',
        'fa-sharp fa-regular fa-file-circle-info fa-fw',
        'fa-sharp fa-regular fa-file-chart-pie fa-fw',
        'fa-sharp fa-regular fa-file-chart-column fa-fw',
        'fa-sharp fa-regular fa-fax fa-fw',
        'fa-sharp fa-regular fa-envelope-open fa-fw',
        'fa-sharp fa-regular fa-envelope-dot fa-fw',
        'fa-sharp fa-regular fa-envelope-circle-check fa-fw',
        'fa-sharp fa-regular fa-coffee-pot fa-fw',
        'fa-sharp fa-regular fa-cloud-word fa-fw',
        'fa-sharp fa-regular fa-clipboard-question fa-fw',
        'fa-sharp fa-regular fa-chart-user fa-fw',
        'fa-sharp fa-regular fa-chart-tree-map fa-fw',
        'fa-sharp fa-regular fa-chart-simple-horizontal fa-fw',
        'fa-sharp fa-regular fa-chart-pyramid fa-fw',
        'fa-sharp fa-regular fa-chart-pie-simple-circle-dollar fa-fw',
        'fa-sharp fa-regular fa-chart-pie-simple-circle-currency fa-fw',
        'fa-sharp fa-regular fa-chart-pie-simple fa-fw',
        'fa-sharp fa-regular fa-chart-pie fa-fw',
        'fa-sharp fa-regular fa-chart-line-up-down fa-fw',
        'fa-sharp fa-regular fa-chart-line-up fa-fw',
        'fa-sharp fa-regular fa-chart-line-down fa-fw',
        'fa-sharp fa-regular fa-chart-line fa-fw',
        'fa-sharp fa-regular fa-cake-candles fa-fw',
        'fa-sharp fa-regular fa-cabinet-filing fa-fw',
        'fa-sharp fa-regular fa-bullhorn fa-fw',
        'fa-sharp fa-regular fa-briefcase-blank fa-fw',
        'fa-sharp fa-regular fa-briefcase-arrow-right fa-fw',
        'fa-sharp fa-regular fa-brain-arrow-curved-right fa-fw',
        'fa-sharp fa-regular fa-boxes-packing fa-fw',
        'fa-sharp fa-regular fa-box-archive fa-fw',
        'fa-sharp fa-regular fa-book-section fa-fw',
        'fa-sharp fa-regular fa-bars-staggered fa-fw',
        'fa-sharp fa-regular fa-bars-progress fa-fw',
        'fa-sharp fa-regular fa-badge-percent fa-fw',
        'fa-sharp fa-regular fa-badge-dollar fa-fw',
        'fa-sharp fa-regular fa-arrows-to-eye fa-fw',
        'fa-sharp fa-regular fa-arrows-to-dot fa-fw',
        'fa-sharp fa-regular fa-arrows-spin fa-fw',
        'fa-sharp fa-regular fa-arrow-progress fa-fw',
        'fa-sharp fa-light fa-vault fa-fw',
        'fa-sharp fa-light fa-user-tie-hair-long fa-fw',
        'fa-sharp fa-light fa-user-tie-hair fa-fw',
        'fa-sharp fa-light fa-user-hair-mullet fa-fw',
        'fa-sharp fa-light fa-trademark fa-fw',
        'fa-sharp fa-light fa-timeline-arrow fa-fw',
        'fa-sharp fa-light fa-timeline fa-fw',
        'fa-sharp fa-light fa-table-tree fa-fw',
        'fa-sharp fa-light fa-table-rows fa-fw',
        'fa-sharp fa-light fa-table-pivot fa-fw',
        'fa-sharp fa-light fa-table-layout fa-fw',
        'fa-sharp fa-light fa-table-columns fa-fw',
        'fa-sharp fa-light fa-stapler fa-fw',
        'fa-sharp fa-light fa-square-poll-vertical fa-fw',
        'fa-sharp fa-light fa-square-poll-horizontal fa-fw',
        'fa-sharp fa-light fa-square-phone-flip fa-fw',
        'fa-sharp fa-light fa-square-phone fa-fw',
        'fa-sharp fa-light fa-square-pen fa-fw',
        'fa-sharp fa-light fa-square-kanban fa-fw',
        'fa-sharp fa-light fa-square-envelope fa-fw',
        'fa-sharp fa-light fa-socks fa-fw',
        'fa-sharp fa-light fa-slot-machine fa-fw',
        'fa-sharp fa-light fa-signature-slash fa-fw',
        'fa-sharp fa-light fa-signature-lock fa-fw',
        'fa-sharp fa-light fa-shredder fa-fw',
        'fa-sharp fa-light fa-scissors fa-fw',
        'fa-sharp fa-light fa-scanner-image fa-fw',
        'fa-sharp fa-light fa-scale-unbalanced-flip fa-fw',
        'fa-sharp fa-light fa-scale-unbalanced fa-fw',
        'fa-sharp fa-light fa-scale-balanced fa-fw',
        'fa-sharp fa-light fa-router fa-fw',
        'fa-sharp fa-light fa-rectangle-pro fa-fw',
        'fa-sharp fa-light fa-print-slash fa-fw',
        'fa-sharp fa-light fa-print-magnifying-glass fa-fw',
        'fa-sharp fa-light fa-presentation-screen fa-fw',
        'fa-sharp fa-light fa-podium fa-fw',
        'fa-sharp fa-light fa-phone-slash fa-fw',
        'fa-sharp fa-light fa-phone-intercom fa-fw',
        'fa-sharp fa-light fa-phone-flip fa-fw',
        'fa-sharp fa-light fa-person-chalkboard fa-fw',
        'fa-sharp fa-light fa-pen-nib-slash fa-fw',
        'fa-sharp fa-light fa-pen-clip fa-fw',
        'fa-sharp fa-light fa-paste fa-fw',
        'fa-sharp fa-light fa-paperclip-vertical fa-fw',
        'fa-sharp fa-light fa-notebook fa-fw',
        'fa-sharp fa-light fa-note-sticky fa-fw',
        'fa-sharp fa-light fa-money-check-pen fa-fw',
        'fa-sharp fa-light fa-money-check-dollar-pen fa-fw',
        'fa-sharp fa-light fa-magnifying-glass-chart fa-fw',
        'fa-sharp fa-light fa-magnifying-glass-arrow-right fa-fw',
        'fa-sharp fa-light fa-list-tree fa-fw',
        'fa-sharp fa-light fa-list-timeline fa-fw',
        'fa-sharp fa-light fa-list-radio fa-fw',
        'fa-sharp fa-light fa-list-dropdown fa-fw',
        'fa-sharp fa-light fa-list-check fa-fw',
        'fa-sharp fa-light fa-laptop-file fa-fw',
        'fa-sharp fa-light fa-laptop-binary fa-fw',
        'fa-sharp fa-light fa-lamp-desk fa-fw',
        'fa-sharp fa-light fa-keynote fa-fw',
        'fa-sharp fa-light fa-industry-windows fa-fw',
        'fa-sharp fa-light fa-inboxes fa-fw',
        'fa-sharp fa-light fa-inbox-full fa-fw',
        'fa-sharp fa-light fa-house-laptop fa-fw',
        'fa-sharp fa-light fa-highlighter fa-fw',
        'fa-sharp fa-light fa-folders fa-fw',
        'fa-sharp fa-light fa-folder-xmark fa-fw',
        'fa-sharp fa-light fa-folder-tree fa-fw',
        'fa-sharp fa-light fa-folder-plus fa-fw',
        'fa-sharp fa-light fa-folder-minus fa-fw',
        'fa-sharp fa-light fa-folder-arrow-up fa-fw',
        'fa-sharp fa-light fa-folder-arrow-down fa-fw',
        'fa-sharp fa-light fa-floppy-disk-circle-xmark fa-fw',
        'fa-sharp fa-light fa-floppy-disk-circle-arrow-right fa-fw',
        'fa-sharp fa-light fa-floppy-disk fa-fw',
        'fa-sharp fa-light fa-file-user fa-fw',
        'fa-sharp fa-light fa-file-lines fa-fw',
        'fa-sharp fa-light fa-file-circle-plus fa-fw',
        'fa-sharp fa-light fa-file-circle-info fa-fw',
        'fa-sharp fa-light fa-file-chart-pie fa-fw',
        'fa-sharp fa-light fa-file-chart-column fa-fw',
        'fa-sharp fa-light fa-fax fa-fw',
        'fa-sharp fa-light fa-envelope-open fa-fw',
        'fa-sharp fa-light fa-envelope-dot fa-fw',
        'fa-sharp fa-light fa-envelope-circle-check fa-fw',
        'fa-sharp fa-light fa-coffee-pot fa-fw',
        'fa-sharp fa-light fa-cloud-word fa-fw',
        'fa-sharp fa-light fa-clipboard-question fa-fw',
        'fa-sharp fa-light fa-chart-user fa-fw',
        'fa-sharp fa-light fa-chart-tree-map fa-fw',
        'fa-sharp fa-light fa-chart-simple-horizontal fa-fw',
        'fa-sharp fa-light fa-chart-pyramid fa-fw',
        'fa-sharp fa-light fa-chart-pie-simple-circle-dollar fa-fw',
        'fa-sharp fa-light fa-chart-pie-simple-circle-currency fa-fw',
        'fa-sharp fa-light fa-chart-pie-simple fa-fw',
        'fa-sharp fa-light fa-chart-pie fa-fw',
        'fa-sharp fa-light fa-chart-line-up-down fa-fw',
        'fa-sharp fa-light fa-chart-line-up fa-fw',
        'fa-sharp fa-light fa-chart-line-down fa-fw',
        'fa-sharp fa-light fa-chart-line fa-fw',
        'fa-sharp fa-light fa-cake-candles fa-fw',
        'fa-sharp fa-light fa-cabinet-filing fa-fw',
        'fa-sharp fa-light fa-bullhorn fa-fw',
        'fa-sharp fa-light fa-briefcase-blank fa-fw',
        'fa-sharp fa-light fa-briefcase-arrow-right fa-fw',
        'fa-sharp fa-light fa-brain-arrow-curved-right fa-fw',
        'fa-sharp fa-light fa-boxes-packing fa-fw',
        'fa-sharp fa-light fa-box-archive fa-fw',
        'fa-sharp fa-light fa-book-section fa-fw',
        'fa-sharp fa-light fa-bars-staggered fa-fw',
        'fa-sharp fa-light fa-bars-progress fa-fw',
        'fa-sharp fa-light fa-badge-percent fa-fw',
        'fa-sharp fa-light fa-badge-dollar fa-fw',
        'fa-sharp fa-light fa-arrows-to-eye fa-fw',
        'fa-sharp fa-light fa-arrows-to-dot fa-fw',
        'fa-sharp fa-light fa-arrows-spin fa-fw',
        'fa-sharp fa-light fa-arrow-progress fa-fw',
      ],
    },
    {
      title: 'Camping',
      items: [
        'fa-solid fa-fire fa-fw',
        'fa-regular fa-fire fa-fw',
        'fa-light fa-fire fa-fw',
        'fa-thin fa-fire fa-fw',
        'fa-duotone fa-fire fa-fw',
        'fa-sharp fa-solid fa-fire fa-fw',
        'fa-sharp fa-regular fa-fire fa-fw',
        'fa-sharp fa-light fa-fire fa-fw',
        'fa-solid fa-grill-hot fa-fw',
        'fa-regular fa-grill-hot fa-fw',
        'fa-light fa-grill-hot fa-fw',
        'fa-thin fa-grill-hot fa-fw',
        'fa-duotone fa-grill-hot fa-fw',
        'fa-sharp fa-solid fa-grill-hot fa-fw',
        'fa-sharp fa-regular fa-grill-hot fa-fw',
        'fa-sharp fa-light fa-grill-hot fa-fw',
        'fa-solid fa-tree fa-fw',
        'fa-regular fa-tree fa-fw',
        'fa-light fa-tree fa-fw',
        'fa-thin fa-tree fa-fw',
        'fa-duotone fa-tree fa-fw',
        'fa-sharp fa-solid fa-tree fa-fw',
        'fa-sharp fa-regular fa-tree fa-fw',
        'fa-sharp fa-light fa-tree fa-fw',
        'fa-solid fa-compass fa-fw',
        'fa-regular fa-compass fa-fw',
        'fa-light fa-compass fa-fw',
        'fa-thin fa-compass fa-fw',
        'fa-duotone fa-compass fa-fw',
        'fa-sharp fa-solid fa-compass fa-fw',
        'fa-sharp fa-regular fa-compass fa-fw',
        'fa-sharp fa-light fa-compass fa-fw',
        'fa-solid fa-binoculars fa-fw',
        'fa-regular fa-binoculars fa-fw',
        'fa-light fa-binoculars fa-fw',
        'fa-thin fa-binoculars fa-fw',
        'fa-duotone fa-binoculars fa-fw',
        'fa-sharp fa-solid fa-binoculars fa-fw',
        'fa-sharp fa-regular fa-binoculars fa-fw',
        'fa-sharp fa-light fa-binoculars fa-fw',
        'fa-solid fa-campfire fa-fw',
        'fa-regular fa-campfire fa-fw',
        'fa-light fa-campfire fa-fw',
        'fa-thin fa-campfire fa-fw',
        'fa-duotone fa-campfire fa-fw',
        'fa-sharp fa-solid fa-campfire fa-fw',
        'fa-sharp fa-regular fa-campfire fa-fw',
        'fa-sharp fa-light fa-campfire fa-fw',
        'fa-solid fa-mountain-sun fa-fw',
        'fa-regular fa-mountain-sun fa-fw',
        'fa-light fa-mountain-sun fa-fw',
        'fa-thin fa-mountain-sun fa-fw',
        'fa-duotone fa-mountain-sun fa-fw',
        'fa-sharp fa-solid fa-mountain-sun fa-fw',
        'fa-sharp fa-regular fa-mountain-sun fa-fw',
        'fa-sharp fa-light fa-mountain-sun fa-fw',
        'fa-solid fa-route fa-fw',
        'fa-regular fa-route fa-fw',
        'fa-light fa-route fa-fw',
        'fa-thin fa-route fa-fw',
        'fa-duotone fa-route fa-fw',
        'fa-sharp fa-solid fa-route fa-fw',
        'fa-sharp fa-regular fa-route fa-fw',
        'fa-sharp fa-light fa-route fa-fw',
        'fa-solid fa-cauldron fa-fw',
        'fa-regular fa-cauldron fa-fw',
        'fa-light fa-cauldron fa-fw',
        'fa-thin fa-cauldron fa-fw',
        'fa-duotone fa-cauldron fa-fw',
        'fa-sharp fa-solid fa-cauldron fa-fw',
        'fa-sharp fa-regular fa-cauldron fa-fw',
        'fa-sharp fa-light fa-cauldron fa-fw',
        'fa-solid fa-trees fa-fw',
        'fa-solid fa-tree-large fa-fw',
        'fa-solid fa-tree-deciduous fa-fw',
        'fa-solid fa-trailer fa-fw',
        'fa-solid fa-toilet-paper-blank fa-fw',
        'fa-solid fa-toilet-paper fa-fw',
        'fa-solid fa-tents fa-fw',
        'fa-solid fa-tent-arrows-down fa-fw',
        'fa-solid fa-tent-arrow-turn-left fa-fw',
        'fa-solid fa-tent-arrow-left-right fa-fw',
        'fa-solid fa-tent-arrow-down-to-line fa-fw',
        'fa-solid fa-tent fa-fw',
        'fa-solid fa-teddy-bear fa-fw',
        'fa-solid fa-tarp-droplet fa-fw',
        'fa-solid fa-tarp fa-fw',
        'fa-solid fa-table-picnic fa-fw',
        'fa-solid fa-sunset fa-fw',
        'fa-solid fa-sunrise fa-fw',
        'fa-solid fa-squirrel fa-fw',
        'fa-solid fa-signs-post fa-fw',
        'fa-solid fa-shovel fa-fw',
        'fa-solid fa-shish-kebab fa-fw',
        'fa-solid fa-rv fa-fw',
        'fa-solid fa-pickaxe fa-fw',
        'fa-solid fa-person-shelter fa-fw',
        'fa-solid fa-person-hiking fa-fw',
        'fa-solid fa-person-biking-mountain fa-fw',
        'fa-solid fa-people-roof fa-fw',
        'fa-solid fa-mountains fa-fw',
        'fa-solid fa-mountain fa-fw',
        'fa-solid fa-mosquito-net fa-fw',
        'fa-solid fa-mosquito fa-fw',
        'fa-solid fa-mattress-pillow fa-fw',
        'fa-solid fa-map-location-dot fa-fw',
        'fa-solid fa-map-location fa-fw',
        'fa-solid fa-map fa-fw',
        'fa-solid fa-kit-medical fa-fw',
        'fa-solid fa-grill-fire fa-fw',
        'fa-solid fa-grill fa-fw',
        'fa-solid fa-frog fa-fw',
        'fa-solid fa-flashlight fa-fw',
        'fa-solid fa-fishing-rod fa-fw',
        'fa-solid fa-fire-smoke fa-fw',
        'fa-solid fa-fire-flame-curved fa-fw',
        'fa-solid fa-fire-burner fa-fw',
        'fa-solid fa-faucet-drip fa-fw',
        'fa-solid fa-faucet fa-fw',
        'fa-solid fa-caravan-simple fa-fw',
        'fa-solid fa-caravan fa-fw',
        'fa-solid fa-campground fa-fw',
        'fa-solid fa-cabin fa-fw',
        'fa-solid fa-bucket fa-fw',
        'fa-solid fa-bottle-water fa-fw',
        'fa-solid fa-boot fa-fw',
        'fa-solid fa-bench-tree fa-fw',
        'fa-solid fa-backpack fa-fw',
        'fa-solid fa-axe fa-fw',
        'fa-solid fa-acorn fa-fw',
        'fa-regular fa-trees fa-fw',
        'fa-regular fa-tree-large fa-fw',
        'fa-regular fa-tree-deciduous fa-fw',
        'fa-regular fa-trailer fa-fw',
        'fa-regular fa-toilet-paper-blank fa-fw',
        'fa-regular fa-toilet-paper fa-fw',
        'fa-regular fa-tents fa-fw',
        'fa-regular fa-tent-arrows-down fa-fw',
        'fa-regular fa-tent-arrow-turn-left fa-fw',
        'fa-regular fa-tent-arrow-left-right fa-fw',
        'fa-regular fa-tent-arrow-down-to-line fa-fw',
        'fa-regular fa-tent fa-fw',
        'fa-regular fa-teddy-bear fa-fw',
        'fa-regular fa-tarp-droplet fa-fw',
        'fa-regular fa-tarp fa-fw',
        'fa-regular fa-table-picnic fa-fw',
        'fa-regular fa-sunset fa-fw',
        'fa-regular fa-sunrise fa-fw',
        'fa-regular fa-squirrel fa-fw',
        'fa-regular fa-signs-post fa-fw',
        'fa-regular fa-shovel fa-fw',
        'fa-regular fa-shish-kebab fa-fw',
        'fa-regular fa-rv fa-fw',
        'fa-regular fa-pickaxe fa-fw',
        'fa-regular fa-person-shelter fa-fw',
        'fa-regular fa-person-hiking fa-fw',
        'fa-regular fa-person-biking-mountain fa-fw',
        'fa-regular fa-people-roof fa-fw',
        'fa-regular fa-mountains fa-fw',
        'fa-regular fa-mountain fa-fw',
        'fa-regular fa-mosquito-net fa-fw',
        'fa-regular fa-mosquito fa-fw',
        'fa-regular fa-mattress-pillow fa-fw',
        'fa-regular fa-map-location-dot fa-fw',
        'fa-regular fa-map-location fa-fw',
        'fa-regular fa-map fa-fw',
        'fa-regular fa-kit-medical fa-fw',
        'fa-regular fa-grill-fire fa-fw',
        'fa-regular fa-grill fa-fw',
        'fa-regular fa-frog fa-fw',
        'fa-regular fa-flashlight fa-fw',
        'fa-regular fa-fishing-rod fa-fw',
        'fa-regular fa-fire-smoke fa-fw',
        'fa-regular fa-fire-flame-curved fa-fw',
        'fa-regular fa-fire-burner fa-fw',
        'fa-regular fa-faucet-drip fa-fw',
        'fa-regular fa-faucet fa-fw',
        'fa-regular fa-caravan-simple fa-fw',
        'fa-regular fa-caravan fa-fw',
        'fa-regular fa-campground fa-fw',
        'fa-regular fa-cabin fa-fw',
        'fa-regular fa-bucket fa-fw',
        'fa-regular fa-bottle-water fa-fw',
        'fa-regular fa-boot fa-fw',
        'fa-regular fa-bench-tree fa-fw',
        'fa-regular fa-backpack fa-fw',
        'fa-regular fa-axe fa-fw',
        'fa-regular fa-acorn fa-fw',
        'fa-light fa-trees fa-fw',
        'fa-light fa-tree-large fa-fw',
        'fa-light fa-tree-deciduous fa-fw',
        'fa-light fa-trailer fa-fw',
        'fa-light fa-toilet-paper-blank fa-fw',
        'fa-light fa-toilet-paper fa-fw',
        'fa-light fa-tents fa-fw',
        'fa-light fa-tent-arrows-down fa-fw',
        'fa-light fa-tent-arrow-turn-left fa-fw',
        'fa-light fa-tent-arrow-left-right fa-fw',
        'fa-light fa-tent-arrow-down-to-line fa-fw',
        'fa-light fa-tent fa-fw',
        'fa-light fa-teddy-bear fa-fw',
        'fa-light fa-tarp-droplet fa-fw',
        'fa-light fa-tarp fa-fw',
        'fa-light fa-table-picnic fa-fw',
        'fa-light fa-sunset fa-fw',
        'fa-light fa-sunrise fa-fw',
        'fa-light fa-squirrel fa-fw',
        'fa-light fa-signs-post fa-fw',
        'fa-light fa-shovel fa-fw',
        'fa-light fa-shish-kebab fa-fw',
        'fa-light fa-rv fa-fw',
        'fa-light fa-pickaxe fa-fw',
        'fa-light fa-person-shelter fa-fw',
        'fa-light fa-person-hiking fa-fw',
        'fa-light fa-person-biking-mountain fa-fw',
        'fa-light fa-people-roof fa-fw',
        'fa-light fa-mountains fa-fw',
        'fa-light fa-mountain fa-fw',
        'fa-light fa-mosquito-net fa-fw',
        'fa-light fa-mosquito fa-fw',
        'fa-light fa-mattress-pillow fa-fw',
        'fa-light fa-map-location-dot fa-fw',
        'fa-light fa-map-location fa-fw',
        'fa-light fa-map fa-fw',
        'fa-light fa-kit-medical fa-fw',
        'fa-light fa-grill-fire fa-fw',
        'fa-light fa-grill fa-fw',
        'fa-light fa-frog fa-fw',
        'fa-light fa-flashlight fa-fw',
        'fa-light fa-fishing-rod fa-fw',
        'fa-light fa-fire-smoke fa-fw',
        'fa-light fa-fire-flame-curved fa-fw',
        'fa-light fa-fire-burner fa-fw',
        'fa-light fa-faucet-drip fa-fw',
        'fa-light fa-faucet fa-fw',
        'fa-light fa-caravan-simple fa-fw',
        'fa-light fa-caravan fa-fw',
        'fa-light fa-campground fa-fw',
        'fa-light fa-cabin fa-fw',
        'fa-light fa-bucket fa-fw',
        'fa-light fa-bottle-water fa-fw',
        'fa-light fa-boot fa-fw',
        'fa-light fa-bench-tree fa-fw',
        'fa-light fa-backpack fa-fw',
        'fa-light fa-axe fa-fw',
        'fa-light fa-acorn fa-fw',
        'fa-thin fa-trees fa-fw',
        'fa-thin fa-tree-large fa-fw',
        'fa-thin fa-tree-deciduous fa-fw',
        'fa-thin fa-trailer fa-fw',
        'fa-thin fa-toilet-paper-blank fa-fw',
        'fa-thin fa-toilet-paper fa-fw',
        'fa-thin fa-tents fa-fw',
        'fa-thin fa-tent-arrows-down fa-fw',
        'fa-thin fa-tent-arrow-turn-left fa-fw',
        'fa-thin fa-tent-arrow-left-right fa-fw',
        'fa-thin fa-tent-arrow-down-to-line fa-fw',
        'fa-thin fa-tent fa-fw',
        'fa-thin fa-teddy-bear fa-fw',
        'fa-thin fa-tarp-droplet fa-fw',
        'fa-thin fa-tarp fa-fw',
        'fa-thin fa-table-picnic fa-fw',
        'fa-thin fa-sunset fa-fw',
        'fa-thin fa-sunrise fa-fw',
        'fa-thin fa-squirrel fa-fw',
        'fa-thin fa-signs-post fa-fw',
        'fa-thin fa-shovel fa-fw',
        'fa-thin fa-shish-kebab fa-fw',
        'fa-thin fa-rv fa-fw',
        'fa-thin fa-pickaxe fa-fw',
        'fa-thin fa-person-shelter fa-fw',
        'fa-thin fa-person-hiking fa-fw',
        'fa-thin fa-person-biking-mountain fa-fw',
        'fa-thin fa-people-roof fa-fw',
        'fa-thin fa-mountains fa-fw',
        'fa-thin fa-mountain fa-fw',
        'fa-thin fa-mosquito-net fa-fw',
        'fa-thin fa-mosquito fa-fw',
        'fa-thin fa-mattress-pillow fa-fw',
        'fa-thin fa-map-location-dot fa-fw',
        'fa-thin fa-map-location fa-fw',
        'fa-thin fa-map fa-fw',
        'fa-thin fa-kit-medical fa-fw',
        'fa-thin fa-grill-fire fa-fw',
        'fa-thin fa-grill fa-fw',
        'fa-thin fa-frog fa-fw',
        'fa-thin fa-flashlight fa-fw',
        'fa-thin fa-fishing-rod fa-fw',
        'fa-thin fa-fire-smoke fa-fw',
        'fa-thin fa-fire-flame-curved fa-fw',
        'fa-thin fa-fire-burner fa-fw',
        'fa-thin fa-faucet-drip fa-fw',
        'fa-thin fa-faucet fa-fw',
        'fa-thin fa-caravan-simple fa-fw',
        'fa-thin fa-caravan fa-fw',
        'fa-thin fa-campground fa-fw',
        'fa-thin fa-cabin fa-fw',
        'fa-thin fa-bucket fa-fw',
        'fa-thin fa-bottle-water fa-fw',
        'fa-thin fa-boot fa-fw',
        'fa-thin fa-bench-tree fa-fw',
        'fa-thin fa-backpack fa-fw',
        'fa-thin fa-axe fa-fw',
        'fa-thin fa-acorn fa-fw',
        'fa-duotone fa-trees fa-fw',
        'fa-duotone fa-tree-large fa-fw',
        'fa-duotone fa-tree-deciduous fa-fw',
        'fa-duotone fa-trailer fa-fw',
        'fa-duotone fa-toilet-paper-blank fa-fw',
        'fa-duotone fa-toilet-paper fa-fw',
        'fa-duotone fa-tents fa-fw',
        'fa-duotone fa-tent-arrows-down fa-fw',
        'fa-duotone fa-tent-arrow-turn-left fa-fw',
        'fa-duotone fa-tent-arrow-left-right fa-fw',
        'fa-duotone fa-tent-arrow-down-to-line fa-fw',
        'fa-duotone fa-tent fa-fw',
        'fa-duotone fa-teddy-bear fa-fw',
        'fa-duotone fa-tarp-droplet fa-fw',
        'fa-duotone fa-tarp fa-fw',
        'fa-duotone fa-table-picnic fa-fw',
        'fa-duotone fa-sunset fa-fw',
        'fa-duotone fa-sunrise fa-fw',
        'fa-duotone fa-squirrel fa-fw',
        'fa-duotone fa-signs-post fa-fw',
        'fa-duotone fa-shovel fa-fw',
        'fa-duotone fa-shish-kebab fa-fw',
        'fa-duotone fa-rv fa-fw',
        'fa-duotone fa-pickaxe fa-fw',
        'fa-duotone fa-person-shelter fa-fw',
        'fa-duotone fa-person-hiking fa-fw',
        'fa-duotone fa-person-biking-mountain fa-fw',
        'fa-duotone fa-people-roof fa-fw',
        'fa-duotone fa-mountains fa-fw',
        'fa-duotone fa-mountain fa-fw',
        'fa-duotone fa-mosquito-net fa-fw',
        'fa-duotone fa-mosquito fa-fw',
        'fa-duotone fa-mattress-pillow fa-fw',
        'fa-duotone fa-map-location-dot fa-fw',
        'fa-duotone fa-map-location fa-fw',
        'fa-duotone fa-map fa-fw',
        'fa-duotone fa-kit-medical fa-fw',
        'fa-duotone fa-grill-fire fa-fw',
        'fa-duotone fa-grill fa-fw',
        'fa-duotone fa-frog fa-fw',
        'fa-duotone fa-flashlight fa-fw',
        'fa-duotone fa-fishing-rod fa-fw',
        'fa-duotone fa-fire-smoke fa-fw',
        'fa-duotone fa-fire-flame-curved fa-fw',
        'fa-duotone fa-fire-burner fa-fw',
        'fa-duotone fa-faucet-drip fa-fw',
        'fa-duotone fa-faucet fa-fw',
        'fa-duotone fa-caravan-simple fa-fw',
        'fa-duotone fa-caravan fa-fw',
        'fa-duotone fa-campground fa-fw',
        'fa-duotone fa-cabin fa-fw',
        'fa-duotone fa-bucket fa-fw',
        'fa-duotone fa-bottle-water fa-fw',
        'fa-duotone fa-boot fa-fw',
        'fa-duotone fa-bench-tree fa-fw',
        'fa-duotone fa-backpack fa-fw',
        'fa-duotone fa-axe fa-fw',
        'fa-duotone fa-acorn fa-fw',
        'fa-sharp fa-solid fa-trees fa-fw',
        'fa-sharp fa-solid fa-tree-large fa-fw',
        'fa-sharp fa-solid fa-tree-deciduous fa-fw',
        'fa-sharp fa-solid fa-trailer fa-fw',
        'fa-sharp fa-solid fa-toilet-paper-blank fa-fw',
        'fa-sharp fa-solid fa-toilet-paper fa-fw',
        'fa-sharp fa-solid fa-tents fa-fw',
        'fa-sharp fa-solid fa-tent-arrows-down fa-fw',
        'fa-sharp fa-solid fa-tent-arrow-turn-left fa-fw',
        'fa-sharp fa-solid fa-tent-arrow-left-right fa-fw',
        'fa-sharp fa-solid fa-tent-arrow-down-to-line fa-fw',
        'fa-sharp fa-solid fa-tent fa-fw',
        'fa-sharp fa-solid fa-teddy-bear fa-fw',
        'fa-sharp fa-solid fa-tarp-droplet fa-fw',
        'fa-sharp fa-solid fa-tarp fa-fw',
        'fa-sharp fa-solid fa-table-picnic fa-fw',
        'fa-sharp fa-solid fa-sunset fa-fw',
        'fa-sharp fa-solid fa-sunrise fa-fw',
        'fa-sharp fa-solid fa-squirrel fa-fw',
        'fa-sharp fa-solid fa-signs-post fa-fw',
        'fa-sharp fa-solid fa-shovel fa-fw',
        'fa-sharp fa-solid fa-shish-kebab fa-fw',
        'fa-sharp fa-solid fa-rv fa-fw',
        'fa-sharp fa-solid fa-pickaxe fa-fw',
        'fa-sharp fa-solid fa-person-shelter fa-fw',
        'fa-sharp fa-solid fa-person-hiking fa-fw',
        'fa-sharp fa-solid fa-person-biking-mountain fa-fw',
        'fa-sharp fa-solid fa-people-roof fa-fw',
        'fa-sharp fa-solid fa-mountains fa-fw',
        'fa-sharp fa-solid fa-mountain fa-fw',
        'fa-sharp fa-solid fa-mosquito-net fa-fw',
        'fa-sharp fa-solid fa-mosquito fa-fw',
        'fa-sharp fa-solid fa-mattress-pillow fa-fw',
        'fa-sharp fa-solid fa-map-location-dot fa-fw',
        'fa-sharp fa-solid fa-map-location fa-fw',
        'fa-sharp fa-solid fa-map fa-fw',
        'fa-sharp fa-solid fa-kit-medical fa-fw',
        'fa-sharp fa-solid fa-grill-fire fa-fw',
        'fa-sharp fa-solid fa-grill fa-fw',
        'fa-sharp fa-solid fa-frog fa-fw',
        'fa-sharp fa-solid fa-flashlight fa-fw',
        'fa-sharp fa-solid fa-fishing-rod fa-fw',
        'fa-sharp fa-solid fa-fire-smoke fa-fw',
        'fa-sharp fa-solid fa-fire-flame-curved fa-fw',
        'fa-sharp fa-solid fa-fire-burner fa-fw',
        'fa-sharp fa-solid fa-faucet-drip fa-fw',
        'fa-sharp fa-solid fa-faucet fa-fw',
        'fa-sharp fa-solid fa-caravan-simple fa-fw',
        'fa-sharp fa-solid fa-caravan fa-fw',
        'fa-sharp fa-solid fa-campground fa-fw',
        'fa-sharp fa-solid fa-cabin fa-fw',
        'fa-sharp fa-solid fa-bucket fa-fw',
        'fa-sharp fa-solid fa-bottle-water fa-fw',
        'fa-sharp fa-solid fa-boot fa-fw',
        'fa-sharp fa-solid fa-bench-tree fa-fw',
        'fa-sharp fa-solid fa-backpack fa-fw',
        'fa-sharp fa-solid fa-axe fa-fw',
        'fa-sharp fa-solid fa-acorn fa-fw',
        'fa-sharp fa-regular fa-trees fa-fw',
        'fa-sharp fa-regular fa-tree-large fa-fw',
        'fa-sharp fa-regular fa-tree-deciduous fa-fw',
        'fa-sharp fa-regular fa-trailer fa-fw',
        'fa-sharp fa-regular fa-toilet-paper-blank fa-fw',
        'fa-sharp fa-regular fa-toilet-paper fa-fw',
        'fa-sharp fa-regular fa-tents fa-fw',
        'fa-sharp fa-regular fa-tent-arrows-down fa-fw',
        'fa-sharp fa-regular fa-tent-arrow-turn-left fa-fw',
        'fa-sharp fa-regular fa-tent-arrow-left-right fa-fw',
        'fa-sharp fa-regular fa-tent-arrow-down-to-line fa-fw',
        'fa-sharp fa-regular fa-tent fa-fw',
        'fa-sharp fa-regular fa-teddy-bear fa-fw',
        'fa-sharp fa-regular fa-tarp-droplet fa-fw',
        'fa-sharp fa-regular fa-tarp fa-fw',
        'fa-sharp fa-regular fa-table-picnic fa-fw',
        'fa-sharp fa-regular fa-sunset fa-fw',
        'fa-sharp fa-regular fa-sunrise fa-fw',
        'fa-sharp fa-regular fa-squirrel fa-fw',
        'fa-sharp fa-regular fa-signs-post fa-fw',
        'fa-sharp fa-regular fa-shovel fa-fw',
        'fa-sharp fa-regular fa-shish-kebab fa-fw',
        'fa-sharp fa-regular fa-rv fa-fw',
        'fa-sharp fa-regular fa-pickaxe fa-fw',
        'fa-sharp fa-regular fa-person-shelter fa-fw',
        'fa-sharp fa-regular fa-person-hiking fa-fw',
        'fa-sharp fa-regular fa-person-biking-mountain fa-fw',
        'fa-sharp fa-regular fa-people-roof fa-fw',
        'fa-sharp fa-regular fa-mountains fa-fw',
        'fa-sharp fa-regular fa-mountain fa-fw',
        'fa-sharp fa-regular fa-mosquito-net fa-fw',
        'fa-sharp fa-regular fa-mosquito fa-fw',
        'fa-sharp fa-regular fa-mattress-pillow fa-fw',
        'fa-sharp fa-regular fa-map-location-dot fa-fw',
        'fa-sharp fa-regular fa-map-location fa-fw',
        'fa-sharp fa-regular fa-map fa-fw',
        'fa-sharp fa-regular fa-kit-medical fa-fw',
        'fa-sharp fa-regular fa-grill-fire fa-fw',
        'fa-sharp fa-regular fa-grill fa-fw',
        'fa-sharp fa-regular fa-frog fa-fw',
        'fa-sharp fa-regular fa-flashlight fa-fw',
        'fa-sharp fa-regular fa-fishing-rod fa-fw',
        'fa-sharp fa-regular fa-fire-smoke fa-fw',
        'fa-sharp fa-regular fa-fire-flame-curved fa-fw',
        'fa-sharp fa-regular fa-fire-burner fa-fw',
        'fa-sharp fa-regular fa-faucet-drip fa-fw',
        'fa-sharp fa-regular fa-faucet fa-fw',
        'fa-sharp fa-regular fa-caravan-simple fa-fw',
        'fa-sharp fa-regular fa-caravan fa-fw',
        'fa-sharp fa-regular fa-campground fa-fw',
        'fa-sharp fa-regular fa-cabin fa-fw',
        'fa-sharp fa-regular fa-bucket fa-fw',
        'fa-sharp fa-regular fa-bottle-water fa-fw',
        'fa-sharp fa-regular fa-boot fa-fw',
        'fa-sharp fa-regular fa-bench-tree fa-fw',
        'fa-sharp fa-regular fa-backpack fa-fw',
        'fa-sharp fa-regular fa-axe fa-fw',
        'fa-sharp fa-regular fa-acorn fa-fw',
        'fa-sharp fa-light fa-trees fa-fw',
        'fa-sharp fa-light fa-tree-large fa-fw',
        'fa-sharp fa-light fa-tree-deciduous fa-fw',
        'fa-sharp fa-light fa-trailer fa-fw',
        'fa-sharp fa-light fa-toilet-paper-blank fa-fw',
        'fa-sharp fa-light fa-toilet-paper fa-fw',
        'fa-sharp fa-light fa-tents fa-fw',
        'fa-sharp fa-light fa-tent-arrows-down fa-fw',
        'fa-sharp fa-light fa-tent-arrow-turn-left fa-fw',
        'fa-sharp fa-light fa-tent-arrow-left-right fa-fw',
        'fa-sharp fa-light fa-tent-arrow-down-to-line fa-fw',
        'fa-sharp fa-light fa-tent fa-fw',
        'fa-sharp fa-light fa-teddy-bear fa-fw',
        'fa-sharp fa-light fa-tarp-droplet fa-fw',
        'fa-sharp fa-light fa-tarp fa-fw',
        'fa-sharp fa-light fa-table-picnic fa-fw',
        'fa-sharp fa-light fa-sunset fa-fw',
        'fa-sharp fa-light fa-sunrise fa-fw',
        'fa-sharp fa-light fa-squirrel fa-fw',
        'fa-sharp fa-light fa-signs-post fa-fw',
        'fa-sharp fa-light fa-shovel fa-fw',
        'fa-sharp fa-light fa-shish-kebab fa-fw',
        'fa-sharp fa-light fa-rv fa-fw',
        'fa-sharp fa-light fa-pickaxe fa-fw',
        'fa-sharp fa-light fa-person-shelter fa-fw',
        'fa-sharp fa-light fa-person-hiking fa-fw',
        'fa-sharp fa-light fa-person-biking-mountain fa-fw',
        'fa-sharp fa-light fa-people-roof fa-fw',
        'fa-sharp fa-light fa-mountains fa-fw',
        'fa-sharp fa-light fa-mountain fa-fw',
        'fa-sharp fa-light fa-mosquito-net fa-fw',
        'fa-sharp fa-light fa-mosquito fa-fw',
        'fa-sharp fa-light fa-mattress-pillow fa-fw',
        'fa-sharp fa-light fa-map-location-dot fa-fw',
        'fa-sharp fa-light fa-map-location fa-fw',
        'fa-sharp fa-light fa-map fa-fw',
        'fa-sharp fa-light fa-kit-medical fa-fw',
        'fa-sharp fa-light fa-grill-fire fa-fw',
        'fa-sharp fa-light fa-grill fa-fw',
        'fa-sharp fa-light fa-frog fa-fw',
        'fa-sharp fa-light fa-flashlight fa-fw',
        'fa-sharp fa-light fa-fishing-rod fa-fw',
        'fa-sharp fa-light fa-fire-smoke fa-fw',
        'fa-sharp fa-light fa-fire-flame-curved fa-fw',
        'fa-sharp fa-light fa-fire-burner fa-fw',
        'fa-sharp fa-light fa-faucet-drip fa-fw',
        'fa-sharp fa-light fa-faucet fa-fw',
        'fa-sharp fa-light fa-caravan-simple fa-fw',
        'fa-sharp fa-light fa-caravan fa-fw',
        'fa-sharp fa-light fa-campground fa-fw',
        'fa-sharp fa-light fa-cabin fa-fw',
        'fa-sharp fa-light fa-bucket fa-fw',
        'fa-sharp fa-light fa-bottle-water fa-fw',
        'fa-sharp fa-light fa-boot fa-fw',
        'fa-sharp fa-light fa-bench-tree fa-fw',
        'fa-sharp fa-light fa-backpack fa-fw',
        'fa-sharp fa-light fa-axe fa-fw',
        'fa-sharp fa-light fa-acorn fa-fw',
      ],
    },

    {
      title: 'Charity',
      items: [
        'fa-solid fa-heart fa-fw',
        'fa-regular fa-heart fa-fw',
        'fa-light fa-heart fa-fw',
        'fa-thin fa-heart fa-fw',
        'fa-duotone fa-heart fa-fw',
        'fa-sharp fa-solid fa-heart fa-fw',
        'fa-sharp fa-regular fa-heart fa-fw',
        'fa-sharp fa-light fa-heart fa-fw',
        'fa-solid fa-gift fa-fw',
        'fa-regular fa-gift fa-fw',
        'fa-light fa-gift fa-fw',
        'fa-thin fa-gift fa-fw',
        'fa-duotone fa-gift fa-fw',
        'fa-sharp fa-solid fa-gift fa-fw',
        'fa-sharp fa-regular fa-gift fa-fw',
        'fa-sharp fa-light fa-gift fa-fw',
        'fa-solid fa-globe fa-fw',
        'fa-regular fa-globe fa-fw',
        'fa-light fa-globe fa-fw',
        'fa-thin fa-globe fa-fw',
        'fa-duotone fa-globe fa-fw',
        'fa-sharp fa-solid fa-globe fa-fw',
        'fa-sharp fa-regular fa-globe fa-fw',
        'fa-sharp fa-light fa-globe fa-fw',
        'fa-solid fa-handshake fa-fw',
        'fa-regular fa-handshake fa-fw',
        'fa-light fa-handshake fa-fw',
        'fa-thin fa-handshake fa-fw',
        'fa-duotone fa-handshake fa-fw',
        'fa-sharp fa-solid fa-handshake fa-fw',
        'fa-sharp fa-regular fa-handshake fa-fw',
        'fa-sharp fa-light fa-handshake fa-fw',
        'fa-solid fa-hand-holding-heart fa-fw',
        'fa-regular fa-hand-holding-heart fa-fw',
        'fa-light fa-hand-holding-heart fa-fw',
        'fa-thin fa-hand-holding-heart fa-fw',
        'fa-duotone fa-hand-holding-heart fa-fw',
        'fa-sharp fa-solid fa-hand-holding-heart fa-fw',
        'fa-sharp fa-regular fa-hand-holding-heart fa-fw',
        'fa-sharp fa-light fa-hand-holding-heart fa-fw',
        'fa-solid fa-square-heart fa-fw',
        'fa-regular fa-square-heart fa-fw',
        'fa-light fa-square-heart fa-fw',
        'fa-thin fa-square-heart fa-fw',
        'fa-duotone fa-square-heart fa-fw',
        'fa-sharp fa-solid fa-square-heart fa-fw',
        'fa-sharp fa-regular fa-square-heart fa-fw',
        'fa-sharp fa-light fa-square-heart fa-fw',
        'fa-solid fa-leaf fa-fw',
        'fa-regular fa-leaf fa-fw',
        'fa-light fa-leaf fa-fw',
        'fa-thin fa-leaf fa-fw',
        'fa-duotone fa-leaf fa-fw',
        'fa-sharp fa-solid fa-leaf fa-fw',
        'fa-sharp fa-regular fa-leaf fa-fw',
        'fa-sharp fa-light fa-leaf fa-fw',
        'fa-solid fa-seedling fa-fw',
        'fa-regular fa-seedling fa-fw',
        'fa-light fa-seedling fa-fw',
        'fa-thin fa-seedling fa-fw',
        'fa-duotone fa-seedling fa-fw',
        'fa-sharp fa-solid fa-seedling fa-fw',
        'fa-sharp fa-regular fa-seedling fa-fw',
        'fa-sharp fa-light fa-seedling fa-fw',
        'fa-solid fa-dollar-sign fa-fw',
        'fa-regular fa-dollar-sign fa-fw',
        'fa-light fa-dollar-sign fa-fw',
        'fa-thin fa-dollar-sign fa-fw',
        'fa-duotone fa-dollar-sign fa-fw',
        'fa-sharp fa-solid fa-dollar-sign fa-fw',
        'fa-sharp fa-regular fa-dollar-sign fa-fw',
        'fa-sharp fa-light fa-dollar-sign fa-fw',
        'fa-solid fa-square-dollar fa-fw',
        'fa-solid fa-ribbon fa-fw',
        'fa-solid fa-piggy-bank fa-fw',
        'fa-solid fa-parachute-box fa-fw',
        'fa-solid fa-money-check-pen fa-fw',
        'fa-solid fa-money-check-dollar-pen fa-fw',
        'fa-solid fa-leaf-heart fa-fw',
        'fa-solid fa-house-heart fa-fw',
        'fa-solid fa-house-chimney-heart fa-fw',
        'fa-solid fa-handshake-simple fa-fw',
        'fa-solid fa-handshake-angle fa-fw',
        'fa-solid fa-hands-holding-heart fa-fw',
        'fa-solid fa-hands-holding-dollar fa-fw',
        'fa-solid fa-hands-holding-circle fa-fw',
        'fa-solid fa-hands-holding-child fa-fw',
        'fa-solid fa-hand-holding-seedling fa-fw',
        'fa-solid fa-hand-holding-hand fa-fw',
        'fa-solid fa-hand-holding-droplet fa-fw',
        'fa-solid fa-hand-holding-dollar fa-fw',
        'fa-solid fa-hand-heart fa-fw',
        'fa-solid fa-dove fa-fw',
        'fa-solid fa-circle-heart fa-fw',
        'fa-solid fa-circle-dollar-to-slot fa-fw',
        'fa-solid fa-circle-dollar fa-fw',
        'fa-solid fa-box-heart fa-fw',
        'fa-solid fa-box-dollar fa-fw',
        'fa-solid fa-book-heart fa-fw',
        'fa-regular fa-square-dollar fa-fw',
        'fa-regular fa-ribbon fa-fw',
        'fa-regular fa-piggy-bank fa-fw',
        'fa-regular fa-parachute-box fa-fw',
        'fa-regular fa-money-check-pen fa-fw',
        'fa-regular fa-money-check-dollar-pen fa-fw',
        'fa-regular fa-leaf-heart fa-fw',
        'fa-regular fa-house-heart fa-fw',
        'fa-regular fa-house-chimney-heart fa-fw',
        'fa-regular fa-handshake-simple fa-fw',
        'fa-regular fa-handshake-angle fa-fw',
        'fa-regular fa-hands-holding-heart fa-fw',
        'fa-regular fa-hands-holding-dollar fa-fw',
        'fa-regular fa-hands-holding-circle fa-fw',
        'fa-regular fa-hands-holding-child fa-fw',
        'fa-regular fa-hand-holding-seedling fa-fw',
        'fa-regular fa-hand-holding-hand fa-fw',
        'fa-regular fa-hand-holding-droplet fa-fw',
        'fa-regular fa-hand-holding-dollar fa-fw',
        'fa-regular fa-hand-heart fa-fw',
        'fa-regular fa-dove fa-fw',
        'fa-regular fa-circle-heart fa-fw',
        'fa-regular fa-circle-dollar-to-slot fa-fw',
        'fa-regular fa-circle-dollar fa-fw',
        'fa-regular fa-box-heart fa-fw',
        'fa-regular fa-box-dollar fa-fw',
        'fa-regular fa-book-heart fa-fw',
        'fa-light fa-square-dollar fa-fw',
        'fa-light fa-ribbon fa-fw',
        'fa-light fa-piggy-bank fa-fw',
        'fa-light fa-parachute-box fa-fw',
        'fa-light fa-money-check-pen fa-fw',
        'fa-light fa-money-check-dollar-pen fa-fw',
        'fa-light fa-leaf-heart fa-fw',
        'fa-light fa-house-heart fa-fw',
        'fa-light fa-house-chimney-heart fa-fw',
        'fa-light fa-handshake-simple fa-fw',
        'fa-light fa-handshake-angle fa-fw',
        'fa-light fa-hands-holding-heart fa-fw',
        'fa-light fa-hands-holding-dollar fa-fw',
        'fa-light fa-hands-holding-circle fa-fw',
        'fa-light fa-hands-holding-child fa-fw',
        'fa-light fa-hand-holding-seedling fa-fw',
        'fa-light fa-hand-holding-hand fa-fw',
        'fa-light fa-hand-holding-droplet fa-fw',
        'fa-light fa-hand-holding-dollar fa-fw',
        'fa-light fa-hand-heart fa-fw',
        'fa-light fa-dove fa-fw',
        'fa-light fa-circle-heart fa-fw',
        'fa-light fa-circle-dollar-to-slot fa-fw',
        'fa-light fa-circle-dollar fa-fw',
        'fa-light fa-box-heart fa-fw',
        'fa-light fa-box-dollar fa-fw',
        'fa-light fa-book-heart fa-fw',
        'fa-thin fa-square-dollar fa-fw',
        'fa-thin fa-ribbon fa-fw',
        'fa-thin fa-piggy-bank fa-fw',
        'fa-thin fa-parachute-box fa-fw',
        'fa-thin fa-money-check-pen fa-fw',
        'fa-thin fa-money-check-dollar-pen fa-fw',
        'fa-thin fa-leaf-heart fa-fw',
        'fa-thin fa-house-heart fa-fw',
        'fa-thin fa-house-chimney-heart fa-fw',
        'fa-thin fa-handshake-simple fa-fw',
        'fa-thin fa-handshake-angle fa-fw',
        'fa-thin fa-hands-holding-heart fa-fw',
        'fa-thin fa-hands-holding-dollar fa-fw',
        'fa-thin fa-hands-holding-circle fa-fw',
        'fa-thin fa-hands-holding-child fa-fw',
        'fa-thin fa-hand-holding-seedling fa-fw',
        'fa-thin fa-hand-holding-hand fa-fw',
        'fa-thin fa-hand-holding-droplet fa-fw',
        'fa-thin fa-hand-holding-dollar fa-fw',
        'fa-thin fa-hand-heart fa-fw',
        'fa-thin fa-dove fa-fw',
        'fa-thin fa-circle-heart fa-fw',
        'fa-thin fa-circle-dollar-to-slot fa-fw',
        'fa-thin fa-circle-dollar fa-fw',
        'fa-thin fa-box-heart fa-fw',
        'fa-thin fa-box-dollar fa-fw',
        'fa-thin fa-book-heart fa-fw',
        'fa-duotone fa-square-dollar fa-fw',
        'fa-duotone fa-ribbon fa-fw',
        'fa-duotone fa-piggy-bank fa-fw',
        'fa-duotone fa-parachute-box fa-fw',
        'fa-duotone fa-money-check-pen fa-fw',
        'fa-duotone fa-money-check-dollar-pen fa-fw',
        'fa-duotone fa-leaf-heart fa-fw',
        'fa-duotone fa-house-heart fa-fw',
        'fa-duotone fa-house-chimney-heart fa-fw',
        'fa-duotone fa-handshake-simple fa-fw',
        'fa-duotone fa-handshake-angle fa-fw',
        'fa-duotone fa-hands-holding-heart fa-fw',
        'fa-duotone fa-hands-holding-dollar fa-fw',
        'fa-duotone fa-hands-holding-circle fa-fw',
        'fa-duotone fa-hands-holding-child fa-fw',
        'fa-duotone fa-hand-holding-seedling fa-fw',
        'fa-duotone fa-hand-holding-hand fa-fw',
        'fa-duotone fa-hand-holding-droplet fa-fw',
        'fa-duotone fa-hand-holding-dollar fa-fw',
        'fa-duotone fa-hand-heart fa-fw',
        'fa-duotone fa-dove fa-fw',
        'fa-duotone fa-circle-heart fa-fw',
        'fa-duotone fa-circle-dollar-to-slot fa-fw',
        'fa-duotone fa-circle-dollar fa-fw',
        'fa-duotone fa-box-heart fa-fw',
        'fa-duotone fa-box-dollar fa-fw',
        'fa-duotone fa-book-heart fa-fw',
        'fa-sharp fa-solid fa-square-dollar fa-fw',
        'fa-sharp fa-solid fa-ribbon fa-fw',
        'fa-sharp fa-solid fa-piggy-bank fa-fw',
        'fa-sharp fa-solid fa-parachute-box fa-fw',
        'fa-sharp fa-solid fa-money-check-pen fa-fw',
        'fa-sharp fa-solid fa-money-check-dollar-pen fa-fw',
        'fa-sharp fa-solid fa-leaf-heart fa-fw',
        'fa-sharp fa-solid fa-house-heart fa-fw',
        'fa-sharp fa-solid fa-house-chimney-heart fa-fw',
        'fa-sharp fa-solid fa-handshake-simple fa-fw',
        'fa-sharp fa-solid fa-handshake-angle fa-fw',
        'fa-sharp fa-solid fa-hands-holding-heart fa-fw',
        'fa-sharp fa-solid fa-hands-holding-dollar fa-fw',
        'fa-sharp fa-solid fa-hands-holding-circle fa-fw',
        'fa-sharp fa-solid fa-hands-holding-child fa-fw',
        'fa-sharp fa-solid fa-hand-holding-seedling fa-fw',
        'fa-sharp fa-solid fa-hand-holding-hand fa-fw',
        'fa-sharp fa-solid fa-hand-holding-droplet fa-fw',
        'fa-sharp fa-solid fa-hand-holding-dollar fa-fw',
        'fa-sharp fa-solid fa-hand-heart fa-fw',
        'fa-sharp fa-solid fa-dove fa-fw',
        'fa-sharp fa-solid fa-circle-heart fa-fw',
        'fa-sharp fa-solid fa-circle-dollar-to-slot fa-fw',
        'fa-sharp fa-solid fa-circle-dollar fa-fw',
        'fa-sharp fa-solid fa-box-heart fa-fw',
        'fa-sharp fa-solid fa-box-dollar fa-fw',
        'fa-sharp fa-solid fa-book-heart fa-fw',
        'fa-sharp fa-regular fa-square-dollar fa-fw',
        'fa-sharp fa-regular fa-ribbon fa-fw',
        'fa-sharp fa-regular fa-piggy-bank fa-fw',
        'fa-sharp fa-regular fa-parachute-box fa-fw',
        'fa-sharp fa-regular fa-money-check-pen fa-fw',
        'fa-sharp fa-regular fa-money-check-dollar-pen fa-fw',
        'fa-sharp fa-regular fa-leaf-heart fa-fw',
        'fa-sharp fa-regular fa-house-heart fa-fw',
        'fa-sharp fa-regular fa-house-chimney-heart fa-fw',
        'fa-sharp fa-regular fa-handshake-simple fa-fw',
        'fa-sharp fa-regular fa-handshake-angle fa-fw',
        'fa-sharp fa-regular fa-hands-holding-heart fa-fw',
        'fa-sharp fa-regular fa-hands-holding-dollar fa-fw',
        'fa-sharp fa-regular fa-hands-holding-circle fa-fw',
        'fa-sharp fa-regular fa-hands-holding-child fa-fw',
        'fa-sharp fa-regular fa-hand-holding-seedling fa-fw',
        'fa-sharp fa-regular fa-hand-holding-hand fa-fw',
        'fa-sharp fa-regular fa-hand-holding-droplet fa-fw',
        'fa-sharp fa-regular fa-hand-holding-dollar fa-fw',
        'fa-sharp fa-regular fa-hand-heart fa-fw',
        'fa-sharp fa-regular fa-dove fa-fw',
        'fa-sharp fa-regular fa-circle-heart fa-fw',
        'fa-sharp fa-regular fa-circle-dollar-to-slot fa-fw',
        'fa-sharp fa-regular fa-circle-dollar fa-fw',
        'fa-sharp fa-regular fa-box-heart fa-fw',
        'fa-sharp fa-regular fa-box-dollar fa-fw',
        'fa-sharp fa-regular fa-book-heart fa-fw',
        'fa-sharp fa-light fa-square-dollar fa-fw',
        'fa-sharp fa-light fa-ribbon fa-fw',
        'fa-sharp fa-light fa-piggy-bank fa-fw',
        'fa-sharp fa-light fa-parachute-box fa-fw',
        'fa-sharp fa-light fa-money-check-pen fa-fw',
        'fa-sharp fa-light fa-money-check-dollar-pen fa-fw',
        'fa-sharp fa-light fa-leaf-heart fa-fw',
        'fa-sharp fa-light fa-house-heart fa-fw',
        'fa-sharp fa-light fa-house-chimney-heart fa-fw',
        'fa-sharp fa-light fa-handshake-simple fa-fw',
        'fa-sharp fa-light fa-handshake-angle fa-fw',
        'fa-sharp fa-light fa-hands-holding-heart fa-fw',
        'fa-sharp fa-light fa-hands-holding-dollar fa-fw',
        'fa-sharp fa-light fa-hands-holding-circle fa-fw',
        'fa-sharp fa-light fa-hands-holding-child fa-fw',
        'fa-sharp fa-light fa-hand-holding-seedling fa-fw',
        'fa-sharp fa-light fa-hand-holding-hand fa-fw',
        'fa-sharp fa-light fa-hand-holding-droplet fa-fw',
        'fa-sharp fa-light fa-hand-holding-dollar fa-fw',
        'fa-sharp fa-light fa-hand-heart fa-fw',
        'fa-sharp fa-light fa-dove fa-fw',
        'fa-sharp fa-light fa-circle-heart fa-fw',
        'fa-sharp fa-light fa-circle-dollar-to-slot fa-fw',
        'fa-sharp fa-light fa-circle-dollar fa-fw',
        'fa-sharp fa-light fa-box-heart fa-fw',
        'fa-sharp fa-light fa-box-dollar fa-fw',
        'fa-sharp fa-light fa-book-heart fa-fw',
      ],
    },

    {
      title: 'Childhood',
      items: [
        'fa-solid fa-balloons fa-fw',
        'fa-regular fa-balloons fa-fw',
        'fa-light fa-balloons fa-fw',
        'fa-thin fa-balloons fa-fw',
        'fa-duotone fa-balloons fa-fw',
        'fa-sharp fa-solid fa-balloons fa-fw',
        'fa-sharp fa-regular fa-balloons fa-fw',
        'fa-sharp fa-light fa-balloons fa-fw',
        'fa-solid fa-bath fa-fw',
        'fa-regular fa-bath fa-fw',
        'fa-light fa-bath fa-fw',
        'fa-thin fa-bath fa-fw',
        'fa-duotone fa-bath fa-fw',
        'fa-sharp fa-solid fa-bath fa-fw',
        'fa-sharp fa-regular fa-bath fa-fw',
        'fa-sharp fa-light fa-bath fa-fw',
        'fa-solid fa-gamepad fa-fw',
        'fa-regular fa-gamepad fa-fw',
        'fa-light fa-gamepad fa-fw',
        'fa-thin fa-gamepad fa-fw',
        'fa-duotone fa-gamepad fa-fw',
        'fa-sharp fa-solid fa-gamepad fa-fw',
        'fa-sharp fa-regular fa-gamepad fa-fw',
        'fa-sharp fa-light fa-gamepad fa-fw',
        'fa-solid fa-block-question fa-fw',
        'fa-regular fa-block-question fa-fw',
        'fa-light fa-block-question fa-fw',
        'fa-thin fa-block-question fa-fw',
        'fa-duotone fa-block-question fa-fw',
        'fa-sharp fa-solid fa-block-question fa-fw',
        'fa-sharp fa-regular fa-block-question fa-fw',
        'fa-sharp fa-light fa-block-question fa-fw',
        'fa-solid fa-thought-bubble fa-fw',
        'fa-regular fa-thought-bubble fa-fw',
        'fa-light fa-thought-bubble fa-fw',
        'fa-thin fa-thought-bubble fa-fw',
        'fa-duotone fa-thought-bubble fa-fw',
        'fa-sharp fa-solid fa-thought-bubble fa-fw',
        'fa-sharp fa-regular fa-thought-bubble fa-fw',
        'fa-sharp fa-light fa-thought-bubble fa-fw',
        'fa-solid fa-school fa-fw',
        'fa-regular fa-school fa-fw',
        'fa-light fa-school fa-fw',
        'fa-thin fa-school fa-fw',
        'fa-duotone fa-school fa-fw',
        'fa-sharp fa-solid fa-school fa-fw',
        'fa-sharp fa-regular fa-school fa-fw',
        'fa-sharp fa-light fa-school fa-fw',
        'fa-solid fa-basketball-hoop fa-fw',
        'fa-regular fa-basketball-hoop fa-fw',
        'fa-light fa-basketball-hoop fa-fw',
        'fa-thin fa-basketball-hoop fa-fw',
        'fa-duotone fa-basketball-hoop fa-fw',
        'fa-sharp fa-solid fa-basketball-hoop fa-fw',
        'fa-sharp fa-regular fa-basketball-hoop fa-fw',
        'fa-sharp fa-light fa-basketball-hoop fa-fw',
        'fa-solid fa-robot fa-fw',
        'fa-regular fa-robot fa-fw',
        'fa-light fa-robot fa-fw',
        'fa-thin fa-robot fa-fw',
        'fa-duotone fa-robot fa-fw',
        'fa-sharp fa-solid fa-robot fa-fw',
        'fa-sharp fa-regular fa-robot fa-fw',
        'fa-sharp fa-light fa-robot fa-fw',
        'fa-solid fa-child fa-fw',
        'fa-regular fa-child fa-fw',
        'fa-light fa-child fa-fw',
        'fa-thin fa-child fa-fw',
        'fa-duotone fa-child fa-fw',
        'fa-sharp fa-solid fa-child fa-fw',
        'fa-sharp fa-regular fa-child fa-fw',
        'fa-sharp fa-light fa-child fa-fw',
        'fa-solid fa-baby fa-fw',
        'fa-regular fa-baby fa-fw',
        'fa-light fa-baby fa-fw',
        'fa-thin fa-baby fa-fw',
        'fa-duotone fa-baby fa-fw',
        'fa-sharp fa-solid fa-baby fa-fw',
        'fa-sharp fa-regular fa-baby fa-fw',
        'fa-sharp fa-light fa-baby fa-fw',
        'fa-solid fa-puzzle-piece fa-fw',
        'fa-regular fa-puzzle-piece fa-fw',
        'fa-light fa-puzzle-piece fa-fw',
        'fa-thin fa-puzzle-piece fa-fw',
        'fa-duotone fa-puzzle-piece fa-fw',
        'fa-sharp fa-solid fa-puzzle-piece fa-fw',
        'fa-sharp fa-regular fa-puzzle-piece fa-fw',
        'fa-sharp fa-light fa-puzzle-piece fa-fw',
        'fa-solid fa-cookie-bite fa-fw',
        'fa-regular fa-cookie-bite fa-fw',
        'fa-light fa-cookie-bite fa-fw',
        'fa-thin fa-cookie-bite fa-fw',
        'fa-duotone fa-cookie-bite fa-fw',
        'fa-sharp fa-solid fa-cookie-bite fa-fw',
        'fa-sharp fa-regular fa-cookie-bite fa-fw',
        'fa-sharp fa-light fa-cookie-bite fa-fw',
        'fa-solid fa-game-console-handheld fa-fw',
        'fa-regular fa-game-console-handheld fa-fw',
        'fa-light fa-game-console-handheld fa-fw',
        'fa-thin fa-game-console-handheld fa-fw',
        'fa-duotone fa-game-console-handheld fa-fw',
        'fa-sharp fa-solid fa-game-console-handheld fa-fw',
        'fa-sharp fa-regular fa-game-console-handheld fa-fw',
        'fa-sharp fa-light fa-game-console-handheld fa-fw',
        'fa-solid fa-tricycle fa-fw',
        'fa-solid fa-teddy-bear fa-fw',
        'fa-solid fa-soft-serve fa-fw',
        'fa-solid fa-snowman-head fa-fw',
        'fa-solid fa-snowman fa-fw',
        'fa-solid fa-shapes fa-fw',
        'fa-solid fa-roller-coaster fa-fw',
        'fa-solid fa-puzzle fa-fw',
        'fa-solid fa-pretzel fa-fw',
        'fa-solid fa-popsicle fa-fw',
        'fa-solid fa-pool-8-ball fa-fw',
        'fa-solid fa-pinata fa-fw',
        'fa-solid fa-person-sledding fa-fw',
        'fa-solid fa-person-breastfeeding fa-fw',
        'fa-solid fa-person-biking fa-fw',
        'fa-solid fa-mitten fa-fw',
        'fa-solid fa-lollipop fa-fw',
        'fa-solid fa-ice-cream fa-fw',
        'fa-solid fa-hands-holding-child fa-fw',
        'fa-solid fa-gun-squirt fa-fw',
        'fa-solid fa-globe-snow fa-fw',
        'fa-solid fa-gamepad-modern fa-fw',
        'fa-solid fa-flashlight fa-fw',
        'fa-solid fa-ferris-wheel fa-fw',
        'fa-solid fa-family-pants fa-fw',
        'fa-solid fa-family-dress fa-fw',
        'fa-solid fa-family fa-fw',
        'fa-solid fa-duck fa-fw',
        'fa-solid fa-cupcake fa-fw',
        'fa-solid fa-cubes-stacked fa-fw',
        'fa-solid fa-cookie fa-fw',
        'fa-solid fa-children fa-fw',
        'fa-solid fa-child-reaching fa-fw',
        'fa-solid fa-child-dress fa-fw',
        'fa-solid fa-candy-bar fa-fw',
        'fa-solid fa-candy fa-fw',
        'fa-solid fa-cake-slice fa-fw',
        'fa-solid fa-cake-candles fa-fw',
        'fa-solid fa-bucket fa-fw',
        'fa-solid fa-bowl-soft-serve fa-fw',
        'fa-solid fa-block fa-fw',
        'fa-solid fa-bell-school-slash fa-fw',
        'fa-solid fa-bell-school fa-fw',
        'fa-solid fa-baseball-bat-ball fa-fw',
        'fa-solid fa-balloon fa-fw',
        'fa-solid fa-ball-pile fa-fw',
        'fa-solid fa-backpack fa-fw',
        'fa-solid fa-baby-carriage fa-fw',
        'fa-solid fa-apple-whole fa-fw',
        'fa-regular fa-tricycle fa-fw',
        'fa-regular fa-teddy-bear fa-fw',
        'fa-regular fa-soft-serve fa-fw',
        'fa-regular fa-snowman-head fa-fw',
        'fa-regular fa-snowman fa-fw',
        'fa-regular fa-shapes fa-fw',
        'fa-regular fa-roller-coaster fa-fw',
        'fa-regular fa-puzzle fa-fw',
        'fa-regular fa-pretzel fa-fw',
        'fa-regular fa-popsicle fa-fw',
        'fa-regular fa-pool-8-ball fa-fw',
        'fa-regular fa-pinata fa-fw',
        'fa-regular fa-person-sledding fa-fw',
        'fa-regular fa-person-breastfeeding fa-fw',
        'fa-regular fa-person-biking fa-fw',
        'fa-regular fa-mitten fa-fw',
        'fa-regular fa-lollipop fa-fw',
        'fa-regular fa-ice-cream fa-fw',
        'fa-regular fa-hands-holding-child fa-fw',
        'fa-regular fa-gun-squirt fa-fw',
        'fa-regular fa-globe-snow fa-fw',
        'fa-regular fa-gamepad-modern fa-fw',
        'fa-regular fa-flashlight fa-fw',
        'fa-regular fa-ferris-wheel fa-fw',
        'fa-regular fa-family-pants fa-fw',
        'fa-regular fa-family-dress fa-fw',
        'fa-regular fa-family fa-fw',
        'fa-regular fa-duck fa-fw',
        'fa-regular fa-cupcake fa-fw',
        'fa-regular fa-cubes-stacked fa-fw',
        'fa-regular fa-cookie fa-fw',
        'fa-regular fa-children fa-fw',
        'fa-regular fa-child-reaching fa-fw',
        'fa-regular fa-child-dress fa-fw',
        'fa-regular fa-candy-bar fa-fw',
        'fa-regular fa-candy fa-fw',
        'fa-regular fa-cake-slice fa-fw',
        'fa-regular fa-cake-candles fa-fw',
        'fa-regular fa-bucket fa-fw',
        'fa-regular fa-bowl-soft-serve fa-fw',
        'fa-regular fa-block fa-fw',
        'fa-regular fa-bell-school-slash fa-fw',
        'fa-regular fa-bell-school fa-fw',
        'fa-regular fa-baseball-bat-ball fa-fw',
        'fa-regular fa-balloon fa-fw',
        'fa-regular fa-ball-pile fa-fw',
        'fa-regular fa-backpack fa-fw',
        'fa-regular fa-baby-carriage fa-fw',
        'fa-regular fa-apple-whole fa-fw',
        'fa-light fa-tricycle fa-fw',
        'fa-light fa-teddy-bear fa-fw',
        'fa-light fa-soft-serve fa-fw',
        'fa-light fa-snowman-head fa-fw',
        'fa-light fa-snowman fa-fw',
        'fa-light fa-shapes fa-fw',
        'fa-light fa-roller-coaster fa-fw',
        'fa-light fa-puzzle fa-fw',
        'fa-light fa-pretzel fa-fw',
        'fa-light fa-popsicle fa-fw',
        'fa-light fa-pool-8-ball fa-fw',
        'fa-light fa-pinata fa-fw',
        'fa-light fa-person-sledding fa-fw',
        'fa-light fa-person-breastfeeding fa-fw',
        'fa-light fa-person-biking fa-fw',
        'fa-light fa-mitten fa-fw',
        'fa-light fa-lollipop fa-fw',
        'fa-light fa-ice-cream fa-fw',
        'fa-light fa-hands-holding-child fa-fw',
        'fa-light fa-gun-squirt fa-fw',
        'fa-light fa-globe-snow fa-fw',
        'fa-light fa-gamepad-modern fa-fw',
        'fa-light fa-flashlight fa-fw',
        'fa-light fa-ferris-wheel fa-fw',
        'fa-light fa-family-pants fa-fw',
        'fa-light fa-family-dress fa-fw',
        'fa-light fa-family fa-fw',
        'fa-light fa-duck fa-fw',
        'fa-light fa-cupcake fa-fw',
        'fa-light fa-cubes-stacked fa-fw',
        'fa-light fa-cookie fa-fw',
        'fa-light fa-children fa-fw',
        'fa-light fa-child-reaching fa-fw',
        'fa-light fa-child-dress fa-fw',
        'fa-light fa-candy-bar fa-fw',
        'fa-light fa-candy fa-fw',
        'fa-light fa-cake-slice fa-fw',
        'fa-light fa-cake-candles fa-fw',
        'fa-light fa-bucket fa-fw',
        'fa-light fa-bowl-soft-serve fa-fw',
        'fa-light fa-block fa-fw',
        'fa-light fa-bell-school-slash fa-fw',
        'fa-light fa-bell-school fa-fw',
        'fa-light fa-baseball-bat-ball fa-fw',
        'fa-light fa-balloon fa-fw',
        'fa-light fa-ball-pile fa-fw',
        'fa-light fa-backpack fa-fw',
        'fa-light fa-baby-carriage fa-fw',
        'fa-light fa-apple-whole fa-fw',
        'fa-thin fa-tricycle fa-fw',
        'fa-thin fa-teddy-bear fa-fw',
        'fa-thin fa-soft-serve fa-fw',
        'fa-thin fa-snowman-head fa-fw',
        'fa-thin fa-snowman fa-fw',
        'fa-thin fa-shapes fa-fw',
        'fa-thin fa-roller-coaster fa-fw',
        'fa-thin fa-puzzle fa-fw',
        'fa-thin fa-pretzel fa-fw',
        'fa-thin fa-popsicle fa-fw',
        'fa-thin fa-pool-8-ball fa-fw',
        'fa-thin fa-pinata fa-fw',
        'fa-thin fa-person-sledding fa-fw',
        'fa-thin fa-person-breastfeeding fa-fw',
        'fa-thin fa-person-biking fa-fw',
        'fa-thin fa-mitten fa-fw',
        'fa-thin fa-lollipop fa-fw',
        'fa-thin fa-ice-cream fa-fw',
        'fa-thin fa-hands-holding-child fa-fw',
        'fa-thin fa-gun-squirt fa-fw',
        'fa-thin fa-globe-snow fa-fw',
        'fa-thin fa-gamepad-modern fa-fw',
        'fa-thin fa-flashlight fa-fw',
        'fa-thin fa-ferris-wheel fa-fw',
        'fa-thin fa-family-pants fa-fw',
        'fa-thin fa-family-dress fa-fw',
        'fa-thin fa-family fa-fw',
        'fa-thin fa-duck fa-fw',
        'fa-thin fa-cupcake fa-fw',
        'fa-thin fa-cubes-stacked fa-fw',
        'fa-thin fa-cookie fa-fw',
        'fa-thin fa-children fa-fw',
        'fa-thin fa-child-reaching fa-fw',
        'fa-thin fa-child-dress fa-fw',
        'fa-thin fa-candy-bar fa-fw',
        'fa-thin fa-candy fa-fw',
        'fa-thin fa-cake-slice fa-fw',
        'fa-thin fa-cake-candles fa-fw',
        'fa-thin fa-bucket fa-fw',
        'fa-thin fa-bowl-soft-serve fa-fw',
        'fa-thin fa-block fa-fw',
        'fa-thin fa-bell-school-slash fa-fw',
        'fa-thin fa-bell-school fa-fw',
        'fa-thin fa-baseball-bat-ball fa-fw',
        'fa-thin fa-balloon fa-fw',
        'fa-thin fa-ball-pile fa-fw',
        'fa-thin fa-backpack fa-fw',
        'fa-thin fa-baby-carriage fa-fw',
        'fa-thin fa-apple-whole fa-fw',
        'fa-duotone fa-tricycle fa-fw',
        'fa-duotone fa-teddy-bear fa-fw',
        'fa-duotone fa-soft-serve fa-fw',
        'fa-duotone fa-snowman-head fa-fw',
        'fa-duotone fa-snowman fa-fw',
        'fa-duotone fa-shapes fa-fw',
        'fa-duotone fa-roller-coaster fa-fw',
        'fa-duotone fa-puzzle fa-fw',
        'fa-duotone fa-pretzel fa-fw',
        'fa-duotone fa-popsicle fa-fw',
        'fa-duotone fa-pool-8-ball fa-fw',
        'fa-duotone fa-pinata fa-fw',
        'fa-duotone fa-person-sledding fa-fw',
        'fa-duotone fa-person-breastfeeding fa-fw',
        'fa-duotone fa-person-biking fa-fw',
        'fa-duotone fa-mitten fa-fw',
        'fa-duotone fa-lollipop fa-fw',
        'fa-duotone fa-ice-cream fa-fw',
        'fa-duotone fa-hands-holding-child fa-fw',
        'fa-duotone fa-gun-squirt fa-fw',
        'fa-duotone fa-globe-snow fa-fw',
        'fa-duotone fa-gamepad-modern fa-fw',
        'fa-duotone fa-flashlight fa-fw',
        'fa-duotone fa-ferris-wheel fa-fw',
        'fa-duotone fa-family-pants fa-fw',
        'fa-duotone fa-family-dress fa-fw',
        'fa-duotone fa-family fa-fw',
        'fa-duotone fa-duck fa-fw',
        'fa-duotone fa-cupcake fa-fw',
        'fa-duotone fa-cubes-stacked fa-fw',
        'fa-duotone fa-cookie fa-fw',
        'fa-duotone fa-children fa-fw',
        'fa-duotone fa-child-reaching fa-fw',
        'fa-duotone fa-child-dress fa-fw',
        'fa-duotone fa-candy-bar fa-fw',
        'fa-duotone fa-candy fa-fw',
        'fa-duotone fa-cake-slice fa-fw',
        'fa-duotone fa-cake-candles fa-fw',
        'fa-duotone fa-bucket fa-fw',
        'fa-duotone fa-bowl-soft-serve fa-fw',
        'fa-duotone fa-block fa-fw',
        'fa-duotone fa-bell-school-slash fa-fw',
        'fa-duotone fa-bell-school fa-fw',
        'fa-duotone fa-baseball-bat-ball fa-fw',
        'fa-duotone fa-balloon fa-fw',
        'fa-duotone fa-ball-pile fa-fw',
        'fa-duotone fa-backpack fa-fw',
        'fa-duotone fa-baby-carriage fa-fw',
        'fa-duotone fa-apple-whole fa-fw',
        'fa-sharp fa-solid fa-tricycle fa-fw',
        'fa-sharp fa-solid fa-teddy-bear fa-fw',
        'fa-sharp fa-solid fa-soft-serve fa-fw',
        'fa-sharp fa-solid fa-snowman-head fa-fw',
        'fa-sharp fa-solid fa-snowman fa-fw',
        'fa-sharp fa-solid fa-shapes fa-fw',
        'fa-sharp fa-solid fa-roller-coaster fa-fw',
        'fa-sharp fa-solid fa-puzzle fa-fw',
        'fa-sharp fa-solid fa-pretzel fa-fw',
        'fa-sharp fa-solid fa-popsicle fa-fw',
        'fa-sharp fa-solid fa-pool-8-ball fa-fw',
        'fa-sharp fa-solid fa-pinata fa-fw',
        'fa-sharp fa-solid fa-person-sledding fa-fw',
        'fa-sharp fa-solid fa-person-breastfeeding fa-fw',
        'fa-sharp fa-solid fa-person-biking fa-fw',
        'fa-sharp fa-solid fa-mitten fa-fw',
        'fa-sharp fa-solid fa-lollipop fa-fw',
        'fa-sharp fa-solid fa-ice-cream fa-fw',
        'fa-sharp fa-solid fa-hands-holding-child fa-fw',
        'fa-sharp fa-solid fa-gun-squirt fa-fw',
        'fa-sharp fa-solid fa-globe-snow fa-fw',
        'fa-sharp fa-solid fa-gamepad-modern fa-fw',
        'fa-sharp fa-solid fa-flashlight fa-fw',
        'fa-sharp fa-solid fa-ferris-wheel fa-fw',
        'fa-sharp fa-solid fa-family-pants fa-fw',
        'fa-sharp fa-solid fa-family-dress fa-fw',
        'fa-sharp fa-solid fa-family fa-fw',
        'fa-sharp fa-solid fa-duck fa-fw',
        'fa-sharp fa-solid fa-cupcake fa-fw',
        'fa-sharp fa-solid fa-cubes-stacked fa-fw',
        'fa-sharp fa-solid fa-cookie fa-fw',
        'fa-sharp fa-solid fa-children fa-fw',
        'fa-sharp fa-solid fa-child-reaching fa-fw',
        'fa-sharp fa-solid fa-child-dress fa-fw',
        'fa-sharp fa-solid fa-candy-bar fa-fw',
        'fa-sharp fa-solid fa-candy fa-fw',
        'fa-sharp fa-solid fa-cake-slice fa-fw',
        'fa-sharp fa-solid fa-cake-candles fa-fw',
        'fa-sharp fa-solid fa-bucket fa-fw',
        'fa-sharp fa-solid fa-bowl-soft-serve fa-fw',
        'fa-sharp fa-solid fa-block fa-fw',
        'fa-sharp fa-solid fa-bell-school-slash fa-fw',
        'fa-sharp fa-solid fa-bell-school fa-fw',
        'fa-sharp fa-solid fa-baseball-bat-ball fa-fw',
        'fa-sharp fa-solid fa-balloon fa-fw',
        'fa-sharp fa-solid fa-ball-pile fa-fw',
        'fa-sharp fa-solid fa-backpack fa-fw',
        'fa-sharp fa-solid fa-baby-carriage fa-fw',
        'fa-sharp fa-solid fa-apple-whole fa-fw',
        'fa-sharp fa-regular fa-tricycle fa-fw',
        'fa-sharp fa-regular fa-teddy-bear fa-fw',
        'fa-sharp fa-regular fa-soft-serve fa-fw',
        'fa-sharp fa-regular fa-snowman-head fa-fw',
        'fa-sharp fa-regular fa-snowman fa-fw',
        'fa-sharp fa-regular fa-shapes fa-fw',
        'fa-sharp fa-regular fa-roller-coaster fa-fw',
        'fa-sharp fa-regular fa-puzzle fa-fw',
        'fa-sharp fa-regular fa-pretzel fa-fw',
        'fa-sharp fa-regular fa-popsicle fa-fw',
        'fa-sharp fa-regular fa-pool-8-ball fa-fw',
        'fa-sharp fa-regular fa-pinata fa-fw',
        'fa-sharp fa-regular fa-person-sledding fa-fw',
        'fa-sharp fa-regular fa-person-breastfeeding fa-fw',
        'fa-sharp fa-regular fa-person-biking fa-fw',
        'fa-sharp fa-regular fa-mitten fa-fw',
        'fa-sharp fa-regular fa-lollipop fa-fw',
        'fa-sharp fa-regular fa-ice-cream fa-fw',
        'fa-sharp fa-regular fa-hands-holding-child fa-fw',
        'fa-sharp fa-regular fa-gun-squirt fa-fw',
        'fa-sharp fa-regular fa-globe-snow fa-fw',
        'fa-sharp fa-regular fa-gamepad-modern fa-fw',
        'fa-sharp fa-regular fa-flashlight fa-fw',
        'fa-sharp fa-regular fa-ferris-wheel fa-fw',
        'fa-sharp fa-regular fa-family-pants fa-fw',
        'fa-sharp fa-regular fa-family-dress fa-fw',
        'fa-sharp fa-regular fa-family fa-fw',
        'fa-sharp fa-regular fa-duck fa-fw',
        'fa-sharp fa-regular fa-cupcake fa-fw',
        'fa-sharp fa-regular fa-cubes-stacked fa-fw',
        'fa-sharp fa-regular fa-cookie fa-fw',
        'fa-sharp fa-regular fa-children fa-fw',
        'fa-sharp fa-regular fa-child-reaching fa-fw',
        'fa-sharp fa-regular fa-child-dress fa-fw',
        'fa-sharp fa-regular fa-candy-bar fa-fw',
        'fa-sharp fa-regular fa-candy fa-fw',
        'fa-sharp fa-regular fa-cake-slice fa-fw',
        'fa-sharp fa-regular fa-cake-candles fa-fw',
        'fa-sharp fa-regular fa-bucket fa-fw',
        'fa-sharp fa-regular fa-bowl-soft-serve fa-fw',
        'fa-sharp fa-regular fa-block fa-fw',
        'fa-sharp fa-regular fa-bell-school-slash fa-fw',
        'fa-sharp fa-regular fa-bell-school fa-fw',
        'fa-sharp fa-regular fa-baseball-bat-ball fa-fw',
        'fa-sharp fa-regular fa-balloon fa-fw',
        'fa-sharp fa-regular fa-ball-pile fa-fw',
        'fa-sharp fa-regular fa-backpack fa-fw',
        'fa-sharp fa-regular fa-baby-carriage fa-fw',
        'fa-sharp fa-regular fa-apple-whole fa-fw',
        'fa-sharp fa-light fa-tricycle fa-fw',
        'fa-sharp fa-light fa-teddy-bear fa-fw',
        'fa-sharp fa-light fa-soft-serve fa-fw',
        'fa-sharp fa-light fa-snowman-head fa-fw',
        'fa-sharp fa-light fa-snowman fa-fw',
        'fa-sharp fa-light fa-shapes fa-fw',
        'fa-sharp fa-light fa-roller-coaster fa-fw',
        'fa-sharp fa-light fa-puzzle fa-fw',
        'fa-sharp fa-light fa-pretzel fa-fw',
        'fa-sharp fa-light fa-popsicle fa-fw',
        'fa-sharp fa-light fa-pool-8-ball fa-fw',
        'fa-sharp fa-light fa-pinata fa-fw',
        'fa-sharp fa-light fa-person-sledding fa-fw',
        'fa-sharp fa-light fa-person-breastfeeding fa-fw',
        'fa-sharp fa-light fa-person-biking fa-fw',
        'fa-sharp fa-light fa-mitten fa-fw',
        'fa-sharp fa-light fa-lollipop fa-fw',
        'fa-sharp fa-light fa-ice-cream fa-fw',
        'fa-sharp fa-light fa-hands-holding-child fa-fw',
        'fa-sharp fa-light fa-gun-squirt fa-fw',
        'fa-sharp fa-light fa-globe-snow fa-fw',
        'fa-sharp fa-light fa-gamepad-modern fa-fw',
        'fa-sharp fa-light fa-flashlight fa-fw',
        'fa-sharp fa-light fa-ferris-wheel fa-fw',
        'fa-sharp fa-light fa-family-pants fa-fw',
        'fa-sharp fa-light fa-family-dress fa-fw',
        'fa-sharp fa-light fa-family fa-fw',
        'fa-sharp fa-light fa-duck fa-fw',
        'fa-sharp fa-light fa-cupcake fa-fw',
        'fa-sharp fa-light fa-cubes-stacked fa-fw',
        'fa-sharp fa-light fa-cookie fa-fw',
        'fa-sharp fa-light fa-children fa-fw',
        'fa-sharp fa-light fa-child-reaching fa-fw',
        'fa-sharp fa-light fa-child-dress fa-fw',
        'fa-sharp fa-light fa-candy-bar fa-fw',
        'fa-sharp fa-light fa-candy fa-fw',
        'fa-sharp fa-light fa-cake-slice fa-fw',
        'fa-sharp fa-light fa-cake-candles fa-fw',
        'fa-sharp fa-light fa-bucket fa-fw',
        'fa-sharp fa-light fa-bowl-soft-serve fa-fw',
        'fa-sharp fa-light fa-block fa-fw',
        'fa-sharp fa-light fa-bell-school-slash fa-fw',
        'fa-sharp fa-light fa-bell-school fa-fw',
        'fa-sharp fa-light fa-baseball-bat-ball fa-fw',
        'fa-sharp fa-light fa-balloon fa-fw',
        'fa-sharp fa-light fa-ball-pile fa-fw',
        'fa-sharp fa-light fa-backpack fa-fw',
        'fa-sharp fa-light fa-baby-carriage fa-fw',
        'fa-sharp fa-light fa-apple-whole fa-fw',
      ],
    },
    {
      title: 'Chess',
      items: [
        'fas fa-chess',
        'fas fa-chess-bishop',
        'fas fa-chess-board',
        'fas fa-chess-king',
        'fas fa-chess-knight',
        'fas fa-chess-pawn',
        'fas fa-chess-queen',
        'fas fa-chess-rook',
        'fas fa-square-full',
      ],
    },
    {
      title: 'Clothing',
      items: [
        'fa-thin fa-boot fa-fw',
        'fa-solid fa-boot fa-fw',
        'fa-sharp fa-solid fa-boot fa-fw',
        'fa-sharp fa-regular fa-boot fa-fw',
        'fa-sharp fa-light fa-boot fa-fw',
        'fa-regular fa-boot fa-fw',
        'fa-light fa-boot fa-fw',
        'fa-duotone fa-boot fa-fw',
        'fa-thin fa-boot-heeled fa-fw',
        'fa-solid fa-boot-heeled fa-fw',
        'fa-sharp fa-solid fa-boot-heeled fa-fw',
        'fa-sharp fa-regular fa-boot-heeled fa-fw',
        'fa-sharp fa-light fa-boot-heeled fa-fw',
        'fa-regular fa-boot-heeled fa-fw',
        'fa-light fa-boot-heeled fa-fw',
        'fa-duotone fa-boot-heeled fa-fw',
        'fa-thin fa-clothes-hanger fa-fw',
        'fa-solid fa-clothes-hanger fa-fw',
        'fa-sharp fa-solid fa-clothes-hanger fa-fw',
        'fa-sharp fa-regular fa-clothes-hanger fa-fw',
        'fa-sharp fa-light fa-clothes-hanger fa-fw',
        'fa-regular fa-clothes-hanger fa-fw',
        'fa-light fa-clothes-hanger fa-fw',
        'fa-duotone fa-clothes-hanger fa-fw',
        'fa-thin fa-ear-muffs fa-fw',
        'fa-solid fa-ear-muffs fa-fw',
        'fa-sharp fa-solid fa-ear-muffs fa-fw',
        'fa-sharp fa-regular fa-ear-muffs fa-fw',
        'fa-sharp fa-light fa-ear-muffs fa-fw',
        'fa-regular fa-ear-muffs fa-fw',
        'fa-light fa-ear-muffs fa-fw',
        'fa-duotone fa-ear-muffs fa-fw',
        'fa-thin fa-glasses fa-fw',
        'fa-solid fa-glasses fa-fw',
        'fa-sharp fa-solid fa-glasses fa-fw',
        'fa-sharp fa-regular fa-glasses fa-fw',
        'fa-sharp fa-light fa-glasses fa-fw',
        'fa-regular fa-glasses fa-fw',
        'fa-light fa-glasses fa-fw',
        'fa-duotone fa-glasses fa-fw',
        'fa-thin fa-glasses-round fa-fw',
        'fa-solid fa-glasses-round fa-fw',
        'fa-sharp fa-solid fa-glasses-round fa-fw',
        'fa-sharp fa-regular fa-glasses-round fa-fw',
        'fa-sharp fa-light fa-glasses-round fa-fw',
        'fa-regular fa-glasses-round fa-fw',
        'fa-light fa-glasses-round fa-fw',
        'fa-duotone fa-glasses-round fa-fw',
        'fa-thin fa-graduation-cap fa-fw',
        'fa-solid fa-graduation-cap fa-fw',
        'fa-sharp fa-solid fa-graduation-cap fa-fw',
        'fa-sharp fa-regular fa-graduation-cap fa-fw',
        'fa-sharp fa-light fa-graduation-cap fa-fw',
        'fa-regular fa-graduation-cap fa-fw',
        'fa-light fa-graduation-cap fa-fw',
        'fa-duotone fa-graduation-cap fa-fw',
        'fa-thin fa-hat-beach fa-fw',
        'fa-solid fa-hat-beach fa-fw',
        'fa-sharp fa-solid fa-hat-beach fa-fw',
        'fa-sharp fa-regular fa-hat-beach fa-fw',
        'fa-sharp fa-light fa-hat-beach fa-fw',
        'fa-regular fa-hat-beach fa-fw',
        'fa-light fa-hat-beach fa-fw',
        'fa-duotone fa-hat-beach fa-fw',
        'fa-thin fa-hat-cowboy fa-fw',
        'fa-solid fa-hat-cowboy fa-fw',
        'fa-sharp fa-solid fa-hat-cowboy fa-fw',
        'fa-sharp fa-regular fa-hat-cowboy fa-fw',
        'fa-sharp fa-light fa-hat-cowboy fa-fw',
        'fa-regular fa-hat-cowboy fa-fw',
        'fa-light fa-hat-cowboy fa-fw',
        'fa-duotone fa-hat-cowboy fa-fw',
        'fa-thin fa-hat-cowboy-side fa-fw',
        'fa-solid fa-hat-cowboy-side fa-fw',
        'fa-sharp fa-solid fa-hat-cowboy-side fa-fw',
        'fa-sharp fa-regular fa-hat-cowboy-side fa-fw',
        'fa-sharp fa-light fa-hat-cowboy-side fa-fw',
        'fa-regular fa-hat-cowboy-side fa-fw',
        'fa-light fa-hat-cowboy-side fa-fw',
        'fa-duotone fa-hat-cowboy-side fa-fw',
        'fa-thin fa-hat-santa fa-fw',
        'fa-solid fa-hat-santa fa-fw',
        'fa-sharp fa-solid fa-hat-santa fa-fw',
        'fa-sharp fa-regular fa-hat-santa fa-fw',
        'fa-sharp fa-light fa-hat-santa fa-fw',
        'fa-regular fa-hat-santa fa-fw',
        'fa-light fa-hat-santa fa-fw',
        'fa-duotone fa-hat-santa fa-fw',
        'fa-thin fa-hat-winter fa-fw',
        'fa-solid fa-hat-winter fa-fw',
        'fa-sharp fa-solid fa-hat-winter fa-fw',
        'fa-sharp fa-regular fa-hat-winter fa-fw',
        'fa-sharp fa-light fa-hat-winter fa-fw',
        'fa-regular fa-hat-winter fa-fw',
        'fa-light fa-hat-winter fa-fw',
        'fa-duotone fa-hat-winter fa-fw',
        'fa-thin fa-hat-witch fa-fw',
        'fa-solid fa-hat-witch fa-fw',
        'fa-sharp fa-solid fa-hat-witch fa-fw',
        'fa-sharp fa-regular fa-hat-witch fa-fw',
        'fa-sharp fa-light fa-hat-witch fa-fw',
        'fa-regular fa-hat-witch fa-fw',
        'fa-light fa-hat-witch fa-fw',
        'fa-duotone fa-hat-witch fa-fw',
        'fa-thin fa-hat-wizard fa-fw',
        'fa-solid fa-hat-wizard fa-fw',
        'fa-sharp fa-solid fa-hat-wizard fa-fw',
        'fa-sharp fa-regular fa-hat-wizard fa-fw',
        'fa-sharp fa-light fa-hat-wizard fa-fw',
        'fa-regular fa-hat-wizard fa-fw',
        'fa-light fa-hat-wizard fa-fw',
        'fa-duotone fa-hat-wizard fa-fw',
        'fa-thin fa-hood-cloak fa-fw',
        'fa-solid fa-hood-cloak fa-fw',
        'fa-sharp fa-solid fa-hood-cloak fa-fw',
        'fa-sharp fa-regular fa-hood-cloak fa-fw',
        'fa-sharp fa-light fa-hood-cloak fa-fw',
        'fa-regular fa-hood-cloak fa-fw',
        'fa-light fa-hood-cloak fa-fw',
        'fa-duotone fa-hood-cloak fa-fw',
        'fa-thin fa-ice-skate fa-fw',
        'fa-solid fa-ice-skate fa-fw',
        'fa-sharp fa-solid fa-ice-skate fa-fw',
        'fa-sharp fa-regular fa-ice-skate fa-fw',
        'fa-sharp fa-light fa-ice-skate fa-fw',
        'fa-regular fa-ice-skate fa-fw',
        'fa-light fa-ice-skate fa-fw',
        'fa-duotone fa-ice-skate fa-fw',
        'fa-thin fa-mitten fa-fw',
        'fa-solid fa-mitten fa-fw',
        'fa-sharp fa-solid fa-mitten fa-fw',
        'fa-sharp fa-regular fa-mitten fa-fw',
        'fa-sharp fa-light fa-mitten fa-fw',
        'fa-regular fa-mitten fa-fw',
        'fa-light fa-mitten fa-fw',
        'fa-duotone fa-mitten fa-fw',
        'fa-thin fa-mustache fa-fw',
        'fa-solid fa-mustache fa-fw',
        'fa-sharp fa-solid fa-mustache fa-fw',
        'fa-sharp fa-regular fa-mustache fa-fw',
        'fa-sharp fa-light fa-mustache fa-fw',
        'fa-regular fa-mustache fa-fw',
        'fa-light fa-mustache fa-fw',
        'fa-duotone fa-mustache fa-fw',
        'fa-thin fa-pipe-smoking fa-fw',
        'fa-solid fa-pipe-smoking fa-fw',
        'fa-sharp fa-solid fa-pipe-smoking fa-fw',
        'fa-sharp fa-regular fa-pipe-smoking fa-fw',
        'fa-sharp fa-light fa-pipe-smoking fa-fw',
        'fa-regular fa-pipe-smoking fa-fw',
        'fa-light fa-pipe-smoking fa-fw',
        'fa-duotone fa-pipe-smoking fa-fw',
        'fa-thin fa-reel fa-fw',
        'fa-solid fa-reel fa-fw',
        'fa-sharp fa-solid fa-reel fa-fw',
        'fa-sharp fa-regular fa-reel fa-fw',
        'fa-sharp fa-light fa-reel fa-fw',
        'fa-regular fa-reel fa-fw',
        'fa-light fa-reel fa-fw',
        'fa-duotone fa-reel fa-fw',
        'fa-thin fa-scarf fa-fw',
        'fa-solid fa-scarf fa-fw',
        'fa-sharp fa-solid fa-scarf fa-fw',
        'fa-sharp fa-regular fa-scarf fa-fw',
        'fa-sharp fa-light fa-scarf fa-fw',
        'fa-regular fa-scarf fa-fw',
        'fa-light fa-scarf fa-fw',
        'fa-duotone fa-scarf fa-fw',
        'fa-thin fa-shirt fa-fw',
        'fa-solid fa-shirt fa-fw',
        'fa-sharp fa-solid fa-shirt fa-fw',
        'fa-sharp fa-regular fa-shirt fa-fw',
        'fa-sharp fa-light fa-shirt fa-fw',
        'fa-regular fa-shirt fa-fw',
        'fa-light fa-shirt fa-fw',
        'fa-duotone fa-shirt fa-fw',
        'fa-thin fa-shirt-long-sleeve fa-fw',
        'fa-solid fa-shirt-long-sleeve fa-fw',
        'fa-sharp fa-solid fa-shirt-long-sleeve fa-fw',
        'fa-sharp fa-regular fa-shirt-long-sleeve fa-fw',
        'fa-sharp fa-light fa-shirt-long-sleeve fa-fw',
        'fa-regular fa-shirt-long-sleeve fa-fw',
        'fa-light fa-shirt-long-sleeve fa-fw',
        'fa-duotone fa-shirt-long-sleeve fa-fw',
        'fa-thin fa-shirt-running fa-fw',
        'fa-solid fa-shirt-running fa-fw',
        'fa-sharp fa-solid fa-shirt-running fa-fw',
        'fa-sharp fa-regular fa-shirt-running fa-fw',
        'fa-sharp fa-light fa-shirt-running fa-fw',
        'fa-regular fa-shirt-running fa-fw',
        'fa-light fa-shirt-running fa-fw',
        'fa-duotone fa-shirt-running fa-fw',
        'fa-thin fa-shirt-tank-top fa-fw',
        'fa-solid fa-shirt-tank-top fa-fw',
        'fa-sharp fa-solid fa-shirt-tank-top fa-fw',
        'fa-sharp fa-regular fa-shirt-tank-top fa-fw',
        'fa-sharp fa-light fa-shirt-tank-top fa-fw',
        'fa-regular fa-shirt-tank-top fa-fw',
        'fa-light fa-shirt-tank-top fa-fw',
        'fa-duotone fa-shirt-tank-top fa-fw',
        'fa-thin fa-shoe-prints fa-fw',
        'fa-solid fa-shoe-prints fa-fw',
        'fa-sharp fa-solid fa-shoe-prints fa-fw',
        'fa-sharp fa-regular fa-shoe-prints fa-fw',
        'fa-sharp fa-light fa-shoe-prints fa-fw',
        'fa-regular fa-shoe-prints fa-fw',
        'fa-light fa-shoe-prints fa-fw',
        'fa-duotone fa-shoe-prints fa-fw',
        'fa-thin fa-ski-boot fa-fw',
        'fa-solid fa-ski-boot fa-fw',
        'fa-sharp fa-solid fa-ski-boot fa-fw',
        'fa-sharp fa-regular fa-ski-boot fa-fw',
        'fa-sharp fa-light fa-ski-boot fa-fw',
        'fa-regular fa-ski-boot fa-fw',
        'fa-light fa-ski-boot fa-fw',
        'fa-duotone fa-ski-boot fa-fw',
        'fa-thin fa-socks fa-fw',
        'fa-solid fa-socks fa-fw',
        'fa-sharp fa-solid fa-socks fa-fw',
        'fa-sharp fa-regular fa-socks fa-fw',
        'fa-sharp fa-light fa-socks fa-fw',
        'fa-regular fa-socks fa-fw',
        'fa-light fa-socks fa-fw',
        'fa-duotone fa-socks fa-fw',
        'fa-thin fa-stocking fa-fw',
        'fa-solid fa-stocking fa-fw',
        'fa-sharp fa-solid fa-stocking fa-fw',
        'fa-sharp fa-regular fa-stocking fa-fw',
        'fa-sharp fa-light fa-stocking fa-fw',
        'fa-regular fa-stocking fa-fw',
        'fa-light fa-stocking fa-fw',
        'fa-duotone fa-stocking fa-fw',
        'fa-thin fa-sunglasses fa-fw',
        'fa-solid fa-sunglasses fa-fw',
        'fa-sharp fa-solid fa-sunglasses fa-fw',
        'fa-sharp fa-regular fa-sunglasses fa-fw',
        'fa-sharp fa-light fa-sunglasses fa-fw',
        'fa-regular fa-sunglasses fa-fw',
        'fa-light fa-sunglasses fa-fw',
        'fa-duotone fa-sunglasses fa-fw',
        'fa-thin fa-uniform-martial-arts fa-fw',
        'fa-solid fa-uniform-martial-arts fa-fw',
        'fa-sharp fa-solid fa-uniform-martial-arts fa-fw',
        'fa-sharp fa-regular fa-uniform-martial-arts fa-fw',
        'fa-sharp fa-light fa-uniform-martial-arts fa-fw',
        'fa-regular fa-uniform-martial-arts fa-fw',
        'fa-light fa-uniform-martial-arts fa-fw',
        'fa-duotone fa-uniform-martial-arts fa-fw',
        'fa-thin fa-user-tie fa-fw',
        'fa-solid fa-user-tie fa-fw',
        'fa-sharp fa-solid fa-user-tie fa-fw',
        'fa-sharp fa-regular fa-user-tie fa-fw',
        'fa-sharp fa-light fa-user-tie fa-fw',
        'fa-regular fa-user-tie fa-fw',
        'fa-light fa-user-tie fa-fw',
        'fa-duotone fa-user-tie fa-fw',
        'fa-thin fa-vest fa-fw',
        'fa-solid fa-vest fa-fw',
        'fa-sharp fa-solid fa-vest fa-fw',
        'fa-sharp fa-regular fa-vest fa-fw',
        'fa-sharp fa-light fa-vest fa-fw',
        'fa-regular fa-vest fa-fw',
        'fa-light fa-vest fa-fw',
        'fa-duotone fa-vest fa-fw',
        'fa-thin fa-vest-patches fa-fw',
        'fa-solid fa-vest-patches fa-fw',
        'fa-sharp fa-solid fa-vest-patches fa-fw',
        'fa-sharp fa-regular fa-vest-patches fa-fw',
        'fa-sharp fa-light fa-vest-patches fa-fw',
        'fa-regular fa-vest-patches fa-fw',
        'fa-light fa-vest-patches fa-fw',
        'fa-duotone fa-vest-patches fa-fw',
      ],
    },
    {
      title: 'Code',
      items: [
        'fa-thin fa-ban-bug fa-fw',
        'fa-solid fa-ban-bug fa-fw',
        'fa-sharp fa-solid fa-ban-bug fa-fw',
        'fa-sharp fa-regular fa-ban-bug fa-fw',
        'fa-sharp fa-light fa-ban-bug fa-fw',
        'fa-regular fa-ban-bug fa-fw',
        'fa-light fa-ban-bug fa-fw',
        'fa-duotone fa-ban-bug fa-fw',
        'fa-thin fa-barcode fa-fw',
        'fa-solid fa-barcode fa-fw',
        'fa-sharp fa-solid fa-barcode fa-fw',
        'fa-sharp fa-regular fa-barcode fa-fw',
        'fa-sharp fa-light fa-barcode fa-fw',
        'fa-regular fa-barcode fa-fw',
        'fa-light fa-barcode fa-fw',
        'fa-duotone fa-barcode fa-fw',
        'fa-thin fa-bars fa-fw',
        'fa-solid fa-bars fa-fw',
        'fa-sharp fa-solid fa-bars fa-fw',
        'fa-sharp fa-regular fa-bars fa-fw',
        'fa-sharp fa-light fa-bars fa-fw',
        'fa-regular fa-bars fa-fw',
        'fa-light fa-bars fa-fw',
        'fa-duotone fa-bars fa-fw',
        'fa-thin fa-bars-filter fa-fw',
        'fa-solid fa-bars-filter fa-fw',
        'fa-sharp fa-solid fa-bars-filter fa-fw',
        'fa-sharp fa-regular fa-bars-filter fa-fw',
        'fa-sharp fa-light fa-bars-filter fa-fw',
        'fa-regular fa-bars-filter fa-fw',
        'fa-light fa-bars-filter fa-fw',
        'fa-duotone fa-bars-filter fa-fw',
        'fa-thin fa-bars-sort fa-fw',
        'fa-solid fa-bars-sort fa-fw',
        'fa-sharp fa-solid fa-bars-sort fa-fw',
        'fa-sharp fa-regular fa-bars-sort fa-fw',
        'fa-sharp fa-light fa-bars-sort fa-fw',
        'fa-regular fa-bars-sort fa-fw',
        'fa-light fa-bars-sort fa-fw',
        'fa-duotone fa-bars-sort fa-fw',
        'fa-thin fa-bars-staggered fa-fw',
        'fa-solid fa-bars-staggered fa-fw',
        'fa-sharp fa-solid fa-bars-staggered fa-fw',
        'fa-sharp fa-regular fa-bars-staggered fa-fw',
        'fa-sharp fa-light fa-bars-staggered fa-fw',
        'fa-regular fa-bars-staggered fa-fw',
        'fa-light fa-bars-staggered fa-fw',
        'fa-duotone fa-bars-staggered fa-fw',
        'fa-thin fa-bath fa-fw',
        'fa-solid fa-bath fa-fw',
        'fa-sharp fa-solid fa-bath fa-fw',
        'fa-sharp fa-regular fa-bath fa-fw',
        'fa-sharp fa-light fa-bath fa-fw',
        'fa-regular fa-bath fa-fw',
        'fa-light fa-bath fa-fw',
        'fa-duotone fa-bath fa-fw',
        'fa-thin fa-binary fa-fw',
        'fa-solid fa-binary fa-fw',
        'fa-sharp fa-solid fa-binary fa-fw',
        'fa-sharp fa-regular fa-binary fa-fw',
        'fa-sharp fa-light fa-binary fa-fw',
        'fa-regular fa-binary fa-fw',
        'fa-light fa-binary fa-fw',
        'fa-duotone fa-binary fa-fw',
        'fa-thin fa-binary-circle-check fa-fw',
        'fa-solid fa-binary-circle-check fa-fw',
        'fa-sharp fa-solid fa-binary-circle-check fa-fw',
        'fa-sharp fa-regular fa-binary-circle-check fa-fw',
        'fa-sharp fa-light fa-binary-circle-check fa-fw',
        'fa-regular fa-binary-circle-check fa-fw',
        'fa-light fa-binary-circle-check fa-fw',
        'fa-duotone fa-binary-circle-check fa-fw',
        'fa-thin fa-binary-lock fa-fw',
        'fa-solid fa-binary-lock fa-fw',
        'fa-sharp fa-solid fa-binary-lock fa-fw',
        'fa-sharp fa-regular fa-binary-lock fa-fw',
        'fa-sharp fa-light fa-binary-lock fa-fw',
        'fa-regular fa-binary-lock fa-fw',
        'fa-light fa-binary-lock fa-fw',
        'fa-duotone fa-binary-lock fa-fw',
        'fa-thin fa-binary-slash fa-fw',
        'fa-solid fa-binary-slash fa-fw',
        'fa-sharp fa-solid fa-binary-slash fa-fw',
        'fa-sharp fa-regular fa-binary-slash fa-fw',
        'fa-sharp fa-light fa-binary-slash fa-fw',
        'fa-regular fa-binary-slash fa-fw',
        'fa-light fa-binary-slash fa-fw',
        'fa-duotone fa-binary-slash fa-fw',
        'fa-thin fa-box-archive fa-fw',
        'fa-solid fa-box-archive fa-fw',
        'fa-sharp fa-solid fa-box-archive fa-fw',
        'fa-sharp fa-regular fa-box-archive fa-fw',
        'fa-sharp fa-light fa-box-archive fa-fw',
        'fa-regular fa-box-archive fa-fw',
        'fa-light fa-box-archive fa-fw',
        'fa-duotone fa-box-archive fa-fw',
        'fa-thin fa-bracket-curly fa-fw',
        'fa-solid fa-bracket-curly fa-fw',
        'fa-sharp fa-solid fa-bracket-curly fa-fw',
        'fa-sharp fa-regular fa-bracket-curly fa-fw',
        'fa-sharp fa-light fa-bracket-curly fa-fw',
        'fa-regular fa-bracket-curly fa-fw',
        'fa-light fa-bracket-curly fa-fw',
        'fa-duotone fa-bracket-curly fa-fw',
        'fa-thin fa-bracket-curly-right fa-fw',
        'fa-solid fa-bracket-curly-right fa-fw',
        'fa-sharp fa-solid fa-bracket-curly-right fa-fw',
        'fa-sharp fa-regular fa-bracket-curly-right fa-fw',
        'fa-sharp fa-light fa-bracket-curly-right fa-fw',
        'fa-regular fa-bracket-curly-right fa-fw',
        'fa-light fa-bracket-curly-right fa-fw',
        'fa-duotone fa-bracket-curly-right fa-fw',
        'fa-thin fa-bracket-round fa-fw',
        'fa-solid fa-bracket-round fa-fw',
        'fa-sharp fa-solid fa-bracket-round fa-fw',
        'fa-sharp fa-regular fa-bracket-round fa-fw',
        'fa-sharp fa-light fa-bracket-round fa-fw',
        'fa-regular fa-bracket-round fa-fw',
        'fa-light fa-bracket-round fa-fw',
        'fa-duotone fa-bracket-round fa-fw',
        'fa-thin fa-bracket-round-right fa-fw',
        'fa-solid fa-bracket-round-right fa-fw',
        'fa-sharp fa-solid fa-bracket-round-right fa-fw',
        'fa-sharp fa-regular fa-bracket-round-right fa-fw',
        'fa-sharp fa-light fa-bracket-round-right fa-fw',
        'fa-regular fa-bracket-round-right fa-fw',
        'fa-light fa-bracket-round-right fa-fw',
        'fa-duotone fa-bracket-round-right fa-fw',
        'fa-thin fa-bracket-square fa-fw',
        'fa-solid fa-bracket-square fa-fw',
        'fa-sharp fa-solid fa-bracket-square fa-fw',
        'fa-sharp fa-regular fa-bracket-square fa-fw',
        'fa-sharp fa-light fa-bracket-square fa-fw',
        'fa-regular fa-bracket-square fa-fw',
        'fa-light fa-bracket-square fa-fw',
        'fa-duotone fa-bracket-square fa-fw',
        'fa-thin fa-bracket-square-right fa-fw',
        'fa-solid fa-bracket-square-right fa-fw',
        'fa-sharp fa-solid fa-bracket-square-right fa-fw',
        'fa-sharp fa-regular fa-bracket-square-right fa-fw',
        'fa-sharp fa-light fa-bracket-square-right fa-fw',
        'fa-regular fa-bracket-square-right fa-fw',
        'fa-light fa-bracket-square-right fa-fw',
        'fa-duotone fa-bracket-square-right fa-fw',
        'fa-thin fa-brackets-curly fa-fw',
        'fa-solid fa-brackets-curly fa-fw',
        'fa-sharp fa-solid fa-brackets-curly fa-fw',
        'fa-sharp fa-regular fa-brackets-curly fa-fw',
        'fa-sharp fa-light fa-brackets-curly fa-fw',
        'fa-regular fa-brackets-curly fa-fw',
        'fa-light fa-brackets-curly fa-fw',
        'fa-duotone fa-brackets-curly fa-fw',
        'fa-thin fa-brackets-round fa-fw',
        'fa-solid fa-brackets-round fa-fw',
        'fa-sharp fa-solid fa-brackets-round fa-fw',
        'fa-sharp fa-regular fa-brackets-round fa-fw',
        'fa-sharp fa-light fa-brackets-round fa-fw',
        'fa-regular fa-brackets-round fa-fw',
        'fa-light fa-brackets-round fa-fw',
        'fa-duotone fa-brackets-round fa-fw',
        'fa-thin fa-brackets-square fa-fw',
        'fa-solid fa-brackets-square fa-fw',
        'fa-sharp fa-solid fa-brackets-square fa-fw',
        'fa-sharp fa-regular fa-brackets-square fa-fw',
        'fa-sharp fa-light fa-brackets-square fa-fw',
        'fa-regular fa-brackets-square fa-fw',
        'fa-light fa-brackets-square fa-fw',
        'fa-duotone fa-brackets-square fa-fw',
        'fa-thin fa-brain-circuit fa-fw',
        'fa-solid fa-brain-circuit fa-fw',
        'fa-sharp fa-solid fa-brain-circuit fa-fw',
        'fa-sharp fa-regular fa-brain-circuit fa-fw',
        'fa-sharp fa-light fa-brain-circuit fa-fw',
        'fa-regular fa-brain-circuit fa-fw',
        'fa-light fa-brain-circuit fa-fw',
        'fa-duotone fa-brain-circuit fa-fw',
        'fa-thin fa-browser fa-fw',
        'fa-solid fa-browser fa-fw',
        'fa-sharp fa-solid fa-browser fa-fw',
        'fa-sharp fa-regular fa-browser fa-fw',
        'fa-sharp fa-light fa-browser fa-fw',
        'fa-regular fa-browser fa-fw',
        'fa-light fa-browser fa-fw',
        'fa-duotone fa-browser fa-fw',
        'fa-thin fa-browsers fa-fw',
        'fa-solid fa-browsers fa-fw',
        'fa-sharp fa-solid fa-browsers fa-fw',
        'fa-sharp fa-regular fa-browsers fa-fw',
        'fa-sharp fa-light fa-browsers fa-fw',
        'fa-regular fa-browsers fa-fw',
        'fa-light fa-browsers fa-fw',
        'fa-duotone fa-browsers fa-fw',
        'fa-thin fa-bug fa-fw',
        'fa-solid fa-bug fa-fw',
        'fa-sharp fa-solid fa-bug fa-fw',
        'fa-sharp fa-regular fa-bug fa-fw',
        'fa-sharp fa-light fa-bug fa-fw',
        'fa-regular fa-bug fa-fw',
        'fa-light fa-bug fa-fw',
        'fa-duotone fa-bug fa-fw',
        'fa-thin fa-bug-slash fa-fw',
        'fa-solid fa-bug-slash fa-fw',
        'fa-sharp fa-solid fa-bug-slash fa-fw',
        'fa-sharp fa-regular fa-bug-slash fa-fw',
        'fa-sharp fa-light fa-bug-slash fa-fw',
        'fa-regular fa-bug-slash fa-fw',
        'fa-light fa-bug-slash fa-fw',
        'fa-duotone fa-bug-slash fa-fw',
        'fa-thin fa-circle-nodes fa-fw',
        'fa-solid fa-circle-nodes fa-fw',
        'fa-sharp fa-solid fa-circle-nodes fa-fw',
        'fa-sharp fa-regular fa-circle-nodes fa-fw',
        'fa-sharp fa-light fa-circle-nodes fa-fw',
        'fa-regular fa-circle-nodes fa-fw',
        'fa-light fa-circle-nodes fa-fw',
        'fa-duotone fa-circle-nodes fa-fw',
        'fa-thin fa-cloud-binary fa-fw',
        'fa-solid fa-cloud-binary fa-fw',
        'fa-sharp fa-solid fa-cloud-binary fa-fw',
        'fa-sharp fa-regular fa-cloud-binary fa-fw',
        'fa-sharp fa-light fa-cloud-binary fa-fw',
        'fa-regular fa-cloud-binary fa-fw',
        'fa-light fa-cloud-binary fa-fw',
        'fa-duotone fa-cloud-binary fa-fw',
        'fa-thin fa-code fa-fw',
        'fa-solid fa-code fa-fw',
        'fa-sharp fa-solid fa-code fa-fw',
        'fa-sharp fa-regular fa-code fa-fw',
        'fa-sharp fa-light fa-code fa-fw',
        'fa-regular fa-code fa-fw',
        'fa-light fa-code fa-fw',
        'fa-duotone fa-code fa-fw',
        'fa-thin fa-code-branch fa-fw',
        'fa-solid fa-code-branch fa-fw',
        'fa-sharp fa-solid fa-code-branch fa-fw',
        'fa-sharp fa-regular fa-code-branch fa-fw',
        'fa-sharp fa-light fa-code-branch fa-fw',
        'fa-regular fa-code-branch fa-fw',
        'fa-light fa-code-branch fa-fw',
        'fa-duotone fa-code-branch fa-fw',
        'fa-thin fa-code-commit fa-fw',
        'fa-solid fa-code-commit fa-fw',
        'fa-sharp fa-solid fa-code-commit fa-fw',
        'fa-sharp fa-regular fa-code-commit fa-fw',
        'fa-sharp fa-light fa-code-commit fa-fw',
        'fa-regular fa-code-commit fa-fw',
        'fa-light fa-code-commit fa-fw',
        'fa-duotone fa-code-commit fa-fw',
        'fa-thin fa-code-compare fa-fw',
        'fa-solid fa-code-compare fa-fw',
        'fa-sharp fa-solid fa-code-compare fa-fw',
        'fa-sharp fa-regular fa-code-compare fa-fw',
        'fa-sharp fa-light fa-code-compare fa-fw',
        'fa-regular fa-code-compare fa-fw',
        'fa-light fa-code-compare fa-fw',
        'fa-duotone fa-code-compare fa-fw',
        'fa-thin fa-code-fork fa-fw',
        'fa-solid fa-code-fork fa-fw',
        'fa-sharp fa-solid fa-code-fork fa-fw',
        'fa-sharp fa-regular fa-code-fork fa-fw',
        'fa-sharp fa-light fa-code-fork fa-fw',
        'fa-regular fa-code-fork fa-fw',
        'fa-light fa-code-fork fa-fw',
        'fa-duotone fa-code-fork fa-fw',
        'fa-thin fa-code-merge fa-fw',
        'fa-solid fa-code-merge fa-fw',
        'fa-sharp fa-solid fa-code-merge fa-fw',
        'fa-sharp fa-regular fa-code-merge fa-fw',
        'fa-sharp fa-light fa-code-merge fa-fw',
        'fa-regular fa-code-merge fa-fw',
        'fa-light fa-code-merge fa-fw',
        'fa-duotone fa-code-merge fa-fw',
        'fa-thin fa-code-pull-request fa-fw',
        'fa-solid fa-code-pull-request fa-fw',
        'fa-sharp fa-solid fa-code-pull-request fa-fw',
        'fa-sharp fa-regular fa-code-pull-request fa-fw',
        'fa-sharp fa-light fa-code-pull-request fa-fw',
        'fa-regular fa-code-pull-request fa-fw',
        'fa-light fa-code-pull-request fa-fw',
        'fa-duotone fa-code-pull-request fa-fw',
        'fa-thin fa-code-pull-request-closed fa-fw',
        'fa-solid fa-code-pull-request-closed fa-fw',
        'fa-sharp fa-solid fa-code-pull-request-closed fa-fw',
        'fa-sharp fa-regular fa-code-pull-request-closed fa-fw',
        'fa-sharp fa-light fa-code-pull-request-closed fa-fw',
        'fa-regular fa-code-pull-request-closed fa-fw',
        'fa-light fa-code-pull-request-closed fa-fw',
        'fa-duotone fa-code-pull-request-closed fa-fw',
        'fa-thin fa-code-pull-request-draft fa-fw',
        'fa-solid fa-code-pull-request-draft fa-fw',
        'fa-sharp fa-solid fa-code-pull-request-draft fa-fw',
        'fa-sharp fa-regular fa-code-pull-request-draft fa-fw',
        'fa-sharp fa-light fa-code-pull-request-draft fa-fw',
        'fa-regular fa-code-pull-request-draft fa-fw',
        'fa-light fa-code-pull-request-draft fa-fw',
        'fa-duotone fa-code-pull-request-draft fa-fw',
        'fa-thin fa-code-simple fa-fw',
        'fa-solid fa-code-simple fa-fw',
        'fa-sharp fa-solid fa-code-simple fa-fw',
        'fa-sharp fa-regular fa-code-simple fa-fw',
        'fa-sharp fa-light fa-code-simple fa-fw',
        'fa-regular fa-code-simple fa-fw',
        'fa-light fa-code-simple fa-fw',
        'fa-duotone fa-code-simple fa-fw',
        'fa-thin fa-cube fa-fw',
        'fa-solid fa-cube fa-fw',
        'fa-sharp fa-solid fa-cube fa-fw',
        'fa-sharp fa-regular fa-cube fa-fw',
        'fa-sharp fa-light fa-cube fa-fw',
        'fa-regular fa-cube fa-fw',
        'fa-light fa-cube fa-fw',
        'fa-duotone fa-cube fa-fw',
        'fa-thin fa-cubes fa-fw',
        'fa-solid fa-cubes fa-fw',
        'fa-sharp fa-solid fa-cubes fa-fw',
        'fa-sharp fa-regular fa-cubes fa-fw',
        'fa-sharp fa-light fa-cubes fa-fw',
        'fa-regular fa-cubes fa-fw',
        'fa-light fa-cubes fa-fw',
        'fa-duotone fa-cubes fa-fw',
        'fa-thin fa-diagram-project fa-fw',
        'fa-solid fa-diagram-project fa-fw',
        'fa-sharp fa-solid fa-diagram-project fa-fw',
        'fa-sharp fa-regular fa-diagram-project fa-fw',
        'fa-sharp fa-light fa-diagram-project fa-fw',
        'fa-regular fa-diagram-project fa-fw',
        'fa-light fa-diagram-project fa-fw',
        'fa-duotone fa-diagram-project fa-fw',
        'fa-thin fa-file fa-fw',
        'fa-solid fa-file fa-fw',
        'fa-sharp fa-solid fa-file fa-fw',
        'fa-sharp fa-regular fa-file fa-fw',
        'fa-sharp fa-light fa-file fa-fw',
        'fa-regular fa-file fa-fw',
        'fa-light fa-file fa-fw',
        'fa-duotone fa-file fa-fw',
        'fa-thin fa-file-code fa-fw',
        'fa-solid fa-file-code fa-fw',
        'fa-sharp fa-solid fa-file-code fa-fw',
        'fa-sharp fa-regular fa-file-code fa-fw',
        'fa-sharp fa-light fa-file-code fa-fw',
        'fa-regular fa-file-code fa-fw',
        'fa-light fa-file-code fa-fw',
        'fa-duotone fa-file-code fa-fw',
        'fa-thin fa-file-lines fa-fw',
        'fa-solid fa-file-lines fa-fw',
        'fa-sharp fa-solid fa-file-lines fa-fw',
        'fa-sharp fa-regular fa-file-lines fa-fw',
        'fa-sharp fa-light fa-file-lines fa-fw',
        'fa-regular fa-file-lines fa-fw',
        'fa-light fa-file-lines fa-fw',
        'fa-duotone fa-file-lines fa-fw',
        'fa-thin fa-filter fa-fw',
        'fa-solid fa-filter fa-fw',
        'fa-sharp fa-solid fa-filter fa-fw',
        'fa-sharp fa-regular fa-filter fa-fw',
        'fa-sharp fa-light fa-filter fa-fw',
        'fa-regular fa-filter fa-fw',
        'fa-light fa-filter fa-fw',
        'fa-duotone fa-filter fa-fw',
        'fa-thin fa-fire-extinguisher fa-fw',
        'fa-solid fa-fire-extinguisher fa-fw',
        'fa-sharp fa-solid fa-fire-extinguisher fa-fw',
        'fa-sharp fa-regular fa-fire-extinguisher fa-fw',
        'fa-sharp fa-light fa-fire-extinguisher fa-fw',
        'fa-regular fa-fire-extinguisher fa-fw',
        'fa-light fa-fire-extinguisher fa-fw',
        'fa-duotone fa-fire-extinguisher fa-fw',
        'fa-thin fa-folder fa-fw',
        'fa-solid fa-folder fa-fw',
        'fa-sharp fa-solid fa-folder fa-fw',
        'fa-sharp fa-regular fa-folder fa-fw',
        'fa-sharp fa-light fa-folder fa-fw',
        'fa-regular fa-folder fa-fw',
        'fa-light fa-folder fa-fw',
        'fa-duotone fa-folder fa-fw',
        'fa-thin fa-folder-open fa-fw',
        'fa-solid fa-folder-open fa-fw',
        'fa-sharp fa-solid fa-folder-open fa-fw',
        'fa-sharp fa-regular fa-folder-open fa-fw',
        'fa-sharp fa-light fa-folder-open fa-fw',
        'fa-regular fa-folder-open fa-fw',
        'fa-light fa-folder-open fa-fw',
        'fa-duotone fa-folder-open fa-fw',
        'fa-thin fa-font-awesome fa-fw',
        'fa-solid fa-font-awesome fa-fw',
        'fa-sharp fa-solid fa-font-awesome fa-fw',
        'fa-sharp fa-regular fa-font-awesome fa-fw',
        'fa-sharp fa-light fa-font-awesome fa-fw',
        'fa-regular fa-font-awesome fa-fw',
        'fa-light fa-font-awesome fa-fw',
        'fa-duotone fa-font-awesome fa-fw',
        'fa-brands fa-font-awesome fa-fw',
        'fa-thin fa-gear fa-fw',
        'fa-solid fa-gear fa-fw',
        'fa-sharp fa-solid fa-gear fa-fw',
        'fa-sharp fa-regular fa-gear fa-fw',
        'fa-sharp fa-light fa-gear fa-fw',
        'fa-regular fa-gear fa-fw',
        'fa-light fa-gear fa-fw',
        'fa-duotone fa-gear fa-fw',
        'fa-thin fa-gear-code fa-fw',
        'fa-solid fa-gear-code fa-fw',
        'fa-sharp fa-solid fa-gear-code fa-fw',
        'fa-sharp fa-regular fa-gear-code fa-fw',
        'fa-sharp fa-light fa-gear-code fa-fw',
        'fa-regular fa-gear-code fa-fw',
        'fa-light fa-gear-code fa-fw',
        'fa-duotone fa-gear-code fa-fw',
        'fa-thin fa-gear-complex fa-fw',
        'fa-solid fa-gear-complex fa-fw',
        'fa-sharp fa-solid fa-gear-complex fa-fw',
        'fa-sharp fa-regular fa-gear-complex fa-fw',
        'fa-sharp fa-light fa-gear-complex fa-fw',
        'fa-regular fa-gear-complex fa-fw',
        'fa-light fa-gear-complex fa-fw',
        'fa-duotone fa-gear-complex fa-fw',
        'fa-thin fa-gear-complex-code fa-fw',
        'fa-solid fa-gear-complex-code fa-fw',
        'fa-sharp fa-solid fa-gear-complex-code fa-fw',
        'fa-sharp fa-regular fa-gear-complex-code fa-fw',
        'fa-sharp fa-light fa-gear-complex-code fa-fw',
        'fa-regular fa-gear-complex-code fa-fw',
        'fa-light fa-gear-complex-code fa-fw',
        'fa-duotone fa-gear-complex-code fa-fw',
        'fa-thin fa-gears fa-fw',
        'fa-solid fa-gears fa-fw',
        'fa-sharp fa-solid fa-gears fa-fw',
        'fa-sharp fa-regular fa-gears fa-fw',
        'fa-sharp fa-light fa-gears fa-fw',
        'fa-regular fa-gears fa-fw',
        'fa-light fa-gears fa-fw',
        'fa-duotone fa-gears fa-fw',
        'fa-thin fa-key-skeleton-left-right fa-fw',
        'fa-solid fa-key-skeleton-left-right fa-fw',
        'fa-sharp fa-solid fa-key-skeleton-left-right fa-fw',
        'fa-sharp fa-regular fa-key-skeleton-left-right fa-fw',
        'fa-sharp fa-light fa-key-skeleton-left-right fa-fw',
        'fa-regular fa-key-skeleton-left-right fa-fw',
        'fa-light fa-key-skeleton-left-right fa-fw',
        'fa-duotone fa-key-skeleton-left-right fa-fw',
        'fa-thin fa-keyboard fa-fw',
        'fa-solid fa-keyboard fa-fw',
        'fa-sharp fa-solid fa-keyboard fa-fw',
        'fa-sharp fa-regular fa-keyboard fa-fw',
        'fa-sharp fa-light fa-keyboard fa-fw',
        'fa-regular fa-keyboard fa-fw',
        'fa-light fa-keyboard fa-fw',
        'fa-duotone fa-keyboard fa-fw',
        'fa-thin fa-laptop-binary fa-fw',
        'fa-solid fa-laptop-binary fa-fw',
        'fa-sharp fa-solid fa-laptop-binary fa-fw',
        'fa-sharp fa-regular fa-laptop-binary fa-fw',
        'fa-sharp fa-light fa-laptop-binary fa-fw',
        'fa-regular fa-laptop-binary fa-fw',
        'fa-light fa-laptop-binary fa-fw',
        'fa-duotone fa-laptop-binary fa-fw',
        'fa-thin fa-laptop-code fa-fw',
        'fa-solid fa-laptop-code fa-fw',
        'fa-sharp fa-solid fa-laptop-code fa-fw',
        'fa-sharp fa-regular fa-laptop-code fa-fw',
        'fa-sharp fa-light fa-laptop-code fa-fw',
        'fa-regular fa-laptop-code fa-fw',
        'fa-light fa-laptop-code fa-fw',
        'fa-duotone fa-laptop-code fa-fw',
        'fa-thin fa-laptop-mobile fa-fw',
        'fa-solid fa-laptop-mobile fa-fw',
        'fa-sharp fa-solid fa-laptop-mobile fa-fw',
        'fa-sharp fa-regular fa-laptop-mobile fa-fw',
        'fa-sharp fa-light fa-laptop-mobile fa-fw',
        'fa-regular fa-laptop-mobile fa-fw',
        'fa-light fa-laptop-mobile fa-fw',
        'fa-duotone fa-laptop-mobile fa-fw',
        'fa-thin fa-merge fa-fw',
        'fa-solid fa-merge fa-fw',
        'fa-sharp fa-solid fa-merge fa-fw',
        'fa-sharp fa-regular fa-merge fa-fw',
        'fa-sharp fa-light fa-merge fa-fw',
        'fa-regular fa-merge fa-fw',
        'fa-light fa-merge fa-fw',
        'fa-duotone fa-merge fa-fw',
        'fa-thin fa-microchip fa-fw',
        'fa-solid fa-microchip fa-fw',
        'fa-sharp fa-solid fa-microchip fa-fw',
        'fa-sharp fa-regular fa-microchip fa-fw',
        'fa-sharp fa-light fa-microchip fa-fw',
        'fa-regular fa-microchip fa-fw',
        'fa-light fa-microchip fa-fw',
        'fa-duotone fa-microchip fa-fw',
        'fa-thin fa-mug-saucer fa-fw',
        'fa-solid fa-mug-saucer fa-fw',
        'fa-sharp fa-solid fa-mug-saucer fa-fw',
        'fa-sharp fa-regular fa-mug-saucer fa-fw',
        'fa-sharp fa-light fa-mug-saucer fa-fw',
        'fa-regular fa-mug-saucer fa-fw',
        'fa-light fa-mug-saucer fa-fw',
        'fa-duotone fa-mug-saucer fa-fw',
        'fa-thin fa-network-wired fa-fw',
        'fa-solid fa-network-wired fa-fw',
        'fa-sharp fa-solid fa-network-wired fa-fw',
        'fa-sharp fa-regular fa-network-wired fa-fw',
        'fa-sharp fa-light fa-network-wired fa-fw',
        'fa-regular fa-network-wired fa-fw',
        'fa-light fa-network-wired fa-fw',
        'fa-duotone fa-network-wired fa-fw',
        'fa-thin fa-notdef fa-fw',
        'fa-solid fa-notdef fa-fw',
        'fa-sharp fa-solid fa-notdef fa-fw',
        'fa-sharp fa-regular fa-notdef fa-fw',
        'fa-sharp fa-light fa-notdef fa-fw',
        'fa-regular fa-notdef fa-fw',
        'fa-light fa-notdef fa-fw',
        'fa-duotone fa-notdef fa-fw',
        'fa-thin fa-octagon-exclamation fa-fw',
        'fa-solid fa-octagon-exclamation fa-fw',
        'fa-sharp fa-solid fa-octagon-exclamation fa-fw',
        'fa-sharp fa-regular fa-octagon-exclamation fa-fw',
        'fa-sharp fa-light fa-octagon-exclamation fa-fw',
        'fa-regular fa-octagon-exclamation fa-fw',
        'fa-light fa-octagon-exclamation fa-fw',
        'fa-duotone fa-octagon-exclamation fa-fw',
        'fa-thin fa-qrcode fa-fw',
        'fa-solid fa-qrcode fa-fw',
        'fa-sharp fa-solid fa-qrcode fa-fw',
        'fa-sharp fa-regular fa-qrcode fa-fw',
        'fa-sharp fa-light fa-qrcode fa-fw',
        'fa-regular fa-qrcode fa-fw',
        'fa-light fa-qrcode fa-fw',
        'fa-duotone fa-qrcode fa-fw',
        'fa-thin fa-rectangle-code fa-fw',
        'fa-solid fa-rectangle-code fa-fw',
        'fa-sharp fa-solid fa-rectangle-code fa-fw',
        'fa-sharp fa-regular fa-rectangle-code fa-fw',
        'fa-sharp fa-light fa-rectangle-code fa-fw',
        'fa-regular fa-rectangle-code fa-fw',
        'fa-light fa-rectangle-code fa-fw',
        'fa-duotone fa-rectangle-code fa-fw',
        'fa-thin fa-rectangle-terminal fa-fw',
        'fa-solid fa-rectangle-terminal fa-fw',
        'fa-sharp fa-solid fa-rectangle-terminal fa-fw',
        'fa-sharp fa-regular fa-rectangle-terminal fa-fw',
        'fa-sharp fa-light fa-rectangle-terminal fa-fw',
        'fa-regular fa-rectangle-terminal fa-fw',
        'fa-light fa-rectangle-terminal fa-fw',
        'fa-duotone fa-rectangle-terminal fa-fw',
        'fa-thin fa-rectangle-xmark fa-fw',
        'fa-solid fa-rectangle-xmark fa-fw',
        'fa-sharp fa-solid fa-rectangle-xmark fa-fw',
        'fa-sharp fa-regular fa-rectangle-xmark fa-fw',
        'fa-sharp fa-light fa-rectangle-xmark fa-fw',
        'fa-regular fa-rectangle-xmark fa-fw',
        'fa-light fa-rectangle-xmark fa-fw',
        'fa-duotone fa-rectangle-xmark fa-fw',
        'fa-thin fa-shield fa-fw',
        'fa-solid fa-shield fa-fw',
        'fa-sharp fa-solid fa-shield fa-fw',
        'fa-sharp fa-regular fa-shield fa-fw',
        'fa-sharp fa-light fa-shield fa-fw',
        'fa-regular fa-shield fa-fw',
        'fa-light fa-shield fa-fw',
        'fa-duotone fa-shield fa-fw',
        'fa-thin fa-shield-check fa-fw',
        'fa-solid fa-shield-check fa-fw',
        'fa-sharp fa-solid fa-shield-check fa-fw',
        'fa-sharp fa-regular fa-shield-check fa-fw',
        'fa-sharp fa-light fa-shield-check fa-fw',
        'fa-regular fa-shield-check fa-fw',
        'fa-light fa-shield-check fa-fw',
        'fa-duotone fa-shield-check fa-fw',
        'fa-thin fa-shield-halved fa-fw',
        'fa-solid fa-shield-halved fa-fw',
        'fa-sharp fa-solid fa-shield-halved fa-fw',
        'fa-sharp fa-regular fa-shield-halved fa-fw',
        'fa-sharp fa-light fa-shield-halved fa-fw',
        'fa-regular fa-shield-halved fa-fw',
        'fa-light fa-shield-halved fa-fw',
        'fa-duotone fa-shield-halved fa-fw',
        'fa-thin fa-sidebar fa-fw',
        'fa-solid fa-sidebar fa-fw',
        'fa-sharp fa-solid fa-sidebar fa-fw',
        'fa-sharp fa-regular fa-sidebar fa-fw',
        'fa-sharp fa-light fa-sidebar fa-fw',
        'fa-regular fa-sidebar fa-fw',
        'fa-light fa-sidebar fa-fw',
        'fa-duotone fa-sidebar fa-fw',
        'fa-thin fa-sidebar-flip fa-fw',
        'fa-solid fa-sidebar-flip fa-fw',
        'fa-sharp fa-solid fa-sidebar-flip fa-fw',
        'fa-sharp fa-regular fa-sidebar-flip fa-fw',
        'fa-sharp fa-light fa-sidebar-flip fa-fw',
        'fa-regular fa-sidebar-flip fa-fw',
        'fa-light fa-sidebar-flip fa-fw',
        'fa-duotone fa-sidebar-flip fa-fw',
        'fa-thin fa-sitemap fa-fw',
        'fa-solid fa-sitemap fa-fw',
        'fa-sharp fa-solid fa-sitemap fa-fw',
        'fa-sharp fa-regular fa-sitemap fa-fw',
        'fa-sharp fa-light fa-sitemap fa-fw',
        'fa-regular fa-sitemap fa-fw',
        'fa-light fa-sitemap fa-fw',
        'fa-duotone fa-sitemap fa-fw',
        'fa-thin fa-split fa-fw',
        'fa-solid fa-split fa-fw',
        'fa-sharp fa-solid fa-split fa-fw',
        'fa-sharp fa-regular fa-split fa-fw',
        'fa-sharp fa-light fa-split fa-fw',
        'fa-regular fa-split fa-fw',
        'fa-light fa-split fa-fw',
        'fa-duotone fa-split fa-fw',
        'fa-thin fa-square-code fa-fw',
        'fa-solid fa-square-code fa-fw',
        'fa-sharp fa-solid fa-square-code fa-fw',
        'fa-sharp fa-regular fa-square-code fa-fw',
        'fa-sharp fa-light fa-square-code fa-fw',
        'fa-regular fa-square-code fa-fw',
        'fa-light fa-square-code fa-fw',
        'fa-duotone fa-square-code fa-fw',
        'fa-thin fa-square-terminal fa-fw',
        'fa-solid fa-square-terminal fa-fw',
        'fa-sharp fa-solid fa-square-terminal fa-fw',
        'fa-sharp fa-regular fa-square-terminal fa-fw',
        'fa-sharp fa-light fa-square-terminal fa-fw',
        'fa-regular fa-square-terminal fa-fw',
        'fa-light fa-square-terminal fa-fw',
        'fa-duotone fa-square-terminal fa-fw',
        'fa-thin fa-terminal fa-fw',
        'fa-solid fa-terminal fa-fw',
        'fa-sharp fa-solid fa-terminal fa-fw',
        'fa-sharp fa-regular fa-terminal fa-fw',
        'fa-sharp fa-light fa-terminal fa-fw',
        'fa-regular fa-terminal fa-fw',
        'fa-light fa-terminal fa-fw',
        'fa-duotone fa-terminal fa-fw',
        'fa-thin fa-user-secret fa-fw',
        'fa-solid fa-user-secret fa-fw',
        'fa-sharp fa-solid fa-user-secret fa-fw',
        'fa-sharp fa-regular fa-user-secret fa-fw',
        'fa-sharp fa-light fa-user-secret fa-fw',
        'fa-regular fa-user-secret fa-fw',
        'fa-light fa-user-secret fa-fw',
        'fa-duotone fa-user-secret fa-fw',
        'fa-thin fa-webhook fa-fw',
        'fa-solid fa-webhook fa-fw',
        'fa-sharp fa-solid fa-webhook fa-fw',
        'fa-sharp fa-regular fa-webhook fa-fw',
        'fa-sharp fa-light fa-webhook fa-fw',
        'fa-regular fa-webhook fa-fw',
        'fa-light fa-webhook fa-fw',
        'fa-duotone fa-webhook fa-fw',
        'fa-thin fa-window fa-fw',
        'fa-solid fa-window fa-fw',
        'fa-sharp fa-solid fa-window fa-fw',
        'fa-sharp fa-regular fa-window fa-fw',
        'fa-sharp fa-light fa-window fa-fw',
        'fa-regular fa-window fa-fw',
        'fa-light fa-window fa-fw',
        'fa-duotone fa-window fa-fw',
        'fa-thin fa-window-flip fa-fw',
        'fa-solid fa-window-flip fa-fw',
        'fa-sharp fa-solid fa-window-flip fa-fw',
        'fa-sharp fa-regular fa-window-flip fa-fw',
        'fa-sharp fa-light fa-window-flip fa-fw',
        'fa-regular fa-window-flip fa-fw',
        'fa-light fa-window-flip fa-fw',
        'fa-duotone fa-window-flip fa-fw',
        'fa-thin fa-window-maximize fa-fw',
        'fa-solid fa-window-maximize fa-fw',
        'fa-sharp fa-solid fa-window-maximize fa-fw',
        'fa-sharp fa-regular fa-window-maximize fa-fw',
        'fa-sharp fa-light fa-window-maximize fa-fw',
        'fa-regular fa-window-maximize fa-fw',
        'fa-light fa-window-maximize fa-fw',
        'fa-duotone fa-window-maximize fa-fw',
        'fa-thin fa-window-minimize fa-fw',
        'fa-solid fa-window-minimize fa-fw',
        'fa-sharp fa-solid fa-window-minimize fa-fw',
        'fa-sharp fa-regular fa-window-minimize fa-fw',
        'fa-sharp fa-light fa-window-minimize fa-fw',
        'fa-regular fa-window-minimize fa-fw',
        'fa-light fa-window-minimize fa-fw',
        'fa-duotone fa-window-minimize fa-fw',
        'fa-thin fa-window-restore fa-fw',
        'fa-solid fa-window-restore fa-fw',
        'fa-sharp fa-solid fa-window-restore fa-fw',
        'fa-sharp fa-regular fa-window-restore fa-fw',
        'fa-sharp fa-light fa-window-restore fa-fw',
        'fa-regular fa-window-restore fa-fw',
        'fa-light fa-window-restore fa-fw',
        'fa-duotone fa-window-restore fa-fw',
        'fa-thin fa-wrench-simple fa-fw',
        'fa-solid fa-wrench-simple fa-fw',
        'fa-sharp fa-solid fa-wrench-simple fa-fw',
        'fa-sharp fa-regular fa-wrench-simple fa-fw',
        'fa-sharp fa-light fa-wrench-simple fa-fw',
        'fa-regular fa-wrench-simple fa-fw',
        'fa-light fa-wrench-simple fa-fw',
        'fa-duotone fa-wrench-simple fa-fw',
      ],
    },
    {
      title: 'Communication',
      items: [
        'fa-thin fa-address-book fa-fw',
        'fa-solid fa-address-book fa-fw',
        'fa-sharp fa-solid fa-address-book fa-fw',
        'fa-sharp fa-regular fa-address-book fa-fw',
        'fa-sharp fa-light fa-address-book fa-fw',
        'fa-regular fa-address-book fa-fw',
        'fa-light fa-address-book fa-fw',
        'fa-duotone fa-address-book fa-fw',
        'fa-thin fa-address-card fa-fw',
        'fa-solid fa-address-card fa-fw',
        'fa-sharp fa-solid fa-address-card fa-fw',
        'fa-sharp fa-regular fa-address-card fa-fw',
        'fa-sharp fa-light fa-address-card fa-fw',
        'fa-regular fa-address-card fa-fw',
        'fa-light fa-address-card fa-fw',
        'fa-duotone fa-address-card fa-fw',
        'fa-thin fa-at fa-fw',
        'fa-solid fa-at fa-fw',
        'fa-sharp fa-solid fa-at fa-fw',
        'fa-sharp fa-regular fa-at fa-fw',
        'fa-sharp fa-light fa-at fa-fw',
        'fa-regular fa-at fa-fw',
        'fa-light fa-at fa-fw',
        'fa-duotone fa-at fa-fw',
        'fa-thin fa-blender-phone fa-fw',
        'fa-solid fa-blender-phone fa-fw',
        'fa-sharp fa-solid fa-blender-phone fa-fw',
        'fa-sharp fa-regular fa-blender-phone fa-fw',
        'fa-sharp fa-light fa-blender-phone fa-fw',
        'fa-regular fa-blender-phone fa-fw',
        'fa-light fa-blender-phone fa-fw',
        'fa-duotone fa-blender-phone fa-fw',
        'fa-brands fa-bluetooth-b fa-fw',
        'fa-thin fa-bullhorn fa-fw',
        'fa-solid fa-bullhorn fa-fw',
        'fa-sharp fa-solid fa-bullhorn fa-fw',
        'fa-sharp fa-regular fa-bullhorn fa-fw',
        'fa-sharp fa-light fa-bullhorn fa-fw',
        'fa-regular fa-bullhorn fa-fw',
        'fa-light fa-bullhorn fa-fw',
        'fa-duotone fa-bullhorn fa-fw',
        'fa-thin fa-circle-envelope fa-fw',
        'fa-solid fa-circle-envelope fa-fw',
        'fa-sharp fa-solid fa-circle-envelope fa-fw',
        'fa-sharp fa-regular fa-circle-envelope fa-fw',
        'fa-sharp fa-light fa-circle-envelope fa-fw',
        'fa-regular fa-circle-envelope fa-fw',
        'fa-light fa-circle-envelope fa-fw',
        'fa-duotone fa-circle-envelope fa-fw',
        'fa-thin fa-circle-phone fa-fw',
        'fa-solid fa-circle-phone fa-fw',
        'fa-sharp fa-solid fa-circle-phone fa-fw',
        'fa-sharp fa-regular fa-circle-phone fa-fw',
        'fa-sharp fa-light fa-circle-phone fa-fw',
        'fa-regular fa-circle-phone fa-fw',
        'fa-light fa-circle-phone fa-fw',
        'fa-duotone fa-circle-phone fa-fw',
        'fa-thin fa-circle-phone-flip fa-fw',
        'fa-solid fa-circle-phone-flip fa-fw',
        'fa-sharp fa-solid fa-circle-phone-flip fa-fw',
        'fa-sharp fa-regular fa-circle-phone-flip fa-fw',
        'fa-sharp fa-light fa-circle-phone-flip fa-fw',
        'fa-regular fa-circle-phone-flip fa-fw',
        'fa-light fa-circle-phone-flip fa-fw',
        'fa-duotone fa-circle-phone-flip fa-fw',
        'fa-thin fa-circle-phone-hangup fa-fw',
        'fa-solid fa-circle-phone-hangup fa-fw',
        'fa-sharp fa-solid fa-circle-phone-hangup fa-fw',
        'fa-sharp fa-regular fa-circle-phone-hangup fa-fw',
        'fa-sharp fa-light fa-circle-phone-hangup fa-fw',
        'fa-regular fa-circle-phone-hangup fa-fw',
        'fa-light fa-circle-phone-hangup fa-fw',
        'fa-duotone fa-circle-phone-hangup fa-fw',
        'fa-thin fa-comment fa-fw',
        'fa-solid fa-comment fa-fw',
        'fa-sharp fa-solid fa-comment fa-fw',
        'fa-sharp fa-regular fa-comment fa-fw',
        'fa-sharp fa-light fa-comment fa-fw',
        'fa-regular fa-comment fa-fw',
        'fa-light fa-comment fa-fw',
        'fa-duotone fa-comment fa-fw',
        'fa-thin fa-comment-arrow-down fa-fw',
        'fa-solid fa-comment-arrow-down fa-fw',
        'fa-sharp fa-solid fa-comment-arrow-down fa-fw',
        'fa-sharp fa-regular fa-comment-arrow-down fa-fw',
        'fa-sharp fa-light fa-comment-arrow-down fa-fw',
        'fa-regular fa-comment-arrow-down fa-fw',
        'fa-light fa-comment-arrow-down fa-fw',
        'fa-duotone fa-comment-arrow-down fa-fw',
        'fa-thin fa-comment-arrow-up fa-fw',
        'fa-solid fa-comment-arrow-up fa-fw',
        'fa-sharp fa-solid fa-comment-arrow-up fa-fw',
        'fa-sharp fa-regular fa-comment-arrow-up fa-fw',
        'fa-sharp fa-light fa-comment-arrow-up fa-fw',
        'fa-regular fa-comment-arrow-up fa-fw',
        'fa-light fa-comment-arrow-up fa-fw',
        'fa-duotone fa-comment-arrow-up fa-fw',
        'fa-thin fa-comment-arrow-up-right fa-fw',
        'fa-solid fa-comment-arrow-up-right fa-fw',
        'fa-sharp fa-solid fa-comment-arrow-up-right fa-fw',
        'fa-sharp fa-regular fa-comment-arrow-up-right fa-fw',
        'fa-sharp fa-light fa-comment-arrow-up-right fa-fw',
        'fa-regular fa-comment-arrow-up-right fa-fw',
        'fa-light fa-comment-arrow-up-right fa-fw',
        'fa-duotone fa-comment-arrow-up-right fa-fw',
        'fa-thin fa-comment-captions fa-fw',
        'fa-solid fa-comment-captions fa-fw',
        'fa-sharp fa-solid fa-comment-captions fa-fw',
        'fa-sharp fa-regular fa-comment-captions fa-fw',
        'fa-sharp fa-light fa-comment-captions fa-fw',
        'fa-regular fa-comment-captions fa-fw',
        'fa-light fa-comment-captions fa-fw',
        'fa-duotone fa-comment-captions fa-fw',
        'fa-thin fa-comment-check fa-fw',
        'fa-solid fa-comment-check fa-fw',
        'fa-sharp fa-solid fa-comment-check fa-fw',
        'fa-sharp fa-regular fa-comment-check fa-fw',
        'fa-sharp fa-light fa-comment-check fa-fw',
        'fa-regular fa-comment-check fa-fw',
        'fa-light fa-comment-check fa-fw',
        'fa-duotone fa-comment-check fa-fw',
        'fa-thin fa-comment-code fa-fw',
        'fa-solid fa-comment-code fa-fw',
        'fa-sharp fa-solid fa-comment-code fa-fw',
        'fa-sharp fa-regular fa-comment-code fa-fw',
        'fa-sharp fa-light fa-comment-code fa-fw',
        'fa-regular fa-comment-code fa-fw',
        'fa-light fa-comment-code fa-fw',
        'fa-duotone fa-comment-code fa-fw',
        'fa-thin fa-comment-dots fa-fw',
        'fa-solid fa-comment-dots fa-fw',
        'fa-sharp fa-solid fa-comment-dots fa-fw',
        'fa-sharp fa-regular fa-comment-dots fa-fw',
        'fa-sharp fa-light fa-comment-dots fa-fw',
        'fa-regular fa-comment-dots fa-fw',
        'fa-light fa-comment-dots fa-fw',
        'fa-duotone fa-comment-dots fa-fw',
        'fa-thin fa-comment-exclamation fa-fw',
        'fa-solid fa-comment-exclamation fa-fw',
        'fa-sharp fa-solid fa-comment-exclamation fa-fw',
        'fa-sharp fa-regular fa-comment-exclamation fa-fw',
        'fa-sharp fa-light fa-comment-exclamation fa-fw',
        'fa-regular fa-comment-exclamation fa-fw',
        'fa-light fa-comment-exclamation fa-fw',
        'fa-duotone fa-comment-exclamation fa-fw',
        'fa-thin fa-comment-heart fa-fw',
        'fa-solid fa-comment-heart fa-fw',
        'fa-sharp fa-solid fa-comment-heart fa-fw',
        'fa-sharp fa-regular fa-comment-heart fa-fw',
        'fa-sharp fa-light fa-comment-heart fa-fw',
        'fa-regular fa-comment-heart fa-fw',
        'fa-light fa-comment-heart fa-fw',
        'fa-duotone fa-comment-heart fa-fw',
        'fa-thin fa-comment-image fa-fw',
        'fa-solid fa-comment-image fa-fw',
        'fa-sharp fa-solid fa-comment-image fa-fw',
        'fa-sharp fa-regular fa-comment-image fa-fw',
        'fa-sharp fa-light fa-comment-image fa-fw',
        'fa-regular fa-comment-image fa-fw',
        'fa-light fa-comment-image fa-fw',
        'fa-duotone fa-comment-image fa-fw',
        'fa-thin fa-comment-lines fa-fw',
        'fa-solid fa-comment-lines fa-fw',
        'fa-sharp fa-solid fa-comment-lines fa-fw',
        'fa-sharp fa-regular fa-comment-lines fa-fw',
        'fa-sharp fa-light fa-comment-lines fa-fw',
        'fa-regular fa-comment-lines fa-fw',
        'fa-light fa-comment-lines fa-fw',
        'fa-duotone fa-comment-lines fa-fw',
        'fa-thin fa-comment-medical fa-fw',
        'fa-solid fa-comment-medical fa-fw',
        'fa-sharp fa-solid fa-comment-medical fa-fw',
        'fa-sharp fa-regular fa-comment-medical fa-fw',
        'fa-sharp fa-light fa-comment-medical fa-fw',
        'fa-regular fa-comment-medical fa-fw',
        'fa-light fa-comment-medical fa-fw',
        'fa-duotone fa-comment-medical fa-fw',
        'fa-thin fa-comment-middle fa-fw',
        'fa-solid fa-comment-middle fa-fw',
        'fa-sharp fa-solid fa-comment-middle fa-fw',
        'fa-sharp fa-regular fa-comment-middle fa-fw',
        'fa-sharp fa-light fa-comment-middle fa-fw',
        'fa-regular fa-comment-middle fa-fw',
        'fa-light fa-comment-middle fa-fw',
        'fa-duotone fa-comment-middle fa-fw',
        'fa-thin fa-comment-middle-top fa-fw',
        'fa-solid fa-comment-middle-top fa-fw',
        'fa-sharp fa-solid fa-comment-middle-top fa-fw',
        'fa-sharp fa-regular fa-comment-middle-top fa-fw',
        'fa-sharp fa-light fa-comment-middle-top fa-fw',
        'fa-regular fa-comment-middle-top fa-fw',
        'fa-light fa-comment-middle-top fa-fw',
        'fa-duotone fa-comment-middle-top fa-fw',
        'fa-thin fa-comment-minus fa-fw',
        'fa-solid fa-comment-minus fa-fw',
        'fa-sharp fa-solid fa-comment-minus fa-fw',
        'fa-sharp fa-regular fa-comment-minus fa-fw',
        'fa-sharp fa-light fa-comment-minus fa-fw',
        'fa-regular fa-comment-minus fa-fw',
        'fa-light fa-comment-minus fa-fw',
        'fa-duotone fa-comment-minus fa-fw',
        'fa-thin fa-comment-music fa-fw',
        'fa-solid fa-comment-music fa-fw',
        'fa-sharp fa-solid fa-comment-music fa-fw',
        'fa-sharp fa-regular fa-comment-music fa-fw',
        'fa-sharp fa-light fa-comment-music fa-fw',
        'fa-regular fa-comment-music fa-fw',
        'fa-light fa-comment-music fa-fw',
        'fa-duotone fa-comment-music fa-fw',
        'fa-thin fa-comment-pen fa-fw',
        'fa-solid fa-comment-pen fa-fw',
        'fa-sharp fa-solid fa-comment-pen fa-fw',
        'fa-sharp fa-regular fa-comment-pen fa-fw',
        'fa-sharp fa-light fa-comment-pen fa-fw',
        'fa-regular fa-comment-pen fa-fw',
        'fa-light fa-comment-pen fa-fw',
        'fa-duotone fa-comment-pen fa-fw',
        'fa-thin fa-comment-plus fa-fw',
        'fa-solid fa-comment-plus fa-fw',
        'fa-sharp fa-solid fa-comment-plus fa-fw',
        'fa-sharp fa-regular fa-comment-plus fa-fw',
        'fa-sharp fa-light fa-comment-plus fa-fw',
        'fa-regular fa-comment-plus fa-fw',
        'fa-light fa-comment-plus fa-fw',
        'fa-duotone fa-comment-plus fa-fw',
        'fa-thin fa-comment-question fa-fw',
        'fa-solid fa-comment-question fa-fw',
        'fa-sharp fa-solid fa-comment-question fa-fw',
        'fa-sharp fa-regular fa-comment-question fa-fw',
        'fa-sharp fa-light fa-comment-question fa-fw',
        'fa-regular fa-comment-question fa-fw',
        'fa-light fa-comment-question fa-fw',
        'fa-duotone fa-comment-question fa-fw',
        'fa-thin fa-comment-quote fa-fw',
        'fa-solid fa-comment-quote fa-fw',
        'fa-sharp fa-solid fa-comment-quote fa-fw',
        'fa-sharp fa-regular fa-comment-quote fa-fw',
        'fa-sharp fa-light fa-comment-quote fa-fw',
        'fa-regular fa-comment-quote fa-fw',
        'fa-light fa-comment-quote fa-fw',
        'fa-duotone fa-comment-quote fa-fw',
        'fa-thin fa-comment-slash fa-fw',
        'fa-solid fa-comment-slash fa-fw',
        'fa-sharp fa-solid fa-comment-slash fa-fw',
        'fa-sharp fa-regular fa-comment-slash fa-fw',
        'fa-sharp fa-light fa-comment-slash fa-fw',
        'fa-regular fa-comment-slash fa-fw',
        'fa-light fa-comment-slash fa-fw',
        'fa-duotone fa-comment-slash fa-fw',
        'fa-thin fa-comment-smile fa-fw',
        'fa-solid fa-comment-smile fa-fw',
        'fa-sharp fa-solid fa-comment-smile fa-fw',
        'fa-sharp fa-regular fa-comment-smile fa-fw',
        'fa-sharp fa-light fa-comment-smile fa-fw',
        'fa-regular fa-comment-smile fa-fw',
        'fa-light fa-comment-smile fa-fw',
        'fa-duotone fa-comment-smile fa-fw',
        'fa-thin fa-comment-sms fa-fw',
        'fa-solid fa-comment-sms fa-fw',
        'fa-sharp fa-solid fa-comment-sms fa-fw',
        'fa-sharp fa-regular fa-comment-sms fa-fw',
        'fa-sharp fa-light fa-comment-sms fa-fw',
        'fa-regular fa-comment-sms fa-fw',
        'fa-light fa-comment-sms fa-fw',
        'fa-duotone fa-comment-sms fa-fw',
        'fa-thin fa-comment-text fa-fw',
        'fa-solid fa-comment-text fa-fw',
        'fa-sharp fa-solid fa-comment-text fa-fw',
        'fa-sharp fa-regular fa-comment-text fa-fw',
        'fa-sharp fa-light fa-comment-text fa-fw',
        'fa-regular fa-comment-text fa-fw',
        'fa-light fa-comment-text fa-fw',
        'fa-duotone fa-comment-text fa-fw',
        'fa-thin fa-comment-xmark fa-fw',
        'fa-solid fa-comment-xmark fa-fw',
        'fa-sharp fa-solid fa-comment-xmark fa-fw',
        'fa-sharp fa-regular fa-comment-xmark fa-fw',
        'fa-sharp fa-light fa-comment-xmark fa-fw',
        'fa-regular fa-comment-xmark fa-fw',
        'fa-light fa-comment-xmark fa-fw',
        'fa-duotone fa-comment-xmark fa-fw',
        'fa-thin fa-comments fa-fw',
        'fa-solid fa-comments fa-fw',
        'fa-sharp fa-solid fa-comments fa-fw',
        'fa-sharp fa-regular fa-comments fa-fw',
        'fa-sharp fa-light fa-comments fa-fw',
        'fa-regular fa-comments fa-fw',
        'fa-light fa-comments fa-fw',
        'fa-duotone fa-comments fa-fw',
        'fa-thin fa-comments-question fa-fw',
        'fa-solid fa-comments-question fa-fw',
        'fa-sharp fa-solid fa-comments-question fa-fw',
        'fa-sharp fa-regular fa-comments-question fa-fw',
        'fa-sharp fa-light fa-comments-question fa-fw',
        'fa-regular fa-comments-question fa-fw',
        'fa-light fa-comments-question fa-fw',
        'fa-duotone fa-comments-question fa-fw',
        'fa-thin fa-comments-question-check fa-fw',
        'fa-solid fa-comments-question-check fa-fw',
        'fa-sharp fa-solid fa-comments-question-check fa-fw',
        'fa-sharp fa-regular fa-comments-question-check fa-fw',
        'fa-sharp fa-light fa-comments-question-check fa-fw',
        'fa-regular fa-comments-question-check fa-fw',
        'fa-light fa-comments-question-check fa-fw',
        'fa-duotone fa-comments-question-check fa-fw',
        'fa-thin fa-crystal-ball fa-fw',
        'fa-solid fa-crystal-ball fa-fw',
        'fa-sharp fa-solid fa-crystal-ball fa-fw',
        'fa-sharp fa-regular fa-crystal-ball fa-fw',
        'fa-sharp fa-light fa-crystal-ball fa-fw',
        'fa-regular fa-crystal-ball fa-fw',
        'fa-light fa-crystal-ball fa-fw',
        'fa-duotone fa-crystal-ball fa-fw',
        'fa-thin fa-ear-listen fa-fw',
        'fa-solid fa-ear-listen fa-fw',
        'fa-sharp fa-solid fa-ear-listen fa-fw',
        'fa-sharp fa-regular fa-ear-listen fa-fw',
        'fa-sharp fa-light fa-ear-listen fa-fw',
        'fa-regular fa-ear-listen fa-fw',
        'fa-light fa-ear-listen fa-fw',
        'fa-duotone fa-ear-listen fa-fw',
        'fa-thin fa-envelope fa-fw',
        'fa-solid fa-envelope fa-fw',
        'fa-sharp fa-solid fa-envelope fa-fw',
        'fa-sharp fa-regular fa-envelope fa-fw',
        'fa-sharp fa-light fa-envelope fa-fw',
        'fa-regular fa-envelope fa-fw',
        'fa-light fa-envelope fa-fw',
        'fa-duotone fa-envelope fa-fw',
        'fa-thin fa-envelope-circle-check fa-fw',
        'fa-solid fa-envelope-circle-check fa-fw',
        'fa-sharp fa-solid fa-envelope-circle-check fa-fw',
        'fa-sharp fa-regular fa-envelope-circle-check fa-fw',
        'fa-sharp fa-light fa-envelope-circle-check fa-fw',
        'fa-regular fa-envelope-circle-check fa-fw',
        'fa-light fa-envelope-circle-check fa-fw',
        'fa-duotone fa-envelope-circle-check fa-fw',
        'fa-thin fa-envelope-dot fa-fw',
        'fa-solid fa-envelope-dot fa-fw',
        'fa-sharp fa-solid fa-envelope-dot fa-fw',
        'fa-sharp fa-regular fa-envelope-dot fa-fw',
        'fa-sharp fa-light fa-envelope-dot fa-fw',
        'fa-regular fa-envelope-dot fa-fw',
        'fa-light fa-envelope-dot fa-fw',
        'fa-duotone fa-envelope-dot fa-fw',
        'fa-thin fa-envelope-open fa-fw',
        'fa-solid fa-envelope-open fa-fw',
        'fa-sharp fa-solid fa-envelope-open fa-fw',
        'fa-sharp fa-regular fa-envelope-open fa-fw',
        'fa-sharp fa-light fa-envelope-open fa-fw',
        'fa-regular fa-envelope-open fa-fw',
        'fa-light fa-envelope-open fa-fw',
        'fa-duotone fa-envelope-open fa-fw',
        'fa-thin fa-envelopes fa-fw',
        'fa-solid fa-envelopes fa-fw',
        'fa-sharp fa-solid fa-envelopes fa-fw',
        'fa-sharp fa-regular fa-envelopes fa-fw',
        'fa-sharp fa-light fa-envelopes fa-fw',
        'fa-regular fa-envelopes fa-fw',
        'fa-light fa-envelopes fa-fw',
        'fa-duotone fa-envelopes fa-fw',
        'fa-thin fa-face-awesome fa-fw',
        'fa-solid fa-face-awesome fa-fw',
        'fa-sharp fa-solid fa-face-awesome fa-fw',
        'fa-sharp fa-regular fa-face-awesome fa-fw',
        'fa-sharp fa-light fa-face-awesome fa-fw',
        'fa-regular fa-face-awesome fa-fw',
        'fa-light fa-face-awesome fa-fw',
        'fa-duotone fa-face-awesome fa-fw',
        'fa-thin fa-face-frown fa-fw',
        'fa-solid fa-face-frown fa-fw',
        'fa-sharp fa-solid fa-face-frown fa-fw',
        'fa-sharp fa-regular fa-face-frown fa-fw',
        'fa-sharp fa-light fa-face-frown fa-fw',
        'fa-regular fa-face-frown fa-fw',
        'fa-light fa-face-frown fa-fw',
        'fa-duotone fa-face-frown fa-fw',
        'fa-thin fa-face-meh fa-fw',
        'fa-solid fa-face-meh fa-fw',
        'fa-sharp fa-solid fa-face-meh fa-fw',
        'fa-sharp fa-regular fa-face-meh fa-fw',
        'fa-sharp fa-light fa-face-meh fa-fw',
        'fa-regular fa-face-meh fa-fw',
        'fa-light fa-face-meh fa-fw',
        'fa-duotone fa-face-meh fa-fw',
        'fa-thin fa-face-smile fa-fw',
        'fa-solid fa-face-smile fa-fw',
        'fa-sharp fa-solid fa-face-smile fa-fw',
        'fa-sharp fa-regular fa-face-smile fa-fw',
        'fa-sharp fa-light fa-face-smile fa-fw',
        'fa-regular fa-face-smile fa-fw',
        'fa-light fa-face-smile fa-fw',
        'fa-duotone fa-face-smile fa-fw',
        'fa-thin fa-face-smile-plus fa-fw',
        'fa-solid fa-face-smile-plus fa-fw',
        'fa-sharp fa-solid fa-face-smile-plus fa-fw',
        'fa-sharp fa-regular fa-face-smile-plus fa-fw',
        'fa-sharp fa-light fa-face-smile-plus fa-fw',
        'fa-regular fa-face-smile-plus fa-fw',
        'fa-light fa-face-smile-plus fa-fw',
        'fa-duotone fa-face-smile-plus fa-fw',
        'fa-thin fa-fax fa-fw',
        'fa-solid fa-fax fa-fw',
        'fa-sharp fa-solid fa-fax fa-fw',
        'fa-sharp fa-regular fa-fax fa-fw',
        'fa-sharp fa-light fa-fax fa-fw',
        'fa-regular fa-fax fa-fw',
        'fa-light fa-fax fa-fw',
        'fa-duotone fa-fax fa-fw',
        'fa-thin fa-hands-asl-interpreting fa-fw',
        'fa-solid fa-hands-asl-interpreting fa-fw',
        'fa-sharp fa-solid fa-hands-asl-interpreting fa-fw',
        'fa-sharp fa-regular fa-hands-asl-interpreting fa-fw',
        'fa-sharp fa-light fa-hands-asl-interpreting fa-fw',
        'fa-regular fa-hands-asl-interpreting fa-fw',
        'fa-light fa-hands-asl-interpreting fa-fw',
        'fa-duotone fa-hands-asl-interpreting fa-fw',
        'fa-thin fa-hundred-points fa-fw',
        'fa-solid fa-hundred-points fa-fw',
        'fa-sharp fa-solid fa-hundred-points fa-fw',
        'fa-sharp fa-regular fa-hundred-points fa-fw',
        'fa-sharp fa-light fa-hundred-points fa-fw',
        'fa-regular fa-hundred-points fa-fw',
        'fa-light fa-hundred-points fa-fw',
        'fa-duotone fa-hundred-points fa-fw',
        'fa-thin fa-icons fa-fw',
        'fa-solid fa-icons fa-fw',
        'fa-sharp fa-solid fa-icons fa-fw',
        'fa-sharp fa-regular fa-icons fa-fw',
        'fa-sharp fa-light fa-icons fa-fw',
        'fa-regular fa-icons fa-fw',
        'fa-light fa-icons fa-fw',
        'fa-duotone fa-icons fa-fw',
        'fa-thin fa-inbox fa-fw',
        'fa-solid fa-inbox fa-fw',
        'fa-sharp fa-solid fa-inbox fa-fw',
        'fa-sharp fa-regular fa-inbox fa-fw',
        'fa-sharp fa-light fa-inbox fa-fw',
        'fa-regular fa-inbox fa-fw',
        'fa-light fa-inbox fa-fw',
        'fa-duotone fa-inbox fa-fw',
        'fa-thin fa-inbox-in fa-fw',
        'fa-solid fa-inbox-in fa-fw',
        'fa-sharp fa-solid fa-inbox-in fa-fw',
        'fa-sharp fa-regular fa-inbox-in fa-fw',
        'fa-sharp fa-light fa-inbox-in fa-fw',
        'fa-regular fa-inbox-in fa-fw',
        'fa-light fa-inbox-in fa-fw',
        'fa-duotone fa-inbox-in fa-fw',
        'fa-thin fa-inbox-out fa-fw',
        'fa-solid fa-inbox-out fa-fw',
        'fa-sharp fa-solid fa-inbox-out fa-fw',
        'fa-sharp fa-regular fa-inbox-out fa-fw',
        'fa-sharp fa-light fa-inbox-out fa-fw',
        'fa-regular fa-inbox-out fa-fw',
        'fa-light fa-inbox-out fa-fw',
        'fa-duotone fa-inbox-out fa-fw',
        'fa-thin fa-language fa-fw',
        'fa-solid fa-language fa-fw',
        'fa-sharp fa-solid fa-language fa-fw',
        'fa-sharp fa-regular fa-language fa-fw',
        'fa-sharp fa-light fa-language fa-fw',
        'fa-regular fa-language fa-fw',
        'fa-light fa-language fa-fw',
        'fa-duotone fa-language fa-fw',
        'fa-thin fa-mailbox fa-fw',
        'fa-solid fa-mailbox fa-fw',
        'fa-sharp fa-solid fa-mailbox fa-fw',
        'fa-sharp fa-regular fa-mailbox fa-fw',
        'fa-sharp fa-light fa-mailbox fa-fw',
        'fa-regular fa-mailbox fa-fw',
        'fa-light fa-mailbox fa-fw',
        'fa-duotone fa-mailbox fa-fw',
        'fa-thin fa-mailbox-flag-up fa-fw',
        'fa-solid fa-mailbox-flag-up fa-fw',
        'fa-sharp fa-solid fa-mailbox-flag-up fa-fw',
        'fa-sharp fa-regular fa-mailbox-flag-up fa-fw',
        'fa-sharp fa-light fa-mailbox-flag-up fa-fw',
        'fa-regular fa-mailbox-flag-up fa-fw',
        'fa-light fa-mailbox-flag-up fa-fw',
        'fa-duotone fa-mailbox-flag-up fa-fw',
        'fa-thin fa-message fa-fw',
        'fa-solid fa-message fa-fw',
        'fa-sharp fa-solid fa-message fa-fw',
        'fa-sharp fa-regular fa-message fa-fw',
        'fa-sharp fa-light fa-message fa-fw',
        'fa-regular fa-message fa-fw',
        'fa-light fa-message fa-fw',
        'fa-duotone fa-message fa-fw',
        'fa-thin fa-message-arrow-down fa-fw',
        'fa-solid fa-message-arrow-down fa-fw',
        'fa-sharp fa-solid fa-message-arrow-down fa-fw',
        'fa-sharp fa-regular fa-message-arrow-down fa-fw',
        'fa-sharp fa-light fa-message-arrow-down fa-fw',
        'fa-regular fa-message-arrow-down fa-fw',
        'fa-light fa-message-arrow-down fa-fw',
        'fa-duotone fa-message-arrow-down fa-fw',
        'fa-thin fa-message-arrow-up fa-fw',
        'fa-solid fa-message-arrow-up fa-fw',
        'fa-sharp fa-solid fa-message-arrow-up fa-fw',
        'fa-sharp fa-regular fa-message-arrow-up fa-fw',
        'fa-sharp fa-light fa-message-arrow-up fa-fw',
        'fa-regular fa-message-arrow-up fa-fw',
        'fa-light fa-message-arrow-up fa-fw',
        'fa-duotone fa-message-arrow-up fa-fw',
        'fa-thin fa-message-arrow-up-right fa-fw',
        'fa-solid fa-message-arrow-up-right fa-fw',
        'fa-sharp fa-solid fa-message-arrow-up-right fa-fw',
        'fa-sharp fa-regular fa-message-arrow-up-right fa-fw',
        'fa-sharp fa-light fa-message-arrow-up-right fa-fw',
        'fa-regular fa-message-arrow-up-right fa-fw',
        'fa-light fa-message-arrow-up-right fa-fw',
        'fa-duotone fa-message-arrow-up-right fa-fw',
        'fa-thin fa-message-bot fa-fw',
        'fa-solid fa-message-bot fa-fw',
        'fa-sharp fa-solid fa-message-bot fa-fw',
        'fa-sharp fa-regular fa-message-bot fa-fw',
        'fa-sharp fa-light fa-message-bot fa-fw',
        'fa-regular fa-message-bot fa-fw',
        'fa-light fa-message-bot fa-fw',
        'fa-duotone fa-message-bot fa-fw',
        'fa-thin fa-message-check fa-fw',
        'fa-solid fa-message-check fa-fw',
        'fa-sharp fa-solid fa-message-check fa-fw',
        'fa-sharp fa-regular fa-message-check fa-fw',
        'fa-sharp fa-light fa-message-check fa-fw',
        'fa-regular fa-message-check fa-fw',
        'fa-light fa-message-check fa-fw',
        'fa-duotone fa-message-check fa-fw',
        'fa-thin fa-message-code fa-fw',
        'fa-solid fa-message-code fa-fw',
        'fa-sharp fa-solid fa-message-code fa-fw',
        'fa-sharp fa-regular fa-message-code fa-fw',
        'fa-sharp fa-light fa-message-code fa-fw',
        'fa-regular fa-message-code fa-fw',
        'fa-light fa-message-code fa-fw',
        'fa-duotone fa-message-code fa-fw',
        'fa-thin fa-message-dots fa-fw',
        'fa-solid fa-message-dots fa-fw',
        'fa-sharp fa-solid fa-message-dots fa-fw',
        'fa-sharp fa-regular fa-message-dots fa-fw',
        'fa-sharp fa-light fa-message-dots fa-fw',
        'fa-regular fa-message-dots fa-fw',
        'fa-light fa-message-dots fa-fw',
        'fa-duotone fa-message-dots fa-fw',
        'fa-thin fa-message-exclamation fa-fw',
        'fa-solid fa-message-exclamation fa-fw',
        'fa-sharp fa-solid fa-message-exclamation fa-fw',
        'fa-sharp fa-regular fa-message-exclamation fa-fw',
        'fa-sharp fa-light fa-message-exclamation fa-fw',
        'fa-regular fa-message-exclamation fa-fw',
        'fa-light fa-message-exclamation fa-fw',
        'fa-duotone fa-message-exclamation fa-fw',
        'fa-thin fa-message-heart fa-fw',
        'fa-solid fa-message-heart fa-fw',
        'fa-sharp fa-solid fa-message-heart fa-fw',
        'fa-sharp fa-regular fa-message-heart fa-fw',
        'fa-sharp fa-light fa-message-heart fa-fw',
        'fa-regular fa-message-heart fa-fw',
        'fa-light fa-message-heart fa-fw',
        'fa-duotone fa-message-heart fa-fw',
        'fa-thin fa-message-image fa-fw',
        'fa-solid fa-message-image fa-fw',
        'fa-sharp fa-solid fa-message-image fa-fw',
        'fa-sharp fa-regular fa-message-image fa-fw',
        'fa-sharp fa-light fa-message-image fa-fw',
        'fa-regular fa-message-image fa-fw',
        'fa-light fa-message-image fa-fw',
        'fa-duotone fa-message-image fa-fw',
        'fa-thin fa-message-lines fa-fw',
        'fa-solid fa-message-lines fa-fw',
        'fa-sharp fa-solid fa-message-lines fa-fw',
        'fa-sharp fa-regular fa-message-lines fa-fw',
        'fa-sharp fa-light fa-message-lines fa-fw',
        'fa-regular fa-message-lines fa-fw',
        'fa-light fa-message-lines fa-fw',
        'fa-duotone fa-message-lines fa-fw',
        'fa-thin fa-message-medical fa-fw',
        'fa-solid fa-message-medical fa-fw',
        'fa-sharp fa-solid fa-message-medical fa-fw',
        'fa-sharp fa-regular fa-message-medical fa-fw',
        'fa-sharp fa-light fa-message-medical fa-fw',
        'fa-regular fa-message-medical fa-fw',
        'fa-light fa-message-medical fa-fw',
        'fa-duotone fa-message-medical fa-fw',
        'fa-thin fa-message-middle fa-fw',
        'fa-solid fa-message-middle fa-fw',
        'fa-sharp fa-solid fa-message-middle fa-fw',
        'fa-sharp fa-regular fa-message-middle fa-fw',
        'fa-sharp fa-light fa-message-middle fa-fw',
        'fa-regular fa-message-middle fa-fw',
        'fa-light fa-message-middle fa-fw',
        'fa-duotone fa-message-middle fa-fw',
        'fa-thin fa-message-middle-top fa-fw',
        'fa-solid fa-message-middle-top fa-fw',
        'fa-sharp fa-solid fa-message-middle-top fa-fw',
        'fa-sharp fa-regular fa-message-middle-top fa-fw',
        'fa-sharp fa-light fa-message-middle-top fa-fw',
        'fa-regular fa-message-middle-top fa-fw',
        'fa-light fa-message-middle-top fa-fw',
        'fa-duotone fa-message-middle-top fa-fw',
        'fa-thin fa-message-minus fa-fw',
        'fa-solid fa-message-minus fa-fw',
        'fa-sharp fa-solid fa-message-minus fa-fw',
        'fa-sharp fa-regular fa-message-minus fa-fw',
        'fa-sharp fa-light fa-message-minus fa-fw',
        'fa-regular fa-message-minus fa-fw',
        'fa-light fa-message-minus fa-fw',
        'fa-duotone fa-message-minus fa-fw',
        'fa-thin fa-message-pen fa-fw',
        'fa-solid fa-message-pen fa-fw',
        'fa-sharp fa-solid fa-message-pen fa-fw',
        'fa-sharp fa-regular fa-message-pen fa-fw',
        'fa-sharp fa-light fa-message-pen fa-fw',
        'fa-regular fa-message-pen fa-fw',
        'fa-light fa-message-pen fa-fw',
        'fa-duotone fa-message-pen fa-fw',
        'fa-thin fa-message-plus fa-fw',
        'fa-solid fa-message-plus fa-fw',
        'fa-sharp fa-solid fa-message-plus fa-fw',
        'fa-sharp fa-regular fa-message-plus fa-fw',
        'fa-sharp fa-light fa-message-plus fa-fw',
        'fa-regular fa-message-plus fa-fw',
        'fa-light fa-message-plus fa-fw',
        'fa-duotone fa-message-plus fa-fw',
        'fa-thin fa-message-question fa-fw',
        'fa-solid fa-message-question fa-fw',
        'fa-sharp fa-solid fa-message-question fa-fw',
        'fa-sharp fa-regular fa-message-question fa-fw',
        'fa-sharp fa-light fa-message-question fa-fw',
        'fa-regular fa-message-question fa-fw',
        'fa-light fa-message-question fa-fw',
        'fa-duotone fa-message-question fa-fw',
        'fa-thin fa-message-quote fa-fw',
        'fa-solid fa-message-quote fa-fw',
        'fa-sharp fa-solid fa-message-quote fa-fw',
        'fa-sharp fa-regular fa-message-quote fa-fw',
        'fa-sharp fa-light fa-message-quote fa-fw',
        'fa-regular fa-message-quote fa-fw',
        'fa-light fa-message-quote fa-fw',
        'fa-duotone fa-message-quote fa-fw',
        'fa-thin fa-message-slash fa-fw',
        'fa-solid fa-message-slash fa-fw',
        'fa-sharp fa-solid fa-message-slash fa-fw',
        'fa-sharp fa-regular fa-message-slash fa-fw',
        'fa-sharp fa-light fa-message-slash fa-fw',
        'fa-regular fa-message-slash fa-fw',
        'fa-light fa-message-slash fa-fw',
        'fa-duotone fa-message-slash fa-fw',
        'fa-thin fa-message-smile fa-fw',
        'fa-solid fa-message-smile fa-fw',
        'fa-sharp fa-solid fa-message-smile fa-fw',
        'fa-sharp fa-regular fa-message-smile fa-fw',
        'fa-sharp fa-light fa-message-smile fa-fw',
        'fa-regular fa-message-smile fa-fw',
        'fa-light fa-message-smile fa-fw',
        'fa-duotone fa-message-smile fa-fw',
        'fa-thin fa-message-sms fa-fw',
        'fa-solid fa-message-sms fa-fw',
        'fa-sharp fa-solid fa-message-sms fa-fw',
        'fa-sharp fa-regular fa-message-sms fa-fw',
        'fa-sharp fa-light fa-message-sms fa-fw',
        'fa-regular fa-message-sms fa-fw',
        'fa-light fa-message-sms fa-fw',
        'fa-duotone fa-message-sms fa-fw',
        'fa-thin fa-message-text fa-fw',
        'fa-solid fa-message-text fa-fw',
        'fa-sharp fa-solid fa-message-text fa-fw',
        'fa-sharp fa-regular fa-message-text fa-fw',
        'fa-sharp fa-light fa-message-text fa-fw',
        'fa-regular fa-message-text fa-fw',
        'fa-light fa-message-text fa-fw',
        'fa-duotone fa-message-text fa-fw',
        'fa-thin fa-message-xmark fa-fw',
        'fa-solid fa-message-xmark fa-fw',
        'fa-sharp fa-solid fa-message-xmark fa-fw',
        'fa-sharp fa-regular fa-message-xmark fa-fw',
        'fa-sharp fa-light fa-message-xmark fa-fw',
        'fa-regular fa-message-xmark fa-fw',
        'fa-light fa-message-xmark fa-fw',
        'fa-duotone fa-message-xmark fa-fw',
        'fa-thin fa-messages fa-fw',
        'fa-solid fa-messages fa-fw',
        'fa-sharp fa-solid fa-messages fa-fw',
        'fa-sharp fa-regular fa-messages fa-fw',
        'fa-sharp fa-light fa-messages fa-fw',
        'fa-regular fa-messages fa-fw',
        'fa-light fa-messages fa-fw',
        'fa-duotone fa-messages fa-fw',
        'fa-thin fa-messages-question fa-fw',
        'fa-solid fa-messages-question fa-fw',
        'fa-sharp fa-solid fa-messages-question fa-fw',
        'fa-sharp fa-regular fa-messages-question fa-fw',
        'fa-sharp fa-light fa-messages-question fa-fw',
        'fa-regular fa-messages-question fa-fw',
        'fa-light fa-messages-question fa-fw',
        'fa-duotone fa-messages-question fa-fw',
        'fa-thin fa-microphone fa-fw',
        'fa-solid fa-microphone fa-fw',
        'fa-sharp fa-solid fa-microphone fa-fw',
        'fa-sharp fa-regular fa-microphone fa-fw',
        'fa-sharp fa-light fa-microphone fa-fw',
        'fa-regular fa-microphone fa-fw',
        'fa-light fa-microphone fa-fw',
        'fa-duotone fa-microphone fa-fw',
        'fa-thin fa-microphone-lines fa-fw',
        'fa-solid fa-microphone-lines fa-fw',
        'fa-sharp fa-solid fa-microphone-lines fa-fw',
        'fa-sharp fa-regular fa-microphone-lines fa-fw',
        'fa-sharp fa-light fa-microphone-lines fa-fw',
        'fa-regular fa-microphone-lines fa-fw',
        'fa-light fa-microphone-lines fa-fw',
        'fa-duotone fa-microphone-lines fa-fw',
        'fa-thin fa-microphone-lines-slash fa-fw',
        'fa-solid fa-microphone-lines-slash fa-fw',
        'fa-sharp fa-solid fa-microphone-lines-slash fa-fw',
        'fa-sharp fa-regular fa-microphone-lines-slash fa-fw',
        'fa-sharp fa-light fa-microphone-lines-slash fa-fw',
        'fa-regular fa-microphone-lines-slash fa-fw',
        'fa-light fa-microphone-lines-slash fa-fw',
        'fa-duotone fa-microphone-lines-slash fa-fw',
        'fa-thin fa-microphone-slash fa-fw',
        'fa-solid fa-microphone-slash fa-fw',
        'fa-sharp fa-solid fa-microphone-slash fa-fw',
        'fa-sharp fa-regular fa-microphone-slash fa-fw',
        'fa-sharp fa-light fa-microphone-slash fa-fw',
        'fa-regular fa-microphone-slash fa-fw',
        'fa-light fa-microphone-slash fa-fw',
        'fa-duotone fa-microphone-slash fa-fw',
        'fa-thin fa-mobile fa-fw',
        'fa-solid fa-mobile fa-fw',
        'fa-sharp fa-solid fa-mobile fa-fw',
        'fa-sharp fa-regular fa-mobile fa-fw',
        'fa-sharp fa-light fa-mobile fa-fw',
        'fa-regular fa-mobile fa-fw',
        'fa-light fa-mobile fa-fw',
        'fa-duotone fa-mobile fa-fw',
        'fa-thin fa-mobile-button fa-fw',
        'fa-solid fa-mobile-button fa-fw',
        'fa-sharp fa-solid fa-mobile-button fa-fw',
        'fa-sharp fa-regular fa-mobile-button fa-fw',
        'fa-sharp fa-light fa-mobile-button fa-fw',
        'fa-regular fa-mobile-button fa-fw',
        'fa-light fa-mobile-button fa-fw',
        'fa-duotone fa-mobile-button fa-fw',
        'fa-thin fa-mobile-notch fa-fw',
        'fa-solid fa-mobile-notch fa-fw',
        'fa-sharp fa-solid fa-mobile-notch fa-fw',
        'fa-sharp fa-regular fa-mobile-notch fa-fw',
        'fa-sharp fa-light fa-mobile-notch fa-fw',
        'fa-regular fa-mobile-notch fa-fw',
        'fa-light fa-mobile-notch fa-fw',
        'fa-duotone fa-mobile-notch fa-fw',
        'fa-thin fa-mobile-retro fa-fw',
        'fa-solid fa-mobile-retro fa-fw',
        'fa-sharp fa-solid fa-mobile-retro fa-fw',
        'fa-sharp fa-regular fa-mobile-retro fa-fw',
        'fa-sharp fa-light fa-mobile-retro fa-fw',
        'fa-regular fa-mobile-retro fa-fw',
        'fa-light fa-mobile-retro fa-fw',
        'fa-duotone fa-mobile-retro fa-fw',
        'fa-thin fa-mobile-screen fa-fw',
        'fa-solid fa-mobile-screen fa-fw',
        'fa-sharp fa-solid fa-mobile-screen fa-fw',
        'fa-sharp fa-regular fa-mobile-screen fa-fw',
        'fa-sharp fa-light fa-mobile-screen fa-fw',
        'fa-regular fa-mobile-screen fa-fw',
        'fa-light fa-mobile-screen fa-fw',
        'fa-duotone fa-mobile-screen fa-fw',
        'fa-thin fa-mobile-screen-button fa-fw',
        'fa-solid fa-mobile-screen-button fa-fw',
        'fa-sharp fa-solid fa-mobile-screen-button fa-fw',
        'fa-sharp fa-regular fa-mobile-screen-button fa-fw',
        'fa-sharp fa-light fa-mobile-screen-button fa-fw',
        'fa-regular fa-mobile-screen-button fa-fw',
        'fa-light fa-mobile-screen-button fa-fw',
        'fa-duotone fa-mobile-screen-button fa-fw',
        'fa-thin fa-paper-plane fa-fw',
        'fa-solid fa-paper-plane fa-fw',
        'fa-sharp fa-solid fa-paper-plane fa-fw',
        'fa-sharp fa-regular fa-paper-plane fa-fw',
        'fa-sharp fa-light fa-paper-plane fa-fw',
        'fa-regular fa-paper-plane fa-fw',
        'fa-light fa-paper-plane fa-fw',
        'fa-duotone fa-paper-plane fa-fw',
        'fa-thin fa-paper-plane-top fa-fw',
        'fa-solid fa-paper-plane-top fa-fw',
        'fa-sharp fa-solid fa-paper-plane-top fa-fw',
        'fa-sharp fa-regular fa-paper-plane-top fa-fw',
        'fa-sharp fa-light fa-paper-plane-top fa-fw',
        'fa-regular fa-paper-plane-top fa-fw',
        'fa-light fa-paper-plane-top fa-fw',
        'fa-duotone fa-paper-plane-top fa-fw',
        'fa-thin fa-phone fa-fw',
        'fa-solid fa-phone fa-fw',
        'fa-sharp fa-solid fa-phone fa-fw',
        'fa-sharp fa-regular fa-phone fa-fw',
        'fa-sharp fa-light fa-phone fa-fw',
        'fa-regular fa-phone fa-fw',
        'fa-light fa-phone fa-fw',
        'fa-duotone fa-phone fa-fw',
        'fa-thin fa-phone-arrow-down-left fa-fw',
        'fa-solid fa-phone-arrow-down-left fa-fw',
        'fa-sharp fa-solid fa-phone-arrow-down-left fa-fw',
        'fa-sharp fa-regular fa-phone-arrow-down-left fa-fw',
        'fa-sharp fa-light fa-phone-arrow-down-left fa-fw',
        'fa-regular fa-phone-arrow-down-left fa-fw',
        'fa-light fa-phone-arrow-down-left fa-fw',
        'fa-duotone fa-phone-arrow-down-left fa-fw',
        'fa-thin fa-phone-arrow-right fa-fw',
        'fa-solid fa-phone-arrow-right fa-fw',
        'fa-sharp fa-solid fa-phone-arrow-right fa-fw',
        'fa-sharp fa-regular fa-phone-arrow-right fa-fw',
        'fa-sharp fa-light fa-phone-arrow-right fa-fw',
        'fa-regular fa-phone-arrow-right fa-fw',
        'fa-light fa-phone-arrow-right fa-fw',
        'fa-duotone fa-phone-arrow-right fa-fw',
        'fa-thin fa-phone-arrow-up-right fa-fw',
        'fa-solid fa-phone-arrow-up-right fa-fw',
        'fa-sharp fa-solid fa-phone-arrow-up-right fa-fw',
        'fa-sharp fa-regular fa-phone-arrow-up-right fa-fw',
        'fa-sharp fa-light fa-phone-arrow-up-right fa-fw',
        'fa-regular fa-phone-arrow-up-right fa-fw',
        'fa-light fa-phone-arrow-up-right fa-fw',
        'fa-duotone fa-phone-arrow-up-right fa-fw',
        'fa-thin fa-phone-flip fa-fw',
        'fa-solid fa-phone-flip fa-fw',
        'fa-sharp fa-solid fa-phone-flip fa-fw',
        'fa-sharp fa-regular fa-phone-flip fa-fw',
        'fa-sharp fa-light fa-phone-flip fa-fw',
        'fa-regular fa-phone-flip fa-fw',
        'fa-light fa-phone-flip fa-fw',
        'fa-duotone fa-phone-flip fa-fw',
        'fa-thin fa-phone-hangup fa-fw',
        'fa-solid fa-phone-hangup fa-fw',
        'fa-sharp fa-solid fa-phone-hangup fa-fw',
        'fa-sharp fa-regular fa-phone-hangup fa-fw',
        'fa-sharp fa-light fa-phone-hangup fa-fw',
        'fa-regular fa-phone-hangup fa-fw',
        'fa-light fa-phone-hangup fa-fw',
        'fa-duotone fa-phone-hangup fa-fw',
        'fa-thin fa-phone-intercom fa-fw',
        'fa-solid fa-phone-intercom fa-fw',
        'fa-sharp fa-solid fa-phone-intercom fa-fw',
        'fa-sharp fa-regular fa-phone-intercom fa-fw',
        'fa-sharp fa-light fa-phone-intercom fa-fw',
        'fa-regular fa-phone-intercom fa-fw',
        'fa-light fa-phone-intercom fa-fw',
        'fa-duotone fa-phone-intercom fa-fw',
        'fa-thin fa-phone-missed fa-fw',
        'fa-solid fa-phone-missed fa-fw',
        'fa-sharp fa-solid fa-phone-missed fa-fw',
        'fa-sharp fa-regular fa-phone-missed fa-fw',
        'fa-sharp fa-light fa-phone-missed fa-fw',
        'fa-regular fa-phone-missed fa-fw',
        'fa-light fa-phone-missed fa-fw',
        'fa-duotone fa-phone-missed fa-fw',
        'fa-thin fa-phone-plus fa-fw',
        'fa-solid fa-phone-plus fa-fw',
        'fa-sharp fa-solid fa-phone-plus fa-fw',
        'fa-sharp fa-regular fa-phone-plus fa-fw',
        'fa-sharp fa-light fa-phone-plus fa-fw',
        'fa-regular fa-phone-plus fa-fw',
        'fa-light fa-phone-plus fa-fw',
        'fa-duotone fa-phone-plus fa-fw',
        'fa-thin fa-phone-slash fa-fw',
        'fa-solid fa-phone-slash fa-fw',
        'fa-sharp fa-solid fa-phone-slash fa-fw',
        'fa-sharp fa-regular fa-phone-slash fa-fw',
        'fa-sharp fa-light fa-phone-slash fa-fw',
        'fa-regular fa-phone-slash fa-fw',
        'fa-light fa-phone-slash fa-fw',
        'fa-duotone fa-phone-slash fa-fw',
        'fa-thin fa-phone-volume fa-fw',
        'fa-solid fa-phone-volume fa-fw',
        'fa-sharp fa-solid fa-phone-volume fa-fw',
        'fa-sharp fa-regular fa-phone-volume fa-fw',
        'fa-sharp fa-light fa-phone-volume fa-fw',
        'fa-regular fa-phone-volume fa-fw',
        'fa-light fa-phone-volume fa-fw',
        'fa-duotone fa-phone-volume fa-fw',
        'fa-thin fa-phone-xmark fa-fw',
        'fa-solid fa-phone-xmark fa-fw',
        'fa-sharp fa-solid fa-phone-xmark fa-fw',
        'fa-sharp fa-regular fa-phone-xmark fa-fw',
        'fa-sharp fa-light fa-phone-xmark fa-fw',
        'fa-regular fa-phone-xmark fa-fw',
        'fa-light fa-phone-xmark fa-fw',
        'fa-duotone fa-phone-xmark fa-fw',
        'fa-thin fa-poo fa-fw',
        'fa-solid fa-poo fa-fw',
        'fa-sharp fa-solid fa-poo fa-fw',
        'fa-sharp fa-regular fa-poo fa-fw',
        'fa-sharp fa-light fa-poo fa-fw',
        'fa-regular fa-poo fa-fw',
        'fa-light fa-poo fa-fw',
        'fa-duotone fa-poo fa-fw',
        'fa-thin fa-quote-left fa-fw',
        'fa-solid fa-quote-left fa-fw',
        'fa-sharp fa-solid fa-quote-left fa-fw',
        'fa-sharp fa-regular fa-quote-left fa-fw',
        'fa-sharp fa-light fa-quote-left fa-fw',
        'fa-regular fa-quote-left fa-fw',
        'fa-light fa-quote-left fa-fw',
        'fa-duotone fa-quote-left fa-fw',
        'fa-thin fa-quote-right fa-fw',
        'fa-solid fa-quote-right fa-fw',
        'fa-sharp fa-solid fa-quote-right fa-fw',
        'fa-sharp fa-regular fa-quote-right fa-fw',
        'fa-sharp fa-light fa-quote-right fa-fw',
        'fa-regular fa-quote-right fa-fw',
        'fa-light fa-quote-right fa-fw',
        'fa-duotone fa-quote-right fa-fw',
        'fa-thin fa-right-left-large fa-fw',
        'fa-solid fa-right-left-large fa-fw',
        'fa-sharp fa-solid fa-right-left-large fa-fw',
        'fa-sharp fa-regular fa-right-left-large fa-fw',
        'fa-sharp fa-light fa-right-left-large fa-fw',
        'fa-regular fa-right-left-large fa-fw',
        'fa-light fa-right-left-large fa-fw',
        'fa-duotone fa-right-left-large fa-fw',
        'fa-thin fa-square-envelope fa-fw',
        'fa-solid fa-square-envelope fa-fw',
        'fa-sharp fa-solid fa-square-envelope fa-fw',
        'fa-sharp fa-regular fa-square-envelope fa-fw',
        'fa-sharp fa-light fa-square-envelope fa-fw',
        'fa-regular fa-square-envelope fa-fw',
        'fa-light fa-square-envelope fa-fw',
        'fa-duotone fa-square-envelope fa-fw',
        'fa-thin fa-square-phone fa-fw',
        'fa-solid fa-square-phone fa-fw',
        'fa-sharp fa-solid fa-square-phone fa-fw',
        'fa-sharp fa-regular fa-square-phone fa-fw',
        'fa-sharp fa-light fa-square-phone fa-fw',
        'fa-regular fa-square-phone fa-fw',
        'fa-light fa-square-phone fa-fw',
        'fa-duotone fa-square-phone fa-fw',
        'fa-thin fa-square-phone-flip fa-fw',
        'fa-solid fa-square-phone-flip fa-fw',
        'fa-sharp fa-solid fa-square-phone-flip fa-fw',
        'fa-sharp fa-regular fa-square-phone-flip fa-fw',
        'fa-sharp fa-light fa-square-phone-flip fa-fw',
        'fa-regular fa-square-phone-flip fa-fw',
        'fa-light fa-square-phone-flip fa-fw',
        'fa-duotone fa-square-phone-flip fa-fw',
        'fa-thin fa-square-phone-hangup fa-fw',
        'fa-solid fa-square-phone-hangup fa-fw',
        'fa-sharp fa-solid fa-square-phone-hangup fa-fw',
        'fa-sharp fa-regular fa-square-phone-hangup fa-fw',
        'fa-sharp fa-light fa-square-phone-hangup fa-fw',
        'fa-regular fa-square-phone-hangup fa-fw',
        'fa-light fa-square-phone-hangup fa-fw',
        'fa-duotone fa-square-phone-hangup fa-fw',
        'fa-thin fa-square-quote fa-fw',
        'fa-solid fa-square-quote fa-fw',
        'fa-sharp fa-solid fa-square-quote fa-fw',
        'fa-sharp fa-regular fa-square-quote fa-fw',
        'fa-sharp fa-light fa-square-quote fa-fw',
        'fa-regular fa-square-quote fa-fw',
        'fa-light fa-square-quote fa-fw',
        'fa-duotone fa-square-quote fa-fw',
        'fa-thin fa-square-rss fa-fw',
        'fa-solid fa-square-rss fa-fw',
        'fa-sharp fa-solid fa-square-rss fa-fw',
        'fa-sharp fa-regular fa-square-rss fa-fw',
        'fa-sharp fa-light fa-square-rss fa-fw',
        'fa-regular fa-square-rss fa-fw',
        'fa-light fa-square-rss fa-fw',
        'fa-duotone fa-square-rss fa-fw',
        'fa-thin fa-symbols fa-fw',
        'fa-solid fa-symbols fa-fw',
        'fa-sharp fa-solid fa-symbols fa-fw',
        'fa-sharp fa-regular fa-symbols fa-fw',
        'fa-sharp fa-light fa-symbols fa-fw',
        'fa-regular fa-symbols fa-fw',
        'fa-light fa-symbols fa-fw',
        'fa-duotone fa-symbols fa-fw',
        'fa-thin fa-thought-bubble fa-fw',
        'fa-solid fa-thought-bubble fa-fw',
        'fa-sharp fa-solid fa-thought-bubble fa-fw',
        'fa-sharp fa-regular fa-thought-bubble fa-fw',
        'fa-sharp fa-light fa-thought-bubble fa-fw',
        'fa-regular fa-thought-bubble fa-fw',
        'fa-light fa-thought-bubble fa-fw',
        'fa-duotone fa-thought-bubble fa-fw',
        'fa-thin fa-tower-cell fa-fw',
        'fa-solid fa-tower-cell fa-fw',
        'fa-sharp fa-solid fa-tower-cell fa-fw',
        'fa-sharp fa-regular fa-tower-cell fa-fw',
        'fa-sharp fa-light fa-tower-cell fa-fw',
        'fa-regular fa-tower-cell fa-fw',
        'fa-light fa-tower-cell fa-fw',
        'fa-duotone fa-tower-cell fa-fw',
        'fa-thin fa-tty fa-fw',
        'fa-solid fa-tty fa-fw',
        'fa-sharp fa-solid fa-tty fa-fw',
        'fa-sharp fa-regular fa-tty fa-fw',
        'fa-sharp fa-light fa-tty fa-fw',
        'fa-regular fa-tty fa-fw',
        'fa-light fa-tty fa-fw',
        'fa-duotone fa-tty fa-fw',
        'fa-thin fa-tty-answer fa-fw',
        'fa-solid fa-tty-answer fa-fw',
        'fa-sharp fa-solid fa-tty-answer fa-fw',
        'fa-sharp fa-regular fa-tty-answer fa-fw',
        'fa-sharp fa-light fa-tty-answer fa-fw',
        'fa-regular fa-tty-answer fa-fw',
        'fa-light fa-tty-answer fa-fw',
        'fa-duotone fa-tty-answer fa-fw',
        'fa-thin fa-video fa-fw',
        'fa-solid fa-video fa-fw',
        'fa-sharp fa-solid fa-video fa-fw',
        'fa-sharp fa-regular fa-video fa-fw',
        'fa-sharp fa-light fa-video fa-fw',
        'fa-regular fa-video fa-fw',
        'fa-light fa-video fa-fw',
        'fa-duotone fa-video fa-fw',
        'fa-thin fa-video-plus fa-fw',
        'fa-solid fa-video-plus fa-fw',
        'fa-sharp fa-solid fa-video-plus fa-fw',
        'fa-sharp fa-regular fa-video-plus fa-fw',
        'fa-sharp fa-light fa-video-plus fa-fw',
        'fa-regular fa-video-plus fa-fw',
        'fa-light fa-video-plus fa-fw',
        'fa-duotone fa-video-plus fa-fw',
        'fa-thin fa-video-slash fa-fw',
        'fa-solid fa-video-slash fa-fw',
        'fa-sharp fa-solid fa-video-slash fa-fw',
        'fa-sharp fa-regular fa-video-slash fa-fw',
        'fa-sharp fa-light fa-video-slash fa-fw',
        'fa-regular fa-video-slash fa-fw',
        'fa-light fa-video-slash fa-fw',
        'fa-duotone fa-video-slash fa-fw',
        'fa-thin fa-voicemail fa-fw',
        'fa-solid fa-voicemail fa-fw',
        'fa-sharp fa-solid fa-voicemail fa-fw',
        'fa-sharp fa-regular fa-voicemail fa-fw',
        'fa-sharp fa-light fa-voicemail fa-fw',
        'fa-regular fa-voicemail fa-fw',
        'fa-light fa-voicemail fa-fw',
        'fa-duotone fa-voicemail fa-fw',
        'fa-thin fa-walkie-talkie fa-fw',
        'fa-solid fa-walkie-talkie fa-fw',
        'fa-sharp fa-solid fa-walkie-talkie fa-fw',
        'fa-sharp fa-regular fa-walkie-talkie fa-fw',
        'fa-sharp fa-light fa-walkie-talkie fa-fw',
        'fa-regular fa-walkie-talkie fa-fw',
        'fa-light fa-walkie-talkie fa-fw',
        'fa-duotone fa-walkie-talkie fa-fw',
      ],
    },
    {
      title: 'Connectivity',
      items: [
        'fa-thin fa-bluetooth fa-fw',
        'fa-solid fa-bluetooth fa-fw',
        'fa-sharp fa-solid fa-bluetooth fa-fw',
        'fa-sharp fa-regular fa-bluetooth fa-fw',
        'fa-sharp fa-light fa-bluetooth fa-fw',
        'fa-regular fa-bluetooth fa-fw',
        'fa-light fa-bluetooth fa-fw',
        'fa-duotone fa-bluetooth fa-fw',
        'fa-brands fa-bluetooth fa-fw',
        'fa-thin fa-circle-nodes fa-fw',
        'fa-solid fa-circle-nodes fa-fw',
        'fa-sharp fa-solid fa-circle-nodes fa-fw',
        'fa-sharp fa-regular fa-circle-nodes fa-fw',
        'fa-sharp fa-light fa-circle-nodes fa-fw',
        'fa-regular fa-circle-nodes fa-fw',
        'fa-light fa-circle-nodes fa-fw',
        'fa-duotone fa-circle-nodes fa-fw',
        'fa-thin fa-cloud fa-fw',
        'fa-solid fa-cloud fa-fw',
        'fa-sharp fa-solid fa-cloud fa-fw',
        'fa-sharp fa-regular fa-cloud fa-fw',
        'fa-sharp fa-light fa-cloud fa-fw',
        'fa-regular fa-cloud fa-fw',
        'fa-light fa-cloud fa-fw',
        'fa-duotone fa-cloud fa-fw',
        'fa-thin fa-cloud-arrow-down fa-fw',
        'fa-solid fa-cloud-arrow-down fa-fw',
        'fa-sharp fa-solid fa-cloud-arrow-down fa-fw',
        'fa-sharp fa-regular fa-cloud-arrow-down fa-fw',
        'fa-sharp fa-light fa-cloud-arrow-down fa-fw',
        'fa-regular fa-cloud-arrow-down fa-fw',
        'fa-light fa-cloud-arrow-down fa-fw',
        'fa-duotone fa-cloud-arrow-down fa-fw',
        'fa-thin fa-cloud-arrow-up fa-fw',
        'fa-solid fa-cloud-arrow-up fa-fw',
        'fa-sharp fa-solid fa-cloud-arrow-up fa-fw',
        'fa-sharp fa-regular fa-cloud-arrow-up fa-fw',
        'fa-sharp fa-light fa-cloud-arrow-up fa-fw',
        'fa-regular fa-cloud-arrow-up fa-fw',
        'fa-light fa-cloud-arrow-up fa-fw',
        'fa-duotone fa-cloud-arrow-up fa-fw',
        'fa-thin fa-cloud-check fa-fw',
        'fa-solid fa-cloud-check fa-fw',
        'fa-sharp fa-solid fa-cloud-check fa-fw',
        'fa-sharp fa-regular fa-cloud-check fa-fw',
        'fa-sharp fa-light fa-cloud-check fa-fw',
        'fa-regular fa-cloud-check fa-fw',
        'fa-light fa-cloud-check fa-fw',
        'fa-duotone fa-cloud-check fa-fw',
        'fa-thin fa-cloud-exclamation fa-fw',
        'fa-solid fa-cloud-exclamation fa-fw',
        'fa-sharp fa-solid fa-cloud-exclamation fa-fw',
        'fa-sharp fa-regular fa-cloud-exclamation fa-fw',
        'fa-sharp fa-light fa-cloud-exclamation fa-fw',
        'fa-regular fa-cloud-exclamation fa-fw',
        'fa-light fa-cloud-exclamation fa-fw',
        'fa-duotone fa-cloud-exclamation fa-fw',
        'fa-thin fa-cloud-minus fa-fw',
        'fa-solid fa-cloud-minus fa-fw',
        'fa-sharp fa-solid fa-cloud-minus fa-fw',
        'fa-sharp fa-regular fa-cloud-minus fa-fw',
        'fa-sharp fa-light fa-cloud-minus fa-fw',
        'fa-regular fa-cloud-minus fa-fw',
        'fa-light fa-cloud-minus fa-fw',
        'fa-duotone fa-cloud-minus fa-fw',
        'fa-thin fa-cloud-plus fa-fw',
        'fa-solid fa-cloud-plus fa-fw',
        'fa-sharp fa-solid fa-cloud-plus fa-fw',
        'fa-sharp fa-regular fa-cloud-plus fa-fw',
        'fa-sharp fa-light fa-cloud-plus fa-fw',
        'fa-regular fa-cloud-plus fa-fw',
        'fa-light fa-cloud-plus fa-fw',
        'fa-duotone fa-cloud-plus fa-fw',
        'fa-thin fa-cloud-question fa-fw',
        'fa-solid fa-cloud-question fa-fw',
        'fa-sharp fa-solid fa-cloud-question fa-fw',
        'fa-sharp fa-regular fa-cloud-question fa-fw',
        'fa-sharp fa-light fa-cloud-question fa-fw',
        'fa-regular fa-cloud-question fa-fw',
        'fa-light fa-cloud-question fa-fw',
        'fa-duotone fa-cloud-question fa-fw',
        'fa-thin fa-cloud-slash fa-fw',
        'fa-solid fa-cloud-slash fa-fw',
        'fa-sharp fa-solid fa-cloud-slash fa-fw',
        'fa-sharp fa-regular fa-cloud-slash fa-fw',
        'fa-sharp fa-light fa-cloud-slash fa-fw',
        'fa-regular fa-cloud-slash fa-fw',
        'fa-light fa-cloud-slash fa-fw',
        'fa-duotone fa-cloud-slash fa-fw',
        'fa-thin fa-cloud-xmark fa-fw',
        'fa-solid fa-cloud-xmark fa-fw',
        'fa-sharp fa-solid fa-cloud-xmark fa-fw',
        'fa-sharp fa-regular fa-cloud-xmark fa-fw',
        'fa-sharp fa-light fa-cloud-xmark fa-fw',
        'fa-regular fa-cloud-xmark fa-fw',
        'fa-light fa-cloud-xmark fa-fw',
        'fa-duotone fa-cloud-xmark fa-fw',
        'fa-thin fa-ethernet fa-fw',
        'fa-solid fa-ethernet fa-fw',
        'fa-sharp fa-solid fa-ethernet fa-fw',
        'fa-sharp fa-regular fa-ethernet fa-fw',
        'fa-sharp fa-light fa-ethernet fa-fw',
        'fa-regular fa-ethernet fa-fw',
        'fa-light fa-ethernet fa-fw',
        'fa-duotone fa-ethernet fa-fw',
        'fa-thin fa-globe fa-fw',
        'fa-solid fa-globe fa-fw',
        'fa-sharp fa-solid fa-globe fa-fw',
        'fa-sharp fa-regular fa-globe fa-fw',
        'fa-sharp fa-light fa-globe fa-fw',
        'fa-regular fa-globe fa-fw',
        'fa-light fa-globe fa-fw',
        'fa-duotone fa-globe fa-fw',
        'fa-thin fa-house-signal fa-fw',
        'fa-solid fa-house-signal fa-fw',
        'fa-sharp fa-solid fa-house-signal fa-fw',
        'fa-sharp fa-regular fa-house-signal fa-fw',
        'fa-sharp fa-light fa-house-signal fa-fw',
        'fa-regular fa-house-signal fa-fw',
        'fa-light fa-house-signal fa-fw',
        'fa-duotone fa-house-signal fa-fw',
        'fa-thin fa-link-horizontal fa-fw',
        'fa-solid fa-link-horizontal fa-fw',
        'fa-sharp fa-solid fa-link-horizontal fa-fw',
        'fa-sharp fa-regular fa-link-horizontal fa-fw',
        'fa-sharp fa-light fa-link-horizontal fa-fw',
        'fa-regular fa-link-horizontal fa-fw',
        'fa-light fa-link-horizontal fa-fw',
        'fa-duotone fa-link-horizontal fa-fw',
        'fa-thin fa-link-horizontal-slash fa-fw',
        'fa-solid fa-link-horizontal-slash fa-fw',
        'fa-sharp fa-solid fa-link-horizontal-slash fa-fw',
        'fa-sharp fa-regular fa-link-horizontal-slash fa-fw',
        'fa-sharp fa-light fa-link-horizontal-slash fa-fw',
        'fa-regular fa-link-horizontal-slash fa-fw',
        'fa-light fa-link-horizontal-slash fa-fw',
        'fa-duotone fa-link-horizontal-slash fa-fw',
        'fa-thin fa-mobile-signal fa-fw',
        'fa-solid fa-mobile-signal fa-fw',
        'fa-sharp fa-solid fa-mobile-signal fa-fw',
        'fa-sharp fa-regular fa-mobile-signal fa-fw',
        'fa-sharp fa-light fa-mobile-signal fa-fw',
        'fa-regular fa-mobile-signal fa-fw',
        'fa-light fa-mobile-signal fa-fw',
        'fa-duotone fa-mobile-signal fa-fw',
        'fa-thin fa-mobile-signal-out fa-fw',
        'fa-solid fa-mobile-signal-out fa-fw',
        'fa-sharp fa-solid fa-mobile-signal-out fa-fw',
        'fa-sharp fa-regular fa-mobile-signal-out fa-fw',
        'fa-sharp fa-light fa-mobile-signal-out fa-fw',
        'fa-regular fa-mobile-signal-out fa-fw',
        'fa-light fa-mobile-signal-out fa-fw',
        'fa-duotone fa-mobile-signal-out fa-fw',
        'fa-thin fa-nfc-signal fa-fw',
        'fa-solid fa-nfc-signal fa-fw',
        'fa-sharp fa-solid fa-nfc-signal fa-fw',
        'fa-sharp fa-regular fa-nfc-signal fa-fw',
        'fa-sharp fa-light fa-nfc-signal fa-fw',
        'fa-regular fa-nfc-signal fa-fw',
        'fa-light fa-nfc-signal fa-fw',
        'fa-duotone fa-nfc-signal fa-fw',
        'fa-thin fa-rss fa-fw',
        'fa-solid fa-rss fa-fw',
        'fa-sharp fa-solid fa-rss fa-fw',
        'fa-sharp fa-regular fa-rss fa-fw',
        'fa-sharp fa-light fa-rss fa-fw',
        'fa-regular fa-rss fa-fw',
        'fa-light fa-rss fa-fw',
        'fa-duotone fa-rss fa-fw',
        'fa-thin fa-satellite-dish fa-fw',
        'fa-solid fa-satellite-dish fa-fw',
        'fa-sharp fa-solid fa-satellite-dish fa-fw',
        'fa-sharp fa-regular fa-satellite-dish fa-fw',
        'fa-sharp fa-light fa-satellite-dish fa-fw',
        'fa-regular fa-satellite-dish fa-fw',
        'fa-light fa-satellite-dish fa-fw',
        'fa-duotone fa-satellite-dish fa-fw',
        'fa-thin fa-signal fa-fw',
        'fa-solid fa-signal fa-fw',
        'fa-sharp fa-solid fa-signal fa-fw',
        'fa-sharp fa-regular fa-signal fa-fw',
        'fa-sharp fa-light fa-signal fa-fw',
        'fa-regular fa-signal fa-fw',
        'fa-light fa-signal fa-fw',
        'fa-duotone fa-signal fa-fw',
        'fa-thin fa-signal-bars fa-fw',
        'fa-solid fa-signal-bars fa-fw',
        'fa-sharp fa-solid fa-signal-bars fa-fw',
        'fa-sharp fa-regular fa-signal-bars fa-fw',
        'fa-sharp fa-light fa-signal-bars fa-fw',
        'fa-regular fa-signal-bars fa-fw',
        'fa-light fa-signal-bars fa-fw',
        'fa-duotone fa-signal-bars fa-fw',
        'fa-thin fa-signal-bars-fair fa-fw',
        'fa-solid fa-signal-bars-fair fa-fw',
        'fa-sharp fa-solid fa-signal-bars-fair fa-fw',
        'fa-sharp fa-regular fa-signal-bars-fair fa-fw',
        'fa-sharp fa-light fa-signal-bars-fair fa-fw',
        'fa-regular fa-signal-bars-fair fa-fw',
        'fa-light fa-signal-bars-fair fa-fw',
        'fa-duotone fa-signal-bars-fair fa-fw',
        'fa-thin fa-signal-bars-good fa-fw',
        'fa-solid fa-signal-bars-good fa-fw',
        'fa-sharp fa-solid fa-signal-bars-good fa-fw',
        'fa-sharp fa-regular fa-signal-bars-good fa-fw',
        'fa-sharp fa-light fa-signal-bars-good fa-fw',
        'fa-regular fa-signal-bars-good fa-fw',
        'fa-light fa-signal-bars-good fa-fw',
        'fa-duotone fa-signal-bars-good fa-fw',
        'fa-thin fa-signal-bars-slash fa-fw',
        'fa-solid fa-signal-bars-slash fa-fw',
        'fa-sharp fa-solid fa-signal-bars-slash fa-fw',
        'fa-sharp fa-regular fa-signal-bars-slash fa-fw',
        'fa-sharp fa-light fa-signal-bars-slash fa-fw',
        'fa-regular fa-signal-bars-slash fa-fw',
        'fa-light fa-signal-bars-slash fa-fw',
        'fa-duotone fa-signal-bars-slash fa-fw',
        'fa-thin fa-signal-bars-weak fa-fw',
        'fa-solid fa-signal-bars-weak fa-fw',
        'fa-sharp fa-solid fa-signal-bars-weak fa-fw',
        'fa-sharp fa-regular fa-signal-bars-weak fa-fw',
        'fa-sharp fa-light fa-signal-bars-weak fa-fw',
        'fa-regular fa-signal-bars-weak fa-fw',
        'fa-light fa-signal-bars-weak fa-fw',
        'fa-duotone fa-signal-bars-weak fa-fw',
        'fa-thin fa-signal-fair fa-fw',
        'fa-solid fa-signal-fair fa-fw',
        'fa-sharp fa-solid fa-signal-fair fa-fw',
        'fa-sharp fa-regular fa-signal-fair fa-fw',
        'fa-sharp fa-light fa-signal-fair fa-fw',
        'fa-regular fa-signal-fair fa-fw',
        'fa-light fa-signal-fair fa-fw',
        'fa-duotone fa-signal-fair fa-fw',
        'fa-thin fa-signal-good fa-fw',
        'fa-solid fa-signal-good fa-fw',
        'fa-sharp fa-solid fa-signal-good fa-fw',
        'fa-sharp fa-regular fa-signal-good fa-fw',
        'fa-sharp fa-light fa-signal-good fa-fw',
        'fa-regular fa-signal-good fa-fw',
        'fa-light fa-signal-good fa-fw',
        'fa-duotone fa-signal-good fa-fw',
        'fa-thin fa-signal-slash fa-fw',
        'fa-solid fa-signal-slash fa-fw',
        'fa-sharp fa-solid fa-signal-slash fa-fw',
        'fa-sharp fa-regular fa-signal-slash fa-fw',
        'fa-sharp fa-light fa-signal-slash fa-fw',
        'fa-regular fa-signal-slash fa-fw',
        'fa-light fa-signal-slash fa-fw',
        'fa-duotone fa-signal-slash fa-fw',
        'fa-thin fa-signal-stream fa-fw',
        'fa-solid fa-signal-stream fa-fw',
        'fa-sharp fa-solid fa-signal-stream fa-fw',
        'fa-sharp fa-regular fa-signal-stream fa-fw',
        'fa-sharp fa-light fa-signal-stream fa-fw',
        'fa-regular fa-signal-stream fa-fw',
        'fa-light fa-signal-stream fa-fw',
        'fa-duotone fa-signal-stream fa-fw',
        'fa-thin fa-signal-stream-slash fa-fw',
        'fa-solid fa-signal-stream-slash fa-fw',
        'fa-sharp fa-solid fa-signal-stream-slash fa-fw',
        'fa-sharp fa-regular fa-signal-stream-slash fa-fw',
        'fa-sharp fa-light fa-signal-stream-slash fa-fw',
        'fa-regular fa-signal-stream-slash fa-fw',
        'fa-light fa-signal-stream-slash fa-fw',
        'fa-duotone fa-signal-stream-slash fa-fw',
        'fa-thin fa-signal-strong fa-fw',
        'fa-solid fa-signal-strong fa-fw',
        'fa-sharp fa-solid fa-signal-strong fa-fw',
        'fa-sharp fa-regular fa-signal-strong fa-fw',
        'fa-sharp fa-light fa-signal-strong fa-fw',
        'fa-regular fa-signal-strong fa-fw',
        'fa-light fa-signal-strong fa-fw',
        'fa-duotone fa-signal-strong fa-fw',
        'fa-thin fa-signal-weak fa-fw',
        'fa-solid fa-signal-weak fa-fw',
        'fa-sharp fa-solid fa-signal-weak fa-fw',
        'fa-sharp fa-regular fa-signal-weak fa-fw',
        'fa-sharp fa-light fa-signal-weak fa-fw',
        'fa-regular fa-signal-weak fa-fw',
        'fa-light fa-signal-weak fa-fw',
        'fa-duotone fa-signal-weak fa-fw',
        'fa-thin fa-tower-broadcast fa-fw',
        'fa-solid fa-tower-broadcast fa-fw',
        'fa-sharp fa-solid fa-tower-broadcast fa-fw',
        'fa-sharp fa-regular fa-tower-broadcast fa-fw',
        'fa-sharp fa-light fa-tower-broadcast fa-fw',
        'fa-regular fa-tower-broadcast fa-fw',
        'fa-light fa-tower-broadcast fa-fw',
        'fa-duotone fa-tower-broadcast fa-fw',
        'fa-thin fa-tower-cell fa-fw',
        'fa-solid fa-tower-cell fa-fw',
        'fa-sharp fa-solid fa-tower-cell fa-fw',
        'fa-sharp fa-regular fa-tower-cell fa-fw',
        'fa-sharp fa-light fa-tower-cell fa-fw',
        'fa-regular fa-tower-cell fa-fw',
        'fa-light fa-tower-cell fa-fw',
        'fa-duotone fa-tower-cell fa-fw',
        'fa-thin fa-wifi fa-fw',
        'fa-solid fa-wifi fa-fw',
        'fa-sharp fa-solid fa-wifi fa-fw',
        'fa-sharp fa-regular fa-wifi fa-fw',
        'fa-sharp fa-light fa-wifi fa-fw',
        'fa-regular fa-wifi fa-fw',
        'fa-light fa-wifi fa-fw',
        'fa-duotone fa-wifi fa-fw',
        'fa-thin fa-wifi-exclamation fa-fw',
        'fa-solid fa-wifi-exclamation fa-fw',
        'fa-sharp fa-solid fa-wifi-exclamation fa-fw',
        'fa-sharp fa-regular fa-wifi-exclamation fa-fw',
        'fa-sharp fa-light fa-wifi-exclamation fa-fw',
        'fa-regular fa-wifi-exclamation fa-fw',
        'fa-light fa-wifi-exclamation fa-fw',
        'fa-duotone fa-wifi-exclamation fa-fw',
        'fa-thin fa-wifi-fair fa-fw',
        'fa-solid fa-wifi-fair fa-fw',
        'fa-sharp fa-solid fa-wifi-fair fa-fw',
        'fa-sharp fa-regular fa-wifi-fair fa-fw',
        'fa-sharp fa-light fa-wifi-fair fa-fw',
        'fa-regular fa-wifi-fair fa-fw',
        'fa-light fa-wifi-fair fa-fw',
        'fa-duotone fa-wifi-fair fa-fw',
        'fa-thin fa-wifi-weak fa-fw',
        'fa-solid fa-wifi-weak fa-fw',
        'fa-sharp fa-solid fa-wifi-weak fa-fw',
        'fa-sharp fa-regular fa-wifi-weak fa-fw',
        'fa-sharp fa-light fa-wifi-weak fa-fw',
        'fa-regular fa-wifi-weak fa-fw',
        'fa-light fa-wifi-weak fa-fw',
        'fa-duotone fa-wifi-weak fa-fw',
      ],
    },
    {
      title: 'Computers',
      items: [
        'fas fa-desktop',
        'fas fa-download',
        'fas fa-hdd',
        'far fa-hdd',
        'fas fa-headphones',
        'fas fa-keyboard',
        'far fa-keyboard',
        'fas fa-laptop',
        'fas fa-microchip',
        'fas fa-mobile',
        'fas fa-mobile-alt',
        'fas fa-plug',
        'fas fa-power-off',
        'fas fa-print',
        'fas fa-save',
        'far fa-save',
        'fas fa-server',
        'fas fa-tablet',
        'fas fa-tablet-alt',
        'fas fa-tv',
        'fas fa-upload',
      ],
    },
    {
      title: 'Currency',
      items: [
        'fab fa-bitcoin',
        'fab fa-btc',
        'fas fa-dollar-sign',
        'fas fa-euro-sign',
        'fab fa-gg',
        'fab fa-gg-circle',
        'fas fa-lira-sign',
        'fas fa-money-bill-alt',
        'far fa-money-bill-alt',
        'fas fa-pound-sign',
        'fas fa-ruble-sign',
        'fas fa-rupee-sign',
        'fas fa-shekel-sign',
        'fas fa-won-sign',
        'fas fa-yen-sign',
      ],
    },
    {
      title: 'Date & Time',
      items: [
        'fas fa-bell',
        'far fa-bell',
        'fas fa-bell-slash',
        'far fa-bell-slash',
        'fas fa-calendar',
        'far fa-calendar',
        'fas fa-calendar-alt',
        'far fa-calendar-alt',
        'fas fa-calendar-check',
        'far fa-calendar-check',
        'fas fa-calendar-minus',
        'far fa-calendar-minus',
        'fas fa-calendar-plus',
        'far fa-calendar-plus',
        'fas fa-calendar-times',
        'far fa-calendar-times',
        'fas fa-clock',
        'far fa-clock',
        'fas fa-hourglass',
        'far fa-hourglass',
        'fas fa-hourglass-end',
        'fas fa-hourglass-half',
        'fas fa-hourglass-start',
        'fas fa-stopwatch',
      ],
    },
    {
      title: 'Design',
      items: [
        'fa-thin fa-angle fa-fw',
        'fa-solid fa-angle fa-fw',
        'fa-sharp fa-solid fa-angle fa-fw',
        'fa-sharp fa-regular fa-angle fa-fw',
        'fa-sharp fa-light fa-angle fa-fw',
        'fa-regular fa-angle fa-fw',
        'fa-light fa-angle fa-fw',
        'fa-duotone fa-angle fa-fw',
        'fa-thin fa-angle-90 fa-fw',
        'fa-solid fa-angle-90 fa-fw',
        'fa-sharp fa-solid fa-angle-90 fa-fw',
        'fa-sharp fa-regular fa-angle-90 fa-fw',
        'fa-sharp fa-light fa-angle-90 fa-fw',
        'fa-regular fa-angle-90 fa-fw',
        'fa-light fa-angle-90 fa-fw',
        'fa-duotone fa-angle-90 fa-fw',
        'fa-thin fa-ball-pile fa-fw',
        'fa-solid fa-ball-pile fa-fw',
        'fa-sharp fa-solid fa-ball-pile fa-fw',
        'fa-sharp fa-regular fa-ball-pile fa-fw',
        'fa-sharp fa-light fa-ball-pile fa-fw',
        'fa-regular fa-ball-pile fa-fw',
        'fa-light fa-ball-pile fa-fw',
        'fa-duotone fa-ball-pile fa-fw',
        'fa-thin fa-bezier-curve fa-fw',
        'fa-solid fa-bezier-curve fa-fw',
        'fa-sharp fa-solid fa-bezier-curve fa-fw',
        'fa-sharp fa-regular fa-bezier-curve fa-fw',
        'fa-sharp fa-light fa-bezier-curve fa-fw',
        'fa-regular fa-bezier-curve fa-fw',
        'fa-light fa-bezier-curve fa-fw',
        'fa-duotone fa-bezier-curve fa-fw',
        'fa-thin fa-book-font fa-fw',
        'fa-solid fa-book-font fa-fw',
        'fa-sharp fa-solid fa-book-font fa-fw',
        'fa-sharp fa-regular fa-book-font fa-fw',
        'fa-sharp fa-light fa-book-font fa-fw',
        'fa-regular fa-book-font fa-fw',
        'fa-light fa-book-font fa-fw',
        'fa-duotone fa-book-font fa-fw',
        'fa-thin fa-bring-forward fa-fw',
        'fa-solid fa-bring-forward fa-fw',
        'fa-sharp fa-solid fa-bring-forward fa-fw',
        'fa-sharp fa-regular fa-bring-forward fa-fw',
        'fa-sharp fa-light fa-bring-forward fa-fw',
        'fa-regular fa-bring-forward fa-fw',
        'fa-light fa-bring-forward fa-fw',
        'fa-duotone fa-bring-forward fa-fw',
        'fa-thin fa-bring-front fa-fw',
        'fa-solid fa-bring-front fa-fw',
        'fa-sharp fa-solid fa-bring-front fa-fw',
        'fa-sharp fa-regular fa-bring-front fa-fw',
        'fa-sharp fa-light fa-bring-front fa-fw',
        'fa-regular fa-bring-front fa-fw',
        'fa-light fa-bring-front fa-fw',
        'fa-duotone fa-bring-front fa-fw',
        'fa-thin fa-broom-wide fa-fw',
        'fa-solid fa-broom-wide fa-fw',
        'fa-sharp fa-solid fa-broom-wide fa-fw',
        'fa-sharp fa-regular fa-broom-wide fa-fw',
        'fa-sharp fa-light fa-broom-wide fa-fw',
        'fa-regular fa-broom-wide fa-fw',
        'fa-light fa-broom-wide fa-fw',
        'fa-duotone fa-broom-wide fa-fw',
        'fa-thin fa-brush fa-fw',
        'fa-solid fa-brush fa-fw',
        'fa-sharp fa-solid fa-brush fa-fw',
        'fa-sharp fa-regular fa-brush fa-fw',
        'fa-sharp fa-light fa-brush fa-fw',
        'fa-regular fa-brush fa-fw',
        'fa-light fa-brush fa-fw',
        'fa-duotone fa-brush fa-fw',
        'fa-thin fa-camera-polaroid fa-fw',
        'fa-solid fa-camera-polaroid fa-fw',
        'fa-sharp fa-solid fa-camera-polaroid fa-fw',
        'fa-sharp fa-regular fa-camera-polaroid fa-fw',
        'fa-sharp fa-light fa-camera-polaroid fa-fw',
        'fa-regular fa-camera-polaroid fa-fw',
        'fa-light fa-camera-polaroid fa-fw',
        'fa-duotone fa-camera-polaroid fa-fw',
        'fa-thin fa-circle-dashed fa-fw',
        'fa-solid fa-circle-dashed fa-fw',
        'fa-sharp fa-solid fa-circle-dashed fa-fw',
        'fa-sharp fa-regular fa-circle-dashed fa-fw',
        'fa-sharp fa-light fa-circle-dashed fa-fw',
        'fa-regular fa-circle-dashed fa-fw',
        'fa-light fa-circle-dashed fa-fw',
        'fa-duotone fa-circle-dashed fa-fw',
        'fa-thin fa-circle-half-stroke fa-fw',
        'fa-solid fa-circle-half-stroke fa-fw',
        'fa-sharp fa-solid fa-circle-half-stroke fa-fw',
        'fa-sharp fa-regular fa-circle-half-stroke fa-fw',
        'fa-sharp fa-light fa-circle-half-stroke fa-fw',
        'fa-regular fa-circle-half-stroke fa-fw',
        'fa-light fa-circle-half-stroke fa-fw',
        'fa-duotone fa-circle-half-stroke fa-fw',
        'fa-thin fa-circle-nodes fa-fw',
        'fa-solid fa-circle-nodes fa-fw',
        'fa-sharp fa-solid fa-circle-nodes fa-fw',
        'fa-sharp fa-regular fa-circle-nodes fa-fw',
        'fa-sharp fa-light fa-circle-nodes fa-fw',
        'fa-regular fa-circle-nodes fa-fw',
        'fa-light fa-circle-nodes fa-fw',
        'fa-duotone fa-circle-nodes fa-fw',
        'fa-thin fa-circle-quarter-stroke fa-fw',
        'fa-solid fa-circle-quarter-stroke fa-fw',
        'fa-sharp fa-solid fa-circle-quarter-stroke fa-fw',
        'fa-sharp fa-regular fa-circle-quarter-stroke fa-fw',
        'fa-sharp fa-light fa-circle-quarter-stroke fa-fw',
        'fa-regular fa-circle-quarter-stroke fa-fw',
        'fa-light fa-circle-quarter-stroke fa-fw',
        'fa-duotone fa-circle-quarter-stroke fa-fw',
        'fa-thin fa-circle-three-quarters-stroke fa-fw',
        'fa-solid fa-circle-three-quarters-stroke fa-fw',
        'fa-sharp fa-solid fa-circle-three-quarters-stroke fa-fw',
        'fa-sharp fa-regular fa-circle-three-quarters-stroke fa-fw',
        'fa-sharp fa-light fa-circle-three-quarters-stroke fa-fw',
        'fa-regular fa-circle-three-quarters-stroke fa-fw',
        'fa-light fa-circle-three-quarters-stroke fa-fw',
        'fa-duotone fa-circle-three-quarters-stroke fa-fw',
        'fa-thin fa-circles-overlap fa-fw',
        'fa-solid fa-circles-overlap fa-fw',
        'fa-sharp fa-solid fa-circles-overlap fa-fw',
        'fa-sharp fa-regular fa-circles-overlap fa-fw',
        'fa-sharp fa-light fa-circles-overlap fa-fw',
        'fa-regular fa-circles-overlap fa-fw',
        'fa-light fa-circles-overlap fa-fw',
        'fa-duotone fa-circles-overlap fa-fw',
        'fa-thin fa-clone fa-fw',
        'fa-solid fa-clone fa-fw',
        'fa-sharp fa-solid fa-clone fa-fw',
        'fa-sharp fa-regular fa-clone fa-fw',
        'fa-sharp fa-light fa-clone fa-fw',
        'fa-regular fa-clone fa-fw',
        'fa-light fa-clone fa-fw',
        'fa-duotone fa-clone fa-fw',
        'fa-thin fa-columns-3 fa-fw',
        'fa-solid fa-columns-3 fa-fw',
        'fa-sharp fa-solid fa-columns-3 fa-fw',
        'fa-sharp fa-regular fa-columns-3 fa-fw',
        'fa-sharp fa-light fa-columns-3 fa-fw',
        'fa-regular fa-columns-3 fa-fw',
        'fa-light fa-columns-3 fa-fw',
        'fa-duotone fa-columns-3 fa-fw',
        'fa-thin fa-compass-drafting fa-fw',
        'fa-solid fa-compass-drafting fa-fw',
        'fa-sharp fa-solid fa-compass-drafting fa-fw',
        'fa-sharp fa-regular fa-compass-drafting fa-fw',
        'fa-sharp fa-light fa-compass-drafting fa-fw',
        'fa-regular fa-compass-drafting fa-fw',
        'fa-light fa-compass-drafting fa-fw',
        'fa-duotone fa-compass-drafting fa-fw',
        'fa-thin fa-copy fa-fw',
        'fa-solid fa-copy fa-fw',
        'fa-sharp fa-solid fa-copy fa-fw',
        'fa-sharp fa-regular fa-copy fa-fw',
        'fa-sharp fa-light fa-copy fa-fw',
        'fa-regular fa-copy fa-fw',
        'fa-light fa-copy fa-fw',
        'fa-duotone fa-copy fa-fw',
        'fa-thin fa-crop fa-fw',
        'fa-solid fa-crop fa-fw',
        'fa-sharp fa-solid fa-crop fa-fw',
        'fa-sharp fa-regular fa-crop fa-fw',
        'fa-sharp fa-light fa-crop fa-fw',
        'fa-regular fa-crop fa-fw',
        'fa-light fa-crop fa-fw',
        'fa-duotone fa-crop fa-fw',
        'fa-thin fa-crop-simple fa-fw',
        'fa-solid fa-crop-simple fa-fw',
        'fa-sharp fa-solid fa-crop-simple fa-fw',
        'fa-sharp fa-regular fa-crop-simple fa-fw',
        'fa-sharp fa-light fa-crop-simple fa-fw',
        'fa-regular fa-crop-simple fa-fw',
        'fa-light fa-crop-simple fa-fw',
        'fa-duotone fa-crop-simple fa-fw',
        'fa-thin fa-crosshairs fa-fw',
        'fa-solid fa-crosshairs fa-fw',
        'fa-sharp fa-solid fa-crosshairs fa-fw',
        'fa-sharp fa-regular fa-crosshairs fa-fw',
        'fa-sharp fa-light fa-crosshairs fa-fw',
        'fa-regular fa-crosshairs fa-fw',
        'fa-light fa-crosshairs fa-fw',
        'fa-duotone fa-crosshairs fa-fw',
        'fa-thin fa-crosshairs-simple fa-fw',
        'fa-solid fa-crosshairs-simple fa-fw',
        'fa-sharp fa-solid fa-crosshairs-simple fa-fw',
        'fa-sharp fa-regular fa-crosshairs-simple fa-fw',
        'fa-sharp fa-light fa-crosshairs-simple fa-fw',
        'fa-regular fa-crosshairs-simple fa-fw',
        'fa-light fa-crosshairs-simple fa-fw',
        'fa-duotone fa-crosshairs-simple fa-fw',
        'fa-thin fa-cube fa-fw',
        'fa-solid fa-cube fa-fw',
        'fa-sharp fa-solid fa-cube fa-fw',
        'fa-sharp fa-regular fa-cube fa-fw',
        'fa-sharp fa-light fa-cube fa-fw',
        'fa-regular fa-cube fa-fw',
        'fa-light fa-cube fa-fw',
        'fa-duotone fa-cube fa-fw',
        'fa-thin fa-cubes fa-fw',
        'fa-solid fa-cubes fa-fw',
        'fa-sharp fa-solid fa-cubes fa-fw',
        'fa-sharp fa-regular fa-cubes fa-fw',
        'fa-sharp fa-light fa-cubes fa-fw',
        'fa-regular fa-cubes fa-fw',
        'fa-light fa-cubes fa-fw',
        'fa-duotone fa-cubes fa-fw',
        'fa-thin fa-distribute-spacing-horizontal fa-fw',
        'fa-solid fa-distribute-spacing-horizontal fa-fw',
        'fa-sharp fa-solid fa-distribute-spacing-horizontal fa-fw',
        'fa-sharp fa-regular fa-distribute-spacing-horizontal fa-fw',
        'fa-sharp fa-light fa-distribute-spacing-horizontal fa-fw',
        'fa-regular fa-distribute-spacing-horizontal fa-fw',
        'fa-light fa-distribute-spacing-horizontal fa-fw',
        'fa-duotone fa-distribute-spacing-horizontal fa-fw',
        'fa-thin fa-distribute-spacing-vertical fa-fw',
        'fa-solid fa-distribute-spacing-vertical fa-fw',
        'fa-sharp fa-solid fa-distribute-spacing-vertical fa-fw',
        'fa-sharp fa-regular fa-distribute-spacing-vertical fa-fw',
        'fa-sharp fa-light fa-distribute-spacing-vertical fa-fw',
        'fa-regular fa-distribute-spacing-vertical fa-fw',
        'fa-light fa-distribute-spacing-vertical fa-fw',
        'fa-duotone fa-distribute-spacing-vertical fa-fw',
        'fa-thin fa-draw-circle fa-fw',
        'fa-solid fa-draw-circle fa-fw',
        'fa-sharp fa-solid fa-draw-circle fa-fw',
        'fa-sharp fa-regular fa-draw-circle fa-fw',
        'fa-sharp fa-light fa-draw-circle fa-fw',
        'fa-regular fa-draw-circle fa-fw',
        'fa-light fa-draw-circle fa-fw',
        'fa-duotone fa-draw-circle fa-fw',
        'fa-thin fa-draw-polygon fa-fw',
        'fa-solid fa-draw-polygon fa-fw',
        'fa-sharp fa-solid fa-draw-polygon fa-fw',
        'fa-sharp fa-regular fa-draw-polygon fa-fw',
        'fa-sharp fa-light fa-draw-polygon fa-fw',
        'fa-regular fa-draw-polygon fa-fw',
        'fa-light fa-draw-polygon fa-fw',
        'fa-duotone fa-draw-polygon fa-fw',
        'fa-thin fa-draw-square fa-fw',
        'fa-solid fa-draw-square fa-fw',
        'fa-sharp fa-solid fa-draw-square fa-fw',
        'fa-sharp fa-regular fa-draw-square fa-fw',
        'fa-sharp fa-light fa-draw-square fa-fw',
        'fa-regular fa-draw-square fa-fw',
        'fa-light fa-draw-square fa-fw',
        'fa-duotone fa-draw-square fa-fw',
        'fa-thin fa-droplet fa-fw',
        'fa-solid fa-droplet fa-fw',
        'fa-sharp fa-solid fa-droplet fa-fw',
        'fa-sharp fa-regular fa-droplet fa-fw',
        'fa-sharp fa-light fa-droplet fa-fw',
        'fa-regular fa-droplet fa-fw',
        'fa-light fa-droplet fa-fw',
        'fa-duotone fa-droplet fa-fw',
        'fa-thin fa-droplet-slash fa-fw',
        'fa-solid fa-droplet-slash fa-fw',
        'fa-sharp fa-solid fa-droplet-slash fa-fw',
        'fa-sharp fa-regular fa-droplet-slash fa-fw',
        'fa-sharp fa-light fa-droplet-slash fa-fw',
        'fa-regular fa-droplet-slash fa-fw',
        'fa-light fa-droplet-slash fa-fw',
        'fa-duotone fa-droplet-slash fa-fw',
        'fa-thin fa-eraser fa-fw',
        'fa-solid fa-eraser fa-fw',
        'fa-sharp fa-solid fa-eraser fa-fw',
        'fa-sharp fa-regular fa-eraser fa-fw',
        'fa-sharp fa-light fa-eraser fa-fw',
        'fa-regular fa-eraser fa-fw',
        'fa-light fa-eraser fa-fw',
        'fa-duotone fa-eraser fa-fw',
        'fa-thin fa-eye fa-fw',
        'fa-solid fa-eye fa-fw',
        'fa-sharp fa-solid fa-eye fa-fw',
        'fa-sharp fa-regular fa-eye fa-fw',
        'fa-sharp fa-light fa-eye fa-fw',
        'fa-regular fa-eye fa-fw',
        'fa-light fa-eye fa-fw',
        'fa-duotone fa-eye fa-fw',
        'fa-thin fa-eye-dropper fa-fw',
        'fa-solid fa-eye-dropper fa-fw',
        'fa-sharp fa-solid fa-eye-dropper fa-fw',
        'fa-sharp fa-regular fa-eye-dropper fa-fw',
        'fa-sharp fa-light fa-eye-dropper fa-fw',
        'fa-regular fa-eye-dropper fa-fw',
        'fa-light fa-eye-dropper fa-fw',
        'fa-duotone fa-eye-dropper fa-fw',
        'fa-thin fa-eye-dropper-full fa-fw',
        'fa-solid fa-eye-dropper-full fa-fw',
        'fa-sharp fa-solid fa-eye-dropper-full fa-fw',
        'fa-sharp fa-regular fa-eye-dropper-full fa-fw',
        'fa-sharp fa-light fa-eye-dropper-full fa-fw',
        'fa-regular fa-eye-dropper-full fa-fw',
        'fa-light fa-eye-dropper-full fa-fw',
        'fa-duotone fa-eye-dropper-full fa-fw',
        'fa-thin fa-eye-dropper-half fa-fw',
        'fa-solid fa-eye-dropper-half fa-fw',
        'fa-sharp fa-solid fa-eye-dropper-half fa-fw',
        'fa-sharp fa-regular fa-eye-dropper-half fa-fw',
        'fa-sharp fa-light fa-eye-dropper-half fa-fw',
        'fa-regular fa-eye-dropper-half fa-fw',
        'fa-light fa-eye-dropper-half fa-fw',
        'fa-duotone fa-eye-dropper-half fa-fw',
        'fa-thin fa-eye-slash fa-fw',
        'fa-solid fa-eye-slash fa-fw',
        'fa-sharp fa-solid fa-eye-slash fa-fw',
        'fa-sharp fa-regular fa-eye-slash fa-fw',
        'fa-sharp fa-light fa-eye-slash fa-fw',
        'fa-regular fa-eye-slash fa-fw',
        'fa-light fa-eye-slash fa-fw',
        'fa-duotone fa-eye-slash fa-fw',
        'fa-thin fa-fill fa-fw',
        'fa-solid fa-fill fa-fw',
        'fa-sharp fa-solid fa-fill fa-fw',
        'fa-sharp fa-regular fa-fill fa-fw',
        'fa-sharp fa-light fa-fill fa-fw',
        'fa-regular fa-fill fa-fw',
        'fa-light fa-fill fa-fw',
        'fa-duotone fa-fill fa-fw',
        'fa-thin fa-fill-drip fa-fw',
        'fa-solid fa-fill-drip fa-fw',
        'fa-sharp fa-solid fa-fill-drip fa-fw',
        'fa-sharp fa-regular fa-fill-drip fa-fw',
        'fa-sharp fa-light fa-fill-drip fa-fw',
        'fa-regular fa-fill-drip fa-fw',
        'fa-light fa-fill-drip fa-fw',
        'fa-duotone fa-fill-drip fa-fw',
        'fa-thin fa-floppy-disk fa-fw',
        'fa-solid fa-floppy-disk fa-fw',
        'fa-sharp fa-solid fa-floppy-disk fa-fw',
        'fa-sharp fa-regular fa-floppy-disk fa-fw',
        'fa-sharp fa-light fa-floppy-disk fa-fw',
        'fa-regular fa-floppy-disk fa-fw',
        'fa-light fa-floppy-disk fa-fw',
        'fa-duotone fa-floppy-disk fa-fw',
        'fa-thin fa-font-awesome fa-fw',
        'fa-solid fa-font-awesome fa-fw',
        'fa-sharp fa-solid fa-font-awesome fa-fw',
        'fa-sharp fa-regular fa-font-awesome fa-fw',
        'fa-sharp fa-light fa-font-awesome fa-fw',
        'fa-regular fa-font-awesome fa-fw',
        'fa-light fa-font-awesome fa-fw',
        'fa-duotone fa-font-awesome fa-fw',
        'fa-brands fa-font-awesome fa-fw',
        'fa-thin fa-frame fa-fw',
        'fa-solid fa-frame fa-fw',
        'fa-sharp fa-solid fa-frame fa-fw',
        'fa-sharp fa-regular fa-frame fa-fw',
        'fa-sharp fa-light fa-frame fa-fw',
        'fa-regular fa-frame fa-fw',
        'fa-light fa-frame fa-fw',
        'fa-duotone fa-frame fa-fw',
        'fa-thin fa-gallery-thumbnails fa-fw',
        'fa-solid fa-gallery-thumbnails fa-fw',
        'fa-sharp fa-solid fa-gallery-thumbnails fa-fw',
        'fa-sharp fa-regular fa-gallery-thumbnails fa-fw',
        'fa-sharp fa-light fa-gallery-thumbnails fa-fw',
        'fa-regular fa-gallery-thumbnails fa-fw',
        'fa-light fa-gallery-thumbnails fa-fw',
        'fa-duotone fa-gallery-thumbnails fa-fw',
        'fa-thin fa-grid fa-fw',
        'fa-solid fa-grid fa-fw',
        'fa-sharp fa-solid fa-grid fa-fw',
        'fa-sharp fa-regular fa-grid fa-fw',
        'fa-sharp fa-light fa-grid fa-fw',
        'fa-regular fa-grid fa-fw',
        'fa-light fa-grid fa-fw',
        'fa-duotone fa-grid fa-fw',
        'fa-thin fa-grid-2 fa-fw',
        'fa-solid fa-grid-2 fa-fw',
        'fa-sharp fa-solid fa-grid-2 fa-fw',
        'fa-sharp fa-regular fa-grid-2 fa-fw',
        'fa-sharp fa-light fa-grid-2 fa-fw',
        'fa-regular fa-grid-2 fa-fw',
        'fa-light fa-grid-2 fa-fw',
        'fa-duotone fa-grid-2 fa-fw',
        'fa-thin fa-grid-2-plus fa-fw',
        'fa-solid fa-grid-2-plus fa-fw',
        'fa-sharp fa-solid fa-grid-2-plus fa-fw',
        'fa-sharp fa-regular fa-grid-2-plus fa-fw',
        'fa-sharp fa-light fa-grid-2-plus fa-fw',
        'fa-regular fa-grid-2-plus fa-fw',
        'fa-light fa-grid-2-plus fa-fw',
        'fa-duotone fa-grid-2-plus fa-fw',
        'fa-thin fa-grid-4 fa-fw',
        'fa-solid fa-grid-4 fa-fw',
        'fa-sharp fa-solid fa-grid-4 fa-fw',
        'fa-sharp fa-regular fa-grid-4 fa-fw',
        'fa-sharp fa-light fa-grid-4 fa-fw',
        'fa-regular fa-grid-4 fa-fw',
        'fa-light fa-grid-4 fa-fw',
        'fa-duotone fa-grid-4 fa-fw',
        'fa-thin fa-grid-5 fa-fw',
        'fa-solid fa-grid-5 fa-fw',
        'fa-sharp fa-solid fa-grid-5 fa-fw',
        'fa-sharp fa-regular fa-grid-5 fa-fw',
        'fa-sharp fa-light fa-grid-5 fa-fw',
        'fa-regular fa-grid-5 fa-fw',
        'fa-light fa-grid-5 fa-fw',
        'fa-duotone fa-grid-5 fa-fw',
        'fa-thin fa-grid-dividers fa-fw',
        'fa-solid fa-grid-dividers fa-fw',
        'fa-sharp fa-solid fa-grid-dividers fa-fw',
        'fa-sharp fa-regular fa-grid-dividers fa-fw',
        'fa-sharp fa-light fa-grid-dividers fa-fw',
        'fa-regular fa-grid-dividers fa-fw',
        'fa-light fa-grid-dividers fa-fw',
        'fa-duotone fa-grid-dividers fa-fw',
        'fa-thin fa-grid-round fa-fw',
        'fa-solid fa-grid-round fa-fw',
        'fa-sharp fa-solid fa-grid-round fa-fw',
        'fa-sharp fa-regular fa-grid-round fa-fw',
        'fa-sharp fa-light fa-grid-round fa-fw',
        'fa-regular fa-grid-round fa-fw',
        'fa-light fa-grid-round fa-fw',
        'fa-duotone fa-grid-round fa-fw',
        'fa-thin fa-grid-round-2 fa-fw',
        'fa-solid fa-grid-round-2 fa-fw',
        'fa-sharp fa-solid fa-grid-round-2 fa-fw',
        'fa-sharp fa-regular fa-grid-round-2 fa-fw',
        'fa-sharp fa-light fa-grid-round-2 fa-fw',
        'fa-regular fa-grid-round-2 fa-fw',
        'fa-light fa-grid-round-2 fa-fw',
        'fa-duotone fa-grid-round-2 fa-fw',
        'fa-thin fa-grid-round-2-plus fa-fw',
        'fa-solid fa-grid-round-2-plus fa-fw',
        'fa-sharp fa-solid fa-grid-round-2-plus fa-fw',
        'fa-sharp fa-regular fa-grid-round-2-plus fa-fw',
        'fa-sharp fa-light fa-grid-round-2-plus fa-fw',
        'fa-regular fa-grid-round-2-plus fa-fw',
        'fa-light fa-grid-round-2-plus fa-fw',
        'fa-duotone fa-grid-round-2-plus fa-fw',
        'fa-thin fa-grid-round-4 fa-fw',
        'fa-solid fa-grid-round-4 fa-fw',
        'fa-sharp fa-solid fa-grid-round-4 fa-fw',
        'fa-sharp fa-regular fa-grid-round-4 fa-fw',
        'fa-sharp fa-light fa-grid-round-4 fa-fw',
        'fa-regular fa-grid-round-4 fa-fw',
        'fa-light fa-grid-round-4 fa-fw',
        'fa-duotone fa-grid-round-4 fa-fw',
        'fa-thin fa-grid-round-5 fa-fw',
        'fa-solid fa-grid-round-5 fa-fw',
        'fa-sharp fa-solid fa-grid-round-5 fa-fw',
        'fa-sharp fa-regular fa-grid-round-5 fa-fw',
        'fa-sharp fa-light fa-grid-round-5 fa-fw',
        'fa-regular fa-grid-round-5 fa-fw',
        'fa-light fa-grid-round-5 fa-fw',
        'fa-duotone fa-grid-round-5 fa-fw',
        'fa-thin fa-highlighter fa-fw',
        'fa-solid fa-highlighter fa-fw',
        'fa-sharp fa-solid fa-highlighter fa-fw',
        'fa-sharp fa-regular fa-highlighter fa-fw',
        'fa-sharp fa-light fa-highlighter fa-fw',
        'fa-regular fa-highlighter fa-fw',
        'fa-light fa-highlighter fa-fw',
        'fa-duotone fa-highlighter fa-fw',
        'fa-thin fa-highlighter-line fa-fw',
        'fa-solid fa-highlighter-line fa-fw',
        'fa-sharp fa-solid fa-highlighter-line fa-fw',
        'fa-sharp fa-regular fa-highlighter-line fa-fw',
        'fa-sharp fa-light fa-highlighter-line fa-fw',
        'fa-regular fa-highlighter-line fa-fw',
        'fa-light fa-highlighter-line fa-fw',
        'fa-duotone fa-highlighter-line fa-fw',
        'fa-thin fa-icons fa-fw',
        'fa-solid fa-icons fa-fw',
        'fa-sharp fa-solid fa-icons fa-fw',
        'fa-sharp fa-regular fa-icons fa-fw',
        'fa-sharp fa-light fa-icons fa-fw',
        'fa-regular fa-icons fa-fw',
        'fa-light fa-icons fa-fw',
        'fa-duotone fa-icons fa-fw',
        'fa-thin fa-image-polaroid fa-fw',
        'fa-solid fa-image-polaroid fa-fw',
        'fa-sharp fa-solid fa-image-polaroid fa-fw',
        'fa-sharp fa-regular fa-image-polaroid fa-fw',
        'fa-sharp fa-light fa-image-polaroid fa-fw',
        'fa-regular fa-image-polaroid fa-fw',
        'fa-light fa-image-polaroid fa-fw',
        'fa-duotone fa-image-polaroid fa-fw',
        'fa-thin fa-lasso fa-fw',
        'fa-solid fa-lasso fa-fw',
        'fa-sharp fa-solid fa-lasso fa-fw',
        'fa-sharp fa-regular fa-lasso fa-fw',
        'fa-sharp fa-light fa-lasso fa-fw',
        'fa-regular fa-lasso fa-fw',
        'fa-light fa-lasso fa-fw',
        'fa-duotone fa-lasso fa-fw',
        'fa-thin fa-lasso-sparkles fa-fw',
        'fa-solid fa-lasso-sparkles fa-fw',
        'fa-sharp fa-solid fa-lasso-sparkles fa-fw',
        'fa-sharp fa-regular fa-lasso-sparkles fa-fw',
        'fa-sharp fa-light fa-lasso-sparkles fa-fw',
        'fa-regular fa-lasso-sparkles fa-fw',
        'fa-light fa-lasso-sparkles fa-fw',
        'fa-duotone fa-lasso-sparkles fa-fw',
        'fa-thin fa-layer-group fa-fw',
        'fa-solid fa-layer-group fa-fw',
        'fa-sharp fa-solid fa-layer-group fa-fw',
        'fa-sharp fa-regular fa-layer-group fa-fw',
        'fa-sharp fa-light fa-layer-group fa-fw',
        'fa-regular fa-layer-group fa-fw',
        'fa-light fa-layer-group fa-fw',
        'fa-duotone fa-layer-group fa-fw',
        'fa-thin fa-layer-minus fa-fw',
        'fa-solid fa-layer-minus fa-fw',
        'fa-sharp fa-solid fa-layer-minus fa-fw',
        'fa-sharp fa-regular fa-layer-minus fa-fw',
        'fa-sharp fa-light fa-layer-minus fa-fw',
        'fa-regular fa-layer-minus fa-fw',
        'fa-light fa-layer-minus fa-fw',
        'fa-duotone fa-layer-minus fa-fw',
        'fa-thin fa-layer-plus fa-fw',
        'fa-solid fa-layer-plus fa-fw',
        'fa-sharp fa-solid fa-layer-plus fa-fw',
        'fa-sharp fa-regular fa-layer-plus fa-fw',
        'fa-sharp fa-light fa-layer-plus fa-fw',
        'fa-regular fa-layer-plus fa-fw',
        'fa-light fa-layer-plus fa-fw',
        'fa-duotone fa-layer-plus fa-fw',
        'fa-thin fa-lines-leaning fa-fw',
        'fa-solid fa-lines-leaning fa-fw',
        'fa-sharp fa-solid fa-lines-leaning fa-fw',
        'fa-sharp fa-regular fa-lines-leaning fa-fw',
        'fa-sharp fa-light fa-lines-leaning fa-fw',
        'fa-regular fa-lines-leaning fa-fw',
        'fa-light fa-lines-leaning fa-fw',
        'fa-duotone fa-lines-leaning fa-fw',
        'fa-thin fa-marker fa-fw',
        'fa-solid fa-marker fa-fw',
        'fa-sharp fa-solid fa-marker fa-fw',
        'fa-sharp fa-regular fa-marker fa-fw',
        'fa-sharp fa-light fa-marker fa-fw',
        'fa-regular fa-marker fa-fw',
        'fa-light fa-marker fa-fw',
        'fa-duotone fa-marker fa-fw',
        'fa-thin fa-notebook fa-fw',
        'fa-solid fa-notebook fa-fw',
        'fa-sharp fa-solid fa-notebook fa-fw',
        'fa-sharp fa-regular fa-notebook fa-fw',
        'fa-sharp fa-light fa-notebook fa-fw',
        'fa-regular fa-notebook fa-fw',
        'fa-light fa-notebook fa-fw',
        'fa-duotone fa-notebook fa-fw',
        'fa-thin fa-object-exclude fa-fw',
        'fa-solid fa-object-exclude fa-fw',
        'fa-sharp fa-solid fa-object-exclude fa-fw',
        'fa-sharp fa-regular fa-object-exclude fa-fw',
        'fa-sharp fa-light fa-object-exclude fa-fw',
        'fa-regular fa-object-exclude fa-fw',
        'fa-light fa-object-exclude fa-fw',
        'fa-duotone fa-object-exclude fa-fw',
        'fa-thin fa-object-group fa-fw',
        'fa-solid fa-object-group fa-fw',
        'fa-sharp fa-solid fa-object-group fa-fw',
        'fa-sharp fa-regular fa-object-group fa-fw',
        'fa-sharp fa-light fa-object-group fa-fw',
        'fa-regular fa-object-group fa-fw',
        'fa-light fa-object-group fa-fw',
        'fa-duotone fa-object-group fa-fw',
        'fa-thin fa-object-intersect fa-fw',
        'fa-solid fa-object-intersect fa-fw',
        'fa-sharp fa-solid fa-object-intersect fa-fw',
        'fa-sharp fa-regular fa-object-intersect fa-fw',
        'fa-sharp fa-light fa-object-intersect fa-fw',
        'fa-regular fa-object-intersect fa-fw',
        'fa-light fa-object-intersect fa-fw',
        'fa-duotone fa-object-intersect fa-fw',
        'fa-thin fa-object-subtract fa-fw',
        'fa-solid fa-object-subtract fa-fw',
        'fa-sharp fa-solid fa-object-subtract fa-fw',
        'fa-sharp fa-regular fa-object-subtract fa-fw',
        'fa-sharp fa-light fa-object-subtract fa-fw',
        'fa-regular fa-object-subtract fa-fw',
        'fa-light fa-object-subtract fa-fw',
        'fa-duotone fa-object-subtract fa-fw',
        'fa-thin fa-object-ungroup fa-fw',
        'fa-solid fa-object-ungroup fa-fw',
        'fa-sharp fa-solid fa-object-ungroup fa-fw',
        'fa-sharp fa-regular fa-object-ungroup fa-fw',
        'fa-sharp fa-light fa-object-ungroup fa-fw',
        'fa-regular fa-object-ungroup fa-fw',
        'fa-light fa-object-ungroup fa-fw',
        'fa-duotone fa-object-ungroup fa-fw',
        'fa-thin fa-object-union fa-fw',
        'fa-solid fa-object-union fa-fw',
        'fa-sharp fa-solid fa-object-union fa-fw',
        'fa-sharp fa-regular fa-object-union fa-fw',
        'fa-sharp fa-light fa-object-union fa-fw',
        'fa-regular fa-object-union fa-fw',
        'fa-light fa-object-union fa-fw',
        'fa-duotone fa-object-union fa-fw',
        'fa-thin fa-objects-align-bottom fa-fw',
        'fa-solid fa-objects-align-bottom fa-fw',
        'fa-sharp fa-solid fa-objects-align-bottom fa-fw',
        'fa-sharp fa-regular fa-objects-align-bottom fa-fw',
        'fa-sharp fa-light fa-objects-align-bottom fa-fw',
        'fa-regular fa-objects-align-bottom fa-fw',
        'fa-light fa-objects-align-bottom fa-fw',
        'fa-duotone fa-objects-align-bottom fa-fw',
        'fa-thin fa-objects-align-center-horizontal fa-fw',
        'fa-solid fa-objects-align-center-horizontal fa-fw',
        'fa-sharp fa-solid fa-objects-align-center-horizontal fa-fw',
        'fa-sharp fa-regular fa-objects-align-center-horizontal fa-fw',
        'fa-sharp fa-light fa-objects-align-center-horizontal fa-fw',
        'fa-regular fa-objects-align-center-horizontal fa-fw',
        'fa-light fa-objects-align-center-horizontal fa-fw',
        'fa-duotone fa-objects-align-center-horizontal fa-fw',
        'fa-thin fa-objects-align-center-vertical fa-fw',
        'fa-solid fa-objects-align-center-vertical fa-fw',
        'fa-sharp fa-solid fa-objects-align-center-vertical fa-fw',
        'fa-sharp fa-regular fa-objects-align-center-vertical fa-fw',
        'fa-sharp fa-light fa-objects-align-center-vertical fa-fw',
        'fa-regular fa-objects-align-center-vertical fa-fw',
        'fa-light fa-objects-align-center-vertical fa-fw',
        'fa-duotone fa-objects-align-center-vertical fa-fw',
        'fa-thin fa-objects-align-left fa-fw',
        'fa-solid fa-objects-align-left fa-fw',
        'fa-sharp fa-solid fa-objects-align-left fa-fw',
        'fa-sharp fa-regular fa-objects-align-left fa-fw',
        'fa-sharp fa-light fa-objects-align-left fa-fw',
        'fa-regular fa-objects-align-left fa-fw',
        'fa-light fa-objects-align-left fa-fw',
        'fa-duotone fa-objects-align-left fa-fw',
        'fa-thin fa-objects-align-right fa-fw',
        'fa-solid fa-objects-align-right fa-fw',
        'fa-sharp fa-solid fa-objects-align-right fa-fw',
        'fa-sharp fa-regular fa-objects-align-right fa-fw',
        'fa-sharp fa-light fa-objects-align-right fa-fw',
        'fa-regular fa-objects-align-right fa-fw',
        'fa-light fa-objects-align-right fa-fw',
        'fa-duotone fa-objects-align-right fa-fw',
        'fa-thin fa-objects-align-top fa-fw',
        'fa-solid fa-objects-align-top fa-fw',
        'fa-sharp fa-solid fa-objects-align-top fa-fw',
        'fa-sharp fa-regular fa-objects-align-top fa-fw',
        'fa-sharp fa-light fa-objects-align-top fa-fw',
        'fa-regular fa-objects-align-top fa-fw',
        'fa-light fa-objects-align-top fa-fw',
        'fa-duotone fa-objects-align-top fa-fw',
        'fa-thin fa-objects-column fa-fw',
        'fa-solid fa-objects-column fa-fw',
        'fa-sharp fa-solid fa-objects-column fa-fw',
        'fa-sharp fa-regular fa-objects-column fa-fw',
        'fa-sharp fa-light fa-objects-column fa-fw',
        'fa-regular fa-objects-column fa-fw',
        'fa-light fa-objects-column fa-fw',
        'fa-duotone fa-objects-column fa-fw',
        'fa-thin fa-paint-roller fa-fw',
        'fa-solid fa-paint-roller fa-fw',
        'fa-sharp fa-solid fa-paint-roller fa-fw',
        'fa-sharp fa-regular fa-paint-roller fa-fw',
        'fa-sharp fa-light fa-paint-roller fa-fw',
        'fa-regular fa-paint-roller fa-fw',
        'fa-light fa-paint-roller fa-fw',
        'fa-duotone fa-paint-roller fa-fw',
        'fa-thin fa-paintbrush fa-fw',
        'fa-solid fa-paintbrush fa-fw',
        'fa-sharp fa-solid fa-paintbrush fa-fw',
        'fa-sharp fa-regular fa-paintbrush fa-fw',
        'fa-sharp fa-light fa-paintbrush fa-fw',
        'fa-regular fa-paintbrush fa-fw',
        'fa-light fa-paintbrush fa-fw',
        'fa-duotone fa-paintbrush fa-fw',
        'fa-thin fa-paintbrush-fine fa-fw',
        'fa-solid fa-paintbrush-fine fa-fw',
        'fa-sharp fa-solid fa-paintbrush-fine fa-fw',
        'fa-sharp fa-regular fa-paintbrush-fine fa-fw',
        'fa-sharp fa-light fa-paintbrush-fine fa-fw',
        'fa-regular fa-paintbrush-fine fa-fw',
        'fa-light fa-paintbrush-fine fa-fw',
        'fa-duotone fa-paintbrush-fine fa-fw',
        'fa-thin fa-paintbrush-pencil fa-fw',
        'fa-solid fa-paintbrush-pencil fa-fw',
        'fa-sharp fa-solid fa-paintbrush-pencil fa-fw',
        'fa-sharp fa-regular fa-paintbrush-pencil fa-fw',
        'fa-sharp fa-light fa-paintbrush-pencil fa-fw',
        'fa-regular fa-paintbrush-pencil fa-fw',
        'fa-light fa-paintbrush-pencil fa-fw',
        'fa-duotone fa-paintbrush-pencil fa-fw',
        'fa-thin fa-palette fa-fw',
        'fa-solid fa-palette fa-fw',
        'fa-sharp fa-solid fa-palette fa-fw',
        'fa-sharp fa-regular fa-palette fa-fw',
        'fa-sharp fa-light fa-palette fa-fw',
        'fa-regular fa-palette fa-fw',
        'fa-light fa-palette fa-fw',
        'fa-duotone fa-palette fa-fw',
        'fa-thin fa-paste fa-fw',
        'fa-solid fa-paste fa-fw',
        'fa-sharp fa-solid fa-paste fa-fw',
        'fa-sharp fa-regular fa-paste fa-fw',
        'fa-sharp fa-light fa-paste fa-fw',
        'fa-regular fa-paste fa-fw',
        'fa-light fa-paste fa-fw',
        'fa-duotone fa-paste fa-fw',
        'fa-thin fa-pen fa-fw',
        'fa-solid fa-pen fa-fw',
        'fa-sharp fa-solid fa-pen fa-fw',
        'fa-sharp fa-regular fa-pen fa-fw',
        'fa-sharp fa-light fa-pen fa-fw',
        'fa-regular fa-pen fa-fw',
        'fa-light fa-pen fa-fw',
        'fa-duotone fa-pen fa-fw',
        'fa-thin fa-pen-circle fa-fw',
        'fa-solid fa-pen-circle fa-fw',
        'fa-sharp fa-solid fa-pen-circle fa-fw',
        'fa-sharp fa-regular fa-pen-circle fa-fw',
        'fa-sharp fa-light fa-pen-circle fa-fw',
        'fa-regular fa-pen-circle fa-fw',
        'fa-light fa-pen-circle fa-fw',
        'fa-duotone fa-pen-circle fa-fw',
        'fa-thin fa-pen-clip fa-fw',
        'fa-solid fa-pen-clip fa-fw',
        'fa-sharp fa-solid fa-pen-clip fa-fw',
        'fa-sharp fa-regular fa-pen-clip fa-fw',
        'fa-sharp fa-light fa-pen-clip fa-fw',
        'fa-regular fa-pen-clip fa-fw',
        'fa-light fa-pen-clip fa-fw',
        'fa-duotone fa-pen-clip fa-fw',
        'fa-thin fa-pen-fancy fa-fw',
        'fa-solid fa-pen-fancy fa-fw',
        'fa-sharp fa-solid fa-pen-fancy fa-fw',
        'fa-sharp fa-regular fa-pen-fancy fa-fw',
        'fa-sharp fa-light fa-pen-fancy fa-fw',
        'fa-regular fa-pen-fancy fa-fw',
        'fa-light fa-pen-fancy fa-fw',
        'fa-duotone fa-pen-fancy fa-fw',
        'fa-thin fa-pen-nib fa-fw',
        'fa-solid fa-pen-nib fa-fw',
        'fa-sharp fa-solid fa-pen-nib fa-fw',
        'fa-sharp fa-regular fa-pen-nib fa-fw',
        'fa-sharp fa-light fa-pen-nib fa-fw',
        'fa-regular fa-pen-nib fa-fw',
        'fa-light fa-pen-nib fa-fw',
        'fa-duotone fa-pen-nib fa-fw',
        'fa-thin fa-pen-nib-slash fa-fw',
        'fa-solid fa-pen-nib-slash fa-fw',
        'fa-sharp fa-solid fa-pen-nib-slash fa-fw',
        'fa-sharp fa-regular fa-pen-nib-slash fa-fw',
        'fa-sharp fa-light fa-pen-nib-slash fa-fw',
        'fa-regular fa-pen-nib-slash fa-fw',
        'fa-light fa-pen-nib-slash fa-fw',
        'fa-duotone fa-pen-nib-slash fa-fw',
        'fa-thin fa-pen-ruler fa-fw',
        'fa-solid fa-pen-ruler fa-fw',
        'fa-sharp fa-solid fa-pen-ruler fa-fw',
        'fa-sharp fa-regular fa-pen-ruler fa-fw',
        'fa-sharp fa-light fa-pen-ruler fa-fw',
        'fa-regular fa-pen-ruler fa-fw',
        'fa-light fa-pen-ruler fa-fw',
        'fa-duotone fa-pen-ruler fa-fw',
        'fa-thin fa-pen-to-square fa-fw',
        'fa-solid fa-pen-to-square fa-fw',
        'fa-sharp fa-solid fa-pen-to-square fa-fw',
        'fa-sharp fa-regular fa-pen-to-square fa-fw',
        'fa-sharp fa-light fa-pen-to-square fa-fw',
        'fa-regular fa-pen-to-square fa-fw',
        'fa-light fa-pen-to-square fa-fw',
        'fa-duotone fa-pen-to-square fa-fw',
        'fa-thin fa-pencil fa-fw',
        'fa-solid fa-pencil fa-fw',
        'fa-sharp fa-solid fa-pencil fa-fw',
        'fa-sharp fa-regular fa-pencil fa-fw',
        'fa-sharp fa-light fa-pencil fa-fw',
        'fa-regular fa-pencil fa-fw',
        'fa-light fa-pencil fa-fw',
        'fa-duotone fa-pencil fa-fw',
        'fa-thin fa-pencil-mechanical fa-fw',
        'fa-solid fa-pencil-mechanical fa-fw',
        'fa-sharp fa-solid fa-pencil-mechanical fa-fw',
        'fa-sharp fa-regular fa-pencil-mechanical fa-fw',
        'fa-sharp fa-light fa-pencil-mechanical fa-fw',
        'fa-regular fa-pencil-mechanical fa-fw',
        'fa-light fa-pencil-mechanical fa-fw',
        'fa-duotone fa-pencil-mechanical fa-fw',
        'fa-thin fa-rectangle-pro fa-fw',
        'fa-solid fa-rectangle-pro fa-fw',
        'fa-sharp fa-solid fa-rectangle-pro fa-fw',
        'fa-sharp fa-regular fa-rectangle-pro fa-fw',
        'fa-sharp fa-light fa-rectangle-pro fa-fw',
        'fa-regular fa-rectangle-pro fa-fw',
        'fa-light fa-rectangle-pro fa-fw',
        'fa-duotone fa-rectangle-pro fa-fw',
        'fa-thin fa-rectangles-mixed fa-fw',
        'fa-solid fa-rectangles-mixed fa-fw',
        'fa-sharp fa-solid fa-rectangles-mixed fa-fw',
        'fa-sharp fa-regular fa-rectangles-mixed fa-fw',
        'fa-sharp fa-light fa-rectangles-mixed fa-fw',
        'fa-regular fa-rectangles-mixed fa-fw',
        'fa-light fa-rectangles-mixed fa-fw',
        'fa-duotone fa-rectangles-mixed fa-fw',
        'fa-thin fa-ruler-combined fa-fw',
        'fa-solid fa-ruler-combined fa-fw',
        'fa-sharp fa-solid fa-ruler-combined fa-fw',
        'fa-sharp fa-regular fa-ruler-combined fa-fw',
        'fa-sharp fa-light fa-ruler-combined fa-fw',
        'fa-regular fa-ruler-combined fa-fw',
        'fa-light fa-ruler-combined fa-fw',
        'fa-duotone fa-ruler-combined fa-fw',
        'fa-thin fa-ruler-horizontal fa-fw',
        'fa-solid fa-ruler-horizontal fa-fw',
        'fa-sharp fa-solid fa-ruler-horizontal fa-fw',
        'fa-sharp fa-regular fa-ruler-horizontal fa-fw',
        'fa-sharp fa-light fa-ruler-horizontal fa-fw',
        'fa-regular fa-ruler-horizontal fa-fw',
        'fa-light fa-ruler-horizontal fa-fw',
        'fa-duotone fa-ruler-horizontal fa-fw',
        'fa-thin fa-ruler-vertical fa-fw',
        'fa-solid fa-ruler-vertical fa-fw',
        'fa-sharp fa-solid fa-ruler-vertical fa-fw',
        'fa-sharp fa-regular fa-ruler-vertical fa-fw',
        'fa-sharp fa-light fa-ruler-vertical fa-fw',
        'fa-regular fa-ruler-vertical fa-fw',
        'fa-light fa-ruler-vertical fa-fw',
        'fa-duotone fa-ruler-vertical fa-fw',
        'fa-thin fa-scanner-image fa-fw',
        'fa-solid fa-scanner-image fa-fw',
        'fa-sharp fa-solid fa-scanner-image fa-fw',
        'fa-sharp fa-regular fa-scanner-image fa-fw',
        'fa-sharp fa-light fa-scanner-image fa-fw',
        'fa-regular fa-scanner-image fa-fw',
        'fa-light fa-scanner-image fa-fw',
        'fa-duotone fa-scanner-image fa-fw',
        'fa-thin fa-scissors fa-fw',
        'fa-solid fa-scissors fa-fw',
        'fa-sharp fa-solid fa-scissors fa-fw',
        'fa-sharp fa-regular fa-scissors fa-fw',
        'fa-sharp fa-light fa-scissors fa-fw',
        'fa-regular fa-scissors fa-fw',
        'fa-light fa-scissors fa-fw',
        'fa-duotone fa-scissors fa-fw',
        'fa-thin fa-scribble fa-fw',
        'fa-solid fa-scribble fa-fw',
        'fa-sharp fa-solid fa-scribble fa-fw',
        'fa-sharp fa-regular fa-scribble fa-fw',
        'fa-sharp fa-light fa-scribble fa-fw',
        'fa-regular fa-scribble fa-fw',
        'fa-light fa-scribble fa-fw',
        'fa-duotone fa-scribble fa-fw',
        'fa-thin fa-send-back fa-fw',
        'fa-solid fa-send-back fa-fw',
        'fa-sharp fa-solid fa-send-back fa-fw',
        'fa-sharp fa-regular fa-send-back fa-fw',
        'fa-sharp fa-light fa-send-back fa-fw',
        'fa-regular fa-send-back fa-fw',
        'fa-light fa-send-back fa-fw',
        'fa-duotone fa-send-back fa-fw',
        'fa-thin fa-send-backward fa-fw',
        'fa-solid fa-send-backward fa-fw',
        'fa-sharp fa-solid fa-send-backward fa-fw',
        'fa-sharp fa-regular fa-send-backward fa-fw',
        'fa-sharp fa-light fa-send-backward fa-fw',
        'fa-regular fa-send-backward fa-fw',
        'fa-light fa-send-backward fa-fw',
        'fa-duotone fa-send-backward fa-fw',
        'fa-thin fa-sparkle fa-fw',
        'fa-solid fa-sparkle fa-fw',
        'fa-sharp fa-solid fa-sparkle fa-fw',
        'fa-sharp fa-regular fa-sparkle fa-fw',
        'fa-sharp fa-light fa-sparkle fa-fw',
        'fa-regular fa-sparkle fa-fw',
        'fa-light fa-sparkle fa-fw',
        'fa-duotone fa-sparkle fa-fw',
        'fa-thin fa-splotch fa-fw',
        'fa-solid fa-splotch fa-fw',
        'fa-sharp fa-solid fa-splotch fa-fw',
        'fa-sharp fa-regular fa-splotch fa-fw',
        'fa-sharp fa-light fa-splotch fa-fw',
        'fa-regular fa-splotch fa-fw',
        'fa-light fa-splotch fa-fw',
        'fa-duotone fa-splotch fa-fw',
        'fa-thin fa-spray-can fa-fw',
        'fa-solid fa-spray-can fa-fw',
        'fa-sharp fa-solid fa-spray-can fa-fw',
        'fa-sharp fa-regular fa-spray-can fa-fw',
        'fa-sharp fa-light fa-spray-can fa-fw',
        'fa-regular fa-spray-can fa-fw',
        'fa-light fa-spray-can fa-fw',
        'fa-duotone fa-spray-can fa-fw',
        'fa-thin fa-square-dashed fa-fw',
        'fa-solid fa-square-dashed fa-fw',
        'fa-sharp fa-solid fa-square-dashed fa-fw',
        'fa-sharp fa-regular fa-square-dashed fa-fw',
        'fa-sharp fa-light fa-square-dashed fa-fw',
        'fa-regular fa-square-dashed fa-fw',
        'fa-light fa-square-dashed fa-fw',
        'fa-duotone fa-square-dashed fa-fw',
        'fa-thin fa-square-dashed-circle-plus fa-fw',
        'fa-solid fa-square-dashed-circle-plus fa-fw',
        'fa-sharp fa-solid fa-square-dashed-circle-plus fa-fw',
        'fa-sharp fa-regular fa-square-dashed-circle-plus fa-fw',
        'fa-sharp fa-light fa-square-dashed-circle-plus fa-fw',
        'fa-regular fa-square-dashed-circle-plus fa-fw',
        'fa-light fa-square-dashed-circle-plus fa-fw',
        'fa-duotone fa-square-dashed-circle-plus fa-fw',
        'fa-thin fa-stamp fa-fw',
        'fa-solid fa-stamp fa-fw',
        'fa-sharp fa-solid fa-stamp fa-fw',
        'fa-sharp fa-regular fa-stamp fa-fw',
        'fa-sharp fa-light fa-stamp fa-fw',
        'fa-regular fa-stamp fa-fw',
        'fa-light fa-stamp fa-fw',
        'fa-duotone fa-stamp fa-fw',
        'fa-thin fa-stapler fa-fw',
        'fa-solid fa-stapler fa-fw',
        'fa-sharp fa-solid fa-stapler fa-fw',
        'fa-sharp fa-regular fa-stapler fa-fw',
        'fa-sharp fa-light fa-stapler fa-fw',
        'fa-regular fa-stapler fa-fw',
        'fa-light fa-stapler fa-fw',
        'fa-duotone fa-stapler fa-fw',
        'fa-thin fa-swatchbook fa-fw',
        'fa-solid fa-swatchbook fa-fw',
        'fa-sharp fa-solid fa-swatchbook fa-fw',
        'fa-sharp fa-regular fa-swatchbook fa-fw',
        'fa-sharp fa-light fa-swatchbook fa-fw',
        'fa-regular fa-swatchbook fa-fw',
        'fa-light fa-swatchbook fa-fw',
        'fa-duotone fa-swatchbook fa-fw',
        'fa-thin fa-symbols fa-fw',
        'fa-solid fa-symbols fa-fw',
        'fa-sharp fa-solid fa-symbols fa-fw',
        'fa-sharp fa-regular fa-symbols fa-fw',
        'fa-sharp fa-light fa-symbols fa-fw',
        'fa-regular fa-symbols fa-fw',
        'fa-light fa-symbols fa-fw',
        'fa-duotone fa-symbols fa-fw',
        'fa-thin fa-vector-circle fa-fw',
        'fa-solid fa-vector-circle fa-fw',
        'fa-sharp fa-solid fa-vector-circle fa-fw',
        'fa-sharp fa-regular fa-vector-circle fa-fw',
        'fa-sharp fa-light fa-vector-circle fa-fw',
        'fa-regular fa-vector-circle fa-fw',
        'fa-light fa-vector-circle fa-fw',
        'fa-duotone fa-vector-circle fa-fw',
        'fa-thin fa-vector-polygon fa-fw',
        'fa-solid fa-vector-polygon fa-fw',
        'fa-sharp fa-solid fa-vector-polygon fa-fw',
        'fa-sharp fa-regular fa-vector-polygon fa-fw',
        'fa-sharp fa-light fa-vector-polygon fa-fw',
        'fa-regular fa-vector-polygon fa-fw',
        'fa-light fa-vector-polygon fa-fw',
        'fa-duotone fa-vector-polygon fa-fw',
        'fa-thin fa-vector-square fa-fw',
        'fa-solid fa-vector-square fa-fw',
        'fa-sharp fa-solid fa-vector-square fa-fw',
        'fa-sharp fa-regular fa-vector-square fa-fw',
        'fa-sharp fa-light fa-vector-square fa-fw',
        'fa-regular fa-vector-square fa-fw',
        'fa-light fa-vector-square fa-fw',
        'fa-duotone fa-vector-square fa-fw',
        'fa-thin fa-wand-magic fa-fw',
        'fa-solid fa-wand-magic fa-fw',
        'fa-sharp fa-solid fa-wand-magic fa-fw',
        'fa-sharp fa-regular fa-wand-magic fa-fw',
        'fa-sharp fa-light fa-wand-magic fa-fw',
        'fa-regular fa-wand-magic fa-fw',
        'fa-light fa-wand-magic fa-fw',
        'fa-duotone fa-wand-magic fa-fw',
        'fa-thin fa-wand-magic-sparkles fa-fw',
        'fa-solid fa-wand-magic-sparkles fa-fw',
        'fa-sharp fa-solid fa-wand-magic-sparkles fa-fw',
        'fa-sharp fa-regular fa-wand-magic-sparkles fa-fw',
        'fa-sharp fa-light fa-wand-magic-sparkles fa-fw',
        'fa-regular fa-wand-magic-sparkles fa-fw',
        'fa-light fa-wand-magic-sparkles fa-fw',
        'fa-duotone fa-wand-magic-sparkles fa-fw',
        'fa-thin fa-wrench-simple fa-fw',
        'fa-solid fa-wrench-simple fa-fw',
        'fa-sharp fa-solid fa-wrench-simple fa-fw',
        'fa-sharp fa-regular fa-wrench-simple fa-fw',
        'fa-sharp fa-light fa-wrench-simple fa-fw',
        'fa-regular fa-wrench-simple fa-fw',
        'fa-light fa-wrench-simple fa-fw',
        'fa-duotone fa-wrench-simple fa-fw',
      ],
    },

    {
      title: 'Devices/Hardware',
      items: [
        'fa-thin fa-album fa-fw',
        'fa-solid fa-album fa-fw',
        'fa-sharp fa-solid fa-album fa-fw',
        'fa-sharp fa-regular fa-album fa-fw',
        'fa-sharp fa-light fa-album fa-fw',
        'fa-regular fa-album fa-fw',
        'fa-light fa-album fa-fw',
        'fa-duotone fa-album fa-fw',
        'fa-thin fa-album-circle-plus fa-fw',
        'fa-solid fa-album-circle-plus fa-fw',
        'fa-sharp fa-solid fa-album-circle-plus fa-fw',
        'fa-sharp fa-regular fa-album-circle-plus fa-fw',
        'fa-sharp fa-light fa-album-circle-plus fa-fw',
        'fa-regular fa-album-circle-plus fa-fw',
        'fa-light fa-album-circle-plus fa-fw',
        'fa-duotone fa-album-circle-plus fa-fw',
        'fa-thin fa-album-circle-user fa-fw',
        'fa-solid fa-album-circle-user fa-fw',
        'fa-sharp fa-solid fa-album-circle-user fa-fw',
        'fa-sharp fa-regular fa-album-circle-user fa-fw',
        'fa-sharp fa-light fa-album-circle-user fa-fw',
        'fa-regular fa-album-circle-user fa-fw',
        'fa-light fa-album-circle-user fa-fw',
        'fa-duotone fa-album-circle-user fa-fw',
        'fa-thin fa-blender-phone fa-fw',
        'fa-solid fa-blender-phone fa-fw',
        'fa-sharp fa-solid fa-blender-phone fa-fw',
        'fa-sharp fa-regular fa-blender-phone fa-fw',
        'fa-sharp fa-light fa-blender-phone fa-fw',
        'fa-regular fa-blender-phone fa-fw',
        'fa-light fa-blender-phone fa-fw',
        'fa-duotone fa-blender-phone fa-fw',
        'fa-thin fa-camera fa-fw',
        'fa-solid fa-camera fa-fw',
        'fa-sharp fa-solid fa-camera fa-fw',
        'fa-sharp fa-regular fa-camera fa-fw',
        'fa-sharp fa-light fa-camera fa-fw',
        'fa-regular fa-camera fa-fw',
        'fa-light fa-camera fa-fw',
        'fa-duotone fa-camera fa-fw',
        'fa-thin fa-camera-retro fa-fw',
        'fa-solid fa-camera-retro fa-fw',
        'fa-sharp fa-solid fa-camera-retro fa-fw',
        'fa-sharp fa-regular fa-camera-retro fa-fw',
        'fa-sharp fa-light fa-camera-retro fa-fw',
        'fa-regular fa-camera-retro fa-fw',
        'fa-light fa-camera-retro fa-fw',
        'fa-duotone fa-camera-retro fa-fw',
        'fa-thin fa-camera-web fa-fw',
        'fa-solid fa-camera-web fa-fw',
        'fa-sharp fa-solid fa-camera-web fa-fw',
        'fa-sharp fa-regular fa-camera-web fa-fw',
        'fa-sharp fa-light fa-camera-web fa-fw',
        'fa-regular fa-camera-web fa-fw',
        'fa-light fa-camera-web fa-fw',
        'fa-duotone fa-camera-web fa-fw',
        'fa-thin fa-camera-web-slash fa-fw',
        'fa-solid fa-camera-web-slash fa-fw',
        'fa-sharp fa-solid fa-camera-web-slash fa-fw',
        'fa-sharp fa-regular fa-camera-web-slash fa-fw',
        'fa-sharp fa-light fa-camera-web-slash fa-fw',
        'fa-regular fa-camera-web-slash fa-fw',
        'fa-light fa-camera-web-slash fa-fw',
        'fa-duotone fa-camera-web-slash fa-fw',
        'fa-thin fa-car-battery fa-fw',
        'fa-solid fa-car-battery fa-fw',
        'fa-sharp fa-solid fa-car-battery fa-fw',
        'fa-sharp fa-regular fa-car-battery fa-fw',
        'fa-sharp fa-light fa-car-battery fa-fw',
        'fa-regular fa-car-battery fa-fw',
        'fa-light fa-car-battery fa-fw',
        'fa-duotone fa-car-battery fa-fw',
        'fa-thin fa-compact-disc fa-fw',
        'fa-solid fa-compact-disc fa-fw',
        'fa-sharp fa-solid fa-compact-disc fa-fw',
        'fa-sharp fa-regular fa-compact-disc fa-fw',
        'fa-sharp fa-light fa-compact-disc fa-fw',
        'fa-regular fa-compact-disc fa-fw',
        'fa-light fa-compact-disc fa-fw',
        'fa-duotone fa-compact-disc fa-fw',
        'fa-thin fa-computer fa-fw',
        'fa-solid fa-computer fa-fw',
        'fa-sharp fa-solid fa-computer fa-fw',
        'fa-sharp fa-regular fa-computer fa-fw',
        'fa-sharp fa-light fa-computer fa-fw',
        'fa-regular fa-computer fa-fw',
        'fa-light fa-computer fa-fw',
        'fa-duotone fa-computer fa-fw',
        'fa-thin fa-computer-classic fa-fw',
        'fa-solid fa-computer-classic fa-fw',
        'fa-sharp fa-solid fa-computer-classic fa-fw',
        'fa-sharp fa-regular fa-computer-classic fa-fw',
        'fa-sharp fa-light fa-computer-classic fa-fw',
        'fa-regular fa-computer-classic fa-fw',
        'fa-light fa-computer-classic fa-fw',
        'fa-duotone fa-computer-classic fa-fw',
        'fa-thin fa-computer-mouse fa-fw',
        'fa-solid fa-computer-mouse fa-fw',
        'fa-sharp fa-solid fa-computer-mouse fa-fw',
        'fa-sharp fa-regular fa-computer-mouse fa-fw',
        'fa-sharp fa-light fa-computer-mouse fa-fw',
        'fa-regular fa-computer-mouse fa-fw',
        'fa-light fa-computer-mouse fa-fw',
        'fa-duotone fa-computer-mouse fa-fw',
        'fa-thin fa-computer-mouse-scrollwheel fa-fw',
        'fa-solid fa-computer-mouse-scrollwheel fa-fw',
        'fa-sharp fa-solid fa-computer-mouse-scrollwheel fa-fw',
        'fa-sharp fa-regular fa-computer-mouse-scrollwheel fa-fw',
        'fa-sharp fa-light fa-computer-mouse-scrollwheel fa-fw',
        'fa-regular fa-computer-mouse-scrollwheel fa-fw',
        'fa-light fa-computer-mouse-scrollwheel fa-fw',
        'fa-duotone fa-computer-mouse-scrollwheel fa-fw',
        'fa-thin fa-computer-speaker fa-fw',
        'fa-solid fa-computer-speaker fa-fw',
        'fa-sharp fa-solid fa-computer-speaker fa-fw',
        'fa-sharp fa-regular fa-computer-speaker fa-fw',
        'fa-sharp fa-light fa-computer-speaker fa-fw',
        'fa-regular fa-computer-speaker fa-fw',
        'fa-light fa-computer-speaker fa-fw',
        'fa-duotone fa-computer-speaker fa-fw',
        'fa-thin fa-database fa-fw',
        'fa-solid fa-database fa-fw',
        'fa-sharp fa-solid fa-database fa-fw',
        'fa-sharp fa-regular fa-database fa-fw',
        'fa-sharp fa-light fa-database fa-fw',
        'fa-regular fa-database fa-fw',
        'fa-light fa-database fa-fw',
        'fa-duotone fa-database fa-fw',
        'fa-thin fa-desktop fa-fw',
        'fa-solid fa-desktop fa-fw',
        'fa-sharp fa-solid fa-desktop fa-fw',
        'fa-sharp fa-regular fa-desktop fa-fw',
        'fa-sharp fa-light fa-desktop fa-fw',
        'fa-regular fa-desktop fa-fw',
        'fa-light fa-desktop fa-fw',
        'fa-duotone fa-desktop fa-fw',
        'fa-thin fa-desktop-arrow-down fa-fw',
        'fa-solid fa-desktop-arrow-down fa-fw',
        'fa-sharp fa-solid fa-desktop-arrow-down fa-fw',
        'fa-sharp fa-regular fa-desktop-arrow-down fa-fw',
        'fa-sharp fa-light fa-desktop-arrow-down fa-fw',
        'fa-regular fa-desktop-arrow-down fa-fw',
        'fa-light fa-desktop-arrow-down fa-fw',
        'fa-duotone fa-desktop-arrow-down fa-fw',
        'fa-thin fa-disc-drive fa-fw',
        'fa-solid fa-disc-drive fa-fw',
        'fa-sharp fa-solid fa-disc-drive fa-fw',
        'fa-sharp fa-regular fa-disc-drive fa-fw',
        'fa-sharp fa-light fa-disc-drive fa-fw',
        'fa-regular fa-disc-drive fa-fw',
        'fa-light fa-disc-drive fa-fw',
        'fa-duotone fa-disc-drive fa-fw',
        'fa-thin fa-display fa-fw',
        'fa-solid fa-display fa-fw',
        'fa-sharp fa-solid fa-display fa-fw',
        'fa-sharp fa-regular fa-display fa-fw',
        'fa-sharp fa-light fa-display fa-fw',
        'fa-regular fa-display fa-fw',
        'fa-light fa-display fa-fw',
        'fa-duotone fa-display fa-fw',
        'fa-thin fa-display-arrow-down fa-fw',
        'fa-solid fa-display-arrow-down fa-fw',
        'fa-sharp fa-solid fa-display-arrow-down fa-fw',
        'fa-sharp fa-regular fa-display-arrow-down fa-fw',
        'fa-sharp fa-light fa-display-arrow-down fa-fw',
        'fa-regular fa-display-arrow-down fa-fw',
        'fa-light fa-display-arrow-down fa-fw',
        'fa-duotone fa-display-arrow-down fa-fw',
        'fa-thin fa-display-code fa-fw',
        'fa-solid fa-display-code fa-fw',
        'fa-sharp fa-solid fa-display-code fa-fw',
        'fa-sharp fa-regular fa-display-code fa-fw',
        'fa-sharp fa-light fa-display-code fa-fw',
        'fa-regular fa-display-code fa-fw',
        'fa-light fa-display-code fa-fw',
        'fa-duotone fa-display-code fa-fw',
        'fa-thin fa-display-medical fa-fw',
        'fa-solid fa-display-medical fa-fw',
        'fa-sharp fa-solid fa-display-medical fa-fw',
        'fa-sharp fa-regular fa-display-medical fa-fw',
        'fa-sharp fa-light fa-display-medical fa-fw',
        'fa-regular fa-display-medical fa-fw',
        'fa-light fa-display-medical fa-fw',
        'fa-duotone fa-display-medical fa-fw',
        'fa-thin fa-display-slash fa-fw',
        'fa-solid fa-display-slash fa-fw',
        'fa-sharp fa-solid fa-display-slash fa-fw',
        'fa-sharp fa-regular fa-display-slash fa-fw',
        'fa-sharp fa-light fa-display-slash fa-fw',
        'fa-regular fa-display-slash fa-fw',
        'fa-light fa-display-slash fa-fw',
        'fa-duotone fa-display-slash fa-fw',
        'fa-thin fa-download fa-fw',
        'fa-solid fa-download fa-fw',
        'fa-sharp fa-solid fa-download fa-fw',
        'fa-sharp fa-regular fa-download fa-fw',
        'fa-sharp fa-light fa-download fa-fw',
        'fa-regular fa-download fa-fw',
        'fa-light fa-download fa-fw',
        'fa-duotone fa-download fa-fw',
        'fa-thin fa-engine fa-fw',
        'fa-solid fa-engine fa-fw',
        'fa-sharp fa-solid fa-engine fa-fw',
        'fa-sharp fa-regular fa-engine fa-fw',
        'fa-sharp fa-light fa-engine fa-fw',
        'fa-regular fa-engine fa-fw',
        'fa-light fa-engine fa-fw',
        'fa-duotone fa-engine fa-fw',
        'fa-thin fa-ethernet fa-fw',
        'fa-solid fa-ethernet fa-fw',
        'fa-sharp fa-solid fa-ethernet fa-fw',
        'fa-sharp fa-regular fa-ethernet fa-fw',
        'fa-sharp fa-light fa-ethernet fa-fw',
        'fa-regular fa-ethernet fa-fw',
        'fa-light fa-ethernet fa-fw',
        'fa-duotone fa-ethernet fa-fw',
        'fa-thin fa-fax fa-fw',
        'fa-solid fa-fax fa-fw',
        'fa-sharp fa-solid fa-fax fa-fw',
        'fa-sharp fa-regular fa-fax fa-fw',
        'fa-sharp fa-light fa-fax fa-fw',
        'fa-regular fa-fax fa-fw',
        'fa-light fa-fax fa-fw',
        'fa-duotone fa-fax fa-fw',
        'fa-thin fa-flashlight fa-fw',
        'fa-solid fa-flashlight fa-fw',
        'fa-sharp fa-solid fa-flashlight fa-fw',
        'fa-sharp fa-regular fa-flashlight fa-fw',
        'fa-sharp fa-light fa-flashlight fa-fw',
        'fa-regular fa-flashlight fa-fw',
        'fa-light fa-flashlight fa-fw',
        'fa-duotone fa-flashlight fa-fw',
        'fa-thin fa-floppy-disk fa-fw',
        'fa-solid fa-floppy-disk fa-fw',
        'fa-sharp fa-solid fa-floppy-disk fa-fw',
        'fa-sharp fa-regular fa-floppy-disk fa-fw',
        'fa-sharp fa-light fa-floppy-disk fa-fw',
        'fa-regular fa-floppy-disk fa-fw',
        'fa-light fa-floppy-disk fa-fw',
        'fa-duotone fa-floppy-disk fa-fw',
        'fa-thin fa-floppy-disk-pen fa-fw',
        'fa-solid fa-floppy-disk-pen fa-fw',
        'fa-sharp fa-solid fa-floppy-disk-pen fa-fw',
        'fa-sharp fa-regular fa-floppy-disk-pen fa-fw',
        'fa-sharp fa-light fa-floppy-disk-pen fa-fw',
        'fa-regular fa-floppy-disk-pen fa-fw',
        'fa-light fa-floppy-disk-pen fa-fw',
        'fa-duotone fa-floppy-disk-pen fa-fw',
        'fa-thin fa-floppy-disks fa-fw',
        'fa-solid fa-floppy-disks fa-fw',
        'fa-sharp fa-solid fa-floppy-disks fa-fw',
        'fa-sharp fa-regular fa-floppy-disks fa-fw',
        'fa-sharp fa-light fa-floppy-disks fa-fw',
        'fa-regular fa-floppy-disks fa-fw',
        'fa-light fa-floppy-disks fa-fw',
        'fa-duotone fa-floppy-disks fa-fw',
        'fa-thin fa-flux-capacitor fa-fw',
        'fa-solid fa-flux-capacitor fa-fw',
        'fa-sharp fa-solid fa-flux-capacitor fa-fw',
        'fa-sharp fa-regular fa-flux-capacitor fa-fw',
        'fa-sharp fa-light fa-flux-capacitor fa-fw',
        'fa-regular fa-flux-capacitor fa-fw',
        'fa-light fa-flux-capacitor fa-fw',
        'fa-duotone fa-flux-capacitor fa-fw',
        'fa-thin fa-game-console-handheld fa-fw',
        'fa-solid fa-game-console-handheld fa-fw',
        'fa-sharp fa-solid fa-game-console-handheld fa-fw',
        'fa-sharp fa-regular fa-game-console-handheld fa-fw',
        'fa-sharp fa-light fa-game-console-handheld fa-fw',
        'fa-regular fa-game-console-handheld fa-fw',
        'fa-light fa-game-console-handheld fa-fw',
        'fa-duotone fa-game-console-handheld fa-fw',
        'fa-thin fa-game-console-handheld-crank fa-fw',
        'fa-solid fa-game-console-handheld-crank fa-fw',
        'fa-sharp fa-solid fa-game-console-handheld-crank fa-fw',
        'fa-sharp fa-regular fa-game-console-handheld-crank fa-fw',
        'fa-sharp fa-light fa-game-console-handheld-crank fa-fw',
        'fa-regular fa-game-console-handheld-crank fa-fw',
        'fa-light fa-game-console-handheld-crank fa-fw',
        'fa-duotone fa-game-console-handheld-crank fa-fw',
        'fa-thin fa-gamepad fa-fw',
        'fa-solid fa-gamepad fa-fw',
        'fa-sharp fa-solid fa-gamepad fa-fw',
        'fa-sharp fa-regular fa-gamepad fa-fw',
        'fa-sharp fa-light fa-gamepad fa-fw',
        'fa-regular fa-gamepad fa-fw',
        'fa-light fa-gamepad fa-fw',
        'fa-duotone fa-gamepad fa-fw',
        'fa-thin fa-gamepad-modern fa-fw',
        'fa-solid fa-gamepad-modern fa-fw',
        'fa-sharp fa-solid fa-gamepad-modern fa-fw',
        'fa-sharp fa-regular fa-gamepad-modern fa-fw',
        'fa-sharp fa-light fa-gamepad-modern fa-fw',
        'fa-regular fa-gamepad-modern fa-fw',
        'fa-light fa-gamepad-modern fa-fw',
        'fa-duotone fa-gamepad-modern fa-fw',
        'fa-thin fa-hard-drive fa-fw',
        'fa-solid fa-hard-drive fa-fw',
        'fa-sharp fa-solid fa-hard-drive fa-fw',
        'fa-sharp fa-regular fa-hard-drive fa-fw',
        'fa-sharp fa-light fa-hard-drive fa-fw',
        'fa-regular fa-hard-drive fa-fw',
        'fa-light fa-hard-drive fa-fw',
        'fa-duotone fa-hard-drive fa-fw',
        'fa-thin fa-headphones fa-fw',
        'fa-solid fa-headphones fa-fw',
        'fa-sharp fa-solid fa-headphones fa-fw',
        'fa-sharp fa-regular fa-headphones fa-fw',
        'fa-sharp fa-light fa-headphones fa-fw',
        'fa-regular fa-headphones fa-fw',
        'fa-light fa-headphones fa-fw',
        'fa-duotone fa-headphones fa-fw',
        'fa-thin fa-house-laptop fa-fw',
        'fa-solid fa-house-laptop fa-fw',
        'fa-sharp fa-solid fa-house-laptop fa-fw',
        'fa-sharp fa-regular fa-house-laptop fa-fw',
        'fa-sharp fa-light fa-house-laptop fa-fw',
        'fa-regular fa-house-laptop fa-fw',
        'fa-light fa-house-laptop fa-fw',
        'fa-duotone fa-house-laptop fa-fw',
        'fa-thin fa-keyboard fa-fw',
        'fa-solid fa-keyboard fa-fw',
        'fa-sharp fa-solid fa-keyboard fa-fw',
        'fa-sharp fa-regular fa-keyboard fa-fw',
        'fa-sharp fa-light fa-keyboard fa-fw',
        'fa-regular fa-keyboard fa-fw',
        'fa-light fa-keyboard fa-fw',
        'fa-duotone fa-keyboard fa-fw',
        'fa-thin fa-keyboard-down fa-fw',
        'fa-solid fa-keyboard-down fa-fw',
        'fa-sharp fa-solid fa-keyboard-down fa-fw',
        'fa-sharp fa-regular fa-keyboard-down fa-fw',
        'fa-sharp fa-light fa-keyboard-down fa-fw',
        'fa-regular fa-keyboard-down fa-fw',
        'fa-light fa-keyboard-down fa-fw',
        'fa-duotone fa-keyboard-down fa-fw',
        'fa-thin fa-keyboard-left fa-fw',
        'fa-solid fa-keyboard-left fa-fw',
        'fa-sharp fa-solid fa-keyboard-left fa-fw',
        'fa-sharp fa-regular fa-keyboard-left fa-fw',
        'fa-sharp fa-light fa-keyboard-left fa-fw',
        'fa-regular fa-keyboard-left fa-fw',
        'fa-light fa-keyboard-left fa-fw',
        'fa-duotone fa-keyboard-left fa-fw',
        'fa-thin fa-laptop fa-fw',
        'fa-solid fa-laptop fa-fw',
        'fa-sharp fa-solid fa-laptop fa-fw',
        'fa-sharp fa-regular fa-laptop fa-fw',
        'fa-sharp fa-light fa-laptop fa-fw',
        'fa-regular fa-laptop fa-fw',
        'fa-light fa-laptop fa-fw',
        'fa-duotone fa-laptop fa-fw',
        'fa-thin fa-laptop-arrow-down fa-fw',
        'fa-solid fa-laptop-arrow-down fa-fw',
        'fa-sharp fa-solid fa-laptop-arrow-down fa-fw',
        'fa-sharp fa-regular fa-laptop-arrow-down fa-fw',
        'fa-sharp fa-light fa-laptop-arrow-down fa-fw',
        'fa-regular fa-laptop-arrow-down fa-fw',
        'fa-light fa-laptop-arrow-down fa-fw',
        'fa-duotone fa-laptop-arrow-down fa-fw',
        'fa-thin fa-laptop-binary fa-fw',
        'fa-solid fa-laptop-binary fa-fw',
        'fa-sharp fa-solid fa-laptop-binary fa-fw',
        'fa-sharp fa-regular fa-laptop-binary fa-fw',
        'fa-sharp fa-light fa-laptop-binary fa-fw',
        'fa-regular fa-laptop-binary fa-fw',
        'fa-light fa-laptop-binary fa-fw',
        'fa-duotone fa-laptop-binary fa-fw',
        'fa-thin fa-laptop-file fa-fw',
        'fa-solid fa-laptop-file fa-fw',
        'fa-sharp fa-solid fa-laptop-file fa-fw',
        'fa-sharp fa-regular fa-laptop-file fa-fw',
        'fa-sharp fa-light fa-laptop-file fa-fw',
        'fa-regular fa-laptop-file fa-fw',
        'fa-light fa-laptop-file fa-fw',
        'fa-duotone fa-laptop-file fa-fw',
        'fa-thin fa-laptop-mobile fa-fw',
        'fa-solid fa-laptop-mobile fa-fw',
        'fa-sharp fa-solid fa-laptop-mobile fa-fw',
        'fa-sharp fa-regular fa-laptop-mobile fa-fw',
        'fa-sharp fa-light fa-laptop-mobile fa-fw',
        'fa-regular fa-laptop-mobile fa-fw',
        'fa-light fa-laptop-mobile fa-fw',
        'fa-duotone fa-laptop-mobile fa-fw',
        'fa-thin fa-laptop-slash fa-fw',
        'fa-solid fa-laptop-slash fa-fw',
        'fa-sharp fa-solid fa-laptop-slash fa-fw',
        'fa-sharp fa-regular fa-laptop-slash fa-fw',
        'fa-sharp fa-light fa-laptop-slash fa-fw',
        'fa-regular fa-laptop-slash fa-fw',
        'fa-light fa-laptop-slash fa-fw',
        'fa-duotone fa-laptop-slash fa-fw',
        'fa-thin fa-memory fa-fw',
        'fa-solid fa-memory fa-fw',
        'fa-sharp fa-solid fa-memory fa-fw',
        'fa-sharp fa-regular fa-memory fa-fw',
        'fa-sharp fa-light fa-memory fa-fw',
        'fa-regular fa-memory fa-fw',
        'fa-light fa-memory fa-fw',
        'fa-duotone fa-memory fa-fw',
        'fa-thin fa-meter fa-fw',
        'fa-solid fa-meter fa-fw',
        'fa-sharp fa-solid fa-meter fa-fw',
        'fa-sharp fa-regular fa-meter fa-fw',
        'fa-sharp fa-light fa-meter fa-fw',
        'fa-regular fa-meter fa-fw',
        'fa-light fa-meter fa-fw',
        'fa-duotone fa-meter fa-fw',
        'fa-thin fa-microchip fa-fw',
        'fa-solid fa-microchip fa-fw',
        'fa-sharp fa-solid fa-microchip fa-fw',
        'fa-sharp fa-regular fa-microchip fa-fw',
        'fa-sharp fa-light fa-microchip fa-fw',
        'fa-regular fa-microchip fa-fw',
        'fa-light fa-microchip fa-fw',
        'fa-duotone fa-microchip fa-fw',
        'fa-thin fa-microchip-ai fa-fw',
        'fa-solid fa-microchip-ai fa-fw',
        'fa-sharp fa-solid fa-microchip-ai fa-fw',
        'fa-sharp fa-regular fa-microchip-ai fa-fw',
        'fa-sharp fa-light fa-microchip-ai fa-fw',
        'fa-regular fa-microchip-ai fa-fw',
        'fa-light fa-microchip-ai fa-fw',
        'fa-duotone fa-microchip-ai fa-fw',
        'fa-thin fa-mobile fa-fw',
        'fa-solid fa-mobile fa-fw',
        'fa-sharp fa-solid fa-mobile fa-fw',
        'fa-sharp fa-regular fa-mobile fa-fw',
        'fa-sharp fa-light fa-mobile fa-fw',
        'fa-regular fa-mobile fa-fw',
        'fa-light fa-mobile fa-fw',
        'fa-duotone fa-mobile fa-fw',
        'fa-thin fa-mobile-button fa-fw',
        'fa-solid fa-mobile-button fa-fw',
        'fa-sharp fa-solid fa-mobile-button fa-fw',
        'fa-sharp fa-regular fa-mobile-button fa-fw',
        'fa-sharp fa-light fa-mobile-button fa-fw',
        'fa-regular fa-mobile-button fa-fw',
        'fa-light fa-mobile-button fa-fw',
        'fa-duotone fa-mobile-button fa-fw',
        'fa-thin fa-mobile-notch fa-fw',
        'fa-solid fa-mobile-notch fa-fw',
        'fa-sharp fa-solid fa-mobile-notch fa-fw',
        'fa-sharp fa-regular fa-mobile-notch fa-fw',
        'fa-sharp fa-light fa-mobile-notch fa-fw',
        'fa-regular fa-mobile-notch fa-fw',
        'fa-light fa-mobile-notch fa-fw',
        'fa-duotone fa-mobile-notch fa-fw',
        'fa-thin fa-mobile-retro fa-fw',
        'fa-solid fa-mobile-retro fa-fw',
        'fa-sharp fa-solid fa-mobile-retro fa-fw',
        'fa-sharp fa-regular fa-mobile-retro fa-fw',
        'fa-sharp fa-light fa-mobile-retro fa-fw',
        'fa-regular fa-mobile-retro fa-fw',
        'fa-light fa-mobile-retro fa-fw',
        'fa-duotone fa-mobile-retro fa-fw',
        'fa-thin fa-mobile-screen fa-fw',
        'fa-solid fa-mobile-screen fa-fw',
        'fa-sharp fa-solid fa-mobile-screen fa-fw',
        'fa-sharp fa-regular fa-mobile-screen fa-fw',
        'fa-sharp fa-light fa-mobile-screen fa-fw',
        'fa-regular fa-mobile-screen fa-fw',
        'fa-light fa-mobile-screen fa-fw',
        'fa-duotone fa-mobile-screen fa-fw',
        'fa-thin fa-mobile-screen-button fa-fw',
        'fa-solid fa-mobile-screen-button fa-fw',
        'fa-sharp fa-solid fa-mobile-screen-button fa-fw',
        'fa-sharp fa-regular fa-mobile-screen-button fa-fw',
        'fa-sharp fa-light fa-mobile-screen-button fa-fw',
        'fa-regular fa-mobile-screen-button fa-fw',
        'fa-light fa-mobile-screen-button fa-fw',
        'fa-duotone fa-mobile-screen-button fa-fw',
        'fa-thin fa-mobile-signal fa-fw',
        'fa-solid fa-mobile-signal fa-fw',
        'fa-sharp fa-solid fa-mobile-signal fa-fw',
        'fa-sharp fa-regular fa-mobile-signal fa-fw',
        'fa-sharp fa-light fa-mobile-signal fa-fw',
        'fa-regular fa-mobile-signal fa-fw',
        'fa-light fa-mobile-signal fa-fw',
        'fa-duotone fa-mobile-signal fa-fw',
        'fa-thin fa-mobile-signal-out fa-fw',
        'fa-solid fa-mobile-signal-out fa-fw',
        'fa-sharp fa-solid fa-mobile-signal-out fa-fw',
        'fa-sharp fa-regular fa-mobile-signal-out fa-fw',
        'fa-sharp fa-light fa-mobile-signal-out fa-fw',
        'fa-regular fa-mobile-signal-out fa-fw',
        'fa-light fa-mobile-signal-out fa-fw',
        'fa-duotone fa-mobile-signal-out fa-fw',
        'fa-thin fa-mp3-player fa-fw',
        'fa-solid fa-mp3-player fa-fw',
        'fa-sharp fa-solid fa-mp3-player fa-fw',
        'fa-sharp fa-regular fa-mp3-player fa-fw',
        'fa-sharp fa-light fa-mp3-player fa-fw',
        'fa-regular fa-mp3-player fa-fw',
        'fa-light fa-mp3-player fa-fw',
        'fa-duotone fa-mp3-player fa-fw',
        'fa-thin fa-phone-office fa-fw',
        'fa-solid fa-phone-office fa-fw',
        'fa-sharp fa-solid fa-phone-office fa-fw',
        'fa-sharp fa-regular fa-phone-office fa-fw',
        'fa-sharp fa-light fa-phone-office fa-fw',
        'fa-regular fa-phone-office fa-fw',
        'fa-light fa-phone-office fa-fw',
        'fa-duotone fa-phone-office fa-fw',
        'fa-thin fa-plug fa-fw',
        'fa-solid fa-plug fa-fw',
        'fa-sharp fa-solid fa-plug fa-fw',
        'fa-sharp fa-regular fa-plug fa-fw',
        'fa-sharp fa-light fa-plug fa-fw',
        'fa-regular fa-plug fa-fw',
        'fa-light fa-plug fa-fw',
        'fa-duotone fa-plug fa-fw',
        'fa-thin fa-power-off fa-fw',
        'fa-solid fa-power-off fa-fw',
        'fa-sharp fa-solid fa-power-off fa-fw',
        'fa-sharp fa-regular fa-power-off fa-fw',
        'fa-sharp fa-light fa-power-off fa-fw',
        'fa-regular fa-power-off fa-fw',
        'fa-light fa-power-off fa-fw',
        'fa-duotone fa-power-off fa-fw',
        'fa-thin fa-print fa-fw',
        'fa-solid fa-print fa-fw',
        'fa-sharp fa-solid fa-print fa-fw',
        'fa-sharp fa-regular fa-print fa-fw',
        'fa-sharp fa-light fa-print fa-fw',
        'fa-regular fa-print fa-fw',
        'fa-light fa-print fa-fw',
        'fa-duotone fa-print fa-fw',
        'fa-thin fa-projector fa-fw',
        'fa-solid fa-projector fa-fw',
        'fa-sharp fa-solid fa-projector fa-fw',
        'fa-sharp fa-regular fa-projector fa-fw',
        'fa-sharp fa-light fa-projector fa-fw',
        'fa-regular fa-projector fa-fw',
        'fa-light fa-projector fa-fw',
        'fa-duotone fa-projector fa-fw',
        'fa-thin fa-router fa-fw',
        'fa-solid fa-router fa-fw',
        'fa-sharp fa-solid fa-router fa-fw',
        'fa-sharp fa-regular fa-router fa-fw',
        'fa-sharp fa-light fa-router fa-fw',
        'fa-regular fa-router fa-fw',
        'fa-light fa-router fa-fw',
        'fa-duotone fa-router fa-fw',
        'fa-thin fa-satellite fa-fw',
        'fa-solid fa-satellite fa-fw',
        'fa-sharp fa-solid fa-satellite fa-fw',
        'fa-sharp fa-regular fa-satellite fa-fw',
        'fa-sharp fa-light fa-satellite fa-fw',
        'fa-regular fa-satellite fa-fw',
        'fa-light fa-satellite fa-fw',
        'fa-duotone fa-satellite fa-fw',
        'fa-thin fa-satellite-dish fa-fw',
        'fa-solid fa-satellite-dish fa-fw',
        'fa-sharp fa-solid fa-satellite-dish fa-fw',
        'fa-sharp fa-regular fa-satellite-dish fa-fw',
        'fa-sharp fa-light fa-satellite-dish fa-fw',
        'fa-regular fa-satellite-dish fa-fw',
        'fa-light fa-satellite-dish fa-fw',
        'fa-duotone fa-satellite-dish fa-fw',
        'fa-thin fa-scanner-image fa-fw',
        'fa-solid fa-scanner-image fa-fw',
        'fa-sharp fa-solid fa-scanner-image fa-fw',
        'fa-sharp fa-regular fa-scanner-image fa-fw',
        'fa-sharp fa-light fa-scanner-image fa-fw',
        'fa-regular fa-scanner-image fa-fw',
        'fa-light fa-scanner-image fa-fw',
        'fa-duotone fa-scanner-image fa-fw',
        'fa-thin fa-sd-card fa-fw',
        'fa-solid fa-sd-card fa-fw',
        'fa-sharp fa-solid fa-sd-card fa-fw',
        'fa-sharp fa-regular fa-sd-card fa-fw',
        'fa-sharp fa-light fa-sd-card fa-fw',
        'fa-regular fa-sd-card fa-fw',
        'fa-light fa-sd-card fa-fw',
        'fa-duotone fa-sd-card fa-fw',
        'fa-thin fa-sd-cards fa-fw',
        'fa-solid fa-sd-cards fa-fw',
        'fa-sharp fa-solid fa-sd-cards fa-fw',
        'fa-sharp fa-regular fa-sd-cards fa-fw',
        'fa-sharp fa-light fa-sd-cards fa-fw',
        'fa-regular fa-sd-cards fa-fw',
        'fa-light fa-sd-cards fa-fw',
        'fa-duotone fa-sd-cards fa-fw',
        'fa-thin fa-server fa-fw',
        'fa-solid fa-server fa-fw',
        'fa-sharp fa-solid fa-server fa-fw',
        'fa-sharp fa-regular fa-server fa-fw',
        'fa-sharp fa-light fa-server fa-fw',
        'fa-regular fa-server fa-fw',
        'fa-light fa-server fa-fw',
        'fa-duotone fa-server fa-fw',
        'fa-thin fa-shredder fa-fw',
        'fa-solid fa-shredder fa-fw',
        'fa-sharp fa-solid fa-shredder fa-fw',
        'fa-sharp fa-regular fa-shredder fa-fw',
        'fa-sharp fa-light fa-shredder fa-fw',
        'fa-regular fa-shredder fa-fw',
        'fa-light fa-shredder fa-fw',
        'fa-duotone fa-shredder fa-fw',
        'fa-thin fa-sim-card fa-fw',
        'fa-solid fa-sim-card fa-fw',
        'fa-sharp fa-solid fa-sim-card fa-fw',
        'fa-sharp fa-regular fa-sim-card fa-fw',
        'fa-sharp fa-light fa-sim-card fa-fw',
        'fa-regular fa-sim-card fa-fw',
        'fa-light fa-sim-card fa-fw',
        'fa-duotone fa-sim-card fa-fw',
        'fa-thin fa-sim-cards fa-fw',
        'fa-solid fa-sim-cards fa-fw',
        'fa-sharp fa-solid fa-sim-cards fa-fw',
        'fa-sharp fa-regular fa-sim-cards fa-fw',
        'fa-sharp fa-light fa-sim-cards fa-fw',
        'fa-regular fa-sim-cards fa-fw',
        'fa-light fa-sim-cards fa-fw',
        'fa-duotone fa-sim-cards fa-fw',
        'fa-thin fa-speaker fa-fw',
        'fa-solid fa-speaker fa-fw',
        'fa-sharp fa-solid fa-speaker fa-fw',
        'fa-sharp fa-regular fa-speaker fa-fw',
        'fa-sharp fa-light fa-speaker fa-fw',
        'fa-regular fa-speaker fa-fw',
        'fa-light fa-speaker fa-fw',
        'fa-duotone fa-speaker fa-fw',
        'fa-thin fa-speakers fa-fw',
        'fa-solid fa-speakers fa-fw',
        'fa-sharp fa-solid fa-speakers fa-fw',
        'fa-sharp fa-regular fa-speakers fa-fw',
        'fa-sharp fa-light fa-speakers fa-fw',
        'fa-regular fa-speakers fa-fw',
        'fa-light fa-speakers fa-fw',
        'fa-duotone fa-speakers fa-fw',
        'fa-thin fa-tablet fa-fw',
        'fa-solid fa-tablet fa-fw',
        'fa-sharp fa-solid fa-tablet fa-fw',
        'fa-sharp fa-regular fa-tablet fa-fw',
        'fa-sharp fa-light fa-tablet fa-fw',
        'fa-regular fa-tablet fa-fw',
        'fa-light fa-tablet fa-fw',
        'fa-duotone fa-tablet fa-fw',
        'fa-thin fa-tablet-button fa-fw',
        'fa-solid fa-tablet-button fa-fw',
        'fa-sharp fa-solid fa-tablet-button fa-fw',
        'fa-sharp fa-regular fa-tablet-button fa-fw',
        'fa-sharp fa-light fa-tablet-button fa-fw',
        'fa-regular fa-tablet-button fa-fw',
        'fa-light fa-tablet-button fa-fw',
        'fa-duotone fa-tablet-button fa-fw',
        'fa-thin fa-tablet-screen fa-fw',
        'fa-solid fa-tablet-screen fa-fw',
        'fa-sharp fa-solid fa-tablet-screen fa-fw',
        'fa-sharp fa-regular fa-tablet-screen fa-fw',
        'fa-sharp fa-light fa-tablet-screen fa-fw',
        'fa-regular fa-tablet-screen fa-fw',
        'fa-light fa-tablet-screen fa-fw',
        'fa-duotone fa-tablet-screen fa-fw',
        'fa-thin fa-tablet-screen-button fa-fw',
        'fa-solid fa-tablet-screen-button fa-fw',
        'fa-sharp fa-solid fa-tablet-screen-button fa-fw',
        'fa-sharp fa-regular fa-tablet-screen-button fa-fw',
        'fa-sharp fa-light fa-tablet-screen-button fa-fw',
        'fa-regular fa-tablet-screen-button fa-fw',
        'fa-light fa-tablet-screen-button fa-fw',
        'fa-duotone fa-tablet-screen-button fa-fw',
        'fa-thin fa-tachograph-digital fa-fw',
        'fa-solid fa-tachograph-digital fa-fw',
        'fa-sharp fa-solid fa-tachograph-digital fa-fw',
        'fa-sharp fa-regular fa-tachograph-digital fa-fw',
        'fa-sharp fa-light fa-tachograph-digital fa-fw',
        'fa-regular fa-tachograph-digital fa-fw',
        'fa-light fa-tachograph-digital fa-fw',
        'fa-duotone fa-tachograph-digital fa-fw',
        'fa-thin fa-tv fa-fw',
        'fa-solid fa-tv fa-fw',
        'fa-sharp fa-solid fa-tv fa-fw',
        'fa-sharp fa-regular fa-tv fa-fw',
        'fa-sharp fa-light fa-tv fa-fw',
        'fa-regular fa-tv fa-fw',
        'fa-light fa-tv fa-fw',
        'fa-duotone fa-tv fa-fw',
        'fa-thin fa-tv-music fa-fw',
        'fa-solid fa-tv-music fa-fw',
        'fa-sharp fa-solid fa-tv-music fa-fw',
        'fa-sharp fa-regular fa-tv-music fa-fw',
        'fa-sharp fa-light fa-tv-music fa-fw',
        'fa-regular fa-tv-music fa-fw',
        'fa-light fa-tv-music fa-fw',
        'fa-duotone fa-tv-music fa-fw',
        'fa-thin fa-tv-retro fa-fw',
        'fa-solid fa-tv-retro fa-fw',
        'fa-sharp fa-solid fa-tv-retro fa-fw',
        'fa-sharp fa-regular fa-tv-retro fa-fw',
        'fa-sharp fa-light fa-tv-retro fa-fw',
        'fa-regular fa-tv-retro fa-fw',
        'fa-light fa-tv-retro fa-fw',
        'fa-duotone fa-tv-retro fa-fw',
        'fa-thin fa-typewriter fa-fw',
        'fa-solid fa-typewriter fa-fw',
        'fa-sharp fa-solid fa-typewriter fa-fw',
        'fa-sharp fa-regular fa-typewriter fa-fw',
        'fa-sharp fa-light fa-typewriter fa-fw',
        'fa-regular fa-typewriter fa-fw',
        'fa-light fa-typewriter fa-fw',
        'fa-duotone fa-typewriter fa-fw',
        'fa-thin fa-upload fa-fw',
        'fa-solid fa-upload fa-fw',
        'fa-sharp fa-solid fa-upload fa-fw',
        'fa-sharp fa-regular fa-upload fa-fw',
        'fa-sharp fa-light fa-upload fa-fw',
        'fa-regular fa-upload fa-fw',
        'fa-light fa-upload fa-fw',
        'fa-duotone fa-upload fa-fw',
        'fa-thin fa-usb-drive fa-fw',
        'fa-solid fa-usb-drive fa-fw',
        'fa-sharp fa-solid fa-usb-drive fa-fw',
        'fa-sharp fa-regular fa-usb-drive fa-fw',
        'fa-sharp fa-light fa-usb-drive fa-fw',
        'fa-regular fa-usb-drive fa-fw',
        'fa-light fa-usb-drive fa-fw',
        'fa-duotone fa-usb-drive fa-fw',
        'fa-thin fa-walkie-talkie fa-fw',
        'fa-solid fa-walkie-talkie fa-fw',
        'fa-sharp fa-solid fa-walkie-talkie fa-fw',
        'fa-sharp fa-regular fa-walkie-talkie fa-fw',
        'fa-sharp fa-light fa-walkie-talkie fa-fw',
        'fa-regular fa-walkie-talkie fa-fw',
        'fa-light fa-walkie-talkie fa-fw',
        'fa-duotone fa-walkie-talkie fa-fw',
        'fa-thin fa-watch-calculator fa-fw',
        'fa-solid fa-watch-calculator fa-fw',
        'fa-sharp fa-solid fa-watch-calculator fa-fw',
        'fa-sharp fa-regular fa-watch-calculator fa-fw',
        'fa-sharp fa-light fa-watch-calculator fa-fw',
        'fa-regular fa-watch-calculator fa-fw',
        'fa-light fa-watch-calculator fa-fw',
        'fa-duotone fa-watch-calculator fa-fw',
      ],
    },

    {
      title: 'Editors',
      items: [
        'fas fa-align-center',
        'fas fa-align-justify',
        'fas fa-align-left',
        'fas fa-align-right',
        'fas fa-bold',
        'fas fa-clipboard',
        'far fa-clipboard',
        'fas fa-clone',
        'far fa-clone',
        'fas fa-columns',
        'fas fa-copy',
        'far fa-copy',
        'fas fa-cut',
        'fas fa-edit',
        'far fa-edit',
        'fas fa-eraser',
        'fas fa-file',
        'far fa-file',
        'fas fa-file-alt',
        'far fa-file-alt',
        'fas fa-font',
        'fas fa-heading',
        'fas fa-i-cursor',
        'fas fa-indent',
        'fas fa-italic',
        'fas fa-link',
        'fas fa-list',
        'fas fa-list-alt',
        'far fa-list-alt',
        'fas fa-list-ol',
        'fas fa-list-ul',
        'fas fa-outdent',
        'fas fa-paper-plane',
        'far fa-paper-plane',
        'fas fa-paperclip',
        'fas fa-paragraph',
        'fas fa-paste',
        'fas fa-pencil-alt',
        'fas fa-print',
        'fas fa-quote-left',
        'fas fa-quote-right',
        'fas fa-redo',
        'fas fa-redo-alt',
        'fas fa-reply',
        'fas fa-reply-all',
        'fas fa-share',
        'fas fa-strikethrough',
        'fas fa-subscript',
        'fas fa-superscript',
        'fas fa-sync',
        'fas fa-sync-alt',
        'fas fa-table',
        'fas fa-tasks',
        'fas fa-text-height',
        'fas fa-text-width',
        'fas fa-th',
        'fas fa-th-large',
        'fas fa-th-list',
        'fas fa-trash',
        'fas fa-trash-alt',
        'far fa-trash-alt',
        'fas fa-underline',
        'fas fa-undo',
        'fas fa-undo-alt',
        'fas fa-unlink',
      ],
    },
    {
      title: 'Files',
      items: [
        'fas fa-archive',
        'fas fa-clone',
        'far fa-clone',
        'fas fa-copy',
        'far fa-copy',
        'fas fa-cut',
        'fas fa-file',
        'far fa-file',
        'fas fa-file-alt',
        'far fa-file-alt',
        'fas fa-file-archive',
        'far fa-file-archive',
        'fas fa-file-audio',
        'far fa-file-audio',
        'fas fa-file-code',
        'far fa-file-code',
        'fas fa-file-excel',
        'far fa-file-excel',
        'fas fa-file-image',
        'far fa-file-image',
        'fas fa-file-pdf',
        'far fa-file-pdf',
        'fas fa-file-powerpoint',
        'far fa-file-powerpoint',
        'fas fa-file-video',
        'far fa-file-video',
        'fas fa-file-word',
        'far fa-file-word',
        'fas fa-folder',
        'far fa-folder',
        'fas fa-folder-open',
        'far fa-folder-open',
        'fas fa-paste',
        'fas fa-save',
        'far fa-save',
        'fas fa-sticky-note',
        'far fa-sticky-note',
      ],
    },
    {
      title: 'Genders',
      items: [
        'fas fa-genderless',
        'fas fa-mars',
        'fas fa-mars-double',
        'fas fa-mars-stroke',
        'fas fa-mars-stroke-h',
        'fas fa-mars-stroke-v',
        'fas fa-mercury',
        'fas fa-neuter',
        'fas fa-transgender',
        'fas fa-transgender-alt',
        'fas fa-venus',
        'fas fa-venus-double',
        'fas fa-venus-mars',
      ],
    },

    {
      title: 'Education',
      items: [
        'fa-thin fa-apple-whole fa-fw',
        'fa-solid fa-apple-whole fa-fw',
        'fa-sharp fa-solid fa-apple-whole fa-fw',
        'fa-sharp fa-regular fa-apple-whole fa-fw',
        'fa-sharp fa-light fa-apple-whole fa-fw',
        'fa-regular fa-apple-whole fa-fw',
        'fa-light fa-apple-whole fa-fw',
        'fa-duotone fa-apple-whole fa-fw',
        'fa-thin fa-atom fa-fw',
        'fa-solid fa-atom fa-fw',
        'fa-sharp fa-solid fa-atom fa-fw',
        'fa-sharp fa-regular fa-atom fa-fw',
        'fa-sharp fa-light fa-atom fa-fw',
        'fa-regular fa-atom fa-fw',
        'fa-light fa-atom fa-fw',
        'fa-duotone fa-atom fa-fw',
        'fa-thin fa-atom-simple fa-fw',
        'fa-solid fa-atom-simple fa-fw',
        'fa-sharp fa-solid fa-atom-simple fa-fw',
        'fa-sharp fa-regular fa-atom-simple fa-fw',
        'fa-sharp fa-light fa-atom-simple fa-fw',
        'fa-regular fa-atom-simple fa-fw',
        'fa-light fa-atom-simple fa-fw',
        'fa-duotone fa-atom-simple fa-fw',
        'fa-thin fa-award fa-fw',
        'fa-solid fa-award fa-fw',
        'fa-sharp fa-solid fa-award fa-fw',
        'fa-sharp fa-regular fa-award fa-fw',
        'fa-sharp fa-light fa-award fa-fw',
        'fa-regular fa-award fa-fw',
        'fa-light fa-award fa-fw',
        'fa-duotone fa-award fa-fw',
        'fa-thin fa-backpack fa-fw',
        'fa-solid fa-backpack fa-fw',
        'fa-sharp fa-solid fa-backpack fa-fw',
        'fa-sharp fa-regular fa-backpack fa-fw',
        'fa-sharp fa-light fa-backpack fa-fw',
        'fa-regular fa-backpack fa-fw',
        'fa-light fa-backpack fa-fw',
        'fa-duotone fa-backpack fa-fw',
        'fa-thin fa-bell fa-fw',
        'fa-solid fa-bell fa-fw',
        'fa-sharp fa-solid fa-bell fa-fw',
        'fa-sharp fa-regular fa-bell fa-fw',
        'fa-sharp fa-light fa-bell fa-fw',
        'fa-regular fa-bell fa-fw',
        'fa-light fa-bell fa-fw',
        'fa-duotone fa-bell fa-fw',
        'fa-thin fa-bell-school fa-fw',
        'fa-solid fa-bell-school fa-fw',
        'fa-sharp fa-solid fa-bell-school fa-fw',
        'fa-sharp fa-regular fa-bell-school fa-fw',
        'fa-sharp fa-light fa-bell-school fa-fw',
        'fa-regular fa-bell-school fa-fw',
        'fa-light fa-bell-school fa-fw',
        'fa-duotone fa-bell-school fa-fw',
        'fa-thin fa-bell-school-slash fa-fw',
        'fa-solid fa-bell-school-slash fa-fw',
        'fa-sharp fa-solid fa-bell-school-slash fa-fw',
        'fa-sharp fa-regular fa-bell-school-slash fa-fw',
        'fa-sharp fa-light fa-bell-school-slash fa-fw',
        'fa-regular fa-bell-school-slash fa-fw',
        'fa-light fa-bell-school-slash fa-fw',
        'fa-duotone fa-bell-school-slash fa-fw',
        'fa-thin fa-bell-slash fa-fw',
        'fa-solid fa-bell-slash fa-fw',
        'fa-sharp fa-solid fa-bell-slash fa-fw',
        'fa-sharp fa-regular fa-bell-slash fa-fw',
        'fa-sharp fa-light fa-bell-slash fa-fw',
        'fa-regular fa-bell-slash fa-fw',
        'fa-light fa-bell-slash fa-fw',
        'fa-duotone fa-bell-slash fa-fw',
        'fa-thin fa-book-blank fa-fw',
        'fa-solid fa-book-blank fa-fw',
        'fa-sharp fa-solid fa-book-blank fa-fw',
        'fa-sharp fa-regular fa-book-blank fa-fw',
        'fa-sharp fa-light fa-book-blank fa-fw',
        'fa-regular fa-book-blank fa-fw',
        'fa-light fa-book-blank fa-fw',
        'fa-duotone fa-book-blank fa-fw',
        'fa-thin fa-book-copy fa-fw',
        'fa-solid fa-book-copy fa-fw',
        'fa-sharp fa-solid fa-book-copy fa-fw',
        'fa-sharp fa-regular fa-book-copy fa-fw',
        'fa-sharp fa-light fa-book-copy fa-fw',
        'fa-regular fa-book-copy fa-fw',
        'fa-light fa-book-copy fa-fw',
        'fa-duotone fa-book-copy fa-fw',
        'fa-thin fa-book-open fa-fw',
        'fa-solid fa-book-open fa-fw',
        'fa-sharp fa-solid fa-book-open fa-fw',
        'fa-sharp fa-regular fa-book-open fa-fw',
        'fa-sharp fa-light fa-book-open fa-fw',
        'fa-regular fa-book-open fa-fw',
        'fa-light fa-book-open fa-fw',
        'fa-duotone fa-book-open fa-fw',
        'fa-thin fa-book-open-cover fa-fw',
        'fa-solid fa-book-open-cover fa-fw',
        'fa-sharp fa-solid fa-book-open-cover fa-fw',
        'fa-sharp fa-regular fa-book-open-cover fa-fw',
        'fa-sharp fa-light fa-book-open-cover fa-fw',
        'fa-regular fa-book-open-cover fa-fw',
        'fa-light fa-book-open-cover fa-fw',
        'fa-duotone fa-book-open-cover fa-fw',
        'fa-thin fa-book-open-reader fa-fw',
        'fa-solid fa-book-open-reader fa-fw',
        'fa-sharp fa-solid fa-book-open-reader fa-fw',
        'fa-sharp fa-regular fa-book-open-reader fa-fw',
        'fa-sharp fa-light fa-book-open-reader fa-fw',
        'fa-regular fa-book-open-reader fa-fw',
        'fa-light fa-book-open-reader fa-fw',
        'fa-duotone fa-book-open-reader fa-fw',
        'fa-thin fa-books fa-fw',
        'fa-solid fa-books fa-fw',
        'fa-sharp fa-solid fa-books fa-fw',
        'fa-sharp fa-regular fa-books fa-fw',
        'fa-sharp fa-light fa-books fa-fw',
        'fa-regular fa-books fa-fw',
        'fa-light fa-books fa-fw',
        'fa-duotone fa-books fa-fw',
        'fa-thin fa-bus-school fa-fw',
        'fa-solid fa-bus-school fa-fw',
        'fa-sharp fa-solid fa-bus-school fa-fw',
        'fa-sharp fa-regular fa-bus-school fa-fw',
        'fa-sharp fa-light fa-bus-school fa-fw',
        'fa-regular fa-bus-school fa-fw',
        'fa-light fa-bus-school fa-fw',
        'fa-duotone fa-bus-school fa-fw',
        'fa-thin fa-chalkboard fa-fw',
        'fa-solid fa-chalkboard fa-fw',
        'fa-sharp fa-solid fa-chalkboard fa-fw',
        'fa-sharp fa-regular fa-chalkboard fa-fw',
        'fa-sharp fa-light fa-chalkboard fa-fw',
        'fa-regular fa-chalkboard fa-fw',
        'fa-light fa-chalkboard fa-fw',
        'fa-duotone fa-chalkboard fa-fw',
        'fa-thin fa-chalkboard-user fa-fw',
        'fa-solid fa-chalkboard-user fa-fw',
        'fa-sharp fa-solid fa-chalkboard-user fa-fw',
        'fa-sharp fa-regular fa-chalkboard-user fa-fw',
        'fa-sharp fa-light fa-chalkboard-user fa-fw',
        'fa-regular fa-chalkboard-user fa-fw',
        'fa-light fa-chalkboard-user fa-fw',
        'fa-duotone fa-chalkboard-user fa-fw',
        'fa-thin fa-diploma fa-fw',
        'fa-solid fa-diploma fa-fw',
        'fa-sharp fa-solid fa-diploma fa-fw',
        'fa-sharp fa-regular fa-diploma fa-fw',
        'fa-sharp fa-light fa-diploma fa-fw',
        'fa-regular fa-diploma fa-fw',
        'fa-light fa-diploma fa-fw',
        'fa-duotone fa-diploma fa-fw',
        'fa-thin fa-file-certificate fa-fw',
        'fa-solid fa-file-certificate fa-fw',
        'fa-sharp fa-solid fa-file-certificate fa-fw',
        'fa-sharp fa-regular fa-file-certificate fa-fw',
        'fa-sharp fa-light fa-file-certificate fa-fw',
        'fa-regular fa-file-certificate fa-fw',
        'fa-light fa-file-certificate fa-fw',
        'fa-duotone fa-file-certificate fa-fw',
        'fa-thin fa-glasses-round fa-fw',
        'fa-solid fa-glasses-round fa-fw',
        'fa-sharp fa-solid fa-glasses-round fa-fw',
        'fa-sharp fa-regular fa-glasses-round fa-fw',
        'fa-sharp fa-light fa-glasses-round fa-fw',
        'fa-regular fa-glasses-round fa-fw',
        'fa-light fa-glasses-round fa-fw',
        'fa-duotone fa-glasses-round fa-fw',
        'fa-thin fa-globe-stand fa-fw',
        'fa-solid fa-globe-stand fa-fw',
        'fa-sharp fa-solid fa-globe-stand fa-fw',
        'fa-sharp fa-regular fa-globe-stand fa-fw',
        'fa-sharp fa-light fa-globe-stand fa-fw',
        'fa-regular fa-globe-stand fa-fw',
        'fa-light fa-globe-stand fa-fw',
        'fa-duotone fa-globe-stand fa-fw',
        'fa-thin fa-graduation-cap fa-fw',
        'fa-solid fa-graduation-cap fa-fw',
        'fa-sharp fa-solid fa-graduation-cap fa-fw',
        'fa-sharp fa-regular fa-graduation-cap fa-fw',
        'fa-sharp fa-light fa-graduation-cap fa-fw',
        'fa-regular fa-graduation-cap fa-fw',
        'fa-light fa-graduation-cap fa-fw',
        'fa-duotone fa-graduation-cap fa-fw',
        'fa-thin fa-laptop-code fa-fw',
        'fa-solid fa-laptop-code fa-fw',
        'fa-sharp fa-solid fa-laptop-code fa-fw',
        'fa-sharp fa-regular fa-laptop-code fa-fw',
        'fa-sharp fa-light fa-laptop-code fa-fw',
        'fa-regular fa-laptop-code fa-fw',
        'fa-light fa-laptop-code fa-fw',
        'fa-duotone fa-laptop-code fa-fw',
        'fa-thin fa-laptop-file fa-fw',
        'fa-solid fa-laptop-file fa-fw',
        'fa-sharp fa-solid fa-laptop-file fa-fw',
        'fa-sharp fa-regular fa-laptop-file fa-fw',
        'fa-sharp fa-light fa-laptop-file fa-fw',
        'fa-regular fa-laptop-file fa-fw',
        'fa-light fa-laptop-file fa-fw',
        'fa-duotone fa-laptop-file fa-fw',
        'fa-thin fa-masks-theater fa-fw',
        'fa-solid fa-masks-theater fa-fw',
        'fa-sharp fa-solid fa-masks-theater fa-fw',
        'fa-sharp fa-regular fa-masks-theater fa-fw',
        'fa-sharp fa-light fa-masks-theater fa-fw',
        'fa-regular fa-masks-theater fa-fw',
        'fa-light fa-masks-theater fa-fw',
        'fa-duotone fa-masks-theater fa-fw',
        'fa-thin fa-microscope fa-fw',
        'fa-solid fa-microscope fa-fw',
        'fa-sharp fa-solid fa-microscope fa-fw',
        'fa-sharp fa-regular fa-microscope fa-fw',
        'fa-sharp fa-light fa-microscope fa-fw',
        'fa-regular fa-microscope fa-fw',
        'fa-light fa-microscope fa-fw',
        'fa-duotone fa-microscope fa-fw',
        'fa-thin fa-music fa-fw',
        'fa-solid fa-music fa-fw',
        'fa-sharp fa-solid fa-music fa-fw',
        'fa-sharp fa-regular fa-music fa-fw',
        'fa-sharp fa-light fa-music fa-fw',
        'fa-regular fa-music fa-fw',
        'fa-light fa-music fa-fw',
        'fa-duotone fa-music fa-fw',
        'fa-thin fa-pen-paintbrush fa-fw',
        'fa-solid fa-pen-paintbrush fa-fw',
        'fa-sharp fa-solid fa-pen-paintbrush fa-fw',
        'fa-sharp fa-regular fa-pen-paintbrush fa-fw',
        'fa-sharp fa-light fa-pen-paintbrush fa-fw',
        'fa-regular fa-pen-paintbrush fa-fw',
        'fa-light fa-pen-paintbrush fa-fw',
        'fa-duotone fa-pen-paintbrush fa-fw',
        'fa-thin fa-person-chalkboard fa-fw',
        'fa-solid fa-person-chalkboard fa-fw',
        'fa-sharp fa-solid fa-person-chalkboard fa-fw',
        'fa-sharp fa-regular fa-person-chalkboard fa-fw',
        'fa-sharp fa-light fa-person-chalkboard fa-fw',
        'fa-regular fa-person-chalkboard fa-fw',
        'fa-light fa-person-chalkboard fa-fw',
        'fa-duotone fa-person-chalkboard fa-fw',
        'fa-thin fa-ruler-triangle fa-fw',
        'fa-solid fa-ruler-triangle fa-fw',
        'fa-sharp fa-solid fa-ruler-triangle fa-fw',
        'fa-sharp fa-regular fa-ruler-triangle fa-fw',
        'fa-sharp fa-light fa-ruler-triangle fa-fw',
        'fa-regular fa-ruler-triangle fa-fw',
        'fa-light fa-ruler-triangle fa-fw',
        'fa-duotone fa-ruler-triangle fa-fw',
        'fa-thin fa-school fa-fw',
        'fa-solid fa-school fa-fw',
        'fa-sharp fa-solid fa-school fa-fw',
        'fa-sharp fa-regular fa-school fa-fw',
        'fa-sharp fa-light fa-school fa-fw',
        'fa-regular fa-school fa-fw',
        'fa-light fa-school fa-fw',
        'fa-duotone fa-school fa-fw',
        'fa-thin fa-school-circle-check fa-fw',
        'fa-solid fa-school-circle-check fa-fw',
        'fa-sharp fa-solid fa-school-circle-check fa-fw',
        'fa-sharp fa-regular fa-school-circle-check fa-fw',
        'fa-sharp fa-light fa-school-circle-check fa-fw',
        'fa-regular fa-school-circle-check fa-fw',
        'fa-light fa-school-circle-check fa-fw',
        'fa-duotone fa-school-circle-check fa-fw',
        'fa-thin fa-school-circle-exclamation fa-fw',
        'fa-solid fa-school-circle-exclamation fa-fw',
        'fa-sharp fa-solid fa-school-circle-exclamation fa-fw',
        'fa-sharp fa-regular fa-school-circle-exclamation fa-fw',
        'fa-sharp fa-light fa-school-circle-exclamation fa-fw',
        'fa-regular fa-school-circle-exclamation fa-fw',
        'fa-light fa-school-circle-exclamation fa-fw',
        'fa-duotone fa-school-circle-exclamation fa-fw',
        'fa-thin fa-school-circle-xmark fa-fw',
        'fa-solid fa-school-circle-xmark fa-fw',
        'fa-sharp fa-solid fa-school-circle-xmark fa-fw',
        'fa-sharp fa-regular fa-school-circle-xmark fa-fw',
        'fa-sharp fa-light fa-school-circle-xmark fa-fw',
        'fa-regular fa-school-circle-xmark fa-fw',
        'fa-light fa-school-circle-xmark fa-fw',
        'fa-duotone fa-school-circle-xmark fa-fw',
        'fa-thin fa-school-flag fa-fw',
        'fa-solid fa-school-flag fa-fw',
        'fa-sharp fa-solid fa-school-flag fa-fw',
        'fa-sharp fa-regular fa-school-flag fa-fw',
        'fa-sharp fa-light fa-school-flag fa-fw',
        'fa-regular fa-school-flag fa-fw',
        'fa-light fa-school-flag fa-fw',
        'fa-duotone fa-school-flag fa-fw',
        'fa-thin fa-school-lock fa-fw',
        'fa-solid fa-school-lock fa-fw',
        'fa-sharp fa-solid fa-school-lock fa-fw',
        'fa-sharp fa-regular fa-school-lock fa-fw',
        'fa-sharp fa-light fa-school-lock fa-fw',
        'fa-regular fa-school-lock fa-fw',
        'fa-light fa-school-lock fa-fw',
        'fa-duotone fa-school-lock fa-fw',
        'fa-thin fa-screen-users fa-fw',
        'fa-solid fa-screen-users fa-fw',
        'fa-sharp fa-solid fa-screen-users fa-fw',
        'fa-sharp fa-regular fa-screen-users fa-fw',
        'fa-sharp fa-light fa-screen-users fa-fw',
        'fa-regular fa-screen-users fa-fw',
        'fa-light fa-screen-users fa-fw',
        'fa-duotone fa-screen-users fa-fw',
        'fa-thin fa-shapes fa-fw',
        'fa-solid fa-shapes fa-fw',
        'fa-sharp fa-solid fa-shapes fa-fw',
        'fa-sharp fa-regular fa-shapes fa-fw',
        'fa-sharp fa-light fa-shapes fa-fw',
        'fa-regular fa-shapes fa-fw',
        'fa-light fa-shapes fa-fw',
        'fa-duotone fa-shapes fa-fw',
        'fa-thin fa-thought-bubble fa-fw',
        'fa-solid fa-thought-bubble fa-fw',
        'fa-sharp fa-solid fa-thought-bubble fa-fw',
        'fa-sharp fa-regular fa-thought-bubble fa-fw',
        'fa-sharp fa-light fa-thought-bubble fa-fw',
        'fa-regular fa-thought-bubble fa-fw',
        'fa-light fa-thought-bubble fa-fw',
        'fa-duotone fa-thought-bubble fa-fw',
        'fa-thin fa-user-graduate fa-fw',
        'fa-solid fa-user-graduate fa-fw',
        'fa-sharp fa-solid fa-user-graduate fa-fw',
        'fa-sharp fa-regular fa-user-graduate fa-fw',
        'fa-sharp fa-light fa-user-graduate fa-fw',
        'fa-regular fa-user-graduate fa-fw',
        'fa-light fa-user-graduate fa-fw',
        'fa-duotone fa-user-graduate fa-fw',
      ],
    },
    {
      title: 'Hands',
      items: [
        'fas fa-hand-lizard',
        'far fa-hand-lizard',
        'fas fa-hand-paper',
        'far fa-hand-paper',
        'fas fa-hand-peace',
        'far fa-hand-peace',
        'fas fa-hand-point-down',
        'far fa-hand-point-down',
        'fas fa-hand-point-left',
        'far fa-hand-point-left',
        'fas fa-hand-point-right',
        'far fa-hand-point-right',
        'fas fa-hand-point-up',
        'far fa-hand-point-up',
        'fas fa-hand-pointer',
        'far fa-hand-pointer',
        'fas fa-hand-rock',
        'far fa-hand-rock',
        'fas fa-hand-scissors',
        'far fa-hand-scissors',
        'fas fa-hand-spock',
        'far fa-hand-spock',
        'fas fa-handshake',
        'far fa-handshake',
        'fas fa-thumbs-down',
        'far fa-thumbs-down',
        'fas fa-thumbs-up',
        'far fa-thumbs-up',
      ],
    },
    {
      title: 'Health',
      items: [
        'fa-thin fa-hand fa-fw',
        'fa-solid fa-hand fa-fw',
        'fa-sharp fa-solid fa-hand fa-fw',
        'fa-sharp fa-regular fa-hand fa-fw',
        'fa-sharp fa-light fa-hand fa-fw',
        'fa-regular fa-hand fa-fw',
        'fa-light fa-hand fa-fw',
        'fa-duotone fa-hand fa-fw',
        'fa-thin fa-hand-back-fist fa-fw',
        'fa-solid fa-hand-back-fist fa-fw',
        'fa-sharp fa-solid fa-hand-back-fist fa-fw',
        'fa-sharp fa-regular fa-hand-back-fist fa-fw',
        'fa-sharp fa-light fa-hand-back-fist fa-fw',
        'fa-regular fa-hand-back-fist fa-fw',
        'fa-light fa-hand-back-fist fa-fw',
        'fa-duotone fa-hand-back-fist fa-fw',
        'fa-thin fa-hand-back-point-down fa-fw',
        'fa-solid fa-hand-back-point-down fa-fw',
        'fa-sharp fa-solid fa-hand-back-point-down fa-fw',
        'fa-sharp fa-regular fa-hand-back-point-down fa-fw',
        'fa-sharp fa-light fa-hand-back-point-down fa-fw',
        'fa-regular fa-hand-back-point-down fa-fw',
        'fa-light fa-hand-back-point-down fa-fw',
        'fa-duotone fa-hand-back-point-down fa-fw',
        'fa-thin fa-hand-back-point-left fa-fw',
        'fa-solid fa-hand-back-point-left fa-fw',
        'fa-sharp fa-solid fa-hand-back-point-left fa-fw',
        'fa-sharp fa-regular fa-hand-back-point-left fa-fw',
        'fa-sharp fa-light fa-hand-back-point-left fa-fw',
        'fa-regular fa-hand-back-point-left fa-fw',
        'fa-light fa-hand-back-point-left fa-fw',
        'fa-duotone fa-hand-back-point-left fa-fw',
        'fa-thin fa-hand-back-point-ribbon fa-fw',
        'fa-solid fa-hand-back-point-ribbon fa-fw',
        'fa-sharp fa-solid fa-hand-back-point-ribbon fa-fw',
        'fa-sharp fa-regular fa-hand-back-point-ribbon fa-fw',
        'fa-sharp fa-light fa-hand-back-point-ribbon fa-fw',
        'fa-regular fa-hand-back-point-ribbon fa-fw',
        'fa-light fa-hand-back-point-ribbon fa-fw',
        'fa-duotone fa-hand-back-point-ribbon fa-fw',
        'fa-thin fa-hand-back-point-right fa-fw',
        'fa-solid fa-hand-back-point-right fa-fw',
        'fa-sharp fa-solid fa-hand-back-point-right fa-fw',
        'fa-sharp fa-regular fa-hand-back-point-right fa-fw',
        'fa-sharp fa-light fa-hand-back-point-right fa-fw',
        'fa-regular fa-hand-back-point-right fa-fw',
        'fa-light fa-hand-back-point-right fa-fw',
        'fa-duotone fa-hand-back-point-right fa-fw',
        'fa-thin fa-hand-back-point-up fa-fw',
        'fa-solid fa-hand-back-point-up fa-fw',
        'fa-sharp fa-solid fa-hand-back-point-up fa-fw',
        'fa-sharp fa-regular fa-hand-back-point-up fa-fw',
        'fa-sharp fa-light fa-hand-back-point-up fa-fw',
        'fa-regular fa-hand-back-point-up fa-fw',
        'fa-light fa-hand-back-point-up fa-fw',
        'fa-duotone fa-hand-back-point-up fa-fw',
        'fa-thin fa-hand-dots fa-fw',
        'fa-solid fa-hand-dots fa-fw',
        'fa-sharp fa-solid fa-hand-dots fa-fw',
        'fa-sharp fa-regular fa-hand-dots fa-fw',
        'fa-sharp fa-light fa-hand-dots fa-fw',
        'fa-regular fa-hand-dots fa-fw',
        'fa-light fa-hand-dots fa-fw',
        'fa-duotone fa-hand-dots fa-fw',
        'fa-thin fa-hand-fingers-crossed fa-fw',
        'fa-solid fa-hand-fingers-crossed fa-fw',
        'fa-sharp fa-solid fa-hand-fingers-crossed fa-fw',
        'fa-sharp fa-regular fa-hand-fingers-crossed fa-fw',
        'fa-sharp fa-light fa-hand-fingers-crossed fa-fw',
        'fa-regular fa-hand-fingers-crossed fa-fw',
        'fa-light fa-hand-fingers-crossed fa-fw',
        'fa-duotone fa-hand-fingers-crossed fa-fw',
        'fa-thin fa-hand-fist fa-fw',
        'fa-solid fa-hand-fist fa-fw',
        'fa-sharp fa-solid fa-hand-fist fa-fw',
        'fa-sharp fa-regular fa-hand-fist fa-fw',
        'fa-sharp fa-light fa-hand-fist fa-fw',
        'fa-regular fa-hand-fist fa-fw',
        'fa-light fa-hand-fist fa-fw',
        'fa-duotone fa-hand-fist fa-fw',
        'fa-thin fa-hand-heart fa-fw',
        'fa-solid fa-hand-heart fa-fw',
        'fa-sharp fa-solid fa-hand-heart fa-fw',
        'fa-sharp fa-regular fa-hand-heart fa-fw',
        'fa-sharp fa-light fa-hand-heart fa-fw',
        'fa-regular fa-hand-heart fa-fw',
        'fa-light fa-hand-heart fa-fw',
        'fa-duotone fa-hand-heart fa-fw',
        'fa-thin fa-hand-holding fa-fw',
        'fa-solid fa-hand-holding fa-fw',
        'fa-sharp fa-solid fa-hand-holding fa-fw',
        'fa-sharp fa-regular fa-hand-holding fa-fw',
        'fa-sharp fa-light fa-hand-holding fa-fw',
        'fa-regular fa-hand-holding fa-fw',
        'fa-light fa-hand-holding fa-fw',
        'fa-duotone fa-hand-holding fa-fw',
        'fa-thin fa-hand-holding-box fa-fw',
        'fa-solid fa-hand-holding-box fa-fw',
        'fa-sharp fa-solid fa-hand-holding-box fa-fw',
        'fa-sharp fa-regular fa-hand-holding-box fa-fw',
        'fa-sharp fa-light fa-hand-holding-box fa-fw',
        'fa-regular fa-hand-holding-box fa-fw',
        'fa-light fa-hand-holding-box fa-fw',
        'fa-duotone fa-hand-holding-box fa-fw',
        'fa-thin fa-hand-holding-dollar fa-fw',
        'fa-solid fa-hand-holding-dollar fa-fw',
        'fa-sharp fa-solid fa-hand-holding-dollar fa-fw',
        'fa-sharp fa-regular fa-hand-holding-dollar fa-fw',
        'fa-sharp fa-light fa-hand-holding-dollar fa-fw',
        'fa-regular fa-hand-holding-dollar fa-fw',
        'fa-light fa-hand-holding-dollar fa-fw',
        'fa-duotone fa-hand-holding-dollar fa-fw',
        'fa-thin fa-hand-holding-droplet fa-fw',
        'fa-solid fa-hand-holding-droplet fa-fw',
        'fa-sharp fa-solid fa-hand-holding-droplet fa-fw',
        'fa-sharp fa-regular fa-hand-holding-droplet fa-fw',
        'fa-sharp fa-light fa-hand-holding-droplet fa-fw',
        'fa-regular fa-hand-holding-droplet fa-fw',
        'fa-light fa-hand-holding-droplet fa-fw',
        'fa-duotone fa-hand-holding-droplet fa-fw',
        'fa-thin fa-hand-holding-hand fa-fw',
        'fa-solid fa-hand-holding-hand fa-fw',
        'fa-sharp fa-solid fa-hand-holding-hand fa-fw',
        'fa-sharp fa-regular fa-hand-holding-hand fa-fw',
        'fa-sharp fa-light fa-hand-holding-hand fa-fw',
        'fa-regular fa-hand-holding-hand fa-fw',
        'fa-light fa-hand-holding-hand fa-fw',
        'fa-duotone fa-hand-holding-hand fa-fw',
        'fa-thin fa-hand-holding-heart fa-fw',
        'fa-solid fa-hand-holding-heart fa-fw',
        'fa-sharp fa-solid fa-hand-holding-heart fa-fw',
        'fa-sharp fa-regular fa-hand-holding-heart fa-fw',
        'fa-sharp fa-light fa-hand-holding-heart fa-fw',
        'fa-regular fa-hand-holding-heart fa-fw',
        'fa-light fa-hand-holding-heart fa-fw',
        'fa-duotone fa-hand-holding-heart fa-fw',
        'fa-thin fa-hand-holding-magic fa-fw',
        'fa-solid fa-hand-holding-magic fa-fw',
        'fa-sharp fa-solid fa-hand-holding-magic fa-fw',
        'fa-sharp fa-regular fa-hand-holding-magic fa-fw',
        'fa-sharp fa-light fa-hand-holding-magic fa-fw',
        'fa-regular fa-hand-holding-magic fa-fw',
        'fa-light fa-hand-holding-magic fa-fw',
        'fa-duotone fa-hand-holding-magic fa-fw',
        'fa-thin fa-hand-holding-medical fa-fw',
        'fa-solid fa-hand-holding-medical fa-fw',
        'fa-sharp fa-solid fa-hand-holding-medical fa-fw',
        'fa-sharp fa-regular fa-hand-holding-medical fa-fw',
        'fa-sharp fa-light fa-hand-holding-medical fa-fw',
        'fa-regular fa-hand-holding-medical fa-fw',
        'fa-light fa-hand-holding-medical fa-fw',
        'fa-duotone fa-hand-holding-medical fa-fw',
        'fa-thin fa-hand-holding-seedling fa-fw',
        'fa-solid fa-hand-holding-seedling fa-fw',
        'fa-sharp fa-solid fa-hand-holding-seedling fa-fw',
        'fa-sharp fa-regular fa-hand-holding-seedling fa-fw',
        'fa-sharp fa-light fa-hand-holding-seedling fa-fw',
        'fa-regular fa-hand-holding-seedling fa-fw',
        'fa-light fa-hand-holding-seedling fa-fw',
        'fa-duotone fa-hand-holding-seedling fa-fw',
        'fa-thin fa-hand-holding-skull fa-fw',
        'fa-solid fa-hand-holding-skull fa-fw',
        'fa-sharp fa-solid fa-hand-holding-skull fa-fw',
        'fa-sharp fa-regular fa-hand-holding-skull fa-fw',
        'fa-sharp fa-light fa-hand-holding-skull fa-fw',
        'fa-regular fa-hand-holding-skull fa-fw',
        'fa-light fa-hand-holding-skull fa-fw',
        'fa-duotone fa-hand-holding-skull fa-fw',
        'fa-thin fa-hand-horns fa-fw',
        'fa-solid fa-hand-horns fa-fw',
        'fa-sharp fa-solid fa-hand-horns fa-fw',
        'fa-sharp fa-regular fa-hand-horns fa-fw',
        'fa-sharp fa-light fa-hand-horns fa-fw',
        'fa-regular fa-hand-horns fa-fw',
        'fa-light fa-hand-horns fa-fw',
        'fa-duotone fa-hand-horns fa-fw',
        'fa-thin fa-hand-lizard fa-fw',
        'fa-solid fa-hand-lizard fa-fw',
        'fa-sharp fa-solid fa-hand-lizard fa-fw',
        'fa-sharp fa-regular fa-hand-lizard fa-fw',
        'fa-sharp fa-light fa-hand-lizard fa-fw',
        'fa-regular fa-hand-lizard fa-fw',
        'fa-light fa-hand-lizard fa-fw',
        'fa-duotone fa-hand-lizard fa-fw',
        'fa-thin fa-hand-love fa-fw',
        'fa-solid fa-hand-love fa-fw',
        'fa-sharp fa-solid fa-hand-love fa-fw',
        'fa-sharp fa-regular fa-hand-love fa-fw',
        'fa-sharp fa-light fa-hand-love fa-fw',
        'fa-regular fa-hand-love fa-fw',
        'fa-light fa-hand-love fa-fw',
        'fa-duotone fa-hand-love fa-fw',
        'fa-thin fa-hand-middle-finger fa-fw',
        'fa-solid fa-hand-middle-finger fa-fw',
        'fa-sharp fa-solid fa-hand-middle-finger fa-fw',
        'fa-sharp fa-regular fa-hand-middle-finger fa-fw',
        'fa-sharp fa-light fa-hand-middle-finger fa-fw',
        'fa-regular fa-hand-middle-finger fa-fw',
        'fa-light fa-hand-middle-finger fa-fw',
        'fa-duotone fa-hand-middle-finger fa-fw',
        'fa-thin fa-hand-peace fa-fw',
        'fa-solid fa-hand-peace fa-fw',
        'fa-sharp fa-solid fa-hand-peace fa-fw',
        'fa-sharp fa-regular fa-hand-peace fa-fw',
        'fa-sharp fa-light fa-hand-peace fa-fw',
        'fa-regular fa-hand-peace fa-fw',
        'fa-light fa-hand-peace fa-fw',
        'fa-duotone fa-hand-peace fa-fw',
        'fa-thin fa-hand-point-down fa-fw',
        'fa-solid fa-hand-point-down fa-fw',
        'fa-sharp fa-solid fa-hand-point-down fa-fw',
        'fa-sharp fa-regular fa-hand-point-down fa-fw',
        'fa-sharp fa-light fa-hand-point-down fa-fw',
        'fa-regular fa-hand-point-down fa-fw',
        'fa-light fa-hand-point-down fa-fw',
        'fa-duotone fa-hand-point-down fa-fw',
        'fa-thin fa-hand-point-left fa-fw',
        'fa-solid fa-hand-point-left fa-fw',
        'fa-sharp fa-solid fa-hand-point-left fa-fw',
        'fa-sharp fa-regular fa-hand-point-left fa-fw',
        'fa-sharp fa-light fa-hand-point-left fa-fw',
        'fa-regular fa-hand-point-left fa-fw',
        'fa-light fa-hand-point-left fa-fw',
        'fa-duotone fa-hand-point-left fa-fw',
        'fa-thin fa-hand-point-ribbon fa-fw',
        'fa-solid fa-hand-point-ribbon fa-fw',
        'fa-sharp fa-solid fa-hand-point-ribbon fa-fw',
        'fa-sharp fa-regular fa-hand-point-ribbon fa-fw',
        'fa-sharp fa-light fa-hand-point-ribbon fa-fw',
        'fa-regular fa-hand-point-ribbon fa-fw',
        'fa-light fa-hand-point-ribbon fa-fw',
        'fa-duotone fa-hand-point-ribbon fa-fw',
        'fa-thin fa-hand-point-right fa-fw',
        'fa-solid fa-hand-point-right fa-fw',
        'fa-sharp fa-solid fa-hand-point-right fa-fw',
        'fa-sharp fa-regular fa-hand-point-right fa-fw',
        'fa-sharp fa-light fa-hand-point-right fa-fw',
        'fa-regular fa-hand-point-right fa-fw',
        'fa-light fa-hand-point-right fa-fw',
        'fa-duotone fa-hand-point-right fa-fw',
        'fa-thin fa-hand-point-up fa-fw',
        'fa-solid fa-hand-point-up fa-fw',
        'fa-sharp fa-solid fa-hand-point-up fa-fw',
        'fa-sharp fa-regular fa-hand-point-up fa-fw',
        'fa-sharp fa-light fa-hand-point-up fa-fw',
        'fa-regular fa-hand-point-up fa-fw',
        'fa-light fa-hand-point-up fa-fw',
        'fa-duotone fa-hand-point-up fa-fw',
        'fa-thin fa-hand-pointer fa-fw',
        'fa-solid fa-hand-pointer fa-fw',
        'fa-sharp fa-solid fa-hand-pointer fa-fw',
        'fa-sharp fa-regular fa-hand-pointer fa-fw',
        'fa-sharp fa-light fa-hand-pointer fa-fw',
        'fa-regular fa-hand-pointer fa-fw',
        'fa-light fa-hand-pointer fa-fw',
        'fa-duotone fa-hand-pointer fa-fw',
        'fa-thin fa-hand-scissors fa-fw',
        'fa-solid fa-hand-scissors fa-fw',
        'fa-sharp fa-solid fa-hand-scissors fa-fw',
        'fa-sharp fa-regular fa-hand-scissors fa-fw',
        'fa-sharp fa-light fa-hand-scissors fa-fw',
        'fa-regular fa-hand-scissors fa-fw',
        'fa-light fa-hand-scissors fa-fw',
        'fa-duotone fa-hand-scissors fa-fw',
        'fa-thin fa-hand-sparkles fa-fw',
        'fa-solid fa-hand-sparkles fa-fw',
        'fa-sharp fa-solid fa-hand-sparkles fa-fw',
        'fa-sharp fa-regular fa-hand-sparkles fa-fw',
        'fa-sharp fa-light fa-hand-sparkles fa-fw',
        'fa-regular fa-hand-sparkles fa-fw',
        'fa-light fa-hand-sparkles fa-fw',
        'fa-duotone fa-hand-sparkles fa-fw',
        'fa-thin fa-hand-spock fa-fw',
        'fa-solid fa-hand-spock fa-fw',
        'fa-sharp fa-solid fa-hand-spock fa-fw',
        'fa-sharp fa-regular fa-hand-spock fa-fw',
        'fa-sharp fa-light fa-hand-spock fa-fw',
        'fa-regular fa-hand-spock fa-fw',
        'fa-light fa-hand-spock fa-fw',
        'fa-duotone fa-hand-spock fa-fw',
        'fa-thin fa-hand-wave fa-fw',
        'fa-solid fa-hand-wave fa-fw',
        'fa-sharp fa-solid fa-hand-wave fa-fw',
        'fa-sharp fa-regular fa-hand-wave fa-fw',
        'fa-sharp fa-light fa-hand-wave fa-fw',
        'fa-regular fa-hand-wave fa-fw',
        'fa-light fa-hand-wave fa-fw',
        'fa-duotone fa-hand-wave fa-fw',
        'fa-thin fa-hands-bound fa-fw',
        'fa-solid fa-hands-bound fa-fw',
        'fa-sharp fa-solid fa-hands-bound fa-fw',
        'fa-sharp fa-regular fa-hands-bound fa-fw',
        'fa-sharp fa-light fa-hands-bound fa-fw',
        'fa-regular fa-hands-bound fa-fw',
        'fa-light fa-hands-bound fa-fw',
        'fa-duotone fa-hands-bound fa-fw',
        'fa-thin fa-hands-bubbles fa-fw',
        'fa-solid fa-hands-bubbles fa-fw',
        'fa-sharp fa-solid fa-hands-bubbles fa-fw',
        'fa-sharp fa-regular fa-hands-bubbles fa-fw',
        'fa-sharp fa-light fa-hands-bubbles fa-fw',
        'fa-regular fa-hands-bubbles fa-fw',
        'fa-light fa-hands-bubbles fa-fw',
        'fa-duotone fa-hands-bubbles fa-fw',
        'fa-thin fa-hands-clapping fa-fw',
        'fa-solid fa-hands-clapping fa-fw',
        'fa-sharp fa-solid fa-hands-clapping fa-fw',
        'fa-sharp fa-regular fa-hands-clapping fa-fw',
        'fa-sharp fa-light fa-hands-clapping fa-fw',
        'fa-regular fa-hands-clapping fa-fw',
        'fa-light fa-hands-clapping fa-fw',
        'fa-duotone fa-hands-clapping fa-fw',
        'fa-thin fa-hands-holding fa-fw',
        'fa-solid fa-hands-holding fa-fw',
        'fa-sharp fa-solid fa-hands-holding fa-fw',
        'fa-sharp fa-regular fa-hands-holding fa-fw',
        'fa-sharp fa-light fa-hands-holding fa-fw',
        'fa-regular fa-hands-holding fa-fw',
        'fa-light fa-hands-holding fa-fw',
        'fa-duotone fa-hands-holding fa-fw',
        'fa-thin fa-hands-holding-child fa-fw',
        'fa-solid fa-hands-holding-child fa-fw',
        'fa-sharp fa-solid fa-hands-holding-child fa-fw',
        'fa-sharp fa-regular fa-hands-holding-child fa-fw',
        'fa-sharp fa-light fa-hands-holding-child fa-fw',
        'fa-regular fa-hands-holding-child fa-fw',
        'fa-light fa-hands-holding-child fa-fw',
        'fa-duotone fa-hands-holding-child fa-fw',
        'fa-thin fa-hands-holding-circle fa-fw',
        'fa-solid fa-hands-holding-circle fa-fw',
        'fa-sharp fa-solid fa-hands-holding-circle fa-fw',
        'fa-sharp fa-regular fa-hands-holding-circle fa-fw',
        'fa-sharp fa-light fa-hands-holding-circle fa-fw',
        'fa-regular fa-hands-holding-circle fa-fw',
        'fa-light fa-hands-holding-circle fa-fw',
        'fa-duotone fa-hands-holding-circle fa-fw',
        'fa-thin fa-hands-holding-diamond fa-fw',
        'fa-solid fa-hands-holding-diamond fa-fw',
        'fa-sharp fa-solid fa-hands-holding-diamond fa-fw',
        'fa-sharp fa-regular fa-hands-holding-diamond fa-fw',
        'fa-sharp fa-light fa-hands-holding-diamond fa-fw',
        'fa-regular fa-hands-holding-diamond fa-fw',
        'fa-light fa-hands-holding-diamond fa-fw',
        'fa-duotone fa-hands-holding-diamond fa-fw',
        'fa-thin fa-hands-holding-dollar fa-fw',
        'fa-solid fa-hands-holding-dollar fa-fw',
        'fa-sharp fa-solid fa-hands-holding-dollar fa-fw',
        'fa-sharp fa-regular fa-hands-holding-dollar fa-fw',
        'fa-sharp fa-light fa-hands-holding-dollar fa-fw',
        'fa-regular fa-hands-holding-dollar fa-fw',
        'fa-light fa-hands-holding-dollar fa-fw',
        'fa-duotone fa-hands-holding-dollar fa-fw',
        'fa-thin fa-hands-holding-heart fa-fw',
        'fa-solid fa-hands-holding-heart fa-fw',
        'fa-sharp fa-solid fa-hands-holding-heart fa-fw',
        'fa-sharp fa-regular fa-hands-holding-heart fa-fw',
        'fa-sharp fa-light fa-hands-holding-heart fa-fw',
        'fa-regular fa-hands-holding-heart fa-fw',
        'fa-light fa-hands-holding-heart fa-fw',
        'fa-duotone fa-hands-holding-heart fa-fw',
        'fa-thin fa-hands-praying fa-fw',
        'fa-solid fa-hands-praying fa-fw',
        'fa-sharp fa-solid fa-hands-praying fa-fw',
        'fa-sharp fa-regular fa-hands-praying fa-fw',
        'fa-sharp fa-light fa-hands-praying fa-fw',
        'fa-regular fa-hands-praying fa-fw',
        'fa-light fa-hands-praying fa-fw',
        'fa-duotone fa-hands-praying fa-fw',
        'fa-thin fa-handshake fa-fw',
        'fa-solid fa-handshake fa-fw',
        'fa-sharp fa-solid fa-handshake fa-fw',
        'fa-sharp fa-regular fa-handshake fa-fw',
        'fa-sharp fa-light fa-handshake fa-fw',
        'fa-regular fa-handshake fa-fw',
        'fa-light fa-handshake fa-fw',
        'fa-duotone fa-handshake fa-fw',
        'fa-thin fa-handshake-angle fa-fw',
        'fa-solid fa-handshake-angle fa-fw',
        'fa-sharp fa-solid fa-handshake-angle fa-fw',
        'fa-sharp fa-regular fa-handshake-angle fa-fw',
        'fa-sharp fa-light fa-handshake-angle fa-fw',
        'fa-regular fa-handshake-angle fa-fw',
        'fa-light fa-handshake-angle fa-fw',
        'fa-duotone fa-handshake-angle fa-fw',
        'fa-thin fa-handshake-simple fa-fw',
        'fa-solid fa-handshake-simple fa-fw',
        'fa-sharp fa-solid fa-handshake-simple fa-fw',
        'fa-sharp fa-regular fa-handshake-simple fa-fw',
        'fa-sharp fa-light fa-handshake-simple fa-fw',
        'fa-regular fa-handshake-simple fa-fw',
        'fa-light fa-handshake-simple fa-fw',
        'fa-duotone fa-handshake-simple fa-fw',
        'fa-thin fa-handshake-simple-slash fa-fw',
        'fa-solid fa-handshake-simple-slash fa-fw',
        'fa-sharp fa-solid fa-handshake-simple-slash fa-fw',
        'fa-sharp fa-regular fa-handshake-simple-slash fa-fw',
        'fa-sharp fa-light fa-handshake-simple-slash fa-fw',
        'fa-regular fa-handshake-simple-slash fa-fw',
        'fa-light fa-handshake-simple-slash fa-fw',
        'fa-duotone fa-handshake-simple-slash fa-fw',
        'fa-thin fa-handshake-slash fa-fw',
        'fa-solid fa-handshake-slash fa-fw',
        'fa-sharp fa-solid fa-handshake-slash fa-fw',
        'fa-sharp fa-regular fa-handshake-slash fa-fw',
        'fa-sharp fa-light fa-handshake-slash fa-fw',
        'fa-regular fa-handshake-slash fa-fw',
        'fa-light fa-handshake-slash fa-fw',
        'fa-duotone fa-handshake-slash fa-fw',
        'fa-thin fa-thumbs-down fa-fw',
        'fa-solid fa-thumbs-down fa-fw',
        'fa-sharp fa-solid fa-thumbs-down fa-fw',
        'fa-sharp fa-regular fa-thumbs-down fa-fw',
        'fa-sharp fa-light fa-thumbs-down fa-fw',
        'fa-regular fa-thumbs-down fa-fw',
        'fa-light fa-thumbs-down fa-fw',
        'fa-duotone fa-thumbs-down fa-fw',
        'fa-thin fa-thumbs-up fa-fw',
        'fa-solid fa-thumbs-up fa-fw',
        'fa-sharp fa-solid fa-thumbs-up fa-fw',
        'fa-sharp fa-regular fa-thumbs-up fa-fw',
        'fa-sharp fa-light fa-thumbs-up fa-fw',
        'fa-regular fa-thumbs-up fa-fw',
        'fa-light fa-thumbs-up fa-fw',
        'fa-duotone fa-thumbs-up fa-fw',
      ],
    },
    {
      title: 'Images',
      items: [
        'fas fa-adjust',
        'fas fa-bolt',
        'fas fa-camera',
        'fas fa-camera-retro',
        'fas fa-clone',
        'far fa-clone',
        'fas fa-compress',
        'fas fa-expand',
        'fas fa-eye',
        'fas fa-eye-dropper',
        'fas fa-eye-slash',
        'far fa-eye-slash',
        'fas fa-file-image',
        'far fa-file-image',
        'fas fa-film',
        'fas fa-id-badge',
        'far fa-id-badge',
        'fas fa-id-card',
        'far fa-id-card',
        'fas fa-image',
        'far fa-image',
        'fas fa-images',
        'far fa-images',
        'fas fa-sliders-h',
        'fas fa-tint',
      ],
    },
    {
      title: 'Interfaces',
      items: [
        'fas fa-ban',
        'fas fa-barcode',
        'fas fa-bars',
        'fas fa-beer',
        'fas fa-bell',
        'far fa-bell',
        'fas fa-bell-slash',
        'far fa-bell-slash',
        'fas fa-bug',
        'fas fa-bullhorn',
        'fas fa-bullseye',
        'fas fa-calculator',
        'fas fa-calendar',
        'far fa-calendar',
        'fas fa-calendar-alt',
        'far fa-calendar-alt',
        'fas fa-calendar-check',
        'far fa-calendar-check',
        'fas fa-calendar-minus',
        'far fa-calendar-minus',
        'fas fa-calendar-plus',
        'far fa-calendar-plus',
        'fas fa-calendar-times',
        'far fa-calendar-times',
        'fas fa-certificate',
        'fas fa-check',
        'fas fa-check-circle',
        'far fa-check-circle',
        'fas fa-check-square',
        'far fa-check-square',
        'fas fa-circle',
        'far fa-circle',
        'fas fa-clipboard',
        'far fa-clipboard',
        'fas fa-clone',
        'far fa-clone',
        'fas fa-cloud',
        'fas fa-cloud-download-alt',
        'fas fa-cloud-upload-alt',
        'fas fa-coffee',
        'fas fa-cog',
        'fas fa-cogs',
        'fas fa-copy',
        'far fa-copy',
        'fas fa-cut',
        'fas fa-database',
        'fas fa-dot-circle',
        'far fa-dot-circle',
        'fas fa-download',
        'fas fa-edit',
        'far fa-edit',
        'fas fa-ellipsis-h',
        'fas fa-ellipsis-v',
        'fas fa-envelope',
        'far fa-envelope',
        'fas fa-envelope-open',
        'far fa-envelope-open',
        'fas fa-eraser',
        'fas fa-exclamation',
        'fas fa-exclamation-circle',
        'fas fa-exclamation-triangle',
        'fas fa-external-link-alt',
        'fas fa-external-link-square-alt',
        'fas fa-eye',
        'fas fa-eye-slash',
        'far fa-eye-slash',
        'fas fa-file',
        'far fa-file',
        'fas fa-file-alt',
        'far fa-file-alt',
        'fas fa-filter',
        'fas fa-flag',
        'far fa-flag',
        'fas fa-flag-checkered',
        'fas fa-folder',
        'far fa-folder',
        'fas fa-folder-open',
        'far fa-folder-open',
        'fas fa-frown',
        'far fa-frown',
        'fas fa-hashtag',
        'fas fa-heart',
        'far fa-heart',
        'fas fa-history',
        'fas fa-home',
        'fas fa-i-cursor',
        'fas fa-info',
        'fas fa-info-circle',
        'fas fa-language',
        'fas fa-magic',
        'fas fa-meh',
        'far fa-meh',
        'fas fa-microphone',
        'fas fa-microphone-slash',
        'fas fa-minus',
        'fas fa-minus-circle',
        'fas fa-minus-square',
        'far fa-minus-square',
        'fas fa-paste',
        'fas fa-pencil-alt',
        'fas fa-plus',
        'fas fa-plus-circle',
        'fas fa-plus-square',
        'far fa-plus-square',
        'fas fa-qrcode',
        'fas fa-question',
        'fas fa-question-circle',
        'far fa-question-circle',
      ],
    },
    {
      title: 'Maps',
      items: [
        'fas fa-ambulance',
        'fas fa-anchor',
        'fas fa-balance-scale',
        'fas fa-bath',
        'fas fa-bed',
        'fas fa-beer',
        'fas fa-bell',
        'far fa-bell',
        'fas fa-bell-slash',
        'far fa-bell-slash',
        'fas fa-bicycle',
        'fas fa-binoculars',
        'fas fa-birthday-cake',
        'fas fa-blind',
        'fas fa-bomb',
        'fas fa-book',
        'fas fa-bookmark',
        'far fa-bookmark',
        'fas fa-briefcase',
        'fas fa-building',
        'far fa-building',
        'fas fa-car',
        'fas fa-coffee',
        'fas fa-crosshairs',
        'fas fa-dollar-sign',
        'fas fa-eye',
        'fas fa-eye-slash',
        'far fa-eye-slash',
        'fas fa-fighter-jet',
        'fas fa-fire',
        'fas fa-fire-extinguisher',
        'fas fa-flag',
        'far fa-flag',
        'fas fa-flag-checkered',
        'fas fa-flask',
        'fas fa-gamepad',
        'fas fa-gavel',
        'fas fa-gift',
        'fas fa-glass-martini',
        'fas fa-globe',
        'fas fa-graduation-cap',
        'fas fa-h-square',
        'fas fa-heart',
        'far fa-heart',
        'fas fa-heartbeat',
        'fas fa-home',
        'fas fa-hospital',
        'far fa-hospital',
        'fas fa-image',
        'far fa-image',
        'fas fa-images',
        'far fa-images',
        'fas fa-industry',
        'fas fa-info',
        'fas fa-info-circle',
        'fas fa-key',
        'fas fa-leaf',
        'fas fa-lemon',
        'far fa-lemon',
        'fas fa-life-ring',
        'far fa-life-ring',
        'fas fa-lightbulb',
        'far fa-lightbulb',
        'fas fa-location-arrow',
        'fas fa-low-vision',
        'fas fa-magnet',
        'fas fa-male',
        'fas fa-map',
        'far fa-map',
        'fas fa-map-marker',
        'fas fa-map-marker-alt',
        'fas fa-map-pin',
        'fas fa-map-signs',
        'fas fa-medkit',
        'fas fa-money-bill-alt',
        'far fa-money-bill-alt',
        'fas fa-motorcycle',
        'fas fa-music',
        'fas fa-newspaper',
        'far fa-newspaper',
        'fas fa-paw',
        'fas fa-phone',
        'fas fa-phone-square',
        'fas fa-phone-volume',
        'fas fa-plane',
        'fas fa-plug',
        'fas fa-plus',
        'fas fa-plus-square',
        'far fa-plus-square',
        'fas fa-print',
        'fas fa-recycle',
        'fas fa-road',
        'fas fa-rocket',
        'fas fa-search',
        'fas fa-search-minus',
        'fas fa-search-plus',
        'fas fa-ship',
        'fas fa-shopping-bag',
        'fas fa-shopping-basket',
        'fas fa-shopping-cart',
        'fas fa-shower',
        'fas fa-street-view',
        'fas fa-subway',
        'fas fa-suitcase',
        'fas fa-tag',
        'fas fa-tags',
        'fas fa-taxi',
        'fas fa-thumbtack',
      ],
    },
    {
      title: 'Objects',
      items: [
        'fas fa-ambulance',
        'fas fa-anchor',
        'fas fa-archive',
        'fas fa-balance-scale',
        'fas fa-bath',
        'fas fa-bed',
        'fas fa-beer',
        'fas fa-bell',
        'far fa-bell',
        'fas fa-bicycle',
        'fas fa-binoculars',
        'fas fa-birthday-cake',
        'fas fa-bomb',
        'fas fa-book',
        'fas fa-bookmark',
        'far fa-bookmark',
        'fas fa-briefcase',
        'fas fa-bug',
        'fas fa-building',
        'far fa-building',
        'fas fa-bullhorn',
        'fas fa-bullseye',
        'fas fa-bus',
        'fas fa-calculator',
        'fas fa-calendar',
        'far fa-calendar',
        'fas fa-calendar-alt',
        'far fa-calendar-alt',
        'fas fa-camera',
        'fas fa-camera-retro',
        'fas fa-car',
        'fas fa-clipboard',
        'far fa-clipboard',
        'fas fa-cloud',
        'fas fa-coffee',
        'fas fa-cog',
        'fas fa-cogs',
        'fas fa-compass',
        'far fa-compass',
        'fas fa-copy',
        'far fa-copy',
        'fas fa-cube',
        'fas fa-cubes',
        'fas fa-cut',
        'fas fa-envelope',
        'far fa-envelope',
        'fas fa-envelope-open',
        'far fa-envelope-open',
        'fas fa-eraser',
        'fas fa-eye',
        'fas fa-eye-dropper',
        'fas fa-fax',
        'fas fa-fighter-jet',
        'fas fa-file',
        'far fa-file',
        'fas fa-file-alt',
        'far fa-file-alt',
        'fas fa-film',
        'fas fa-fire',
        'fas fa-fire-extinguisher',
        'fas fa-flag',
        'far fa-flag',
        'fas fa-flag-checkered',
        'fas fa-flask',
        'fas fa-futbol',
        'far fa-futbol',
        'fas fa-gamepad',
        'fas fa-gavel',
        'fas fa-gem',
        'far fa-gem',
        'fas fa-gift',
        'fas fa-glass-martini',
        'fas fa-globe',
        'fas fa-graduation-cap',
        'fas fa-hdd',
        'far fa-hdd',
        'fas fa-headphones',
        'fas fa-heart',
        'far fa-heart',
        'fas fa-home',
        'fas fa-hospital',
        'far fa-hospital',
        'fas fa-hourglass',
        'far fa-hourglass',
        'fas fa-image',
        'far fa-image',
        'fas fa-images',
        'far fa-images',
        'fas fa-industry',
        'fas fa-key',
        'fas fa-keyboard',
        'far fa-keyboard',
        'fas fa-laptop',
        'fas fa-leaf',
        'fas fa-lemon',
        'far fa-lemon',
        'fas fa-life-ring',
        'far fa-life-ring',
        'fas fa-lightbulb',
        'far fa-lightbulb',
        'fas fa-lock',
        'fas fa-lock-open',
        'fas fa-magic',
        'fas fa-magnet',
        'fas fa-map',
        'far fa-map',
        'fas fa-map-marker',
        'fas fa-map-marker-alt',
      ],
    },
    {
      title: 'Payments & Shopping',
      items: [
        'fab fa-amazon-pay',
        'fab fa-apple-pay',
        'fas fa-bell',
        'far fa-bell',
        'fas fa-bookmark',
        'far fa-bookmark',
        'fas fa-bullhorn',
        'fas fa-camera',
        'fas fa-camera-retro',
        'fas fa-cart-arrow-down',
        'fas fa-cart-plus',
        'fab fa-cc-amazon-pay',
        'fab fa-cc-amex',
        'fab fa-cc-apple-pay',
        'fab fa-cc-diners-club',
        'fab fa-cc-discover',
        'fab fa-cc-jcb',
        'fab fa-cc-mastercard',
        'fab fa-cc-paypal',
        'fab fa-cc-stripe',
        'fab fa-cc-visa',
        'fas fa-certificate',
        'fas fa-credit-card',
        'far fa-credit-card',
        'fab fa-ethereum',
        'fas fa-gem',
        'far fa-gem',
        'fas fa-gift',
        'fab fa-google-wallet',
        'fas fa-handshake',
        'far fa-handshake',
        'fas fa-heart',
        'far fa-heart',
        'fas fa-key',
        'fab fa-paypal',
        'fas fa-shopping-bag',
        'fas fa-shopping-basket',
        'fas fa-shopping-cart',
        'fas fa-star',
        'far fa-star',
        'fab fa-stripe',
        'fab fa-stripe-s',
        'fas fa-tag',
        'fas fa-tags',
        'fas fa-thumbs-down',
        'far fa-thumbs-down',
        'fas fa-thumbs-up',
        'far fa-thumbs-up',
        'fas fa-trophy',
      ],
    },
    {
      title: 'Shapes',
      items: [
        'fas fa-bookmark',
        'far fa-bookmark',
        'fas fa-calendar',
        'far fa-calendar',
        'fas fa-certificate',
        'fas fa-circle',
        'far fa-circle',
        'fas fa-cloud',
        'fas fa-comment',
        'far fa-comment',
        'fas fa-file',
        'far fa-file',
        'fas fa-folder',
        'far fa-folder',
        'fas fa-heart',
        'far fa-heart',
        'fas fa-map-marker',
        'fas fa-play',
        'fas fa-square',
        'far fa-square',
        'fas fa-star',
        'far fa-star',
      ],
    },
    {
      title: 'Spinners',
      items: [
        'fas fa-asterisk',
        'fas fa-certificate',
        'fas fa-circle-notch',
        'fas fa-cog',
        'fas fa-compass',
        'far fa-compass',
        'fas fa-crosshairs',
        'fas fa-life-ring',
        'far fa-life-ring',
        'fas fa-snowflake',
        'far fa-snowflake',
        'fas fa-spinner',
        'fas fa-sun',
        'far fa-sun',
        'fas fa-sync',
      ],
    },
    {
      title: 'Sports',
      items: [
        'fas fa-baseball-ball',
        'fas fa-basketball-ball',
        'fas fa-bowling-ball',
        'fas fa-football-ball',
        'fas fa-futbol',
        'far fa-futbol',
        'fas fa-golf-ball',
        'fas fa-hockey-puck',
        'fas fa-quidditch',
        'fas fa-table-tennis',
        'fas fa-volleyball-ball',
      ],
    },
    {
      title: 'Status',
      items: [
        'fas fa-ban',
        'fas fa-battery-empty',
        'fas fa-battery-full',
        'fas fa-battery-half',
        'fas fa-battery-quarter',
        'fas fa-battery-three-quarters',
        'fas fa-bell',
        'far fa-bell',
        'fas fa-bell-slash',
        'far fa-bell-slash',
        'fas fa-calendar',
        'far fa-calendar',
        'fas fa-calendar-alt',
        'far fa-calendar-alt',
        'fas fa-calendar-check',
        'far fa-calendar-check',
        'fas fa-calendar-minus',
        'far fa-calendar-minus',
        'fas fa-calendar-plus',
        'far fa-calendar-plus',
        'fas fa-calendar-times',
        'far fa-calendar-times',
        'fas fa-cart-arrow-down',
        'fas fa-cart-plus',
        'fas fa-exclamation',
        'fas fa-exclamation-circle',
        'fas fa-exclamation-triangle',
        'fas fa-eye',
        'fas fa-eye-slash',
        'far fa-eye-slash',
        'fas fa-file',
        'far fa-file',
        'fas fa-file-alt',
        'far fa-file-alt',
        'fas fa-folder',
        'far fa-folder',
        'fas fa-folder-open',
        'far fa-folder-open',
        'fas fa-info',
        'fas fa-info-circle',
        'fas fa-lock',
        'fas fa-lock-open',
        'fas fa-minus',
        'fas fa-minus-circle',
        'fas fa-minus-square',
        'far fa-minus-square',
        'fas fa-plus',
        'fas fa-plus-circle',
        'fas fa-plus-square',
        'far fa-plus-square',
        'fas fa-question',
        'fas fa-question-circle',
        'far fa-question-circle',
        'fas fa-shield-alt',
        'fas fa-shopping-cart',
        'fas fa-sign-in-alt',
        'fas fa-sign-out-alt',
        'fas fa-thermometer-empty',
        'fas fa-thermometer-full',
        'fas fa-thermometer-half',
        'fas fa-thermometer-quarter',
        'fas fa-thermometer-three-quarters',
        'fas fa-thumbs-down',
        'far fa-thumbs-down',
        'fas fa-thumbs-up',
        'far fa-thumbs-up',
        'fas fa-toggle-off',
        'fas fa-toggle-on',
        'fas fa-unlock',
        'fas fa-unlock-alt',
      ],
    },
    {
      title: 'Users & People',
      items: [
        'fab fa-accessible-icon',
        'fas fa-address-book',
        'far fa-address-book',
        'fas fa-address-card',
        'far fa-address-card',
        'fas fa-bed',
        'fas fa-blind',
        'fas fa-child',
        'fas fa-female',
        'fas fa-frown',
        'far fa-frown',
        'fas fa-id-badge',
        'far fa-id-badge',
        'fas fa-id-card',
        'far fa-id-card',
        'fas fa-male',
        'fas fa-meh',
        'far fa-meh',
        'fas fa-power-off',
        'fas fa-smile',
        'far fa-smile',
        'fas fa-street-view',
        'fas fa-user',
        'far fa-user',
        'fas fa-user-circle',
        'far fa-user-circle',
        'fas fa-user-md',
        'fas fa-user-plus',
        'fas fa-user-secret',
        'fas fa-user-times',
        'fas fa-users',
        'fas fa-wheelchair',
      ],
    },
    {
      title: 'Vehicles',
      items: [
        'fab fa-accessible-icon',
        'fas fa-ambulance',
        'fas fa-bicycle',
        'fas fa-bus',
        'fas fa-car',
        'fas fa-fighter-jet',
        'fas fa-motorcycle',
        'fas fa-paper-plane',
        'far fa-paper-plane',
        'fas fa-plane',
        'fas fa-rocket',
        'fas fa-ship',
        'fas fa-shopping-cart',
        'fas fa-space-shuttle',
        'fas fa-subway',
        'fas fa-taxi',
        'fas fa-train',
        'fas fa-truck',
        'fas fa-wheelchair',
      ],
    },
    {
      title: 'Writing',
      items: [
        'fas fa-archive',
        'fas fa-book',
        'fas fa-bookmark',
        'far fa-bookmark',
        'fas fa-edit',
        'far fa-edit',
        'fas fa-envelope',
        'far fa-envelope',
        'fas fa-envelope-open',
        'far fa-envelope-open',
        'fas fa-eraser',
        'fas fa-file',
        'far fa-file',
        'fas fa-file-alt',
        'far fa-file-alt',
        'fas fa-folder',
        'far fa-folder',
        'fas fa-folder-open',
        'far fa-folder-open',
        'fas fa-keyboard',
        'far fa-keyboard',
        'fas fa-newspaper',
        'far fa-newspaper',
        'fas fa-paper-plane',
        'far fa-paper-plane',
        'fas fa-paperclip',
        'fas fa-paragraph',
        'fas fa-pen-square',
        'fas fa-pencil-alt',
        'fas fa-quote-left',
        'fas fa-quote-right',
        'fas fa-sticky-note',
        'far fa-sticky-note',
        'fas fa-thumbtack',
      ],
    },
  ];
  all = [
    'fa-solid fa-house fa-fw',
    'fa-solid fa-magnifying-glass fa-fw',
    'fa-solid fa-user fa-fw',
    'fa-brands fa-facebook fa-fw',
    'fa-solid fa-check fa-fw',
    'fa-solid fa-download fa-fw',
    'fa-brands fa-twitter fa-fw',
    'fa-solid fa-image fa-fw',
    'fa-brands fa-instagram fa-fw',
    'fa-solid fa-phone fa-fw',
    'fa-brands fa-tiktok fa-fw',
    'fa-solid fa-bars fa-fw',
    'fa-solid fa-envelope fa-fw',
    'fa-brands fa-linkedin fa-fw',
    'fa-solid fa-star fa-fw',
    'fa-solid fa-location-dot fa-fw',
    'fa-brands fa-github fa-fw',
    'fa-solid fa-music fa-fw',
    'fa-solid fa-wand-magic-sparkles fa-fw',
    'fa-solid fa-face-awesome fa-fw',
    'fa-solid fa-heart fa-fw',
    'fa-solid fa-arrow-right fa-fw',
    'fa-brands fa-discord fa-fw',
    'fa-solid fa-circle-xmark fa-fw',
    'fa-solid fa-bomb fa-fw',
    'fa-solid fa-poo fa-fw',
    'fa-solid fa-camera-retro fa-fw',
    'fa-solid fa-xmark fa-fw',
    'fa-brands fa-youtube fa-fw',
    'fa-solid fa-cloud fa-fw',
    'fa-solid fa-comment fa-fw',
    'fa-solid fa-caret-up fa-fw',
    'fa-solid fa-truck-fast fa-fw',
    'fa-brands fa-wordpress fa-fw',
    'fa-solid fa-pen-nib fa-fw',
    'fa-solid fa-arrow-up fa-fw',
    'fa-solid fa-hippo fa-fw',
    'fa-solid fa-face-smile fa-fw',
    'fa-solid fa-calendar-days fa-fw',
    'fa-solid fa-paperclip fa-fw',
    'fa-brands fa-slack fa-fw',
    'fa-solid fa-shield-halved fa-fw',
    'fa-brands fa-figma fa-fw',
    'fa-solid fa-file fa-fw',
    'fa-solid fa-bell fa-fw',
    'fa-solid fa-cart-shopping fa-fw',
    'fa-solid fa-clipboard fa-fw',
    'fa-solid fa-filter fa-fw',
    'fa-solid fa-circle-info fa-fw',
    'fa-solid fa-arrow-up-from-bracket fa-fw',
    'fa-solid fa-alarm-clock fa-fw',
    'fa-solid fa-bolt fa-fw',
    'fa-solid fa-raygun fa-fw',
    'fa-solid fa-car fa-fw',
    'fa-solid fa-ghost fa-fw',
    'fa-brands fa-apple fa-fw',
    'fa-solid fa-mug-hot fa-fw',
    'fa-solid fa-circle-user fa-fw',
    'fa-solid fa-rocket-launch fa-fw',
    'fa-solid fa-pen fa-fw',
    'fa-brands fa-google fa-fw',
    'fa-solid fa-umbrella fa-fw',
    'fa-solid fa-gift fa-fw',
    'fa-solid fa-film fa-fw',
    'fa-solid fa-grid-2 fa-fw',
    'fa-brands fa-stripe fa-fw',
    'fa-solid fa-list fa-fw',
    'fa-solid fa-gear fa-fw',
    'fa-brands fa-algolia fa-fw',
    'fa-solid fa-trash fa-fw',
    'fa-solid fa-circle-up fa-fw',
    'fa-brands fa-docker fa-fw',
    'fa-solid fa-circle-down fa-fw',
    'fa-solid fa-inbox fa-fw',
    'fa-solid fa-rotate-right fa-fw',
    'fa-solid fa-sparkles fa-fw',
    'fa-solid fa-lock fa-fw',
    'fa-brands fa-windows fa-fw',
    'fa-solid fa-headphones fa-fw',
    'fa-solid fa-volume fa-fw',
    'fa-solid fa-barcode fa-fw',
    'fa-solid fa-tag fa-fw',
    'fa-solid fa-book fa-fw',
    'fa-solid fa-bookmark fa-fw',
    'fa-brands fa-paypal fa-fw',
    'fa-solid fa-print fa-fw',
    'fa-solid fa-camera fa-fw',
    'fa-brands fa-stack-overflow fa-fw',
    'fa-solid fa-font fa-fw',
    'fa-solid fa-video fa-fw',
    'fa-solid fa-circle-half-stroke fa-fw',
    'fa-solid fa-droplet fa-fw',
    'fa-solid fa-pen-to-square fa-fw',
    'fa-solid fa-share-from-square fa-fw',
    'fa-solid fa-plus fa-fw',
    'fa-solid fa-minus fa-fw',
    'fa-brands fa-kickstarter fa-fw',
    'fa-solid fa-share fa-fw',
    'fa-solid fa-circle-exclamation fa-fw',
    'fa-solid fa-fire fa-fw',
    'fa-solid fa-eye fa-fw',
    'fa-solid fa-eye-slash fa-fw',
    'fa-brands fa-dribbble fa-fw',
    'fa-solid fa-plane fa-fw',
    'fa-solid fa-magnet fa-fw',
    'fa-solid fa-hand fa-fw',
    'fa-solid fa-folder fa-fw',
    'fa-solid fa-folder-open fa-fw',
    'fa-solid fa-money-bill fa-fw',
    'fa-brands fa-dropbox fa-fw',
    'fa-solid fa-thumbs-up fa-fw',
    'fa-solid fa-thumbs-down fa-fw',
    'fa-solid fa-comments fa-fw',
    'fa-solid fa-grill-hot fa-fw',
    'fa-solid fa-lemon fa-fw',
    'fa-solid fa-key fa-fw',
    'fa-solid fa-thumbtack fa-fw',
    'fa-solid fa-gears fa-fw',
    'fa-solid fa-paper-plane fa-fw',
    'fa-solid fa-code fa-fw',
    'fa-brands fa-squarespace fa-fw',
    'fa-solid fa-globe fa-fw',
    'fa-solid fa-text fa-fw',
    'fa-solid fa-arrow-down-to-line fa-fw',
    'fa-solid fa-truck fa-fw',
    'fa-solid fa-city fa-fw',
    'fa-solid fa-ticket fa-fw',
    'fa-solid fa-tree fa-fw',
    'fa-solid fa-wifi fa-fw',
    'fa-solid fa-window fa-fw',
    'fa-solid fa-burger-soda fa-fw',
    'fa-solid fa-camera-movie fa-fw',
    'fa-solid fa-paint-roller fa-fw',
    'fa-solid fa-bicycle fa-fw',
    'fa-brands fa-android fa-fw',
    'fa-solid fa-sliders fa-fw',
    'fa-solid fa-brush fa-fw',
    'fa-solid fa-hashtag fa-fw',
    'fa-solid fa-megaphone fa-fw',
    'fa-solid fa-flask fa-fw',
    'fa-solid fa-briefcase fa-fw',
    'fa-solid fa-compass fa-fw',
    'fa-solid fa-dumpster-fire fa-fw',
    'fa-solid fa-person fa-fw',
    'fa-solid fa-person-dress fa-fw',
    'fa-brands fa-shopify fa-fw',
    'fa-solid fa-balloons fa-fw',
    'fa-solid fa-address-book fa-fw',
    'fa-solid fa-bath fa-fw',
    'fa-solid fa-handshake fa-fw',
    'fa-brands fa-medium fa-fw',
    'fa-solid fa-snowflake fa-fw',
    'fa-solid fa-right-to-bracket fa-fw',
    'fa-solid fa-earth-americas fa-fw',
    'fa-solid fa-cloud-arrow-up fa-fw',
    'fa-solid fa-binoculars fa-fw',
    'fa-solid fa-palette fa-fw',
    'fa-brands fa-codepen fa-fw',
    'fa-solid fa-layer-group fa-fw',
    'fa-solid fa-brackets-curly fa-fw',
    'fa-solid fa-users fa-fw',
    'fa-solid fa-gamepad fa-fw',
    'fa-solid fa-business-time fa-fw',
    'fa-brands fa-cloudflare fa-fw',
    'fa-solid fa-feather fa-fw',
    'fa-solid fa-sun fa-fw',
    'fa-solid fa-computer-classic fa-fw',
    'fa-solid fa-link fa-fw',
    'fa-solid fa-pen-fancy fa-fw',
    'fa-brands fa-airbnb fa-fw',
    'fa-solid fa-badge-check fa-fw',
    'fa-solid fa-fish fa-fw',
    'fa-solid fa-joystick fa-fw',
    'fa-solid fa-play-pause fa-fw',
    'fa-solid fa-bug fa-fw',
    'fa-solid fa-shop fa-fw',
    'fa-solid fa-mug-saucer fa-fw',
    'fa-solid fa-planet-ringed fa-fw',
    'fa-brands fa-vimeo fa-fw',
    'fa-solid fa-landmark fa-fw',
    'fa-solid fa-campfire fa-fw',
    'fa-solid fa-poo-storm fa-fw',
    'fa-brands fa-whatsapp fa-fw',
    'fa-solid fa-chart-simple fa-fw',
    'fa-solid fa-shirt fa-fw',
    'fa-solid fa-files fa-fw',
    'fa-solid fa-dolphin fa-fw',
    'fa-solid fa-anchor fa-fw',
    'fa-solid fa-quote-left fa-fw',
    'fa-solid fa-atom-simple fa-fw',
    'fa-solid fa-bag-shopping fa-fw',
    'fa-solid fa-bed-front fa-fw',
    'fa-solid fa-people-simple fa-fw',
    'fa-solid fa-gauge fa-fw',
    'fa-solid fa-signal-bars fa-fw',
    'fa-solid fa-code-compare fa-fw',
    'fa-solid fa-user-secret fa-fw',
    'fa-solid fa-stethoscope fa-fw',
    'fa-solid fa-car-side fa-fw',
    'fa-solid fa-hand-holding-heart fa-fw',
    'fa-solid fa-ufo fa-fw',
    'fa-solid fa-alien-8bit fa-fw',
    'fa-solid fa-block-question fa-fw',
    'fa-solid fa-aperture fa-fw',
    'fa-solid fa-bird fa-fw',
    'fa-solid fa-strawberry fa-fw',
    'fa-solid fa-envelopes fa-fw',
    'fa-brands fa-intercom fa-fw',
    'fa-solid fa-face-vomit fa-fw',
    'fa-solid fa-fort fa-fw',
    'fa-solid fa-truck-front fa-fw',
    'fa-solid fa-crab fa-fw',
    'fa-solid fa-user-bounty-hunter fa-fw',
    'fa-solid fa-thought-bubble fa-fw',
    'fa-solid fa-cable-car fa-fw',
    'fa-solid fa-mountain-sun fa-fw',
    'fa-solid fa-traffic-cone fa-fw',
    'fa-solid fa-diagram-venn fa-fw',
    'fa-solid fa-bowl-chopsticks-noodles fa-fw',
    'fa-solid fa-moped fa-fw',
    'fa-solid fa-burrito fa-fw',
    'fa-solid fa-robot-astromech fa-fw',
    'fa-solid fa-bat fa-fw',
    'fa-solid fa-location-pin fa-fw',
    'fa-solid fa-info fa-fw',
    'fa-solid fa-user-minus fa-fw',
    'fa-solid fa-calendar fa-fw',
    'fa-solid fa-cart-plus fa-fw',
    'fa-solid fa-clock fa-fw',
    'fa-solid fa-person-sign fa-fw',
    'fa-solid fa-circle fa-fw',
    'fa-solid fa-play fa-fw',
    'fa-solid fa-cross fa-fw',
    'fa-solid fa-backward fa-fw',
    'fa-solid fa-chart-scatter fa-fw',
    'fa-solid fa-handshake-slash fa-fw',
    'fa-solid fa-chevron-up fa-fw',
    'fa-solid fa-passport fa-fw',
    'fa-brands fa-usps fa-fw',
    'fa-solid fa-question fa-fw',
    'fa-solid fa-pencil fa-fw',
    'fa-solid fa-phone-volume fa-fw',
    'fa-brands fa-wix fa-fw',
    'fa-solid fa-car-building fa-fw',
    'fa-solid fa-head-side fa-fw',
    'fa-solid fa-upload fa-fw',
    'fa-solid fa-strikethrough fa-fw',
    'fa-solid fa-computer-speaker fa-fw',
    'fa-brands fa-line fa-fw',
    'fa-solid fa-credit-card fa-fw',
    'fa-solid fa-street-view fa-fw',
    'fa-solid fa-database fa-fw',
    'fa-solid fa-copy fa-fw',
    'fa-solid fa-mobile fa-fw',
    'fa-solid fa-square fa-fw',
    'fa-solid fa-sort fa-fw',
    'fa-solid fa-forward fa-fw',
    'fa-solid fa-hourglass-start fa-fw',
    'fa-brands fa-behance fa-fw',
    'fa-solid fa-signal-slash fa-fw',
    'fa-solid fa-newspaper fa-fw',
    'fa-solid fa-notes-medical fa-fw',
    'fa-solid fa-table fa-fw',
    'fa-solid fa-building fa-fw',
    'fa-solid fa-globe-stand fa-fw',
    'fa-solid fa-square-heart fa-fw',
    'fa-solid fa-stop fa-fw',
    'fa-brands fa-openid fa-fw',
    'fa-solid fa-tally fa-fw',
    'fa-solid fa-store fa-fw',
    'fa-solid fa-flag fa-fw',
    'fa-brands fa-product-hunt fa-fw',
    'fa-solid fa-lightbulb-slash fa-fw',
    'fa-solid fa-file-excel fa-fw',
    'fa-solid fa-browser fa-fw',
    'fa-solid fa-network-wired fa-fw',
    'fa-solid fa-cash-register fa-fw',
    'fa-solid fa-file-export fa-fw',
    'fa-brands fa-internet-explorer fa-fw',
    'fa-solid fa-hand-point-up fa-fw',
    'fa-brands fa-pagelines fa-fw',
    'fa-solid fa-angle-up fa-fw',
    'fa-solid fa-shield fa-fw',
    'fa-brands fa-teamspeak fa-fw',
    'fa-solid fa-border-top fa-fw',
    'fa-solid fa-address-card fa-fw',
    'fa-solid fa-expand fa-fw',
    'fa-solid fa-flag-checkered fa-fw',
    'fa-brands fa-html5 fa-fw',
    'fa-solid fa-quote-right fa-fw',
    'fa-solid fa-tags fa-fw',
    'fa-solid fa-server fa-fw',
    'fa-solid fa-user-nurse fa-fw',
    'fa-solid fa-video-slash fa-fw',
    'fa-solid fa-arrow-down fa-fw',
    'fa-solid fa-blog fa-fw',
    'fa-solid fa-school fa-fw',
    'fa-solid fa-file-invoice fa-fw',
    'fa-solid fa-rocket fa-fw',
    'fa-solid fa-coin fa-fw',
    'fa-solid fa-spinner fa-fw',
    'fa-brands fa-telegram fa-fw',
    'fa-solid fa-square-question fa-fw',
    'fa-solid fa-tty fa-fw',
    'fa-solid fa-exclamation fa-fw',
    'fa-solid fa-water fa-fw',
    'fa-solid fa-shield-check fa-fw',
    'fa-solid fa-registered fa-fw',
    'fa-solid fa-empty-set fa-fw',
    'fa-solid fa-signature fa-fw',
    'fa-solid fa-laptop fa-fw',
    'fa-solid fa-phone-office fa-fw',
    'fa-solid fa-line-height fa-fw',
    'fa-solid fa-transporter-3 fa-fw',
    'fa-solid fa-projector fa-fw',
    'fa-solid fa-moon-stars fa-fw',
    'fa-solid fa-restroom fa-fw',
    'fa-solid fa-power-off fa-fw',
    'fa-solid fa-sitemap fa-fw',
    'fa-solid fa-icons fa-fw',
    'fa-solid fa-desktop fa-fw',
    'fa-solid fa-moon fa-fw',
    'fa-solid fa-basketball-hoop fa-fw',
    'fa-solid fa-loveseat fa-fw',
    'fa-solid fa-square-info fa-fw',
    'fa-solid fa-calendar-week fa-fw',
    'fa-brands fa-pinterest fa-fw',
    'fa-solid fa-pause fa-fw',
    'fa-solid fa-file-word fa-fw',
    'fa-solid fa-triangle fa-fw',
    'fa-solid fa-watch fa-fw',
    'fa-solid fa-vials fa-fw',
    'fa-solid fa-language fa-fw',
    'fa-solid fa-door-open fa-fw',
    'fa-solid fa-brain fa-fw',
    'fa-solid fa-hotel fa-fw',
    'fa-solid fa-marker fa-fw',
    'fa-solid fa-star-of-life fa-fw',
    'fa-solid fa-leaf fa-fw',
    'fa-solid fa-walkie-talkie fa-fw',
    'fa-solid fa-person-dolly-empty fa-fw',
    'fa-solid fa-shower fa-fw',
    'fa-brands fa-dashcube fa-fw',
    'fa-solid fa-glass fa-fw',
    'fa-solid fa-mailbox fa-fw',
    'fa-solid fa-caret-down fa-fw',
    'fa-brands fa-ideal fa-fw',
    'fa-solid fa-light-switch fa-fw',
    'fa-brands fa-salesforce fa-fw',
    'fa-solid fa-badge fa-fw',
    'fa-solid fa-file-import fa-fw',
    'fa-solid fa-typewriter fa-fw',
    'fa-solid fa-place-of-worship fa-fw',
    'fa-solid fa-flower fa-fw',
    'fa-solid fa-spinner-third fa-fw',
    'fa-solid fa-wallet fa-fw',
    'fa-solid fa-slash fa-fw',
    'fa-brands fa-readme fa-fw',
    'fa-solid fa-computer-mouse-scrollwheel fa-fw',
    'fa-solid fa-award fa-fw',
    'fa-solid fa-toggle-on fa-fw',
    'fa-solid fa-ship fa-fw',
    'fa-brands fa-free-code-camp fa-fw',
    'fa-solid fa-file-check fa-fw',
    'fa-brands fa-soundcloud fa-fw',
    'fa-solid fa-stocking fa-fw',
    'fa-solid fa-chalkboard fa-fw',
    'fa-brands fa-square-twitter fa-fw',
    'fa-solid fa-planet-moon fa-fw',
    'fa-solid fa-lights-holiday fa-fw',
    'fa-solid fa-hands fa-fw',
    'fa-solid fa-signal fa-fw',
    'fa-solid fa-radar fa-fw',
    'fa-solid fa-motorcycle fa-fw',
    'fa-solid fa-booth-curtain fa-fw',
    'fa-solid fa-arrow-up-right-from-square fa-fw',
    'fa-solid fa-audio-description fa-fw',
    'fa-brands fa-accessible-icon fa-fw',
    'fa-solid fa-seedling fa-fw',
    'fa-solid fa-closed-captioning fa-fw',
    'fa-solid fa-text-size fa-fw',
    'fa-solid fa-train fa-fw',
    'fa-brands fa-cc-visa fa-fw',
    'fa-solid fa-arrow-left fa-fw',
    'fa-solid fa-books fa-fw',
    'fa-solid fa-wrench fa-fw',
    'fa-solid fa-microchip fa-fw',
    'fa-solid fa-record-vinyl fa-fw',
    'fa-brands fa-goodreads-g fa-fw',
    'fa-solid fa-trophy fa-fw',
    'fa-solid fa-hammer fa-fw',
    'fa-solid fa-diamond fa-fw',
    'fa-solid fa-robot fa-fw',
    'fa-solid fa-file-pdf fa-fw',
    'fa-solid fa-tablet-rugged fa-fw',
    'fa-brands fa-google-play fa-fw',
    'fa-solid fa-hospital fa-fw',
    'fa-solid fa-file-contract fa-fw',
    'fa-solid fa-square-xmark fa-fw',
    'fa-solid fa-square-check fa-fw',
    'fa-solid fa-stars fa-fw',
    'fa-solid fa-crown fa-fw',
    'fa-brands fa-react fa-fw',
    'fa-solid fa-speaker fa-fw',
    'fa-solid fa-ballot-check fa-fw',
    'fa-solid fa-speakers fa-fw',
    'fa-solid fa-user-plus fa-fw',
    'fa-solid fa-mug-tea fa-fw',
    'fa-solid fa-solar-system fa-fw',
    'fa-solid fa-virus fa-fw',
    'fa-solid fa-child fa-fw',
    'fa-solid fa-scanner-touchscreen fa-fw',
    'fa-solid fa-repeat fa-fw',
    'fa-solid fa-cube fa-fw',
    'fa-solid fa-copyright fa-fw',
    'fa-solid fa-medal fa-fw',
    'fa-solid fa-bullseye fa-fw',
    'fa-solid fa-mask fa-fw',
    'fa-solid fa-meat fa-fw',
    'fa-solid fa-circle-check fa-fw',
    'fa-solid fa-radio fa-fw',
    'fa-solid fa-reply fa-fw',
    'fa-solid fa-album fa-fw',
    'fa-solid fa-chair fa-fw',
    'fa-solid fa-route fa-fw',
    'fa-brands fa-wikipedia-w fa-fw',
    'fa-solid fa-plug fa-fw',
    'fa-solid fa-calculator fa-fw',
    'fa-solid fa-dragon fa-fw',
    'fa-solid fa-certificate fa-fw',
    'fa-solid fa-fingerprint fa-fw',
    'fa-solid fa-road fa-fw',
    'fa-solid fa-crosshairs fa-fw',
    'fa-solid fa-heading fa-fw',
    'fa-solid fa-percent fa-fw',
    'fa-brands fa-square-js fa-fw',
    'fa-solid fa-user-tie fa-fw',
    'fa-brands fa-java fa-fw',
    'fa-solid fa-square-minus fa-fw',
    'fa-solid fa-i-cursor fa-fw',
    'fa-solid fa-church fa-fw',
    'fa-solid fa-joint fa-fw',
    'fa-solid fa-container-storage fa-fw',
    'fa-solid fa-comments-dollar fa-fw',
    'fa-solid fa-truck-monster fa-fw',
    'fa-solid fa-recycle fa-fw',
    'fa-brands fa-square-pinterest fa-fw',
    'fa-solid fa-warehouse fa-fw',
    'fa-solid fa-ruler fa-fw',
    'fa-solid fa-font-case fa-fw',
    'fa-brands fa-python fa-fw',
    'fa-solid fa-police-box fa-fw',
    'fa-solid fa-soap fa-fw',
    'fa-solid fa-starship-freighter fa-fw',
    'fa-solid fa-bullseye-pointer fa-fw',
    'fa-solid fa-blanket fa-fw',
    'fa-solid fa-scroll fa-fw',
    'fa-brands fa-skype fa-fw',
    'fa-solid fa-coins fa-fw',
    'fa-solid fa-house-night fa-fw',
    'fa-solid fa-alarm-snooze fa-fw',
    'fa-solid fa-wind fa-fw',
    'fa-solid fa-baby fa-fw',
    'fa-solid fa-lightbulb fa-fw',
    'fa-solid fa-file-exclamation fa-fw',
    'fa-solid fa-transporter-empty fa-fw',
    'fa-brands fa-linux fa-fw',
    'fa-solid fa-cauldron fa-fw',
    'fa-brands fa-node fa-fw',
    'fa-brands fa-rebel fa-fw',
    'fa-solid fa-voicemail fa-fw',
    'fa-solid fa-puzzle-piece fa-fw',
    'fa-solid fa-keyboard fa-fw',
    'fa-solid fa-clone fa-fw',
    'fa-solid fa-eraser fa-fw',
    'fa-solid fa-wine-bottle fa-fw',
    'fa-solid fa-dice fa-fw',
    'fa-solid fa-file-spreadsheet fa-fw',
    'fa-solid fa-receipt fa-fw',
    'fa-solid fa-ring fa-fw',
    'fa-brands fa-etsy fa-fw',
    'fa-solid fa-lamp fa-fw',
    'fa-solid fa-wagon-covered fa-fw',
    'fa-solid fa-unlock fa-fw',
    'fa-brands fa-discourse fa-fw',
    'fa-solid fa-solar-panel fa-fw',
    'fa-solid fa-ruler-vertical fa-fw',
    'fa-solid fa-circle-notch fa-fw',
    'fa-solid fa-people-arrows fa-fw',
    'fa-solid fa-flower-tulip fa-fw',
    'fa-solid fa-draw-square fa-fw',
    'fa-solid fa-engine-warning fa-fw',
    'fa-solid fa-raindrops fa-fw',
    'fa-solid fa-rectangle-wide fa-fw',
    'fa-solid fa-dollar-sign fa-fw',
    'fa-brands fa-amazon fa-fw',
    'fa-solid fa-tablet fa-fw',
    'fa-solid fa-not-equal fa-fw',
    'fa-solid fa-glasses fa-fw',
    'fa-solid fa-headset fa-fw',
    'fa-solid fa-code-branch fa-fw',
    'fa-brands fa-glide-g fa-fw',
    'fa-solid fa-gopuram fa-fw',
    'fa-solid fa-images fa-fw',
    'fa-solid fa-window-restore fa-fw',
    'fa-solid fa-industry fa-fw',
    'fa-brands fa-gitlab fa-fw',
    'fa-brands fa-spotify fa-fw',
    'fa-solid fa-staff fa-fw',
    'fa-solid fa-stamp fa-fw',
    'fa-solid fa-microphone-slash fa-fw',
    'fa-brands fa-think-peaks fa-fw',
    'fa-solid fa-align-slash fa-fw',
    'fa-brands fa-microsoft fa-fw',
    'fa-solid fa-cookie-bite fa-fw',
    'fa-solid fa-otter fa-fw',
    'fa-solid fa-chevron-down fa-fw',
    'fa-solid fa-kiwi-bird fa-fw',
    'fa-solid fa-viruses fa-fw',
    'fa-brands fa-elementor fa-fw',
    'fa-brands fa-pied-piper fa-fw',
    'fa-solid fa-kidneys fa-fw',
    'fa-solid fa-users-medical fa-fw',
    'fa-brands fa-square-youtube fa-fw',
    'fa-solid fa-umbrella-beach fa-fw',
    'fa-solid fa-microwave fa-fw',
    'fa-solid fa-subscript fa-fw',
    'fa-solid fa-tablets fa-fw',
    'fa-brands fa-cc-mastercard fa-fw',
    'fa-brands fa-facebook-messenger fa-fw',
    'fa-brands fa-atlassian fa-fw',
    'fa-solid fa-knife-kitchen fa-fw',
    'fa-solid fa-game-console-handheld fa-fw',
    'fa-brands fa-playstation fa-fw',
    'fa-brands fa-fly fa-fw',
    'fa-solid fa-transporter fa-fw',
    'fa-solid fa-microphone fa-fw',
    'fa-brands fa-meetup fa-fw',
    'fa-solid fa-blinds-raised fa-fw',
    'fa-solid fa-border-none fa-fw',
    'fa-solid fa-dumbbell fa-fw',
    'fa-brands fa-twitch fa-fw',
    'fa-solid fa-plane-departure fa-fw',
    'fa-brands fa-waze fa-fw',
    'fa-solid fa-z fa-fw',
    'fa-solid fa-yin-yang fa-fw',
    'fa-solid fa-yen-sign fa-fw',
    'fa-solid fa-y fa-fw',
    'fa-solid fa-xmarks-lines fa-fw',
    'fa-solid fa-xmark-to-slot fa-fw',
    'fa-solid fa-xmark-large fa-fw',
    'fa-solid fa-x-ray fa-fw',
    'fa-solid fa-x fa-fw',
    'fa-solid fa-wrench-simple fa-fw',
    'fa-solid fa-wreath-laurel fa-fw',
    'fa-solid fa-wreath fa-fw',
    'fa-solid fa-worm fa-fw',
    'fa-solid fa-won-sign fa-fw',
    'fa-solid fa-wine-glass-empty fa-fw',
    'fa-solid fa-wine-glass-crack fa-fw',
    'fa-solid fa-wine-glass fa-fw',
    'fa-solid fa-windsock fa-fw',
    'fa-solid fa-window-minimize fa-fw',
    'fa-solid fa-window-maximize fa-fw',
    'fa-solid fa-window-frame-open fa-fw',
    'fa-solid fa-window-frame fa-fw',
    'fa-solid fa-window-flip fa-fw',
    'fa-solid fa-wind-warning fa-fw',
    'fa-solid fa-wind-turbine fa-fw',
    'fa-solid fa-wifi-weak fa-fw',
    'fa-solid fa-wifi-slash fa-fw',
    'fa-solid fa-wifi-fair fa-fw',
    'fa-solid fa-wifi-exclamation fa-fw',
    'fa-solid fa-whistle fa-fw',
    'fa-solid fa-whiskey-glass-ice fa-fw',
    'fa-solid fa-whiskey-glass fa-fw',
    'fa-solid fa-wheelchair-move fa-fw',
    'fa-solid fa-wheelchair fa-fw',
    'fa-solid fa-wheat-slash fa-fw',
    'fa-solid fa-wheat-awn-slash fa-fw',
    'fa-solid fa-wheat-awn-circle-exclamation fa-fw',
    'fa-solid fa-wheat-awn fa-fw',
    'fa-solid fa-wheat fa-fw',
    'fa-solid fa-whale fa-fw',
    'fa-solid fa-weight-scale fa-fw',
    'fa-solid fa-weight-hanging fa-fw',
    'fa-solid fa-webhook fa-fw',
    'fa-solid fa-waveform-lines fa-fw',
    'fa-solid fa-waveform fa-fw',
    'fa-solid fa-wave-triangle fa-fw',
    'fa-solid fa-wave-square fa-fw',
    'fa-solid fa-wave-sine fa-fw',
    'fa-solid fa-wave-pulse fa-fw',
    'fa-solid fa-watermelon-slice fa-fw',
    'fa-solid fa-water-ladder fa-fw',
    'fa-solid fa-water-arrow-up fa-fw',
    'fa-solid fa-water-arrow-down fa-fw',
    'fa-solid fa-watch-smart fa-fw',
    'fa-solid fa-watch-fitness fa-fw',
    'fa-solid fa-watch-calculator fa-fw',
    'fa-solid fa-watch-apple fa-fw',
    'fa-solid fa-washing-machine fa-fw',
    'fa-solid fa-warehouse-full fa-fw',
    'fa-solid fa-wand-sparkles fa-fw',
    'fa-solid fa-wand-magic fa-fw',
    'fa-solid fa-wand fa-fw',
    'fa-solid fa-walker fa-fw',
    'fa-solid fa-waffle fa-fw',
    'fa-solid fa-w fa-fw',
    'fa-solid fa-vr-cardboard fa-fw',
    'fa-solid fa-volume-xmark fa-fw',
    'fa-solid fa-volume-slash fa-fw',
    'fa-solid fa-volume-off fa-fw',
    'fa-solid fa-volume-low fa-fw',
    'fa-solid fa-volume-high fa-fw',
    'fa-solid fa-volleyball fa-fw',
    'fa-solid fa-volcano fa-fw',
    'fa-solid fa-virus-slash fa-fw',
    'fa-solid fa-virus-covid-slash fa-fw',
    'fa-solid fa-virus-covid fa-fw',
    'fa-solid fa-violin fa-fw',
    'fa-solid fa-vihara fa-fw',
    'fa-solid fa-video-plus fa-fw',
    'fa-solid fa-video-arrow-up-right fa-fw',
    'fa-solid fa-video-arrow-down-left fa-fw',
    'fa-solid fa-vial-virus fa-fw',
    'fa-solid fa-vial-circle-check fa-fw',
    'fa-solid fa-vial fa-fw',
    'fa-solid fa-vest-patches fa-fw',
    'fa-solid fa-vest fa-fw',
    'fa-solid fa-venus-mars fa-fw',
    'fa-solid fa-venus-double fa-fw',
    'fa-solid fa-venus fa-fw',
    'fa-solid fa-vent-damper fa-fw',
    'fa-solid fa-vector-square fa-fw',
    'fa-solid fa-vector-polygon fa-fw',
    'fa-solid fa-vector-circle fa-fw',
    'fa-solid fa-vault fa-fw',
    'fa-solid fa-van-shuttle fa-fw',
    'fa-solid fa-value-absolute fa-fw',
    'fa-solid fa-vacuum-robot fa-fw',
    'fa-solid fa-vacuum fa-fw',
    'fa-solid fa-v fa-fw',
    'fa-solid fa-utility-pole-double fa-fw',
    'fa-solid fa-utility-pole fa-fw',
    'fa-solid fa-utensils-slash fa-fw',
    'fa-solid fa-utensils fa-fw',
    'fa-solid fa-users-viewfinder fa-fw',
    'fa-solid fa-users-slash fa-fw',
    'fa-solid fa-users-rectangle fa-fw',
    'fa-solid fa-users-rays fa-fw',
    'fa-solid fa-users-line fa-fw',
    'fa-solid fa-users-gear fa-fw',
    'fa-solid fa-users-between-lines fa-fw',
    'fa-solid fa-user-xmark fa-fw',
    'fa-solid fa-user-vneck-hair-long fa-fw',
    'fa-solid fa-user-vneck-hair fa-fw',
    'fa-solid fa-user-vneck fa-fw',
    'fa-solid fa-user-visor fa-fw',
    'fa-solid fa-user-unlock fa-fw',
    'fa-solid fa-user-tie-hair-long fa-fw',
    'fa-solid fa-user-tie-hair fa-fw',
    'fa-solid fa-user-tag fa-fw',
    'fa-solid fa-user-slash fa-fw',
    'fa-solid fa-user-shield fa-fw',
    'fa-solid fa-user-shakespeare fa-fw',
    'fa-solid fa-user-robot-xmarks fa-fw',
    'fa-solid fa-user-robot fa-fw',
    'fa-solid fa-user-police-tie fa-fw',
    'fa-solid fa-user-police fa-fw',
    'fa-solid fa-user-pilot-tie fa-fw',
    'fa-solid fa-user-pilot fa-fw',
    'fa-solid fa-user-pen fa-fw',
    'fa-solid fa-user-nurse-hair-long fa-fw',
    'fa-solid fa-user-nurse-hair fa-fw',
    'fa-solid fa-user-ninja fa-fw',
    'fa-solid fa-user-music fa-fw',
    'fa-solid fa-user-magnifying-glass fa-fw',
    'fa-solid fa-user-lock fa-fw',
    'fa-solid fa-user-large-slash fa-fw',
    'fa-solid fa-user-large fa-fw',
    'fa-solid fa-user-injured fa-fw',
    'fa-solid fa-user-helmet-safety fa-fw',
    'fa-solid fa-user-headset fa-fw',
    'fa-solid fa-user-hair-mullet fa-fw',
    'fa-solid fa-user-hair-long fa-fw',
    'fa-solid fa-user-hair-buns fa-fw',
    'fa-solid fa-user-hair fa-fw',
    'fa-solid fa-user-group-simple fa-fw',
    'fa-solid fa-user-group-crown fa-fw',
    'fa-solid fa-user-group fa-fw',
    'fa-solid fa-user-graduate fa-fw',
    'fa-solid fa-user-gear fa-fw',
    'fa-solid fa-user-doctor-message fa-fw',
    'fa-solid fa-user-doctor-hair-long fa-fw',
    'fa-solid fa-user-doctor-hair fa-fw',
    'fa-solid fa-user-doctor fa-fw',
    'fa-solid fa-user-crown fa-fw',
    'fa-solid fa-user-cowboy fa-fw',
    'fa-solid fa-user-clock fa-fw',
    'fa-solid fa-user-chef fa-fw',
    'fa-solid fa-user-check fa-fw',
    'fa-solid fa-user-astronaut fa-fw',
    'fa-solid fa-user-alien fa-fw',
    'fa-solid fa-usb-drive fa-fw',
    'fa-solid fa-up-to-line fa-fw',
    'fa-solid fa-up-to-dotted-line fa-fw',
    'fa-solid fa-up-right-from-square fa-fw',
    'fa-solid fa-up-right-and-down-left-from-center fa-fw',
    'fa-solid fa-up-right fa-fw',
    'fa-solid fa-up-long fa-fw',
    'fa-solid fa-up-left fa-fw',
    'fa-solid fa-up-from-line fa-fw',
    'fa-solid fa-up-from-dotted-line fa-fw',
    'fa-solid fa-up-from-bracket fa-fw',
    'fa-solid fa-up-down-left-right fa-fw',
    'fa-solid fa-up-down fa-fw',
    'fa-solid fa-up fa-fw',
    'fa-solid fa-unlock-keyhole fa-fw',
    'fa-solid fa-universal-access fa-fw',
    'fa-solid fa-union fa-fw',
    'fa-solid fa-uniform-martial-arts fa-fw',
    'fa-solid fa-unicorn fa-fw',
    'fa-solid fa-underline fa-fw',
    'fa-solid fa-umbrella-simple fa-fw',
    'fa-solid fa-ufo-beam fa-fw',
    'fa-solid fa-u fa-fw',
    'fa-solid fa-tv-retro fa-fw',
    'fa-solid fa-tv-music fa-fw',
    'fa-solid fa-tv fa-fw',
    'fa-solid fa-turtle fa-fw',
    'fa-solid fa-turntable fa-fw',
    'fa-solid fa-turn-up fa-fw',
    'fa-solid fa-turn-down-right fa-fw',
    'fa-solid fa-turn-down-left fa-fw',
    'fa-solid fa-turn-down fa-fw',
    'fa-solid fa-turkish-lira-sign fa-fw',
    'fa-solid fa-turkey fa-fw',
    'fa-solid fa-tugrik-sign fa-fw',
    'fa-solid fa-tty-answer fa-fw',
    'fa-solid fa-trumpet fa-fw',
    'fa-solid fa-truck-tow fa-fw',
    'fa-solid fa-truck-ramp-couch fa-fw',
    'fa-solid fa-truck-ramp-box fa-fw',
    'fa-solid fa-truck-ramp fa-fw',
    'fa-solid fa-truck-plow fa-fw',
    'fa-solid fa-truck-plane fa-fw',
    'fa-solid fa-truck-pickup fa-fw',
    'fa-solid fa-truck-moving fa-fw',
    'fa-solid fa-truck-medical fa-fw',
    'fa-solid fa-truck-flatbed fa-fw',
    'fa-solid fa-truck-field-un fa-fw',
    'fa-solid fa-truck-field fa-fw',
    'fa-solid fa-truck-droplet fa-fw',
    'fa-solid fa-truck-container-empty fa-fw',
    'fa-solid fa-truck-container fa-fw',
    'fa-solid fa-truck-clock fa-fw',
    'fa-solid fa-truck-bolt fa-fw',
    'fa-solid fa-truck-arrow-right fa-fw',
    'fa-solid fa-trowel-bricks fa-fw',
    'fa-solid fa-trowel fa-fw',
    'fa-solid fa-trophy-star fa-fw',
    'fa-solid fa-trillium fa-fw',
    'fa-solid fa-tricycle-adult fa-fw',
    'fa-solid fa-tricycle fa-fw',
    'fa-solid fa-triangle-person-digging fa-fw',
    'fa-solid fa-triangle-instrument fa-fw',
    'fa-solid fa-triangle-exclamation fa-fw',
    'fa-solid fa-trees fa-fw',
    'fa-solid fa-tree-palm fa-fw',
    'fa-solid fa-tree-large fa-fw',
    'fa-solid fa-tree-decorated fa-fw',
    'fa-solid fa-tree-deciduous fa-fw',
    'fa-solid fa-tree-city fa-fw',
    'fa-solid fa-tree-christmas fa-fw',
    'fa-solid fa-treasure-chest fa-fw',
    'fa-solid fa-trash-xmark fa-fw',
    'fa-solid fa-trash-undo fa-fw',
    'fa-solid fa-trash-slash fa-fw',
    'fa-solid fa-trash-plus fa-fw',
    'fa-solid fa-trash-list fa-fw',
    'fa-solid fa-trash-clock fa-fw',
    'fa-solid fa-trash-check fa-fw',
    'fa-solid fa-trash-can-xmark fa-fw',
    'fa-solid fa-trash-can-undo fa-fw',
    'fa-solid fa-trash-can-slash fa-fw',
    'fa-solid fa-trash-can-plus fa-fw',
    'fa-solid fa-trash-can-list fa-fw',
    'fa-solid fa-trash-can-clock fa-fw',
    'fa-solid fa-trash-can-check fa-fw',
    'fa-solid fa-trash-can-arrow-up fa-fw',
    'fa-solid fa-trash-can fa-fw',
    'fa-solid fa-trash-arrow-up fa-fw',
    'fa-solid fa-transporter-7 fa-fw',
    'fa-solid fa-transporter-6 fa-fw',
    'fa-solid fa-transporter-5 fa-fw',
    'fa-solid fa-transporter-4 fa-fw',
    'fa-solid fa-transporter-2 fa-fw',
    'fa-solid fa-transporter-1 fa-fw',
    'fa-solid fa-transgender fa-fw',
    'fa-solid fa-transformer-bolt fa-fw',
    'fa-solid fa-train-tunnel fa-fw',
    'fa-solid fa-train-tram fa-fw',
    'fa-solid fa-train-track fa-fw',
    'fa-solid fa-train-subway-tunnel fa-fw',
    'fa-solid fa-train-subway fa-fw',
    'fa-solid fa-trailer fa-fw',
    'fa-solid fa-traffic-light-stop fa-fw',
    'fa-solid fa-traffic-light-slow fa-fw',
    'fa-solid fa-traffic-light-go fa-fw',
    'fa-solid fa-traffic-light fa-fw',
    'fa-solid fa-trademark fa-fw',
    'fa-solid fa-tractor fa-fw',
    'fa-solid fa-tower-observation fa-fw',
    'fa-solid fa-tower-control fa-fw',
    'fa-solid fa-tower-cell fa-fw',
    'fa-solid fa-tower-broadcast fa-fw',
    'fa-solid fa-tornado fa-fw',
    'fa-solid fa-torii-gate fa-fw',
    'fa-solid fa-toothbrush fa-fw',
    'fa-solid fa-tooth fa-fw',
    'fa-solid fa-toolbox fa-fw',
    'fa-solid fa-tombstone-blank fa-fw',
    'fa-solid fa-tombstone fa-fw',
    'fa-solid fa-tomato fa-fw',
    'fa-solid fa-toilets-portable fa-fw',
    'fa-solid fa-toilet-portable fa-fw',
    'fa-solid fa-toilet-paper-xmark fa-fw',
    'fa-solid fa-toilet-paper-under-slash fa-fw',
    'fa-solid fa-toilet-paper-under fa-fw',
    'fa-solid fa-toilet-paper-slash fa-fw',
    'fa-solid fa-toilet-paper-check fa-fw',
    'fa-solid fa-toilet-paper-blank-under fa-fw',
    'fa-solid fa-toilet-paper-blank fa-fw',
    'fa-solid fa-toilet-paper fa-fw',
    'fa-solid fa-toilet fa-fw',
    'fa-solid fa-toggle-off fa-fw',
    'fa-solid fa-toggle-large-on fa-fw',
    'fa-solid fa-toggle-large-off fa-fw',
    'fa-solid fa-tire-rugged fa-fw',
    'fa-solid fa-tire-pressure-warning fa-fw',
    'fa-solid fa-tire-flat fa-fw',
    'fa-solid fa-tire fa-fw',
    'fa-solid fa-timer fa-fw',
    'fa-solid fa-timeline-arrow fa-fw',
    'fa-solid fa-timeline fa-fw',
    'fa-solid fa-tilde fa-fw',
    'fa-solid fa-tickets-airline fa-fw',
    'fa-solid fa-ticket-simple fa-fw',
    'fa-solid fa-ticket-airline fa-fw',
    'fa-solid fa-tick fa-fw',
    'fa-solid fa-theta fa-fw',
    'fa-solid fa-thermometer fa-fw',
    'fa-solid fa-text-width fa-fw',
    'fa-solid fa-text-slash fa-fw',
    'fa-solid fa-text-height fa-fw',
    'fa-solid fa-terminal fa-fw',
    'fa-solid fa-tents fa-fw',
    'fa-solid fa-tent-arrows-down fa-fw',
    'fa-solid fa-tent-arrow-turn-left fa-fw',
    'fa-solid fa-tent-arrow-left-right fa-fw',
    'fa-solid fa-tent-arrow-down-to-line fa-fw',
    'fa-solid fa-tent fa-fw',
    'fa-solid fa-tennis-ball fa-fw',
    'fa-solid fa-tenge-sign fa-fw',
    'fa-solid fa-temperature-three-quarters fa-fw',
    'fa-solid fa-temperature-sun fa-fw',
    'fa-solid fa-temperature-snow fa-fw',
    'fa-solid fa-temperature-quarter fa-fw',
    'fa-solid fa-temperature-low fa-fw',
    'fa-solid fa-temperature-list fa-fw',
    'fa-solid fa-temperature-high fa-fw',
    'fa-solid fa-temperature-half fa-fw',
    'fa-solid fa-temperature-full fa-fw',
    'fa-solid fa-temperature-empty fa-fw',
    'fa-solid fa-temperature-arrow-up fa-fw',
    'fa-solid fa-temperature-arrow-down fa-fw',
    'fa-solid fa-telescope fa-fw',
    'fa-solid fa-teeth-open fa-fw',
    'fa-solid fa-teeth fa-fw',
    'fa-solid fa-teddy-bear fa-fw',
    'fa-solid fa-taxi-bus fa-fw',
    'fa-solid fa-taxi fa-fw',
    'fa-solid fa-tarp-droplet fa-fw',
    'fa-solid fa-tarp fa-fw',
    'fa-solid fa-tape fa-fw',
    'fa-solid fa-tank-water fa-fw',
    'fa-solid fa-tamale fa-fw',
    'fa-solid fa-tally-4 fa-fw',
    'fa-solid fa-tally-3 fa-fw',
    'fa-solid fa-tally-2 fa-fw',
    'fa-solid fa-tally-1 fa-fw',
    'fa-solid fa-taco fa-fw',
    'fa-solid fa-tachograph-digital fa-fw',
    'fa-solid fa-tablet-screen-button fa-fw',
    'fa-solid fa-tablet-screen fa-fw',
    'fa-solid fa-tablet-button fa-fw',
    'fa-solid fa-table-tree fa-fw',
    'fa-solid fa-table-tennis-paddle-ball fa-fw',
    'fa-solid fa-table-rows fa-fw',
    'fa-solid fa-table-pivot fa-fw',
    'fa-solid fa-table-picnic fa-fw',
    'fa-solid fa-table-list fa-fw',
    'fa-solid fa-table-layout fa-fw',
    'fa-solid fa-table-columns fa-fw',
    'fa-solid fa-table-cells-large fa-fw',
    'fa-solid fa-table-cells fa-fw',
    'fa-solid fa-t fa-fw',
    'fa-solid fa-syringe fa-fw',
    'fa-solid fa-synagogue fa-fw',
    'fa-solid fa-symbols fa-fw',
    'fa-solid fa-swords-laser fa-fw',
    'fa-solid fa-swords fa-fw',
    'fa-solid fa-sword-laser-alt fa-fw',
    'fa-solid fa-sword-laser fa-fw',
    'fa-solid fa-sword fa-fw',
    'fa-solid fa-swatchbook fa-fw',
    'fa-solid fa-sushi-roll fa-fw',
    'fa-solid fa-sushi fa-fw',
    'fa-solid fa-superscript fa-fw',
    'fa-solid fa-sunset fa-fw',
    'fa-solid fa-sunrise fa-fw',
    'fa-solid fa-sunglasses fa-fw',
    'fa-solid fa-sun-plant-wilt fa-fw',
    'fa-solid fa-sun-haze fa-fw',
    'fa-solid fa-sun-dust fa-fw',
    'fa-solid fa-sun-cloud fa-fw',
    'fa-solid fa-sun-bright fa-fw',
    'fa-solid fa-suitcase-rolling fa-fw',
    'fa-solid fa-suitcase-medical fa-fw',
    'fa-solid fa-suitcase fa-fw',
    'fa-solid fa-stroopwafel fa-fw',
    'fa-solid fa-stretcher fa-fw',
    'fa-solid fa-store-slash fa-fw',
    'fa-solid fa-store-lock fa-fw',
    'fa-solid fa-stopwatch-20 fa-fw',
    'fa-solid fa-stopwatch fa-fw',
    'fa-solid fa-stomach fa-fw',
    'fa-solid fa-sterling-sign fa-fw',
    'fa-solid fa-steering-wheel fa-fw',
    'fa-solid fa-steak fa-fw',
    'fa-solid fa-starship fa-fw',
    'fa-solid fa-starfighter-twin-ion-engine-advanced fa-fw',
    'fa-solid fa-starfighter-twin-ion-engine fa-fw',
    'fa-solid fa-starfighter fa-fw',
    'fa-solid fa-star-shooting fa-fw',
    'fa-solid fa-star-sharp-half-stroke fa-fw',
    'fa-solid fa-star-sharp-half fa-fw',
    'fa-solid fa-star-sharp fa-fw',
    'fa-solid fa-star-of-david fa-fw',
    'fa-solid fa-star-half-stroke fa-fw',
    'fa-solid fa-star-half fa-fw',
    'fa-solid fa-star-exclamation fa-fw',
    'fa-solid fa-star-christmas fa-fw',
    'fa-solid fa-star-and-crescent fa-fw',
    'fa-solid fa-stapler fa-fw',
    'fa-solid fa-standard-definition fa-fw',
    'fa-solid fa-stairs fa-fw',
    'fa-solid fa-staff-snake fa-fw',
    'fa-solid fa-squirrel fa-fw',
    'fa-solid fa-squid fa-fw',
    'fa-solid fa-square-z fa-fw',
    'fa-solid fa-square-y fa-fw',
    'fa-solid fa-square-x fa-fw',
    'fa-solid fa-square-w fa-fw',
    'fa-solid fa-square-virus fa-fw',
    'fa-solid fa-square-v fa-fw',
    'fa-solid fa-square-user fa-fw',
    'fa-solid fa-square-up-right fa-fw',
    'fa-solid fa-square-up-left fa-fw',
    'fa-solid fa-square-up fa-fw',
    'fa-solid fa-square-u fa-fw',
    'fa-solid fa-square-this-way-up fa-fw',
    'fa-solid fa-square-terminal fa-fw',
    'fa-solid fa-square-t fa-fw',
    'fa-solid fa-square-star fa-fw',
    'fa-solid fa-square-small fa-fw',
    'fa-solid fa-square-sliders-vertical fa-fw',
    'fa-solid fa-square-sliders fa-fw',
    'fa-solid fa-square-share-nodes fa-fw',
    'fa-solid fa-square-s fa-fw',
    'fa-solid fa-square-rss fa-fw',
    'fa-solid fa-square-root-variable fa-fw',
    'fa-solid fa-square-root fa-fw',
    'fa-solid fa-square-ring fa-fw',
    'fa-solid fa-square-right fa-fw',
    'fa-solid fa-square-r fa-fw',
    'fa-solid fa-square-quote fa-fw',
    'fa-solid fa-square-quarters fa-fw',
    'fa-solid fa-square-q fa-fw',
    'fa-solid fa-square-poll-vertical fa-fw',
    'fa-solid fa-square-poll-horizontal fa-fw',
    'fa-solid fa-square-plus fa-fw',
    'fa-solid fa-square-phone-hangup fa-fw',
    'fa-solid fa-square-phone-flip fa-fw',
    'fa-solid fa-square-phone fa-fw',
    'fa-solid fa-square-person-confined fa-fw',
    'fa-solid fa-square-pen fa-fw',
    'fa-solid fa-square-parking-slash fa-fw',
    'fa-solid fa-square-parking fa-fw',
    'fa-solid fa-square-p fa-fw',
    'fa-solid fa-square-o fa-fw',
    'fa-solid fa-square-nfi fa-fw',
    'fa-solid fa-square-n fa-fw',
    'fa-solid fa-square-m fa-fw',
    'fa-solid fa-square-list fa-fw',
    'fa-solid fa-square-left fa-fw',
    'fa-solid fa-square-l fa-fw',
    'fa-solid fa-square-kanban fa-fw',
    'fa-solid fa-square-k fa-fw',
    'fa-solid fa-square-j fa-fw',
    'fa-solid fa-square-i fa-fw',
    'fa-solid fa-square-h fa-fw',
    'fa-solid fa-square-g fa-fw',
    'fa-solid fa-square-full fa-fw',
    'fa-solid fa-square-fragile fa-fw',
    'fa-solid fa-square-f fa-fw',
    'fa-solid fa-square-exclamation fa-fw',
    'fa-solid fa-square-envelope fa-fw',
    'fa-solid fa-square-ellipsis-vertical fa-fw',
    'fa-solid fa-square-ellipsis fa-fw',
    'fa-solid fa-square-e fa-fw',
    'fa-solid fa-square-down-right fa-fw',
    'fa-solid fa-square-down-left fa-fw',
    'fa-solid fa-square-down fa-fw',
    'fa-solid fa-square-dollar fa-fw',
    'fa-solid fa-square-divide fa-fw',
    'fa-solid fa-square-dashed-circle-plus fa-fw',
    'fa-solid fa-square-dashed fa-fw',
    'fa-solid fa-square-d fa-fw',
    'fa-solid fa-square-code fa-fw',
    'fa-solid fa-square-chevron-up fa-fw',
    'fa-solid fa-square-chevron-right fa-fw',
    'fa-solid fa-square-chevron-left fa-fw',
    'fa-solid fa-square-chevron-down fa-fw',
    'fa-solid fa-square-caret-up fa-fw',
    'fa-solid fa-square-caret-right fa-fw',
    'fa-solid fa-square-caret-left fa-fw',
    'fa-solid fa-square-caret-down fa-fw',
    'fa-solid fa-square-c fa-fw',
    'fa-solid fa-square-bolt fa-fw',
    'fa-solid fa-square-b fa-fw',
    'fa-solid fa-square-arrow-up-right fa-fw',
    'fa-solid fa-square-arrow-up-left fa-fw',
    'fa-solid fa-square-arrow-up fa-fw',
    'fa-solid fa-square-arrow-right fa-fw',
    'fa-solid fa-square-arrow-left fa-fw',
    'fa-solid fa-square-arrow-down-right fa-fw',
    'fa-solid fa-square-arrow-down-left fa-fw',
    'fa-solid fa-square-arrow-down fa-fw',
    'fa-solid fa-square-ampersand fa-fw',
    'fa-solid fa-square-a-lock fa-fw',
    'fa-solid fa-square-a fa-fw',
    'fa-solid fa-square-9 fa-fw',
    'fa-solid fa-square-8 fa-fw',
    'fa-solid fa-square-7 fa-fw',
    'fa-solid fa-square-6 fa-fw',
    'fa-solid fa-square-5 fa-fw',
    'fa-solid fa-square-4 fa-fw',
    'fa-solid fa-square-3 fa-fw',
    'fa-solid fa-square-2 fa-fw',
    'fa-solid fa-square-1 fa-fw',
    'fa-solid fa-square-0 fa-fw',
    'fa-solid fa-sprinkler-ceiling fa-fw',
    'fa-solid fa-sprinkler fa-fw',
    'fa-solid fa-spray-can-sparkles fa-fw',
    'fa-solid fa-spray-can fa-fw',
    'fa-solid fa-sportsball fa-fw',
    'fa-solid fa-spoon fa-fw',
    'fa-solid fa-splotch fa-fw',
    'fa-solid fa-split fa-fw',
    'fa-solid fa-spider-web fa-fw',
    'fa-solid fa-spider-black-widow fa-fw',
    'fa-solid fa-spider fa-fw',
    'fa-solid fa-spell-check fa-fw',
    'fa-solid fa-sparkle fa-fw',
    'fa-solid fa-spaghetti-monster-flying fa-fw',
    'fa-solid fa-spade fa-fw',
    'fa-solid fa-space-station-moon-construction fa-fw',
    'fa-solid fa-space-station-moon fa-fw',
    'fa-solid fa-spa fa-fw',
    'fa-solid fa-sort-up fa-fw',
    'fa-solid fa-sort-down fa-fw',
    'fa-solid fa-soft-serve fa-fw',
    'fa-solid fa-socks fa-fw',
    'fa-solid fa-snowplow fa-fw',
    'fa-solid fa-snowman-head fa-fw',
    'fa-solid fa-snowman fa-fw',
    'fa-solid fa-snowflakes fa-fw',
    'fa-solid fa-snowflake-droplets fa-fw',
    'fa-solid fa-snow-blowing fa-fw',
    'fa-solid fa-snooze fa-fw',
    'fa-solid fa-snake fa-fw',
    'fa-solid fa-smoking fa-fw',
    'fa-solid fa-smoke fa-fw',
    'fa-solid fa-smog fa-fw',
    'fa-solid fa-slot-machine fa-fw',
    'fa-solid fa-sliders-up fa-fw',
    'fa-solid fa-sliders-simple fa-fw',
    'fa-solid fa-slider fa-fw',
    'fa-solid fa-sleigh fa-fw',
    'fa-solid fa-slash-forward fa-fw',
    'fa-solid fa-slash-back fa-fw',
    'fa-solid fa-skull-crossbones fa-fw',
    'fa-solid fa-skull-cow fa-fw',
    'fa-solid fa-skull fa-fw',
    'fa-solid fa-ski-boot-ski fa-fw',
    'fa-solid fa-ski-boot fa-fw',
    'fa-solid fa-skeleton-ribs fa-fw',
    'fa-solid fa-skeleton fa-fw',
    'fa-solid fa-siren-on fa-fw',
    'fa-solid fa-siren fa-fw',
    'fa-solid fa-sink fa-fw',
    'fa-solid fa-sim-cards fa-fw',
    'fa-solid fa-sim-card fa-fw',
    'fa-solid fa-signs-post fa-fw',
    'fa-solid fa-signature-slash fa-fw',
    'fa-solid fa-signature-lock fa-fw',
    'fa-solid fa-signal-weak fa-fw',
    'fa-solid fa-signal-strong fa-fw',
    'fa-solid fa-signal-stream-slash fa-fw',
    'fa-solid fa-signal-stream fa-fw',
    'fa-solid fa-signal-good fa-fw',
    'fa-solid fa-signal-fair fa-fw',
    'fa-solid fa-signal-bars-weak fa-fw',
    'fa-solid fa-signal-bars-slash fa-fw',
    'fa-solid fa-signal-bars-good fa-fw',
    'fa-solid fa-signal-bars-fair fa-fw',
    'fa-solid fa-sign-hanging fa-fw',
    'fa-solid fa-sigma fa-fw',
    'fa-solid fa-sidebar-flip fa-fw',
    'fa-solid fa-sidebar fa-fw',
    'fa-solid fa-sickle fa-fw',
    'fa-solid fa-shuttlecock fa-fw',
    'fa-solid fa-shuttle-space fa-fw',
    'fa-solid fa-shutters fa-fw',
    'fa-solid fa-shuffle fa-fw',
    'fa-solid fa-shrimp fa-fw',
    'fa-solid fa-shredder fa-fw',
    'fa-solid fa-shower-down fa-fw',
    'fa-solid fa-shovel-snow fa-fw',
    'fa-solid fa-shovel fa-fw',
    'fa-solid fa-shop-slash fa-fw',
    'fa-solid fa-shop-lock fa-fw',
    'fa-solid fa-shoe-prints fa-fw',
    'fa-solid fa-shish-kebab fa-fw',
    'fa-solid fa-shirt-tank-top fa-fw',
    'fa-solid fa-shirt-running fa-fw',
    'fa-solid fa-shirt-long-sleeve fa-fw',
    'fa-solid fa-shield-xmark fa-fw',
    'fa-solid fa-shield-virus fa-fw',
    'fa-solid fa-shield-slash fa-fw',
    'fa-solid fa-shield-quartered fa-fw',
    'fa-solid fa-shield-plus fa-fw',
    'fa-solid fa-shield-minus fa-fw',
    'fa-solid fa-shield-keyhole fa-fw',
    'fa-solid fa-shield-heart fa-fw',
    'fa-solid fa-shield-exclamation fa-fw',
    'fa-solid fa-shield-dog fa-fw',
    'fa-solid fa-shield-cross fa-fw',
    'fa-solid fa-shield-cat fa-fw',
    'fa-solid fa-shelves-empty fa-fw',
    'fa-solid fa-shelves fa-fw',
    'fa-solid fa-shekel-sign fa-fw',
    'fa-solid fa-sheet-plastic fa-fw',
    'fa-solid fa-sheep fa-fw',
    'fa-solid fa-share-nodes fa-fw',
    'fa-solid fa-share-all fa-fw',
    'fa-solid fa-shapes fa-fw',
    'fa-solid fa-sensor-triangle-exclamation fa-fw',
    'fa-solid fa-sensor-on fa-fw',
    'fa-solid fa-sensor-fire fa-fw',
    'fa-solid fa-sensor-cloud fa-fw',
    'fa-solid fa-sensor fa-fw',
    'fa-solid fa-send-backward fa-fw',
    'fa-solid fa-send-back fa-fw',
    'fa-solid fa-semicolon fa-fw',
    'fa-solid fa-section fa-fw',
    'fa-solid fa-seat-airline fa-fw',
    'fa-solid fa-seal-question fa-fw',
    'fa-solid fa-seal-exclamation fa-fw',
    'fa-solid fa-seal fa-fw',
    'fa-solid fa-sd-cards fa-fw',
    'fa-solid fa-sd-card fa-fw',
    'fa-solid fa-scythe fa-fw',
    'fa-solid fa-scrubber fa-fw',
    'fa-solid fa-scroll-torah fa-fw',
    'fa-solid fa-scroll-old fa-fw',
    'fa-solid fa-scribble fa-fw',
    'fa-solid fa-screwdriver-wrench fa-fw',
    'fa-solid fa-screwdriver fa-fw',
    'fa-solid fa-screencast fa-fw',
    'fa-solid fa-screen-users fa-fw',
    'fa-solid fa-scissors fa-fw',
    'fa-solid fa-school-lock fa-fw',
    'fa-solid fa-school-flag fa-fw',
    'fa-solid fa-school-circle-xmark fa-fw',
    'fa-solid fa-school-circle-exclamation fa-fw',
    'fa-solid fa-school-circle-check fa-fw',
    'fa-solid fa-scarf fa-fw',
    'fa-solid fa-scarecrow fa-fw',
    'fa-solid fa-scanner-keyboard fa-fw',
    'fa-solid fa-scanner-image fa-fw',
    'fa-solid fa-scanner-gun fa-fw',
    'fa-solid fa-scalpel-line-dashed fa-fw',
    'fa-solid fa-scalpel fa-fw',
    'fa-solid fa-scale-unbalanced-flip fa-fw',
    'fa-solid fa-scale-unbalanced fa-fw',
    'fa-solid fa-scale-balanced fa-fw',
    'fa-solid fa-saxophone-fire fa-fw',
    'fa-solid fa-saxophone fa-fw',
    'fa-solid fa-sausage fa-fw',
    'fa-solid fa-satellite-dish fa-fw',
    'fa-solid fa-satellite fa-fw',
    'fa-solid fa-sandwich fa-fw',
    'fa-solid fa-salt-shaker fa-fw',
    'fa-solid fa-salad fa-fw',
    'fa-solid fa-sailboat fa-fw',
    'fa-solid fa-sack-xmark fa-fw',
    'fa-solid fa-sack-dollar fa-fw',
    'fa-solid fa-sack fa-fw',
    'fa-solid fa-s fa-fw',
    'fa-solid fa-rv fa-fw',
    'fa-solid fa-rupiah-sign fa-fw',
    'fa-solid fa-rupee-sign fa-fw',
    'fa-solid fa-ruler-triangle fa-fw',
    'fa-solid fa-ruler-horizontal fa-fw',
    'fa-solid fa-ruler-combined fa-fw',
    'fa-solid fa-rugby-ball fa-fw',
    'fa-solid fa-rug fa-fw',
    'fa-solid fa-ruble-sign fa-fw',
    'fa-solid fa-rss fa-fw',
    'fa-solid fa-router fa-fw',
    'fa-solid fa-route-interstate fa-fw',
    'fa-solid fa-route-highway fa-fw',
    'fa-solid fa-rotate-left fa-fw',
    'fa-solid fa-rotate-exclamation fa-fw',
    'fa-solid fa-rotate fa-fw',
    'fa-solid fa-roller-coaster fa-fw',
    'fa-solid fa-road-spikes fa-fw',
    'fa-solid fa-road-lock fa-fw',
    'fa-solid fa-road-circle-xmark fa-fw',
    'fa-solid fa-road-circle-exclamation fa-fw',
    'fa-solid fa-road-circle-check fa-fw',
    'fa-solid fa-road-bridge fa-fw',
    'fa-solid fa-road-barrier fa-fw',
    'fa-solid fa-rings-wedding fa-fw',
    'fa-solid fa-ring-diamond fa-fw',
    'fa-solid fa-right-to-line fa-fw',
    'fa-solid fa-right-long-to-line fa-fw',
    'fa-solid fa-right-long fa-fw',
    'fa-solid fa-right-left-large fa-fw',
    'fa-solid fa-right-left fa-fw',
    'fa-solid fa-right-from-line fa-fw',
    'fa-solid fa-right-from-bracket fa-fw',
    'fa-solid fa-right fa-fw',
    'fa-solid fa-ribbon fa-fw',
    'fa-solid fa-rhombus fa-fw',
    'fa-solid fa-retweet fa-fw',
    'fa-solid fa-restroom-simple fa-fw',
    'fa-solid fa-republican fa-fw',
    'fa-solid fa-reply-clock fa-fw',
    'fa-solid fa-reply-all fa-fw',
    'fa-solid fa-repeat-1 fa-fw',
    'fa-solid fa-refrigerator fa-fw',
    'fa-solid fa-reel fa-fw',
    'fa-solid fa-rectangles-mixed fa-fw',
    'fa-solid fa-rectangle-xmark fa-fw',
    'fa-solid fa-rectangle-vertical-history fa-fw',
    'fa-solid fa-rectangle-vertical fa-fw',
    'fa-solid fa-rectangle-terminal fa-fw',
    'fa-solid fa-rectangle-pro fa-fw',
    'fa-solid fa-rectangle-list fa-fw',
    'fa-solid fa-rectangle-history-circle-user fa-fw',
    'fa-solid fa-rectangle-history-circle-plus fa-fw',
    'fa-solid fa-rectangle-history fa-fw',
    'fa-solid fa-rectangle-code fa-fw',
    'fa-solid fa-rectangle-barcode fa-fw',
    'fa-solid fa-rectangle-ad fa-fw',
    'fa-solid fa-rectangle fa-fw',
    'fa-solid fa-ranking-star fa-fw',
    'fa-solid fa-ramp-loading fa-fw',
    'fa-solid fa-ram fa-fw',
    'fa-solid fa-rainbow fa-fw',
    'fa-solid fa-radio-tuner fa-fw',
    'fa-solid fa-radiation fa-fw',
    'fa-solid fa-racquet fa-fw',
    'fa-solid fa-rabbit-running fa-fw',
    'fa-solid fa-rabbit fa-fw',
    'fa-solid fa-r fa-fw',
    'fa-solid fa-quotes fa-fw',
    'fa-solid fa-qrcode fa-fw',
    'fa-solid fa-q fa-fw',
    'fa-solid fa-puzzle-piece-simple fa-fw',
    'fa-solid fa-puzzle fa-fw',
    'fa-solid fa-pumpkin fa-fw',
    'fa-solid fa-pump-soap fa-fw',
    'fa-solid fa-pump-medical fa-fw',
    'fa-solid fa-pump fa-fw',
    'fa-solid fa-print-slash fa-fw',
    'fa-solid fa-print-magnifying-glass fa-fw',
    'fa-solid fa-pretzel fa-fw',
    'fa-solid fa-presentation-screen fa-fw',
    'fa-solid fa-prescription-bottle-pill fa-fw',
    'fa-solid fa-prescription-bottle-medical fa-fw',
    'fa-solid fa-prescription-bottle fa-fw',
    'fa-solid fa-prescription fa-fw',
    'fa-solid fa-potato fa-fw',
    'fa-solid fa-pot-food fa-fw',
    'fa-solid fa-popsicle fa-fw',
    'fa-solid fa-popcorn fa-fw',
    'fa-solid fa-poop fa-fw',
    'fa-solid fa-pool-8-ball fa-fw',
    'fa-solid fa-pompebled fa-fw',
    'fa-solid fa-poll-people fa-fw',
    'fa-solid fa-podium-star fa-fw',
    'fa-solid fa-podium fa-fw',
    'fa-solid fa-podcast fa-fw',
    'fa-solid fa-plus-minus fa-fw',
    'fa-solid fa-plus-large fa-fw',
    'fa-solid fa-plug-circle-xmark fa-fw',
    'fa-solid fa-plug-circle-plus fa-fw',
    'fa-solid fa-plug-circle-minus fa-fw',
    'fa-solid fa-plug-circle-exclamation fa-fw',
    'fa-solid fa-plug-circle-check fa-fw',
    'fa-solid fa-plug-circle-bolt fa-fw',
    'fa-solid fa-plate-wheat fa-fw',
    'fa-solid fa-plate-utensils fa-fw',
    'fa-solid fa-plant-wilt fa-fw',
    'fa-solid fa-plane-up-slash fa-fw',
    'fa-solid fa-plane-up fa-fw',
    'fa-solid fa-plane-tail fa-fw',
    'fa-solid fa-plane-slash fa-fw',
    'fa-solid fa-plane-prop fa-fw',
    'fa-solid fa-plane-lock fa-fw',
    'fa-solid fa-plane-engines fa-fw',
    'fa-solid fa-plane-circle-xmark fa-fw',
    'fa-solid fa-plane-circle-exclamation fa-fw',
    'fa-solid fa-plane-circle-check fa-fw',
    'fa-solid fa-plane-arrival fa-fw',
    'fa-solid fa-pizza-slice fa-fw',
    'fa-solid fa-pizza fa-fw',
    'fa-solid fa-pipe-valve fa-fw',
    'fa-solid fa-pipe-smoking fa-fw',
    'fa-solid fa-pipe-section fa-fw',
    'fa-solid fa-pipe-collar fa-fw',
    'fa-solid fa-pipe-circle-check fa-fw',
    'fa-solid fa-pipe fa-fw',
    'fa-solid fa-pineapple fa-fw',
    'fa-solid fa-pinball fa-fw',
    'fa-solid fa-pinata fa-fw',
    'fa-solid fa-pills fa-fw',
    'fa-solid fa-piggy-bank fa-fw',
    'fa-solid fa-pig fa-fw',
    'fa-solid fa-pie fa-fw',
    'fa-solid fa-pickleball fa-fw',
    'fa-solid fa-pickaxe fa-fw',
    'fa-solid fa-piano-keyboard fa-fw',
    'fa-solid fa-piano fa-fw',
    'fa-solid fa-pi fa-fw',
    'fa-solid fa-photo-film-music fa-fw',
    'fa-solid fa-photo-film fa-fw',
    'fa-solid fa-phone-xmark fa-fw',
    'fa-solid fa-phone-slash fa-fw',
    'fa-solid fa-phone-rotary fa-fw',
    'fa-solid fa-phone-plus fa-fw',
    'fa-solid fa-phone-missed fa-fw',
    'fa-solid fa-phone-intercom fa-fw',
    'fa-solid fa-phone-hangup fa-fw',
    'fa-solid fa-phone-flip fa-fw',
    'fa-solid fa-phone-arrow-up-right fa-fw',
    'fa-solid fa-phone-arrow-right fa-fw',
    'fa-solid fa-phone-arrow-down-left fa-fw',
    'fa-solid fa-peso-sign fa-fw',
    'fa-solid fa-peseta-sign fa-fw',
    'fa-solid fa-person-walking-with-cane fa-fw',
    'fa-solid fa-person-walking-luggage fa-fw',
    'fa-solid fa-person-walking-dashed-line-arrow-right fa-fw',
    'fa-solid fa-person-walking-arrow-right fa-fw',
    'fa-solid fa-person-walking-arrow-loop-left fa-fw',
    'fa-solid fa-person-walking fa-fw',
    'fa-solid fa-person-to-portal fa-fw',
    'fa-solid fa-person-to-door fa-fw',
    'fa-solid fa-person-through-window fa-fw',
    'fa-solid fa-person-swimming fa-fw',
    'fa-solid fa-person-snowmobiling fa-fw',
    'fa-solid fa-person-snowboarding fa-fw',
    'fa-solid fa-person-sledding fa-fw',
    'fa-solid fa-person-skiing-nordic fa-fw',
    'fa-solid fa-person-skiing fa-fw',
    'fa-solid fa-person-ski-lift fa-fw',
    'fa-solid fa-person-ski-jumping fa-fw',
    'fa-solid fa-person-skating fa-fw',
    'fa-solid fa-person-simple fa-fw',
    'fa-solid fa-person-shelter fa-fw',
    'fa-solid fa-person-seat-reclined fa-fw',
    'fa-solid fa-person-seat fa-fw',
    'fa-solid fa-person-running-fast fa-fw',
    'fa-solid fa-person-running fa-fw',
    'fa-solid fa-person-rifle fa-fw',
    'fa-solid fa-person-rays fa-fw',
    'fa-solid fa-person-pregnant fa-fw',
    'fa-solid fa-person-praying fa-fw',
    'fa-solid fa-person-pinball fa-fw',
    'fa-solid fa-person-military-to-person fa-fw',
    'fa-solid fa-person-military-rifle fa-fw',
    'fa-solid fa-person-military-pointing fa-fw',
    'fa-solid fa-person-hiking fa-fw',
    'fa-solid fa-person-harassing fa-fw',
    'fa-solid fa-person-half-dress fa-fw',
    'fa-solid fa-person-from-portal fa-fw',
    'fa-solid fa-person-falling-burst fa-fw',
    'fa-solid fa-person-falling fa-fw',
    'fa-solid fa-person-drowning fa-fw',
    'fa-solid fa-person-dress-simple fa-fw',
    'fa-solid fa-person-dress-burst fa-fw',
    'fa-solid fa-person-dots-from-line fa-fw',
    'fa-solid fa-person-dolly fa-fw',
    'fa-solid fa-person-digging fa-fw',
    'fa-solid fa-person-circle-xmark fa-fw',
    'fa-solid fa-person-circle-question fa-fw',
    'fa-solid fa-person-circle-plus fa-fw',
    'fa-solid fa-person-circle-minus fa-fw',
    'fa-solid fa-person-circle-exclamation fa-fw',
    'fa-solid fa-person-circle-check fa-fw',
    'fa-solid fa-person-chalkboard fa-fw',
    'fa-solid fa-person-carry-box fa-fw',
    'fa-solid fa-person-cane fa-fw',
    'fa-solid fa-person-burst fa-fw',
    'fa-solid fa-person-breastfeeding fa-fw',
    'fa-solid fa-person-booth fa-fw',
    'fa-solid fa-person-biking-mountain fa-fw',
    'fa-solid fa-person-biking fa-fw',
    'fa-solid fa-person-arrow-up-from-line fa-fw',
    'fa-solid fa-person-arrow-down-to-line fa-fw',
    'fa-solid fa-period fa-fw',
    'fa-solid fa-pepper-hot fa-fw',
    'fa-solid fa-pepper fa-fw',
    'fa-solid fa-people-roof fa-fw',
    'fa-solid fa-people-robbery fa-fw',
    'fa-solid fa-people-pulling fa-fw',
    'fa-solid fa-people-pants-simple fa-fw',
    'fa-solid fa-people-pants fa-fw',
    'fa-solid fa-people-line fa-fw',
    'fa-solid fa-people-group fa-fw',
    'fa-solid fa-people-dress-simple fa-fw',
    'fa-solid fa-people-dress fa-fw',
    'fa-solid fa-people-carry-box fa-fw',
    'fa-solid fa-people fa-fw',
    'fa-solid fa-pencil-slash fa-fw',
    'fa-solid fa-pencil-mechanical fa-fw',
    'fa-solid fa-pen-swirl fa-fw',
    'fa-solid fa-pen-slash fa-fw',
    'fa-solid fa-pen-ruler fa-fw',
    'fa-solid fa-pen-paintbrush fa-fw',
    'fa-solid fa-pen-nib-slash fa-fw',
    'fa-solid fa-pen-line fa-fw',
    'fa-solid fa-pen-field fa-fw',
    'fa-solid fa-pen-fancy-slash fa-fw',
    'fa-solid fa-pen-clip-slash fa-fw',
    'fa-solid fa-pen-clip fa-fw',
    'fa-solid fa-pen-circle fa-fw',
    'fa-solid fa-pegasus fa-fw',
    'fa-solid fa-pedestal fa-fw',
    'fa-solid fa-pear fa-fw',
    'fa-solid fa-peapod fa-fw',
    'fa-solid fa-peanuts fa-fw',
    'fa-solid fa-peanut fa-fw',
    'fa-solid fa-peach fa-fw',
    'fa-solid fa-peace fa-fw',
    'fa-solid fa-paw-simple fa-fw',
    'fa-solid fa-paw-claws fa-fw',
    'fa-solid fa-paw fa-fw',
    'fa-solid fa-paste fa-fw',
    'fa-solid fa-party-horn fa-fw',
    'fa-solid fa-party-bell fa-fw',
    'fa-solid fa-paragraph-left fa-fw',
    'fa-solid fa-paragraph fa-fw',
    'fa-solid fa-parachute-box fa-fw',
    'fa-solid fa-paperclip-vertical fa-fw',
    'fa-solid fa-paper-plane-top fa-fw',
    'fa-solid fa-panorama fa-fw',
    'fa-solid fa-panel-fire fa-fw',
    'fa-solid fa-panel-ews fa-fw',
    'fa-solid fa-pancakes fa-fw',
    'fa-solid fa-pan-frying fa-fw',
    'fa-solid fa-pan-food fa-fw',
    'fa-solid fa-pallet-boxes fa-fw',
    'fa-solid fa-pallet-box fa-fw',
    'fa-solid fa-pallet fa-fw',
    'fa-solid fa-paintbrush-pencil fa-fw',
    'fa-solid fa-paintbrush-fine fa-fw',
    'fa-solid fa-paintbrush fa-fw',
    'fa-solid fa-pager fa-fw',
    'fa-solid fa-page-caret-up fa-fw',
    'fa-solid fa-page-caret-down fa-fw',
    'fa-solid fa-page fa-fw',
    'fa-solid fa-p fa-fw',
    'fa-solid fa-overline fa-fw',
    'fa-solid fa-oven fa-fw',
    'fa-solid fa-outlet fa-fw',
    'fa-solid fa-outdent fa-fw',
    'fa-solid fa-ornament fa-fw',
    'fa-solid fa-option fa-fw',
    'fa-solid fa-onion fa-fw',
    'fa-solid fa-omega fa-fw',
    'fa-solid fa-om fa-fw',
    'fa-solid fa-olive-branch fa-fw',
    'fa-solid fa-olive fa-fw',
    'fa-solid fa-oil-well fa-fw',
    'fa-solid fa-oil-temperature fa-fw',
    'fa-solid fa-oil-can-drip fa-fw',
    'fa-solid fa-oil-can fa-fw',
    'fa-solid fa-octagon-xmark fa-fw',
    'fa-solid fa-octagon-plus fa-fw',
    'fa-solid fa-octagon-minus fa-fw',
    'fa-solid fa-octagon-exclamation fa-fw',
    'fa-solid fa-octagon-divide fa-fw',
    'fa-solid fa-octagon-check fa-fw',
    'fa-solid fa-octagon fa-fw',
    'fa-solid fa-objects-column fa-fw',
    'fa-solid fa-objects-align-top fa-fw',
    'fa-solid fa-objects-align-right fa-fw',
    'fa-solid fa-objects-align-left fa-fw',
    'fa-solid fa-objects-align-center-vertical fa-fw',
    'fa-solid fa-objects-align-center-horizontal fa-fw',
    'fa-solid fa-objects-align-bottom fa-fw',
    'fa-solid fa-object-union fa-fw',
    'fa-solid fa-object-ungroup fa-fw',
    'fa-solid fa-object-subtract fa-fw',
    'fa-solid fa-object-intersect fa-fw',
    'fa-solid fa-object-group fa-fw',
    'fa-solid fa-object-exclude fa-fw',
    'fa-solid fa-o fa-fw',
    'fa-solid fa-notes fa-fw',
    'fa-solid fa-notebook fa-fw',
    'fa-solid fa-note-sticky fa-fw',
    'fa-solid fa-note-medical fa-fw',
    'fa-solid fa-note fa-fw',
    'fa-solid fa-notdef fa-fw',
    'fa-solid fa-nose fa-fw',
    'fa-solid fa-nfc-trash fa-fw',
    'fa-solid fa-nfc-symbol fa-fw',
    'fa-solid fa-nfc-slash fa-fw',
    'fa-solid fa-nfc-signal fa-fw',
    'fa-solid fa-nfc-pen fa-fw',
    'fa-solid fa-nfc-magnifying-glass fa-fw',
    'fa-solid fa-nfc-lock fa-fw',
    'fa-solid fa-nfc fa-fw',
    'fa-solid fa-neuter fa-fw',
    'fa-solid fa-nesting-dolls fa-fw',
    'fa-solid fa-narwhal fa-fw',
    'fa-solid fa-naira-sign fa-fw',
    'fa-solid fa-n fa-fw',
    'fa-solid fa-mustache fa-fw',
    'fa-solid fa-music-slash fa-fw',
    'fa-solid fa-music-note-slash fa-fw',
    'fa-solid fa-music-note fa-fw',
    'fa-solid fa-mushroom fa-fw',
    'fa-solid fa-mug-tea-saucer fa-fw',
    'fa-solid fa-mug-marshmallows fa-fw',
    'fa-solid fa-mug fa-fw',
    'fa-solid fa-mp3-player fa-fw',
    'fa-solid fa-mouse-field fa-fw',
    'fa-solid fa-mountains fa-fw',
    'fa-solid fa-mountain-city fa-fw',
    'fa-solid fa-mountain fa-fw',
    'fa-solid fa-mound fa-fw',
    'fa-solid fa-mosquito-net fa-fw',
    'fa-solid fa-mosquito fa-fw',
    'fa-solid fa-mosque fa-fw',
    'fa-solid fa-mortar-pestle fa-fw',
    'fa-solid fa-moon-over-sun fa-fw',
    'fa-solid fa-moon-cloud fa-fw',
    'fa-solid fa-monument fa-fw',
    'fa-solid fa-monkey fa-fw',
    'fa-solid fa-monitor-waveform fa-fw',
    'fa-solid fa-money-simple-from-bracket fa-fw',
    'fa-solid fa-money-from-bracket fa-fw',
    'fa-solid fa-money-check-pen fa-fw',
    'fa-solid fa-money-check-dollar-pen fa-fw',
    'fa-solid fa-money-check-dollar fa-fw',
    'fa-solid fa-money-check fa-fw',
    'fa-solid fa-money-bills-simple fa-fw',
    'fa-solid fa-money-bills fa-fw',
    'fa-solid fa-money-bill-wheat fa-fw',
    'fa-solid fa-money-bill-wave fa-fw',
    'fa-solid fa-money-bill-trend-up fa-fw',
    'fa-solid fa-money-bill-transfer fa-fw',
    'fa-solid fa-money-bill-simple-wave fa-fw',
    'fa-solid fa-money-bill-simple fa-fw',
    'fa-solid fa-money-bill-1-wave fa-fw',
    'fa-solid fa-money-bill-1 fa-fw',
    'fa-solid fa-mobile-signal-out fa-fw',
    'fa-solid fa-mobile-signal fa-fw',
    'fa-solid fa-mobile-screen-button fa-fw',
    'fa-solid fa-mobile-screen fa-fw',
    'fa-solid fa-mobile-retro fa-fw',
    'fa-solid fa-mobile-notch fa-fw',
    'fa-solid fa-mobile-button fa-fw',
    'fa-solid fa-mitten fa-fw',
    'fa-solid fa-mistletoe fa-fw',
    'fa-solid fa-minimize fa-fw',
    'fa-solid fa-mill-sign fa-fw',
    'fa-solid fa-microscope fa-fw',
    'fa-solid fa-microphone-stand fa-fw',
    'fa-solid fa-microphone-lines-slash fa-fw',
    'fa-solid fa-microphone-lines fa-fw',
    'fa-solid fa-microchip-ai fa-fw',
    'fa-solid fa-meter-fire fa-fw',
    'fa-solid fa-meter-droplet fa-fw',
    'fa-solid fa-meter-bolt fa-fw',
    'fa-solid fa-meter fa-fw',
    'fa-solid fa-meteor fa-fw',
    'fa-solid fa-messages-question fa-fw',
    'fa-solid fa-messages-dollar fa-fw',
    'fa-solid fa-messages fa-fw',
    'fa-solid fa-message-xmark fa-fw',
    'fa-solid fa-message-text fa-fw',
    'fa-solid fa-message-sms fa-fw',
    'fa-solid fa-message-smile fa-fw',
    'fa-solid fa-message-slash fa-fw',
    'fa-solid fa-message-quote fa-fw',
    'fa-solid fa-message-question fa-fw',
    'fa-solid fa-message-plus fa-fw',
    'fa-solid fa-message-pen fa-fw',
    'fa-solid fa-message-music fa-fw',
    'fa-solid fa-message-minus fa-fw',
    'fa-solid fa-message-middle-top fa-fw',
    'fa-solid fa-message-middle fa-fw',
    'fa-solid fa-message-medical fa-fw',
    'fa-solid fa-message-lines fa-fw',
    'fa-solid fa-message-image fa-fw',
    'fa-solid fa-message-heart fa-fw',
    'fa-solid fa-message-exclamation fa-fw',
    'fa-solid fa-message-dots fa-fw',
    'fa-solid fa-message-dollar fa-fw',
    'fa-solid fa-message-code fa-fw',
    'fa-solid fa-message-check fa-fw',
    'fa-solid fa-message-captions fa-fw',
    'fa-solid fa-message-bot fa-fw',
    'fa-solid fa-message-arrow-up-right fa-fw',
    'fa-solid fa-message-arrow-up fa-fw',
    'fa-solid fa-message-arrow-down fa-fw',
    'fa-solid fa-message fa-fw',
    'fa-solid fa-merge fa-fw',
    'fa-solid fa-mercury fa-fw',
    'fa-solid fa-menorah fa-fw',
    'fa-solid fa-memory fa-fw',
    'fa-solid fa-memo-pad fa-fw',
    'fa-solid fa-memo-circle-info fa-fw',
    'fa-solid fa-memo-circle-check fa-fw',
    'fa-solid fa-memo fa-fw',
    'fa-solid fa-melon-slice fa-fw',
    'fa-solid fa-melon fa-fw',
    'fa-solid fa-maximize fa-fw',
    'fa-solid fa-mattress-pillow fa-fw',
    'fa-solid fa-masks-theater fa-fw',
    'fa-solid fa-mask-ventilator fa-fw',
    'fa-solid fa-mask-snorkel fa-fw',
    'fa-solid fa-mask-face fa-fw',
    'fa-solid fa-martini-glass-empty fa-fw',
    'fa-solid fa-martini-glass-citrus fa-fw',
    'fa-solid fa-martini-glass fa-fw',
    'fa-solid fa-mars-stroke-up fa-fw',
    'fa-solid fa-mars-stroke-right fa-fw',
    'fa-solid fa-mars-stroke fa-fw',
    'fa-solid fa-mars-double fa-fw',
    'fa-solid fa-mars-and-venus-burst fa-fw',
    'fa-solid fa-mars-and-venus fa-fw',
    'fa-solid fa-mars fa-fw',
    'fa-solid fa-map-pin fa-fw',
    'fa-solid fa-map-location-dot fa-fw',
    'fa-solid fa-map-location fa-fw',
    'fa-solid fa-map fa-fw',
    'fa-solid fa-manhole fa-fw',
    'fa-solid fa-mango fa-fw',
    'fa-solid fa-mandolin fa-fw',
    'fa-solid fa-manat-sign fa-fw',
    'fa-solid fa-mailbox-flag-up fa-fw',
    'fa-solid fa-magnifying-glass-plus fa-fw',
    'fa-solid fa-magnifying-glass-minus fa-fw',
    'fa-solid fa-magnifying-glass-location fa-fw',
    'fa-solid fa-magnifying-glass-dollar fa-fw',
    'fa-solid fa-magnifying-glass-chart fa-fw',
    'fa-solid fa-magnifying-glass-arrow-right fa-fw',
    'fa-solid fa-mace fa-fw',
    'fa-solid fa-m fa-fw',
    'fa-solid fa-lungs-virus fa-fw',
    'fa-solid fa-lungs fa-fw',
    'fa-solid fa-luchador-mask fa-fw',
    'fa-solid fa-lollipop fa-fw',
    'fa-solid fa-locust fa-fw',
    'fa-solid fa-lock-open fa-fw',
    'fa-solid fa-lock-keyhole-open fa-fw',
    'fa-solid fa-lock-keyhole fa-fw',
    'fa-solid fa-lock-hashtag fa-fw',
    'fa-solid fa-lock-a fa-fw',
    'fa-solid fa-location-xmark fa-fw',
    'fa-solid fa-location-smile fa-fw',
    'fa-solid fa-location-question fa-fw',
    'fa-solid fa-location-plus fa-fw',
    'fa-solid fa-location-pin-slash fa-fw',
    'fa-solid fa-location-pin-lock fa-fw',
    'fa-solid fa-location-pen fa-fw',
    'fa-solid fa-location-minus fa-fw',
    'fa-solid fa-location-exclamation fa-fw',
    'fa-solid fa-location-dot-slash fa-fw',
    'fa-solid fa-location-crosshairs-slash fa-fw',
    'fa-solid fa-location-crosshairs fa-fw',
    'fa-solid fa-location-check fa-fw',
    'fa-solid fa-location-arrow fa-fw',
    'fa-solid fa-lobster fa-fw',
    'fa-solid fa-loader fa-fw',
    'fa-solid fa-litecoin-sign fa-fw',
    'fa-solid fa-list-ul fa-fw',
    'fa-solid fa-list-tree fa-fw',
    'fa-solid fa-list-timeline fa-fw',
    'fa-solid fa-list-radio fa-fw',
    'fa-solid fa-list-ol fa-fw',
    'fa-solid fa-list-music fa-fw',
    'fa-solid fa-list-dropdown fa-fw',
    'fa-solid fa-list-check fa-fw',
    'fa-solid fa-lira-sign fa-fw',
    'fa-solid fa-lips fa-fw',
    'fa-solid fa-link-slash fa-fw',
    'fa-solid fa-link-simple-slash fa-fw',
    'fa-solid fa-link-simple fa-fw',
    'fa-solid fa-link-horizontal-slash fa-fw',
    'fa-solid fa-link-horizontal fa-fw',
    'fa-solid fa-lines-leaning fa-fw',
    'fa-solid fa-line-columns fa-fw',
    'fa-solid fa-lightbulb-on fa-fw',
    'fa-solid fa-lightbulb-gear fa-fw',
    'fa-solid fa-lightbulb-exclamation-on fa-fw',
    'fa-solid fa-lightbulb-exclamation fa-fw',
    'fa-solid fa-lightbulb-dollar fa-fw',
    'fa-solid fa-lightbulb-cfl-on fa-fw',
    'fa-solid fa-lightbulb-cfl fa-fw',
    'fa-solid fa-light-switch-on fa-fw',
    'fa-solid fa-light-switch-off fa-fw',
    'fa-solid fa-light-emergency-on fa-fw',
    'fa-solid fa-light-emergency fa-fw',
    'fa-solid fa-light-ceiling fa-fw',
    'fa-solid fa-life-ring fa-fw',
    'fa-solid fa-less-than-equal fa-fw',
    'fa-solid fa-less-than fa-fw',
    'fa-solid fa-left-to-line fa-fw',
    'fa-solid fa-left-right fa-fw',
    'fa-solid fa-left-long-to-line fa-fw',
    'fa-solid fa-left-long fa-fw',
    'fa-solid fa-left-from-line fa-fw',
    'fa-solid fa-left fa-fw',
    'fa-solid fa-leafy-green fa-fw',
    'fa-solid fa-leaf-oak fa-fw',
    'fa-solid fa-leaf-maple fa-fw',
    'fa-solid fa-leaf-heart fa-fw',
    'fa-solid fa-layer-plus fa-fw',
    'fa-solid fa-layer-minus fa-fw',
    'fa-solid fa-lasso-sparkles fa-fw',
    'fa-solid fa-lasso fa-fw',
    'fa-solid fa-lari-sign fa-fw',
    'fa-solid fa-laptop-slash fa-fw',
    'fa-solid fa-laptop-mobile fa-fw',
    'fa-solid fa-laptop-medical fa-fw',
    'fa-solid fa-laptop-file fa-fw',
    'fa-solid fa-laptop-code fa-fw',
    'fa-solid fa-laptop-binary fa-fw',
    'fa-solid fa-laptop-arrow-down fa-fw',
    'fa-solid fa-landmark-flag fa-fw',
    'fa-solid fa-landmark-dome fa-fw',
    'fa-solid fa-land-mine-on fa-fw',
    'fa-solid fa-lamp-street fa-fw',
    'fa-solid fa-lamp-floor fa-fw',
    'fa-solid fa-lamp-desk fa-fw',
    'fa-solid fa-lambda fa-fw',
    'fa-solid fa-lacrosse-stick-ball fa-fw',
    'fa-solid fa-lacrosse-stick fa-fw',
    'fa-solid fa-l fa-fw',
    'fa-solid fa-knife fa-fw',
    'fa-solid fa-kiwi-fruit fa-fw',
    'fa-solid fa-kite fa-fw',
    'fa-solid fa-kitchen-set fa-fw',
    'fa-solid fa-kit-medical fa-fw',
    'fa-solid fa-kip-sign fa-fw',
    'fa-solid fa-khanda fa-fw',
    'fa-solid fa-keynote fa-fw',
    'fa-solid fa-keyboard-left fa-fw',
    'fa-solid fa-keyboard-down fa-fw',
    'fa-solid fa-keyboard-brightness-low fa-fw',
    'fa-solid fa-keyboard-brightness fa-fw',
    'fa-solid fa-key-skeleton-left-right fa-fw',
    'fa-solid fa-key-skeleton fa-fw',
    'fa-solid fa-kerning fa-fw',
    'fa-solid fa-kazoo fa-fw',
    'fa-solid fa-kaaba fa-fw',
    'fa-solid fa-k fa-fw',
    'fa-solid fa-jug-detergent fa-fw',
    'fa-solid fa-jug-bottle fa-fw',
    'fa-solid fa-jug fa-fw',
    'fa-solid fa-jet-fighter-up fa-fw',
    'fa-solid fa-jet-fighter fa-fw',
    'fa-solid fa-jedi fa-fw',
    'fa-solid fa-jar-wheat fa-fw',
    'fa-solid fa-jar fa-fw',
    'fa-solid fa-jack-o-lantern fa-fw',
    'fa-solid fa-j fa-fw',
    'fa-solid fa-italic fa-fw',
    'fa-solid fa-island-tropical fa-fw',
    'fa-solid fa-intersection fa-fw',
    'fa-solid fa-interrobang fa-fw',
    'fa-solid fa-integral fa-fw',
    'fa-solid fa-input-text fa-fw',
    'fa-solid fa-input-pipe fa-fw',
    'fa-solid fa-input-numeric fa-fw',
    'fa-solid fa-inhaler fa-fw',
    'fa-solid fa-infinity fa-fw',
    'fa-solid fa-industry-windows fa-fw',
    'fa-solid fa-indian-rupee-sign fa-fw',
    'fa-solid fa-indent fa-fw',
    'fa-solid fa-inboxes fa-fw',
    'fa-solid fa-inbox-out fa-fw',
    'fa-solid fa-inbox-in fa-fw',
    'fa-solid fa-inbox-full fa-fw',
    'fa-solid fa-images-user fa-fw',
    'fa-solid fa-image-user fa-fw',
    'fa-solid fa-image-slash fa-fw',
    'fa-solid fa-image-portrait fa-fw',
    'fa-solid fa-image-polaroid-user fa-fw',
    'fa-solid fa-image-polaroid fa-fw',
    'fa-solid fa-image-landscape fa-fw',
    'fa-solid fa-igloo fa-fw',
    'fa-solid fa-id-card-clip fa-fw',
    'fa-solid fa-id-card fa-fw',
    'fa-solid fa-id-badge fa-fw',
    'fa-solid fa-icicles fa-fw',
    'fa-solid fa-ice-skate fa-fw',
    'fa-solid fa-ice-cream fa-fw',
    'fa-solid fa-i fa-fw',
    'fa-solid fa-hyphen fa-fw',
    'fa-solid fa-hurricane fa-fw',
    'fa-solid fa-hundred-points fa-fw',
    'fa-solid fa-hryvnia-sign fa-fw',
    'fa-solid fa-house-window fa-fw',
    'fa-solid fa-house-water fa-fw',
    'fa-solid fa-house-user fa-fw',
    'fa-solid fa-house-turret fa-fw',
    'fa-solid fa-house-tsunami fa-fw',
    'fa-solid fa-house-tree fa-fw',
    'fa-solid fa-house-signal fa-fw',
    'fa-solid fa-house-person-return fa-fw',
    'fa-solid fa-house-person-leave fa-fw',
    'fa-solid fa-house-medical-flag fa-fw',
    'fa-solid fa-house-medical-circle-xmark fa-fw',
    'fa-solid fa-house-medical-circle-exclamation fa-fw',
    'fa-solid fa-house-medical-circle-check fa-fw',
    'fa-solid fa-house-medical fa-fw',
    'fa-solid fa-house-lock fa-fw',
    'fa-solid fa-house-laptop fa-fw',
    'fa-solid fa-house-heart fa-fw',
    'fa-solid fa-house-flood-water-circle-arrow-right fa-fw',
    'fa-solid fa-house-flood-water fa-fw',
    'fa-solid fa-house-flag fa-fw',
    'fa-solid fa-house-fire fa-fw',
    'fa-solid fa-house-day fa-fw',
    'fa-solid fa-house-crack fa-fw',
    'fa-solid fa-house-circle-xmark fa-fw',
    'fa-solid fa-house-circle-exclamation fa-fw',
    'fa-solid fa-house-circle-check fa-fw',
    'fa-solid fa-house-chimney-window fa-fw',
    'fa-solid fa-house-chimney-user fa-fw',
    'fa-solid fa-house-chimney-medical fa-fw',
    'fa-solid fa-house-chimney-heart fa-fw',
    'fa-solid fa-house-chimney-crack fa-fw',
    'fa-solid fa-house-chimney-blank fa-fw',
    'fa-solid fa-house-chimney fa-fw',
    'fa-solid fa-house-building fa-fw',
    'fa-solid fa-house-blank fa-fw',
    'fa-solid fa-hourglass-half fa-fw',
    'fa-solid fa-hourglass-end fa-fw',
    'fa-solid fa-hourglass-clock fa-fw',
    'fa-solid fa-hourglass fa-fw',
    'fa-solid fa-hotdog fa-fw',
    'fa-solid fa-hot-tub-person fa-fw',
    'fa-solid fa-hospitals fa-fw',
    'fa-solid fa-hospital-user fa-fw',
    'fa-solid fa-hose-reel fa-fw',
    'fa-solid fa-hose fa-fw',
    'fa-solid fa-horse-saddle fa-fw',
    'fa-solid fa-horse-head fa-fw',
    'fa-solid fa-horse fa-fw',
    'fa-solid fa-horizontal-rule fa-fw',
    'fa-solid fa-hood-cloak fa-fw',
    'fa-solid fa-honey-pot fa-fw',
    'fa-solid fa-holly-berry fa-fw',
    'fa-solid fa-hockey-sticks fa-fw',
    'fa-solid fa-hockey-stick-puck fa-fw',
    'fa-solid fa-hockey-puck fa-fw',
    'fa-solid fa-hockey-mask fa-fw',
    'fa-solid fa-hill-rockslide fa-fw',
    'fa-solid fa-hill-avalanche fa-fw',
    'fa-solid fa-highlighter-line fa-fw',
    'fa-solid fa-highlighter fa-fw',
    'fa-solid fa-high-definition fa-fw',
    'fa-solid fa-hexagon-xmark fa-fw',
    'fa-solid fa-hexagon-vertical-nft-slanted fa-fw',
    'fa-solid fa-hexagon-vertical-nft fa-fw',
    'fa-solid fa-hexagon-plus fa-fw',
    'fa-solid fa-hexagon-minus fa-fw',
    'fa-solid fa-hexagon-image fa-fw',
    'fa-solid fa-hexagon-exclamation fa-fw',
    'fa-solid fa-hexagon-divide fa-fw',
    'fa-solid fa-hexagon-check fa-fw',
    'fa-solid fa-hexagon fa-fw',
    'fa-solid fa-helmet-un fa-fw',
    'fa-solid fa-helmet-safety fa-fw',
    'fa-solid fa-helmet-battle fa-fw',
    'fa-solid fa-helicopter-symbol fa-fw',
    'fa-solid fa-helicopter fa-fw',
    'fa-solid fa-heat fa-fw',
    'fa-solid fa-heart-pulse fa-fw',
    'fa-solid fa-heart-half-stroke fa-fw',
    'fa-solid fa-heart-half fa-fw',
    'fa-solid fa-heart-crack fa-fw',
    'fa-solid fa-heart-circle-xmark fa-fw',
    'fa-solid fa-heart-circle-plus fa-fw',
    'fa-solid fa-heart-circle-minus fa-fw',
    'fa-solid fa-heart-circle-exclamation fa-fw',
    'fa-solid fa-heart-circle-check fa-fw',
    'fa-solid fa-heart-circle-bolt fa-fw',
    'fa-solid fa-headphones-simple fa-fw',
    'fa-solid fa-head-side-virus fa-fw',
    'fa-solid fa-head-side-medical fa-fw',
    'fa-solid fa-head-side-mask fa-fw',
    'fa-solid fa-head-side-heart fa-fw',
    'fa-solid fa-head-side-headphones fa-fw',
    'fa-solid fa-head-side-goggles fa-fw',
    'fa-solid fa-head-side-cough-slash fa-fw',
    'fa-solid fa-head-side-cough fa-fw',
    'fa-solid fa-head-side-brain fa-fw',
    'fa-solid fa-hat-wizard fa-fw',
    'fa-solid fa-hat-witch fa-fw',
    'fa-solid fa-hat-winter fa-fw',
    'fa-solid fa-hat-santa fa-fw',
    'fa-solid fa-hat-cowboy-side fa-fw',
    'fa-solid fa-hat-cowboy fa-fw',
    'fa-solid fa-hat-chef fa-fw',
    'fa-solid fa-hat-beach fa-fw',
    'fa-solid fa-hashtag-lock fa-fw',
    'fa-solid fa-hard-drive fa-fw',
    'fa-solid fa-hanukiah fa-fw',
    'fa-solid fa-handshake-simple-slash fa-fw',
    'fa-solid fa-handshake-simple fa-fw',
    'fa-solid fa-handshake-angle fa-fw',
    'fa-solid fa-hands-praying fa-fw',
    'fa-solid fa-hands-holding-heart fa-fw',
    'fa-solid fa-hands-holding-dollar fa-fw',
    'fa-solid fa-hands-holding-diamond fa-fw',
    'fa-solid fa-hands-holding-circle fa-fw',
    'fa-solid fa-hands-holding-child fa-fw',
    'fa-solid fa-hands-holding fa-fw',
    'fa-solid fa-hands-clapping fa-fw',
    'fa-solid fa-hands-bubbles fa-fw',
    'fa-solid fa-hands-bound fa-fw',
    'fa-solid fa-hands-asl-interpreting fa-fw',
    'fa-solid fa-handcuffs fa-fw',
    'fa-solid fa-hand-wave fa-fw',
    'fa-solid fa-hand-spock fa-fw',
    'fa-solid fa-hand-sparkles fa-fw',
    'fa-solid fa-hand-scissors fa-fw',
    'fa-solid fa-hand-pointer fa-fw',
    'fa-solid fa-hand-point-right fa-fw',
    'fa-solid fa-hand-point-ribbon fa-fw',
    'fa-solid fa-hand-point-left fa-fw',
    'fa-solid fa-hand-point-down fa-fw',
    'fa-solid fa-hand-peace fa-fw',
    'fa-solid fa-hand-middle-finger fa-fw',
    'fa-solid fa-hand-love fa-fw',
    'fa-solid fa-hand-lizard fa-fw',
    'fa-solid fa-hand-horns fa-fw',
    'fa-solid fa-hand-holding-skull fa-fw',
    'fa-solid fa-hand-holding-seedling fa-fw',
    'fa-solid fa-hand-holding-medical fa-fw',
    'fa-solid fa-hand-holding-magic fa-fw',
    'fa-solid fa-hand-holding-hand fa-fw',
    'fa-solid fa-hand-holding-droplet fa-fw',
    'fa-solid fa-hand-holding-dollar fa-fw',
    'fa-solid fa-hand-holding-box fa-fw',
    'fa-solid fa-hand-holding fa-fw',
    'fa-solid fa-hand-heart fa-fw',
    'fa-solid fa-hand-fist fa-fw',
    'fa-solid fa-hand-fingers-crossed fa-fw',
    'fa-solid fa-hand-dots fa-fw',
    'fa-solid fa-hand-back-point-up fa-fw',
    'fa-solid fa-hand-back-point-right fa-fw',
    'fa-solid fa-hand-back-point-ribbon fa-fw',
    'fa-solid fa-hand-back-point-left fa-fw',
    'fa-solid fa-hand-back-point-down fa-fw',
    'fa-solid fa-hand-back-fist fa-fw',
    'fa-solid fa-hamsa fa-fw',
    'fa-solid fa-hammer-war fa-fw',
    'fa-solid fa-hammer-crash fa-fw',
    'fa-solid fa-h6 fa-fw',
    'fa-solid fa-h5 fa-fw',
    'fa-solid fa-h4 fa-fw',
    'fa-solid fa-h3 fa-fw',
    'fa-solid fa-h2 fa-fw',
    'fa-solid fa-h1 fa-fw',
    'fa-solid fa-h fa-fw',
    'fa-solid fa-gun-squirt fa-fw',
    'fa-solid fa-gun-slash fa-fw',
    'fa-solid fa-gun fa-fw',
    'fa-solid fa-guitars fa-fw',
    'fa-solid fa-guitar-electric fa-fw',
    'fa-solid fa-guitar fa-fw',
    'fa-solid fa-guarani-sign fa-fw',
    'fa-solid fa-group-arrows-rotate fa-fw',
    'fa-solid fa-grip-vertical fa-fw',
    'fa-solid fa-grip-lines-vertical fa-fw',
    'fa-solid fa-grip-lines fa-fw',
    'fa-solid fa-grip-dots-vertical fa-fw',
    'fa-solid fa-grip-dots fa-fw',
    'fa-solid fa-grip fa-fw',
    'fa-solid fa-grill-fire fa-fw',
    'fa-solid fa-grill fa-fw',
    'fa-solid fa-grid-round-5 fa-fw',
    'fa-solid fa-grid-round-4 fa-fw',
    'fa-solid fa-grid-round-2-plus fa-fw',
    'fa-solid fa-grid-round-2 fa-fw',
    'fa-solid fa-grid-round fa-fw',
    'fa-solid fa-grid-horizontal fa-fw',
    'fa-solid fa-grid-dividers fa-fw',
    'fa-solid fa-grid-5 fa-fw',
    'fa-solid fa-grid-4 fa-fw',
    'fa-solid fa-grid-2-plus fa-fw',
    'fa-solid fa-grid fa-fw',
    'fa-solid fa-greater-than-equal fa-fw',
    'fa-solid fa-greater-than fa-fw',
    'fa-solid fa-grate-droplet fa-fw',
    'fa-solid fa-grate fa-fw',
    'fa-solid fa-grapes fa-fw',
    'fa-solid fa-gramophone fa-fw',
    'fa-solid fa-graduation-cap fa-fw',
    'fa-solid fa-golf-flag-hole fa-fw',
    'fa-solid fa-golf-club fa-fw',
    'fa-solid fa-golf-ball-tee fa-fw',
    'fa-solid fa-goal-net fa-fw',
    'fa-solid fa-globe-snow fa-fw',
    'fa-solid fa-glasses-round fa-fw',
    'fa-solid fa-glass-water-droplet fa-fw',
    'fa-solid fa-glass-water fa-fw',
    'fa-solid fa-glass-half fa-fw',
    'fa-solid fa-glass-empty fa-fw',
    'fa-solid fa-glass-citrus fa-fw',
    'fa-solid fa-gingerbread-man fa-fw',
    'fa-solid fa-gifts fa-fw',
    'fa-solid fa-gift-card fa-fw',
    'fa-solid fa-gif fa-fw',
    'fa-solid fa-genderless fa-fw',
    'fa-solid fa-gem fa-fw',
    'fa-solid fa-gear-complex-code fa-fw',
    'fa-solid fa-gear-complex fa-fw',
    'fa-solid fa-gear-code fa-fw',
    'fa-solid fa-gavel fa-fw',
    'fa-solid fa-gauge-simple-min fa-fw',
    'fa-solid fa-gauge-simple-max fa-fw',
    'fa-solid fa-gauge-simple-low fa-fw',
    'fa-solid fa-gauge-simple-high fa-fw',
    'fa-solid fa-gauge-simple fa-fw',
    'fa-solid fa-gauge-min fa-fw',
    'fa-solid fa-gauge-max fa-fw',
    'fa-solid fa-gauge-low fa-fw',
    'fa-solid fa-gauge-high fa-fw',
    'fa-solid fa-gauge-circle-plus fa-fw',
    'fa-solid fa-gauge-circle-minus fa-fw',
    'fa-solid fa-gauge-circle-bolt fa-fw',
    'fa-solid fa-gas-pump-slash fa-fw',
    'fa-solid fa-gas-pump fa-fw',
    'fa-solid fa-garlic fa-fw',
    'fa-solid fa-garage-open fa-fw',
    'fa-solid fa-garage-car fa-fw',
    'fa-solid fa-garage fa-fw',
    'fa-solid fa-gamepad-modern fa-fw',
    'fa-solid fa-game-console-handheld-crank fa-fw',
    'fa-solid fa-game-board-simple fa-fw',
    'fa-solid fa-game-board fa-fw',
    'fa-solid fa-gallery-thumbnails fa-fw',
    'fa-solid fa-galaxy fa-fw',
    'fa-solid fa-g fa-fw',
    'fa-solid fa-futbol fa-fw',
    'fa-solid fa-function fa-fw',
    'fa-solid fa-frog fa-fw',
    'fa-solid fa-french-fries fa-fw',
    'fa-solid fa-franc-sign fa-fw',
    'fa-solid fa-frame fa-fw',
    'fa-solid fa-forward-step fa-fw',
    'fa-solid fa-forward-fast fa-fw',
    'fa-solid fa-forklift fa-fw',
    'fa-solid fa-fork-knife fa-fw',
    'fa-solid fa-fork fa-fw',
    'fa-solid fa-football-helmet fa-fw',
    'fa-solid fa-football fa-fw',
    'fa-solid fa-font-awesome fa-fw',
    'fa-solid fa-fondue-pot fa-fw',
    'fa-solid fa-folders fa-fw',
    'fa-solid fa-folder-xmark fa-fw',
    'fa-solid fa-folder-user fa-fw',
    'fa-solid fa-folder-tree fa-fw',
    'fa-solid fa-folder-plus fa-fw',
    'fa-solid fa-folder-music fa-fw',
    'fa-solid fa-folder-minus fa-fw',
    'fa-solid fa-folder-medical fa-fw',
    'fa-solid fa-folder-magnifying-glass fa-fw',
    'fa-solid fa-folder-image fa-fw',
    'fa-solid fa-folder-heart fa-fw',
    'fa-solid fa-folder-grid fa-fw',
    'fa-solid fa-folder-gear fa-fw',
    'fa-solid fa-folder-closed fa-fw',
    'fa-solid fa-folder-bookmark fa-fw',
    'fa-solid fa-folder-arrow-up fa-fw',
    'fa-solid fa-folder-arrow-down fa-fw',
    'fa-solid fa-flying-disc fa-fw',
    'fa-solid fa-flux-capacitor fa-fw',
    'fa-solid fa-flute fa-fw',
    'fa-solid fa-flower-daffodil fa-fw',
    'fa-solid fa-florin-sign fa-fw',
    'fa-solid fa-floppy-disks fa-fw',
    'fa-solid fa-floppy-disk-pen fa-fw',
    'fa-solid fa-floppy-disk-circle-xmark fa-fw',
    'fa-solid fa-floppy-disk-circle-arrow-right fa-fw',
    'fa-solid fa-floppy-disk fa-fw',
    'fa-solid fa-flatbread-stuffed fa-fw',
    'fa-solid fa-flatbread fa-fw',
    'fa-solid fa-flask-vial fa-fw',
    'fa-solid fa-flask-round-potion fa-fw',
    'fa-solid fa-flask-round-poison fa-fw',
    'fa-solid fa-flask-gear fa-fw',
    'fa-solid fa-flashlight fa-fw',
    'fa-solid fa-flag-usa fa-fw',
    'fa-solid fa-flag-swallowtail fa-fw',
    'fa-solid fa-flag-pennant fa-fw',
    'fa-solid fa-fishing-rod fa-fw',
    'fa-solid fa-fish-fins fa-fw',
    'fa-solid fa-fish-cooked fa-fw',
    'fa-solid fa-fish-bones fa-fw',
    'fa-solid fa-fireplace fa-fw',
    'fa-solid fa-fire-smoke fa-fw',
    'fa-solid fa-fire-hydrant fa-fw',
    'fa-solid fa-fire-flame-simple fa-fw',
    'fa-solid fa-fire-flame-curved fa-fw',
    'fa-solid fa-fire-flame fa-fw',
    'fa-solid fa-fire-extinguisher fa-fw',
    'fa-solid fa-fire-burner fa-fw',
    'fa-solid fa-filters fa-fw',
    'fa-solid fa-filter-slash fa-fw',
    'fa-solid fa-filter-list fa-fw',
    'fa-solid fa-filter-circle-xmark fa-fw',
    'fa-solid fa-filter-circle-dollar fa-fw',
    'fa-solid fa-films fa-fw',
    'fa-solid fa-film-slash fa-fw',
    'fa-solid fa-film-simple fa-fw',
    'fa-solid fa-film-canister fa-fw',
    'fa-solid fa-fill-drip fa-fw',
    'fa-solid fa-fill fa-fw',
    'fa-solid fa-files-medical fa-fw',
    'fa-solid fa-file-zipper fa-fw',
    'fa-solid fa-file-zip fa-fw',
    'fa-solid fa-file-xmark fa-fw',
    'fa-solid fa-file-waveform fa-fw',
    'fa-solid fa-file-video fa-fw',
    'fa-solid fa-file-user fa-fw',
    'fa-solid fa-file-slash fa-fw',
    'fa-solid fa-file-signature fa-fw',
    'fa-solid fa-file-shield fa-fw',
    'fa-solid fa-file-prescription fa-fw',
    'fa-solid fa-file-powerpoint fa-fw',
    'fa-solid fa-file-plus-minus fa-fw',
    'fa-solid fa-file-plus fa-fw',
    'fa-solid fa-file-pen fa-fw',
    'fa-solid fa-file-music fa-fw',
    'fa-solid fa-file-minus fa-fw',
    'fa-solid fa-file-medical fa-fw',
    'fa-solid fa-file-magnifying-glass fa-fw',
    'fa-solid fa-file-lock fa-fw',
    'fa-solid fa-file-lines fa-fw',
    'fa-solid fa-file-invoice-dollar fa-fw',
    'fa-solid fa-file-image fa-fw',
    'fa-solid fa-file-heart fa-fw',
    'fa-solid fa-file-doc fa-fw',
    'fa-solid fa-file-dashed-line fa-fw',
    'fa-solid fa-file-csv fa-fw',
    'fa-solid fa-file-code fa-fw',
    'fa-solid fa-file-circle-xmark fa-fw',
    'fa-solid fa-file-circle-question fa-fw',
    'fa-solid fa-file-circle-plus fa-fw',
    'fa-solid fa-file-circle-minus fa-fw',
    'fa-solid fa-file-circle-info fa-fw',
    'fa-solid fa-file-circle-exclamation fa-fw',
    'fa-solid fa-file-circle-check fa-fw',
    'fa-solid fa-file-chart-pie fa-fw',
    'fa-solid fa-file-chart-column fa-fw',
    'fa-solid fa-file-certificate fa-fw',
    'fa-solid fa-file-binary fa-fw',
    'fa-solid fa-file-audio fa-fw',
    'fa-solid fa-file-arrow-up fa-fw',
    'fa-solid fa-file-arrow-down fa-fw',
    'fa-solid fa-field-hockey-stick-ball fa-fw',
    'fa-solid fa-ferry fa-fw',
    'fa-solid fa-ferris-wheel fa-fw',
    'fa-solid fa-fence fa-fw',
    'fa-solid fa-feather-pointed fa-fw',
    'fa-solid fa-fax fa-fw',
    'fa-solid fa-faucet-drip fa-fw',
    'fa-solid fa-faucet fa-fw',
    'fa-solid fa-farm fa-fw',
    'fa-solid fa-fan-table fa-fw',
    'fa-solid fa-fan fa-fw',
    'fa-solid fa-family-pants fa-fw',
    'fa-solid fa-family-dress fa-fw',
    'fa-solid fa-family fa-fw',
    'fa-solid fa-falafel fa-fw',
    'fa-solid fa-face-zipper fa-fw',
    'fa-solid fa-face-zany fa-fw',
    'fa-solid fa-face-worried fa-fw',
    'fa-solid fa-face-woozy fa-fw',
    'fa-solid fa-face-weary fa-fw',
    'fa-solid fa-face-viewfinder fa-fw',
    'fa-solid fa-face-unamused fa-fw',
    'fa-solid fa-face-tongue-sweat fa-fw',
    'fa-solid fa-face-tongue-money fa-fw',
    'fa-solid fa-face-tissue fa-fw',
    'fa-solid fa-face-tired fa-fw',
    'fa-solid fa-face-thinking fa-fw',
    'fa-solid fa-face-thermometer fa-fw',
    'fa-solid fa-face-swear fa-fw',
    'fa-solid fa-face-surprise fa-fw',
    'fa-solid fa-face-sunglasses fa-fw',
    'fa-solid fa-face-spiral-eyes fa-fw',
    'fa-solid fa-face-smirking fa-fw',
    'fa-solid fa-face-smiling-hands fa-fw',
    'fa-solid fa-face-smile-wink fa-fw',
    'fa-solid fa-face-smile-upside-down fa-fw',
    'fa-solid fa-face-smile-tongue fa-fw',
    'fa-solid fa-face-smile-tear fa-fw',
    'fa-solid fa-face-smile-relaxed fa-fw',
    'fa-solid fa-face-smile-plus fa-fw',
    'fa-solid fa-face-smile-horns fa-fw',
    'fa-solid fa-face-smile-hearts fa-fw',
    'fa-solid fa-face-smile-halo fa-fw',
    'fa-solid fa-face-smile-beam fa-fw',
    'fa-solid fa-face-sleepy fa-fw',
    'fa-solid fa-face-sleeping fa-fw',
    'fa-solid fa-face-shush fa-fw',
    'fa-solid fa-face-scream fa-fw',
    'fa-solid fa-face-saluting fa-fw',
    'fa-solid fa-face-sad-tear fa-fw',
    'fa-solid fa-face-sad-sweat fa-fw',
    'fa-solid fa-face-sad-cry fa-fw',
    'fa-solid fa-face-rolling-eyes fa-fw',
    'fa-solid fa-face-relieved fa-fw',
    'fa-solid fa-face-raised-eyebrow fa-fw',
    'fa-solid fa-face-pouting fa-fw',
    'fa-solid fa-face-pleading fa-fw',
    'fa-solid fa-face-persevering fa-fw',
    'fa-solid fa-face-pensive fa-fw',
    'fa-solid fa-face-party fa-fw',
    'fa-solid fa-face-nose-steam fa-fw',
    'fa-solid fa-face-nauseated fa-fw',
    'fa-solid fa-face-monocle fa-fw',
    'fa-solid fa-face-melting fa-fw',
    'fa-solid fa-face-meh-blank fa-fw',
    'fa-solid fa-face-meh fa-fw',
    'fa-solid fa-face-mask fa-fw',
    'fa-solid fa-face-lying fa-fw',
    'fa-solid fa-face-laugh-wink fa-fw',
    'fa-solid fa-face-laugh-squint fa-fw',
    'fa-solid fa-face-laugh-beam fa-fw',
    'fa-solid fa-face-laugh fa-fw',
    'fa-solid fa-face-kiss-wink-heart fa-fw',
    'fa-solid fa-face-kiss-closed-eyes fa-fw',
    'fa-solid fa-face-kiss-beam fa-fw',
    'fa-solid fa-face-kiss fa-fw',
    'fa-solid fa-face-icicles fa-fw',
    'fa-solid fa-face-hushed fa-fw',
    'fa-solid fa-face-holding-back-tears fa-fw',
    'fa-solid fa-face-head-bandage fa-fw',
    'fa-solid fa-face-hand-yawn fa-fw',
    'fa-solid fa-face-hand-peeking fa-fw',
    'fa-solid fa-face-hand-over-mouth fa-fw',
    'fa-solid fa-face-grin-wink fa-fw',
    'fa-solid fa-face-grin-wide fa-fw',
    'fa-solid fa-face-grin-tongue-wink fa-fw',
    'fa-solid fa-face-grin-tongue-squint fa-fw',
    'fa-solid fa-face-grin-tongue fa-fw',
    'fa-solid fa-face-grin-tears fa-fw',
    'fa-solid fa-face-grin-stars fa-fw',
    'fa-solid fa-face-grin-squint-tears fa-fw',
    'fa-solid fa-face-grin-squint fa-fw',
    'fa-solid fa-face-grin-hearts fa-fw',
    'fa-solid fa-face-grin-beam-sweat fa-fw',
    'fa-solid fa-face-grin-beam fa-fw',
    'fa-solid fa-face-grin fa-fw',
    'fa-solid fa-face-grimace fa-fw',
    'fa-solid fa-face-glasses fa-fw',
    'fa-solid fa-face-frown-slight fa-fw',
    'fa-solid fa-face-frown-open fa-fw',
    'fa-solid fa-face-frown fa-fw',
    'fa-solid fa-face-flushed fa-fw',
    'fa-solid fa-face-fearful fa-fw',
    'fa-solid fa-face-eyes-xmarks fa-fw',
    'fa-solid fa-face-expressionless fa-fw',
    'fa-solid fa-face-explode fa-fw',
    'fa-solid fa-face-exhaling fa-fw',
    'fa-solid fa-face-drooling fa-fw',
    'fa-solid fa-face-downcast-sweat fa-fw',
    'fa-solid fa-face-dotted fa-fw',
    'fa-solid fa-face-dizzy fa-fw',
    'fa-solid fa-face-disguise fa-fw',
    'fa-solid fa-face-disappointed fa-fw',
    'fa-solid fa-face-diagonal-mouth fa-fw',
    'fa-solid fa-face-cowboy-hat fa-fw',
    'fa-solid fa-face-confused fa-fw',
    'fa-solid fa-face-confounded fa-fw',
    'fa-solid fa-face-clouds fa-fw',
    'fa-solid fa-face-beam-hand-over-mouth fa-fw',
    'fa-solid fa-face-astonished fa-fw',
    'fa-solid fa-face-anxious-sweat fa-fw',
    'fa-solid fa-face-anguished fa-fw',
    'fa-solid fa-face-angry-horns fa-fw',
    'fa-solid fa-face-angry fa-fw',
    'fa-solid fa-f fa-fw',
    'fa-solid fa-eyes fa-fw',
    'fa-solid fa-eye-low-vision fa-fw',
    'fa-solid fa-eye-evil fa-fw',
    'fa-solid fa-eye-dropper-half fa-fw',
    'fa-solid fa-eye-dropper-full fa-fw',
    'fa-solid fa-eye-dropper fa-fw',
    'fa-solid fa-explosion fa-fw',
    'fa-solid fa-expand-wide fa-fw',
    'fa-solid fa-euro-sign fa-fw',
    'fa-solid fa-ethernet fa-fw',
    'fa-solid fa-escalator fa-fw',
    'fa-solid fa-equals fa-fw',
    'fa-solid fa-envelopes-bulk fa-fw',
    'fa-solid fa-envelope-open-text fa-fw',
    'fa-solid fa-envelope-open-dollar fa-fw',
    'fa-solid fa-envelope-open fa-fw',
    'fa-solid fa-envelope-dot fa-fw',
    'fa-solid fa-envelope-circle-check fa-fw',
    'fa-solid fa-engine fa-fw',
    'fa-solid fa-ellipsis-vertical fa-fw',
    'fa-solid fa-ellipsis-stroke-vertical fa-fw',
    'fa-solid fa-ellipsis-stroke fa-fw',
    'fa-solid fa-ellipsis fa-fw',
    'fa-solid fa-elevator fa-fw',
    'fa-solid fa-elephant fa-fw',
    'fa-solid fa-eject fa-fw',
    'fa-solid fa-eggplant fa-fw',
    'fa-solid fa-egg-fried fa-fw',
    'fa-solid fa-egg fa-fw',
    'fa-solid fa-eclipse fa-fw',
    'fa-solid fa-earth-oceania fa-fw',
    'fa-solid fa-earth-europe fa-fw',
    'fa-solid fa-earth-asia fa-fw',
    'fa-solid fa-earth-africa fa-fw',
    'fa-solid fa-ear-muffs fa-fw',
    'fa-solid fa-ear-listen fa-fw',
    'fa-solid fa-ear-deaf fa-fw',
    'fa-solid fa-ear fa-fw',
    'fa-solid fa-e fa-fw',
    'fa-solid fa-dungeon fa-fw',
    'fa-solid fa-dumpster fa-fw',
    'fa-solid fa-duck fa-fw',
    'fa-solid fa-dryer-heat fa-fw',
    'fa-solid fa-dryer fa-fw',
    'fa-solid fa-drumstick-bite fa-fw',
    'fa-solid fa-drumstick fa-fw',
    'fa-solid fa-drum-steelpan fa-fw',
    'fa-solid fa-drum fa-fw',
    'fa-solid fa-droplet-slash fa-fw',
    'fa-solid fa-droplet-percent fa-fw',
    'fa-solid fa-droplet-degree fa-fw',
    'fa-solid fa-drone-front fa-fw',
    'fa-solid fa-drone fa-fw',
    'fa-solid fa-dreidel fa-fw',
    'fa-solid fa-draw-polygon fa-fw',
    'fa-solid fa-draw-circle fa-fw',
    'fa-solid fa-down-to-line fa-fw',
    'fa-solid fa-down-to-dotted-line fa-fw',
    'fa-solid fa-down-to-bracket fa-fw',
    'fa-solid fa-down-right fa-fw',
    'fa-solid fa-down-long fa-fw',
    'fa-solid fa-down-left-and-up-right-to-center fa-fw',
    'fa-solid fa-down-left fa-fw',
    'fa-solid fa-down-from-line fa-fw',
    'fa-solid fa-down-from-dotted-line fa-fw',
    'fa-solid fa-down fa-fw',
    'fa-solid fa-dove fa-fw',
    'fa-solid fa-door-closed fa-fw',
    'fa-solid fa-donut fa-fw',
    'fa-solid fa-dong-sign fa-fw',
    'fa-solid fa-dolly-empty fa-fw',
    'fa-solid fa-dolly fa-fw',
    'fa-solid fa-dog-leashed fa-fw',
    'fa-solid fa-dog fa-fw',
    'fa-solid fa-do-not-enter fa-fw',
    'fa-solid fa-dna fa-fw',
    'fa-solid fa-divide fa-fw',
    'fa-solid fa-ditto fa-fw',
    'fa-solid fa-distribute-spacing-vertical fa-fw',
    'fa-solid fa-distribute-spacing-horizontal fa-fw',
    'fa-solid fa-display-slash fa-fw',
    'fa-solid fa-display-medical fa-fw',
    'fa-solid fa-display-code fa-fw',
    'fa-solid fa-display-chart-up-circle-dollar fa-fw',
    'fa-solid fa-display-chart-up-circle-currency fa-fw',
    'fa-solid fa-display-chart-up fa-fw',
    'fa-solid fa-display-arrow-down fa-fw',
    'fa-solid fa-display fa-fw',
    'fa-solid fa-disease fa-fw',
    'fa-solid fa-disc-drive fa-fw',
    'fa-solid fa-diploma fa-fw',
    'fa-solid fa-dinosaur fa-fw',
    'fa-solid fa-dice-two fa-fw',
    'fa-solid fa-dice-three fa-fw',
    'fa-solid fa-dice-six fa-fw',
    'fa-solid fa-dice-one fa-fw',
    'fa-solid fa-dice-four fa-fw',
    'fa-solid fa-dice-five fa-fw',
    'fa-solid fa-dice-d8 fa-fw',
    'fa-solid fa-dice-d6 fa-fw',
    'fa-solid fa-dice-d4 fa-fw',
    'fa-solid fa-dice-d20 fa-fw',
    'fa-solid fa-dice-d12 fa-fw',
    'fa-solid fa-dice-d10 fa-fw',
    'fa-solid fa-diamond-turn-right fa-fw',
    'fa-solid fa-diamond-half-stroke fa-fw',
    'fa-solid fa-diamond-half fa-fw',
    'fa-solid fa-diamond-exclamation fa-fw',
    'fa-solid fa-dial-off fa-fw',
    'fa-solid fa-dial-min fa-fw',
    'fa-solid fa-dial-med-low fa-fw',
    'fa-solid fa-dial-med fa-fw',
    'fa-solid fa-dial-max fa-fw',
    'fa-solid fa-dial-low fa-fw',
    'fa-solid fa-dial-high fa-fw',
    'fa-solid fa-dial fa-fw',
    'fa-solid fa-diagram-successor fa-fw',
    'fa-solid fa-diagram-subtask fa-fw',
    'fa-solid fa-diagram-sankey fa-fw',
    'fa-solid fa-diagram-project fa-fw',
    'fa-solid fa-diagram-previous fa-fw',
    'fa-solid fa-diagram-predecessor fa-fw',
    'fa-solid fa-diagram-next fa-fw',
    'fa-solid fa-diagram-nested fa-fw',
    'fa-solid fa-diagram-lean-canvas fa-fw',
    'fa-solid fa-diagram-cells fa-fw',
    'fa-solid fa-dharmachakra fa-fw',
    'fa-solid fa-desktop-arrow-down fa-fw',
    'fa-solid fa-democrat fa-fw',
    'fa-solid fa-delete-right fa-fw',
    'fa-solid fa-delete-left fa-fw',
    'fa-solid fa-deer-rudolph fa-fw',
    'fa-solid fa-deer fa-fw',
    'fa-solid fa-dash fa-fw',
    'fa-solid fa-dagger fa-fw',
    'fa-solid fa-d fa-fw',
    'fa-solid fa-custard fa-fw',
    'fa-solid fa-curling-stone fa-fw',
    'fa-solid fa-cupcake fa-fw',
    'fa-solid fa-cup-togo fa-fw',
    'fa-solid fa-cup-straw-swoosh fa-fw',
    'fa-solid fa-cup-straw fa-fw',
    'fa-solid fa-cucumber fa-fw',
    'fa-solid fa-cubes-stacked fa-fw',
    'fa-solid fa-cubes fa-fw',
    'fa-solid fa-crystal-ball fa-fw',
    'fa-solid fa-cruzeiro-sign fa-fw',
    'fa-solid fa-crutches fa-fw',
    'fa-solid fa-crutch fa-fw',
    'fa-solid fa-crow fa-fw',
    'fa-solid fa-crosshairs-simple fa-fw',
    'fa-solid fa-crop-simple fa-fw',
    'fa-solid fa-crop fa-fw',
    'fa-solid fa-croissant fa-fw',
    'fa-solid fa-cricket-bat-ball fa-fw',
    'fa-solid fa-credit-card-front fa-fw',
    'fa-solid fa-credit-card-blank fa-fw',
    'fa-solid fa-crate-empty fa-fw',
    'fa-solid fa-crate-apple fa-fw',
    'fa-solid fa-cowbell-circle-plus fa-fw',
    'fa-solid fa-cowbell fa-fw',
    'fa-solid fa-cow fa-fw',
    'fa-solid fa-couch fa-fw',
    'fa-solid fa-corner fa-fw',
    'fa-solid fa-corn fa-fw',
    'fa-solid fa-cookie fa-fw',
    'fa-solid fa-conveyor-belt-empty fa-fw',
    'fa-solid fa-conveyor-belt-boxes fa-fw',
    'fa-solid fa-conveyor-belt-arm fa-fw',
    'fa-solid fa-conveyor-belt fa-fw',
    'fa-solid fa-computer-mouse fa-fw',
    'fa-solid fa-computer fa-fw',
    'fa-solid fa-compress-wide fa-fw',
    'fa-solid fa-compress fa-fw',
    'fa-solid fa-compass-slash fa-fw',
    'fa-solid fa-compass-drafting fa-fw',
    'fa-solid fa-compact-disc fa-fw',
    'fa-solid fa-comments-question-check fa-fw',
    'fa-solid fa-comments-question fa-fw',
    'fa-solid fa-comment-xmark fa-fw',
    'fa-solid fa-comment-text fa-fw',
    'fa-solid fa-comment-sms fa-fw',
    'fa-solid fa-comment-smile fa-fw',
    'fa-solid fa-comment-slash fa-fw',
    'fa-solid fa-comment-quote fa-fw',
    'fa-solid fa-comment-question fa-fw',
    'fa-solid fa-comment-plus fa-fw',
    'fa-solid fa-comment-pen fa-fw',
    'fa-solid fa-comment-music fa-fw',
    'fa-solid fa-comment-minus fa-fw',
    'fa-solid fa-comment-middle-top fa-fw',
    'fa-solid fa-comment-middle fa-fw',
    'fa-solid fa-comment-medical fa-fw',
    'fa-solid fa-comment-lines fa-fw',
    'fa-solid fa-comment-image fa-fw',
    'fa-solid fa-comment-heart fa-fw',
    'fa-solid fa-comment-exclamation fa-fw',
    'fa-solid fa-comment-dots fa-fw',
    'fa-solid fa-comment-dollar fa-fw',
    'fa-solid fa-comment-code fa-fw',
    'fa-solid fa-comment-check fa-fw',
    'fa-solid fa-comment-captions fa-fw',
    'fa-solid fa-comment-arrow-up-right fa-fw',
    'fa-solid fa-comment-arrow-up fa-fw',
    'fa-solid fa-comment-arrow-down fa-fw',
    'fa-solid fa-command fa-fw',
    'fa-solid fa-comma fa-fw',
    'fa-solid fa-comet fa-fw',
    'fa-solid fa-columns-3 fa-fw',
    'fa-solid fa-colon-sign fa-fw',
    'fa-solid fa-colon fa-fw',
    'fa-solid fa-coin-vertical fa-fw',
    'fa-solid fa-coin-front fa-fw',
    'fa-solid fa-coin-blank fa-fw',
    'fa-solid fa-coffin-cross fa-fw',
    'fa-solid fa-coffin fa-fw',
    'fa-solid fa-coffee-pot fa-fw',
    'fa-solid fa-coffee-beans fa-fw',
    'fa-solid fa-coffee-bean fa-fw',
    'fa-solid fa-code-simple fa-fw',
    'fa-solid fa-code-pull-request-draft fa-fw',
    'fa-solid fa-code-pull-request-closed fa-fw',
    'fa-solid fa-code-pull-request fa-fw',
    'fa-solid fa-code-merge fa-fw',
    'fa-solid fa-code-fork fa-fw',
    'fa-solid fa-code-commit fa-fw',
    'fa-solid fa-coconut fa-fw',
    'fa-solid fa-club fa-fw',
    'fa-solid fa-clover fa-fw',
    'fa-solid fa-clouds-sun fa-fw',
    'fa-solid fa-clouds-moon fa-fw',
    'fa-solid fa-clouds fa-fw',
    'fa-solid fa-cloud-xmark fa-fw',
    'fa-solid fa-cloud-word fa-fw',
    'fa-solid fa-cloud-sun-rain fa-fw',
    'fa-solid fa-cloud-sun fa-fw',
    'fa-solid fa-cloud-snow fa-fw',
    'fa-solid fa-cloud-sleet fa-fw',
    'fa-solid fa-cloud-slash fa-fw',
    'fa-solid fa-cloud-showers-water fa-fw',
    'fa-solid fa-cloud-showers-heavy fa-fw',
    'fa-solid fa-cloud-showers fa-fw',
    'fa-solid fa-cloud-rainbow fa-fw',
    'fa-solid fa-cloud-rain fa-fw',
    'fa-solid fa-cloud-question fa-fw',
    'fa-solid fa-cloud-plus fa-fw',
    'fa-solid fa-cloud-music fa-fw',
    'fa-solid fa-cloud-moon-rain fa-fw',
    'fa-solid fa-cloud-moon fa-fw',
    'fa-solid fa-cloud-minus fa-fw',
    'fa-solid fa-cloud-meatball fa-fw',
    'fa-solid fa-cloud-hail-mixed fa-fw',
    'fa-solid fa-cloud-hail fa-fw',
    'fa-solid fa-cloud-fog fa-fw',
    'fa-solid fa-cloud-exclamation fa-fw',
    'fa-solid fa-cloud-drizzle fa-fw',
    'fa-solid fa-cloud-check fa-fw',
    'fa-solid fa-cloud-bolt-sun fa-fw',
    'fa-solid fa-cloud-bolt-moon fa-fw',
    'fa-solid fa-cloud-bolt fa-fw',
    'fa-solid fa-cloud-binary fa-fw',
    'fa-solid fa-cloud-arrow-down fa-fw',
    'fa-solid fa-clothes-hanger fa-fw',
    'fa-solid fa-closed-captioning-slash fa-fw',
    'fa-solid fa-clock-two-thirty fa-fw',
    'fa-solid fa-clock-two fa-fw',
    'fa-solid fa-clock-twelve-thirty fa-fw',
    'fa-solid fa-clock-twelve fa-fw',
    'fa-solid fa-clock-three-thirty fa-fw',
    'fa-solid fa-clock-three fa-fw',
    'fa-solid fa-clock-ten-thirty fa-fw',
    'fa-solid fa-clock-ten fa-fw',
    'fa-solid fa-clock-six-thirty fa-fw',
    'fa-solid fa-clock-six fa-fw',
    'fa-solid fa-clock-seven-thirty fa-fw',
    'fa-solid fa-clock-seven fa-fw',
    'fa-solid fa-clock-rotate-left fa-fw',
    'fa-solid fa-clock-one-thirty fa-fw',
    'fa-solid fa-clock-one fa-fw',
    'fa-solid fa-clock-nine-thirty fa-fw',
    'fa-solid fa-clock-nine fa-fw',
    'fa-solid fa-clock-four-thirty fa-fw',
    'fa-solid fa-clock-five-thirty fa-fw',
    'fa-solid fa-clock-five fa-fw',
    'fa-solid fa-clock-eleven-thirty fa-fw',
    'fa-solid fa-clock-eleven fa-fw',
    'fa-solid fa-clock-eight-thirty fa-fw',
    'fa-solid fa-clock-eight fa-fw',
    'fa-solid fa-clock-desk fa-fw',
    'fa-solid fa-clipboard-user fa-fw',
    'fa-solid fa-clipboard-question fa-fw',
    'fa-solid fa-clipboard-prescription fa-fw',
    'fa-solid fa-clipboard-medical fa-fw',
    'fa-solid fa-clipboard-list-check fa-fw',
    'fa-solid fa-clipboard-list fa-fw',
    'fa-solid fa-clipboard-check fa-fw',
    'fa-solid fa-claw-marks fa-fw',
    'fa-solid fa-clarinet fa-fw',
    'fa-solid fa-clapperboard-play fa-fw',
    'fa-solid fa-clapperboard fa-fw',
    'fa-solid fa-citrus-slice fa-fw',
    'fa-solid fa-citrus fa-fw',
    'fa-solid fa-circles-overlap fa-fw',
    'fa-solid fa-circle-z fa-fw',
    'fa-solid fa-circle-yen fa-fw',
    'fa-solid fa-circle-y fa-fw',
    'fa-solid fa-circle-x fa-fw',
    'fa-solid fa-circle-waveform-lines fa-fw',
    'fa-solid fa-circle-w fa-fw',
    'fa-solid fa-circle-video fa-fw',
    'fa-solid fa-circle-v fa-fw',
    'fa-solid fa-circle-up-right fa-fw',
    'fa-solid fa-circle-up-left fa-fw',
    'fa-solid fa-circle-u fa-fw',
    'fa-solid fa-circle-trash fa-fw',
    'fa-solid fa-circle-three-quarters-stroke fa-fw',
    'fa-solid fa-circle-three-quarters fa-fw',
    'fa-solid fa-circle-t fa-fw',
    'fa-solid fa-circle-stop fa-fw',
    'fa-solid fa-circle-sterling fa-fw',
    'fa-solid fa-circle-star fa-fw',
    'fa-solid fa-circle-sort-up fa-fw',
    'fa-solid fa-circle-sort-down fa-fw',
    'fa-solid fa-circle-sort fa-fw',
    'fa-solid fa-circle-small fa-fw',
    'fa-solid fa-circle-s fa-fw',
    'fa-solid fa-circle-right fa-fw',
    'fa-solid fa-circle-radiation fa-fw',
    'fa-solid fa-circle-r fa-fw',
    'fa-solid fa-circle-question fa-fw',
    'fa-solid fa-circle-quarters fa-fw',
    'fa-solid fa-circle-quarter-stroke fa-fw',
    'fa-solid fa-circle-quarter fa-fw',
    'fa-solid fa-circle-q fa-fw',
    'fa-solid fa-circle-plus fa-fw',
    'fa-solid fa-circle-play fa-fw',
    'fa-solid fa-circle-phone-hangup fa-fw',
    'fa-solid fa-circle-phone-flip fa-fw',
    'fa-solid fa-circle-phone fa-fw',
    'fa-solid fa-circle-pause fa-fw',
    'fa-solid fa-circle-parking fa-fw',
    'fa-solid fa-circle-p fa-fw',
    'fa-solid fa-circle-o fa-fw',
    'fa-solid fa-circle-nodes fa-fw',
    'fa-solid fa-circle-n fa-fw',
    'fa-solid fa-circle-minus fa-fw',
    'fa-solid fa-circle-microphone-lines fa-fw',
    'fa-solid fa-circle-microphone fa-fw',
    'fa-solid fa-circle-m fa-fw',
    'fa-solid fa-circle-location-arrow fa-fw',
    'fa-solid fa-circle-left fa-fw',
    'fa-solid fa-circle-l fa-fw',
    'fa-solid fa-circle-k fa-fw',
    'fa-solid fa-circle-j fa-fw',
    'fa-solid fa-circle-i fa-fw',
    'fa-solid fa-circle-heart fa-fw',
    'fa-solid fa-circle-half fa-fw',
    'fa-solid fa-circle-h fa-fw',
    'fa-solid fa-circle-g fa-fw',
    'fa-solid fa-circle-f fa-fw',
    'fa-solid fa-circle-exclamation-check fa-fw',
    'fa-solid fa-circle-euro fa-fw',
    'fa-solid fa-circle-envelope fa-fw',
    'fa-solid fa-circle-ellipsis-vertical fa-fw',
    'fa-solid fa-circle-ellipsis fa-fw',
    'fa-solid fa-circle-e fa-fw',
    'fa-solid fa-circle-down-right fa-fw',
    'fa-solid fa-circle-down-left fa-fw',
    'fa-solid fa-circle-dot fa-fw',
    'fa-solid fa-circle-dollar-to-slot fa-fw',
    'fa-solid fa-circle-dollar fa-fw',
    'fa-solid fa-circle-divide fa-fw',
    'fa-solid fa-circle-dashed fa-fw',
    'fa-solid fa-circle-d fa-fw',
    'fa-solid fa-circle-chevron-up fa-fw',
    'fa-solid fa-circle-chevron-right fa-fw',
    'fa-solid fa-circle-chevron-left fa-fw',
    'fa-solid fa-circle-chevron-down fa-fw',
    'fa-solid fa-circle-caret-up fa-fw',
    'fa-solid fa-circle-caret-right fa-fw',
    'fa-solid fa-circle-caret-left fa-fw',
    'fa-solid fa-circle-caret-down fa-fw',
    'fa-solid fa-circle-camera fa-fw',
    'fa-solid fa-circle-calendar fa-fw',
    'fa-solid fa-circle-c fa-fw',
    'fa-solid fa-circle-bookmark fa-fw',
    'fa-solid fa-circle-book-open fa-fw',
    'fa-solid fa-circle-bolt fa-fw',
    'fa-solid fa-circle-b fa-fw',
    'fa-solid fa-circle-arrow-up-right fa-fw',
    'fa-solid fa-circle-arrow-up-left fa-fw',
    'fa-solid fa-circle-arrow-up fa-fw',
    'fa-solid fa-circle-arrow-right fa-fw',
    'fa-solid fa-circle-arrow-left fa-fw',
    'fa-solid fa-circle-arrow-down-right fa-fw',
    'fa-solid fa-circle-arrow-down-left fa-fw',
    'fa-solid fa-circle-arrow-down fa-fw',
    'fa-solid fa-circle-ampersand fa-fw',
    'fa-solid fa-circle-a fa-fw',
    'fa-solid fa-circle-9 fa-fw',
    'fa-solid fa-circle-8 fa-fw',
    'fa-solid fa-circle-7 fa-fw',
    'fa-solid fa-circle-6 fa-fw',
    'fa-solid fa-circle-5 fa-fw',
    'fa-solid fa-circle-4 fa-fw',
    'fa-solid fa-circle-3 fa-fw',
    'fa-solid fa-circle-2 fa-fw',
    'fa-solid fa-circle-1 fa-fw',
    'fa-solid fa-circle-0 fa-fw',
    'fa-solid fa-chopsticks fa-fw',
    'fa-solid fa-chimney fa-fw',
    'fa-solid fa-children fa-fw',
    'fa-solid fa-child-reaching fa-fw',
    'fa-solid fa-child-dress fa-fw',
    'fa-solid fa-child-combatant fa-fw',
    'fa-solid fa-chf-sign fa-fw',
    'fa-solid fa-chevrons-up fa-fw',
    'fa-solid fa-chevrons-right fa-fw',
    'fa-solid fa-chevrons-left fa-fw',
    'fa-solid fa-chevrons-down fa-fw',
    'fa-solid fa-chevron-right fa-fw',
    'fa-solid fa-chevron-left fa-fw',
    'fa-solid fa-chestnut fa-fw',
    'fa-solid fa-chess-rook-piece fa-fw',
    'fa-solid fa-chess-rook fa-fw',
    'fa-solid fa-chess-queen-piece fa-fw',
    'fa-solid fa-chess-queen fa-fw',
    'fa-solid fa-chess-pawn-piece fa-fw',
    'fa-solid fa-chess-pawn fa-fw',
    'fa-solid fa-chess-knight-piece fa-fw',
    'fa-solid fa-chess-knight fa-fw',
    'fa-solid fa-chess-king-piece fa-fw',
    'fa-solid fa-chess-king fa-fw',
    'fa-solid fa-chess-clock-flip fa-fw',
    'fa-solid fa-chess-clock fa-fw',
    'fa-solid fa-chess-board fa-fw',
    'fa-solid fa-chess-bishop-piece fa-fw',
    'fa-solid fa-chess-bishop fa-fw',
    'fa-solid fa-chess fa-fw',
    'fa-solid fa-cherries fa-fw',
    'fa-solid fa-cheese-swiss fa-fw',
    'fa-solid fa-cheese fa-fw',
    'fa-solid fa-check-to-slot fa-fw',
    'fa-solid fa-check-double fa-fw',
    'fa-solid fa-chart-waterfall fa-fw',
    'fa-solid fa-chart-user fa-fw',
    'fa-solid fa-chart-tree-map fa-fw',
    'fa-solid fa-chart-simple-horizontal fa-fw',
    'fa-solid fa-chart-scatter-bubble fa-fw',
    'fa-solid fa-chart-scatter-3d fa-fw',
    'fa-solid fa-chart-radar fa-fw',
    'fa-solid fa-chart-pyramid fa-fw',
    'fa-solid fa-chart-pie-simple-circle-dollar fa-fw',
    'fa-solid fa-chart-pie-simple-circle-currency fa-fw',
    'fa-solid fa-chart-pie-simple fa-fw',
    'fa-solid fa-chart-pie fa-fw',
    'fa-solid fa-chart-network fa-fw',
    'fa-solid fa-chart-mixed-up-circle-dollar fa-fw',
    'fa-solid fa-chart-mixed-up-circle-currency fa-fw',
    'fa-solid fa-chart-mixed fa-fw',
    'fa-solid fa-chart-line-up-down fa-fw',
    'fa-solid fa-chart-line-up fa-fw',
    'fa-solid fa-chart-line-down fa-fw',
    'fa-solid fa-chart-line fa-fw',
    'fa-solid fa-chart-gantt fa-fw',
    'fa-solid fa-chart-column fa-fw',
    'fa-solid fa-chart-candlestick fa-fw',
    'fa-solid fa-chart-bullet fa-fw',
    'fa-solid fa-chart-bar fa-fw',
    'fa-solid fa-chart-area fa-fw',
    'fa-solid fa-charging-station fa-fw',
    'fa-solid fa-champagne-glasses fa-fw',
    'fa-solid fa-champagne-glass fa-fw',
    'fa-solid fa-chalkboard-user fa-fw',
    'fa-solid fa-chair-office fa-fw',
    'fa-solid fa-cent-sign fa-fw',
    'fa-solid fa-cedi-sign fa-fw',
    'fa-solid fa-cat-space fa-fw',
    'fa-solid fa-cat fa-fw',
    'fa-solid fa-castle fa-fw',
    'fa-solid fa-cassette-vhs fa-fw',
    'fa-solid fa-cassette-tape fa-fw',
    'fa-solid fa-cassette-betamax fa-fw',
    'fa-solid fa-cart-xmark fa-fw',
    'fa-solid fa-cart-shopping-fast fa-fw',
    'fa-solid fa-cart-minus fa-fw',
    'fa-solid fa-cart-flatbed-suitcase fa-fw',
    'fa-solid fa-cart-flatbed-empty fa-fw',
    'fa-solid fa-cart-flatbed-boxes fa-fw',
    'fa-solid fa-cart-flatbed fa-fw',
    'fa-solid fa-cart-circle-xmark fa-fw',
    'fa-solid fa-cart-circle-plus fa-fw',
    'fa-solid fa-cart-circle-exclamation fa-fw',
    'fa-solid fa-cart-circle-check fa-fw',
    'fa-solid fa-cart-circle-arrow-up fa-fw',
    'fa-solid fa-cart-circle-arrow-down fa-fw',
    'fa-solid fa-cart-arrow-up fa-fw',
    'fa-solid fa-cart-arrow-down fa-fw',
    'fa-solid fa-cars fa-fw',
    'fa-solid fa-carrot fa-fw',
    'fa-solid fa-caret-right fa-fw',
    'fa-solid fa-caret-left fa-fw',
    'fa-solid fa-cards-blank fa-fw',
    'fa-solid fa-cards fa-fw',
    'fa-solid fa-card-spade fa-fw',
    'fa-solid fa-card-heart fa-fw',
    'fa-solid fa-card-diamond fa-fw',
    'fa-solid fa-card-club fa-fw',
    'fa-solid fa-caravan-simple fa-fw',
    'fa-solid fa-caravan fa-fw',
    'fa-solid fa-car-wrench fa-fw',
    'fa-solid fa-car-wash fa-fw',
    'fa-solid fa-car-tunnel fa-fw',
    'fa-solid fa-car-tilt fa-fw',
    'fa-solid fa-car-side-bolt fa-fw',
    'fa-solid fa-car-rear fa-fw',
    'fa-solid fa-car-on fa-fw',
    'fa-solid fa-car-mirrors fa-fw',
    'fa-solid fa-car-garage fa-fw',
    'fa-solid fa-car-circle-bolt fa-fw',
    'fa-solid fa-car-bus fa-fw',
    'fa-solid fa-car-burst fa-fw',
    'fa-solid fa-car-bump fa-fw',
    'fa-solid fa-car-bolt fa-fw',
    'fa-solid fa-car-battery fa-fw',
    'fa-solid fa-capsules fa-fw',
    'fa-solid fa-cannabis fa-fw',
    'fa-solid fa-candy-corn fa-fw',
    'fa-solid fa-candy-cane fa-fw',
    'fa-solid fa-candy-bar fa-fw',
    'fa-solid fa-candy fa-fw',
    'fa-solid fa-candle-holder fa-fw',
    'fa-solid fa-can-food fa-fw',
    'fa-solid fa-campground fa-fw',
    'fa-solid fa-camera-web-slash fa-fw',
    'fa-solid fa-camera-web fa-fw',
    'fa-solid fa-camera-viewfinder fa-fw',
    'fa-solid fa-camera-slash fa-fw',
    'fa-solid fa-camera-security fa-fw',
    'fa-solid fa-camera-rotate fa-fw',
    'fa-solid fa-camera-polaroid fa-fw',
    'fa-solid fa-camera-cctv fa-fw',
    'fa-solid fa-camcorder fa-fw',
    'fa-solid fa-calendars fa-fw',
    'fa-solid fa-calendar-xmark fa-fw',
    'fa-solid fa-calendar-users fa-fw',
    'fa-solid fa-calendar-star fa-fw',
    'fa-solid fa-calendar-range fa-fw',
    'fa-solid fa-calendar-plus fa-fw',
    'fa-solid fa-calendar-pen fa-fw',
    'fa-solid fa-calendar-minus fa-fw',
    'fa-solid fa-calendar-lines-pen fa-fw',
    'fa-solid fa-calendar-lines fa-fw',
    'fa-solid fa-calendar-image fa-fw',
    'fa-solid fa-calendar-heart fa-fw',
    'fa-solid fa-calendar-exclamation fa-fw',
    'fa-solid fa-calendar-day fa-fw',
    'fa-solid fa-calendar-clock fa-fw',
    'fa-solid fa-calendar-circle-user fa-fw',
    'fa-solid fa-calendar-circle-plus fa-fw',
    'fa-solid fa-calendar-circle-minus fa-fw',
    'fa-solid fa-calendar-circle-exclamation fa-fw',
    'fa-solid fa-calendar-check fa-fw',
    'fa-solid fa-calendar-arrow-up fa-fw',
    'fa-solid fa-calendar-arrow-down fa-fw',
    'fa-solid fa-calculator-simple fa-fw',
    'fa-solid fa-cake-slice fa-fw',
    'fa-solid fa-cake-candles fa-fw',
    'fa-solid fa-cactus fa-fw',
    'fa-solid fa-cabinet-filing fa-fw',
    'fa-solid fa-cabin fa-fw',
    'fa-solid fa-c fa-fw',
    'fa-solid fa-butter fa-fw',
    'fa-solid fa-bus-simple fa-fw',
    'fa-solid fa-bus-school fa-fw',
    'fa-solid fa-bus fa-fw',
    'fa-solid fa-burst fa-fw',
    'fa-solid fa-burger-lettuce fa-fw',
    'fa-solid fa-burger-glass fa-fw',
    'fa-solid fa-burger-fries fa-fw',
    'fa-solid fa-burger-cheese fa-fw',
    'fa-solid fa-burger fa-fw',
    'fa-solid fa-buoy-mooring fa-fw',
    'fa-solid fa-buoy fa-fw',
    'fa-solid fa-bullseye-arrow fa-fw',
    'fa-solid fa-bullhorn fa-fw',
    'fa-solid fa-buildings fa-fw',
    'fa-solid fa-building-wheat fa-fw',
    'fa-solid fa-building-user fa-fw',
    'fa-solid fa-building-un fa-fw',
    'fa-solid fa-building-shield fa-fw',
    'fa-solid fa-building-ngo fa-fw',
    'fa-solid fa-building-lock fa-fw',
    'fa-solid fa-building-flag fa-fw',
    'fa-solid fa-building-columns fa-fw',
    'fa-solid fa-building-circle-xmark fa-fw',
    'fa-solid fa-building-circle-exclamation fa-fw',
    'fa-solid fa-building-circle-check fa-fw',
    'fa-solid fa-building-circle-arrow-right fa-fw',
    'fa-solid fa-bugs fa-fw',
    'fa-solid fa-bug-slash fa-fw',
    'fa-solid fa-bucket fa-fw',
    'fa-solid fa-browsers fa-fw',
    'fa-solid fa-broom-wide fa-fw',
    'fa-solid fa-broom-ball fa-fw',
    'fa-solid fa-broom fa-fw',
    'fa-solid fa-broccoli fa-fw',
    'fa-solid fa-bring-front fa-fw',
    'fa-solid fa-bring-forward fa-fw',
    'fa-solid fa-brightness-low fa-fw',
    'fa-solid fa-brightness fa-fw',
    'fa-solid fa-briefcase-medical fa-fw',
    'fa-solid fa-briefcase-blank fa-fw',
    'fa-solid fa-briefcase-arrow-right fa-fw',
    'fa-solid fa-bridge-water fa-fw',
    'fa-solid fa-bridge-suspension fa-fw',
    'fa-solid fa-bridge-lock fa-fw',
    'fa-solid fa-bridge-circle-xmark fa-fw',
    'fa-solid fa-bridge-circle-exclamation fa-fw',
    'fa-solid fa-bridge-circle-check fa-fw',
    'fa-solid fa-bridge fa-fw',
    'fa-solid fa-bread-slice-butter fa-fw',
    'fa-solid fa-bread-slice fa-fw',
    'fa-solid fa-bread-loaf fa-fw',
    'fa-solid fa-brazilian-real-sign fa-fw',
    'fa-solid fa-brake-warning fa-fw',
    'fa-solid fa-brain-circuit fa-fw',
    'fa-solid fa-brain-arrow-curved-right fa-fw',
    'fa-solid fa-braille fa-fw',
    'fa-solid fa-brackets-square fa-fw',
    'fa-solid fa-brackets-round fa-fw',
    'fa-solid fa-bracket-square-right fa-fw',
    'fa-solid fa-bracket-square fa-fw',
    'fa-solid fa-bracket-round-right fa-fw',
    'fa-solid fa-bracket-round fa-fw',
    'fa-solid fa-bracket-curly-right fa-fw',
    'fa-solid fa-bracket-curly fa-fw',
    'fa-solid fa-boxing-glove fa-fw',
    'fa-solid fa-boxes-stacked fa-fw',
    'fa-solid fa-boxes-packing fa-fw',
    'fa-solid fa-box-tissue fa-fw',
    'fa-solid fa-box-taped fa-fw',
    'fa-solid fa-box-open-full fa-fw',
    'fa-solid fa-box-open fa-fw',
    'fa-solid fa-box-heart fa-fw',
    'fa-solid fa-box-dollar fa-fw',
    'fa-solid fa-box-circle-check fa-fw',
    'fa-solid fa-box-check fa-fw',
    'fa-solid fa-box-ballot fa-fw',
    'fa-solid fa-box-archive fa-fw',
    'fa-solid fa-box fa-fw',
    'fa-solid fa-bowling-pins fa-fw',
    'fa-solid fa-bowling-ball-pin fa-fw',
    'fa-solid fa-bowling-ball fa-fw',
    'fa-solid fa-bowl-spoon fa-fw',
    'fa-solid fa-bowl-soft-serve fa-fw',
    'fa-solid fa-bowl-scoops fa-fw',
    'fa-solid fa-bowl-scoop fa-fw',
    'fa-solid fa-bowl-rice fa-fw',
    'fa-solid fa-bowl-hot fa-fw',
    'fa-solid fa-bowl-food fa-fw',
    'fa-solid fa-bowl-chopsticks fa-fw',
    'fa-solid fa-bow-arrow fa-fw',
    'fa-solid fa-bottle-water fa-fw',
    'fa-solid fa-bottle-droplet fa-fw',
    'fa-solid fa-bore-hole fa-fw',
    'fa-solid fa-border-top-left fa-fw',
    'fa-solid fa-border-right fa-fw',
    'fa-solid fa-border-outer fa-fw',
    'fa-solid fa-border-left fa-fw',
    'fa-solid fa-border-inner fa-fw',
    'fa-solid fa-border-center-v fa-fw',
    'fa-solid fa-border-center-h fa-fw',
    'fa-solid fa-border-bottom-right fa-fw',
    'fa-solid fa-border-bottom fa-fw',
    'fa-solid fa-border-all fa-fw',
    'fa-solid fa-boot-heeled fa-fw',
    'fa-solid fa-boot fa-fw',
    'fa-solid fa-boombox fa-fw',
    'fa-solid fa-books-medical fa-fw',
    'fa-solid fa-bookmark-slash fa-fw',
    'fa-solid fa-book-user fa-fw',
    'fa-solid fa-book-tanakh fa-fw',
    'fa-solid fa-book-sparkles fa-fw',
    'fa-solid fa-book-skull fa-fw',
    'fa-solid fa-book-section fa-fw',
    'fa-solid fa-book-quran fa-fw',
    'fa-solid fa-book-open-reader fa-fw',
    'fa-solid fa-book-open-cover fa-fw',
    'fa-solid fa-book-open fa-fw',
    'fa-solid fa-book-medical fa-fw',
    'fa-solid fa-book-journal-whills fa-fw',
    'fa-solid fa-book-heart fa-fw',
    'fa-solid fa-book-font fa-fw',
    'fa-solid fa-book-copy fa-fw',
    'fa-solid fa-book-circle-arrow-up fa-fw',
    'fa-solid fa-book-circle-arrow-right fa-fw',
    'fa-solid fa-book-bookmark fa-fw',
    'fa-solid fa-book-blank fa-fw',
    'fa-solid fa-book-bible fa-fw',
    'fa-solid fa-book-atlas fa-fw',
    'fa-solid fa-book-arrow-up fa-fw',
    'fa-solid fa-book-arrow-right fa-fw',
    'fa-solid fa-bong fa-fw',
    'fa-solid fa-bone-break fa-fw',
    'fa-solid fa-bone fa-fw',
    'fa-solid fa-bolt-slash fa-fw',
    'fa-solid fa-bolt-lightning fa-fw',
    'fa-solid fa-bolt-auto fa-fw',
    'fa-solid fa-bold fa-fw',
    'fa-solid fa-bluetooth fa-fw',
    'fa-solid fa-blueberries fa-fw',
    'fa-solid fa-block-quote fa-fw',
    'fa-solid fa-block-brick-fire fa-fw',
    'fa-solid fa-block-brick fa-fw',
    'fa-solid fa-block fa-fw',
    'fa-solid fa-blinds-open fa-fw',
    'fa-solid fa-blinds fa-fw',
    'fa-solid fa-blender-phone fa-fw',
    'fa-solid fa-blender fa-fw',
    'fa-solid fa-blanket-fire fa-fw',
    'fa-solid fa-bitcoin-sign fa-fw',
    'fa-solid fa-biohazard fa-fw',
    'fa-solid fa-binary-slash fa-fw',
    'fa-solid fa-binary-lock fa-fw',
    'fa-solid fa-binary-circle-check fa-fw',
    'fa-solid fa-binary fa-fw',
    'fa-solid fa-bin-recycle fa-fw',
    'fa-solid fa-bin-bottles-recycle fa-fw',
    'fa-solid fa-bin-bottles fa-fw',
    'fa-solid fa-billboard fa-fw',
    'fa-solid fa-bezier-curve fa-fw',
    'fa-solid fa-bench-tree fa-fw',
    'fa-solid fa-bells fa-fw',
    'fa-solid fa-bell-slash fa-fw',
    'fa-solid fa-bell-school-slash fa-fw',
    'fa-solid fa-bell-school fa-fw',
    'fa-solid fa-bell-plus fa-fw',
    'fa-solid fa-bell-on fa-fw',
    'fa-solid fa-bell-exclamation fa-fw',
    'fa-solid fa-bell-concierge fa-fw',
    'fa-solid fa-beer-mug-empty fa-fw',
    'fa-solid fa-beer-mug fa-fw',
    'fa-solid fa-bee fa-fw',
    'fa-solid fa-bed-pulse fa-fw',
    'fa-solid fa-bed-empty fa-fw',
    'fa-solid fa-bed-bunk fa-fw',
    'fa-solid fa-bed fa-fw',
    'fa-solid fa-battery-three-quarters fa-fw',
    'fa-solid fa-battery-slash fa-fw',
    'fa-solid fa-battery-quarter fa-fw',
    'fa-solid fa-battery-low fa-fw',
    'fa-solid fa-battery-half fa-fw',
    'fa-solid fa-battery-full fa-fw',
    'fa-solid fa-battery-exclamation fa-fw',
    'fa-solid fa-battery-empty fa-fw',
    'fa-solid fa-battery-bolt fa-fw',
    'fa-solid fa-basketball fa-fw',
    'fa-solid fa-basket-shopping-simple fa-fw',
    'fa-solid fa-basket-shopping fa-fw',
    'fa-solid fa-baseball-bat-ball fa-fw',
    'fa-solid fa-baseball fa-fw',
    'fa-solid fa-bars-staggered fa-fw',
    'fa-solid fa-bars-sort fa-fw',
    'fa-solid fa-bars-progress fa-fw',
    'fa-solid fa-bars-filter fa-fw',
    'fa-solid fa-barcode-scan fa-fw',
    'fa-solid fa-barcode-read fa-fw',
    'fa-solid fa-banjo fa-fw',
    'fa-solid fa-bangladeshi-taka-sign fa-fw',
    'fa-solid fa-bandage fa-fw',
    'fa-solid fa-banana fa-fw',
    'fa-solid fa-ban-smoking fa-fw',
    'fa-solid fa-ban-parking fa-fw',
    'fa-solid fa-ban-bug fa-fw',
    'fa-solid fa-ban fa-fw',
    'fa-solid fa-ballot fa-fw',
    'fa-solid fa-balloon fa-fw',
    'fa-solid fa-ball-pile fa-fw',
    'fa-solid fa-baht-sign fa-fw',
    'fa-solid fa-bahai fa-fw',
    'fa-solid fa-baguette fa-fw',
    'fa-solid fa-bags-shopping fa-fw',
    'fa-solid fa-bagel fa-fw',
    'fa-solid fa-bag-seedling fa-fw',
    'fa-solid fa-badminton fa-fw',
    'fa-solid fa-badger-honey fa-fw',
    'fa-solid fa-badge-sheriff fa-fw',
    'fa-solid fa-badge-percent fa-fw',
    'fa-solid fa-badge-dollar fa-fw',
    'fa-solid fa-bacterium fa-fw',
    'fa-solid fa-bacteria fa-fw',
    'fa-solid fa-bacon fa-fw',
    'fa-solid fa-backward-step fa-fw',
    'fa-solid fa-backward-fast fa-fw',
    'fa-solid fa-backpack fa-fw',
    'fa-solid fa-baby-carriage fa-fw',
    'fa-solid fa-b fa-fw',
    'fa-solid fa-axe-battle fa-fw',
    'fa-solid fa-axe fa-fw',
    'fa-solid fa-award-simple fa-fw',
    'fa-solid fa-avocado fa-fw',
    'fa-solid fa-austral-sign fa-fw',
    'fa-solid fa-audio-description-slash fa-fw',
    'fa-solid fa-atom fa-fw',
    'fa-solid fa-at fa-fw',
    'fa-solid fa-asterisk fa-fw',
    'fa-solid fa-arrows-up-to-line fa-fw',
    'fa-solid fa-arrows-up-down-left-right fa-fw',
    'fa-solid fa-arrows-up-down fa-fw',
    'fa-solid fa-arrows-turn-to-dots fa-fw',
    'fa-solid fa-arrows-turn-right fa-fw',
    'fa-solid fa-arrows-to-line fa-fw',
    'fa-solid fa-arrows-to-eye fa-fw',
    'fa-solid fa-arrows-to-dotted-line fa-fw',
    'fa-solid fa-arrows-to-dot fa-fw',
    'fa-solid fa-arrows-to-circle fa-fw',
    'fa-solid fa-arrows-split-up-and-left fa-fw',
    'fa-solid fa-arrows-spin fa-fw',
    'fa-solid fa-arrows-rotate fa-fw',
    'fa-solid fa-arrows-retweet fa-fw',
    'fa-solid fa-arrows-repeat-1 fa-fw',
    'fa-solid fa-arrows-repeat fa-fw',
    'fa-solid fa-arrows-minimize fa-fw',
    'fa-solid fa-arrows-maximize fa-fw',
    'fa-solid fa-arrows-left-right-to-line fa-fw',
    'fa-solid fa-arrows-left-right fa-fw',
    'fa-solid fa-arrows-from-line fa-fw',
    'fa-solid fa-arrows-from-dotted-line fa-fw',
    'fa-solid fa-arrows-down-to-people fa-fw',
    'fa-solid fa-arrows-down-to-line fa-fw',
    'fa-solid fa-arrows-cross fa-fw',
    'fa-solid fa-arrow-up-z-a fa-fw',
    'fa-solid fa-arrow-up-wide-short fa-fw',
    'fa-solid fa-arrow-up-triangle-square fa-fw',
    'fa-solid fa-arrow-up-to-line fa-fw',
    'fa-solid fa-arrow-up-to-dotted-line fa-fw',
    'fa-solid fa-arrow-up-square-triangle fa-fw',
    'fa-solid fa-arrow-up-small-big fa-fw',
    'fa-solid fa-arrow-up-short-wide fa-fw',
    'fa-solid fa-arrow-up-right-dots fa-fw',
    'fa-solid fa-arrow-up-right-and-arrow-down-left-from-center fa-fw',
    'fa-solid fa-arrow-up-right fa-fw',
    'fa-solid fa-arrow-up-long fa-fw',
    'fa-solid fa-arrow-up-left-from-circle fa-fw',
    'fa-solid fa-arrow-up-left fa-fw',
    'fa-solid fa-arrow-up-from-water-pump fa-fw',
    'fa-solid fa-arrow-up-from-square fa-fw',
    'fa-solid fa-arrow-up-from-line fa-fw',
    'fa-solid fa-arrow-up-from-ground-water fa-fw',
    'fa-solid fa-arrow-up-from-dotted-line fa-fw',
    'fa-solid fa-arrow-up-from-arc fa-fw',
    'fa-solid fa-arrow-up-big-small fa-fw',
    'fa-solid fa-arrow-up-arrow-down fa-fw',
    'fa-solid fa-arrow-up-a-z fa-fw',
    'fa-solid fa-arrow-up-9-1 fa-fw',
    'fa-solid fa-arrow-up-1-9 fa-fw',
    'fa-solid fa-arrow-turn-up fa-fw',
    'fa-solid fa-arrow-turn-down-right fa-fw',
    'fa-solid fa-arrow-turn-down-left fa-fw',
    'fa-solid fa-arrow-turn-down fa-fw',
    'fa-solid fa-arrow-trend-up fa-fw',
    'fa-solid fa-arrow-trend-down fa-fw',
    'fa-solid fa-arrow-rotate-right fa-fw',
    'fa-solid fa-arrow-rotate-left fa-fw',
    'fa-solid fa-arrow-right-to-line fa-fw',
    'fa-solid fa-arrow-right-to-city fa-fw',
    'fa-solid fa-arrow-right-to-bracket fa-fw',
    'fa-solid fa-arrow-right-to-arc fa-fw',
    'fa-solid fa-arrow-right-long-to-line fa-fw',
    'fa-solid fa-arrow-right-long fa-fw',
    'fa-solid fa-arrow-right-from-line fa-fw',
    'fa-solid fa-arrow-right-from-bracket fa-fw',
    'fa-solid fa-arrow-right-from-arc fa-fw',
    'fa-solid fa-arrow-right-arrow-left fa-fw',
    'fa-solid fa-arrow-progress fa-fw',
    'fa-solid fa-arrow-pointer fa-fw',
    'fa-solid fa-arrow-left-to-line fa-fw',
    'fa-solid fa-arrow-left-long-to-line fa-fw',
    'fa-solid fa-arrow-left-long fa-fw',
    'fa-solid fa-arrow-left-from-line fa-fw',
    'fa-solid fa-arrow-down-z-a fa-fw',
    'fa-solid fa-arrow-down-wide-short fa-fw',
    'fa-solid fa-arrow-down-up-lock fa-fw',
    'fa-solid fa-arrow-down-up-across-line fa-fw',
    'fa-solid fa-arrow-down-triangle-square fa-fw',
    'fa-solid fa-arrow-down-to-square fa-fw',
    'fa-solid fa-arrow-down-to-dotted-line fa-fw',
    'fa-solid fa-arrow-down-to-bracket fa-fw',
    'fa-solid fa-arrow-down-to-arc fa-fw',
    'fa-solid fa-arrow-down-square-triangle fa-fw',
    'fa-solid fa-arrow-down-small-big fa-fw',
    'fa-solid fa-arrow-down-short-wide fa-fw',
    'fa-solid fa-arrow-down-right fa-fw',
    'fa-solid fa-arrow-down-long fa-fw',
    'fa-solid fa-arrow-down-left-and-arrow-up-right-to-center fa-fw',
    'fa-solid fa-arrow-down-left fa-fw',
    'fa-solid fa-arrow-down-from-line fa-fw',
    'fa-solid fa-arrow-down-from-dotted-line fa-fw',
    'fa-solid fa-arrow-down-big-small fa-fw',
    'fa-solid fa-arrow-down-arrow-up fa-fw',
    'fa-solid fa-arrow-down-a-z fa-fw',
    'fa-solid fa-arrow-down-9-1 fa-fw',
    'fa-solid fa-arrow-down-1-9 fa-fw',
    'fa-solid fa-archway fa-fw',
    'fa-solid fa-apple-whole fa-fw',
    'fa-solid fa-apple-core fa-fw',
    'fa-solid fa-apostrophe fa-fw',
    'fa-solid fa-apartment fa-fw',
    'fa-solid fa-ankh fa-fw',
    'fa-solid fa-angles-up fa-fw',
    'fa-solid fa-angles-right fa-fw',
    'fa-solid fa-angles-left fa-fw',
    'fa-solid fa-angles-down fa-fw',
    'fa-solid fa-angle-right fa-fw',
    'fa-solid fa-angle-left fa-fw',
    'fa-solid fa-angle-down fa-fw',
    'fa-solid fa-angle-90 fa-fw',
    'fa-solid fa-angle fa-fw',
    'fa-solid fa-angel fa-fw',
    'fa-solid fa-anchor-lock fa-fw',
    'fa-solid fa-anchor-circle-xmark fa-fw',
    'fa-solid fa-anchor-circle-exclamation fa-fw',
    'fa-solid fa-anchor-circle-check fa-fw',
    'fa-solid fa-ampersand fa-fw',
    'fa-solid fa-amp-guitar fa-fw',
    'fa-solid fa-alt fa-fw',
    'fa-solid fa-align-right fa-fw',
    'fa-solid fa-align-left fa-fw',
    'fa-solid fa-align-justify fa-fw',
    'fa-solid fa-align-center fa-fw',
    'fa-solid fa-alien fa-fw',
    'fa-solid fa-alicorn fa-fw',
    'fa-solid fa-album-collection-circle-user fa-fw',
    'fa-solid fa-album-collection-circle-plus fa-fw',
    'fa-solid fa-album-collection fa-fw',
    'fa-solid fa-album-circle-user fa-fw',
    'fa-solid fa-album-circle-plus fa-fw',
    'fa-solid fa-alarm-plus fa-fw',
    'fa-solid fa-alarm-exclamation fa-fw',
    'fa-solid fa-airplay fa-fw',
    'fa-solid fa-air-conditioner fa-fw',
    'fa-solid fa-acorn fa-fw',
    'fa-solid fa-accent-grave fa-fw',
    'fa-solid fa-abacus fa-fw',
    'fa-solid fa-a fa-fw',
    'fa-solid fa-9 fa-fw',
    'fa-solid fa-8 fa-fw',
    'fa-solid fa-7 fa-fw',
    'fa-solid fa-6 fa-fw',
    'fa-solid fa-5 fa-fw',
    'fa-solid fa-4 fa-fw',
    'fa-solid fa-360-degrees fa-fw',
    'fa-solid fa-3 fa-fw',
    'fa-solid fa-2 fa-fw',
    'fa-solid fa-1 fa-fw',
    'fa-solid fa-00 fa-fw',
    'fa-solid fa-0 fa-fw',
    'fa-brands fa-zhihu fa-fw',
    'fa-brands fa-yoast fa-fw',
    'fa-brands fa-yelp fa-fw',
    'fa-brands fa-yarn fa-fw',
    'fa-brands fa-yandex-international fa-fw',
    'fa-brands fa-yandex fa-fw',
    'fa-brands fa-yammer fa-fw',
    'fa-brands fa-yahoo fa-fw',
    'fa-brands fa-y-combinator fa-fw',
    'fa-brands fa-xing fa-fw',
    'fa-brands fa-xbox fa-fw',
    'fa-brands fa-wpressr fa-fw',
    'fa-brands fa-wpforms fa-fw',
    'fa-brands fa-wpexplorer fa-fw',
    'fa-brands fa-wpbeginner fa-fw',
    'fa-brands fa-wordpress-simple fa-fw',
    'fa-brands fa-wolf-pack-battalion fa-fw',
    'fa-brands fa-wodu fa-fw',
    'fa-brands fa-wizards-of-the-coast fa-fw',
    'fa-brands fa-wirsindhandwerk fa-fw',
    'fa-brands fa-whmcs fa-fw',
    'fa-brands fa-weixin fa-fw',
    'fa-brands fa-weibo fa-fw',
    'fa-brands fa-weebly fa-fw',
    'fa-brands fa-watchman-monitoring fa-fw',
    'fa-brands fa-vuejs fa-fw',
    'fa-brands fa-vnv fa-fw',
    'fa-brands fa-vk fa-fw',
    'fa-brands fa-vine fa-fw',
    'fa-brands fa-vimeo-v fa-fw',
    'fa-brands fa-viber fa-fw',
    'fa-brands fa-viadeo fa-fw',
    'fa-brands fa-viacoin fa-fw',
    'fa-brands fa-vaadin fa-fw',
    'fa-brands fa-ussunnah fa-fw',
    'fa-brands fa-usb fa-fw',
    'fa-brands fa-ups fa-fw',
    'fa-brands fa-untappd fa-fw',
    'fa-brands fa-unsplash fa-fw',
    'fa-brands fa-unity fa-fw',
    'fa-brands fa-uniregistry fa-fw',
    'fa-brands fa-uncharted fa-fw',
    'fa-brands fa-umbraco fa-fw',
    'fa-brands fa-uikit fa-fw',
    'fa-brands fa-ubuntu fa-fw',
    'fa-brands fa-uber fa-fw',
    'fa-brands fa-typo3 fa-fw',
    'fa-brands fa-tumblr fa-fw',
    'fa-brands fa-trello fa-fw',
    'fa-brands fa-trade-federation fa-fw',
    'fa-brands fa-themeisle fa-fw',
    'fa-brands fa-themeco fa-fw',
    'fa-brands fa-the-red-yeti fa-fw',
    'fa-brands fa-tencent-weibo fa-fw',
    'fa-brands fa-symfony fa-fw',
    'fa-brands fa-swift fa-fw',
    'fa-brands fa-suse fa-fw',
    'fa-brands fa-supple fa-fw',
    'fa-brands fa-superpowers fa-fw',
    'fa-brands fa-stumbleupon-circle fa-fw',
    'fa-brands fa-stumbleupon fa-fw',
    'fa-brands fa-studiovinari fa-fw',
    'fa-brands fa-stubber fa-fw',
    'fa-brands fa-stripe-s fa-fw',
    'fa-brands fa-strava fa-fw',
    'fa-brands fa-sticker-mule fa-fw',
    'fa-brands fa-steam-symbol fa-fw',
    'fa-brands fa-steam fa-fw',
    'fa-brands fa-staylinked fa-fw',
    'fa-brands fa-stackpath fa-fw',
    'fa-brands fa-stack-exchange fa-fw',
    'fa-brands fa-square-xing fa-fw',
    'fa-brands fa-square-whatsapp fa-fw',
    'fa-brands fa-square-vimeo fa-fw',
    'fa-brands fa-square-viadeo fa-fw',
    'fa-brands fa-square-tumblr fa-fw',
    'fa-brands fa-square-steam fa-fw',
    'fa-brands fa-square-snapchat fa-fw',
    'fa-brands fa-square-reddit fa-fw',
    'fa-brands fa-square-pied-piper fa-fw',
    'fa-brands fa-square-odnoklassniki fa-fw',
    'fa-brands fa-square-lastfm fa-fw',
    'fa-brands fa-square-instagram fa-fw',
    'fa-brands fa-square-hacker-news fa-fw',
    'fa-brands fa-square-google-plus fa-fw',
    'fa-brands fa-square-gitlab fa-fw',
    'fa-brands fa-square-github fa-fw',
    'fa-brands fa-square-git fa-fw',
    'fa-brands fa-square-font-awesome-stroke fa-fw',
    'fa-brands fa-square-font-awesome fa-fw',
    'fa-brands fa-square-facebook fa-fw',
    'fa-brands fa-square-dribbble fa-fw',
    'fa-brands fa-square-behance fa-fw',
    'fa-brands fa-speaker-deck fa-fw',
    'fa-brands fa-speakap fa-fw',
    'fa-brands fa-space-awesome fa-fw',
    'fa-brands fa-sourcetree fa-fw',
    'fa-brands fa-snapchat fa-fw',
    'fa-brands fa-slideshare fa-fw',
    'fa-brands fa-skyatlas fa-fw',
    'fa-brands fa-sketch fa-fw',
    'fa-brands fa-sitrox fa-fw',
    'fa-brands fa-sith fa-fw',
    'fa-brands fa-sistrix fa-fw',
    'fa-brands fa-simplybuilt fa-fw',
    'fa-brands fa-shopware fa-fw',
    'fa-brands fa-shirtsinbulk fa-fw',
    'fa-brands fa-servicestack fa-fw',
    'fa-brands fa-sellsy fa-fw',
    'fa-brands fa-sellcast fa-fw',
    'fa-brands fa-searchengin fa-fw',
    'fa-brands fa-scribd fa-fw',
    'fa-brands fa-screenpal fa-fw',
    'fa-brands fa-schlix fa-fw',
    'fa-brands fa-sass fa-fw',
    'fa-brands fa-safari fa-fw',
    'fa-brands fa-rust fa-fw',
    'fa-brands fa-rockrms fa-fw',
    'fa-brands fa-rocketchat fa-fw',
    'fa-brands fa-rev fa-fw',
    'fa-brands fa-resolving fa-fw',
    'fa-brands fa-researchgate fa-fw',
    'fa-brands fa-replyd fa-fw',
    'fa-brands fa-renren fa-fw',
    'fa-brands fa-redhat fa-fw',
    'fa-brands fa-reddit-alien fa-fw',
    'fa-brands fa-reddit fa-fw',
    'fa-brands fa-red-river fa-fw',
    'fa-brands fa-reacteurope fa-fw',
    'fa-brands fa-ravelry fa-fw',
    'fa-brands fa-raspberry-pi fa-fw',
    'fa-brands fa-r-project fa-fw',
    'fa-brands fa-quora fa-fw',
    'fa-brands fa-quinscape fa-fw',
    'fa-brands fa-qq fa-fw',
    'fa-brands fa-pushed fa-fw',
    'fa-brands fa-pix fa-fw',
    'fa-brands fa-pinterest-p fa-fw',
    'fa-brands fa-pied-piper-pp fa-fw',
    'fa-brands fa-pied-piper-hat fa-fw',
    'fa-brands fa-pied-piper-alt fa-fw',
    'fa-brands fa-php fa-fw',
    'fa-brands fa-phoenix-squadron fa-fw',
    'fa-brands fa-phoenix-framework fa-fw',
    'fa-brands fa-phabricator fa-fw',
    'fa-brands fa-periscope fa-fw',
    'fa-brands fa-perbyte fa-fw',
    'fa-brands fa-patreon fa-fw',
    'fa-brands fa-palfed fa-fw',
    'fa-brands fa-page4 fa-fw',
    'fa-brands fa-padlet fa-fw',
    'fa-brands fa-osi fa-fw',
    'fa-brands fa-orcid fa-fw',
    'fa-brands fa-optin-monster fa-fw',
    'fa-brands fa-opera fa-fw',
    'fa-brands fa-opencart fa-fw',
    'fa-brands fa-old-republic fa-fw',
    'fa-brands fa-odysee fa-fw',
    'fa-brands fa-odnoklassniki fa-fw',
    'fa-brands fa-octopus-deploy fa-fw',
    'fa-brands fa-nutritionix fa-fw',
    'fa-brands fa-ns8 fa-fw',
    'fa-brands fa-npm fa-fw',
    'fa-brands fa-node-js fa-fw',
    'fa-brands fa-nimblr fa-fw',
    'fa-brands fa-nfc-symbol fa-fw',
    'fa-brands fa-nfc-directional fa-fw',
    'fa-brands fa-neos fa-fw',
    'fa-brands fa-napster fa-fw',
    'fa-brands fa-monero fa-fw',
    'fa-brands fa-modx fa-fw',
    'fa-brands fa-mizuni fa-fw',
    'fa-brands fa-mixer fa-fw',
    'fa-brands fa-mixcloud fa-fw',
    'fa-brands fa-mix fa-fw',
    'fa-brands fa-microblog fa-fw',
    'fa-brands fa-meta fa-fw',
    'fa-brands fa-mendeley fa-fw',
    'fa-brands fa-megaport fa-fw',
    'fa-brands fa-medrt fa-fw',
    'fa-brands fa-medapps fa-fw',
    'fa-brands fa-mdb fa-fw',
    'fa-brands fa-maxcdn fa-fw',
    'fa-brands fa-mastodon fa-fw',
    'fa-brands fa-markdown fa-fw',
    'fa-brands fa-mandalorian fa-fw',
    'fa-brands fa-mailchimp fa-fw',
    'fa-brands fa-magento fa-fw',
    'fa-brands fa-lyft fa-fw',
    'fa-brands fa-linode fa-fw',
    'fa-brands fa-linkedin-in fa-fw',
    'fa-brands fa-less fa-fw',
    'fa-brands fa-leanpub fa-fw',
    'fa-brands fa-lastfm fa-fw',
    'fa-brands fa-laravel fa-fw',
    'fa-brands fa-korvue fa-fw',
    'fa-brands fa-kickstarter-k fa-fw',
    'fa-brands fa-keycdn fa-fw',
    'fa-brands fa-keybase fa-fw',
    'fa-brands fa-kaggle fa-fw',
    'fa-brands fa-jsfiddle fa-fw',
    'fa-brands fa-js fa-fw',
    'fa-brands fa-joomla fa-fw',
    'fa-brands fa-joget fa-fw',
    'fa-brands fa-jira fa-fw',
    'fa-brands fa-jenkins fa-fw',
    'fa-brands fa-jedi-order fa-fw',
    'fa-brands fa-itunes-note fa-fw',
    'fa-brands fa-itunes fa-fw',
    'fa-brands fa-itch-io fa-fw',
    'fa-brands fa-ioxhost fa-fw',
  ];
  constructor() {
    /*  this.catagories.forEach(cat => {
      cat.items.forEach(icon => {
        if (!this.all.includes(icon)) {
          this.all.push(icon);
      })
    })*/
  }
}
